/**
 * Enums file for Django constants generated by a script.
 * Not to be edited directly.
 */
import { t, useTranslation } from "../utils";

useTranslation("constants");

export const VENUE_PERMISSIONS = {
  VP_MANAGE_VENUE_INFO: {
    id: "manage_venues",
    name: t("Manage Organization Info"),
    children: [],
    tooltip:
      "Employees will be able to update information on the organization's profile",
    require_totp: true,
    key: "VP_MANAGE_VENUE_INFO",
  },
  VP_MANAGE_EMPLOYEES: {
    id: "manage_employees",
    name: t("Manage Employees"),
    children: [],
    tooltip: "Employees will be able to manage user permissions",
    require_totp: true,
    key: "VP_MANAGE_EMPLOYEES",
  },
  VP_MANAGE_ROOMS: {
    id: "manage_rooms",
    name: t("Manage Venue Layouts"),
    children: [],
    tooltip:
      "Employees will be able to build out venue layouts for assigned seating",
    require_totp: false,
    key: "VP_MANAGE_ROOMS",
  },
  VP_MANAGE_INCIDENTS: {
    id: "manage_incidents",
    name: t("Manage Incidents"),
    modules: ["5"],
    children: ["view_incidents", "use_incidents"],
    require_totp: false,
    key: "VP_MANAGE_INCIDENTS",
  },
  VP_VIEW_INCIDENTS: {
    id: "view_incidents",
    name: t("View Incident Details"),
    modules: ["5"],
    children: ["use_incidents"],
    require_totp: false,
    key: "VP_VIEW_INCIDENTS",
  },
  VP_USE_INCIDENTS: {
    id: "use_incidents",
    name: t("Use Incident System"),
    modules: ["5"],
    children: [],
    require_totp: false,
    key: "VP_USE_INCIDENTS",
  },
  VP_MANAGE_MEMBERSHIPS: {
    id: "manage_memberships",
    name: t("Manage Memberships"),
    modules: ["6"],
    children: ["scan_memberships"],
    tooltip:
      "Employees will be able to manage memberships and membership benefits",
    require_totp: false,
    key: "VP_MANAGE_MEMBERSHIPS",
  },
  VP_SCAN_MEMBERSHIPS: {
    id: "scan_memberships",
    name: t("Scan Memberships"),
    modules: ["6"],
    children: [],
    tooltip: "Employees will be able to scan member barcodes",
    require_totp: false,
    key: "VP_SCAN_MEMBERSHIPS",
  },
  VP_MANAGE_CLICKERS: {
    id: "manage_clickers",
    name: t("Manage Capacity Counters"),
    modules: ["4"],
    children: ["view_clickers", "use_clickers"],
    tooltip: "Employees will have full access to the capacity counter feature",
    require_totp: false,
    key: "VP_MANAGE_CLICKERS",
  },
  VP_VIEW_CLICKERS: {
    id: "view_clickers",
    name: t("View Capacity Counter Info"),
    modules: ["4"],
    children: ["use_clickers"],
    tooltip:
      "Employees will be able to use capacity counters, but not discard them",
    require_totp: false,
    key: "VP_VIEW_CLICKERS",
  },
  VP_USE_CLICKERS: {
    id: "use_clickers",
    name: t("Use Capacity Counters"),
    modules: ["4"],
    children: [],
    tooltip:
      "Employees will be given access to use capacity counters, but not manage or see counter info",
    require_totp: false,
    key: "VP_USE_CLICKERS",
  },
  VP_MANAGE_INTEGRATIONS: {
    id: "manage_integrations",
    name: t("Manage Integrations"),
    children: [],
    tooltip: "Employees will be able to validate the available integrations",
    require_totp: false,
    key: "VP_MANAGE_INTEGRATIONS",
  },
  VP_MANAGE_FINANCIALS: {
    id: "manage_financials",
    name: t("Manage Transactions"),
    children: ["administer_transactions"],
    tooltip:
      "Employees will be able to view all transactions, process refunds, and set custom fees or taxes at an organizational level",
    require_totp: true,
    key: "VP_MANAGE_FINANCIALS",
  },
  VP_ADMINISTER_TRANSACTIONS: {
    id: "administer_transactions",
    name: t("Administer Transactions"),
    children: [],
    tooltip:
      "Employees will be able to refund, void, and resend confirmation emails",
    require_totp: true,
    key: "VP_ADMINISTER_TRANSACTIONS",
  },
  VP_ADMINISTER_CASH_REFUNDS: {
    id: "administer_cash_refunds",
    name: t("Administer Cash Refunds"),
    children: [],
    tooltip: "Employees will be able to refund cash transactions",
    require_totp: false,
    key: "VP_ADMINISTER_CASH_REFUNDS",
  },
  VP_MANAGE_BANK_ACCOUNT: {
    id: "manage_bank_account",
    name: t("Manage Financials"),
    children: [],
    tooltip: "Employees will be able to change banking info.",
    require_totp: true,
    key: "VP_MANAGE_BANK_ACCOUNT",
  },
  VP_MANAGE_USERS: {
    id: "manage_users",
    name: t("Manage Network"),
    children: [],
    tooltip:
      "Employees will have full access to the Network Management page and will be able to send out SMS and email messages",
    require_totp: true,
    key: "VP_MANAGE_USERS",
  },
  VP_MANAGE_WIDGETS: {
    id: "manage_widgets",
    name: t("Manage Widgets"),
    children: [],
    tooltip:
      "Employees will be able to access the event list and guestlist iFrame widgets",
    require_totp: false,
    key: "VP_MANAGE_WIDGETS",
  },
  VP_MANAGE_MARKETPLACE: {
    id: "manage_marketplace",
    name: t("Manage Marketplace"),
    children: [],
    tooltip:
      "Employees will have full access to the Marketplace and will be able to create items, and view transactions",
    require_totp: false,
    key: "VP_MANAGE_MARKETPLACE",
  },
  VP_MANAGE_RESERVATIONS: {
    id: "manage_reservations",
    name: t("Manage Guestlists"),
    modules: ["2"],
    children: ["view_reservations", "edit_booked_reservations"],
    tooltip: "Employees will have full access to the guestlist feature",
    require_totp: true,
    key: "VP_MANAGE_RESERVATIONS",
  },
  VP_VIEW_RESERVATIONS: {
    id: "view_reservations",
    name: t("Check-in Guestlists"),
    modules: ["2"],
    children: [],
    tooltip: "Employees will be able to check in guestlists",
    require_totp: false,
    key: "VP_VIEW_RESERVATIONS",
  },
  VP_EDIT_BOOKED_RESERVATIONS: {
    id: "edit_booked_reservations",
    name: t("Book Guestlists"),
    modules: ["2"],
    children: [],
    tooltip: "Employees will be able to book guestlists",
    require_totp: false,
    key: "VP_EDIT_BOOKED_RESERVATIONS",
  },
  VP_MANAGE_QUEUES: {
    id: "manage_queues",
    name: t("Manage Queues"),
    modules: [],
    children: [],
    require_totp: false,
    key: "VP_MANAGE_QUEUES",
  },
  VP_MANAGE_EVENTS: {
    id: "manage_events",
    name: t("Manage Events"),
    modules: ["1"],
    children: [],
    tooltip:
      "Employees will have access to everything related to managing and creating events. They will not have access to change custom fees and/or taxes on an event",
    require_totp: true,
    key: "VP_MANAGE_EVENTS",
  },
  VP_MANAGE_CHECKIN_PRESETS: {
    id: "manage_checkin_presets",
    name: t("Manage Check-in"),
    modules: ["1"],
    children: ["scan_tickets", "scan_memberships", "select_items_to_scan"],
    tooltip:
      "Employees will have the capability to manage check-in presets and undo prior check-ins",
    require_totp: false,
    key: "VP_MANAGE_CHECKIN_PRESETS",
  },
  VP_SCAN_TICKETS: {
    id: "scan_tickets",
    name: t("Scan Tickets"),
    modules: ["1"],
    children: [],
    tooltip: "Employees will be able to scan tickets in",
    require_totp: false,
    key: "VP_SCAN_TICKETS",
  },
  VP_SELECT_ITEMS_TO_SCAN: {
    id: "select_items_to_scan",
    name: t("Select Items to Scan"),
    modules: ["1"],
    children: [],
    tooltip: "Employees will be able to select which items to scan in",
    require_totp: false,
    key: "VP_SELECT_ITEMS_TO_SCAN",
  },
  VP_USE_BOX_OFFICE: {
    id: "use_box_office",
    name: t("Box Office Sales"),
    modules: ["1"],
    children: [],
    tooltip:
      "Employees will be able to sell tickets and products from the box office",
    require_totp: false,
    key: "VP_USE_BOX_OFFICE",
  },
  VP_USE_BOX_OFFICE_CARD: {
    id: "use_box_office_card",
    name: t("Credit Card Box Office Sales"),
    modules: ["1"],
    children: ["use_box_office"],
    tooltip:
      "Employees will be able to sell box office tickets via credit card",
    require_totp: false,
    key: "VP_USE_BOX_OFFICE_CARD",
  },
  VP_SELL_CASH_TICKETS: {
    id: "sell_cash_tickets",
    name: t("Cash Box Office Sales"),
    modules: ["1"],
    children: ["use_box_office"],
    tooltip:
      "Employees will be able to complete cash transactions from the box office",
    require_totp: false,
    key: "VP_SELL_CASH_TICKETS",
  },
  VP_SELL_COMPLIMENTARY_TICKETS: {
    id: "sell_complimentary_tickets",
    name: t("Complimentary Box Office Sales"),
    modules: ["1"],
    children: ["use_box_office"],
    tooltip:
      "Employees will be able to sell complimentary tickets from the box office",
    require_totp: false,
    key: "VP_SELL_COMPLIMENTARY_TICKETS",
  },
  VP_USE_BOX_OFFICE_OTHER: {
    id: "use_box_office_other",
    name: t("Other Box Office Sales"),
    modules: ["1"],
    children: ["use_box_office"],
    tooltip:
      "Employees will be able to sell box office tickets via other payment types",
    require_totp: false,
    key: "VP_USE_BOX_OFFICE_OTHER",
  },
  VP_MANAGE_REPORTS: {
    id: "manage_reports",
    name: t("Manage Reports"),
    children: [],
    tooltip:
      "Employees will be able to create, send, and download different reports",
    require_totp: true,
    key: "VP_MANAGE_REPORTS",
  },
  VP_MANAGE_HOLDS: {
    id: "manage_holds",
    name: t("Manage Holds"),
    modules: ["1"],
    children: ["use_box_office"],
    tooltip:
      "Employees will be able to manage holds in the box office that they have created",
    require_totp: false,
    key: "VP_MANAGE_HOLDS",
  },
  VP_MANAGE_ALL_HOLDS: {
    id: "manage_all_holds",
    name: t("Manage All Holds"),
    modules: ["1"],
    children: ["manage_holds", "use_box_office"],
    tooltip: "Employees will be able to manage all holds in the box office",
    require_totp: false,
    key: "VP_MANAGE_ALL_HOLDS",
  },
  VP_DEVELOPER: {
    id: "developer",
    name: t("Access Developer Features"),
    children: [],
    tooltip:
      "Employees will be able to access to developer features like webhooks",
    require_totp: false,
    key: "VP_DEVELOPER",
  },
  VP_MANAGE_GROUP_SALE: {
    id: "manage_group_sale",
    name: t("Group Sale Manager"),
    children: [],
    tooltip: "Employees will be able to access and manage group sales",
    require_totp: true,
    key: "VP_MANAGE_GROUP_SALE",
  },
  VP_DISTRIBUTE_GROUP_SALE: {
    id: "distribute_group_sale",
    name: t("Group Sale Distributor"),
    children: [],
    tooltip: "Employees will be able to distribute group sale tickets",
    require_totp: false,
    key: "VP_DISTRIBUTE_GROUP_SALE",
  },
  VP_VIEW_ADVANCED_ANALYTICS: {
    id: "view_advanced_analytics",
    name: t("View Advanced Analytics"),
    children: [],
    tooltip: "Employees will be able to view advanced analytics dashboards",
    require_totp: true,
    key: "VP_VIEW_ADVANCED_ANALYTICS",
  },
  VP_MANAGE_ACCESS_PIN: {
    id: "manage_access_pin",
    name: t("Access PIN Management"),
    children: [],
    tooltip: "Employees will be able to manage Access PINs",
    require_totp: true,
    key: "VP_MANAGE_ACCESS_PIN",
  },
  VP_MANAGE_MODULE_USAGES: {
    id: "manage_module_usages",
    name: t("Manage Add-ons"),
    children: [],
    tooltip: "Employees will be able to view and manage add-ons",
    require_totp: false,
    key: "VP_MANAGE_MODULE_USAGES",
  },
} as const;

export const VENUE_PERMISSIONS_BY_ID = {
  manage_venues: {
    id: "manage_venues",
    name: t("Manage Organization Info"),
    children: [],
    tooltip:
      "Employees will be able to update information on the organization's profile",
    require_totp: true,
    key: "VP_MANAGE_VENUE_INFO",
  },
  manage_employees: {
    id: "manage_employees",
    name: t("Manage Employees"),
    children: [],
    tooltip: "Employees will be able to manage user permissions",
    require_totp: true,
    key: "VP_MANAGE_EMPLOYEES",
  },
  manage_rooms: {
    id: "manage_rooms",
    name: t("Manage Venue Layouts"),
    children: [],
    tooltip:
      "Employees will be able to build out venue layouts for assigned seating",
    require_totp: false,
    key: "VP_MANAGE_ROOMS",
  },
  manage_incidents: {
    id: "manage_incidents",
    name: t("Manage Incidents"),
    modules: ["5"],
    children: ["view_incidents", "use_incidents"],
    require_totp: false,
    key: "VP_MANAGE_INCIDENTS",
  },
  view_incidents: {
    id: "view_incidents",
    name: t("View Incident Details"),
    modules: ["5"],
    children: ["use_incidents"],
    require_totp: false,
    key: "VP_VIEW_INCIDENTS",
  },
  use_incidents: {
    id: "use_incidents",
    name: t("Use Incident System"),
    modules: ["5"],
    children: [],
    require_totp: false,
    key: "VP_USE_INCIDENTS",
  },
  manage_memberships: {
    id: "manage_memberships",
    name: t("Manage Memberships"),
    modules: ["6"],
    children: ["scan_memberships"],
    tooltip:
      "Employees will be able to manage memberships and membership benefits",
    require_totp: false,
    key: "VP_MANAGE_MEMBERSHIPS",
  },
  scan_memberships: {
    id: "scan_memberships",
    name: t("Scan Memberships"),
    modules: ["6"],
    children: [],
    tooltip: "Employees will be able to scan member barcodes",
    require_totp: false,
    key: "VP_SCAN_MEMBERSHIPS",
  },
  manage_clickers: {
    id: "manage_clickers",
    name: t("Manage Capacity Counters"),
    modules: ["4"],
    children: ["view_clickers", "use_clickers"],
    tooltip: "Employees will have full access to the capacity counter feature",
    require_totp: false,
    key: "VP_MANAGE_CLICKERS",
  },
  view_clickers: {
    id: "view_clickers",
    name: t("View Capacity Counter Info"),
    modules: ["4"],
    children: ["use_clickers"],
    tooltip:
      "Employees will be able to use capacity counters, but not discard them",
    require_totp: false,
    key: "VP_VIEW_CLICKERS",
  },
  use_clickers: {
    id: "use_clickers",
    name: t("Use Capacity Counters"),
    modules: ["4"],
    children: [],
    tooltip:
      "Employees will be given access to use capacity counters, but not manage or see counter info",
    require_totp: false,
    key: "VP_USE_CLICKERS",
  },
  manage_integrations: {
    id: "manage_integrations",
    name: t("Manage Integrations"),
    children: [],
    tooltip: "Employees will be able to validate the available integrations",
    require_totp: false,
    key: "VP_MANAGE_INTEGRATIONS",
  },
  manage_financials: {
    id: "manage_financials",
    name: t("Manage Transactions"),
    children: ["administer_transactions"],
    tooltip:
      "Employees will be able to view all transactions, process refunds, and set custom fees or taxes at an organizational level",
    require_totp: true,
    key: "VP_MANAGE_FINANCIALS",
  },
  administer_transactions: {
    id: "administer_transactions",
    name: t("Administer Transactions"),
    children: [],
    tooltip:
      "Employees will be able to refund, void, and resend confirmation emails",
    require_totp: true,
    key: "VP_ADMINISTER_TRANSACTIONS",
  },
  administer_cash_refunds: {
    id: "administer_cash_refunds",
    name: t("Administer Cash Refunds"),
    children: [],
    tooltip: "Employees will be able to refund cash transactions",
    require_totp: false,
    key: "VP_ADMINISTER_CASH_REFUNDS",
  },
  manage_bank_account: {
    id: "manage_bank_account",
    name: t("Manage Financials"),
    children: [],
    tooltip: "Employees will be able to change banking info.",
    require_totp: true,
    key: "VP_MANAGE_BANK_ACCOUNT",
  },
  manage_users: {
    id: "manage_users",
    name: t("Manage Network"),
    children: [],
    tooltip:
      "Employees will have full access to the Network Management page and will be able to send out SMS and email messages",
    require_totp: true,
    key: "VP_MANAGE_USERS",
  },
  manage_widgets: {
    id: "manage_widgets",
    name: t("Manage Widgets"),
    children: [],
    tooltip:
      "Employees will be able to access the event list and guestlist iFrame widgets",
    require_totp: false,
    key: "VP_MANAGE_WIDGETS",
  },
  manage_marketplace: {
    id: "manage_marketplace",
    name: t("Manage Marketplace"),
    children: [],
    tooltip:
      "Employees will have full access to the Marketplace and will be able to create items, and view transactions",
    require_totp: false,
    key: "VP_MANAGE_MARKETPLACE",
  },
  manage_reservations: {
    id: "manage_reservations",
    name: t("Manage Guestlists"),
    modules: ["2"],
    children: ["view_reservations", "edit_booked_reservations"],
    tooltip: "Employees will have full access to the guestlist feature",
    require_totp: true,
    key: "VP_MANAGE_RESERVATIONS",
  },
  view_reservations: {
    id: "view_reservations",
    name: t("Check-in Guestlists"),
    modules: ["2"],
    children: [],
    tooltip: "Employees will be able to check in guestlists",
    require_totp: false,
    key: "VP_VIEW_RESERVATIONS",
  },
  edit_booked_reservations: {
    id: "edit_booked_reservations",
    name: t("Book Guestlists"),
    modules: ["2"],
    children: [],
    tooltip: "Employees will be able to book guestlists",
    require_totp: false,
    key: "VP_EDIT_BOOKED_RESERVATIONS",
  },
  manage_queues: {
    id: "manage_queues",
    name: t("Manage Queues"),
    modules: [],
    children: [],
    require_totp: false,
    key: "VP_MANAGE_QUEUES",
  },
  manage_events: {
    id: "manage_events",
    name: t("Manage Events"),
    modules: ["1"],
    children: [],
    tooltip:
      "Employees will have access to everything related to managing and creating events. They will not have access to change custom fees and/or taxes on an event",
    require_totp: true,
    key: "VP_MANAGE_EVENTS",
  },
  manage_checkin_presets: {
    id: "manage_checkin_presets",
    name: t("Manage Check-in"),
    modules: ["1"],
    children: ["scan_tickets", "scan_memberships", "select_items_to_scan"],
    tooltip:
      "Employees will have the capability to manage check-in presets and undo prior check-ins",
    require_totp: false,
    key: "VP_MANAGE_CHECKIN_PRESETS",
  },
  scan_tickets: {
    id: "scan_tickets",
    name: t("Scan Tickets"),
    modules: ["1"],
    children: [],
    tooltip: "Employees will be able to scan tickets in",
    require_totp: false,
    key: "VP_SCAN_TICKETS",
  },
  select_items_to_scan: {
    id: "select_items_to_scan",
    name: t("Select Items to Scan"),
    modules: ["1"],
    children: [],
    tooltip: "Employees will be able to select which items to scan in",
    require_totp: false,
    key: "VP_SELECT_ITEMS_TO_SCAN",
  },
  use_box_office: {
    id: "use_box_office",
    name: t("Box Office Sales"),
    modules: ["1"],
    children: [],
    tooltip:
      "Employees will be able to sell tickets and products from the box office",
    require_totp: false,
    key: "VP_USE_BOX_OFFICE",
  },
  use_box_office_card: {
    id: "use_box_office_card",
    name: t("Credit Card Box Office Sales"),
    modules: ["1"],
    children: ["use_box_office"],
    tooltip:
      "Employees will be able to sell box office tickets via credit card",
    require_totp: false,
    key: "VP_USE_BOX_OFFICE_CARD",
  },
  sell_cash_tickets: {
    id: "sell_cash_tickets",
    name: t("Cash Box Office Sales"),
    modules: ["1"],
    children: ["use_box_office"],
    tooltip:
      "Employees will be able to complete cash transactions from the box office",
    require_totp: false,
    key: "VP_SELL_CASH_TICKETS",
  },
  sell_complimentary_tickets: {
    id: "sell_complimentary_tickets",
    name: t("Complimentary Box Office Sales"),
    modules: ["1"],
    children: ["use_box_office"],
    tooltip:
      "Employees will be able to sell complimentary tickets from the box office",
    require_totp: false,
    key: "VP_SELL_COMPLIMENTARY_TICKETS",
  },
  use_box_office_other: {
    id: "use_box_office_other",
    name: t("Other Box Office Sales"),
    modules: ["1"],
    children: ["use_box_office"],
    tooltip:
      "Employees will be able to sell box office tickets via other payment types",
    require_totp: false,
    key: "VP_USE_BOX_OFFICE_OTHER",
  },
  manage_reports: {
    id: "manage_reports",
    name: t("Manage Reports"),
    children: [],
    tooltip:
      "Employees will be able to create, send, and download different reports",
    require_totp: true,
    key: "VP_MANAGE_REPORTS",
  },
  manage_holds: {
    id: "manage_holds",
    name: t("Manage Holds"),
    modules: ["1"],
    children: ["use_box_office"],
    tooltip:
      "Employees will be able to manage holds in the box office that they have created",
    require_totp: false,
    key: "VP_MANAGE_HOLDS",
  },
  manage_all_holds: {
    id: "manage_all_holds",
    name: t("Manage All Holds"),
    modules: ["1"],
    children: ["manage_holds", "use_box_office"],
    tooltip: "Employees will be able to manage all holds in the box office",
    require_totp: false,
    key: "VP_MANAGE_ALL_HOLDS",
  },
  developer: {
    id: "developer",
    name: t("Access Developer Features"),
    children: [],
    tooltip:
      "Employees will be able to access to developer features like webhooks",
    require_totp: false,
    key: "VP_DEVELOPER",
  },
  manage_group_sale: {
    id: "manage_group_sale",
    name: t("Group Sale Manager"),
    children: [],
    tooltip: "Employees will be able to access and manage group sales",
    require_totp: true,
    key: "VP_MANAGE_GROUP_SALE",
  },
  distribute_group_sale: {
    id: "distribute_group_sale",
    name: t("Group Sale Distributor"),
    children: [],
    tooltip: "Employees will be able to distribute group sale tickets",
    require_totp: false,
    key: "VP_DISTRIBUTE_GROUP_SALE",
  },
  view_advanced_analytics: {
    id: "view_advanced_analytics",
    name: t("View Advanced Analytics"),
    children: [],
    tooltip: "Employees will be able to view advanced analytics dashboards",
    require_totp: true,
    key: "VP_VIEW_ADVANCED_ANALYTICS",
  },
  manage_access_pin: {
    id: "manage_access_pin",
    name: t("Access PIN Management"),
    children: [],
    tooltip: "Employees will be able to manage Access PINs",
    require_totp: true,
    key: "VP_MANAGE_ACCESS_PIN",
  },
  manage_module_usages: {
    id: "manage_module_usages",
    name: t("Manage Add-ons"),
    children: [],
    tooltip: "Employees will be able to view and manage add-ons",
    require_totp: false,
    key: "VP_MANAGE_MODULE_USAGES",
  },
} as const;

export const VENUE_PERMISSIONS_BY_LIST = [
  {
    id: "manage_venues",
    name: t("Manage Organization Info"),
    children: [],
    tooltip:
      "Employees will be able to update information on the organization's profile",
    require_totp: true,
    key: "VP_MANAGE_VENUE_INFO",
  },
  {
    id: "manage_employees",
    name: t("Manage Employees"),
    children: [],
    tooltip: "Employees will be able to manage user permissions",
    require_totp: true,
    key: "VP_MANAGE_EMPLOYEES",
  },
  {
    id: "manage_rooms",
    name: t("Manage Venue Layouts"),
    children: [],
    tooltip:
      "Employees will be able to build out venue layouts for assigned seating",
    require_totp: false,
    key: "VP_MANAGE_ROOMS",
  },
  {
    id: "manage_incidents",
    name: t("Manage Incidents"),
    modules: ["5"],
    children: ["view_incidents", "use_incidents"],
    require_totp: false,
    key: "VP_MANAGE_INCIDENTS",
  },
  {
    id: "view_incidents",
    name: t("View Incident Details"),
    modules: ["5"],
    children: ["use_incidents"],
    require_totp: false,
    key: "VP_VIEW_INCIDENTS",
  },
  {
    id: "use_incidents",
    name: t("Use Incident System"),
    modules: ["5"],
    children: [],
    require_totp: false,
    key: "VP_USE_INCIDENTS",
  },
  {
    id: "manage_memberships",
    name: t("Manage Memberships"),
    modules: ["6"],
    children: ["scan_memberships"],
    tooltip:
      "Employees will be able to manage memberships and membership benefits",
    require_totp: false,
    key: "VP_MANAGE_MEMBERSHIPS",
  },
  {
    id: "scan_memberships",
    name: t("Scan Memberships"),
    modules: ["6"],
    children: [],
    tooltip: "Employees will be able to scan member barcodes",
    require_totp: false,
    key: "VP_SCAN_MEMBERSHIPS",
  },
  {
    id: "manage_clickers",
    name: t("Manage Capacity Counters"),
    modules: ["4"],
    children: ["view_clickers", "use_clickers"],
    tooltip: "Employees will have full access to the capacity counter feature",
    require_totp: false,
    key: "VP_MANAGE_CLICKERS",
  },
  {
    id: "view_clickers",
    name: t("View Capacity Counter Info"),
    modules: ["4"],
    children: ["use_clickers"],
    tooltip:
      "Employees will be able to use capacity counters, but not discard them",
    require_totp: false,
    key: "VP_VIEW_CLICKERS",
  },
  {
    id: "use_clickers",
    name: t("Use Capacity Counters"),
    modules: ["4"],
    children: [],
    tooltip:
      "Employees will be given access to use capacity counters, but not manage or see counter info",
    require_totp: false,
    key: "VP_USE_CLICKERS",
  },
  {
    id: "manage_integrations",
    name: t("Manage Integrations"),
    children: [],
    tooltip: "Employees will be able to validate the available integrations",
    require_totp: false,
    key: "VP_MANAGE_INTEGRATIONS",
  },
  {
    id: "manage_financials",
    name: t("Manage Transactions"),
    children: ["administer_transactions"],
    tooltip:
      "Employees will be able to view all transactions, process refunds, and set custom fees or taxes at an organizational level",
    require_totp: true,
    key: "VP_MANAGE_FINANCIALS",
  },
  {
    id: "administer_transactions",
    name: t("Administer Transactions"),
    children: [],
    tooltip:
      "Employees will be able to refund, void, and resend confirmation emails",
    require_totp: true,
    key: "VP_ADMINISTER_TRANSACTIONS",
  },
  {
    id: "administer_cash_refunds",
    name: t("Administer Cash Refunds"),
    children: [],
    tooltip: "Employees will be able to refund cash transactions",
    require_totp: false,
    key: "VP_ADMINISTER_CASH_REFUNDS",
  },
  {
    id: "manage_bank_account",
    name: t("Manage Financials"),
    children: [],
    tooltip: "Employees will be able to change banking info.",
    require_totp: true,
    key: "VP_MANAGE_BANK_ACCOUNT",
  },
  {
    id: "manage_users",
    name: t("Manage Network"),
    children: [],
    tooltip:
      "Employees will have full access to the Network Management page and will be able to send out SMS and email messages",
    require_totp: true,
    key: "VP_MANAGE_USERS",
  },
  {
    id: "manage_widgets",
    name: t("Manage Widgets"),
    children: [],
    tooltip:
      "Employees will be able to access the event list and guestlist iFrame widgets",
    require_totp: false,
    key: "VP_MANAGE_WIDGETS",
  },
  {
    id: "manage_marketplace",
    name: t("Manage Marketplace"),
    children: [],
    tooltip:
      "Employees will have full access to the Marketplace and will be able to create items, and view transactions",
    require_totp: false,
    key: "VP_MANAGE_MARKETPLACE",
  },
  {
    id: "manage_reservations",
    name: t("Manage Guestlists"),
    modules: ["2"],
    children: ["view_reservations", "edit_booked_reservations"],
    tooltip: "Employees will have full access to the guestlist feature",
    require_totp: true,
    key: "VP_MANAGE_RESERVATIONS",
  },
  {
    id: "view_reservations",
    name: t("Check-in Guestlists"),
    modules: ["2"],
    children: [],
    tooltip: "Employees will be able to check in guestlists",
    require_totp: false,
    key: "VP_VIEW_RESERVATIONS",
  },
  {
    id: "edit_booked_reservations",
    name: t("Book Guestlists"),
    modules: ["2"],
    children: [],
    tooltip: "Employees will be able to book guestlists",
    require_totp: false,
    key: "VP_EDIT_BOOKED_RESERVATIONS",
  },
  {
    id: "manage_queues",
    name: t("Manage Queues"),
    modules: [],
    children: [],
    require_totp: false,
    key: "VP_MANAGE_QUEUES",
  },
  {
    id: "manage_events",
    name: t("Manage Events"),
    modules: ["1"],
    children: [],
    tooltip:
      "Employees will have access to everything related to managing and creating events. They will not have access to change custom fees and/or taxes on an event",
    require_totp: true,
    key: "VP_MANAGE_EVENTS",
  },
  {
    id: "manage_checkin_presets",
    name: t("Manage Check-in"),
    modules: ["1"],
    children: ["scan_tickets", "scan_memberships", "select_items_to_scan"],
    tooltip:
      "Employees will have the capability to manage check-in presets and undo prior check-ins",
    require_totp: false,
    key: "VP_MANAGE_CHECKIN_PRESETS",
  },
  {
    id: "scan_tickets",
    name: t("Scan Tickets"),
    modules: ["1"],
    children: [],
    tooltip: "Employees will be able to scan tickets in",
    require_totp: false,
    key: "VP_SCAN_TICKETS",
  },
  {
    id: "select_items_to_scan",
    name: t("Select Items to Scan"),
    modules: ["1"],
    children: [],
    tooltip: "Employees will be able to select which items to scan in",
    require_totp: false,
    key: "VP_SELECT_ITEMS_TO_SCAN",
  },
  {
    id: "use_box_office",
    name: t("Box Office Sales"),
    modules: ["1"],
    children: [],
    tooltip:
      "Employees will be able to sell tickets and products from the box office",
    require_totp: false,
    key: "VP_USE_BOX_OFFICE",
  },
  {
    id: "use_box_office_card",
    name: t("Credit Card Box Office Sales"),
    modules: ["1"],
    children: ["use_box_office"],
    tooltip:
      "Employees will be able to sell box office tickets via credit card",
    require_totp: false,
    key: "VP_USE_BOX_OFFICE_CARD",
  },
  {
    id: "sell_cash_tickets",
    name: t("Cash Box Office Sales"),
    modules: ["1"],
    children: ["use_box_office"],
    tooltip:
      "Employees will be able to complete cash transactions from the box office",
    require_totp: false,
    key: "VP_SELL_CASH_TICKETS",
  },
  {
    id: "sell_complimentary_tickets",
    name: t("Complimentary Box Office Sales"),
    modules: ["1"],
    children: ["use_box_office"],
    tooltip:
      "Employees will be able to sell complimentary tickets from the box office",
    require_totp: false,
    key: "VP_SELL_COMPLIMENTARY_TICKETS",
  },
  {
    id: "use_box_office_other",
    name: t("Other Box Office Sales"),
    modules: ["1"],
    children: ["use_box_office"],
    tooltip:
      "Employees will be able to sell box office tickets via other payment types",
    require_totp: false,
    key: "VP_USE_BOX_OFFICE_OTHER",
  },
  {
    id: "manage_reports",
    name: t("Manage Reports"),
    children: [],
    tooltip:
      "Employees will be able to create, send, and download different reports",
    require_totp: true,
    key: "VP_MANAGE_REPORTS",
  },
  {
    id: "manage_holds",
    name: t("Manage Holds"),
    modules: ["1"],
    children: ["use_box_office"],
    tooltip:
      "Employees will be able to manage holds in the box office that they have created",
    require_totp: false,
    key: "VP_MANAGE_HOLDS",
  },
  {
    id: "manage_all_holds",
    name: t("Manage All Holds"),
    modules: ["1"],
    children: ["manage_holds", "use_box_office"],
    tooltip: "Employees will be able to manage all holds in the box office",
    require_totp: false,
    key: "VP_MANAGE_ALL_HOLDS",
  },
  {
    id: "developer",
    name: t("Access Developer Features"),
    children: [],
    tooltip:
      "Employees will be able to access to developer features like webhooks",
    require_totp: false,
    key: "VP_DEVELOPER",
  },
  {
    id: "manage_group_sale",
    name: t("Group Sale Manager"),
    children: [],
    tooltip: "Employees will be able to access and manage group sales",
    require_totp: true,
    key: "VP_MANAGE_GROUP_SALE",
  },
  {
    id: "distribute_group_sale",
    name: t("Group Sale Distributor"),
    children: [],
    tooltip: "Employees will be able to distribute group sale tickets",
    require_totp: false,
    key: "VP_DISTRIBUTE_GROUP_SALE",
  },
  {
    id: "view_advanced_analytics",
    name: t("View Advanced Analytics"),
    children: [],
    tooltip: "Employees will be able to view advanced analytics dashboards",
    require_totp: true,
    key: "VP_VIEW_ADVANCED_ANALYTICS",
  },
  {
    id: "manage_access_pin",
    name: t("Access PIN Management"),
    children: [],
    tooltip: "Employees will be able to manage Access PINs",
    require_totp: true,
    key: "VP_MANAGE_ACCESS_PIN",
  },
  {
    id: "manage_module_usages",
    name: t("Manage Add-ons"),
    children: [],
    tooltip: "Employees will be able to view and manage add-ons",
    require_totp: false,
    key: "VP_MANAGE_MODULE_USAGES",
  },
] as const;

export const VENUE_MODULES = {
  VM_EVENTS: { id: "1", name: t("Events"), key: "VM_EVENTS" },
  VM_RESERVATIONS: { id: "2", name: t("Guestlists"), key: "VM_RESERVATIONS" },
  VM_CLICKERS: { id: "4", name: t("Capacity Counters"), key: "VM_CLICKERS" },
  VM_INCIDENTS: { id: "5", name: t("Incidents"), key: "VM_INCIDENTS" },
  VM_MEMBERSHIPS: { id: "6", name: t("Memberships"), key: "VM_MEMBERSHIPS" },
  VM_EXCHANGES: { id: "7", name: t("Exchanges"), key: "VM_EXCHANGES" },
  VM_GROUP_SALES: { id: "8", name: t("Group Sales"), key: "VM_GROUP_SALES" },
  VM_GIFT_CARDS: { id: "9", name: t("Gift Cards"), key: "VM_GIFT_CARDS" },
  VM_DONATIONS: { id: "10", name: t("Donations"), key: "VM_DONATIONS" },
} as const;

export const VENUE_MODULES_BY_ID = {
  "1": { id: "1", name: t("Events"), key: "VM_EVENTS" },
  "2": { id: "2", name: t("Guestlists"), key: "VM_RESERVATIONS" },
  "4": { id: "4", name: t("Capacity Counters"), key: "VM_CLICKERS" },
  "5": { id: "5", name: t("Incidents"), key: "VM_INCIDENTS" },
  "6": { id: "6", name: t("Memberships"), key: "VM_MEMBERSHIPS" },
  "7": { id: "7", name: t("Exchanges"), key: "VM_EXCHANGES" },
  "8": { id: "8", name: t("Group Sales"), key: "VM_GROUP_SALES" },
  "9": { id: "9", name: t("Gift Cards"), key: "VM_GIFT_CARDS" },
  "10": { id: "10", name: t("Donations"), key: "VM_DONATIONS" },
} as const;

export const VENUE_MODULES_BY_LIST = [
  { id: "1", name: t("Events"), key: "VM_EVENTS" },
  { id: "2", name: t("Guestlists"), key: "VM_RESERVATIONS" },
  { id: "4", name: t("Capacity Counters"), key: "VM_CLICKERS" },
  { id: "5", name: t("Incidents"), key: "VM_INCIDENTS" },
  { id: "6", name: t("Memberships"), key: "VM_MEMBERSHIPS" },
  { id: "7", name: t("Exchanges"), key: "VM_EXCHANGES" },
  { id: "8", name: t("Group Sales"), key: "VM_GROUP_SALES" },
  { id: "9", name: t("Gift Cards"), key: "VM_GIFT_CARDS" },
  { id: "10", name: t("Donations"), key: "VM_DONATIONS" },
] as const;

export const VENUE_PRICING_TIER_MAP = {
  VPT_BASIC: { id: "vpt_basic", name: t("Essential") },
  VPT_STANDARD: { id: "vpt_standard", name: t("Professional") },
  VPT_PREMIUM: { id: "vpt_premium", name: t("Premium") },
} as const;

export const VENUE_PRICING_TIER_MAP_BY_ID = {
  vpt_basic: { id: "vpt_basic", name: t("Essential") },
  vpt_standard: { id: "vpt_standard", name: t("Professional") },
  vpt_premium: { id: "vpt_premium", name: t("Premium") },
} as const;

export const VENUE_PRICING_TIER_MAP_BY_LIST = [
  { id: "vpt_basic", name: t("Essential") },
  { id: "vpt_standard", name: t("Professional") },
  { id: "vpt_premium", name: t("Premium") },
] as const;

export const VENUE_DESCRIPTION_LIMIT_MAP = {
  DESCRIPTION: {
    id: "short_description",
    name: t("Short Description"),
    limit: 256,
    key: "DESCRIPTION",
  },
  LONG_DESCRIPTION: {
    id: "long_description",
    name: t("Long Description"),
    limit: 5120,
    key: "LONG_DESCRIPTION",
  },
  SUBSCRIPTION_MESSAGE: {
    id: "subscription_message",
    name: t("Subscription Message"),
    limit: 256,
    key: "SUBSCRIPTION_MESSAGE",
  },
  REFUND_POLICY: {
    id: "refund_policy",
    name: t("Refund Policy"),
    limit: 512,
    key: "REFUND_POLICY",
  },
  CHECKOUT_MESSAGE: {
    id: "checkout_message",
    name: t("Checkout Message"),
    limit: 4096,
    key: "CHECKOUT_MESSAGE",
  },
  THANKS_EMAIL_BODY: {
    id: "thanks_email_body",
    name: t("Thank you Email Body"),
    limit: 4096,
    key: "THANKS_EMAIL_BODY",
  },
  MAX_UPCOMING_EVENT: {
    id: "max_upcoming_event",
    name: t("Maximum Upcoming Event"),
    limit: 4096,
    key: "MAX_UPCOMING_EVENT",
  },
  MAX_SUBMIT_MESSAGE: {
    id: "max_submit_message",
    name: t("Maximum Submit Review Message"),
    limit: 4096,
    key: "MAX_SUBMIT_MESSAGE",
  },
  MIN_CUSTOM_STATEMENT_DESC: {
    id: "min_custom_statement_desc",
    name: t("Minimum Custom Statement Description"),
    limit: 5,
    key: "MIN_CUSTOM_STATEMENT_DESC",
  },
  MAX_CUSTOM_STATEMENT_DESC: {
    id: "max_custom_statement_desc",
    name: t("Maximum Custom Statement Description"),
    limit: 14,
    key: "MAX_CUSTOM_STATEMENT_DESC",
  },
  MAX_CUSTOM_STATEMENT_DESC_V2: {
    id: "max_custom_statement_desc_v2",
    name: t("Maximum Custom Statement Description"),
    limit: 9,
    key: "MAX_CUSTOM_STATEMENT_DESC_V2",
  },
} as const;

export const VENUE_DESCRIPTION_LIMIT_MAP_BY_ID = {
  short_description: {
    id: "short_description",
    name: t("Short Description"),
    limit: 256,
    key: "DESCRIPTION",
  },
  long_description: {
    id: "long_description",
    name: t("Long Description"),
    limit: 5120,
    key: "LONG_DESCRIPTION",
  },
  subscription_message: {
    id: "subscription_message",
    name: t("Subscription Message"),
    limit: 256,
    key: "SUBSCRIPTION_MESSAGE",
  },
  refund_policy: {
    id: "refund_policy",
    name: t("Refund Policy"),
    limit: 512,
    key: "REFUND_POLICY",
  },
  checkout_message: {
    id: "checkout_message",
    name: t("Checkout Message"),
    limit: 4096,
    key: "CHECKOUT_MESSAGE",
  },
  thanks_email_body: {
    id: "thanks_email_body",
    name: t("Thank you Email Body"),
    limit: 4096,
    key: "THANKS_EMAIL_BODY",
  },
  max_upcoming_event: {
    id: "max_upcoming_event",
    name: t("Maximum Upcoming Event"),
    limit: 4096,
    key: "MAX_UPCOMING_EVENT",
  },
  max_submit_message: {
    id: "max_submit_message",
    name: t("Maximum Submit Review Message"),
    limit: 4096,
    key: "MAX_SUBMIT_MESSAGE",
  },
  min_custom_statement_desc: {
    id: "min_custom_statement_desc",
    name: t("Minimum Custom Statement Description"),
    limit: 5,
    key: "MIN_CUSTOM_STATEMENT_DESC",
  },
  max_custom_statement_desc: {
    id: "max_custom_statement_desc",
    name: t("Maximum Custom Statement Description"),
    limit: 14,
    key: "MAX_CUSTOM_STATEMENT_DESC",
  },
  max_custom_statement_desc_v2: {
    id: "max_custom_statement_desc_v2",
    name: t("Maximum Custom Statement Description"),
    limit: 9,
    key: "MAX_CUSTOM_STATEMENT_DESC_V2",
  },
} as const;

export const VENUE_DESCRIPTION_LIMIT_MAP_BY_LIST = [
  {
    id: "short_description",
    name: t("Short Description"),
    limit: 256,
    key: "DESCRIPTION",
  },
  {
    id: "long_description",
    name: t("Long Description"),
    limit: 5120,
    key: "LONG_DESCRIPTION",
  },
  {
    id: "subscription_message",
    name: t("Subscription Message"),
    limit: 256,
    key: "SUBSCRIPTION_MESSAGE",
  },
  {
    id: "refund_policy",
    name: t("Refund Policy"),
    limit: 512,
    key: "REFUND_POLICY",
  },
  {
    id: "checkout_message",
    name: t("Checkout Message"),
    limit: 4096,
    key: "CHECKOUT_MESSAGE",
  },
  {
    id: "thanks_email_body",
    name: t("Thank you Email Body"),
    limit: 4096,
    key: "THANKS_EMAIL_BODY",
  },
  {
    id: "max_upcoming_event",
    name: t("Maximum Upcoming Event"),
    limit: 4096,
    key: "MAX_UPCOMING_EVENT",
  },
  {
    id: "max_submit_message",
    name: t("Maximum Submit Review Message"),
    limit: 4096,
    key: "MAX_SUBMIT_MESSAGE",
  },
  {
    id: "min_custom_statement_desc",
    name: t("Minimum Custom Statement Description"),
    limit: 5,
    key: "MIN_CUSTOM_STATEMENT_DESC",
  },
  {
    id: "max_custom_statement_desc",
    name: t("Maximum Custom Statement Description"),
    limit: 14,
    key: "MAX_CUSTOM_STATEMENT_DESC",
  },
  {
    id: "max_custom_statement_desc_v2",
    name: t("Maximum Custom Statement Description"),
    limit: 9,
    key: "MAX_CUSTOM_STATEMENT_DESC_V2",
  },
] as const;

export const VENUE_CLIENT_TYPE_MAP = {
  REGULAR: {
    id: "regular",
    name: t("Regular"),
    flags_disabled: [],
    name_on_salesforce: "Regular",
    key: "REGULAR",
  },
  THIRD_PARTY: {
    id: "third_party",
    name: t("Third Party"),
    flags_disabled: ["discounts", "transfers"],
    name_on_salesforce: "Third Party",
    key: "THIRD_PARTY",
  },
  GHOST_PRODUCT: {
    id: "ghost_product",
    name: t("Ghost Product"),
    flags_disabled: ["transfers"],
    name_on_salesforce: "Ghost Product",
    key: "GHOST_PRODUCT",
  },
  AFFILIATE: {
    id: "affiliate",
    name: t("Affiliate"),
    flags_disabled: ["transfers"],
    name_on_salesforce: "Affiliate",
    key: "AFFILIATE",
  },
  SHOWPASS_INTERNAL: {
    id: "showpass_internal",
    name: t("Showpass Internal"),
    flags_disabled: [],
    name_on_salesforce: "Showpass Internal",
    key: "SHOWPASS_INTERNAL",
  },
  ANGEL_PRODUCT: {
    id: "angel_product",
    name: t("Angel Product"),
    flags_disabled: ["transfers"],
    name_on_salesforce: "Angel Product",
    key: "ANGEL_PRODUCT",
  },
} as const;

export const VENUE_CLIENT_TYPE_MAP_BY_ID = {
  regular: {
    id: "regular",
    name: t("Regular"),
    flags_disabled: [],
    name_on_salesforce: "Regular",
    key: "REGULAR",
  },
  third_party: {
    id: "third_party",
    name: t("Third Party"),
    flags_disabled: ["discounts", "transfers"],
    name_on_salesforce: "Third Party",
    key: "THIRD_PARTY",
  },
  ghost_product: {
    id: "ghost_product",
    name: t("Ghost Product"),
    flags_disabled: ["transfers"],
    name_on_salesforce: "Ghost Product",
    key: "GHOST_PRODUCT",
  },
  affiliate: {
    id: "affiliate",
    name: t("Affiliate"),
    flags_disabled: ["transfers"],
    name_on_salesforce: "Affiliate",
    key: "AFFILIATE",
  },
  showpass_internal: {
    id: "showpass_internal",
    name: t("Showpass Internal"),
    flags_disabled: [],
    name_on_salesforce: "Showpass Internal",
    key: "SHOWPASS_INTERNAL",
  },
  angel_product: {
    id: "angel_product",
    name: t("Angel Product"),
    flags_disabled: ["transfers"],
    name_on_salesforce: "Angel Product",
    key: "ANGEL_PRODUCT",
  },
} as const;

export const VENUE_CLIENT_TYPE_MAP_BY_LIST = [
  {
    id: "regular",
    name: t("Regular"),
    flags_disabled: [],
    name_on_salesforce: "Regular",
    key: "REGULAR",
  },
  {
    id: "third_party",
    name: t("Third Party"),
    flags_disabled: ["discounts", "transfers"],
    name_on_salesforce: "Third Party",
    key: "THIRD_PARTY",
  },
  {
    id: "ghost_product",
    name: t("Ghost Product"),
    flags_disabled: ["transfers"],
    name_on_salesforce: "Ghost Product",
    key: "GHOST_PRODUCT",
  },
  {
    id: "affiliate",
    name: t("Affiliate"),
    flags_disabled: ["transfers"],
    name_on_salesforce: "Affiliate",
    key: "AFFILIATE",
  },
  {
    id: "showpass_internal",
    name: t("Showpass Internal"),
    flags_disabled: [],
    name_on_salesforce: "Showpass Internal",
    key: "SHOWPASS_INTERNAL",
  },
  {
    id: "angel_product",
    name: t("Angel Product"),
    flags_disabled: ["transfers"],
    name_on_salesforce: "Angel Product",
    key: "ANGEL_PRODUCT",
  },
] as const;

export const GENDERS = {
  GENDER_MALE: { id: "male", name: t("Male"), key: "GENDER_MALE" },
  GENDER_FEMALE: { id: "female", name: t("Female"), key: "GENDER_FEMALE" },
  GENDER_NON_BINARY: {
    id: "non_binary",
    name: t("Non-binary"),
    key: "GENDER_NON_BINARY",
  },
  GENDER_OPT_OUT: {
    id: "opt_out",
    name: t("Prefer not to say"),
    key: "GENDER_OPT_OUT",
  },
} as const;

export const GENDERS_BY_ID = {
  male: { id: "male", name: t("Male"), key: "GENDER_MALE" },
  female: { id: "female", name: t("Female"), key: "GENDER_FEMALE" },
  non_binary: {
    id: "non_binary",
    name: t("Non-binary"),
    key: "GENDER_NON_BINARY",
  },
  opt_out: {
    id: "opt_out",
    name: t("Prefer not to say"),
    key: "GENDER_OPT_OUT",
  },
} as const;

export const GENDERS_BY_LIST = [
  { id: "male", name: t("Male"), key: "GENDER_MALE" },
  { id: "female", name: t("Female"), key: "GENDER_FEMALE" },
  { id: "non_binary", name: t("Non-binary"), key: "GENDER_NON_BINARY" },
  { id: "opt_out", name: t("Prefer not to say"), key: "GENDER_OPT_OUT" },
] as const;

export const ALLOWED_TIMEZONES = [
  "Africa/Abidjan",
  "Africa/Accra",
  "Africa/Addis_Ababa",
  "Africa/Algiers",
  "Africa/Asmara",
  "Africa/Bamako",
  "Africa/Bangui",
  "Africa/Banjul",
  "Africa/Bissau",
  "Africa/Blantyre",
  "Africa/Brazzaville",
  "Africa/Bujumbura",
  "Africa/Cairo",
  "Africa/Casablanca",
  "Africa/Ceuta",
  "Africa/Conakry",
  "Africa/Dakar",
  "Africa/Dar_es_Salaam",
  "Africa/Djibouti",
  "Africa/Douala",
  "Africa/El_Aaiun",
  "Africa/Freetown",
  "Africa/Gaborone",
  "Africa/Harare",
  "Africa/Johannesburg",
  "Africa/Juba",
  "Africa/Kampala",
  "Africa/Khartoum",
  "Africa/Kigali",
  "Africa/Kinshasa",
  "Africa/Lagos",
  "Africa/Libreville",
  "Africa/Lome",
  "Africa/Luanda",
  "Africa/Lubumbashi",
  "Africa/Lusaka",
  "Africa/Malabo",
  "Africa/Maputo",
  "Africa/Maseru",
  "Africa/Mbabane",
  "Africa/Mogadishu",
  "Africa/Monrovia",
  "Africa/Nairobi",
  "Africa/Ndjamena",
  "Africa/Niamey",
  "Africa/Nouakchott",
  "Africa/Ouagadougou",
  "Africa/Porto-Novo",
  "Africa/Sao_Tome",
  "Africa/Tripoli",
  "Africa/Tunis",
  "Africa/Windhoek",
  "America/Adak",
  "America/Anchorage",
  "America/Anguilla",
  "America/Antigua",
  "America/Araguaina",
  "America/Argentina/Buenos_Aires",
  "America/Argentina/Catamarca",
  "America/Argentina/Cordoba",
  "America/Argentina/Jujuy",
  "America/Argentina/La_Rioja",
  "America/Argentina/Mendoza",
  "America/Argentina/Rio_Gallegos",
  "America/Argentina/Salta",
  "America/Argentina/San_Juan",
  "America/Argentina/San_Luis",
  "America/Argentina/Tucuman",
  "America/Argentina/Ushuaia",
  "America/Aruba",
  "America/Asuncion",
  "America/Atikokan",
  "America/Bahia",
  "America/Bahia_Banderas",
  "America/Barbados",
  "America/Belem",
  "America/Belize",
  "America/Blanc-Sablon",
  "America/Boa_Vista",
  "America/Bogota",
  "America/Boise",
  "America/Cambridge_Bay",
  "America/Campo_Grande",
  "America/Cancun",
  "America/Caracas",
  "America/Cayenne",
  "America/Cayman",
  "America/Chicago",
  "America/Chihuahua",
  "America/Ciudad_Juarez",
  "America/Costa_Rica",
  "America/Coyhaique",
  "America/Creston",
  "America/Cuiaba",
  "America/Curacao",
  "America/Danmarkshavn",
  "America/Dawson",
  "America/Dawson_Creek",
  "America/Denver",
  "America/Detroit",
  "America/Dominica",
  "America/Edmonton",
  "America/Eirunepe",
  "America/El_Salvador",
  "America/Fort_Nelson",
  "America/Fortaleza",
  "America/Glace_Bay",
  "America/Goose_Bay",
  "America/Grand_Turk",
  "America/Grenada",
  "America/Guadeloupe",
  "America/Guatemala",
  "America/Guayaquil",
  "America/Guyana",
  "America/Halifax",
  "America/Havana",
  "America/Hermosillo",
  "America/Indiana/Indianapolis",
  "America/Indiana/Knox",
  "America/Indiana/Marengo",
  "America/Indiana/Petersburg",
  "America/Indiana/Tell_City",
  "America/Indiana/Vevay",
  "America/Indiana/Vincennes",
  "America/Indiana/Winamac",
  "America/Inuvik",
  "America/Iqaluit",
  "America/Jamaica",
  "America/Juneau",
  "America/Kentucky/Louisville",
  "America/Kentucky/Monticello",
  "America/Kralendijk",
  "America/La_Paz",
  "America/Lima",
  "America/Los_Angeles",
  "America/Lower_Princes",
  "America/Maceio",
  "America/Managua",
  "America/Manaus",
  "America/Marigot",
  "America/Martinique",
  "America/Matamoros",
  "America/Mazatlan",
  "America/Menominee",
  "America/Merida",
  "America/Metlakatla",
  "America/Mexico_City",
  "America/Miquelon",
  "America/Moncton",
  "America/Monterrey",
  "America/Montevideo",
  "America/Montserrat",
  "America/Nassau",
  "America/New_York",
  "America/Nome",
  "America/Noronha",
  "America/North_Dakota/Beulah",
  "America/North_Dakota/Center",
  "America/North_Dakota/New_Salem",
  "America/Nuuk",
  "America/Ojinaga",
  "America/Panama",
  "America/Paramaribo",
  "America/Phoenix",
  "America/Port-au-Prince",
  "America/Port_of_Spain",
  "America/Porto_Velho",
  "America/Puerto_Rico",
  "America/Punta_Arenas",
  "America/Rankin_Inlet",
  "America/Recife",
  "America/Regina",
  "America/Resolute",
  "America/Rio_Branco",
  "America/Santarem",
  "America/Santiago",
  "America/Santo_Domingo",
  "America/Sao_Paulo",
  "America/Scoresbysund",
  "America/Sitka",
  "America/St_Barthelemy",
  "America/St_Johns",
  "America/St_Kitts",
  "America/St_Lucia",
  "America/St_Thomas",
  "America/St_Vincent",
  "America/Swift_Current",
  "America/Tegucigalpa",
  "America/Thule",
  "America/Tijuana",
  "America/Toronto",
  "America/Tortola",
  "America/Vancouver",
  "America/Whitehorse",
  "America/Winnipeg",
  "America/Yakutat",
  "Antarctica/Casey",
  "Antarctica/Davis",
  "Antarctica/DumontDUrville",
  "Antarctica/Macquarie",
  "Antarctica/Mawson",
  "Antarctica/McMurdo",
  "Antarctica/Palmer",
  "Antarctica/Rothera",
  "Antarctica/Syowa",
  "Antarctica/Troll",
  "Antarctica/Vostok",
  "Arctic/Longyearbyen",
  "Asia/Aden",
  "Asia/Almaty",
  "Asia/Amman",
  "Asia/Anadyr",
  "Asia/Aqtau",
  "Asia/Aqtobe",
  "Asia/Ashgabat",
  "Asia/Atyrau",
  "Asia/Baghdad",
  "Asia/Bahrain",
  "Asia/Baku",
  "Asia/Bangkok",
  "Asia/Barnaul",
  "Asia/Beirut",
  "Asia/Bishkek",
  "Asia/Brunei",
  "Asia/Chita",
  "Asia/Colombo",
  "Asia/Damascus",
  "Asia/Dhaka",
  "Asia/Dili",
  "Asia/Dubai",
  "Asia/Dushanbe",
  "Asia/Famagusta",
  "Asia/Gaza",
  "Asia/Hebron",
  "Asia/Ho_Chi_Minh",
  "Asia/Hong_Kong",
  "Asia/Hovd",
  "Asia/Irkutsk",
  "Asia/Jakarta",
  "Asia/Jayapura",
  "Asia/Jerusalem",
  "Asia/Kabul",
  "Asia/Kamchatka",
  "Asia/Karachi",
  "Asia/Kathmandu",
  "Asia/Khandyga",
  "Asia/Kolkata",
  "Asia/Krasnoyarsk",
  "Asia/Kuala_Lumpur",
  "Asia/Kuching",
  "Asia/Kuwait",
  "Asia/Macau",
  "Asia/Magadan",
  "Asia/Makassar",
  "Asia/Manila",
  "Asia/Muscat",
  "Asia/Nicosia",
  "Asia/Novokuznetsk",
  "Asia/Novosibirsk",
  "Asia/Omsk",
  "Asia/Oral",
  "Asia/Phnom_Penh",
  "Asia/Pontianak",
  "Asia/Pyongyang",
  "Asia/Qatar",
  "Asia/Qostanay",
  "Asia/Qyzylorda",
  "Asia/Riyadh",
  "Asia/Sakhalin",
  "Asia/Samarkand",
  "Asia/Seoul",
  "Asia/Shanghai",
  "Asia/Singapore",
  "Asia/Srednekolymsk",
  "Asia/Taipei",
  "Asia/Tashkent",
  "Asia/Tbilisi",
  "Asia/Tehran",
  "Asia/Thimphu",
  "Asia/Tokyo",
  "Asia/Tomsk",
  "Asia/Ulaanbaatar",
  "Asia/Urumqi",
  "Asia/Ust-Nera",
  "Asia/Vientiane",
  "Asia/Vladivostok",
  "Asia/Yakutsk",
  "Asia/Yangon",
  "Asia/Yekaterinburg",
  "Asia/Yerevan",
  "Atlantic/Azores",
  "Atlantic/Bermuda",
  "Atlantic/Canary",
  "Atlantic/Cape_Verde",
  "Atlantic/Faroe",
  "Atlantic/Madeira",
  "Atlantic/Reykjavik",
  "Atlantic/South_Georgia",
  "Atlantic/St_Helena",
  "Atlantic/Stanley",
  "Australia/Adelaide",
  "Australia/Brisbane",
  "Australia/Broken_Hill",
  "Australia/Darwin",
  "Australia/Eucla",
  "Australia/Hobart",
  "Australia/Lindeman",
  "Australia/Lord_Howe",
  "Australia/Melbourne",
  "Australia/Perth",
  "Australia/Sydney",
  "Canada/Atlantic",
  "Canada/Central",
  "Canada/Eastern",
  "Canada/Mountain",
  "Canada/Newfoundland",
  "Canada/Pacific",
  "Europe/Amsterdam",
  "Europe/Andorra",
  "Europe/Astrakhan",
  "Europe/Athens",
  "Europe/Belgrade",
  "Europe/Berlin",
  "Europe/Bratislava",
  "Europe/Brussels",
  "Europe/Bucharest",
  "Europe/Budapest",
  "Europe/Busingen",
  "Europe/Chisinau",
  "Europe/Copenhagen",
  "Europe/Dublin",
  "Europe/Gibraltar",
  "Europe/Guernsey",
  "Europe/Helsinki",
  "Europe/Isle_of_Man",
  "Europe/Istanbul",
  "Europe/Jersey",
  "Europe/Kaliningrad",
  "Europe/Kirov",
  "Europe/Kyiv",
  "Europe/Lisbon",
  "Europe/Ljubljana",
  "Europe/London",
  "Europe/Luxembourg",
  "Europe/Madrid",
  "Europe/Malta",
  "Europe/Mariehamn",
  "Europe/Minsk",
  "Europe/Monaco",
  "Europe/Moscow",
  "Europe/Oslo",
  "Europe/Paris",
  "Europe/Podgorica",
  "Europe/Prague",
  "Europe/Riga",
  "Europe/Rome",
  "Europe/Samara",
  "Europe/San_Marino",
  "Europe/Sarajevo",
  "Europe/Saratov",
  "Europe/Simferopol",
  "Europe/Skopje",
  "Europe/Sofia",
  "Europe/Stockholm",
  "Europe/Tallinn",
  "Europe/Tirane",
  "Europe/Ulyanovsk",
  "Europe/Vaduz",
  "Europe/Vatican",
  "Europe/Vienna",
  "Europe/Vilnius",
  "Europe/Volgograd",
  "Europe/Warsaw",
  "Europe/Zagreb",
  "Europe/Zurich",
  "GMT",
  "Indian/Antananarivo",
  "Indian/Chagos",
  "Indian/Christmas",
  "Indian/Cocos",
  "Indian/Comoro",
  "Indian/Kerguelen",
  "Indian/Mahe",
  "Indian/Maldives",
  "Indian/Mauritius",
  "Indian/Mayotte",
  "Indian/Reunion",
  "Pacific/Apia",
  "Pacific/Auckland",
  "Pacific/Bougainville",
  "Pacific/Chatham",
  "Pacific/Chuuk",
  "Pacific/Easter",
  "Pacific/Efate",
  "Pacific/Fakaofo",
  "Pacific/Fiji",
  "Pacific/Funafuti",
  "Pacific/Galapagos",
  "Pacific/Gambier",
  "Pacific/Guadalcanal",
  "Pacific/Guam",
  "Pacific/Honolulu",
  "Pacific/Kanton",
  "Pacific/Kiritimati",
  "Pacific/Kosrae",
  "Pacific/Kwajalein",
  "Pacific/Majuro",
  "Pacific/Marquesas",
  "Pacific/Midway",
  "Pacific/Nauru",
  "Pacific/Niue",
  "Pacific/Norfolk",
  "Pacific/Noumea",
  "Pacific/Pago_Pago",
  "Pacific/Palau",
  "Pacific/Pitcairn",
  "Pacific/Pohnpei",
  "Pacific/Port_Moresby",
  "Pacific/Rarotonga",
  "Pacific/Saipan",
  "Pacific/Tahiti",
  "Pacific/Tarawa",
  "Pacific/Tongatapu",
  "Pacific/Wake",
  "Pacific/Wallis",
  "US/Alaska",
  "US/Arizona",
  "US/Central",
  "US/Eastern",
  "US/Hawaii",
  "US/Mountain",
  "US/Pacific",
  "UTC",
] as const;

export const TRACKING_TOKEN_TYPES = {
  TR_SIMPLE: {
    id: "tr_simple",
    required: ["tracking_url"],
    name: t("Simple"),
    key: "TR_SIMPLE",
  },
  TR_GOOGLE_ADWORDS: {
    id: "tr_google_adwords",
    required: ["tracking_id"],
    name: t("Google Adwords"),
    key: "TR_GOOGLE_ADWORDS",
  },
  TR_FACEBOOK: {
    id: "tr_facebook",
    required: ["tracking_id"],
    name: t("Facebook"),
    key: "TR_FACEBOOK",
  },
  TR_TWITTER: {
    id: "ct_token",
    required: ["tracking_id"],
    name: t("Twitter"),
    key: "TR_TWITTER",
  },
  TR_TRADABLE_BITS: {
    id: "tr_tradable_bits",
    required: ["tracking_id"],
    name: t("Tradable Bits"),
    key: "TR_TRADABLE_BITS",
  },
} as const;

export const TRACKING_TOKEN_TYPES_BY_ID = {
  tr_simple: {
    id: "tr_simple",
    required: ["tracking_url"],
    name: t("Simple"),
    key: "TR_SIMPLE",
  },
  tr_google_adwords: {
    id: "tr_google_adwords",
    required: ["tracking_id"],
    name: t("Google Adwords"),
    key: "TR_GOOGLE_ADWORDS",
  },
  tr_facebook: {
    id: "tr_facebook",
    required: ["tracking_id"],
    name: t("Facebook"),
    key: "TR_FACEBOOK",
  },
  ct_token: {
    id: "ct_token",
    required: ["tracking_id"],
    name: t("Twitter"),
    key: "TR_TWITTER",
  },
  tr_tradable_bits: {
    id: "tr_tradable_bits",
    required: ["tracking_id"],
    name: t("Tradable Bits"),
    key: "TR_TRADABLE_BITS",
  },
} as const;

export const TRACKING_TOKEN_TYPES_BY_LIST = [
  {
    id: "tr_simple",
    required: ["tracking_url"],
    name: t("Simple"),
    key: "TR_SIMPLE",
  },
  {
    id: "tr_google_adwords",
    required: ["tracking_id"],
    name: t("Google Adwords"),
    key: "TR_GOOGLE_ADWORDS",
  },
  {
    id: "tr_facebook",
    required: ["tracking_id"],
    name: t("Facebook"),
    key: "TR_FACEBOOK",
  },
  {
    id: "ct_token",
    required: ["tracking_id"],
    name: t("Twitter"),
    key: "TR_TWITTER",
  },
  {
    id: "tr_tradable_bits",
    required: ["tracking_id"],
    name: t("Tradable Bits"),
    key: "TR_TRADABLE_BITS",
  },
] as const;

export const TRACKING_TOKEN_LOCATIONS = {
  LOCATION_CHECKOUT: {
    id: 1,
    name: t("Checkout page"),
    key: "LOCATION_CHECKOUT",
  },
  LOCATION_POST_CHECKOUT: {
    id: 2,
    name: t("Post-checkout page"),
    key: "LOCATION_POST_CHECKOUT",
  },
  LOCATION_PUBLIC_EVENT: {
    id: 3,
    name: t("Public event page"),
    key: "LOCATION_PUBLIC_EVENT",
  },
  LOCATION_ADD_CART: {
    id: 4,
    name: t("Add to cart"),
    key: "LOCATION_ADD_CART",
  },
  LOCATION_PUBLIC_MEMBERSHIP: {
    id: 5,
    name: t("Public membership page"),
    key: "LOCATION_PUBLIC_MEMBERSHIP",
  },
} as const;

export const TRACKING_TOKEN_LOCATIONS_BY_ID = {
  "1": { id: 1, name: t("Checkout page"), key: "LOCATION_CHECKOUT" },
  "2": { id: 2, name: t("Post-checkout page"), key: "LOCATION_POST_CHECKOUT" },
  "3": { id: 3, name: t("Public event page"), key: "LOCATION_PUBLIC_EVENT" },
  "4": { id: 4, name: t("Add to cart"), key: "LOCATION_ADD_CART" },
  "5": {
    id: 5,
    name: t("Public membership page"),
    key: "LOCATION_PUBLIC_MEMBERSHIP",
  },
} as const;

export const TRACKING_TOKEN_LOCATIONS_BY_LIST = [
  { id: 1, name: t("Checkout page"), key: "LOCATION_CHECKOUT" },
  { id: 2, name: t("Post-checkout page"), key: "LOCATION_POST_CHECKOUT" },
  { id: 3, name: t("Public event page"), key: "LOCATION_PUBLIC_EVENT" },
  { id: 4, name: t("Add to cart"), key: "LOCATION_ADD_CART" },
  {
    id: 5,
    name: t("Public membership page"),
    key: "LOCATION_PUBLIC_MEMBERSHIP",
  },
] as const;

export const TRACKING_TOKEN_LOCATION_MAP = {
  LOCATION_CHECKOUT: {
    id: 1,
    name: t("Checkout page"),
    key: "LOCATION_CHECKOUT",
  },
  LOCATION_POST_CHECKOUT: {
    id: 2,
    name: t("Post-checkout page"),
    key: "LOCATION_POST_CHECKOUT",
  },
  LOCATION_PUBLIC_EVENT: {
    id: 3,
    name: t("Public event page"),
    key: "LOCATION_PUBLIC_EVENT",
  },
  LOCATION_ADD_CART: {
    id: 4,
    name: t("Add to cart"),
    key: "LOCATION_ADD_CART",
  },
  LOCATION_PUBLIC_MEMBERSHIP: {
    id: 5,
    name: t("Public membership page"),
    key: "LOCATION_PUBLIC_MEMBERSHIP",
  },
} as const;

export const TRACKING_TOKEN_LOCATION_MAP_BY_ID = {
  "1": { id: 1, name: t("Checkout page"), key: "LOCATION_CHECKOUT" },
  "2": { id: 2, name: t("Post-checkout page"), key: "LOCATION_POST_CHECKOUT" },
  "3": { id: 3, name: t("Public event page"), key: "LOCATION_PUBLIC_EVENT" },
  "4": { id: 4, name: t("Add to cart"), key: "LOCATION_ADD_CART" },
  "5": {
    id: 5,
    name: t("Public membership page"),
    key: "LOCATION_PUBLIC_MEMBERSHIP",
  },
} as const;

export const TRACKING_TOKEN_LOCATION_MAP_BY_LIST = [
  { id: 1, name: t("Checkout page"), key: "LOCATION_CHECKOUT" },
  { id: 2, name: t("Post-checkout page"), key: "LOCATION_POST_CHECKOUT" },
  { id: 3, name: t("Public event page"), key: "LOCATION_PUBLIC_EVENT" },
  { id: 4, name: t("Add to cart"), key: "LOCATION_ADD_CART" },
  {
    id: 5,
    name: t("Public membership page"),
    key: "LOCATION_PUBLIC_MEMBERSHIP",
  },
] as const;

export const TRACKING_LINK_TYPE_MAP = {
  EMPLOYEE: {
    id: 1,
    name: t("Employee"),
    generated: false,
    purchasable: false,
    key: "EMPLOYEE",
  },
  VENUE: {
    id: 2,
    name: t("Venue"),
    generated: false,
    purchasable: false,
    key: "VENUE",
  },
  AFFILIATE: {
    id: 3,
    name: t("Affiliate"),
    generated: false,
    purchasable: false,
    key: "AFFILIATE",
  },
  QUICK_PURCHASE: {
    id: 4,
    name: t("Quick Checkout Purchase"),
    generated: false,
    purchasable: true,
    key: "QUICK_PURCHASE",
  },
  ABANDONED_BASKET: {
    id: 5,
    name: t("Abandoned Basket"),
    generated: true,
    purchasable: true,
    key: "ABANDONED_BASKET",
  },
  HELD_BASKET: {
    id: 6,
    name: t("Held Basket"),
    generated: true,
    purchasable: true,
    key: "HELD_BASKET",
  },
  MEMBERSHIP_RENEWAL: {
    id: 7,
    name: t("Membership Renewal"),
    generated: true,
    purchasable: true,
    key: "MEMBERSHIP_RENEWAL",
  },
  HELD_BASKET_DYNAMIC: {
    id: 8,
    name: t("Held Basket Dynamic"),
    generated: true,
    purchasable: true,
    key: "HELD_BASKET_DYNAMIC",
  },
  QUICK_EVENT_PURCHASE: {
    id: 9,
    name: t("Quick Event Purchase"),
    generated: false,
    purchasable: false,
    key: "QUICK_EVENT_PURCHASE",
  },
  ABANDONED_BASKET_SEATING_EVENT: {
    id: 10,
    name: t("Abandoned Basket Seating Event"),
    generated: true,
    purchasable: false,
    key: "ABANDONED_BASKET_SEATING_EVENT",
  },
  SMS_TICKETS: {
    id: 11,
    name: t("SMS Tickets"),
    generated: true,
    purchasable: false,
    key: "SMS_TICKETS",
  },
} as const;

export const TRACKING_LINK_TYPE_MAP_BY_ID = {
  "1": {
    id: 1,
    name: t("Employee"),
    generated: false,
    purchasable: false,
    key: "EMPLOYEE",
  },
  "2": {
    id: 2,
    name: t("Venue"),
    generated: false,
    purchasable: false,
    key: "VENUE",
  },
  "3": {
    id: 3,
    name: t("Affiliate"),
    generated: false,
    purchasable: false,
    key: "AFFILIATE",
  },
  "4": {
    id: 4,
    name: t("Quick Checkout Purchase"),
    generated: false,
    purchasable: true,
    key: "QUICK_PURCHASE",
  },
  "5": {
    id: 5,
    name: t("Abandoned Basket"),
    generated: true,
    purchasable: true,
    key: "ABANDONED_BASKET",
  },
  "6": {
    id: 6,
    name: t("Held Basket"),
    generated: true,
    purchasable: true,
    key: "HELD_BASKET",
  },
  "7": {
    id: 7,
    name: t("Membership Renewal"),
    generated: true,
    purchasable: true,
    key: "MEMBERSHIP_RENEWAL",
  },
  "8": {
    id: 8,
    name: t("Held Basket Dynamic"),
    generated: true,
    purchasable: true,
    key: "HELD_BASKET_DYNAMIC",
  },
  "9": {
    id: 9,
    name: t("Quick Event Purchase"),
    generated: false,
    purchasable: false,
    key: "QUICK_EVENT_PURCHASE",
  },
  "10": {
    id: 10,
    name: t("Abandoned Basket Seating Event"),
    generated: true,
    purchasable: false,
    key: "ABANDONED_BASKET_SEATING_EVENT",
  },
  "11": {
    id: 11,
    name: t("SMS Tickets"),
    generated: true,
    purchasable: false,
    key: "SMS_TICKETS",
  },
} as const;

export const TRACKING_LINK_TYPE_MAP_BY_LIST = [
  {
    id: 1,
    name: t("Employee"),
    generated: false,
    purchasable: false,
    key: "EMPLOYEE",
  },
  {
    id: 2,
    name: t("Venue"),
    generated: false,
    purchasable: false,
    key: "VENUE",
  },
  {
    id: 3,
    name: t("Affiliate"),
    generated: false,
    purchasable: false,
    key: "AFFILIATE",
  },
  {
    id: 4,
    name: t("Quick Checkout Purchase"),
    generated: false,
    purchasable: true,
    key: "QUICK_PURCHASE",
  },
  {
    id: 5,
    name: t("Abandoned Basket"),
    generated: true,
    purchasable: true,
    key: "ABANDONED_BASKET",
  },
  {
    id: 6,
    name: t("Held Basket"),
    generated: true,
    purchasable: true,
    key: "HELD_BASKET",
  },
  {
    id: 7,
    name: t("Membership Renewal"),
    generated: true,
    purchasable: true,
    key: "MEMBERSHIP_RENEWAL",
  },
  {
    id: 8,
    name: t("Held Basket Dynamic"),
    generated: true,
    purchasable: true,
    key: "HELD_BASKET_DYNAMIC",
  },
  {
    id: 9,
    name: t("Quick Event Purchase"),
    generated: false,
    purchasable: false,
    key: "QUICK_EVENT_PURCHASE",
  },
  {
    id: 10,
    name: t("Abandoned Basket Seating Event"),
    generated: true,
    purchasable: false,
    key: "ABANDONED_BASKET_SEATING_EVENT",
  },
  {
    id: 11,
    name: t("SMS Tickets"),
    generated: true,
    purchasable: false,
    key: "SMS_TICKETS",
  },
] as const;

export const NOTIFICATION_PERMISSIONS = {
  notify_user: {
    id: "notify_user",
    detail: t(
      "Flag for all notifications. Disabling this will stop all type of notification"
    ),
    name: t("All notifications"),
    key: "notify_user",
  },
  sms: {
    id: "sms_send_general",
    detail: t("Disabling this will stop all SMS notifications"),
    name: t("SMS"),
    fields: [
      "sms_reservations",
      "sms_purchases",
      "sms_transfers",
      "sms_campaigns",
    ],
    definitions: {
      reservations: {
        id: "sms_reservations",
        detail: t(
          "Notifications for approving and confirming guestlist requests"
        ),
        name: t("Guestlists"),
        enabled_by_default: true,
        key: "reservations",
      },
      purchases: {
        id: "sms_purchases",
        detail: t("Notifications for new ticket/product purchases"),
        name: t("New Purchases"),
        enabled_by_default: false,
        key: "purchases",
      },
      transfers: {
        id: "sms_transfers",
        detail: t(
          "Notifications for sending and receiving ticket/product transfers"
        ),
        name: t("Ticket Transfers"),
        enabled_by_default: true,
        key: "transfers",
      },
      campaigns: {
        id: "sms_campaigns",
        detail: t("Notifications for SMS campaigns"),
        name: t("Campaigns"),
        enabled_by_default: true,
        key: "campaigns",
      },
    },
    key: "sms",
  },
  push: {
    id: "push_general",
    detail: t("Disabling this will stop all mobile push notifications"),
    name: t("Push"),
    fields: ["push_reservations", "push_purchases", "push_transfers"],
    definitions: {
      reservations: {
        id: "push_reservations",
        detail: t(
          "Notifications for approving and confirming guestlist requests"
        ),
        name: t("Guestlists"),
        title: "Reservations",
        push_type: 1,
        key: "reservations",
      },
      purchases: {
        id: "push_purchases",
        detail: t("Notifications for new ticket/product purchases"),
        name: t("New Purchases"),
        title: "New Purchases",
        push_type: 2,
        key: "purchases",
      },
      transfers: {
        id: "push_transfers",
        detail: t(
          "Notifications for sending and receiving ticket/product transfers"
        ),
        name: t("Transfers"),
        title: "Ticket Transfers",
        push_type: 3,
        key: "transfers",
      },
    },
    key: "push",
  },
  email: {
    id: "email_send_general",
    detail: t("Disabling this will stop all email notifications"),
    name: t("Email"),
    fields: [
      "email_reservations",
      "email_purchases",
      "email_event_notifications",
      "email_abandoned_carts",
    ],
    definitions: {
      reservations: {
        id: "email_reservations",
        detail: t(
          "Notifications for approving and confirming guestlist requests"
        ),
        name: t("Guestlists"),
        key: "reservations",
      },
      purchases: {
        id: "email_purchases",
        detail: t("Notifications for new ticket/product purchases"),
        name: t("New Purchases"),
        key: "purchases",
      },
      events: {
        id: "email_event_notifications",
        detail: t("Notifications for events"),
        name: t("Events"),
        key: "events",
      },
      abandoned_carts: {
        id: "email_abandoned_carts",
        detail: t("Notifications to recover abandoned carts"),
        name: t("Abandoned Carts"),
        key: "abandoned_carts",
      },
    },
    key: "email",
  },
} as const;

export const NOTIFICATION_PERMISSIONS_BY_ID = {
  sms_send_general: {
    id: "sms_send_general",
    detail: t("Disabling this will stop all SMS notifications"),
    name: t("SMS"),
    fields: [
      "sms_reservations",
      "sms_purchases",
      "sms_transfers",
      "sms_campaigns",
    ],
    definitions: {
      reservations: {
        id: "sms_reservations",
        detail: t(
          "Notifications for approving and confirming guestlist requests"
        ),
        name: t("Guestlists"),
        enabled_by_default: true,
        key: "reservations",
      },
      purchases: {
        id: "sms_purchases",
        detail: t("Notifications for new ticket/product purchases"),
        name: t("New Purchases"),
        enabled_by_default: false,
        key: "purchases",
      },
      transfers: {
        id: "sms_transfers",
        detail: t(
          "Notifications for sending and receiving ticket/product transfers"
        ),
        name: t("Ticket Transfers"),
        enabled_by_default: true,
        key: "transfers",
      },
      campaigns: {
        id: "sms_campaigns",
        detail: t("Notifications for SMS campaigns"),
        name: t("Campaigns"),
        enabled_by_default: true,
        key: "campaigns",
      },
    },
    key: "sms",
  },
  push_general: {
    id: "push_general",
    detail: t("Disabling this will stop all mobile push notifications"),
    name: t("Push"),
    fields: ["push_reservations", "push_purchases", "push_transfers"],
    definitions: {
      reservations: {
        id: "push_reservations",
        detail: t(
          "Notifications for approving and confirming guestlist requests"
        ),
        name: t("Guestlists"),
        title: "Reservations",
        push_type: 1,
        key: "reservations",
      },
      purchases: {
        id: "push_purchases",
        detail: t("Notifications for new ticket/product purchases"),
        name: t("New Purchases"),
        title: "New Purchases",
        push_type: 2,
        key: "purchases",
      },
      transfers: {
        id: "push_transfers",
        detail: t(
          "Notifications for sending and receiving ticket/product transfers"
        ),
        name: t("Transfers"),
        title: "Ticket Transfers",
        push_type: 3,
        key: "transfers",
      },
    },
    key: "push",
  },
  email_send_general: {
    id: "email_send_general",
    detail: t("Disabling this will stop all email notifications"),
    name: t("Email"),
    fields: [
      "email_reservations",
      "email_purchases",
      "email_event_notifications",
      "email_abandoned_carts",
    ],
    definitions: {
      reservations: {
        id: "email_reservations",
        detail: t(
          "Notifications for approving and confirming guestlist requests"
        ),
        name: t("Guestlists"),
        key: "reservations",
      },
      purchases: {
        id: "email_purchases",
        detail: t("Notifications for new ticket/product purchases"),
        name: t("New Purchases"),
        key: "purchases",
      },
      events: {
        id: "email_event_notifications",
        detail: t("Notifications for events"),
        name: t("Events"),
        key: "events",
      },
      abandoned_carts: {
        id: "email_abandoned_carts",
        detail: t("Notifications to recover abandoned carts"),
        name: t("Abandoned Carts"),
        key: "abandoned_carts",
      },
    },
    key: "email",
  },
} as const;

export const NOTIFICATION_PERMISSIONS_BY_LIST = [
  {
    id: "sms_send_general",
    detail: t("Disabling this will stop all SMS notifications"),
    name: t("SMS"),
    fields: [
      "sms_reservations",
      "sms_purchases",
      "sms_transfers",
      "sms_campaigns",
    ],
    definitions: {
      reservations: {
        id: "sms_reservations",
        detail: t(
          "Notifications for approving and confirming guestlist requests"
        ),
        name: t("Guestlists"),
        enabled_by_default: true,
        key: "reservations",
      },
      purchases: {
        id: "sms_purchases",
        detail: t("Notifications for new ticket/product purchases"),
        name: t("New Purchases"),
        enabled_by_default: false,
        key: "purchases",
      },
      transfers: {
        id: "sms_transfers",
        detail: t(
          "Notifications for sending and receiving ticket/product transfers"
        ),
        name: t("Ticket Transfers"),
        enabled_by_default: true,
        key: "transfers",
      },
      campaigns: {
        id: "sms_campaigns",
        detail: t("Notifications for SMS campaigns"),
        name: t("Campaigns"),
        enabled_by_default: true,
        key: "campaigns",
      },
    },
    key: "sms",
  },
  {
    id: "push_general",
    detail: t("Disabling this will stop all mobile push notifications"),
    name: t("Push"),
    fields: ["push_reservations", "push_purchases", "push_transfers"],
    definitions: {
      reservations: {
        id: "push_reservations",
        detail: t(
          "Notifications for approving and confirming guestlist requests"
        ),
        name: t("Guestlists"),
        title: "Reservations",
        push_type: 1,
        key: "reservations",
      },
      purchases: {
        id: "push_purchases",
        detail: t("Notifications for new ticket/product purchases"),
        name: t("New Purchases"),
        title: "New Purchases",
        push_type: 2,
        key: "purchases",
      },
      transfers: {
        id: "push_transfers",
        detail: t(
          "Notifications for sending and receiving ticket/product transfers"
        ),
        name: t("Transfers"),
        title: "Ticket Transfers",
        push_type: 3,
        key: "transfers",
      },
    },
    key: "push",
  },
  {
    id: "email_send_general",
    detail: t("Disabling this will stop all email notifications"),
    name: t("Email"),
    fields: [
      "email_reservations",
      "email_purchases",
      "email_event_notifications",
      "email_abandoned_carts",
    ],
    definitions: {
      reservations: {
        id: "email_reservations",
        detail: t(
          "Notifications for approving and confirming guestlist requests"
        ),
        name: t("Guestlists"),
        key: "reservations",
      },
      purchases: {
        id: "email_purchases",
        detail: t("Notifications for new ticket/product purchases"),
        name: t("New Purchases"),
        key: "purchases",
      },
      events: {
        id: "email_event_notifications",
        detail: t("Notifications for events"),
        name: t("Events"),
        key: "events",
      },
      abandoned_carts: {
        id: "email_abandoned_carts",
        detail: t("Notifications to recover abandoned carts"),
        name: t("Abandoned Carts"),
        key: "abandoned_carts",
      },
    },
    key: "email",
  },
] as const;

export const MULTI_GUEST_INFO_COLLECT_MAP = {
  MULTI_GUEST_FIRST_NAME: {
    id: "multi_guest_first_name",
    name: t("First Name"),
    field_collect: "info_first_name",
    field_bool: "collect_info_first_name",
    input_type: "text",
    key: "MULTI_GUEST_FIRST_NAME",
    order: 0,
  },
  MULTI_GUEST_LAST_NAME: {
    id: "multi_guest_last_name",
    name: t("Last Name"),
    field_collect: "info_last_name",
    field_bool: "collect_info_last_name",
    input_type: "text",
    key: "MULTI_GUEST_LAST_NAME",
    order: 1,
  },
  MULTI_GUEST_COMPANY: {
    id: "multi_guest_company",
    name: t("Company"),
    field_collect: "info_company",
    field_bool: "collect_info_company",
    input_type: "text",
    key: "MULTI_GUEST_COMPANY",
    order: 2,
  },
  MULTI_GUEST_PHONE_NUMBER: {
    id: "multi_guest_phone_number",
    name: t("Phone Number"),
    field_collect: "info_phone_number",
    field_bool: "collect_info_phone_number",
    input_type: "text",
    key: "MULTI_GUEST_PHONE_NUMBER",
    order: 3,
  },
  MULTI_GUEST_EMAIL: {
    id: "multi_guest_email",
    name: t("Email"),
    field_collect: "info_email",
    field_bool: "collect_info_email",
    input_type: "text",
    key: "MULTI_GUEST_EMAIL",
    order: 4,
  },
  MULTI_GUEST_JOB_TITLE: {
    id: "multi_guest_job_title",
    name: t("Job Title"),
    field_collect: "info_job_title",
    field_bool: "collect_info_job_title",
    input_type: "text",
    key: "MULTI_GUEST_JOB_TITLE",
    order: 5,
  },
  MULTI_GUEST_STUDENT_NUMBER: {
    id: "multi_guest_student_number",
    name: t("Student Number"),
    field_collect: "info_student_number",
    field_bool: "collect_info_student_number",
    input_type: "text",
    key: "MULTI_GUEST_STUDENT_NUMBER",
    order: 6,
  },
  MULTI_GUEST_HOME_ADDRESS_UNIT_NUMBER: {
    id: "multi_guest_home_address_unit_number",
    name: t("Unit Number"),
    field_collect: "info_home_address_unit_number",
    field_bool: "collect_info_home_address",
    input_type: "text",
    key: "MULTI_GUEST_HOME_ADDRESS_UNIT_NUMBER",
    order: 7,
  },
  MULTI_GUEST_HOME_ADDRESS_STREET_NAME: {
    id: "multi_guest_home_address_street_name",
    name: t("Street"),
    field_collect: "info_home_address_street_name",
    field_bool: "collect_info_home_address",
    input_type: "text",
    key: "MULTI_GUEST_HOME_ADDRESS_STREET_NAME",
    order: 8,
  },
  MULTI_GUEST_HOME_ADDRESS_CITY: {
    id: "multi_guest_home_address_city",
    name: t("City"),
    field_collect: "info_home_address_city",
    field_bool: "collect_info_home_address",
    input_type: "text",
    key: "MULTI_GUEST_HOME_ADDRESS_CITY",
    order: 9,
  },
  MULTI_GUEST_HOME_ADDRESS_PROVINCE: {
    id: "multi_guest_home_province",
    name: t("Province"),
    field_collect: "info_home_address_province",
    field_bool: "collect_info_home_address",
    input_type: "text",
    key: "MULTI_GUEST_HOME_ADDRESS_PROVINCE",
    order: 10,
  },
  MULTI_GUEST_HOME_ADDRESS_POSTAL: {
    id: "multi_guest_home_postal",
    name: t("Postal Address"),
    field_collect: "info_home_address_postal",
    field_bool: "collect_info_home_address",
    input_type: "text",
    key: "MULTI_GUEST_HOME_ADDRESS_POSTAL",
    order: 11,
  },
  MULTI_GUEST_HOME_ADDRESS_COUNTRY: {
    id: "multi_guest_country",
    name: t("Country"),
    field_collect: "info_home_address_country",
    field_bool: "collect_info_home_address",
    input_type: "text",
    key: "MULTI_GUEST_HOME_ADDRESS_COUNTRY",
    order: 12,
  },
  MULTI_GUEST_BIRTHDAY: {
    id: "multi_guest_birthday",
    name: t("Birthday"),
    field_collect: "info_birthday",
    field_bool: "collect_info_birthday",
    input_type: "date",
    key: "MULTI_GUEST_BIRTHDAY",
    order: 13,
  },
  MULTI_GUEST_LICENSE_PLATE: {
    id: "multi_guest_license_plate",
    name: t("Vehicle Registration Plate"),
    field_collect: "info_license_plate",
    field_bool: "collect_info_license_plate",
    input_type: "text",
    key: "MULTI_GUEST_LICENSE_PLATE",
    order: 14,
  },
} as const;

export const MULTI_GUEST_INFO_COLLECT_MAP_BY_ID = {
  multi_guest_first_name: {
    id: "multi_guest_first_name",
    name: t("First Name"),
    field_collect: "info_first_name",
    field_bool: "collect_info_first_name",
    input_type: "text",
    key: "MULTI_GUEST_FIRST_NAME",
    order: 0,
  },
  multi_guest_last_name: {
    id: "multi_guest_last_name",
    name: t("Last Name"),
    field_collect: "info_last_name",
    field_bool: "collect_info_last_name",
    input_type: "text",
    key: "MULTI_GUEST_LAST_NAME",
    order: 1,
  },
  multi_guest_company: {
    id: "multi_guest_company",
    name: t("Company"),
    field_collect: "info_company",
    field_bool: "collect_info_company",
    input_type: "text",
    key: "MULTI_GUEST_COMPANY",
    order: 2,
  },
  multi_guest_phone_number: {
    id: "multi_guest_phone_number",
    name: t("Phone Number"),
    field_collect: "info_phone_number",
    field_bool: "collect_info_phone_number",
    input_type: "text",
    key: "MULTI_GUEST_PHONE_NUMBER",
    order: 3,
  },
  multi_guest_email: {
    id: "multi_guest_email",
    name: t("Email"),
    field_collect: "info_email",
    field_bool: "collect_info_email",
    input_type: "text",
    key: "MULTI_GUEST_EMAIL",
    order: 4,
  },
  multi_guest_job_title: {
    id: "multi_guest_job_title",
    name: t("Job Title"),
    field_collect: "info_job_title",
    field_bool: "collect_info_job_title",
    input_type: "text",
    key: "MULTI_GUEST_JOB_TITLE",
    order: 5,
  },
  multi_guest_student_number: {
    id: "multi_guest_student_number",
    name: t("Student Number"),
    field_collect: "info_student_number",
    field_bool: "collect_info_student_number",
    input_type: "text",
    key: "MULTI_GUEST_STUDENT_NUMBER",
    order: 6,
  },
  multi_guest_home_address_unit_number: {
    id: "multi_guest_home_address_unit_number",
    name: t("Unit Number"),
    field_collect: "info_home_address_unit_number",
    field_bool: "collect_info_home_address",
    input_type: "text",
    key: "MULTI_GUEST_HOME_ADDRESS_UNIT_NUMBER",
    order: 7,
  },
  multi_guest_home_address_street_name: {
    id: "multi_guest_home_address_street_name",
    name: t("Street"),
    field_collect: "info_home_address_street_name",
    field_bool: "collect_info_home_address",
    input_type: "text",
    key: "MULTI_GUEST_HOME_ADDRESS_STREET_NAME",
    order: 8,
  },
  multi_guest_home_address_city: {
    id: "multi_guest_home_address_city",
    name: t("City"),
    field_collect: "info_home_address_city",
    field_bool: "collect_info_home_address",
    input_type: "text",
    key: "MULTI_GUEST_HOME_ADDRESS_CITY",
    order: 9,
  },
  multi_guest_home_province: {
    id: "multi_guest_home_province",
    name: t("Province"),
    field_collect: "info_home_address_province",
    field_bool: "collect_info_home_address",
    input_type: "text",
    key: "MULTI_GUEST_HOME_ADDRESS_PROVINCE",
    order: 10,
  },
  multi_guest_home_postal: {
    id: "multi_guest_home_postal",
    name: t("Postal Address"),
    field_collect: "info_home_address_postal",
    field_bool: "collect_info_home_address",
    input_type: "text",
    key: "MULTI_GUEST_HOME_ADDRESS_POSTAL",
    order: 11,
  },
  multi_guest_country: {
    id: "multi_guest_country",
    name: t("Country"),
    field_collect: "info_home_address_country",
    field_bool: "collect_info_home_address",
    input_type: "text",
    key: "MULTI_GUEST_HOME_ADDRESS_COUNTRY",
    order: 12,
  },
  multi_guest_birthday: {
    id: "multi_guest_birthday",
    name: t("Birthday"),
    field_collect: "info_birthday",
    field_bool: "collect_info_birthday",
    input_type: "date",
    key: "MULTI_GUEST_BIRTHDAY",
    order: 13,
  },
  multi_guest_license_plate: {
    id: "multi_guest_license_plate",
    name: t("Vehicle Registration Plate"),
    field_collect: "info_license_plate",
    field_bool: "collect_info_license_plate",
    input_type: "text",
    key: "MULTI_GUEST_LICENSE_PLATE",
    order: 14,
  },
} as const;

export const MULTI_GUEST_INFO_COLLECT_MAP_BY_LIST = [
  {
    id: "multi_guest_first_name",
    name: t("First Name"),
    field_collect: "info_first_name",
    field_bool: "collect_info_first_name",
    input_type: "text",
    key: "MULTI_GUEST_FIRST_NAME",
    order: 0,
  },
  {
    id: "multi_guest_last_name",
    name: t("Last Name"),
    field_collect: "info_last_name",
    field_bool: "collect_info_last_name",
    input_type: "text",
    key: "MULTI_GUEST_LAST_NAME",
    order: 1,
  },
  {
    id: "multi_guest_company",
    name: t("Company"),
    field_collect: "info_company",
    field_bool: "collect_info_company",
    input_type: "text",
    key: "MULTI_GUEST_COMPANY",
    order: 2,
  },
  {
    id: "multi_guest_phone_number",
    name: t("Phone Number"),
    field_collect: "info_phone_number",
    field_bool: "collect_info_phone_number",
    input_type: "text",
    key: "MULTI_GUEST_PHONE_NUMBER",
    order: 3,
  },
  {
    id: "multi_guest_email",
    name: t("Email"),
    field_collect: "info_email",
    field_bool: "collect_info_email",
    input_type: "text",
    key: "MULTI_GUEST_EMAIL",
    order: 4,
  },
  {
    id: "multi_guest_job_title",
    name: t("Job Title"),
    field_collect: "info_job_title",
    field_bool: "collect_info_job_title",
    input_type: "text",
    key: "MULTI_GUEST_JOB_TITLE",
    order: 5,
  },
  {
    id: "multi_guest_student_number",
    name: t("Student Number"),
    field_collect: "info_student_number",
    field_bool: "collect_info_student_number",
    input_type: "text",
    key: "MULTI_GUEST_STUDENT_NUMBER",
    order: 6,
  },
  {
    id: "multi_guest_home_address_unit_number",
    name: t("Unit Number"),
    field_collect: "info_home_address_unit_number",
    field_bool: "collect_info_home_address",
    input_type: "text",
    key: "MULTI_GUEST_HOME_ADDRESS_UNIT_NUMBER",
    order: 7,
  },
  {
    id: "multi_guest_home_address_street_name",
    name: t("Street"),
    field_collect: "info_home_address_street_name",
    field_bool: "collect_info_home_address",
    input_type: "text",
    key: "MULTI_GUEST_HOME_ADDRESS_STREET_NAME",
    order: 8,
  },
  {
    id: "multi_guest_home_address_city",
    name: t("City"),
    field_collect: "info_home_address_city",
    field_bool: "collect_info_home_address",
    input_type: "text",
    key: "MULTI_GUEST_HOME_ADDRESS_CITY",
    order: 9,
  },
  {
    id: "multi_guest_home_province",
    name: t("Province"),
    field_collect: "info_home_address_province",
    field_bool: "collect_info_home_address",
    input_type: "text",
    key: "MULTI_GUEST_HOME_ADDRESS_PROVINCE",
    order: 10,
  },
  {
    id: "multi_guest_home_postal",
    name: t("Postal Address"),
    field_collect: "info_home_address_postal",
    field_bool: "collect_info_home_address",
    input_type: "text",
    key: "MULTI_GUEST_HOME_ADDRESS_POSTAL",
    order: 11,
  },
  {
    id: "multi_guest_country",
    name: t("Country"),
    field_collect: "info_home_address_country",
    field_bool: "collect_info_home_address",
    input_type: "text",
    key: "MULTI_GUEST_HOME_ADDRESS_COUNTRY",
    order: 12,
  },
  {
    id: "multi_guest_birthday",
    name: t("Birthday"),
    field_collect: "info_birthday",
    field_bool: "collect_info_birthday",
    input_type: "date",
    key: "MULTI_GUEST_BIRTHDAY",
    order: 13,
  },
  {
    id: "multi_guest_license_plate",
    name: t("Vehicle Registration Plate"),
    field_collect: "info_license_plate",
    field_bool: "collect_info_license_plate",
    input_type: "text",
    key: "MULTI_GUEST_LICENSE_PLATE",
    order: 14,
  },
] as const;

export const DISCOUNT_TYPES = {
  DISC_TYPE_REGULAR: {
    id: 1,
    name: t("Regular Discount"),
    generated: false,
    default_prefix: "",
    key: "DISC_TYPE_REGULAR",
  },
  DISC_TYPE_SOCIAL_SHARE: {
    id: 2,
    name: t("Social Share"),
    generated: false,
    default_prefix: "",
    key: "DISC_TYPE_SOCIAL_SHARE",
  },
  DISC_TYPE_VOUCHER: {
    id: 3,
    name: t("Voucher"),
    generated: false,
    default_prefix: "",
    key: "DISC_TYPE_VOUCHER",
  },
  DISC_TYPE_VOUCHER_CREDIT: {
    id: 4,
    name: t("Voucher Credit"),
    generated: true,
    default_prefix: "VC-",
    key: "DISC_TYPE_VOUCHER_CREDIT",
  },
  DISC_TYPE_TIERED: {
    id: 5,
    name: t("Tiered Discount, based on quantity"),
    generated: false,
    default_prefix: "TIERED-",
    key: "DISC_TYPE_TIERED",
  },
  DISC_TYPE_USER_REFERRAL: {
    id: 6,
    name: t("Discount for referral code"),
    generated: true,
    default_prefix: "",
    key: "DISC_TYPE_USER_REFERRAL",
  },
  DISC_TYPE_MEMBERSHIP: {
    id: 7,
    name: t("Discount created as a membership benefit"),
    generated: false,
    default_prefix: "MEMBER-",
    key: "DISC_TYPE_MEMBERSHIP",
  },
  DISC_TYPE_AUTO_APPLIED: {
    id: 8,
    name: t("Discount that is automatically applied"),
    generated: false,
    default_prefix: "",
    key: "DISC_TYPE_AUTO_APPLIED",
  },
} as const;

export const DISCOUNT_TYPES_BY_ID = {
  "1": {
    id: 1,
    name: t("Regular Discount"),
    generated: false,
    default_prefix: "",
    key: "DISC_TYPE_REGULAR",
  },
  "2": {
    id: 2,
    name: t("Social Share"),
    generated: false,
    default_prefix: "",
    key: "DISC_TYPE_SOCIAL_SHARE",
  },
  "3": {
    id: 3,
    name: t("Voucher"),
    generated: false,
    default_prefix: "",
    key: "DISC_TYPE_VOUCHER",
  },
  "4": {
    id: 4,
    name: t("Voucher Credit"),
    generated: true,
    default_prefix: "VC-",
    key: "DISC_TYPE_VOUCHER_CREDIT",
  },
  "5": {
    id: 5,
    name: t("Tiered Discount, based on quantity"),
    generated: false,
    default_prefix: "TIERED-",
    key: "DISC_TYPE_TIERED",
  },
  "6": {
    id: 6,
    name: t("Discount for referral code"),
    generated: true,
    default_prefix: "",
    key: "DISC_TYPE_USER_REFERRAL",
  },
  "7": {
    id: 7,
    name: t("Discount created as a membership benefit"),
    generated: false,
    default_prefix: "MEMBER-",
    key: "DISC_TYPE_MEMBERSHIP",
  },
  "8": {
    id: 8,
    name: t("Discount that is automatically applied"),
    generated: false,
    default_prefix: "",
    key: "DISC_TYPE_AUTO_APPLIED",
  },
} as const;

export const DISCOUNT_TYPES_BY_LIST = [
  {
    id: 1,
    name: t("Regular Discount"),
    generated: false,
    default_prefix: "",
    key: "DISC_TYPE_REGULAR",
  },
  {
    id: 2,
    name: t("Social Share"),
    generated: false,
    default_prefix: "",
    key: "DISC_TYPE_SOCIAL_SHARE",
  },
  {
    id: 3,
    name: t("Voucher"),
    generated: false,
    default_prefix: "",
    key: "DISC_TYPE_VOUCHER",
  },
  {
    id: 4,
    name: t("Voucher Credit"),
    generated: true,
    default_prefix: "VC-",
    key: "DISC_TYPE_VOUCHER_CREDIT",
  },
  {
    id: 5,
    name: t("Tiered Discount, based on quantity"),
    generated: false,
    default_prefix: "TIERED-",
    key: "DISC_TYPE_TIERED",
  },
  {
    id: 6,
    name: t("Discount for referral code"),
    generated: true,
    default_prefix: "",
    key: "DISC_TYPE_USER_REFERRAL",
  },
  {
    id: 7,
    name: t("Discount created as a membership benefit"),
    generated: false,
    default_prefix: "MEMBER-",
    key: "DISC_TYPE_MEMBERSHIP",
  },
  {
    id: 8,
    name: t("Discount that is automatically applied"),
    generated: false,
    default_prefix: "",
    key: "DISC_TYPE_AUTO_APPLIED",
  },
] as const;

export const PAYOUT_GROUPING_MAP = {
  INDIVIDUAL: { id: "pg_individual", name: t("Individual"), key: "INDIVIDUAL" },
  COMBINED: { id: "pg_combined", name: t("Combined"), key: "COMBINED" },
} as const;

export const PAYOUT_GROUPING_MAP_BY_ID = {
  pg_individual: {
    id: "pg_individual",
    name: t("Individual"),
    key: "INDIVIDUAL",
  },
  pg_combined: { id: "pg_combined", name: t("Combined"), key: "COMBINED" },
} as const;

export const PAYOUT_GROUPING_MAP_BY_LIST = [
  { id: "pg_individual", name: t("Individual"), key: "INDIVIDUAL" },
  { id: "pg_combined", name: t("Combined"), key: "COMBINED" },
] as const;

export const PAYOUT_FREQUENCY_MAP = {
  PAYOUT_FREQUENCY_EVENT_BASED: {
    id: "pf_event_based",
    name: t("Event Based"),
    key: "PAYOUT_FREQUENCY_EVENT_BASED",
  },
  PAYOUT_FREQUENCY_WEEKLY: {
    id: "pf_weekly",
    name: t("Weekly"),
    key: "PAYOUT_FREQUENCY_WEEKLY",
  },
  PAYOUT_FREQUENCY_MONTHLY: {
    id: "pf_monthly",
    name: t("Monthly"),
    key: "PAYOUT_FREQUENCY_MONTHLY",
  },
  PAYOUT_FREQUENCY_YEARLY: {
    id: "pf_yearly",
    name: t("Yearly"),
    key: "PAYOUT_FREQUENCY_YEARLY",
  },
} as const;

export const PAYOUT_FREQUENCY_MAP_BY_ID = {
  pf_event_based: {
    id: "pf_event_based",
    name: t("Event Based"),
    key: "PAYOUT_FREQUENCY_EVENT_BASED",
  },
  pf_weekly: {
    id: "pf_weekly",
    name: t("Weekly"),
    key: "PAYOUT_FREQUENCY_WEEKLY",
  },
  pf_monthly: {
    id: "pf_monthly",
    name: t("Monthly"),
    key: "PAYOUT_FREQUENCY_MONTHLY",
  },
  pf_yearly: {
    id: "pf_yearly",
    name: t("Yearly"),
    key: "PAYOUT_FREQUENCY_YEARLY",
  },
} as const;

export const PAYOUT_FREQUENCY_MAP_BY_LIST = [
  {
    id: "pf_event_based",
    name: t("Event Based"),
    key: "PAYOUT_FREQUENCY_EVENT_BASED",
  },
  { id: "pf_weekly", name: t("Weekly"), key: "PAYOUT_FREQUENCY_WEEKLY" },
  { id: "pf_monthly", name: t("Monthly"), key: "PAYOUT_FREQUENCY_MONTHLY" },
  { id: "pf_yearly", name: t("Yearly"), key: "PAYOUT_FREQUENCY_YEARLY" },
] as const;

export const SHIPPING_METHODS = {
  PRINT: {
    id: "st_print",
    name: t("Electronic Ticket"),
    require_fee: false,
    enabled_for_tickets: true,
    enabled_for_products: true,
    key: "PRINT",
  },
  DELIVERY: {
    id: "st_delivery",
    name: t("Standard Shipping"),
    require_fee: true,
    enabled_for_tickets: true,
    enabled_for_products: true,
    key: "DELIVERY",
  },
  WILL_CALL: {
    id: "st_will_call",
    name: t("Will Call/Pick Up"),
    require_fee: true,
    enabled_for_tickets: true,
    enabled_for_products: true,
    key: "WILL_CALL",
  },
} as const;

export const SHIPPING_METHODS_BY_ID = {
  st_print: {
    id: "st_print",
    name: t("Electronic Ticket"),
    require_fee: false,
    enabled_for_tickets: true,
    enabled_for_products: true,
    key: "PRINT",
  },
  st_delivery: {
    id: "st_delivery",
    name: t("Standard Shipping"),
    require_fee: true,
    enabled_for_tickets: true,
    enabled_for_products: true,
    key: "DELIVERY",
  },
  st_will_call: {
    id: "st_will_call",
    name: t("Will Call/Pick Up"),
    require_fee: true,
    enabled_for_tickets: true,
    enabled_for_products: true,
    key: "WILL_CALL",
  },
} as const;

export const SHIPPING_METHODS_BY_LIST = [
  {
    id: "st_print",
    name: t("Electronic Ticket"),
    require_fee: false,
    enabled_for_tickets: true,
    enabled_for_products: true,
    key: "PRINT",
  },
  {
    id: "st_delivery",
    name: t("Standard Shipping"),
    require_fee: true,
    enabled_for_tickets: true,
    enabled_for_products: true,
    key: "DELIVERY",
  },
  {
    id: "st_will_call",
    name: t("Will Call/Pick Up"),
    require_fee: true,
    enabled_for_tickets: true,
    enabled_for_products: true,
    key: "WILL_CALL",
  },
] as const;

export const SHIPPING_PRICING_METHOD_MAP = {
  PER_ITEM: { id: "sp_per_item", name: t("Per item"), key: "PER_ITEM" },
  PER_ITEM_GROUP: {
    id: "sp_per_ticket_item_group",
    name: t("Per item group type"),
    key: "PER_ITEM_GROUP",
  },
  FLAT_RATE: { id: "sp_flat_rate", name: t("Flat rate"), key: "FLAT_RATE" },
} as const;

export const SHIPPING_PRICING_METHOD_MAP_BY_ID = {
  sp_per_item: { id: "sp_per_item", name: t("Per item"), key: "PER_ITEM" },
  sp_per_ticket_item_group: {
    id: "sp_per_ticket_item_group",
    name: t("Per item group type"),
    key: "PER_ITEM_GROUP",
  },
  sp_flat_rate: { id: "sp_flat_rate", name: t("Flat rate"), key: "FLAT_RATE" },
} as const;

export const SHIPPING_PRICING_METHOD_MAP_BY_LIST = [
  { id: "sp_per_item", name: t("Per item"), key: "PER_ITEM" },
  {
    id: "sp_per_ticket_item_group",
    name: t("Per item group type"),
    key: "PER_ITEM_GROUP",
  },
  { id: "sp_flat_rate", name: t("Flat rate"), key: "FLAT_RATE" },
] as const;

export const REPORT_COLUMN_MAP = {
  TICKET_HISTORY_COLUMN_TICKET_CODE: {
    id: "rc_ticket_history_ticket_code",
    enabled_for: ["report_ticket_history"],
    name: t("Barcode String"),
    column_type: "ticket_history",
    formats_available: ["csv"],
  },
  TICKET_HISTORY_COLUMN_ITEM_TYPE: {
    id: "rc_ticket_history_item_type",
    enabled_for: ["report_ticket_history", "report_holds_stats"],
    name: t("Item Type"),
    column_type: "ticket_history",
    formats_available: ["csv"],
  },
  TICKET_HISTORY_COLUMN_NAME_ON_TICKET: {
    id: "rc_ticket_history_ticket_name_on_ticket",
    enabled_for: ["report_ticket_history"],
    name: t("Name On Ticket"),
    column_type: "ticket_history",
    formats_available: ["csv"],
  },
  TICKET_HISTORY_COLUMN_EVENT_NAME: {
    id: "rc_ticket_history_ticket_event_name",
    enabled_for: [
      "report_ticket_history",
      "report_shipping_fulfillment",
      "report_will_call_financial",
      "report_holds_stats",
      "settlement_report",
      "advance_report",
      "report_marketing_campaign_details",
    ],
    name: t("Event Name"),
    column_type: "ticket_history",
    formats_available: ["csv"],
  },
  TICKET_HISTORY_COLUMN_EVENT_ID: {
    id: "rc_ticket_history_event_id",
    enabled_for: [
      "report_ticket_history",
      "report_shipping_fulfillment",
      "report_will_call_financial",
      "report_holds_stats",
      "settlement_report",
      "advance_report",
      "report_marketing_campaign_details",
    ],
    name: t("Event ID"),
    column_type: "ticket_history",
    formats_available: ["csv"],
  },
  TICKET_HISTORY_COLUMN_TICKET_TYPE_DESCRIPTION: {
    id: "rc_ticket_history_tt_description",
    enabled_for: ["report_ticket_history", "report_shipping_fulfillment"],
    name: t("Ticket Type Name"),
    column_type: "ticket_history",
    formats_available: ["csv"],
  },
  TICKET_HISTORY_COLUMN_TICKET_ID: {
    id: "rc_ticket_history_ticket_id",
    enabled_for: ["report_ticket_history", "report_shipping_fulfillment"],
    name: t("Ticket Type ID"),
    column_type: "ticket_history",
    formats_available: ["csv"],
  },
  TICKET_HISTORY_COLUMN_PRODUCT_DESCRIPTION: {
    id: "rc_ticket_history_product_description",
    enabled_for: [
      "report_ticket_history",
      "report_shipping_fulfillment",
      "report_holds_stats",
    ],
    name: t("Product Name"),
    column_type: "ticket_history",
    formats_available: ["csv"],
  },
  TICKET_HISTORY_COLUMN_PRODUCT_ID: {
    id: "rc_ticket_history_product_id",
    enabled_for: [
      "report_ticket_history",
      "report_shipping_fulfillment",
      "report_will_call_financial",
      "report_holds_stats",
      "settlement_report",
      "advance_report",
      "report_marketing_campaign_details",
    ],
    name: t("Product ID"),
    column_type: "ticket_history",
    formats_available: ["csv"],
  },
  TICKET_HISTORY_COLUMN_PRODUCT_ATTRIBUTE_NAME: {
    id: "rc_ticket_history_product_attribute_name",
    enabled_for: [
      "report_ticket_history",
      "report_shipping_fulfillment",
      "report_holds_stats",
    ],
    name: t("Product Attribute Name"),
    column_type: "ticket_history",
    formats_available: ["csv"],
  },
  TICKET_HISTORY_COLUMN_PRODUCT_ATTRIBUTE_ID: {
    id: "rc_ticket_history_product_attribute_id",
    enabled_for: [
      "report_ticket_history",
      "report_shipping_fulfillment",
      "report_will_call_financial",
      "report_holds_stats",
      "settlement_report",
      "advance_report",
      "report_marketing_campaign_details",
    ],
    name: t("Product Attribute ID"),
    column_type: "ticket_history",
    formats_available: ["csv"],
  },
  TICKET_HISTORY_COLUMN_CREATED: {
    id: "rc_ticket_history_created",
    enabled_for: ["report_ticket_history"],
    name: t("Created On"),
    column_type: "ticket_history",
    formats_available: ["csv"],
  },
  TICKET_HISTORY_COLUMN_USER_ACTION: {
    id: "rc_ticket_history_user_action",
    enabled_for: ["report_ticket_history"],
    name: t("Action"),
    column_type: "ticket_history",
    formats_available: ["csv"],
  },
  TICKET_HISTORY_COLUMN_BEFORE_STATUS: {
    id: "rc_ticket_history_before_status",
    enabled_for: ["report_ticket_history"],
    name: t("Status Before"),
    column_type: "ticket_history",
    formats_available: ["csv"],
  },
  TICKET_HISTORY_COLUMN_AFTER_STATUS: {
    id: "rc_ticket_history_after_status",
    enabled_for: ["report_ticket_history"],
    name: t("Status After"),
    column_type: "ticket_history",
    formats_available: ["csv"],
  },
  TICKET_HISTORY_COLUMN_CREATED_BY: {
    id: "rc_ticket_history_created_by",
    enabled_for: ["report_ticket_history"],
    name: t("Created By"),
    column_type: "ticket_history",
    formats_available: ["csv"],
  },
  TICKET_HISTORY_PICKED_UP: {
    id: "picked_up",
    enabled_for: ["report_event_product_inventory"],
    name: t("Picked Up"),
    column_type: "ticket_history",
    formats_available: ["csv"],
  },
  DISCOUNT_COLUMN_ALLOWED_CHECKOUTS: {
    enabled_for: ["report_discount_creation"],
    id: "rc_discount_allowed_checkouts",
    name: t("Allowed Checkouts"),
    column_type: "discount",
    formats_available: ["csv"],
  },
  DISCOUNT_COLUMN_AMOUNT: {
    enabled_for: [
      "report_discount_creation",
      "report_will_call_financial",
      "settlement_report",
      "advance_report",
      "report_marketing_campaign_details",
    ],
    id: "rc_discount_amount",
    name: t("Discount Code Amount"),
    column_type: "discount",
    formats_available: ["csv"],
  },
  DISCOUNT_RULE_COLUMN_PERCENTAGE: {
    enabled_for: [
      "report_will_call_financial",
      "settlement_report",
      "advance_report",
      "report_marketing_campaign_details",
    ],
    id: "rc_rule_discount_percentage",
    name: t("Discount Rule Percentage"),
    column_type: "discount",
    formats_available: ["csv"],
  },
  DISCOUNT_RULE_COLUMN_AMOUNT: {
    enabled_for: [
      "report_will_call_financial",
      "settlement_report",
      "advance_report",
      "report_marketing_campaign_details",
    ],
    id: "rc_discount_rule_amount",
    name: t("Discount Rule Amount"),
    column_type: "discount",
    formats_available: ["csv"],
  },
  DISCOUNT_COLUMN_LIMIT: {
    enabled_for: ["report_discount_creation"],
    id: "rc_discount_limit",
    name: t("Total Limit"),
    column_type: "discount",
    formats_available: ["csv"],
  },
  DISCOUNT_COLUMN_MAXIMUM_QUANTITY: {
    enabled_for: ["report_discount_creation"],
    id: "rc_discount_maximum_quantity",
    name: t("Maximum Quantity For Tiered Discounts"),
    column_type: "discount",
    formats_available: ["csv"],
  },
  DISCOUNT_COLUMN_MINIMUM_QUANTITY: {
    enabled_for: ["report_discount_creation"],
    id: "rc_discount_minimum_quantity",
    name: t("Minimum Quantity for tiered discounts"),
    column_type: "discount",
    formats_available: ["csv"],
  },
  DISCOUNT_COLUMN_DISCOUNT_RULE_PERCENTAGES: {
    enabled_for: ["report_discount_creation"],
    id: "rc_discount_rule_percentages",
    name: t("Discount Rule Percentages"),
    column_type: "discount",
    formats_available: ["csv"],
  },
  DISCOUNT_COLUMN_DISCOUNT_RULE_AMOUNTS: {
    enabled_for: ["report_discount_creation"],
    id: "rc_discount_rule_amounts",
    name: t("Discount Rule Amounts"),
    column_type: "discount",
    formats_available: ["csv"],
  },
  DISCOUNT_COLUMN_PERCENTAGE: {
    enabled_for: [
      "report_discount_creation",
      "report_will_call_financial",
      "settlement_report",
      "advance_report",
      "report_marketing_campaign_details",
    ],
    id: "rc_discount_percentage",
    name: t("Discount Code Percentage"),
    column_type: "discount",
    formats_available: ["csv"],
  },
  DISCOUNT_COLUMN_PERMISSION_TYPE: {
    enabled_for: ["report_discount_creation"],
    id: "rc_discount_permission_type",
    name: t("Discount Ticket Type/Event Permissions"),
    column_type: "discount",
    formats_available: ["csv"],
  },
  DISCOUNT_COLUMN_PER_USER_LIMIT: {
    enabled_for: ["report_discount_creation"],
    id: "rc_discount_per_user_limit",
    name: t("Usage Limit Per User"),
    column_type: "discount",
    formats_available: ["csv"],
  },
  DISCOUNT_COLUMN_TYPE: {
    enabled_for: [
      "report_discount_creation",
      "report_will_call_financial",
      "settlement_report",
      "advance_report",
      "report_marketing_campaign_details",
    ],
    id: "rc_discount_type",
    name: t("Discount Type"),
    column_type: "discount",
    formats_available: ["csv"],
  },
  DISCOUNT_COLUMN_CREATED_BY: {
    enabled_for: ["report_discount_creation"],
    id: "rc_discount_created_by",
    name: t("Discount Created By"),
    column_type: "discount",
    formats_available: ["csv"],
  },
  DISCOUNT_COLUMN_CREATED_ON: {
    enabled_for: ["report_discount_creation"],
    id: "rc_discount_created_on",
    name: t("Discount Created On"),
    column_type: "discount",
    formats_available: ["csv"],
  },
  DISCOUNT_COLUMN_DISCOUNT_DESCRIPTION: {
    id: "rc_discount_description",
    enabled_for: ["report_discount_usage_stats", "report_discount_creation"],
    name: t("Discount Description"),
    column_type: "discount",
    formats_available: ["csv"],
  },
  DISCOUNT_COLUMN_PURCHASE_PLATFORM: {
    id: "rc_discount_purchase_platform",
    enabled_for: ["report_discount_usage_stats"],
    name: t("Purchase Platform"),
    column_type: "discount",
    formats_available: ["csv"],
  },
  DISCOUNT_COLUMN_DISCOUNTS_USED: {
    id: "rc_discounts_used",
    enabled_for: ["report_discount_usage_stats"],
    name: t("Quantity Discount Used"),
    column_type: "discount",
    formats_available: ["csv"],
  },
  DISCOUNT_COLUMN_TICKET_QUANTITY: {
    id: "rc_discount_ticket_quantity",
    enabled_for: ["report_discount_usage_stats"],
    name: t("Ticket Quantity"),
    column_type: "discount",
    formats_available: ["csv"],
  },
  COLUMN_USERNAME: {
    id: "rc_username",
    enabled_for: [
      "report_invoice_transaction",
      "report_venue_user",
      "report_seller_stats",
      "report_surveys",
      "report_will_call_financial",
      "settlement_report",
      "advance_report",
      "report_holds_stats",
      "report_donor_transaction",
      "report_marketing_campaign_details",
    ],
    name: t("Customer Name"),
    column_type: "customer",
    formats_available: ["csv"],
  },
  COLUMN_EMAIL: {
    id: "rc_email",
    name: t("Customer Email"),
    enabled_for: [
      "report_invoice_transaction",
      "report_venue_user",
      "report_will_call",
      "report_seller_stats",
      "report_surveys",
      "report_shipping_fulfillment",
      "report_event_product_inventory",
      "report_will_call_financial",
      "settlement_report",
      "advance_report",
      "report_holds_stats",
      "waitlist_subscriber_report",
      "reseller_submissions_report",
      "report_donor_transaction",
      "report_marketing_campaign_details",
    ],
    column_type: "customer",
    formats_available: ["csv"],
  },
  COLUMN_PHONE: {
    id: "rc_phone",
    name: t("Customer Phone Number"),
    enabled_for: [
      "report_invoice_transaction",
      "report_venue_user",
      "report_will_call",
      "report_holds_stats",
      "report_seller_stats",
      "report_shipping_fulfillment",
      "report_will_call_financial",
      "report_donor_transaction",
      "settlement_report",
      "advance_report",
      "report_marketing_campaign_details",
    ],
    column_type: "customer",
    formats_available: ["csv"],
  },
  COLUMN_BIRTHDAY: {
    id: "rc_birthday",
    name: t("Birthday"),
    enabled_for: ["report_venue_user"],
    column_type: "customer",
    formats_available: ["csv"],
  },
  COLUMN_GENDER: {
    id: "rc_gender",
    name: t("Gender"),
    enabled_for: ["report_venue_user"],
    column_type: "customer",
    formats_available: ["csv"],
  },
  COLUMN_IS_SELLER: {
    id: "rc_is_seller",
    name: t("Seller Status"),
    enabled_for: ["report_venue_user"],
    column_type: "customer",
    formats_available: ["csv"],
  },
  COLUMN_IS_EMPLOYEE: {
    id: "rc_is_employee",
    name: t("Employee Status"),
    enabled_for: ["report_venue_user"],
    column_type: "customer",
    formats_available: ["csv"],
  },
  COLUMN_IS_SUBSCRIBED: {
    id: "rc_is_subscribed",
    name: t("Subscribed to Email"),
    enabled_for: [
      "report_venue_user",
      "report_will_call_financial",
      "settlement_report",
      "advance_report",
      "report_marketing_campaign_details",
    ],
    column_type: "customer",
    formats_available: ["csv"],
  },
  COLUMN_ALLOW_MAIL_CONTACT: {
    id: "rc_allow_mail_contact",
    name: t("Allowed to Mail"),
    enabled_for: ["report_venue_user"],
    column_type: "customer",
    formats_available: ["csv"],
  },
  COLUMN_ALLOW_PHONE_CONTACT: {
    id: "rc_allow_phone_contact",
    name: t("Allowed to Phone"),
    enabled_for: ["report_venue_user"],
    column_type: "customer",
    formats_available: ["csv"],
  },
  COLUMN_CUSTOMER_RESERVATIONS_CREATED: {
    id: "rc_num_customer_reservations",
    name: t("Number Of Customer Reservations Booked"),
    enabled_for: ["report_venue_user"],
    column_type: "customer",
    formats_available: ["csv"],
  },
  COLUMN_CUSTOMER_CHECKED_IN: {
    id: "rc_num_checked_in_as_customer",
    name: t("Number Of Times Customer Checked In"),
    enabled_for: ["report_venue_user"],
    column_type: "customer",
    formats_available: ["csv"],
  },
  COLUMN_NUM_RESERVATIONS_BOOKED: {
    id: "rc_num_reservations_booked",
    name: t("Number Of Staff Reservations Booked"),
    enabled_for: ["report_venue_user"],
    column_type: "customer",
    formats_available: ["csv"],
  },
  COLUMN_EMPLOYEE_CHECKED_IN: {
    id: "rc_num_checked_in_as_employee",
    name: t("Number Of Staff Check Ins"),
    enabled_for: ["report_venue_user"],
    column_type: "customer",
    formats_available: ["csv"],
  },
  COLUMN_TICKETS_PURCHASED: {
    id: "rc_num_tickets_purchased",
    name: t("Tickets Purchased"),
    enabled_for: ["report_venue_user"],
    column_type: "customer",
    formats_available: ["csv"],
  },
  COLUMN_NUM_TICKETS_SOLD: {
    id: "rc_num_tickets_sold",
    name: t("Tickets Sold"),
    enabled_for: [
      "report_venue_user",
      "report_surveys",
      "report_password_used_breakdown",
      "report_seller_stats",
    ],
    column_type: "customer",
    formats_available: ["csv"],
  },
  COLUMN_NUM_ITEMS_SOLD: {
    id: "rc_num_items_sold",
    name: t("Items Sold"),
    enabled_for: ["report_marketing_campaigns"],
    column_type: "customer",
    formats_available: ["csv"],
  },
  COLUMN_EXTERNAL_TICKETS_QUANTITY: {
    id: "rc_external_tickets_quantity",
    name: t("Tickets Purchased"),
    enabled_for: ["report_venue_user"],
    column_type: "customer",
    formats_available: ["csv"],
  },
  COLUMN_EXTERNAL_TICKETS_SPEND: {
    id: "rc_external_tickets_spend",
    name: t("External Ticket Spend"),
    enabled_for: ["report_venue_user"],
    column_type: "customer",
    formats_available: ["csv"],
  },
  COLUMN_EXTERNAL_DONATIONS: {
    id: "rc_external_donations",
    name: t("External Donations"),
    enabled_for: ["report_venue_user"],
    column_type: "customer",
    formats_available: ["csv"],
  },
  SUB_TICKETS_GENERATED_FROM_PACKAGE: {
    id: "rc_sub_tickets_generated_from_package",
    name: t("Sub Tickets Generated From Package"),
    enabled_for: ["report_event_breakdown", "report_ticket_type_breakdown"],
    column_type: "customer",
    formats_available: ["csv"],
  },
  COLUMN_NAME_ON_TICKET: {
    id: "rc_name_on_ticket",
    name: t("Name On Ticket"),
    enabled_for: [
      "report_invoice_transaction",
      "report_will_call",
      "report_surveys",
      "report_shipping_fulfillment",
      "report_event_product_inventory",
    ],
    column_type: "customer",
    formats_available: ["csv"],
  },
  COLUMN_VENUEUSER_SHIPPING_NAME: {
    id: "rc_venueuser_shipping_name",
    name: t("Shipping Name"),
    enabled_for: ["report_venue_user"],
    column_type: "customer",
    formats_available: ["csv"],
  },
  COLUMN_INVOICE_ITEM_DESCRIPTION: {
    id: "rc_invoice_item_description",
    name: t("Description"),
    enabled_for: [
      "report_will_call_financial",
      "settlement_report",
      "advance_report",
      "report_marketing_campaign_details",
    ],
    column_type: "financial",
    formats_available: ["csv"],
  },
  COLUMN_CHARGE_ID: {
    id: "rc_charge_id",
    name: t("Charge ID"),
    enabled_for: [
      "report_will_call_financial",
      "settlement_report",
      "advance_report",
      "report_marketing_campaign_details",
    ],
    column_type: "financial",
    formats_available: ["csv"],
  },
  INVOICE_TYPE_NAME: {
    id: "rc_invoice_type_name",
    name: t("Item Type"),
    enabled_for: [
      "report_will_call_financial",
      "settlement_report",
      "advance_report",
      "report_marketing_campaign_details",
    ],
    column_type: "financial",
    formats_available: ["csv"],
  },
  INVOICE_CATEGORY_NAME: {
    id: "rc_invoice_category_name",
    name: t("Item Category"),
    enabled_for: [
      "report_will_call_financial",
      "settlement_report",
      "advance_report",
      "report_marketing_campaign_details",
    ],
    column_type: "financial",
    formats_available: ["csv"],
  },
  COLUMN_REVENUE_TICKETS_PURCHASED: {
    id: "rc_revenue_tickets_purchased",
    name: t("Revenue From Customer Purchases"),
    enabled_for: ["report_venue_user"],
    column_type: "financial",
    formats_available: ["csv"],
  },
  COLUMN_REVENUE_TICKETS_SOLD: {
    id: "rc_revenue_tickets_sold",
    name: t("Revenue From Tickets Sold"),
    enabled_for: ["report_venue_user"],
    column_type: "financial",
    formats_available: ["csv"],
  },
  COLUMN_INVOICE_TYPE: {
    id: "rc_invoice_type",
    name: t("Invoice Type"),
    enabled_for: ["report_invoice_transaction"],
    column_type: "financial",
    formats_available: ["csv"],
  },
  COLUMN_TRANSACTION_ID: {
    id: "rc_transaction_id",
    name: t("Transaction ID"),
    enabled_for: [
      "report_invoice_transaction",
      "report_surveys",
      "report_shipping_fulfillment",
      "report_will_call_financial",
      "settlement_report",
      "advance_report",
      "report_marketing_campaign_details",
    ],
    column_type: "financial",
    formats_available: ["csv"],
  },
  COLUMN_TRANSACTION_DATE: {
    id: "rc_transaction_date",
    name: t("Transaction Date"),
    enabled_for: [
      "report_will_call_financial",
      "settlement_report",
      "advance_report",
      "gift_card_recipients_report",
      "report_marketing_campaign_details",
    ],
    column_type: "financial",
    formats_available: ["csv"],
  },
  COLUMN_SALE_TRANSACTION_ID: {
    id: "rc_sale_transaction_id",
    name: t("Sale Transaction ID"),
    enabled_for: [
      "report_will_call_financial",
      "settlement_report",
      "advance_report",
      "report_marketing_campaign_details",
    ],
    column_type: "financial",
    formats_available: ["csv"],
  },
  COLUMN_SETTLEMENT_DATE: {
    id: "rc_settlement_date",
    name: t("Settlement Date"),
    enabled_for: [
      "report_will_call_financial",
      "settlement_report",
      "advance_report",
      "report_marketing_campaign_details",
    ],
    column_type: "financial",
    formats_available: ["csv"],
  },
  COLUMN_ADVANCE_DATE: {
    id: "rc_advance_date",
    name: t("Advance Date"),
    enabled_for: [
      "report_will_call_financial",
      "settlement_report",
      "advance_report",
      "report_marketing_campaign_details",
    ],
    column_type: "financial",
    formats_available: ["csv"],
  },
  COLUMN_TICKET_TYPE_PRICE: {
    id: "rc_ticket_type_price",
    name: t("Ticket Type Price"),
    enabled_for: [
      "report_will_call_financial",
      "settlement_report",
      "advance_report",
      "report_marketing_campaign_details",
      "report_ticket_type_breakdown",
    ],
    column_type: "financial",
    formats_available: ["csv"],
  },
  COLUMN_FINAL_AMOUNT: {
    id: "rc_final_amount",
    name: t("Total Sales"),
    enabled_for: [
      "report_invoice_transaction",
      "report_seller_stats",
      "report_surveys",
      "report_event_product_inventory",
      "report_marketing_campaigns",
    ],
    column_type: "financial",
    formats_available: ["csv"],
  },
  COLUMN_AMOUNT_EARNED: {
    id: "rc_amount_earned",
    name: t("Revenue"),
    enabled_for: ["report_invoice_transaction", "report_seller_stats"],
    column_type: "financial",
    formats_available: ["csv"],
  },
  COLUMN_TAX: {
    id: "rc_tax",
    name: t("Total Organizer Taxes"),
    enabled_for: [
      "report_event_product_inventory",
      "report_marketing_campaigns",
    ],
    column_type: "financial",
    formats_available: ["csv"],
  },
  COLUMN_REFUNDS: {
    id: "rc_refunds",
    name: t("Refunds"),
    enabled_for: ["report_marketing_campaigns"],
    column_type: "financial",
    formats_available: ["csv"],
  },
  COLUMN_DISCOUNTS: {
    id: "rc_discounts",
    name: t("Discounts"),
    enabled_for: ["report_marketing_campaigns"],
    column_type: "financial",
    formats_available: ["csv"],
  },
  COLUMN_NET_SALES: {
    id: "rc_gross_sales",
    name: t("Net Sales"),
    enabled_for: ["report_marketing_campaigns"],
    column_type: "financial",
    formats_available: ["csv"],
  },
  COLUMN_SERVICE_FEES: {
    id: "rc_amount_company_earned",
    name: t("Service Fees"),
    enabled_for: ["report_marketing_campaigns"],
    column_type: "financial",
    formats_available: ["csv"],
  },
  COLUMN_DISPLAY_GROSS_REVENUE: {
    id: "rc_display_gross_revenue",
    name: t("Gross Revenue"),
    enabled_for: ["report_marketing_campaigns"],
    column_type: "financial",
    formats_available: ["csv"],
  },
  COLUMN_DISPLAY_NET_REVENUE: {
    id: "rc_display_net_revenue",
    name: t("Net Revenue"),
    enabled_for: ["report_marketing_campaigns"],
    column_type: "financial",
    formats_available: ["csv"],
  },
  COLUMN_CREDIT_TYPE: {
    id: "rc_credit_type",
    name: t("Account Credit Type"),
    enabled_for: [
      "report_will_call_financial",
      "settlement_report",
      "advance_report",
      "report_marketing_campaign_details",
    ],
    column_type: "financial",
    formats_available: ["csv"],
  },
  COLUMN_PURCHASE_SOURCE_PLATFORM: {
    id: "rc_purchase_source_platform",
    name: t("Purchase Source Platform"),
    enabled_for: [
      "report_will_call_financial",
      "settlement_report",
      "advance_report",
      "report_marketing_campaign_details",
    ],
    column_type: "financial",
    formats_available: ["csv"],
  },
  COLUMN_PURCHASE_NOTE: {
    id: "rc_purchase_note",
    name: t("Purchase Note"),
    enabled_for: [
      "report_will_call_financial",
      "settlement_report",
      "advance_report",
      "report_marketing_campaign_details",
    ],
    column_type: "financial",
    formats_available: ["csv"],
  },
  COLUMN_OTHER_CUSTOM_TYPE: {
    id: "rc_other_custom_type",
    name: t("Other Custom Purchase Type"),
    enabled_for: ["report_invoice_transaction"],
    column_type: "financial",
    formats_available: ["csv"],
  },
  COLUMN_OTHER_PAYMENT_TYPE: {
    id: "rc_other_payment_type",
    name: t("Other Payment Type"),
    enabled_for: [
      "report_will_call_financial",
      "settlement_report",
      "advance_report",
      "report_marketing_campaign_details",
    ],
    column_type: "financial",
    formats_available: ["csv"],
  },
  COLUMN_QUANTITY: {
    id: "rc_quantity",
    name: t("Quantity"),
    enabled_for: [
      "report_will_call",
      "report_event_product_inventory",
      "report_holds_stats",
      "waitlist_subscriber_report",
      "reseller_submissions_report",
      "gift_card_recipients_report",
      "member_seating_report",
    ],
    column_type: "financial",
    formats_available: ["csv"],
  },
  COLUMN_TRANSACTION_QUANTITY: {
    id: "rc_transaction_quantity",
    name: t("Transaction Quantity"),
    enabled_for: [
      "report_will_call_financial",
      "settlement_report",
      "advance_report",
      "report_marketing_campaign_details",
    ],
    column_type: "financial",
    formats_available: ["csv"],
  },
  COLUMN_ITEM_QUANTITY: {
    id: "rc_item_quantity",
    name: t("Item Quantity"),
    enabled_for: [
      "report_will_call_financial",
      "settlement_report",
      "advance_report",
      "report_marketing_campaign_details",
    ],
    column_type: "financial",
    formats_available: ["csv"],
  },
  COLUMN_TRANSFER_QUANTITY: {
    id: "rc_transfer_quantity",
    name: t("Transfer Quantity"),
    enabled_for: [
      "report_will_call_financial",
      "settlement_report",
      "advance_report",
      "report_marketing_campaign_details",
    ],
    column_type: "financial",
    formats_available: ["csv"],
  },
  COLUMN_SCANNED_QUANTITY: {
    id: "rc_scanned_quantity",
    name: t("Scanned Quantity"),
    enabled_for: [
      "report_will_call_financial",
      "settlement_report",
      "advance_report",
      "report_marketing_campaign_details",
    ],
    column_type: "financial",
    formats_available: ["csv"],
  },
  COLUMN_SCAN_LIMIT: {
    id: "rc_scan_limit",
    name: t("Scan Limit"),
    enabled_for: [
      "report_will_call_financial",
      "settlement_report",
      "advance_report",
      "report_marketing_campaign_details",
    ],
    column_type: "financial",
    formats_available: ["csv"],
  },
  COLUMN_ORGANIZER_CHARGES: {
    id: "rc_organizer_charges",
    name: t("Organizer Charges"),
    enabled_for: [
      "report_invoice_transaction",
      "report_seller_stats",
      "report_event_product_inventory",
      "report_marketing_campaigns",
    ],
    column_type: "financial",
    formats_available: ["csv"],
  },
  COLUMN_CARD_ORGANIZER_CHARGES: {
    id: "rc_card_organizer_charges",
    name: t("Card Organizer Charges"),
    enabled_for: [
      "report_invoice_transaction",
      "report_seller_stats",
      "report_event_product_inventory",
    ],
    column_type: "financial",
    formats_available: ["csv"],
  },
  COLUMN_CASH_ORGANIZER_CHARGES: {
    id: "rc_cash_organizer_charges",
    name: t("Cash Organizer Charges"),
    enabled_for: [
      "report_invoice_transaction",
      "report_event_breakdown",
      "product_breakdown_report",
      "report_ticket_type_breakdown",
      "report_seller_stats",
    ],
    column_type: "financial",
    formats_available: ["csv"],
  },
  COLUMN_OTHER_ORGANIZER_CHARGES: {
    id: "rc_other_organizer_charges",
    name: t("Other Organizer Charges"),
    enabled_for: [
      "report_invoice_transaction",
      "report_event_breakdown",
      "product_breakdown_report",
      "report_ticket_type_breakdown",
      "report_seller_stats",
    ],
    column_type: "financial",
    formats_available: ["csv"],
  },
  COLUMN_REFUND_TYPE: {
    id: "rc_refund_type",
    name: t("Refund Type"),
    enabled_for: [
      "report_will_call_financial",
      "settlement_report",
      "advance_report",
      "report_marketing_campaign_details",
    ],
    column_type: "financial",
    formats_available: ["csv"],
  },
  COLUMN_REFUND_REASON: {
    id: "rc_refund_reason",
    name: t("Refund Reason"),
    enabled_for: [
      "report_will_call_financial",
      "settlement_report",
      "advance_report",
      "report_marketing_campaign_details",
    ],
    column_type: "financial",
    formats_available: ["csv"],
  },
  COLUMN_COMMISSIONS: {
    id: "rc_commissions",
    name: t("Commissions"),
    enabled_for: [
      "report_invoice_transaction",
      "report_event_breakdown",
      "product_breakdown_report",
      "report_ticket_type_breakdown",
      "report_will_call_financial",
      "settlement_report",
      "advance_report",
      "report_marketing_campaign_details",
    ],
    column_type: "financial",
    formats_available: ["csv"],
  },
  COLUMN_CASH_COMMISSIONS: {
    id: "rc_cash_commissions",
    name: t("Cash Commission"),
    enabled_for: ["report_seller_stats"],
    column_type: "financial",
    formats_available: ["csv"],
  },
  COLUMN_CREDIT_COMMISSIONS: {
    id: "rc_credit_commissions",
    name: t("Credit Commission"),
    enabled_for: ["report_seller_stats"],
    column_type: "financial",
    formats_available: ["csv"],
  },
  COLUMN_SHIPPING_COSTS: {
    id: "rc_shipping_costs",
    name: t("Shipping Costs"),
    enabled_for: [
      "report_invoice_transaction",
      "report_event_breakdown",
      "product_breakdown_report",
      "report_ticket_type_breakdown",
    ],
    column_type: "financial",
    formats_available: ["csv"],
  },
  COLUMN_ITEMS_TOTAL_AMOUNT: {
    id: "rc_items_total_amount",
    name: t("Face Value"),
    enabled_for: ["report_invoice_transaction"],
    column_type: "financial",
    formats_available: ["csv"],
  },
  COLUMN_PAYMENT_TYPE: {
    id: "rc_payment_type",
    name: t("Payment Method"),
    enabled_for: [
      "report_invoice_transaction",
      "report_will_call_financial",
      "settlement_report",
      "advance_report",
      "report_marketing_campaign_details",
    ],
    column_type: "financial",
    formats_available: ["csv"],
  },
  COLUMN_CARD_TYPE: {
    id: "rc_card_type",
    name: t("Card Type"),
    enabled_for: [
      "report_invoice_transaction",
      "report_will_call_financial",
      "settlement_report",
      "advance_report",
      "report_marketing_campaign_details",
    ],
    column_type: "financial",
    formats_available: ["csv"],
  },
  COLUMN_CASH_REVENUE: {
    id: "rc_cash_revenue",
    name: t("Cash Revenue"),
    enabled_for: [
      "report_event_breakdown",
      "product_breakdown_report",
      "report_ticket_type_breakdown",
      "report_seller_stats",
    ],
    column_type: "financial",
    formats_available: ["csv"],
  },
  COLUMN_CREDIT_REVENUE: {
    id: "rc_credit_revenue",
    name: t("Credit Revenue"),
    enabled_for: [
      "report_event_breakdown",
      "product_breakdown_report",
      "report_ticket_type_breakdown",
      "report_seller_stats",
    ],
    column_type: "financial",
    formats_available: ["csv"],
  },
  COLUMN_EVENT: {
    id: "rc_event",
    name: t("Event"),
    enabled_for: [
      "report_will_call",
      "report_event_breakdown",
      "report_ticket_type_breakdown",
      "report_event_product_inventory",
      "report_password_used_breakdown",
      "waitlist_subscriber_report",
      "reseller_submissions_report",
      "report_donor_transaction",
    ],
    column_type: "tickets",
    formats_available: ["csv"],
  },
  COLUMN_EVENT_STARTS_ON: {
    id: "rc_event_starts_on",
    name: t("Event Start Time"),
    enabled_for: [
      "report_will_call",
      "report_event_breakdown",
      "report_ticket_type_breakdown",
      "report_event_product_inventory",
      "report_will_call_financial",
      "settlement_report",
      "advance_report",
      "report_shipping_fulfillment",
      "report_holds_stats",
      "waitlist_subscriber_report",
      "reseller_submissions_report",
      "report_donor_transaction",
      "report_marketing_campaign_details",
    ],
    column_type: "tickets",
    formats_available: ["csv"],
  },
  COLUMN_EVENT_ENDS_ON: {
    id: "rc_event_ends_on",
    name: t("Event End Time"),
    enabled_for: [
      "report_will_call",
      "report_event_breakdown",
      "report_ticket_type_breakdown",
      "report_will_call_financial",
      "settlement_report",
      "advance_report",
      "report_holds_stats",
      "report_marketing_campaign_details",
    ],
    column_type: "tickets",
    formats_available: ["csv"],
  },
  COLUMN_TICKET_TYPE: {
    id: "rc_ticket_type",
    name: t("Ticket Type Name"),
    enabled_for: [
      "report_will_call",
      "report_will_call_financial",
      "report_ticket_type_breakdown",
      "settlement_report",
      "advance_report",
      "report_holds_stats",
      "report_event_product_inventory",
      "waitlist_subscriber_report",
      "reseller_submissions_report",
      "report_marketing_campaign_details",
    ],
    column_type: "tickets",
    formats_available: ["csv"],
  },
  COLUMN_TICKET_TYPE_ID: {
    id: "rc_ticket_type_id",
    name: t("Ticket Type ID"),
    enabled_for: [
      "report_will_call_financial",
      "settlement_report",
      "advance_report",
      "report_holds_stats",
      "report_marketing_campaign_details",
    ],
    column_type: "tickets",
    formats_available: ["csv"],
  },
  COLUMN_EVENT_LOCATION: {
    id: "rc_event_location",
    name: t("Event Location"),
    enabled_for: ["report_event_breakdown", "report_ticket_type_breakdown"],
    column_type: "tickets",
    formats_available: ["csv"],
  },
  COLUMN_EVENT_LOCATION_NAME: {
    id: "rc_event_location_name",
    name: t("Event Location Name"),
    enabled_for: [
      "report_will_call_financial",
      "settlement_report",
      "advance_report",
      "report_marketing_campaign_details",
    ],
    column_type: "tickets",
    formats_available: ["csv"],
  },
  COLUMN_EVENT_LOCATION_POSTAL_ADDRESS: {
    id: "rc_event_location_postal_address",
    name: t("Event Location Postal/Zip Code"),
    enabled_for: [
      "report_will_call_financial",
      "settlement_report",
      "advance_report",
      "report_marketing_campaign_details",
    ],
    column_type: "tickets",
    formats_available: ["csv"],
  },
  COLUMN_EVENT_LOCATION_CITY_ADDRESS: {
    id: "rc_event_location_city_address",
    name: t("Event Location City"),
    enabled_for: [
      "report_will_call_financial",
      "settlement_report",
      "advance_report",
      "report_marketing_campaign_details",
    ],
    column_type: "other",
    formats_available: ["csv"],
  },
  COLUMN_EVENT_LOCATION_STREET_NAME: {
    id: "rc_event_location_street_name",
    name: t("Event Location Street"),
    enabled_for: [
      "report_will_call_financial",
      "settlement_report",
      "advance_report",
      "report_marketing_campaign_details",
    ],
    column_type: "other",
    formats_available: ["csv"],
  },
  COLUMN_EVENT_LOCATION_PROVINCE_ADDRESS: {
    id: "rc_event_location_province_address",
    name: t("Event Location Province/State"),
    enabled_for: [
      "report_will_call_financial",
      "settlement_report",
      "advance_report",
      "report_marketing_campaign_details",
    ],
    column_type: "other",
    formats_available: ["csv"],
  },
  COLUMN_EVENT_LOCATION_COUNTRY_ADDRESS: {
    id: "rc_event_location_country_address",
    name: t("Event Location Country"),
    enabled_for: [
      "report_will_call_financial",
      "settlement_report",
      "advance_report",
      "report_marketing_campaign_details",
    ],
    column_type: "other",
    formats_available: ["csv"],
  },
  COLUMN_TICKET_STATUS: {
    id: "rc_ticket_status",
    name: t("Ticket Status"),
    enabled_for: ["report_will_call"],
    column_type: "tickets",
    formats_available: ["csv"],
  },
  COLUMN_TICKET_BARCODE: {
    id: "rc_ticket_barcode",
    name: t("Barcode String"),
    enabled_for: ["report_will_call"],
    column_type: "tickets",
    formats_available: ["csv"],
  },
  COLUMN_TICKET_SCAN_CODE: {
    id: "rc_ticket_scan_code",
    name: t("Ticket Scan Code"),
    enabled_for: ["report_will_call", "report_shipping_fulfillment"],
    column_type: "tickets",
    formats_available: ["csv"],
  },
  COLUMN_SEATING_SECTION: {
    id: "rc_seating_section",
    name: t("Seat Section"),
    enabled_for: [
      "report_will_call",
      "report_holds_stats",
      "member_seating_report",
    ],
    column_type: "tickets",
    formats_available: ["csv"],
  },
  COLUMN_PASSWORD_USED: {
    id: "rc_password_used",
    name: t("Password Used"),
    enabled_for: [
      "report_will_call",
      "report_will_call_financial",
      "settlement_report",
      "advance_report",
      "report_marketing_campaign_details",
    ],
    column_type: "tickets",
    formats_available: ["csv"],
  },
  COLUMN_SEATING_ROW: {
    id: "rc_seating_row",
    name: t("Row/Area"),
    enabled_for: [
      "report_will_call",
      "report_holds_stats",
      "member_seating_report",
    ],
    column_type: "tickets",
    formats_available: ["csv"],
  },
  COLUMN_SEATING_SEAT: {
    id: "rc_seating_seat",
    name: t("Seat"),
    enabled_for: [
      "report_will_call",
      "report_holds_stats",
      "member_seating_report",
    ],
    column_type: "tickets",
    formats_available: ["csv"],
  },
  COLUMN_BASKET_UUID: {
    id: "rc_basket_uuid",
    name: t("Basket UUID"),
    enabled_for: ["report_holds_stats"],
    column_type: "tickets",
    formats_available: ["csv"],
  },
  COLUMN_TICKET_DESCRIPTION: {
    id: "rc_ticket_description",
    name: t("Ticket Description"),
    enabled_for: ["report_will_call"],
    column_type: "tickets",
    formats_available: ["csv"],
  },
  COLUMN_TICKET_STATUS_CHANGE_DATE: {
    id: "rc_last_status_change",
    name: t("Last Ticket Status Change Time"),
    enabled_for: ["report_will_call"],
    column_type: "tickets",
    formats_available: ["csv"],
  },
  COLUMN_TICKET_STATUS_CHANGE_BY_USER: {
    id: "rc_last_status_changed_by",
    name: t("Last Ticket Status Changed By"),
    enabled_for: ["report_will_call"],
    column_type: "tickets",
    formats_available: ["csv"],
  },
  COLUMN_NUM_TICKETS_SOLD_CASH: {
    id: "rc_num_tickets_sold_cash",
    name: t("Num Cash Tickets Sold"),
    enabled_for: [
      "report_event_breakdown",
      "product_breakdown_report",
      "report_ticket_type_breakdown",
      "report_seller_stats",
    ],
    column_type: "tickets",
    formats_available: ["csv"],
  },
  COLUMN_NUM_TICKETS_SOLD_CREDIT: {
    id: "rc_num_tickets_sold_credit",
    name: t("Num Credit Tickets Sold"),
    enabled_for: [
      "report_event_breakdown",
      "product_breakdown_report",
      "report_ticket_type_breakdown",
      "report_seller_stats",
    ],
    column_type: "tickets",
    formats_available: ["csv"],
  },
  COLUMN_NUM_TICKETS_SOLD_AFFIRM: {
    id: "rc_num_tickets_sold_affirm",
    name: t("Num Affirm Tickets Sold"),
    enabled_for: [
      "report_event_breakdown",
      "product_breakdown_report",
      "report_ticket_type_breakdown",
      "report_seller_stats",
    ],
    column_type: "tickets",
    formats_available: ["csv"],
  },
  COLUMN_NUM_TICKETS_SOLD_COMP: {
    id: "rc_num_tickets_sold_comp",
    name: t("Num Comp Tickets Sold"),
    enabled_for: [
      "report_event_breakdown",
      "product_breakdown_report",
      "report_ticket_type_breakdown",
      "report_seller_stats",
    ],
    column_type: "tickets",
    formats_available: ["csv"],
  },
  COLUMN_NUM_TICKETS_SOLD_FREE: {
    id: "rc_num_tickets_sold_free",
    name: t("Num Free Tickets Sold"),
    enabled_for: [
      "report_event_breakdown",
      "product_breakdown_report",
      "report_ticket_type_breakdown",
      "report_seller_stats",
    ],
    column_type: "tickets",
    formats_available: ["csv"],
  },
  COLUMN_NUM_TICKETS_REFUNDED: {
    id: "rc_num_tickets_refunded",
    name: t("Num Tickets Refunded"),
    enabled_for: ["report_ticket_type_breakdown"],
    column_type: "tickets",
    formats_available: ["csv"],
  },
  COLUMN_IS_CHILD: {
    id: "rc_is_child",
    name: t("Child Ticket"),
    enabled_for: ["report_shipping_fulfillment"],
    column_type: "tickets",
    formats_available: ["csv"],
  },
  COLUMN_IS_SUB_TICKET: {
    id: "rc_is_sub_ticket",
    name: t("Is Sub Ticket"),
    enabled_for: [
      "report_will_call_financial",
      "settlement_report",
      "advance_report",
      "report_marketing_campaign_details",
    ],
    column_type: "tickets",
    formats_available: ["csv"],
  },
  COLUMN_MEMBER_FIRST_NAME: {
    id: "rc_member_first_name",
    name: t("Member First Name"),
    enabled_for: ["member_report"],
    column_type: "membership",
    formats_available: ["csv"],
  },
  COLUMN_MEMBER_MEMBER_LAST_NAME: {
    id: "rc_member_last_name",
    name: t("Member Last Name"),
    enabled_for: ["member_report"],
    column_type: "membership",
    formats_available: ["csv"],
  },
  COLUMN_MEMBER_NAME: {
    id: "rc_member_name",
    name: t("Member Name"),
    enabled_for: [
      "report_will_call_financial",
      "settlement_report",
      "advance_report",
      "member_report",
      "member_history_report",
      "member_seating_report",
      "report_marketing_campaign_details",
    ],
    column_type: "membership",
    formats_available: ["csv"],
  },
  COLUMN_MEMBER_EMAIL: {
    id: "rc_member_email",
    name: t("Member Email"),
    enabled_for: [
      "report_will_call_financial",
      "settlement_report",
      "advance_report",
      "member_report",
      "member_history_report",
      "member_seating_report",
      "report_marketing_campaign_details",
    ],
    column_type: "membership",
    formats_available: ["csv"],
  },
  COLUMN_MEMBER_PHONE: {
    id: "rc_member_phone",
    name: t("Member Phone"),
    enabled_for: [
      "member_report",
      "member_history_report",
      "member_seating_report",
    ],
    column_type: "membership",
    formats_available: ["csv"],
  },
  COLUMN_MEMBER_STATUS: {
    id: "rc_member_status",
    name: t("Member Status"),
    enabled_for: ["member_report", "member_seating_report"],
    column_type: "membership",
    formats_available: ["csv"],
  },
  COLUMN_MEMBER_SEATING_RESERVED: {
    id: "rc_member_seating_reserved",
    name: t("Seating Reserved"),
    enabled_for: ["member_seating_report"],
    column_type: "membership",
    formats_available: ["csv"],
  },
  COLUMN_MEMBER_QUANTITY: {
    id: "rc_member_quantity",
    name: t("Member Quantity"),
    enabled_for: ["member_report"],
    column_type: "membership",
    formats_available: ["csv"],
  },
  COLUMN_MEMBER_EXPIRY_DATE: {
    id: "rc_member_expiry_date",
    name: t("Member Expiry Date"),
    enabled_for: ["member_report"],
    column_type: "membership",
    formats_available: ["csv"],
  },
  COLUMN_MEMBER_BARCODE: {
    id: "rc_member_barcode",
    name: t("Member Barcode"),
    enabled_for: ["member_report", "member_history_report"],
    column_type: "membership",
    formats_available: ["csv"],
  },
  COLUMN_MEMBER_UNIVERSAL_CODE: {
    id: "rc_member_universal_code",
    name: t("Member Universal Code"),
    enabled_for: ["member_report"],
    column_type: "membership",
    formats_available: ["csv"],
  },
  COLUMN_MEMBER_SCANS_ALLOWED: {
    id: "rc_member_scans_allowed",
    name: t("Member Scans Allowed"),
    enabled_for: ["member_benefit_usage_report"],
    column_type: "membership",
    formats_available: ["csv"],
  },
  COLUMN_MEMBER_SCANS_USED: {
    id: "rc_member_scans_used",
    name: t("Member Scans Used"),
    enabled_for: ["member_report", "member_benefit_usage_report"],
    column_type: "membership",
    formats_available: ["csv"],
  },
  COLUMN_MEMBER_HISTORY_AMOUNT: {
    id: "rc_member_history_amount",
    name: t("Amount"),
    enabled_for: ["member_history_report"],
    column_type: "membership",
    formats_available: ["csv"],
  },
  COLUMN_MEMBER_DISCOUNTS_ALLOWED: {
    id: "rc_member_discounts_allowed",
    name: t("Member Discounts Allowed"),
    enabled_for: ["member_benefit_usage_report"],
    column_type: "membership",
    formats_available: ["csv"],
  },
  COLUMN_MEMBER_DISCOUNTS_USED: {
    id: "rc_member_discounts_used",
    name: t("Member Discounts Used"),
    enabled_for: ["member_report", "member_benefit_usage_report"],
    column_type: "membership",
    formats_available: ["csv"],
  },
  COLUMN_MEMBER_LAST_STATUS_CHANGE: {
    id: "rc_member_last_status_change",
    name: t("Member Last Status Change"),
    enabled_for: ["member_report"],
    column_type: "membership",
    formats_available: ["csv"],
  },
  COLUMN_MEMBER_LAST_STATUS_CHANGED_BY: {
    id: "rc_member_last_status_changed_by",
    name: t("Member Last Status Changed By"),
    enabled_for: ["member_report"],
    column_type: "membership",
    formats_available: ["csv"],
  },
  COLUMN_MEMBERSHIP_GROUP_NAME: {
    id: "rc_membership_group_name",
    name: t("Membership Group Name"),
    enabled_for: [
      "report_will_call_financial",
      "settlement_report",
      "advance_report",
      "member_report",
      "member_history_report",
      "member_benefit_usage_report",
      "report_shipping_fulfillment",
      "member_seating_report",
      "report_marketing_campaign_details",
      "report_holds_stats",
    ],
    column_type: "membership",
    formats_available: ["csv"],
  },
  COLUMN_MEMBERSHIP_GROUP_ID: {
    id: "rc_membership_group_id",
    name: t("Membership Group ID"),
    enabled_for: [
      "report_will_call_financial",
      "settlement_report",
      "advance_report",
      "report_shipping_fulfillment",
      "report_marketing_campaign_details",
      "report_holds_stats",
    ],
    column_type: "membership",
    formats_available: ["csv"],
  },
  COLUMN_MEMBERSHIP_LEVEL_NAME: {
    id: "rc_membership_level_name",
    name: t("Membership Level Name"),
    enabled_for: [
      "report_will_call_financial",
      "settlement_report",
      "advance_report",
      "member_report",
      "member_history_report",
      "member_benefit_usage_report",
      "report_shipping_fulfillment",
      "member_seating_report",
      "report_marketing_campaign_details",
      "report_holds_stats",
    ],
    column_type: "membership",
    formats_available: ["csv"],
  },
  COLUMN_MEMBERSHIP_LEVEL_ID: {
    id: "rc_membership_level_id",
    name: t("Membership Level ID"),
    enabled_for: [
      "report_will_call_financial",
      "settlement_report",
      "advance_report",
      "report_shipping_fulfillment",
      "report_marketing_campaign_details",
      "report_holds_stats",
    ],
    column_type: "membership",
    formats_available: ["csv"],
  },
  COLUMN_MEMBERSHIP_LEVEL_PRICE: {
    id: "rc_membership_level_price",
    name: t("Membership Level Price"),
    enabled_for: [
      "report_will_call_financial",
      "settlement_report",
      "advance_report",
      "report_marketing_campaign_details",
    ],
    column_type: "membership",
    formats_available: ["csv"],
  },
  COLUMN_MEMBERSHIP_STATUS_BEFORE: {
    id: "rc_member_status_before",
    name: t("Member Status Before"),
    enabled_for: ["member_history_report"],
    column_type: "membership",
    formats_available: ["csv"],
  },
  COLUMN_MEMBERSHIP_STATUS_AFTER: {
    id: "rc_member_status_after",
    name: t("Member Status After"),
    enabled_for: ["member_history_report"],
    column_type: "membership",
    formats_available: ["csv"],
  },
  COLUMN_MEMBERSHIP_HISTORY_ACTION: {
    id: "rc_member_history_action",
    name: t("Member History Action"),
    enabled_for: ["member_history_report"],
    column_type: "membership",
    formats_available: ["csv"],
  },
  COLUMN_MEMBERSHIP_HISTORY_TYPE: {
    id: "rc_member_history_type",
    name: t("Member History Type"),
    enabled_for: ["member_history_report"],
    column_type: "membership",
    formats_available: ["csv"],
  },
  COLUMN_MEMBERSHIP_BENEFIT: {
    id: "rc_membership_benefit",
    name: t("Membership Benefit"),
    enabled_for: ["member_history_report", "member_benefit_usage_report"],
    column_type: "membership",
    formats_available: ["csv"],
  },
  COLUMN_MEMBERSHIP_BENEFIT_TYPE: {
    id: "rc_membership_benefit_type",
    name: t("Membership Benefit Type"),
    enabled_for: ["member_benefit_usage_report"],
    column_type: "membership",
    formats_available: ["csv"],
  },
  COLUMN_MEMBER_LATEST_SEASON: {
    id: "rc_member_latest_season",
    name: t("Member Latest Season"),
    enabled_for: ["member_report"],
    column_type: "membership",
    formats_available: ["csv"],
  },
  COLUMN_PRODUCT_ATTRIBUTE: {
    id: "rc_product_attribute",
    name: t("Product Attribute Name"),
    enabled_for: [
      "report_will_call",
      "report_event_product_inventory",
      "report_will_call_financial",
      "settlement_report",
      "advance_report",
      "report_marketing_campaign_details",
    ],
    column_type: "products",
    formats_available: ["csv"],
  },
  COLUMN_PRODUCT_ATTRIBUTE_PRICE: {
    id: "rc_product_attribute_price",
    name: t("Product Attribute Price"),
    enabled_for: [
      "report_will_call_financial",
      "settlement_report",
      "advance_report",
      "report_marketing_campaign_details",
    ],
    column_type: "products",
    formats_available: ["csv"],
  },
  COLUMN_PRODUCT: {
    id: "rc_product",
    name: t("Product Name"),
    enabled_for: [
      "report_will_call",
      "report_event_product_inventory",
      "report_will_call_financial",
      "settlement_report",
      "advance_report",
      "product_breakdown_report",
      "report_marketing_campaign_details",
    ],
    column_type: "products",
    formats_available: ["csv"],
  },
  COLUMN_PRODUCT_ATTRIBUTE_SKU: {
    id: "rc_product_attribute_sku",
    name: t("SKU"),
    enabled_for: ["report_shipping_fulfillment"],
    column_type: "products",
    formats_available: ["csv"],
  },
  COLUMN_PURCHASER_USERNAME: {
    id: "rc_purchaser_username",
    name: t("Purchaser Name"),
    enabled_for: ["gift_card_recipients_report"],
    column_type: "gift_cards",
    formats_available: ["csv"],
  },
  COLUMN_PURCHASER_EMAIL: {
    id: "rc_purchaser_email",
    name: t("Purchaser Email"),
    enabled_for: ["gift_card_recipients_report"],
    column_type: "gift_cards",
    formats_available: ["csv"],
  },
  COLUMN_PURCHASER_PHONE_NUMBER: {
    id: "rc_purchaser_phone",
    name: t("Purchaser Phone Number"),
    enabled_for: ["gift_card_recipients_report"],
    column_type: "gift_cards",
    formats_available: ["csv"],
  },
  COLUMN_SENDER_USERNAME: {
    id: "rc_sender_username",
    name: t("Sender Name"),
    enabled_for: ["gift_card_recipients_report"],
    column_type: "gift_cards",
    formats_available: ["csv"],
  },
  COLUMN_GIFT_CARD_REDEEMED: {
    id: "rc_gift_card_redeemed",
    name: t("Is Redeemed"),
    enabled_for: ["gift_card_recipients_report"],
    column_type: "gift_cards",
    formats_available: ["csv"],
  },
  COLUMN_RECIPIENT_NAME: {
    id: "rc_recipient_name",
    name: t("Recipient Name"),
    enabled_for: ["gift_card_recipients_report"],
    column_type: "gift_cards",
    formats_available: ["csv"],
  },
  COLUMN_RECIPIENT_EMAIL: {
    id: "rc_recipient_email",
    name: t("Recipient Email"),
    enabled_for: ["gift_card_recipients_report"],
    column_type: "gift_cards",
    formats_available: ["csv"],
  },
  COLUMN_RECIPIENT_PHONE_NUMBER: {
    id: "rc_recipient_phone",
    name: t("Recipient Phone Number"),
    enabled_for: ["gift_card_recipients_report"],
    column_type: "gift_cards",
    formats_available: ["csv"],
  },
  COLUMN_GIFT_CARD_ID: {
    id: "rc_gift_card_id",
    name: t("Gift Card ID"),
    enabled_for: ["gift_card_recipients_report"],
    column_type: "gift_cards",
    formats_available: ["csv"],
  },
  COLUMN_GIFT_CARD_NAME: {
    id: "rc_gift_card_name",
    name: t("Gift Card Name"),
    enabled_for: ["gift_card_recipients_report"],
    column_type: "gift_cards",
    formats_available: ["csv"],
  },
  COLUMN_GIFT_CARD_DENOMINATION_ID: {
    id: "rc_gift_card_denomination_id",
    name: t("Gift Card Denomination ID"),
    enabled_for: ["gift_card_recipients_report"],
    column_type: "gift_cards",
    formats_available: ["csv"],
  },
  COLUMN_GIFT_CARD_DENOMINATION_PRICE: {
    id: "rc_gift_card_denomination_price",
    name: t("Gift Card Denomination Price"),
    enabled_for: ["gift_card_recipients_report"],
    column_type: "gift_cards",
    formats_available: ["csv"],
  },
  COLUMN_GIFT_CARD_AMOUNT_PAID: {
    id: "rc_gift_card_amount_paid",
    name: t("Amount Paid"),
    enabled_for: ["gift_card_recipients_report"],
    column_type: "gift_cards",
    formats_available: ["csv"],
  },
  COLUMN_TOTAL_GIFT_CARD_AMOUNT: {
    id: "rc_total_gift_card_amount",
    name: t("Total Amount"),
    enabled_for: ["gift_card_recipients_report"],
    column_type: "gift_cards",
    formats_available: ["csv"],
  },
  COLUMN_AMOUNT_ADVANCED: {
    id: "rc_amount_advanced",
    name: t("Amount Advanced"),
    enabled_for: ["gift_card_recipients_report"],
    column_type: "gift_cards",
    formats_available: ["csv"],
  },
  COLUMN_AMOUNT_USED: {
    id: "rc_amount_used",
    name: t("Amount Used"),
    enabled_for: ["gift_card_recipients_report"],
    column_type: "gift_cards",
    formats_available: ["csv"],
  },
  COLUMN_AMOUNT_REMAINING: {
    id: "rc_amount_remaining",
    name: t("Amount Remaining"),
    enabled_for: ["gift_card_recipients_report"],
    column_type: "gift_cards",
    formats_available: ["csv"],
  },
  COLUMN_PRICE_TIER_NAME: {
    id: "rc_price_tier_name",
    name: t("Price Tier Name"),
    enabled_for: [
      "report_will_call_financial",
      "settlement_report",
      "advance_report",
    ],
    column_type: "price_tiers",
    formats_available: ["csv"],
  },
  COLUMN_PRICE_TIER_ID: {
    id: "rc_price_tier_id",
    name: t("Price Tier ID"),
    enabled_for: [
      "report_will_call_financial",
      "settlement_report",
      "advance_report",
    ],
    column_type: "price_tiers",
    formats_available: ["csv"],
  },
  COLUMN_PRICE_TIER_PRICE: {
    id: "rc_price_tier_price",
    name: t("Price Tier Price"),
    enabled_for: [
      "report_will_call_financial",
      "settlement_report",
      "advance_report",
    ],
    column_type: "price_tiers",
    formats_available: ["csv"],
  },
  COLUMN_VENUE_NAME: {
    id: "rc_venue_name",
    name: t("Venue Name"),
    enabled_for: [
      "report_will_call_financial",
      "settlement_report",
      "advance_report",
      "report_marketing_campaign_details",
    ],
    column_type: "other",
    formats_available: ["csv"],
  },
  COLUMN_VENUE_ID: {
    id: "rc_venue_id",
    name: t("Venue ID"),
    enabled_for: [
      "report_will_call_financial",
      "settlement_report",
      "advance_report",
      "report_marketing_campaign_details",
    ],
    column_type: "other",
    formats_available: ["csv"],
  },
  COLUMN_CREATED: {
    id: "rc_created",
    name: t("Purchase Date"),
    enabled_for: [
      "report_invoice_transaction",
      "report_will_call",
      "report_surveys",
      "report_shipping_fulfillment",
      "report_donor_transaction",
    ],
    column_type: "other",
    formats_available: ["csv"],
  },
  COLUMN_UPDATED: {
    id: "rc_updated",
    name: t("Last Updated"),
    enabled_for: ["report_holds_stats"],
    column_type: "other",
    formats_available: ["csv"],
  },
  COLUMN_GENERAL_CREATED: {
    id: "rc_general_created",
    name: t("Created"),
    enabled_for: ["member_history_report"],
    column_type: "other",
    formats_available: ["csv"],
  },
  COLUMN_SURVEY_NAME: {
    id: "rc_survey_name",
    name: t("Survey Name"),
    enabled_for: ["report_surveys"],
    column_type: "other",
    formats_available: ["csv"],
  },
  COLUMN_SOLD_BY: {
    id: "rc_sold_by",
    name: t("Sold By"),
    enabled_for: [
      "report_invoice_transaction",
      "report_will_call",
      "report_will_call_financial",
      "settlement_report",
      "advance_report",
      "report_holds_stats",
      "report_marketing_campaign_details",
    ],
    column_type: "other",
    formats_available: ["csv"],
  },
  COLUMN_SOLD_BY_VENUE: {
    id: "rc_sold_by_venue",
    name: t("Sold By Venue"),
    enabled_for: ["report_will_call"],
    column_type: "other",
    formats_available: ["csv"],
  },
  COLUMN_REFERRED_BY: {
    id: "rc_referred_by",
    name: t("Referred By"),
    enabled_for: [
      "report_invoice_transaction",
      "report_will_call_financial",
      "settlement_report",
      "advance_report",
      "report_marketing_campaign_details",
    ],
    column_type: "other",
    formats_available: ["csv"],
  },
  COLUMN_REFERRED_BY_DESCRIPTION: {
    id: "rc_referred_link_description",
    name: t("Referral Link Description"),
    enabled_for: [
      "report_invoice_transaction",
      "report_will_call_financial",
      "settlement_report",
      "advance_report",
      "report_marketing_campaign_details",
    ],
    column_type: "other",
    formats_available: ["csv"],
  },
  COLUMN_REFERRED_LINK_URL: {
    id: "rc_referred_link_URL",
    name: t("Referral Link URL"),
    enabled_for: [
      "report_will_call_financial",
      "settlement_report",
      "advance_report",
      "report_marketing_campaign_details",
    ],
    column_type: "other",
    formats_available: ["csv"],
  },
  COLUMN_CUSTOM_QUESTION_INFO: {
    id: "rc_custom_question_info",
    name: t("Custom Question Info"),
    enabled_for: ["report_will_call", "member_report"],
    column_type: "other",
    formats_available: ["csv"],
  },
  COLUMN_POSTAL_ADDRESS: {
    id: "rc_postal_address",
    name: t("Billing Postal Code/Zip"),
    enabled_for: [
      "report_invoice_transaction",
      "report_will_call_financial",
      "settlement_report",
      "advance_report",
      "report_donor_transaction",
      "report_marketing_campaign_details",
    ],
    column_type: "other",
    formats_available: ["csv"],
  },
  COLUMN_BILLING_ADDRESS: {
    id: "rc_billing_address",
    name: t("Billing Address"),
    enabled_for: ["report_event_product_inventory"],
    column_type: "other",
    formats_available: ["csv"],
  },
  COLUMN_CITY_ADDRESS: {
    id: "rc_city_address",
    name: t("Billing City"),
    enabled_for: [
      "report_invoice_transaction",
      "report_will_call_financial",
      "settlement_report",
      "advance_report",
      "report_donor_transaction",
      "report_marketing_campaign_details",
    ],
    column_type: "other",
    formats_available: ["csv"],
  },
  COLUMN_STREET_ADDRESS: {
    id: "rc_street_address",
    name: t("Billing Street"),
    enabled_for: [
      "report_invoice_transaction",
      "report_will_call_financial",
      "settlement_report",
      "advance_report",
      "report_donor_transaction",
      "report_marketing_campaign_details",
    ],
    column_type: "other",
    formats_available: ["csv"],
  },
  COLUMN_PROVINCE_ADDRESS: {
    id: "rc_province_address",
    name: t("Billing Province/State"),
    enabled_for: [
      "report_invoice_transaction",
      "report_will_call_financial",
      "settlement_report",
      "advance_report",
      "report_donor_transaction",
      "report_marketing_campaign_details",
    ],
    column_type: "other",
    formats_available: ["csv"],
  },
  COLUMN_COUNTRY_ADDRESS: {
    id: "rc_country_address",
    name: t("Billing Country"),
    enabled_for: [
      "report_invoice_transaction",
      "report_will_call_financial",
      "settlement_report",
      "advance_report",
      "report_donor_transaction",
      "report_marketing_campaign_details",
    ],
    column_type: "other",
    formats_available: ["csv"],
  },
  COLUMN_DISCOUNT_CODE: {
    id: "rc_discount_code",
    name: t("Discount Code Used"),
    enabled_for: [
      "report_invoice_transaction",
      "report_discount_usage_stats",
      "report_discount_creation",
      "report_will_call_financial",
      "settlement_report",
      "advance_report",
      "report_marketing_campaign_details",
    ],
    column_type: "other",
    formats_available: ["csv"],
  },
  COLUMN_INTERNAL_INFO: {
    id: "rc_internal_info",
    name: t("Info"),
    enabled_for: ["report_invoice_transaction"],
    column_type: "other",
    formats_available: ["csv"],
  },
  COLUMN_SHIPPING_FULFILLMENT_STATUS: {
    id: "rc_shipping_fulfillment_status",
    name: t("Fulfillment Status"),
    enabled_for: ["report_shipping_fulfillment"],
    column_type: "shipping",
    formats_available: ["csv"],
  },
  COLUMN_FULFILLED_BY_EMPLOYEE: {
    id: "rc_fulfilled_by_employee",
    name: t("Fulfilled By Employee"),
    enabled_for: ["report_shipping_fulfillment"],
    column_type: "shipping",
    formats_available: ["csv"],
  },
  COLUMN_SHIPPING_FULFILLMENT_DATE: {
    id: "rc_shipping_fulfillment_date",
    name: t("Fulfillment Date"),
    enabled_for: ["report_shipping_fulfillment"],
    column_type: "shipping",
    formats_available: ["csv"],
  },
  COLUMN_TICKET_AMOUNT_TO_SHIP: {
    id: "rc_ticket_amount_to_ship",
    name: t("Quantity Per Order"),
    enabled_for: ["report_shipping_fulfillment"],
    column_type: "shipping",
    formats_available: ["csv"],
  },
  COLUMN_SHIPPING_METHOD: {
    id: "rc_shipping_method",
    name: t("Delivery Method"),
    enabled_for: [
      "report_will_call_financial",
      "settlement_report",
      "advance_report",
      "report_marketing_campaign_details",
    ],
    column_type: "shipping",
    formats_available: ["csv"],
  },
  COLUMN_SHIPPING_STREET_ADDRESS: {
    id: "rc_shipping_street_address",
    name: t("Shipping Street"),
    enabled_for: [
      "report_will_call_financial",
      "report_shipping_fulfillment",
      "report_venue_user",
      "settlement_report",
      "advance_report",
      "report_marketing_campaign_details",
    ],
    column_type: "other",
    formats_available: ["csv"],
  },
  COLUMN_SHIPPING_UNIT_NUMBER: {
    id: "rc_shipping_unit_number",
    name: t("Shipping Unit Number"),
    enabled_for: [
      "report_will_call_financial",
      "report_shipping_fulfillment",
      "report_venue_user",
      "settlement_report",
      "advance_report",
      "report_marketing_campaign_details",
    ],
    column_type: "other",
    formats_available: ["csv"],
  },
  COLUMN_SHIPPING_CITY_ADDRESS: {
    id: "rc_shipping_city_address",
    name: t("Shipping City"),
    enabled_for: [
      "report_will_call_financial",
      "report_shipping_fulfillment",
      "report_venue_user",
      "settlement_report",
      "advance_report",
      "report_marketing_campaign_details",
    ],
    column_type: "other",
    formats_available: ["csv"],
  },
  COLUMN_SHIPPING_PROVINCE_ADDRESS: {
    id: "rc_shipping_province_address",
    name: t("Shipping Province/State"),
    enabled_for: [
      "report_will_call_financial",
      "report_shipping_fulfillment",
      "report_venue_user",
      "settlement_report",
      "advance_report",
      "report_marketing_campaign_details",
    ],
    column_type: "other",
    formats_available: ["csv"],
  },
  COLUMN_SHIPPING_COUNTRY_ADDRESS: {
    id: "rc_shipping_country_address",
    name: t("Shipping Country"),
    enabled_for: [
      "report_will_call_financial",
      "report_shipping_fulfillment",
      "report_venue_user",
      "settlement_report",
      "advance_report",
      "report_marketing_campaign_details",
    ],
    column_type: "other",
    formats_available: ["csv"],
  },
  COLUMN_SHIPPING_POSTAL_ADDRESS: {
    id: "rc_shipping_postal_address",
    name: t("Shipping Postal Code/Zip"),
    enabled_for: [
      "report_will_call_financial",
      "report_shipping_fulfillment",
      "report_venue_user",
      "settlement_report",
      "advance_report",
      "report_marketing_campaign_details",
    ],
    column_type: "other",
    formats_available: ["csv"],
  },
  COLUMN_SHIPPING_FEES: {
    id: "rc_shipping_cost",
    name: t("Shipping & Handling Fees"),
    enabled_for: [
      "report_will_call_financial",
      "settlement_report",
      "advance_report",
      "report_marketing_campaign_details",
    ],
    column_type: "other",
    formats_available: ["csv"],
  },
  COLUMN_COMPANY_CHARGES: {
    id: "rc_company_charges",
    name: t("Showpass Fees"),
    enabled_for: ["report_event_product_inventory"],
    column_type: "financial",
    formats_available: ["csv"],
  },
  COLUMN_TOTAL_PRICE: {
    id: "rc_total_price",
    name: t("Total Price"),
    enabled_for: ["waitlist_subscriber_report"],
    column_type: "tickets",
    formats_available: ["csv"],
  },
  COLUMN_TOTAL_PRICE_NO_FEES: {
    id: "rc_total_price_no_fees",
    name: t("Total Price No Fees"),
    enabled_for: ["waitlist_subscriber_report"],
    column_type: "tickets",
    formats_available: ["csv"],
  },
  COLUMN_REFUND_AMOUNT: {
    id: "rc_refund_amount",
    name: t("Refund Amount"),
    enabled_for: ["reseller_submissions_report"],
    column_type: "tickets",
    formats_available: ["csv"],
  },
  COLUMN_NUM_OF_PASSWORDS_USED: {
    id: "rc_num_of_passwords_used",
    name: t("Number Of Passwords Used"),
    enabled_for: ["report_password_used_breakdown"],
    column_type: "inventory",
    formats_available: ["csv"],
  },
  COLUMN_NUM_OF_STANDARD_TICKETS_SOLD: {
    id: "rc_num_of_standard_tickets_sold",
    name: t("Standard Tickets Sold"),
    enabled_for: ["product_breakdown_report", "report_event_breakdown"],
    column_type: "inventory",
    formats_available: ["pdf"],
  },
  COLUMN_NUM_OF_TICKETS_SOLD_REDEEMABLE: {
    id: "rc_num_of_tickets_sold_redeemable",
    name: t("Quantity"),
    enabled_for: ["report_event_breakdown"],
    column_type: "inventory",
    formats_available: ["pdf"],
  },
  COLUMN_NUM_OF_REDEEMABLE_TICKETS: {
    id: "rc_num_of_redeemable_tickets",
    name: t("Total Redeemable Tickets"),
    enabled_for: [
      "report_event_breakdown",
      "product_breakdown_report",
      "report_ticket_type_breakdown",
    ],
    column_type: "inventory",
    formats_available: ["csv"],
  },
  COLUMN_TOTAL_INVENTORY: {
    id: "rc_total_inventory",
    name: t("Total Inventory"),
    enabled_for: [
      "report_event_breakdown",
      "product_breakdown_report",
      "report_ticket_type_breakdown",
    ],
    column_type: "inventory",
    formats_available: ["pdf", "csv"],
  },
  COLUMN_NUM_OF_TOTAL_PACKAGES: {
    id: "rc_num_of_total_packages",
    name: t("Total Packages"),
    enabled_for: ["report_event_breakdown", "report_ticket_type_breakdown"],
    column_type: "inventory",
    formats_available: ["pdf", "csv"],
  },
  COLUMN_TOTAL_TICKET_PACKAGE_INVENTORY: {
    id: "rc_total_ticket_package_inventory",
    name: t("Total Ticket Package Inventory"),
    enabled_for: ["report_event_breakdown"],
    column_type: "inventory",
    formats_available: ["pdf"],
  },
  COLUMN_NUM_OF_SUB_TICKETS_FROM_EVENT: {
    id: "rc_num_of_sub_tickets_from_event",
    name: t("Sub Tickets From Event"),
    enabled_for: ["report_event_breakdown"],
    column_type: "inventory",
    formats_available: ["pdf", "csv"],
  },
  COLUMN_NUM_OF_SUB_TICKETS_FROM_OUTSIDE_EVENT: {
    id: "rc_num_of_sub_tickets_from_outside_event",
    name: t("Sub Tickets From Outside Event"),
    enabled_for: ["report_event_breakdown"],
    column_type: "inventory",
    formats_available: ["pdf", "csv"],
  },
  COLUMN_NUM_OF_TICKETS_NOT_INCLUDED_IN_STATS: {
    id: "rc_num_of_tickets_not_included_in_stats",
    name: t("Tickets Not Included In Stats"),
    enabled_for: ["report_event_breakdown", "report_ticket_type_breakdown"],
    column_type: "inventory",
    formats_available: ["pdf", "csv"],
  },
  COLUMN_NUM_OF_HOLD_TICKETS: {
    id: "rc_num_of_hold_tickets",
    name: t("Tickets On Hold"),
    enabled_for: ["product_breakdown_report", "report_event_breakdown"],
    column_type: "inventory",
    formats_available: ["pdf"],
  },
  COLUMN_HOLD_LINK: {
    id: "rc_hold_link",
    name: t("Hold Link"),
    enabled_for: ["report_holds_stats"],
    column_type: "tickets",
    formats_available: ["csv"],
  },
  COLUMN_NUM_OF_PAYMENT_PLANS_COPY: {
    id: "rc_num_of_payment_plans_copy",
    name: t("Payment Plans Sold"),
    enabled_for: ["report_event_breakdown"],
    column_type: "inventory",
    formats_available: ["pdf"],
  },
  COLUMN_UTM_CAMPAIGN: {
    id: "rc_utm_campaign",
    name: t("UTM Campaign"),
    enabled_for: [
      "report_marketing_campaigns",
      "report_marketing_campaign_details",
    ],
    column_type: "marketing_campaigns",
    formats_available: ["csv"],
  },
  COLUMN_UTM_SOURCE: {
    id: "rc_utm_source",
    name: t("UTM Source"),
    enabled_for: [
      "report_marketing_campaigns",
      "report_marketing_campaign_details",
    ],
    column_type: "marketing_campaigns",
    formats_available: ["csv"],
  },
  COLUMN_UTM_MEDIUM: {
    id: "rc_utm_medium",
    name: t("UTM Medium"),
    enabled_for: [
      "report_marketing_campaigns",
      "report_marketing_campaign_details",
    ],
    column_type: "marketing_campaigns",
    formats_available: ["csv"],
  },
  COLUMN_VIEWS: {
    id: "rc_views",
    name: t("Page Views"),
    enabled_for: ["report_marketing_campaigns"],
    column_type: "marketing_campaigns",
    formats_available: ["csv"],
  },
  COLUMN_ADD_TO_CART: {
    id: "rc_add_to_cart",
    name: t("Add To Cart Events"),
    enabled_for: ["report_marketing_campaigns"],
    column_type: "marketing_campaigns",
    formats_available: ["csv"],
  },
  COLUMN_ADD_TO_CART_RATE: {
    id: "rc_add_to_cart_rate",
    name: t("Add To Cart Rate"),
    enabled_for: ["report_marketing_campaigns"],
    column_type: "marketing_campaigns",
    formats_available: ["csv"],
  },
  COLUMN_INITIATE_CHECKOUT: {
    id: "rc_initiate_checkout",
    name: t("Initiate Checkout Events"),
    enabled_for: ["report_marketing_campaigns"],
    column_type: "marketing_campaigns",
    formats_available: ["csv"],
  },
  COLUMN_INITIATE_CHECKOUT_RATE: {
    id: "rc_initiate_checkout_rate",
    name: t("Initiate Checkout Rate"),
    enabled_for: ["report_marketing_campaigns"],
    column_type: "marketing_campaigns",
    formats_available: ["csv"],
  },
  COLUMN_PURCHASES: {
    id: "rc_purchases",
    name: t("Purchase Events"),
    enabled_for: ["report_marketing_campaigns"],
    column_type: "marketing_campaigns",
    formats_available: ["csv"],
  },
  COLUMN_PURCHASE_RATE: {
    id: "rc_purchase_rate",
    name: t("Purchase Rate"),
    enabled_for: ["report_marketing_campaigns"],
    column_type: "marketing_campaigns",
    formats_available: ["csv"],
  },
  COLUMN_INFO_STUDENT_NUMBER: {
    id: "rc_info_student_number",
    name: t("Student Number"),
    enabled_for: ["report_will_call", "member_report"],
    column_type: "tickets",
    formats_available: ["csv"],
  },
  COLUMN_INFO_COMPANY: {
    id: "rc_info_company",
    name: t("Company"),
    enabled_for: ["report_will_call", "member_report"],
    column_type: "tickets",
    formats_available: ["csv"],
  },
  COLUMN_INFO_JOB_TITLE: {
    id: "rc_info_job_title",
    name: t("Job Title"),
    enabled_for: ["report_will_call", "member_report"],
    column_type: "tickets",
    formats_available: ["csv"],
  },
  COLUMN_INFO_FIRST_NAME: {
    id: "rc_info_first_name",
    name: t("First Name"),
    enabled_for: [
      "report_will_call",
      "waitlist_subscriber_report",
      "reseller_submissions_report",
    ],
    column_type: "tickets",
    formats_available: ["csv"],
  },
  COLUMN_INFO_LAST_NAME: {
    id: "rc_info_last_name",
    name: t("Last Name"),
    enabled_for: [
      "report_will_call",
      "waitlist_subscriber_report",
      "reseller_submissions_report",
    ],
    column_type: "tickets",
    formats_available: ["csv"],
  },
  COLUMN_INFO_PHONE_NUMBER: {
    id: "rc_info_phone_number",
    name: t("Phone Number"),
    enabled_for: ["report_will_call"],
    column_type: "tickets",
    formats_available: ["csv"],
  },
  COLUMN_INFO_EMAIL: {
    id: "rc_info_email",
    name: t("Info Email"),
    enabled_for: ["report_will_call"],
    column_type: "tickets",
    formats_available: ["csv"],
  },
  COLUMN_INFO_HOME_ADDRESS_UNIT_NUMBER: {
    id: "rc_info_home_address_unit_number",
    name: t("Guest Unit Number"),
    enabled_for: ["report_will_call", "member_report"],
    column_type: "tickets",
    formats_available: ["csv"],
  },
  COLUMN_INFO_HOME_ADDRESS_STREET_NAME: {
    id: "rc_info_home_address_street_name",
    name: t("Guest Street Name"),
    enabled_for: ["report_will_call", "member_report"],
    column_type: "tickets",
    formats_available: ["csv"],
  },
  COLUMN_INFO_HOME_ADDRESS_CITY: {
    id: "rc_info_home_address_city",
    name: t("Guest City"),
    enabled_for: ["report_will_call", "member_report"],
    column_type: "tickets",
    formats_available: ["csv"],
  },
  COLUMN_INFO_HOME_ADDRESS_PROVINCE: {
    id: "rc_info_home_address_province",
    name: t("Guest Province"),
    enabled_for: ["report_will_call", "member_report"],
    column_type: "tickets",
    formats_available: ["csv"],
  },
  COLUMN_INFO_HOME_ADDRESS_POSTAL_CODE: {
    id: "rc_info_home_address_postal",
    name: t("Guest Postal Code"),
    enabled_for: ["report_will_call", "member_report"],
    column_type: "tickets",
    formats_available: ["csv"],
  },
  COLUMN_INFO_HOME_ADDRESS_COUNTRY: {
    id: "rc_info_home_address_country",
    name: t("Guest Country"),
    enabled_for: ["report_will_call", "member_report"],
    column_type: "tickets",
    formats_available: ["csv"],
  },
  COLUMN_INFO_BIRTHDAY: {
    id: "rc_info_birthday",
    name: t("Birthday"),
    enabled_for: ["report_will_call", "member_report"],
    column_type: "tickets",
    formats_available: ["csv"],
  },
  COLUMN_INFO_LICENSE_PLATE: {
    id: "rc_info_license_plate",
    name: t("License Plate"),
    enabled_for: ["report_will_call", "member_report"],
    column_type: "tickets",
    formats_available: ["csv"],
  },
  COLUMN_PASSWORD: {
    id: "rc_password",
    name: t("Password"),
    enabled_for: ["report_password_used_breakdown"],
    column_type: "other",
    formats_available: ["csv"],
  },
  COLUMN_STATUS: {
    id: "rc_status",
    name: t("Status"),
    enabled_for: ["waitlist_subscriber_report", "reseller_submissions_report"],
    column_type: "other",
    formats_available: ["csv"],
  },
  COLUMN_DONATION_TOTAL: {
    id: "rc_donation_total",
    name: t("Donation Total"),
    enabled_for: ["report_donor_transaction"],
    column_type: "donation",
    formats_available: ["csv"],
  },
  COLUMN_REGISTRATION_NUMBER: {
    id: "rc_registration_number",
    name: t("Charity Registration Number"),
    enabled_for: ["report_donor_transaction"],
    column_type: "donation",
    formats_available: ["csv"],
  },
  COLUMN_CHARITY_NAME: {
    id: "rc_charity_name",
    name: t("Charity Name"),
    enabled_for: ["report_donor_transaction"],
    column_type: "donation",
    formats_available: ["csv"],
  },
  COLUMN_CHARITY_CURRENCY: {
    id: "rc_charity_currency",
    name: t("Charity Currency"),
    enabled_for: ["report_donor_transaction"],
    column_type: "donation",
    formats_available: ["csv"],
  },
  TICKET_PAY_WHAT_YOU_CAN_ENABLED: {
    id: "rc_ticket_pay_what_you_can_enabled",
    enabled_for: ["report_will_call_financial"],
    name: t("Pay What You Can Enabled"),
    column_type: "ticket_history",
    formats_available: ["csv"],
  },
  TICKET_PAY_WHAT_YOU_CAN_DIFFERENCE: {
    id: "rc_ticket_pay_what_you_can_difference",
    enabled_for: ["report_will_call_financial"],
    name: t("Pay What You Can Surplus/Deficit"),
    column_type: "ticket_history",
    formats_available: ["csv"],
  },
  COLUMN_AFFIRM_REVENUE: {
    id: "rc_affirm_revenue",
    name: t("Affirm Revenue"),
    enabled_for: [
      "report_event_breakdown",
      "product_breakdown_report",
      "report_ticket_type_breakdown",
      "report_seller_stats",
    ],
    column_type: "financial",
    formats_available: ["csv"],
  },
  COLUMN_DISPLAY_GROSS_SALES_PDF: {
    id: "rc_display_gross_sales",
    name: t("Gross Sales"),
    formats_available: ["pdf"],
    enabled_for: ["report_event_breakdown", "product_breakdown_report"],
    column_type: "financial",
  },
  COLUMN_DISCOUNTS_PDF: {
    id: "rc_discounts",
    name: t("Discounts"),
    formats_available: ["pdf"],
    enabled_for: ["report_event_breakdown", "product_breakdown_report"],
    column_type: "financial",
  },
  COLUMN_REFUNDS_PDF: {
    id: "rc_refunds",
    name: t("Refunds"),
    formats_available: ["pdf"],
    enabled_for: ["report_event_breakdown", "product_breakdown_report"],
    column_type: "financial",
  },
  COLUMN_DISPUTES_PDF: {
    id: "rc_disputes",
    name: t("Chargebacks"),
    formats_available: ["pdf"],
    enabled_for: ["report_event_breakdown", "product_breakdown_report"],
    column_type: "financial",
  },
  COLUMN_NET_SALES_PDF: {
    id: "rc_gross_sales",
    name: t("Net Sales"),
    formats_available: ["pdf"],
    enabled_for: ["report_event_breakdown", "product_breakdown_report"],
    column_type: "financial",
  },
  COLUMN_SERVICE_FEES_SUB_CUSTOM_FEES_PDF: {
    id: "rc_amount_company_earned_sub_custom_fees",
    name: t("Service Fees"),
    formats_available: ["pdf"],
    enabled_for: ["report_event_breakdown", "product_breakdown_report"],
    column_type: "financial",
  },
  COLUMN_SHOWPASS_FEES_SUB_CUSTOM_FEES_PDF: {
    id: "rc_company_charges_sub_custom_fees",
    name: t("Showpass Fees"),
    formats_available: ["pdf"],
    enabled_for: ["report_event_breakdown", "product_breakdown_report"],
    column_type: "financial",
  },
  COLUMN_PROCESSING_FEES_PDF: {
    id: "rc_cc_charges",
    name: t("Processing Fees"),
    formats_available: ["pdf"],
    enabled_for: ["report_event_breakdown", "product_breakdown_report"],
    column_type: "financial",
  },
  COLUMN_DISCOVERY_FEES_PDF: {
    id: "rc_discovery_charges",
    name: t("Discovery Fees"),
    formats_available: ["pdf"],
    enabled_for: ["report_event_breakdown", "product_breakdown_report"],
    column_type: "financial",
  },
  COLUMN_RESALE_FEES_PDF: {
    id: "rc_resale_charges",
    name: t("Resale Fees"),
    formats_available: ["pdf"],
    enabled_for: ["report_event_breakdown", "product_breakdown_report"],
    column_type: "financial",
  },
  COLUMN_INVOICE_FEE_TOTAL_PDF: {
    id: "rc_invoice_fee_total",
    name: t("Invoices"),
    formats_available: ["pdf"],
    enabled_for: ["report_event_breakdown", "product_breakdown_report"],
    column_type: "financial",
  },
  COLUMN_ACCOUNT_CREDIT_APPLIED_PDF: {
    id: "rc_account_credit_applied",
    name: t("Account Credits Applied"),
    formats_available: ["pdf"],
    enabled_for: ["report_event_breakdown", "product_breakdown_report"],
    column_type: "financial",
  },
  COLUMN_EXCHANGE_CREDIT_APPLIED_PDF: {
    id: "rc_exchange_credit_applied",
    name: t("Exchange Credits"),
    formats_available: ["pdf"],
    enabled_for: ["report_event_breakdown", "product_breakdown_report"],
    column_type: "financial",
  },
  COLUMN_VENUE_CREDIT_APPLIED_PDF: {
    id: "rc_venue_credit_applied",
    name: t("Organizer Credits"),
    formats_available: ["pdf"],
    enabled_for: ["report_event_breakdown", "product_breakdown_report"],
    column_type: "financial",
  },
  COLUMN_USER_CREDIT_APPLIED_PDF: {
    id: "rc_user_credit_applied",
    name: t("Universal Credits"),
    formats_available: ["pdf"],
    enabled_for: ["report_event_breakdown", "product_breakdown_report"],
    column_type: "financial",
  },
  COLUMN_REFERRAL_CREDIT_APPLIED_PDF: {
    id: "rc_referral_credit_applied",
    name: t("Referral Credits"),
    formats_available: ["pdf"],
    enabled_for: ["report_event_breakdown", "product_breakdown_report"],
    column_type: "financial",
  },
  COLUMN_EXCHANGED_OUT_PDF: {
    id: "rc_exchanged_out",
    name: t("Exchanged Out"),
    formats_available: ["pdf"],
    enabled_for: ["report_event_breakdown", "product_breakdown_report"],
    column_type: "financial",
  },
  COLUMN_ACCOUNT_CREDIT_REFUNDS_PDF: {
    id: "rc_account_credit_refunds",
    name: t("Account Credit Refunds"),
    formats_available: ["pdf"],
    enabled_for: ["report_event_breakdown", "product_breakdown_report"],
    column_type: "financial",
  },
  COLUMN_DISPLAY_GROSS_REVENUE_PDF: {
    id: "rc_display_gross_revenue",
    name: t("Gross Revenue"),
    formats_available: ["pdf"],
    enabled_for: ["report_event_breakdown", "product_breakdown_report"],
    column_type: "financial",
  },
  COLUMN_ORGANIZER_FEES_PDF: {
    id: "rc_display_organizer_charges",
    name: t("Total Organizer Fees"),
    formats_available: ["pdf"],
    enabled_for: ["report_event_breakdown", "product_breakdown_report"],
    column_type: "financial",
  },
  COLUMN_TOTAL_TAXES_PDF: {
    id: "rc_tax",
    name: t("Total Organizer Taxes"),
    formats_available: ["pdf"],
    enabled_for: ["report_event_breakdown", "product_breakdown_report"],
    column_type: "financial",
  },
  COLUMN_SHIPPING_COSTS_PDF: {
    id: "rc_shipping_costs",
    name: t("Shipping Costs"),
    formats_available: ["pdf"],
    enabled_for: ["report_event_breakdown", "product_breakdown_report"],
    column_type: "financial",
  },
  COLUMN_CREDIT_MEMO_TOTAL_PDF: {
    id: "rc_credit_memo_total",
    name: t("Credit Memos"),
    formats_available: ["pdf"],
    enabled_for: ["report_event_breakdown", "product_breakdown_report"],
    column_type: "financial",
  },
  COLUMN_DISPLAY_NET_REVENUE_PDF: {
    id: "rc_display_net_revenue",
    name: t("Net Revenue"),
    formats_available: ["pdf"],
    enabled_for: ["report_event_breakdown", "product_breakdown_report"],
    column_type: "financial",
  },
  COLUMN_CARD_ORGANIZER_FEES_PDF: {
    id: "rc_card_organizer_charges",
    name: t("Organizer Fees"),
    formats_available: ["pdf"],
    enabled_for: ["report_event_breakdown", "product_breakdown_report"],
    column_type: "financial",
  },
  COLUMN_CARD_TAXES_PDF: {
    id: "rc_card_tax",
    name: t("Total Taxes"),
    formats_available: ["pdf"],
    enabled_for: ["report_event_breakdown", "product_breakdown_report"],
    column_type: "financial",
  },
  COLUMN_CARD_SHIPPING_COSTS_PDF: {
    id: "rc_card_shipping_costs",
    name: t("Shipping Costs"),
    formats_available: ["pdf"],
    enabled_for: ["report_event_breakdown", "product_breakdown_report"],
    column_type: "financial",
  },
  COLUMN_OTHER_SALES_ADJUSTMENT_PDF: {
    id: "rc_other_settlement_difference",
    name: t("Other Payment Adjustment"),
    formats_available: ["pdf"],
    enabled_for: ["report_event_breakdown", "product_breakdown_report"],
    column_type: "financial",
  },
  COLUMN_CASH_SALES_ADJUSTMENT_PDF: {
    id: "rc_cash_settlement_difference",
    name: t("Cash Payment Adjustment"),
    formats_available: ["pdf"],
    enabled_for: ["report_event_breakdown", "product_breakdown_report"],
    column_type: "financial",
  },
  COLUMN_CUSTOM_PROCESSOR_SALES_ADJUSTMENT_PDF: {
    id: "rc_custom_processor_adjustment",
    name: t("Custom Processor Adjustment"),
    formats_available: ["pdf"],
    enabled_for: ["report_event_breakdown", "product_breakdown_report"],
    column_type: "financial",
  },
  COLUMN_SQUARE_OAUTH_ADJUSTMENT_PDF: {
    id: "rc_square_oauth_adjustment",
    name: t("Square OAuth Adjustment"),
    formats_available: ["pdf"],
    enabled_for: ["report_event_breakdown", "product_breakdown_report"],
    column_type: "financial",
  },
  COLUMN_ADVANCES_PDF: {
    id: "rc_advances",
    name: t("Advances"),
    formats_available: ["pdf"],
    enabled_for: ["report_event_breakdown", "product_breakdown_report"],
    column_type: "financial",
  },
  COLUMN_SETTLEMENTS_PDF: {
    id: "rc_settlements",
    name: t("Settlements"),
    formats_available: ["pdf"],
    enabled_for: ["report_event_breakdown", "product_breakdown_report"],
    column_type: "financial",
  },
  COLUMN_NON_VENUE_CREDIT_PDF: {
    id: "rc_non_venue_credit_applied",
    name: t("Account Credit Adjustment"),
    formats_available: ["pdf"],
    enabled_for: ["report_event_breakdown", "product_breakdown_report"],
    column_type: "financial",
  },
  COLUMN_SETTLEMENT_AMOUNT_PDF: {
    id: "rc_amount_paid",
    name: t("Settlement Amount"),
    formats_available: ["pdf"],
    enabled_for: ["report_event_breakdown", "product_breakdown_report"],
    column_type: "financial",
  },
  COLUMN_REFUNDS_CSV: {
    id: "rc_refunds",
    name: t("Refunds"),
    formats_available: ["csv"],
    enabled_for: [
      "report_invoice_transaction",
      "report_will_call_financial",
      "settlement_report",
      "advance_report",
      "report_password_used_breakdown",
      "report_discount_usage_stats",
      "report_event_breakdown",
      "report_ticket_type_breakdown",
      "product_breakdown_report",
      "report_marketing_campaign_details",
    ],
    column_type: "financial",
  },
  COLUMN_DISCOUNTS_CSV: {
    id: "rc_discounts",
    name: t("Discounts"),
    formats_available: ["csv"],
    enabled_for: [
      "report_invoice_transaction",
      "report_will_call_financial",
      "settlement_report",
      "advance_report",
      "report_password_used_breakdown",
      "report_discount_usage_stats",
      "report_event_breakdown",
      "report_ticket_type_breakdown",
      "product_breakdown_report",
      "report_marketing_campaign_details",
    ],
    column_type: "financial",
  },
  COLUMN_SERVICE_FEES_CSV: {
    id: "rc_amount_company_earned",
    name: t("Service Fees"),
    formats_available: ["csv"],
    enabled_for: [
      "report_invoice_transaction",
      "report_will_call_financial",
      "settlement_report",
      "advance_report",
      "report_password_used_breakdown",
      "report_discount_usage_stats",
      "report_event_breakdown",
      "report_ticket_type_breakdown",
      "product_breakdown_report",
      "report_marketing_campaign_details",
    ],
    column_type: "financial",
  },
  COLUMN_PRE_TAX_SHOWPASS_FEES_CSV: {
    id: "rc_pre_tax_company_charges",
    name: t("Pre-Tax Showpass Fees"),
    formats_available: ["csv"],
    enabled_for: [
      "report_invoice_transaction",
      "report_will_call_financial",
      "settlement_report",
      "advance_report",
      "report_password_used_breakdown",
      "report_discount_usage_stats",
      "report_event_breakdown",
      "report_ticket_type_breakdown",
      "product_breakdown_report",
      "report_marketing_campaign_details",
    ],
    column_type: "financial",
  },
  COLUMN_SHOWPASS_FEES_TAX_CSV: {
    id: "rc_company_charges_tax",
    name: t("Showpass Fees Tax"),
    formats_available: ["csv"],
    enabled_for: [
      "report_invoice_transaction",
      "report_will_call_financial",
      "settlement_report",
      "advance_report",
      "report_password_used_breakdown",
      "report_discount_usage_stats",
      "report_event_breakdown",
      "report_ticket_type_breakdown",
      "product_breakdown_report",
      "report_marketing_campaign_details",
    ],
    column_type: "financial",
  },
  COLUMN_SHOWPASS_FEES_CSV: {
    id: "rc_company_charges",
    name: t("Showpass Fees"),
    formats_available: ["csv"],
    enabled_for: [
      "report_invoice_transaction",
      "report_will_call_financial",
      "settlement_report",
      "advance_report",
      "report_password_used_breakdown",
      "report_discount_usage_stats",
      "report_event_breakdown",
      "report_ticket_type_breakdown",
      "product_breakdown_report",
      "report_marketing_campaign_details",
    ],
    column_type: "financial",
  },
  COLUMN_PRE_TAX_PROCESSING_FEES_CSV: {
    id: "rc_pre_tax_processing_fees",
    name: t("Pre-Tax Processing Fees"),
    formats_available: ["csv"],
    enabled_for: [
      "report_invoice_transaction",
      "report_will_call_financial",
      "settlement_report",
      "advance_report",
      "report_password_used_breakdown",
      "report_discount_usage_stats",
      "report_event_breakdown",
      "report_ticket_type_breakdown",
      "product_breakdown_report",
      "report_marketing_campaign_details",
    ],
    column_type: "financial",
  },
  COLUMN_PROCESSING_FEES_TAX_CSV: {
    id: "rc_processing_fees_tax",
    name: t("Processing Fees Tax"),
    formats_available: ["csv"],
    enabled_for: [
      "report_invoice_transaction",
      "report_will_call_financial",
      "settlement_report",
      "advance_report",
      "report_password_used_breakdown",
      "report_discount_usage_stats",
      "report_event_breakdown",
      "report_ticket_type_breakdown",
      "product_breakdown_report",
      "report_marketing_campaign_details",
    ],
    column_type: "financial",
  },
  COLUMN_PROCESSING_FEES_CSV: {
    id: "rc_cc_charges",
    name: t("Processing Fees"),
    formats_available: ["csv"],
    enabled_for: [
      "report_invoice_transaction",
      "report_will_call_financial",
      "settlement_report",
      "advance_report",
      "report_password_used_breakdown",
      "report_discount_usage_stats",
      "report_event_breakdown",
      "report_ticket_type_breakdown",
      "product_breakdown_report",
      "report_marketing_campaign_details",
    ],
    column_type: "financial",
  },
  COLUMN_PRE_TAX_DISCOVERY_FEES_CSV: {
    id: "rc_pre_tax_discovery_charges",
    name: t("Pre-Tax Discovery Fees"),
    formats_available: ["csv"],
    enabled_for: [
      "report_invoice_transaction",
      "report_will_call_financial",
      "settlement_report",
      "advance_report",
      "report_password_used_breakdown",
      "report_discount_usage_stats",
      "report_event_breakdown",
      "report_ticket_type_breakdown",
      "product_breakdown_report",
      "report_marketing_campaign_details",
    ],
    column_type: "financial",
  },
  COLUMN_DISCOVERY_FEES_TAX_CSV: {
    id: "rc_discovery_charges_tax",
    name: t("Discovery Fees Tax"),
    formats_available: ["csv"],
    enabled_for: [
      "report_invoice_transaction",
      "report_will_call_financial",
      "settlement_report",
      "advance_report",
      "report_password_used_breakdown",
      "report_discount_usage_stats",
      "report_event_breakdown",
      "report_ticket_type_breakdown",
      "product_breakdown_report",
      "report_marketing_campaign_details",
    ],
    column_type: "financial",
  },
  COLUMN_DISCOVERY_FEES_CSV: {
    id: "rc_discovery_charges",
    name: t("Discovery Fees"),
    formats_available: ["csv"],
    enabled_for: [
      "report_invoice_transaction",
      "report_will_call_financial",
      "settlement_report",
      "advance_report",
      "report_password_used_breakdown",
      "report_discount_usage_stats",
      "report_event_breakdown",
      "report_ticket_type_breakdown",
      "product_breakdown_report",
      "report_marketing_campaign_details",
    ],
    column_type: "financial",
  },
  COLUMN_PRE_TAX_RESALE_FEES_CSV: {
    id: "rc_pre_tax_resale_charges",
    name: t("Pre-Tax Resale Fees"),
    formats_available: ["csv"],
    enabled_for: [
      "report_invoice_transaction",
      "report_will_call_financial",
      "settlement_report",
      "advance_report",
      "report_password_used_breakdown",
      "report_discount_usage_stats",
      "report_event_breakdown",
      "report_ticket_type_breakdown",
      "product_breakdown_report",
      "report_marketing_campaign_details",
    ],
    column_type: "financial",
  },
  COLUMN_RESALE_FEES_TAX_CSV: {
    id: "rc_resale_charges_tax",
    name: t("Resale Fees Tax"),
    formats_available: ["csv"],
    enabled_for: [
      "report_invoice_transaction",
      "report_will_call_financial",
      "settlement_report",
      "advance_report",
      "report_password_used_breakdown",
      "report_discount_usage_stats",
      "report_event_breakdown",
      "report_ticket_type_breakdown",
      "product_breakdown_report",
      "report_marketing_campaign_details",
    ],
    column_type: "financial",
  },
  COLUMN_RESALE_FEES_CSV: {
    id: "rc_resale_charges",
    name: t("Resale Fees"),
    formats_available: ["csv"],
    enabled_for: [
      "report_invoice_transaction",
      "report_will_call_financial",
      "settlement_report",
      "advance_report",
      "report_password_used_breakdown",
      "report_discount_usage_stats",
      "report_event_breakdown",
      "report_ticket_type_breakdown",
      "product_breakdown_report",
      "report_marketing_campaign_details",
    ],
    column_type: "financial",
  },
  COLUMN_ORGANIZER_FEES_CSV: {
    id: "rc_display_organizer_charges",
    name: t("Total Organizer Fees"),
    formats_available: ["csv"],
    enabled_for: [
      "report_invoice_transaction",
      "report_will_call_financial",
      "settlement_report",
      "advance_report",
      "report_password_used_breakdown",
      "report_discount_usage_stats",
      "report_event_breakdown",
      "report_ticket_type_breakdown",
      "product_breakdown_report",
      "report_marketing_campaign_details",
    ],
    column_type: "financial",
  },
  COLUMN_ORGANIZER_ITEM_TAX_CSV: {
    id: "rc_organizer_item_tax",
    name: t("Item Taxes"),
    formats_available: ["csv"],
    enabled_for: [
      "report_invoice_transaction",
      "report_will_call_financial",
      "settlement_report",
      "advance_report",
      "report_password_used_breakdown",
      "report_discount_usage_stats",
      "report_event_breakdown",
      "report_ticket_type_breakdown",
      "product_breakdown_report",
      "report_marketing_campaign_details",
    ],
    column_type: "financial",
  },
  COLUMN_ORGANIZER_FEE_TAX_CSV: {
    id: "rc_organizer_fee_tax",
    name: t("Organizer Fee Taxes"),
    formats_available: ["csv"],
    enabled_for: [
      "report_invoice_transaction",
      "report_will_call_financial",
      "settlement_report",
      "advance_report",
      "report_password_used_breakdown",
      "report_discount_usage_stats",
      "report_event_breakdown",
      "report_ticket_type_breakdown",
      "product_breakdown_report",
      "report_marketing_campaign_details",
    ],
    column_type: "financial",
  },
  COLUMN_TOTAL_TAXES_CSV: {
    id: "rc_tax",
    name: t("Total Organizer Taxes"),
    formats_available: ["csv"],
    enabled_for: [
      "report_invoice_transaction",
      "report_will_call_financial",
      "settlement_report",
      "advance_report",
      "report_password_used_breakdown",
      "report_discount_usage_stats",
      "report_event_breakdown",
      "report_ticket_type_breakdown",
      "product_breakdown_report",
      "report_marketing_campaign_details",
    ],
    column_type: "financial",
  },
  COLUMN_DISPLAY_GROSS_SALES_CSV: {
    id: "rc_display_gross_sales",
    name: t("Gross Sales"),
    formats_available: ["csv"],
    enabled_for: [
      "report_will_call_financial",
      "settlement_report",
      "advance_report",
      "report_password_used_breakdown",
      "report_discount_usage_stats",
      "report_event_breakdown",
      "report_ticket_type_breakdown",
      "product_breakdown_report",
      "report_marketing_campaign_details",
    ],
    column_type: "financial",
  },
  COLUMN_NET_SALES_CSV: {
    id: "rc_gross_sales",
    name: t("Net Sales"),
    formats_available: ["csv"],
    enabled_for: [
      "report_will_call_financial",
      "settlement_report",
      "advance_report",
      "report_password_used_breakdown",
      "report_discount_usage_stats",
      "report_event_breakdown",
      "report_ticket_type_breakdown",
      "product_breakdown_report",
      "report_marketing_campaign_details",
    ],
    column_type: "financial",
  },
  COLUMN_ACCOUNT_CREDIT_APPLIED_CSV: {
    id: "rc_account_credit_applied",
    name: t("Account Credits Applied"),
    formats_available: ["csv"],
    enabled_for: [
      "report_will_call_financial",
      "settlement_report",
      "advance_report",
      "report_password_used_breakdown",
      "report_discount_usage_stats",
      "report_event_breakdown",
      "report_ticket_type_breakdown",
      "product_breakdown_report",
      "report_marketing_campaign_details",
    ],
    column_type: "financial",
  },
  COLUMN_ACCOUNT_CREDIT_REFUNDS_CSV: {
    id: "rc_account_credit_refunds",
    name: t("Account Credit Refunds"),
    formats_available: ["csv"],
    enabled_for: [
      "report_will_call_financial",
      "settlement_report",
      "advance_report",
      "report_password_used_breakdown",
      "report_discount_usage_stats",
      "report_event_breakdown",
      "report_ticket_type_breakdown",
      "product_breakdown_report",
      "report_marketing_campaign_details",
    ],
    column_type: "financial",
  },
  COLUMN_EXCHANGED_OUT_CSV: {
    id: "rc_exchanged_out",
    name: t("Exchanged Out"),
    formats_available: ["csv"],
    enabled_for: [
      "report_will_call_financial",
      "settlement_report",
      "advance_report",
      "report_password_used_breakdown",
      "report_discount_usage_stats",
      "report_event_breakdown",
      "report_ticket_type_breakdown",
      "product_breakdown_report",
      "report_marketing_campaign_details",
    ],
    column_type: "financial",
  },
  COLUMN_DISPLAY_GROSS_REVENUE_CSV: {
    id: "rc_display_gross_revenue",
    name: t("Gross Revenue"),
    formats_available: ["csv"],
    enabled_for: [
      "report_will_call_financial",
      "settlement_report",
      "advance_report",
      "report_password_used_breakdown",
      "report_discount_usage_stats",
      "report_event_breakdown",
      "report_ticket_type_breakdown",
      "product_breakdown_report",
      "report_marketing_campaign_details",
    ],
    column_type: "financial",
  },
  COLUMN_DISPLAY_NET_REVENUE_CSV: {
    id: "rc_display_net_revenue",
    name: t("Net Revenue"),
    formats_available: ["csv"],
    enabled_for: [
      "report_will_call_financial",
      "settlement_report",
      "advance_report",
      "report_password_used_breakdown",
      "report_discount_usage_stats",
      "report_event_breakdown",
      "report_ticket_type_breakdown",
      "product_breakdown_report",
      "report_marketing_campaign_details",
    ],
    column_type: "financial",
  },
  COLUMN_TOTAL_ADJUSTMENT_AMOUNT_CSV: {
    id: "rc_adjustment",
    name: t("Adjustments"),
    formats_available: ["csv"],
    enabled_for: [
      "report_will_call_financial",
      "settlement_report",
      "advance_report",
      "report_password_used_breakdown",
      "report_discount_usage_stats",
      "report_event_breakdown",
      "report_ticket_type_breakdown",
      "product_breakdown_report",
      "report_marketing_campaign_details",
    ],
    column_type: "financial",
  },
  COLUMN_SETTLEMENT_AMOUNT_CSV: {
    id: "rc_amount_paid",
    name: t("Settlement Amount"),
    formats_available: ["csv"],
    enabled_for: [
      "report_will_call_financial",
      "settlement_report",
      "advance_report",
      "report_password_used_breakdown",
      "report_discount_usage_stats",
      "report_event_breakdown",
      "report_ticket_type_breakdown",
      "product_breakdown_report",
      "report_marketing_campaign_details",
    ],
    column_type: "financial",
  },
} as const;

export const REPORT_COLUMN_MAP_BY_ID = {
  rc_ticket_history_ticket_code: {
    id: "rc_ticket_history_ticket_code",
    enabled_for: ["report_ticket_history"],
    name: t("Barcode String"),
    column_type: "ticket_history",
    formats_available: ["csv"],
  },
  rc_ticket_history_item_type: {
    id: "rc_ticket_history_item_type",
    enabled_for: ["report_ticket_history", "report_holds_stats"],
    name: t("Item Type"),
    column_type: "ticket_history",
    formats_available: ["csv"],
  },
  rc_ticket_history_ticket_name_on_ticket: {
    id: "rc_ticket_history_ticket_name_on_ticket",
    enabled_for: ["report_ticket_history"],
    name: t("Name On Ticket"),
    column_type: "ticket_history",
    formats_available: ["csv"],
  },
  rc_ticket_history_ticket_event_name: {
    id: "rc_ticket_history_ticket_event_name",
    enabled_for: [
      "report_ticket_history",
      "report_shipping_fulfillment",
      "report_will_call_financial",
      "report_holds_stats",
      "settlement_report",
      "advance_report",
      "report_marketing_campaign_details",
    ],
    name: t("Event Name"),
    column_type: "ticket_history",
    formats_available: ["csv"],
  },
  rc_ticket_history_event_id: {
    id: "rc_ticket_history_event_id",
    enabled_for: [
      "report_ticket_history",
      "report_shipping_fulfillment",
      "report_will_call_financial",
      "report_holds_stats",
      "settlement_report",
      "advance_report",
      "report_marketing_campaign_details",
    ],
    name: t("Event ID"),
    column_type: "ticket_history",
    formats_available: ["csv"],
  },
  rc_ticket_history_tt_description: {
    id: "rc_ticket_history_tt_description",
    enabled_for: ["report_ticket_history", "report_shipping_fulfillment"],
    name: t("Ticket Type Name"),
    column_type: "ticket_history",
    formats_available: ["csv"],
  },
  rc_ticket_history_ticket_id: {
    id: "rc_ticket_history_ticket_id",
    enabled_for: ["report_ticket_history", "report_shipping_fulfillment"],
    name: t("Ticket Type ID"),
    column_type: "ticket_history",
    formats_available: ["csv"],
  },
  rc_ticket_history_product_description: {
    id: "rc_ticket_history_product_description",
    enabled_for: [
      "report_ticket_history",
      "report_shipping_fulfillment",
      "report_holds_stats",
    ],
    name: t("Product Name"),
    column_type: "ticket_history",
    formats_available: ["csv"],
  },
  rc_ticket_history_product_id: {
    id: "rc_ticket_history_product_id",
    enabled_for: [
      "report_ticket_history",
      "report_shipping_fulfillment",
      "report_will_call_financial",
      "report_holds_stats",
      "settlement_report",
      "advance_report",
      "report_marketing_campaign_details",
    ],
    name: t("Product ID"),
    column_type: "ticket_history",
    formats_available: ["csv"],
  },
  rc_ticket_history_product_attribute_name: {
    id: "rc_ticket_history_product_attribute_name",
    enabled_for: [
      "report_ticket_history",
      "report_shipping_fulfillment",
      "report_holds_stats",
    ],
    name: t("Product Attribute Name"),
    column_type: "ticket_history",
    formats_available: ["csv"],
  },
  rc_ticket_history_product_attribute_id: {
    id: "rc_ticket_history_product_attribute_id",
    enabled_for: [
      "report_ticket_history",
      "report_shipping_fulfillment",
      "report_will_call_financial",
      "report_holds_stats",
      "settlement_report",
      "advance_report",
      "report_marketing_campaign_details",
    ],
    name: t("Product Attribute ID"),
    column_type: "ticket_history",
    formats_available: ["csv"],
  },
  rc_ticket_history_created: {
    id: "rc_ticket_history_created",
    enabled_for: ["report_ticket_history"],
    name: t("Created On"),
    column_type: "ticket_history",
    formats_available: ["csv"],
  },
  rc_ticket_history_user_action: {
    id: "rc_ticket_history_user_action",
    enabled_for: ["report_ticket_history"],
    name: t("Action"),
    column_type: "ticket_history",
    formats_available: ["csv"],
  },
  rc_ticket_history_before_status: {
    id: "rc_ticket_history_before_status",
    enabled_for: ["report_ticket_history"],
    name: t("Status Before"),
    column_type: "ticket_history",
    formats_available: ["csv"],
  },
  rc_ticket_history_after_status: {
    id: "rc_ticket_history_after_status",
    enabled_for: ["report_ticket_history"],
    name: t("Status After"),
    column_type: "ticket_history",
    formats_available: ["csv"],
  },
  rc_ticket_history_created_by: {
    id: "rc_ticket_history_created_by",
    enabled_for: ["report_ticket_history"],
    name: t("Created By"),
    column_type: "ticket_history",
    formats_available: ["csv"],
  },
  picked_up: {
    id: "picked_up",
    enabled_for: ["report_event_product_inventory"],
    name: t("Picked Up"),
    column_type: "ticket_history",
    formats_available: ["csv"],
  },
  rc_discount_allowed_checkouts: {
    enabled_for: ["report_discount_creation"],
    id: "rc_discount_allowed_checkouts",
    name: t("Allowed Checkouts"),
    column_type: "discount",
    formats_available: ["csv"],
  },
  rc_discount_amount: {
    enabled_for: [
      "report_discount_creation",
      "report_will_call_financial",
      "settlement_report",
      "advance_report",
      "report_marketing_campaign_details",
    ],
    id: "rc_discount_amount",
    name: t("Discount Code Amount"),
    column_type: "discount",
    formats_available: ["csv"],
  },
  rc_rule_discount_percentage: {
    enabled_for: [
      "report_will_call_financial",
      "settlement_report",
      "advance_report",
      "report_marketing_campaign_details",
    ],
    id: "rc_rule_discount_percentage",
    name: t("Discount Rule Percentage"),
    column_type: "discount",
    formats_available: ["csv"],
  },
  rc_discount_rule_amount: {
    enabled_for: [
      "report_will_call_financial",
      "settlement_report",
      "advance_report",
      "report_marketing_campaign_details",
    ],
    id: "rc_discount_rule_amount",
    name: t("Discount Rule Amount"),
    column_type: "discount",
    formats_available: ["csv"],
  },
  rc_discount_limit: {
    enabled_for: ["report_discount_creation"],
    id: "rc_discount_limit",
    name: t("Total Limit"),
    column_type: "discount",
    formats_available: ["csv"],
  },
  rc_discount_maximum_quantity: {
    enabled_for: ["report_discount_creation"],
    id: "rc_discount_maximum_quantity",
    name: t("Maximum Quantity For Tiered Discounts"),
    column_type: "discount",
    formats_available: ["csv"],
  },
  rc_discount_minimum_quantity: {
    enabled_for: ["report_discount_creation"],
    id: "rc_discount_minimum_quantity",
    name: t("Minimum Quantity for tiered discounts"),
    column_type: "discount",
    formats_available: ["csv"],
  },
  rc_discount_rule_percentages: {
    enabled_for: ["report_discount_creation"],
    id: "rc_discount_rule_percentages",
    name: t("Discount Rule Percentages"),
    column_type: "discount",
    formats_available: ["csv"],
  },
  rc_discount_rule_amounts: {
    enabled_for: ["report_discount_creation"],
    id: "rc_discount_rule_amounts",
    name: t("Discount Rule Amounts"),
    column_type: "discount",
    formats_available: ["csv"],
  },
  rc_discount_percentage: {
    enabled_for: [
      "report_discount_creation",
      "report_will_call_financial",
      "settlement_report",
      "advance_report",
      "report_marketing_campaign_details",
    ],
    id: "rc_discount_percentage",
    name: t("Discount Code Percentage"),
    column_type: "discount",
    formats_available: ["csv"],
  },
  rc_discount_permission_type: {
    enabled_for: ["report_discount_creation"],
    id: "rc_discount_permission_type",
    name: t("Discount Ticket Type/Event Permissions"),
    column_type: "discount",
    formats_available: ["csv"],
  },
  rc_discount_per_user_limit: {
    enabled_for: ["report_discount_creation"],
    id: "rc_discount_per_user_limit",
    name: t("Usage Limit Per User"),
    column_type: "discount",
    formats_available: ["csv"],
  },
  rc_discount_type: {
    enabled_for: [
      "report_discount_creation",
      "report_will_call_financial",
      "settlement_report",
      "advance_report",
      "report_marketing_campaign_details",
    ],
    id: "rc_discount_type",
    name: t("Discount Type"),
    column_type: "discount",
    formats_available: ["csv"],
  },
  rc_discount_created_by: {
    enabled_for: ["report_discount_creation"],
    id: "rc_discount_created_by",
    name: t("Discount Created By"),
    column_type: "discount",
    formats_available: ["csv"],
  },
  rc_discount_created_on: {
    enabled_for: ["report_discount_creation"],
    id: "rc_discount_created_on",
    name: t("Discount Created On"),
    column_type: "discount",
    formats_available: ["csv"],
  },
  rc_discount_description: {
    id: "rc_discount_description",
    enabled_for: ["report_discount_usage_stats", "report_discount_creation"],
    name: t("Discount Description"),
    column_type: "discount",
    formats_available: ["csv"],
  },
  rc_discount_purchase_platform: {
    id: "rc_discount_purchase_platform",
    enabled_for: ["report_discount_usage_stats"],
    name: t("Purchase Platform"),
    column_type: "discount",
    formats_available: ["csv"],
  },
  rc_discounts_used: {
    id: "rc_discounts_used",
    enabled_for: ["report_discount_usage_stats"],
    name: t("Quantity Discount Used"),
    column_type: "discount",
    formats_available: ["csv"],
  },
  rc_discount_ticket_quantity: {
    id: "rc_discount_ticket_quantity",
    enabled_for: ["report_discount_usage_stats"],
    name: t("Ticket Quantity"),
    column_type: "discount",
    formats_available: ["csv"],
  },
  rc_username: {
    id: "rc_username",
    enabled_for: [
      "report_invoice_transaction",
      "report_venue_user",
      "report_seller_stats",
      "report_surveys",
      "report_will_call_financial",
      "settlement_report",
      "advance_report",
      "report_holds_stats",
      "report_donor_transaction",
      "report_marketing_campaign_details",
    ],
    name: t("Customer Name"),
    column_type: "customer",
    formats_available: ["csv"],
  },
  rc_email: {
    id: "rc_email",
    name: t("Customer Email"),
    enabled_for: [
      "report_invoice_transaction",
      "report_venue_user",
      "report_will_call",
      "report_seller_stats",
      "report_surveys",
      "report_shipping_fulfillment",
      "report_event_product_inventory",
      "report_will_call_financial",
      "settlement_report",
      "advance_report",
      "report_holds_stats",
      "waitlist_subscriber_report",
      "reseller_submissions_report",
      "report_donor_transaction",
      "report_marketing_campaign_details",
    ],
    column_type: "customer",
    formats_available: ["csv"],
  },
  rc_phone: {
    id: "rc_phone",
    name: t("Customer Phone Number"),
    enabled_for: [
      "report_invoice_transaction",
      "report_venue_user",
      "report_will_call",
      "report_holds_stats",
      "report_seller_stats",
      "report_shipping_fulfillment",
      "report_will_call_financial",
      "report_donor_transaction",
      "settlement_report",
      "advance_report",
      "report_marketing_campaign_details",
    ],
    column_type: "customer",
    formats_available: ["csv"],
  },
  rc_birthday: {
    id: "rc_birthday",
    name: t("Birthday"),
    enabled_for: ["report_venue_user"],
    column_type: "customer",
    formats_available: ["csv"],
  },
  rc_gender: {
    id: "rc_gender",
    name: t("Gender"),
    enabled_for: ["report_venue_user"],
    column_type: "customer",
    formats_available: ["csv"],
  },
  rc_is_seller: {
    id: "rc_is_seller",
    name: t("Seller Status"),
    enabled_for: ["report_venue_user"],
    column_type: "customer",
    formats_available: ["csv"],
  },
  rc_is_employee: {
    id: "rc_is_employee",
    name: t("Employee Status"),
    enabled_for: ["report_venue_user"],
    column_type: "customer",
    formats_available: ["csv"],
  },
  rc_is_subscribed: {
    id: "rc_is_subscribed",
    name: t("Subscribed to Email"),
    enabled_for: [
      "report_venue_user",
      "report_will_call_financial",
      "settlement_report",
      "advance_report",
      "report_marketing_campaign_details",
    ],
    column_type: "customer",
    formats_available: ["csv"],
  },
  rc_allow_mail_contact: {
    id: "rc_allow_mail_contact",
    name: t("Allowed to Mail"),
    enabled_for: ["report_venue_user"],
    column_type: "customer",
    formats_available: ["csv"],
  },
  rc_allow_phone_contact: {
    id: "rc_allow_phone_contact",
    name: t("Allowed to Phone"),
    enabled_for: ["report_venue_user"],
    column_type: "customer",
    formats_available: ["csv"],
  },
  rc_num_customer_reservations: {
    id: "rc_num_customer_reservations",
    name: t("Number Of Customer Reservations Booked"),
    enabled_for: ["report_venue_user"],
    column_type: "customer",
    formats_available: ["csv"],
  },
  rc_num_checked_in_as_customer: {
    id: "rc_num_checked_in_as_customer",
    name: t("Number Of Times Customer Checked In"),
    enabled_for: ["report_venue_user"],
    column_type: "customer",
    formats_available: ["csv"],
  },
  rc_num_reservations_booked: {
    id: "rc_num_reservations_booked",
    name: t("Number Of Staff Reservations Booked"),
    enabled_for: ["report_venue_user"],
    column_type: "customer",
    formats_available: ["csv"],
  },
  rc_num_checked_in_as_employee: {
    id: "rc_num_checked_in_as_employee",
    name: t("Number Of Staff Check Ins"),
    enabled_for: ["report_venue_user"],
    column_type: "customer",
    formats_available: ["csv"],
  },
  rc_num_tickets_purchased: {
    id: "rc_num_tickets_purchased",
    name: t("Tickets Purchased"),
    enabled_for: ["report_venue_user"],
    column_type: "customer",
    formats_available: ["csv"],
  },
  rc_num_tickets_sold: {
    id: "rc_num_tickets_sold",
    name: t("Tickets Sold"),
    enabled_for: [
      "report_venue_user",
      "report_surveys",
      "report_password_used_breakdown",
      "report_seller_stats",
    ],
    column_type: "customer",
    formats_available: ["csv"],
  },
  rc_num_items_sold: {
    id: "rc_num_items_sold",
    name: t("Items Sold"),
    enabled_for: ["report_marketing_campaigns"],
    column_type: "customer",
    formats_available: ["csv"],
  },
  rc_external_tickets_quantity: {
    id: "rc_external_tickets_quantity",
    name: t("Tickets Purchased"),
    enabled_for: ["report_venue_user"],
    column_type: "customer",
    formats_available: ["csv"],
  },
  rc_external_tickets_spend: {
    id: "rc_external_tickets_spend",
    name: t("External Ticket Spend"),
    enabled_for: ["report_venue_user"],
    column_type: "customer",
    formats_available: ["csv"],
  },
  rc_external_donations: {
    id: "rc_external_donations",
    name: t("External Donations"),
    enabled_for: ["report_venue_user"],
    column_type: "customer",
    formats_available: ["csv"],
  },
  rc_sub_tickets_generated_from_package: {
    id: "rc_sub_tickets_generated_from_package",
    name: t("Sub Tickets Generated From Package"),
    enabled_for: ["report_event_breakdown", "report_ticket_type_breakdown"],
    column_type: "customer",
    formats_available: ["csv"],
  },
  rc_name_on_ticket: {
    id: "rc_name_on_ticket",
    name: t("Name On Ticket"),
    enabled_for: [
      "report_invoice_transaction",
      "report_will_call",
      "report_surveys",
      "report_shipping_fulfillment",
      "report_event_product_inventory",
    ],
    column_type: "customer",
    formats_available: ["csv"],
  },
  rc_venueuser_shipping_name: {
    id: "rc_venueuser_shipping_name",
    name: t("Shipping Name"),
    enabled_for: ["report_venue_user"],
    column_type: "customer",
    formats_available: ["csv"],
  },
  rc_invoice_item_description: {
    id: "rc_invoice_item_description",
    name: t("Description"),
    enabled_for: [
      "report_will_call_financial",
      "settlement_report",
      "advance_report",
      "report_marketing_campaign_details",
    ],
    column_type: "financial",
    formats_available: ["csv"],
  },
  rc_charge_id: {
    id: "rc_charge_id",
    name: t("Charge ID"),
    enabled_for: [
      "report_will_call_financial",
      "settlement_report",
      "advance_report",
      "report_marketing_campaign_details",
    ],
    column_type: "financial",
    formats_available: ["csv"],
  },
  rc_invoice_type_name: {
    id: "rc_invoice_type_name",
    name: t("Item Type"),
    enabled_for: [
      "report_will_call_financial",
      "settlement_report",
      "advance_report",
      "report_marketing_campaign_details",
    ],
    column_type: "financial",
    formats_available: ["csv"],
  },
  rc_invoice_category_name: {
    id: "rc_invoice_category_name",
    name: t("Item Category"),
    enabled_for: [
      "report_will_call_financial",
      "settlement_report",
      "advance_report",
      "report_marketing_campaign_details",
    ],
    column_type: "financial",
    formats_available: ["csv"],
  },
  rc_revenue_tickets_purchased: {
    id: "rc_revenue_tickets_purchased",
    name: t("Revenue From Customer Purchases"),
    enabled_for: ["report_venue_user"],
    column_type: "financial",
    formats_available: ["csv"],
  },
  rc_revenue_tickets_sold: {
    id: "rc_revenue_tickets_sold",
    name: t("Revenue From Tickets Sold"),
    enabled_for: ["report_venue_user"],
    column_type: "financial",
    formats_available: ["csv"],
  },
  rc_invoice_type: {
    id: "rc_invoice_type",
    name: t("Invoice Type"),
    enabled_for: ["report_invoice_transaction"],
    column_type: "financial",
    formats_available: ["csv"],
  },
  rc_transaction_id: {
    id: "rc_transaction_id",
    name: t("Transaction ID"),
    enabled_for: [
      "report_invoice_transaction",
      "report_surveys",
      "report_shipping_fulfillment",
      "report_will_call_financial",
      "settlement_report",
      "advance_report",
      "report_marketing_campaign_details",
    ],
    column_type: "financial",
    formats_available: ["csv"],
  },
  rc_transaction_date: {
    id: "rc_transaction_date",
    name: t("Transaction Date"),
    enabled_for: [
      "report_will_call_financial",
      "settlement_report",
      "advance_report",
      "gift_card_recipients_report",
      "report_marketing_campaign_details",
    ],
    column_type: "financial",
    formats_available: ["csv"],
  },
  rc_sale_transaction_id: {
    id: "rc_sale_transaction_id",
    name: t("Sale Transaction ID"),
    enabled_for: [
      "report_will_call_financial",
      "settlement_report",
      "advance_report",
      "report_marketing_campaign_details",
    ],
    column_type: "financial",
    formats_available: ["csv"],
  },
  rc_settlement_date: {
    id: "rc_settlement_date",
    name: t("Settlement Date"),
    enabled_for: [
      "report_will_call_financial",
      "settlement_report",
      "advance_report",
      "report_marketing_campaign_details",
    ],
    column_type: "financial",
    formats_available: ["csv"],
  },
  rc_advance_date: {
    id: "rc_advance_date",
    name: t("Advance Date"),
    enabled_for: [
      "report_will_call_financial",
      "settlement_report",
      "advance_report",
      "report_marketing_campaign_details",
    ],
    column_type: "financial",
    formats_available: ["csv"],
  },
  rc_ticket_type_price: {
    id: "rc_ticket_type_price",
    name: t("Ticket Type Price"),
    enabled_for: [
      "report_will_call_financial",
      "settlement_report",
      "advance_report",
      "report_marketing_campaign_details",
      "report_ticket_type_breakdown",
    ],
    column_type: "financial",
    formats_available: ["csv"],
  },
  rc_final_amount: {
    id: "rc_final_amount",
    name: t("Total Sales"),
    enabled_for: [
      "report_invoice_transaction",
      "report_seller_stats",
      "report_surveys",
      "report_event_product_inventory",
      "report_marketing_campaigns",
    ],
    column_type: "financial",
    formats_available: ["csv"],
  },
  rc_amount_earned: {
    id: "rc_amount_earned",
    name: t("Revenue"),
    enabled_for: ["report_invoice_transaction", "report_seller_stats"],
    column_type: "financial",
    formats_available: ["csv"],
  },
  rc_tax: {
    id: "rc_tax",
    name: t("Total Organizer Taxes"),
    formats_available: ["csv"],
    enabled_for: [
      "report_invoice_transaction",
      "report_will_call_financial",
      "settlement_report",
      "advance_report",
      "report_password_used_breakdown",
      "report_discount_usage_stats",
      "report_event_breakdown",
      "report_ticket_type_breakdown",
      "product_breakdown_report",
      "report_marketing_campaign_details",
    ],
    column_type: "financial",
  },
  rc_refunds: {
    id: "rc_refunds",
    name: t("Refunds"),
    formats_available: ["csv"],
    enabled_for: [
      "report_invoice_transaction",
      "report_will_call_financial",
      "settlement_report",
      "advance_report",
      "report_password_used_breakdown",
      "report_discount_usage_stats",
      "report_event_breakdown",
      "report_ticket_type_breakdown",
      "product_breakdown_report",
      "report_marketing_campaign_details",
    ],
    column_type: "financial",
  },
  rc_discounts: {
    id: "rc_discounts",
    name: t("Discounts"),
    formats_available: ["csv"],
    enabled_for: [
      "report_invoice_transaction",
      "report_will_call_financial",
      "settlement_report",
      "advance_report",
      "report_password_used_breakdown",
      "report_discount_usage_stats",
      "report_event_breakdown",
      "report_ticket_type_breakdown",
      "product_breakdown_report",
      "report_marketing_campaign_details",
    ],
    column_type: "financial",
  },
  rc_gross_sales: {
    id: "rc_gross_sales",
    name: t("Net Sales"),
    formats_available: ["csv"],
    enabled_for: [
      "report_will_call_financial",
      "settlement_report",
      "advance_report",
      "report_password_used_breakdown",
      "report_discount_usage_stats",
      "report_event_breakdown",
      "report_ticket_type_breakdown",
      "product_breakdown_report",
      "report_marketing_campaign_details",
    ],
    column_type: "financial",
  },
  rc_amount_company_earned: {
    id: "rc_amount_company_earned",
    name: t("Service Fees"),
    formats_available: ["csv"],
    enabled_for: [
      "report_invoice_transaction",
      "report_will_call_financial",
      "settlement_report",
      "advance_report",
      "report_password_used_breakdown",
      "report_discount_usage_stats",
      "report_event_breakdown",
      "report_ticket_type_breakdown",
      "product_breakdown_report",
      "report_marketing_campaign_details",
    ],
    column_type: "financial",
  },
  rc_display_gross_revenue: {
    id: "rc_display_gross_revenue",
    name: t("Gross Revenue"),
    formats_available: ["csv"],
    enabled_for: [
      "report_will_call_financial",
      "settlement_report",
      "advance_report",
      "report_password_used_breakdown",
      "report_discount_usage_stats",
      "report_event_breakdown",
      "report_ticket_type_breakdown",
      "product_breakdown_report",
      "report_marketing_campaign_details",
    ],
    column_type: "financial",
  },
  rc_display_net_revenue: {
    id: "rc_display_net_revenue",
    name: t("Net Revenue"),
    formats_available: ["csv"],
    enabled_for: [
      "report_will_call_financial",
      "settlement_report",
      "advance_report",
      "report_password_used_breakdown",
      "report_discount_usage_stats",
      "report_event_breakdown",
      "report_ticket_type_breakdown",
      "product_breakdown_report",
      "report_marketing_campaign_details",
    ],
    column_type: "financial",
  },
  rc_credit_type: {
    id: "rc_credit_type",
    name: t("Account Credit Type"),
    enabled_for: [
      "report_will_call_financial",
      "settlement_report",
      "advance_report",
      "report_marketing_campaign_details",
    ],
    column_type: "financial",
    formats_available: ["csv"],
  },
  rc_purchase_source_platform: {
    id: "rc_purchase_source_platform",
    name: t("Purchase Source Platform"),
    enabled_for: [
      "report_will_call_financial",
      "settlement_report",
      "advance_report",
      "report_marketing_campaign_details",
    ],
    column_type: "financial",
    formats_available: ["csv"],
  },
  rc_purchase_note: {
    id: "rc_purchase_note",
    name: t("Purchase Note"),
    enabled_for: [
      "report_will_call_financial",
      "settlement_report",
      "advance_report",
      "report_marketing_campaign_details",
    ],
    column_type: "financial",
    formats_available: ["csv"],
  },
  rc_other_custom_type: {
    id: "rc_other_custom_type",
    name: t("Other Custom Purchase Type"),
    enabled_for: ["report_invoice_transaction"],
    column_type: "financial",
    formats_available: ["csv"],
  },
  rc_other_payment_type: {
    id: "rc_other_payment_type",
    name: t("Other Payment Type"),
    enabled_for: [
      "report_will_call_financial",
      "settlement_report",
      "advance_report",
      "report_marketing_campaign_details",
    ],
    column_type: "financial",
    formats_available: ["csv"],
  },
  rc_quantity: {
    id: "rc_quantity",
    name: t("Quantity"),
    enabled_for: [
      "report_will_call",
      "report_event_product_inventory",
      "report_holds_stats",
      "waitlist_subscriber_report",
      "reseller_submissions_report",
      "gift_card_recipients_report",
      "member_seating_report",
    ],
    column_type: "financial",
    formats_available: ["csv"],
  },
  rc_transaction_quantity: {
    id: "rc_transaction_quantity",
    name: t("Transaction Quantity"),
    enabled_for: [
      "report_will_call_financial",
      "settlement_report",
      "advance_report",
      "report_marketing_campaign_details",
    ],
    column_type: "financial",
    formats_available: ["csv"],
  },
  rc_item_quantity: {
    id: "rc_item_quantity",
    name: t("Item Quantity"),
    enabled_for: [
      "report_will_call_financial",
      "settlement_report",
      "advance_report",
      "report_marketing_campaign_details",
    ],
    column_type: "financial",
    formats_available: ["csv"],
  },
  rc_transfer_quantity: {
    id: "rc_transfer_quantity",
    name: t("Transfer Quantity"),
    enabled_for: [
      "report_will_call_financial",
      "settlement_report",
      "advance_report",
      "report_marketing_campaign_details",
    ],
    column_type: "financial",
    formats_available: ["csv"],
  },
  rc_scanned_quantity: {
    id: "rc_scanned_quantity",
    name: t("Scanned Quantity"),
    enabled_for: [
      "report_will_call_financial",
      "settlement_report",
      "advance_report",
      "report_marketing_campaign_details",
    ],
    column_type: "financial",
    formats_available: ["csv"],
  },
  rc_scan_limit: {
    id: "rc_scan_limit",
    name: t("Scan Limit"),
    enabled_for: [
      "report_will_call_financial",
      "settlement_report",
      "advance_report",
      "report_marketing_campaign_details",
    ],
    column_type: "financial",
    formats_available: ["csv"],
  },
  rc_organizer_charges: {
    id: "rc_organizer_charges",
    name: t("Organizer Charges"),
    enabled_for: [
      "report_invoice_transaction",
      "report_seller_stats",
      "report_event_product_inventory",
      "report_marketing_campaigns",
    ],
    column_type: "financial",
    formats_available: ["csv"],
  },
  rc_card_organizer_charges: {
    id: "rc_card_organizer_charges",
    name: t("Organizer Fees"),
    formats_available: ["pdf"],
    enabled_for: ["report_event_breakdown", "product_breakdown_report"],
    column_type: "financial",
  },
  rc_cash_organizer_charges: {
    id: "rc_cash_organizer_charges",
    name: t("Cash Organizer Charges"),
    enabled_for: [
      "report_invoice_transaction",
      "report_event_breakdown",
      "product_breakdown_report",
      "report_ticket_type_breakdown",
      "report_seller_stats",
    ],
    column_type: "financial",
    formats_available: ["csv"],
  },
  rc_other_organizer_charges: {
    id: "rc_other_organizer_charges",
    name: t("Other Organizer Charges"),
    enabled_for: [
      "report_invoice_transaction",
      "report_event_breakdown",
      "product_breakdown_report",
      "report_ticket_type_breakdown",
      "report_seller_stats",
    ],
    column_type: "financial",
    formats_available: ["csv"],
  },
  rc_refund_type: {
    id: "rc_refund_type",
    name: t("Refund Type"),
    enabled_for: [
      "report_will_call_financial",
      "settlement_report",
      "advance_report",
      "report_marketing_campaign_details",
    ],
    column_type: "financial",
    formats_available: ["csv"],
  },
  rc_refund_reason: {
    id: "rc_refund_reason",
    name: t("Refund Reason"),
    enabled_for: [
      "report_will_call_financial",
      "settlement_report",
      "advance_report",
      "report_marketing_campaign_details",
    ],
    column_type: "financial",
    formats_available: ["csv"],
  },
  rc_commissions: {
    id: "rc_commissions",
    name: t("Commissions"),
    enabled_for: [
      "report_invoice_transaction",
      "report_event_breakdown",
      "product_breakdown_report",
      "report_ticket_type_breakdown",
      "report_will_call_financial",
      "settlement_report",
      "advance_report",
      "report_marketing_campaign_details",
    ],
    column_type: "financial",
    formats_available: ["csv"],
  },
  rc_cash_commissions: {
    id: "rc_cash_commissions",
    name: t("Cash Commission"),
    enabled_for: ["report_seller_stats"],
    column_type: "financial",
    formats_available: ["csv"],
  },
  rc_credit_commissions: {
    id: "rc_credit_commissions",
    name: t("Credit Commission"),
    enabled_for: ["report_seller_stats"],
    column_type: "financial",
    formats_available: ["csv"],
  },
  rc_shipping_costs: {
    id: "rc_shipping_costs",
    name: t("Shipping Costs"),
    formats_available: ["pdf"],
    enabled_for: ["report_event_breakdown", "product_breakdown_report"],
    column_type: "financial",
  },
  rc_items_total_amount: {
    id: "rc_items_total_amount",
    name: t("Face Value"),
    enabled_for: ["report_invoice_transaction"],
    column_type: "financial",
    formats_available: ["csv"],
  },
  rc_payment_type: {
    id: "rc_payment_type",
    name: t("Payment Method"),
    enabled_for: [
      "report_invoice_transaction",
      "report_will_call_financial",
      "settlement_report",
      "advance_report",
      "report_marketing_campaign_details",
    ],
    column_type: "financial",
    formats_available: ["csv"],
  },
  rc_card_type: {
    id: "rc_card_type",
    name: t("Card Type"),
    enabled_for: [
      "report_invoice_transaction",
      "report_will_call_financial",
      "settlement_report",
      "advance_report",
      "report_marketing_campaign_details",
    ],
    column_type: "financial",
    formats_available: ["csv"],
  },
  rc_cash_revenue: {
    id: "rc_cash_revenue",
    name: t("Cash Revenue"),
    enabled_for: [
      "report_event_breakdown",
      "product_breakdown_report",
      "report_ticket_type_breakdown",
      "report_seller_stats",
    ],
    column_type: "financial",
    formats_available: ["csv"],
  },
  rc_credit_revenue: {
    id: "rc_credit_revenue",
    name: t("Credit Revenue"),
    enabled_for: [
      "report_event_breakdown",
      "product_breakdown_report",
      "report_ticket_type_breakdown",
      "report_seller_stats",
    ],
    column_type: "financial",
    formats_available: ["csv"],
  },
  rc_event: {
    id: "rc_event",
    name: t("Event"),
    enabled_for: [
      "report_will_call",
      "report_event_breakdown",
      "report_ticket_type_breakdown",
      "report_event_product_inventory",
      "report_password_used_breakdown",
      "waitlist_subscriber_report",
      "reseller_submissions_report",
      "report_donor_transaction",
    ],
    column_type: "tickets",
    formats_available: ["csv"],
  },
  rc_event_starts_on: {
    id: "rc_event_starts_on",
    name: t("Event Start Time"),
    enabled_for: [
      "report_will_call",
      "report_event_breakdown",
      "report_ticket_type_breakdown",
      "report_event_product_inventory",
      "report_will_call_financial",
      "settlement_report",
      "advance_report",
      "report_shipping_fulfillment",
      "report_holds_stats",
      "waitlist_subscriber_report",
      "reseller_submissions_report",
      "report_donor_transaction",
      "report_marketing_campaign_details",
    ],
    column_type: "tickets",
    formats_available: ["csv"],
  },
  rc_event_ends_on: {
    id: "rc_event_ends_on",
    name: t("Event End Time"),
    enabled_for: [
      "report_will_call",
      "report_event_breakdown",
      "report_ticket_type_breakdown",
      "report_will_call_financial",
      "settlement_report",
      "advance_report",
      "report_holds_stats",
      "report_marketing_campaign_details",
    ],
    column_type: "tickets",
    formats_available: ["csv"],
  },
  rc_ticket_type: {
    id: "rc_ticket_type",
    name: t("Ticket Type Name"),
    enabled_for: [
      "report_will_call",
      "report_will_call_financial",
      "report_ticket_type_breakdown",
      "settlement_report",
      "advance_report",
      "report_holds_stats",
      "report_event_product_inventory",
      "waitlist_subscriber_report",
      "reseller_submissions_report",
      "report_marketing_campaign_details",
    ],
    column_type: "tickets",
    formats_available: ["csv"],
  },
  rc_ticket_type_id: {
    id: "rc_ticket_type_id",
    name: t("Ticket Type ID"),
    enabled_for: [
      "report_will_call_financial",
      "settlement_report",
      "advance_report",
      "report_holds_stats",
      "report_marketing_campaign_details",
    ],
    column_type: "tickets",
    formats_available: ["csv"],
  },
  rc_event_location: {
    id: "rc_event_location",
    name: t("Event Location"),
    enabled_for: ["report_event_breakdown", "report_ticket_type_breakdown"],
    column_type: "tickets",
    formats_available: ["csv"],
  },
  rc_event_location_name: {
    id: "rc_event_location_name",
    name: t("Event Location Name"),
    enabled_for: [
      "report_will_call_financial",
      "settlement_report",
      "advance_report",
      "report_marketing_campaign_details",
    ],
    column_type: "tickets",
    formats_available: ["csv"],
  },
  rc_event_location_postal_address: {
    id: "rc_event_location_postal_address",
    name: t("Event Location Postal/Zip Code"),
    enabled_for: [
      "report_will_call_financial",
      "settlement_report",
      "advance_report",
      "report_marketing_campaign_details",
    ],
    column_type: "tickets",
    formats_available: ["csv"],
  },
  rc_event_location_city_address: {
    id: "rc_event_location_city_address",
    name: t("Event Location City"),
    enabled_for: [
      "report_will_call_financial",
      "settlement_report",
      "advance_report",
      "report_marketing_campaign_details",
    ],
    column_type: "other",
    formats_available: ["csv"],
  },
  rc_event_location_street_name: {
    id: "rc_event_location_street_name",
    name: t("Event Location Street"),
    enabled_for: [
      "report_will_call_financial",
      "settlement_report",
      "advance_report",
      "report_marketing_campaign_details",
    ],
    column_type: "other",
    formats_available: ["csv"],
  },
  rc_event_location_province_address: {
    id: "rc_event_location_province_address",
    name: t("Event Location Province/State"),
    enabled_for: [
      "report_will_call_financial",
      "settlement_report",
      "advance_report",
      "report_marketing_campaign_details",
    ],
    column_type: "other",
    formats_available: ["csv"],
  },
  rc_event_location_country_address: {
    id: "rc_event_location_country_address",
    name: t("Event Location Country"),
    enabled_for: [
      "report_will_call_financial",
      "settlement_report",
      "advance_report",
      "report_marketing_campaign_details",
    ],
    column_type: "other",
    formats_available: ["csv"],
  },
  rc_ticket_status: {
    id: "rc_ticket_status",
    name: t("Ticket Status"),
    enabled_for: ["report_will_call"],
    column_type: "tickets",
    formats_available: ["csv"],
  },
  rc_ticket_barcode: {
    id: "rc_ticket_barcode",
    name: t("Barcode String"),
    enabled_for: ["report_will_call"],
    column_type: "tickets",
    formats_available: ["csv"],
  },
  rc_ticket_scan_code: {
    id: "rc_ticket_scan_code",
    name: t("Ticket Scan Code"),
    enabled_for: ["report_will_call", "report_shipping_fulfillment"],
    column_type: "tickets",
    formats_available: ["csv"],
  },
  rc_seating_section: {
    id: "rc_seating_section",
    name: t("Seat Section"),
    enabled_for: [
      "report_will_call",
      "report_holds_stats",
      "member_seating_report",
    ],
    column_type: "tickets",
    formats_available: ["csv"],
  },
  rc_password_used: {
    id: "rc_password_used",
    name: t("Password Used"),
    enabled_for: [
      "report_will_call",
      "report_will_call_financial",
      "settlement_report",
      "advance_report",
      "report_marketing_campaign_details",
    ],
    column_type: "tickets",
    formats_available: ["csv"],
  },
  rc_seating_row: {
    id: "rc_seating_row",
    name: t("Row/Area"),
    enabled_for: [
      "report_will_call",
      "report_holds_stats",
      "member_seating_report",
    ],
    column_type: "tickets",
    formats_available: ["csv"],
  },
  rc_seating_seat: {
    id: "rc_seating_seat",
    name: t("Seat"),
    enabled_for: [
      "report_will_call",
      "report_holds_stats",
      "member_seating_report",
    ],
    column_type: "tickets",
    formats_available: ["csv"],
  },
  rc_basket_uuid: {
    id: "rc_basket_uuid",
    name: t("Basket UUID"),
    enabled_for: ["report_holds_stats"],
    column_type: "tickets",
    formats_available: ["csv"],
  },
  rc_ticket_description: {
    id: "rc_ticket_description",
    name: t("Ticket Description"),
    enabled_for: ["report_will_call"],
    column_type: "tickets",
    formats_available: ["csv"],
  },
  rc_last_status_change: {
    id: "rc_last_status_change",
    name: t("Last Ticket Status Change Time"),
    enabled_for: ["report_will_call"],
    column_type: "tickets",
    formats_available: ["csv"],
  },
  rc_last_status_changed_by: {
    id: "rc_last_status_changed_by",
    name: t("Last Ticket Status Changed By"),
    enabled_for: ["report_will_call"],
    column_type: "tickets",
    formats_available: ["csv"],
  },
  rc_num_tickets_sold_cash: {
    id: "rc_num_tickets_sold_cash",
    name: t("Num Cash Tickets Sold"),
    enabled_for: [
      "report_event_breakdown",
      "product_breakdown_report",
      "report_ticket_type_breakdown",
      "report_seller_stats",
    ],
    column_type: "tickets",
    formats_available: ["csv"],
  },
  rc_num_tickets_sold_credit: {
    id: "rc_num_tickets_sold_credit",
    name: t("Num Credit Tickets Sold"),
    enabled_for: [
      "report_event_breakdown",
      "product_breakdown_report",
      "report_ticket_type_breakdown",
      "report_seller_stats",
    ],
    column_type: "tickets",
    formats_available: ["csv"],
  },
  rc_num_tickets_sold_affirm: {
    id: "rc_num_tickets_sold_affirm",
    name: t("Num Affirm Tickets Sold"),
    enabled_for: [
      "report_event_breakdown",
      "product_breakdown_report",
      "report_ticket_type_breakdown",
      "report_seller_stats",
    ],
    column_type: "tickets",
    formats_available: ["csv"],
  },
  rc_num_tickets_sold_comp: {
    id: "rc_num_tickets_sold_comp",
    name: t("Num Comp Tickets Sold"),
    enabled_for: [
      "report_event_breakdown",
      "product_breakdown_report",
      "report_ticket_type_breakdown",
      "report_seller_stats",
    ],
    column_type: "tickets",
    formats_available: ["csv"],
  },
  rc_num_tickets_sold_free: {
    id: "rc_num_tickets_sold_free",
    name: t("Num Free Tickets Sold"),
    enabled_for: [
      "report_event_breakdown",
      "product_breakdown_report",
      "report_ticket_type_breakdown",
      "report_seller_stats",
    ],
    column_type: "tickets",
    formats_available: ["csv"],
  },
  rc_num_tickets_refunded: {
    id: "rc_num_tickets_refunded",
    name: t("Num Tickets Refunded"),
    enabled_for: ["report_ticket_type_breakdown"],
    column_type: "tickets",
    formats_available: ["csv"],
  },
  rc_is_child: {
    id: "rc_is_child",
    name: t("Child Ticket"),
    enabled_for: ["report_shipping_fulfillment"],
    column_type: "tickets",
    formats_available: ["csv"],
  },
  rc_is_sub_ticket: {
    id: "rc_is_sub_ticket",
    name: t("Is Sub Ticket"),
    enabled_for: [
      "report_will_call_financial",
      "settlement_report",
      "advance_report",
      "report_marketing_campaign_details",
    ],
    column_type: "tickets",
    formats_available: ["csv"],
  },
  rc_member_first_name: {
    id: "rc_member_first_name",
    name: t("Member First Name"),
    enabled_for: ["member_report"],
    column_type: "membership",
    formats_available: ["csv"],
  },
  rc_member_last_name: {
    id: "rc_member_last_name",
    name: t("Member Last Name"),
    enabled_for: ["member_report"],
    column_type: "membership",
    formats_available: ["csv"],
  },
  rc_member_name: {
    id: "rc_member_name",
    name: t("Member Name"),
    enabled_for: [
      "report_will_call_financial",
      "settlement_report",
      "advance_report",
      "member_report",
      "member_history_report",
      "member_seating_report",
      "report_marketing_campaign_details",
    ],
    column_type: "membership",
    formats_available: ["csv"],
  },
  rc_member_email: {
    id: "rc_member_email",
    name: t("Member Email"),
    enabled_for: [
      "report_will_call_financial",
      "settlement_report",
      "advance_report",
      "member_report",
      "member_history_report",
      "member_seating_report",
      "report_marketing_campaign_details",
    ],
    column_type: "membership",
    formats_available: ["csv"],
  },
  rc_member_phone: {
    id: "rc_member_phone",
    name: t("Member Phone"),
    enabled_for: [
      "member_report",
      "member_history_report",
      "member_seating_report",
    ],
    column_type: "membership",
    formats_available: ["csv"],
  },
  rc_member_status: {
    id: "rc_member_status",
    name: t("Member Status"),
    enabled_for: ["member_report", "member_seating_report"],
    column_type: "membership",
    formats_available: ["csv"],
  },
  rc_member_seating_reserved: {
    id: "rc_member_seating_reserved",
    name: t("Seating Reserved"),
    enabled_for: ["member_seating_report"],
    column_type: "membership",
    formats_available: ["csv"],
  },
  rc_member_quantity: {
    id: "rc_member_quantity",
    name: t("Member Quantity"),
    enabled_for: ["member_report"],
    column_type: "membership",
    formats_available: ["csv"],
  },
  rc_member_expiry_date: {
    id: "rc_member_expiry_date",
    name: t("Member Expiry Date"),
    enabled_for: ["member_report"],
    column_type: "membership",
    formats_available: ["csv"],
  },
  rc_member_barcode: {
    id: "rc_member_barcode",
    name: t("Member Barcode"),
    enabled_for: ["member_report", "member_history_report"],
    column_type: "membership",
    formats_available: ["csv"],
  },
  rc_member_universal_code: {
    id: "rc_member_universal_code",
    name: t("Member Universal Code"),
    enabled_for: ["member_report"],
    column_type: "membership",
    formats_available: ["csv"],
  },
  rc_member_scans_allowed: {
    id: "rc_member_scans_allowed",
    name: t("Member Scans Allowed"),
    enabled_for: ["member_benefit_usage_report"],
    column_type: "membership",
    formats_available: ["csv"],
  },
  rc_member_scans_used: {
    id: "rc_member_scans_used",
    name: t("Member Scans Used"),
    enabled_for: ["member_report", "member_benefit_usage_report"],
    column_type: "membership",
    formats_available: ["csv"],
  },
  rc_member_history_amount: {
    id: "rc_member_history_amount",
    name: t("Amount"),
    enabled_for: ["member_history_report"],
    column_type: "membership",
    formats_available: ["csv"],
  },
  rc_member_discounts_allowed: {
    id: "rc_member_discounts_allowed",
    name: t("Member Discounts Allowed"),
    enabled_for: ["member_benefit_usage_report"],
    column_type: "membership",
    formats_available: ["csv"],
  },
  rc_member_discounts_used: {
    id: "rc_member_discounts_used",
    name: t("Member Discounts Used"),
    enabled_for: ["member_report", "member_benefit_usage_report"],
    column_type: "membership",
    formats_available: ["csv"],
  },
  rc_member_last_status_change: {
    id: "rc_member_last_status_change",
    name: t("Member Last Status Change"),
    enabled_for: ["member_report"],
    column_type: "membership",
    formats_available: ["csv"],
  },
  rc_member_last_status_changed_by: {
    id: "rc_member_last_status_changed_by",
    name: t("Member Last Status Changed By"),
    enabled_for: ["member_report"],
    column_type: "membership",
    formats_available: ["csv"],
  },
  rc_membership_group_name: {
    id: "rc_membership_group_name",
    name: t("Membership Group Name"),
    enabled_for: [
      "report_will_call_financial",
      "settlement_report",
      "advance_report",
      "member_report",
      "member_history_report",
      "member_benefit_usage_report",
      "report_shipping_fulfillment",
      "member_seating_report",
      "report_marketing_campaign_details",
      "report_holds_stats",
    ],
    column_type: "membership",
    formats_available: ["csv"],
  },
  rc_membership_group_id: {
    id: "rc_membership_group_id",
    name: t("Membership Group ID"),
    enabled_for: [
      "report_will_call_financial",
      "settlement_report",
      "advance_report",
      "report_shipping_fulfillment",
      "report_marketing_campaign_details",
      "report_holds_stats",
    ],
    column_type: "membership",
    formats_available: ["csv"],
  },
  rc_membership_level_name: {
    id: "rc_membership_level_name",
    name: t("Membership Level Name"),
    enabled_for: [
      "report_will_call_financial",
      "settlement_report",
      "advance_report",
      "member_report",
      "member_history_report",
      "member_benefit_usage_report",
      "report_shipping_fulfillment",
      "member_seating_report",
      "report_marketing_campaign_details",
      "report_holds_stats",
    ],
    column_type: "membership",
    formats_available: ["csv"],
  },
  rc_membership_level_id: {
    id: "rc_membership_level_id",
    name: t("Membership Level ID"),
    enabled_for: [
      "report_will_call_financial",
      "settlement_report",
      "advance_report",
      "report_shipping_fulfillment",
      "report_marketing_campaign_details",
      "report_holds_stats",
    ],
    column_type: "membership",
    formats_available: ["csv"],
  },
  rc_membership_level_price: {
    id: "rc_membership_level_price",
    name: t("Membership Level Price"),
    enabled_for: [
      "report_will_call_financial",
      "settlement_report",
      "advance_report",
      "report_marketing_campaign_details",
    ],
    column_type: "membership",
    formats_available: ["csv"],
  },
  rc_member_status_before: {
    id: "rc_member_status_before",
    name: t("Member Status Before"),
    enabled_for: ["member_history_report"],
    column_type: "membership",
    formats_available: ["csv"],
  },
  rc_member_status_after: {
    id: "rc_member_status_after",
    name: t("Member Status After"),
    enabled_for: ["member_history_report"],
    column_type: "membership",
    formats_available: ["csv"],
  },
  rc_member_history_action: {
    id: "rc_member_history_action",
    name: t("Member History Action"),
    enabled_for: ["member_history_report"],
    column_type: "membership",
    formats_available: ["csv"],
  },
  rc_member_history_type: {
    id: "rc_member_history_type",
    name: t("Member History Type"),
    enabled_for: ["member_history_report"],
    column_type: "membership",
    formats_available: ["csv"],
  },
  rc_membership_benefit: {
    id: "rc_membership_benefit",
    name: t("Membership Benefit"),
    enabled_for: ["member_history_report", "member_benefit_usage_report"],
    column_type: "membership",
    formats_available: ["csv"],
  },
  rc_membership_benefit_type: {
    id: "rc_membership_benefit_type",
    name: t("Membership Benefit Type"),
    enabled_for: ["member_benefit_usage_report"],
    column_type: "membership",
    formats_available: ["csv"],
  },
  rc_member_latest_season: {
    id: "rc_member_latest_season",
    name: t("Member Latest Season"),
    enabled_for: ["member_report"],
    column_type: "membership",
    formats_available: ["csv"],
  },
  rc_product_attribute: {
    id: "rc_product_attribute",
    name: t("Product Attribute Name"),
    enabled_for: [
      "report_will_call",
      "report_event_product_inventory",
      "report_will_call_financial",
      "settlement_report",
      "advance_report",
      "report_marketing_campaign_details",
    ],
    column_type: "products",
    formats_available: ["csv"],
  },
  rc_product_attribute_price: {
    id: "rc_product_attribute_price",
    name: t("Product Attribute Price"),
    enabled_for: [
      "report_will_call_financial",
      "settlement_report",
      "advance_report",
      "report_marketing_campaign_details",
    ],
    column_type: "products",
    formats_available: ["csv"],
  },
  rc_product: {
    id: "rc_product",
    name: t("Product Name"),
    enabled_for: [
      "report_will_call",
      "report_event_product_inventory",
      "report_will_call_financial",
      "settlement_report",
      "advance_report",
      "product_breakdown_report",
      "report_marketing_campaign_details",
    ],
    column_type: "products",
    formats_available: ["csv"],
  },
  rc_product_attribute_sku: {
    id: "rc_product_attribute_sku",
    name: t("SKU"),
    enabled_for: ["report_shipping_fulfillment"],
    column_type: "products",
    formats_available: ["csv"],
  },
  rc_purchaser_username: {
    id: "rc_purchaser_username",
    name: t("Purchaser Name"),
    enabled_for: ["gift_card_recipients_report"],
    column_type: "gift_cards",
    formats_available: ["csv"],
  },
  rc_purchaser_email: {
    id: "rc_purchaser_email",
    name: t("Purchaser Email"),
    enabled_for: ["gift_card_recipients_report"],
    column_type: "gift_cards",
    formats_available: ["csv"],
  },
  rc_purchaser_phone: {
    id: "rc_purchaser_phone",
    name: t("Purchaser Phone Number"),
    enabled_for: ["gift_card_recipients_report"],
    column_type: "gift_cards",
    formats_available: ["csv"],
  },
  rc_sender_username: {
    id: "rc_sender_username",
    name: t("Sender Name"),
    enabled_for: ["gift_card_recipients_report"],
    column_type: "gift_cards",
    formats_available: ["csv"],
  },
  rc_gift_card_redeemed: {
    id: "rc_gift_card_redeemed",
    name: t("Is Redeemed"),
    enabled_for: ["gift_card_recipients_report"],
    column_type: "gift_cards",
    formats_available: ["csv"],
  },
  rc_recipient_name: {
    id: "rc_recipient_name",
    name: t("Recipient Name"),
    enabled_for: ["gift_card_recipients_report"],
    column_type: "gift_cards",
    formats_available: ["csv"],
  },
  rc_recipient_email: {
    id: "rc_recipient_email",
    name: t("Recipient Email"),
    enabled_for: ["gift_card_recipients_report"],
    column_type: "gift_cards",
    formats_available: ["csv"],
  },
  rc_recipient_phone: {
    id: "rc_recipient_phone",
    name: t("Recipient Phone Number"),
    enabled_for: ["gift_card_recipients_report"],
    column_type: "gift_cards",
    formats_available: ["csv"],
  },
  rc_gift_card_id: {
    id: "rc_gift_card_id",
    name: t("Gift Card ID"),
    enabled_for: ["gift_card_recipients_report"],
    column_type: "gift_cards",
    formats_available: ["csv"],
  },
  rc_gift_card_name: {
    id: "rc_gift_card_name",
    name: t("Gift Card Name"),
    enabled_for: ["gift_card_recipients_report"],
    column_type: "gift_cards",
    formats_available: ["csv"],
  },
  rc_gift_card_denomination_id: {
    id: "rc_gift_card_denomination_id",
    name: t("Gift Card Denomination ID"),
    enabled_for: ["gift_card_recipients_report"],
    column_type: "gift_cards",
    formats_available: ["csv"],
  },
  rc_gift_card_denomination_price: {
    id: "rc_gift_card_denomination_price",
    name: t("Gift Card Denomination Price"),
    enabled_for: ["gift_card_recipients_report"],
    column_type: "gift_cards",
    formats_available: ["csv"],
  },
  rc_gift_card_amount_paid: {
    id: "rc_gift_card_amount_paid",
    name: t("Amount Paid"),
    enabled_for: ["gift_card_recipients_report"],
    column_type: "gift_cards",
    formats_available: ["csv"],
  },
  rc_total_gift_card_amount: {
    id: "rc_total_gift_card_amount",
    name: t("Total Amount"),
    enabled_for: ["gift_card_recipients_report"],
    column_type: "gift_cards",
    formats_available: ["csv"],
  },
  rc_amount_advanced: {
    id: "rc_amount_advanced",
    name: t("Amount Advanced"),
    enabled_for: ["gift_card_recipients_report"],
    column_type: "gift_cards",
    formats_available: ["csv"],
  },
  rc_amount_used: {
    id: "rc_amount_used",
    name: t("Amount Used"),
    enabled_for: ["gift_card_recipients_report"],
    column_type: "gift_cards",
    formats_available: ["csv"],
  },
  rc_amount_remaining: {
    id: "rc_amount_remaining",
    name: t("Amount Remaining"),
    enabled_for: ["gift_card_recipients_report"],
    column_type: "gift_cards",
    formats_available: ["csv"],
  },
  rc_price_tier_name: {
    id: "rc_price_tier_name",
    name: t("Price Tier Name"),
    enabled_for: [
      "report_will_call_financial",
      "settlement_report",
      "advance_report",
    ],
    column_type: "price_tiers",
    formats_available: ["csv"],
  },
  rc_price_tier_id: {
    id: "rc_price_tier_id",
    name: t("Price Tier ID"),
    enabled_for: [
      "report_will_call_financial",
      "settlement_report",
      "advance_report",
    ],
    column_type: "price_tiers",
    formats_available: ["csv"],
  },
  rc_price_tier_price: {
    id: "rc_price_tier_price",
    name: t("Price Tier Price"),
    enabled_for: [
      "report_will_call_financial",
      "settlement_report",
      "advance_report",
    ],
    column_type: "price_tiers",
    formats_available: ["csv"],
  },
  rc_venue_name: {
    id: "rc_venue_name",
    name: t("Venue Name"),
    enabled_for: [
      "report_will_call_financial",
      "settlement_report",
      "advance_report",
      "report_marketing_campaign_details",
    ],
    column_type: "other",
    formats_available: ["csv"],
  },
  rc_venue_id: {
    id: "rc_venue_id",
    name: t("Venue ID"),
    enabled_for: [
      "report_will_call_financial",
      "settlement_report",
      "advance_report",
      "report_marketing_campaign_details",
    ],
    column_type: "other",
    formats_available: ["csv"],
  },
  rc_created: {
    id: "rc_created",
    name: t("Purchase Date"),
    enabled_for: [
      "report_invoice_transaction",
      "report_will_call",
      "report_surveys",
      "report_shipping_fulfillment",
      "report_donor_transaction",
    ],
    column_type: "other",
    formats_available: ["csv"],
  },
  rc_updated: {
    id: "rc_updated",
    name: t("Last Updated"),
    enabled_for: ["report_holds_stats"],
    column_type: "other",
    formats_available: ["csv"],
  },
  rc_general_created: {
    id: "rc_general_created",
    name: t("Created"),
    enabled_for: ["member_history_report"],
    column_type: "other",
    formats_available: ["csv"],
  },
  rc_survey_name: {
    id: "rc_survey_name",
    name: t("Survey Name"),
    enabled_for: ["report_surveys"],
    column_type: "other",
    formats_available: ["csv"],
  },
  rc_sold_by: {
    id: "rc_sold_by",
    name: t("Sold By"),
    enabled_for: [
      "report_invoice_transaction",
      "report_will_call",
      "report_will_call_financial",
      "settlement_report",
      "advance_report",
      "report_holds_stats",
      "report_marketing_campaign_details",
    ],
    column_type: "other",
    formats_available: ["csv"],
  },
  rc_sold_by_venue: {
    id: "rc_sold_by_venue",
    name: t("Sold By Venue"),
    enabled_for: ["report_will_call"],
    column_type: "other",
    formats_available: ["csv"],
  },
  rc_referred_by: {
    id: "rc_referred_by",
    name: t("Referred By"),
    enabled_for: [
      "report_invoice_transaction",
      "report_will_call_financial",
      "settlement_report",
      "advance_report",
      "report_marketing_campaign_details",
    ],
    column_type: "other",
    formats_available: ["csv"],
  },
  rc_referred_link_description: {
    id: "rc_referred_link_description",
    name: t("Referral Link Description"),
    enabled_for: [
      "report_invoice_transaction",
      "report_will_call_financial",
      "settlement_report",
      "advance_report",
      "report_marketing_campaign_details",
    ],
    column_type: "other",
    formats_available: ["csv"],
  },
  rc_referred_link_URL: {
    id: "rc_referred_link_URL",
    name: t("Referral Link URL"),
    enabled_for: [
      "report_will_call_financial",
      "settlement_report",
      "advance_report",
      "report_marketing_campaign_details",
    ],
    column_type: "other",
    formats_available: ["csv"],
  },
  rc_custom_question_info: {
    id: "rc_custom_question_info",
    name: t("Custom Question Info"),
    enabled_for: ["report_will_call", "member_report"],
    column_type: "other",
    formats_available: ["csv"],
  },
  rc_postal_address: {
    id: "rc_postal_address",
    name: t("Billing Postal Code/Zip"),
    enabled_for: [
      "report_invoice_transaction",
      "report_will_call_financial",
      "settlement_report",
      "advance_report",
      "report_donor_transaction",
      "report_marketing_campaign_details",
    ],
    column_type: "other",
    formats_available: ["csv"],
  },
  rc_billing_address: {
    id: "rc_billing_address",
    name: t("Billing Address"),
    enabled_for: ["report_event_product_inventory"],
    column_type: "other",
    formats_available: ["csv"],
  },
  rc_city_address: {
    id: "rc_city_address",
    name: t("Billing City"),
    enabled_for: [
      "report_invoice_transaction",
      "report_will_call_financial",
      "settlement_report",
      "advance_report",
      "report_donor_transaction",
      "report_marketing_campaign_details",
    ],
    column_type: "other",
    formats_available: ["csv"],
  },
  rc_street_address: {
    id: "rc_street_address",
    name: t("Billing Street"),
    enabled_for: [
      "report_invoice_transaction",
      "report_will_call_financial",
      "settlement_report",
      "advance_report",
      "report_donor_transaction",
      "report_marketing_campaign_details",
    ],
    column_type: "other",
    formats_available: ["csv"],
  },
  rc_province_address: {
    id: "rc_province_address",
    name: t("Billing Province/State"),
    enabled_for: [
      "report_invoice_transaction",
      "report_will_call_financial",
      "settlement_report",
      "advance_report",
      "report_donor_transaction",
      "report_marketing_campaign_details",
    ],
    column_type: "other",
    formats_available: ["csv"],
  },
  rc_country_address: {
    id: "rc_country_address",
    name: t("Billing Country"),
    enabled_for: [
      "report_invoice_transaction",
      "report_will_call_financial",
      "settlement_report",
      "advance_report",
      "report_donor_transaction",
      "report_marketing_campaign_details",
    ],
    column_type: "other",
    formats_available: ["csv"],
  },
  rc_discount_code: {
    id: "rc_discount_code",
    name: t("Discount Code Used"),
    enabled_for: [
      "report_invoice_transaction",
      "report_discount_usage_stats",
      "report_discount_creation",
      "report_will_call_financial",
      "settlement_report",
      "advance_report",
      "report_marketing_campaign_details",
    ],
    column_type: "other",
    formats_available: ["csv"],
  },
  rc_internal_info: {
    id: "rc_internal_info",
    name: t("Info"),
    enabled_for: ["report_invoice_transaction"],
    column_type: "other",
    formats_available: ["csv"],
  },
  rc_shipping_fulfillment_status: {
    id: "rc_shipping_fulfillment_status",
    name: t("Fulfillment Status"),
    enabled_for: ["report_shipping_fulfillment"],
    column_type: "shipping",
    formats_available: ["csv"],
  },
  rc_fulfilled_by_employee: {
    id: "rc_fulfilled_by_employee",
    name: t("Fulfilled By Employee"),
    enabled_for: ["report_shipping_fulfillment"],
    column_type: "shipping",
    formats_available: ["csv"],
  },
  rc_shipping_fulfillment_date: {
    id: "rc_shipping_fulfillment_date",
    name: t("Fulfillment Date"),
    enabled_for: ["report_shipping_fulfillment"],
    column_type: "shipping",
    formats_available: ["csv"],
  },
  rc_ticket_amount_to_ship: {
    id: "rc_ticket_amount_to_ship",
    name: t("Quantity Per Order"),
    enabled_for: ["report_shipping_fulfillment"],
    column_type: "shipping",
    formats_available: ["csv"],
  },
  rc_shipping_method: {
    id: "rc_shipping_method",
    name: t("Delivery Method"),
    enabled_for: [
      "report_will_call_financial",
      "settlement_report",
      "advance_report",
      "report_marketing_campaign_details",
    ],
    column_type: "shipping",
    formats_available: ["csv"],
  },
  rc_shipping_street_address: {
    id: "rc_shipping_street_address",
    name: t("Shipping Street"),
    enabled_for: [
      "report_will_call_financial",
      "report_shipping_fulfillment",
      "report_venue_user",
      "settlement_report",
      "advance_report",
      "report_marketing_campaign_details",
    ],
    column_type: "other",
    formats_available: ["csv"],
  },
  rc_shipping_unit_number: {
    id: "rc_shipping_unit_number",
    name: t("Shipping Unit Number"),
    enabled_for: [
      "report_will_call_financial",
      "report_shipping_fulfillment",
      "report_venue_user",
      "settlement_report",
      "advance_report",
      "report_marketing_campaign_details",
    ],
    column_type: "other",
    formats_available: ["csv"],
  },
  rc_shipping_city_address: {
    id: "rc_shipping_city_address",
    name: t("Shipping City"),
    enabled_for: [
      "report_will_call_financial",
      "report_shipping_fulfillment",
      "report_venue_user",
      "settlement_report",
      "advance_report",
      "report_marketing_campaign_details",
    ],
    column_type: "other",
    formats_available: ["csv"],
  },
  rc_shipping_province_address: {
    id: "rc_shipping_province_address",
    name: t("Shipping Province/State"),
    enabled_for: [
      "report_will_call_financial",
      "report_shipping_fulfillment",
      "report_venue_user",
      "settlement_report",
      "advance_report",
      "report_marketing_campaign_details",
    ],
    column_type: "other",
    formats_available: ["csv"],
  },
  rc_shipping_country_address: {
    id: "rc_shipping_country_address",
    name: t("Shipping Country"),
    enabled_for: [
      "report_will_call_financial",
      "report_shipping_fulfillment",
      "report_venue_user",
      "settlement_report",
      "advance_report",
      "report_marketing_campaign_details",
    ],
    column_type: "other",
    formats_available: ["csv"],
  },
  rc_shipping_postal_address: {
    id: "rc_shipping_postal_address",
    name: t("Shipping Postal Code/Zip"),
    enabled_for: [
      "report_will_call_financial",
      "report_shipping_fulfillment",
      "report_venue_user",
      "settlement_report",
      "advance_report",
      "report_marketing_campaign_details",
    ],
    column_type: "other",
    formats_available: ["csv"],
  },
  rc_shipping_cost: {
    id: "rc_shipping_cost",
    name: t("Shipping & Handling Fees"),
    enabled_for: [
      "report_will_call_financial",
      "settlement_report",
      "advance_report",
      "report_marketing_campaign_details",
    ],
    column_type: "other",
    formats_available: ["csv"],
  },
  rc_company_charges: {
    id: "rc_company_charges",
    name: t("Showpass Fees"),
    formats_available: ["csv"],
    enabled_for: [
      "report_invoice_transaction",
      "report_will_call_financial",
      "settlement_report",
      "advance_report",
      "report_password_used_breakdown",
      "report_discount_usage_stats",
      "report_event_breakdown",
      "report_ticket_type_breakdown",
      "product_breakdown_report",
      "report_marketing_campaign_details",
    ],
    column_type: "financial",
  },
  rc_total_price: {
    id: "rc_total_price",
    name: t("Total Price"),
    enabled_for: ["waitlist_subscriber_report"],
    column_type: "tickets",
    formats_available: ["csv"],
  },
  rc_total_price_no_fees: {
    id: "rc_total_price_no_fees",
    name: t("Total Price No Fees"),
    enabled_for: ["waitlist_subscriber_report"],
    column_type: "tickets",
    formats_available: ["csv"],
  },
  rc_refund_amount: {
    id: "rc_refund_amount",
    name: t("Refund Amount"),
    enabled_for: ["reseller_submissions_report"],
    column_type: "tickets",
    formats_available: ["csv"],
  },
  rc_num_of_passwords_used: {
    id: "rc_num_of_passwords_used",
    name: t("Number Of Passwords Used"),
    enabled_for: ["report_password_used_breakdown"],
    column_type: "inventory",
    formats_available: ["csv"],
  },
  rc_num_of_standard_tickets_sold: {
    id: "rc_num_of_standard_tickets_sold",
    name: t("Standard Tickets Sold"),
    enabled_for: ["product_breakdown_report", "report_event_breakdown"],
    column_type: "inventory",
    formats_available: ["pdf"],
  },
  rc_num_of_tickets_sold_redeemable: {
    id: "rc_num_of_tickets_sold_redeemable",
    name: t("Quantity"),
    enabled_for: ["report_event_breakdown"],
    column_type: "inventory",
    formats_available: ["pdf"],
  },
  rc_num_of_redeemable_tickets: {
    id: "rc_num_of_redeemable_tickets",
    name: t("Total Redeemable Tickets"),
    enabled_for: [
      "report_event_breakdown",
      "product_breakdown_report",
      "report_ticket_type_breakdown",
    ],
    column_type: "inventory",
    formats_available: ["csv"],
  },
  rc_total_inventory: {
    id: "rc_total_inventory",
    name: t("Total Inventory"),
    enabled_for: [
      "report_event_breakdown",
      "product_breakdown_report",
      "report_ticket_type_breakdown",
    ],
    column_type: "inventory",
    formats_available: ["pdf", "csv"],
  },
  rc_num_of_total_packages: {
    id: "rc_num_of_total_packages",
    name: t("Total Packages"),
    enabled_for: ["report_event_breakdown", "report_ticket_type_breakdown"],
    column_type: "inventory",
    formats_available: ["pdf", "csv"],
  },
  rc_total_ticket_package_inventory: {
    id: "rc_total_ticket_package_inventory",
    name: t("Total Ticket Package Inventory"),
    enabled_for: ["report_event_breakdown"],
    column_type: "inventory",
    formats_available: ["pdf"],
  },
  rc_num_of_sub_tickets_from_event: {
    id: "rc_num_of_sub_tickets_from_event",
    name: t("Sub Tickets From Event"),
    enabled_for: ["report_event_breakdown"],
    column_type: "inventory",
    formats_available: ["pdf", "csv"],
  },
  rc_num_of_sub_tickets_from_outside_event: {
    id: "rc_num_of_sub_tickets_from_outside_event",
    name: t("Sub Tickets From Outside Event"),
    enabled_for: ["report_event_breakdown"],
    column_type: "inventory",
    formats_available: ["pdf", "csv"],
  },
  rc_num_of_tickets_not_included_in_stats: {
    id: "rc_num_of_tickets_not_included_in_stats",
    name: t("Tickets Not Included In Stats"),
    enabled_for: ["report_event_breakdown", "report_ticket_type_breakdown"],
    column_type: "inventory",
    formats_available: ["pdf", "csv"],
  },
  rc_num_of_hold_tickets: {
    id: "rc_num_of_hold_tickets",
    name: t("Tickets On Hold"),
    enabled_for: ["product_breakdown_report", "report_event_breakdown"],
    column_type: "inventory",
    formats_available: ["pdf"],
  },
  rc_hold_link: {
    id: "rc_hold_link",
    name: t("Hold Link"),
    enabled_for: ["report_holds_stats"],
    column_type: "tickets",
    formats_available: ["csv"],
  },
  rc_num_of_payment_plans_copy: {
    id: "rc_num_of_payment_plans_copy",
    name: t("Payment Plans Sold"),
    enabled_for: ["report_event_breakdown"],
    column_type: "inventory",
    formats_available: ["pdf"],
  },
  rc_utm_campaign: {
    id: "rc_utm_campaign",
    name: t("UTM Campaign"),
    enabled_for: [
      "report_marketing_campaigns",
      "report_marketing_campaign_details",
    ],
    column_type: "marketing_campaigns",
    formats_available: ["csv"],
  },
  rc_utm_source: {
    id: "rc_utm_source",
    name: t("UTM Source"),
    enabled_for: [
      "report_marketing_campaigns",
      "report_marketing_campaign_details",
    ],
    column_type: "marketing_campaigns",
    formats_available: ["csv"],
  },
  rc_utm_medium: {
    id: "rc_utm_medium",
    name: t("UTM Medium"),
    enabled_for: [
      "report_marketing_campaigns",
      "report_marketing_campaign_details",
    ],
    column_type: "marketing_campaigns",
    formats_available: ["csv"],
  },
  rc_views: {
    id: "rc_views",
    name: t("Page Views"),
    enabled_for: ["report_marketing_campaigns"],
    column_type: "marketing_campaigns",
    formats_available: ["csv"],
  },
  rc_add_to_cart: {
    id: "rc_add_to_cart",
    name: t("Add To Cart Events"),
    enabled_for: ["report_marketing_campaigns"],
    column_type: "marketing_campaigns",
    formats_available: ["csv"],
  },
  rc_add_to_cart_rate: {
    id: "rc_add_to_cart_rate",
    name: t("Add To Cart Rate"),
    enabled_for: ["report_marketing_campaigns"],
    column_type: "marketing_campaigns",
    formats_available: ["csv"],
  },
  rc_initiate_checkout: {
    id: "rc_initiate_checkout",
    name: t("Initiate Checkout Events"),
    enabled_for: ["report_marketing_campaigns"],
    column_type: "marketing_campaigns",
    formats_available: ["csv"],
  },
  rc_initiate_checkout_rate: {
    id: "rc_initiate_checkout_rate",
    name: t("Initiate Checkout Rate"),
    enabled_for: ["report_marketing_campaigns"],
    column_type: "marketing_campaigns",
    formats_available: ["csv"],
  },
  rc_purchases: {
    id: "rc_purchases",
    name: t("Purchase Events"),
    enabled_for: ["report_marketing_campaigns"],
    column_type: "marketing_campaigns",
    formats_available: ["csv"],
  },
  rc_purchase_rate: {
    id: "rc_purchase_rate",
    name: t("Purchase Rate"),
    enabled_for: ["report_marketing_campaigns"],
    column_type: "marketing_campaigns",
    formats_available: ["csv"],
  },
  rc_info_student_number: {
    id: "rc_info_student_number",
    name: t("Student Number"),
    enabled_for: ["report_will_call", "member_report"],
    column_type: "tickets",
    formats_available: ["csv"],
  },
  rc_info_company: {
    id: "rc_info_company",
    name: t("Company"),
    enabled_for: ["report_will_call", "member_report"],
    column_type: "tickets",
    formats_available: ["csv"],
  },
  rc_info_job_title: {
    id: "rc_info_job_title",
    name: t("Job Title"),
    enabled_for: ["report_will_call", "member_report"],
    column_type: "tickets",
    formats_available: ["csv"],
  },
  rc_info_first_name: {
    id: "rc_info_first_name",
    name: t("First Name"),
    enabled_for: [
      "report_will_call",
      "waitlist_subscriber_report",
      "reseller_submissions_report",
    ],
    column_type: "tickets",
    formats_available: ["csv"],
  },
  rc_info_last_name: {
    id: "rc_info_last_name",
    name: t("Last Name"),
    enabled_for: [
      "report_will_call",
      "waitlist_subscriber_report",
      "reseller_submissions_report",
    ],
    column_type: "tickets",
    formats_available: ["csv"],
  },
  rc_info_phone_number: {
    id: "rc_info_phone_number",
    name: t("Phone Number"),
    enabled_for: ["report_will_call"],
    column_type: "tickets",
    formats_available: ["csv"],
  },
  rc_info_email: {
    id: "rc_info_email",
    name: t("Info Email"),
    enabled_for: ["report_will_call"],
    column_type: "tickets",
    formats_available: ["csv"],
  },
  rc_info_home_address_unit_number: {
    id: "rc_info_home_address_unit_number",
    name: t("Guest Unit Number"),
    enabled_for: ["report_will_call", "member_report"],
    column_type: "tickets",
    formats_available: ["csv"],
  },
  rc_info_home_address_street_name: {
    id: "rc_info_home_address_street_name",
    name: t("Guest Street Name"),
    enabled_for: ["report_will_call", "member_report"],
    column_type: "tickets",
    formats_available: ["csv"],
  },
  rc_info_home_address_city: {
    id: "rc_info_home_address_city",
    name: t("Guest City"),
    enabled_for: ["report_will_call", "member_report"],
    column_type: "tickets",
    formats_available: ["csv"],
  },
  rc_info_home_address_province: {
    id: "rc_info_home_address_province",
    name: t("Guest Province"),
    enabled_for: ["report_will_call", "member_report"],
    column_type: "tickets",
    formats_available: ["csv"],
  },
  rc_info_home_address_postal: {
    id: "rc_info_home_address_postal",
    name: t("Guest Postal Code"),
    enabled_for: ["report_will_call", "member_report"],
    column_type: "tickets",
    formats_available: ["csv"],
  },
  rc_info_home_address_country: {
    id: "rc_info_home_address_country",
    name: t("Guest Country"),
    enabled_for: ["report_will_call", "member_report"],
    column_type: "tickets",
    formats_available: ["csv"],
  },
  rc_info_birthday: {
    id: "rc_info_birthday",
    name: t("Birthday"),
    enabled_for: ["report_will_call", "member_report"],
    column_type: "tickets",
    formats_available: ["csv"],
  },
  rc_info_license_plate: {
    id: "rc_info_license_plate",
    name: t("License Plate"),
    enabled_for: ["report_will_call", "member_report"],
    column_type: "tickets",
    formats_available: ["csv"],
  },
  rc_password: {
    id: "rc_password",
    name: t("Password"),
    enabled_for: ["report_password_used_breakdown"],
    column_type: "other",
    formats_available: ["csv"],
  },
  rc_status: {
    id: "rc_status",
    name: t("Status"),
    enabled_for: ["waitlist_subscriber_report", "reseller_submissions_report"],
    column_type: "other",
    formats_available: ["csv"],
  },
  rc_donation_total: {
    id: "rc_donation_total",
    name: t("Donation Total"),
    enabled_for: ["report_donor_transaction"],
    column_type: "donation",
    formats_available: ["csv"],
  },
  rc_registration_number: {
    id: "rc_registration_number",
    name: t("Charity Registration Number"),
    enabled_for: ["report_donor_transaction"],
    column_type: "donation",
    formats_available: ["csv"],
  },
  rc_charity_name: {
    id: "rc_charity_name",
    name: t("Charity Name"),
    enabled_for: ["report_donor_transaction"],
    column_type: "donation",
    formats_available: ["csv"],
  },
  rc_charity_currency: {
    id: "rc_charity_currency",
    name: t("Charity Currency"),
    enabled_for: ["report_donor_transaction"],
    column_type: "donation",
    formats_available: ["csv"],
  },
  rc_ticket_pay_what_you_can_enabled: {
    id: "rc_ticket_pay_what_you_can_enabled",
    enabled_for: ["report_will_call_financial"],
    name: t("Pay What You Can Enabled"),
    column_type: "ticket_history",
    formats_available: ["csv"],
  },
  rc_ticket_pay_what_you_can_difference: {
    id: "rc_ticket_pay_what_you_can_difference",
    enabled_for: ["report_will_call_financial"],
    name: t("Pay What You Can Surplus/Deficit"),
    column_type: "ticket_history",
    formats_available: ["csv"],
  },
  rc_affirm_revenue: {
    id: "rc_affirm_revenue",
    name: t("Affirm Revenue"),
    enabled_for: [
      "report_event_breakdown",
      "product_breakdown_report",
      "report_ticket_type_breakdown",
      "report_seller_stats",
    ],
    column_type: "financial",
    formats_available: ["csv"],
  },
  rc_display_gross_sales: {
    id: "rc_display_gross_sales",
    name: t("Gross Sales"),
    formats_available: ["csv"],
    enabled_for: [
      "report_will_call_financial",
      "settlement_report",
      "advance_report",
      "report_password_used_breakdown",
      "report_discount_usage_stats",
      "report_event_breakdown",
      "report_ticket_type_breakdown",
      "product_breakdown_report",
      "report_marketing_campaign_details",
    ],
    column_type: "financial",
  },
  rc_disputes: {
    id: "rc_disputes",
    name: t("Chargebacks"),
    formats_available: ["pdf"],
    enabled_for: ["report_event_breakdown", "product_breakdown_report"],
    column_type: "financial",
  },
  rc_amount_company_earned_sub_custom_fees: {
    id: "rc_amount_company_earned_sub_custom_fees",
    name: t("Service Fees"),
    formats_available: ["pdf"],
    enabled_for: ["report_event_breakdown", "product_breakdown_report"],
    column_type: "financial",
  },
  rc_company_charges_sub_custom_fees: {
    id: "rc_company_charges_sub_custom_fees",
    name: t("Showpass Fees"),
    formats_available: ["pdf"],
    enabled_for: ["report_event_breakdown", "product_breakdown_report"],
    column_type: "financial",
  },
  rc_cc_charges: {
    id: "rc_cc_charges",
    name: t("Processing Fees"),
    formats_available: ["csv"],
    enabled_for: [
      "report_invoice_transaction",
      "report_will_call_financial",
      "settlement_report",
      "advance_report",
      "report_password_used_breakdown",
      "report_discount_usage_stats",
      "report_event_breakdown",
      "report_ticket_type_breakdown",
      "product_breakdown_report",
      "report_marketing_campaign_details",
    ],
    column_type: "financial",
  },
  rc_discovery_charges: {
    id: "rc_discovery_charges",
    name: t("Discovery Fees"),
    formats_available: ["csv"],
    enabled_for: [
      "report_invoice_transaction",
      "report_will_call_financial",
      "settlement_report",
      "advance_report",
      "report_password_used_breakdown",
      "report_discount_usage_stats",
      "report_event_breakdown",
      "report_ticket_type_breakdown",
      "product_breakdown_report",
      "report_marketing_campaign_details",
    ],
    column_type: "financial",
  },
  rc_resale_charges: {
    id: "rc_resale_charges",
    name: t("Resale Fees"),
    formats_available: ["csv"],
    enabled_for: [
      "report_invoice_transaction",
      "report_will_call_financial",
      "settlement_report",
      "advance_report",
      "report_password_used_breakdown",
      "report_discount_usage_stats",
      "report_event_breakdown",
      "report_ticket_type_breakdown",
      "product_breakdown_report",
      "report_marketing_campaign_details",
    ],
    column_type: "financial",
  },
  rc_invoice_fee_total: {
    id: "rc_invoice_fee_total",
    name: t("Invoices"),
    formats_available: ["pdf"],
    enabled_for: ["report_event_breakdown", "product_breakdown_report"],
    column_type: "financial",
  },
  rc_account_credit_applied: {
    id: "rc_account_credit_applied",
    name: t("Account Credits Applied"),
    formats_available: ["csv"],
    enabled_for: [
      "report_will_call_financial",
      "settlement_report",
      "advance_report",
      "report_password_used_breakdown",
      "report_discount_usage_stats",
      "report_event_breakdown",
      "report_ticket_type_breakdown",
      "product_breakdown_report",
      "report_marketing_campaign_details",
    ],
    column_type: "financial",
  },
  rc_exchange_credit_applied: {
    id: "rc_exchange_credit_applied",
    name: t("Exchange Credits"),
    formats_available: ["pdf"],
    enabled_for: ["report_event_breakdown", "product_breakdown_report"],
    column_type: "financial",
  },
  rc_venue_credit_applied: {
    id: "rc_venue_credit_applied",
    name: t("Organizer Credits"),
    formats_available: ["pdf"],
    enabled_for: ["report_event_breakdown", "product_breakdown_report"],
    column_type: "financial",
  },
  rc_user_credit_applied: {
    id: "rc_user_credit_applied",
    name: t("Universal Credits"),
    formats_available: ["pdf"],
    enabled_for: ["report_event_breakdown", "product_breakdown_report"],
    column_type: "financial",
  },
  rc_referral_credit_applied: {
    id: "rc_referral_credit_applied",
    name: t("Referral Credits"),
    formats_available: ["pdf"],
    enabled_for: ["report_event_breakdown", "product_breakdown_report"],
    column_type: "financial",
  },
  rc_exchanged_out: {
    id: "rc_exchanged_out",
    name: t("Exchanged Out"),
    formats_available: ["csv"],
    enabled_for: [
      "report_will_call_financial",
      "settlement_report",
      "advance_report",
      "report_password_used_breakdown",
      "report_discount_usage_stats",
      "report_event_breakdown",
      "report_ticket_type_breakdown",
      "product_breakdown_report",
      "report_marketing_campaign_details",
    ],
    column_type: "financial",
  },
  rc_account_credit_refunds: {
    id: "rc_account_credit_refunds",
    name: t("Account Credit Refunds"),
    formats_available: ["csv"],
    enabled_for: [
      "report_will_call_financial",
      "settlement_report",
      "advance_report",
      "report_password_used_breakdown",
      "report_discount_usage_stats",
      "report_event_breakdown",
      "report_ticket_type_breakdown",
      "product_breakdown_report",
      "report_marketing_campaign_details",
    ],
    column_type: "financial",
  },
  rc_display_organizer_charges: {
    id: "rc_display_organizer_charges",
    name: t("Total Organizer Fees"),
    formats_available: ["csv"],
    enabled_for: [
      "report_invoice_transaction",
      "report_will_call_financial",
      "settlement_report",
      "advance_report",
      "report_password_used_breakdown",
      "report_discount_usage_stats",
      "report_event_breakdown",
      "report_ticket_type_breakdown",
      "product_breakdown_report",
      "report_marketing_campaign_details",
    ],
    column_type: "financial",
  },
  rc_credit_memo_total: {
    id: "rc_credit_memo_total",
    name: t("Credit Memos"),
    formats_available: ["pdf"],
    enabled_for: ["report_event_breakdown", "product_breakdown_report"],
    column_type: "financial",
  },
  rc_card_tax: {
    id: "rc_card_tax",
    name: t("Total Taxes"),
    formats_available: ["pdf"],
    enabled_for: ["report_event_breakdown", "product_breakdown_report"],
    column_type: "financial",
  },
  rc_card_shipping_costs: {
    id: "rc_card_shipping_costs",
    name: t("Shipping Costs"),
    formats_available: ["pdf"],
    enabled_for: ["report_event_breakdown", "product_breakdown_report"],
    column_type: "financial",
  },
  rc_other_settlement_difference: {
    id: "rc_other_settlement_difference",
    name: t("Other Payment Adjustment"),
    formats_available: ["pdf"],
    enabled_for: ["report_event_breakdown", "product_breakdown_report"],
    column_type: "financial",
  },
  rc_cash_settlement_difference: {
    id: "rc_cash_settlement_difference",
    name: t("Cash Payment Adjustment"),
    formats_available: ["pdf"],
    enabled_for: ["report_event_breakdown", "product_breakdown_report"],
    column_type: "financial",
  },
  rc_custom_processor_adjustment: {
    id: "rc_custom_processor_adjustment",
    name: t("Custom Processor Adjustment"),
    formats_available: ["pdf"],
    enabled_for: ["report_event_breakdown", "product_breakdown_report"],
    column_type: "financial",
  },
  rc_square_oauth_adjustment: {
    id: "rc_square_oauth_adjustment",
    name: t("Square OAuth Adjustment"),
    formats_available: ["pdf"],
    enabled_for: ["report_event_breakdown", "product_breakdown_report"],
    column_type: "financial",
  },
  rc_advances: {
    id: "rc_advances",
    name: t("Advances"),
    formats_available: ["pdf"],
    enabled_for: ["report_event_breakdown", "product_breakdown_report"],
    column_type: "financial",
  },
  rc_settlements: {
    id: "rc_settlements",
    name: t("Settlements"),
    formats_available: ["pdf"],
    enabled_for: ["report_event_breakdown", "product_breakdown_report"],
    column_type: "financial",
  },
  rc_non_venue_credit_applied: {
    id: "rc_non_venue_credit_applied",
    name: t("Account Credit Adjustment"),
    formats_available: ["pdf"],
    enabled_for: ["report_event_breakdown", "product_breakdown_report"],
    column_type: "financial",
  },
  rc_amount_paid: {
    id: "rc_amount_paid",
    name: t("Settlement Amount"),
    formats_available: ["csv"],
    enabled_for: [
      "report_will_call_financial",
      "settlement_report",
      "advance_report",
      "report_password_used_breakdown",
      "report_discount_usage_stats",
      "report_event_breakdown",
      "report_ticket_type_breakdown",
      "product_breakdown_report",
      "report_marketing_campaign_details",
    ],
    column_type: "financial",
  },
  rc_pre_tax_company_charges: {
    id: "rc_pre_tax_company_charges",
    name: t("Pre-Tax Showpass Fees"),
    formats_available: ["csv"],
    enabled_for: [
      "report_invoice_transaction",
      "report_will_call_financial",
      "settlement_report",
      "advance_report",
      "report_password_used_breakdown",
      "report_discount_usage_stats",
      "report_event_breakdown",
      "report_ticket_type_breakdown",
      "product_breakdown_report",
      "report_marketing_campaign_details",
    ],
    column_type: "financial",
  },
  rc_company_charges_tax: {
    id: "rc_company_charges_tax",
    name: t("Showpass Fees Tax"),
    formats_available: ["csv"],
    enabled_for: [
      "report_invoice_transaction",
      "report_will_call_financial",
      "settlement_report",
      "advance_report",
      "report_password_used_breakdown",
      "report_discount_usage_stats",
      "report_event_breakdown",
      "report_ticket_type_breakdown",
      "product_breakdown_report",
      "report_marketing_campaign_details",
    ],
    column_type: "financial",
  },
  rc_pre_tax_processing_fees: {
    id: "rc_pre_tax_processing_fees",
    name: t("Pre-Tax Processing Fees"),
    formats_available: ["csv"],
    enabled_for: [
      "report_invoice_transaction",
      "report_will_call_financial",
      "settlement_report",
      "advance_report",
      "report_password_used_breakdown",
      "report_discount_usage_stats",
      "report_event_breakdown",
      "report_ticket_type_breakdown",
      "product_breakdown_report",
      "report_marketing_campaign_details",
    ],
    column_type: "financial",
  },
  rc_processing_fees_tax: {
    id: "rc_processing_fees_tax",
    name: t("Processing Fees Tax"),
    formats_available: ["csv"],
    enabled_for: [
      "report_invoice_transaction",
      "report_will_call_financial",
      "settlement_report",
      "advance_report",
      "report_password_used_breakdown",
      "report_discount_usage_stats",
      "report_event_breakdown",
      "report_ticket_type_breakdown",
      "product_breakdown_report",
      "report_marketing_campaign_details",
    ],
    column_type: "financial",
  },
  rc_pre_tax_discovery_charges: {
    id: "rc_pre_tax_discovery_charges",
    name: t("Pre-Tax Discovery Fees"),
    formats_available: ["csv"],
    enabled_for: [
      "report_invoice_transaction",
      "report_will_call_financial",
      "settlement_report",
      "advance_report",
      "report_password_used_breakdown",
      "report_discount_usage_stats",
      "report_event_breakdown",
      "report_ticket_type_breakdown",
      "product_breakdown_report",
      "report_marketing_campaign_details",
    ],
    column_type: "financial",
  },
  rc_discovery_charges_tax: {
    id: "rc_discovery_charges_tax",
    name: t("Discovery Fees Tax"),
    formats_available: ["csv"],
    enabled_for: [
      "report_invoice_transaction",
      "report_will_call_financial",
      "settlement_report",
      "advance_report",
      "report_password_used_breakdown",
      "report_discount_usage_stats",
      "report_event_breakdown",
      "report_ticket_type_breakdown",
      "product_breakdown_report",
      "report_marketing_campaign_details",
    ],
    column_type: "financial",
  },
  rc_pre_tax_resale_charges: {
    id: "rc_pre_tax_resale_charges",
    name: t("Pre-Tax Resale Fees"),
    formats_available: ["csv"],
    enabled_for: [
      "report_invoice_transaction",
      "report_will_call_financial",
      "settlement_report",
      "advance_report",
      "report_password_used_breakdown",
      "report_discount_usage_stats",
      "report_event_breakdown",
      "report_ticket_type_breakdown",
      "product_breakdown_report",
      "report_marketing_campaign_details",
    ],
    column_type: "financial",
  },
  rc_resale_charges_tax: {
    id: "rc_resale_charges_tax",
    name: t("Resale Fees Tax"),
    formats_available: ["csv"],
    enabled_for: [
      "report_invoice_transaction",
      "report_will_call_financial",
      "settlement_report",
      "advance_report",
      "report_password_used_breakdown",
      "report_discount_usage_stats",
      "report_event_breakdown",
      "report_ticket_type_breakdown",
      "product_breakdown_report",
      "report_marketing_campaign_details",
    ],
    column_type: "financial",
  },
  rc_organizer_item_tax: {
    id: "rc_organizer_item_tax",
    name: t("Item Taxes"),
    formats_available: ["csv"],
    enabled_for: [
      "report_invoice_transaction",
      "report_will_call_financial",
      "settlement_report",
      "advance_report",
      "report_password_used_breakdown",
      "report_discount_usage_stats",
      "report_event_breakdown",
      "report_ticket_type_breakdown",
      "product_breakdown_report",
      "report_marketing_campaign_details",
    ],
    column_type: "financial",
  },
  rc_organizer_fee_tax: {
    id: "rc_organizer_fee_tax",
    name: t("Organizer Fee Taxes"),
    formats_available: ["csv"],
    enabled_for: [
      "report_invoice_transaction",
      "report_will_call_financial",
      "settlement_report",
      "advance_report",
      "report_password_used_breakdown",
      "report_discount_usage_stats",
      "report_event_breakdown",
      "report_ticket_type_breakdown",
      "product_breakdown_report",
      "report_marketing_campaign_details",
    ],
    column_type: "financial",
  },
  rc_adjustment: {
    id: "rc_adjustment",
    name: t("Adjustments"),
    formats_available: ["csv"],
    enabled_for: [
      "report_will_call_financial",
      "settlement_report",
      "advance_report",
      "report_password_used_breakdown",
      "report_discount_usage_stats",
      "report_event_breakdown",
      "report_ticket_type_breakdown",
      "product_breakdown_report",
      "report_marketing_campaign_details",
    ],
    column_type: "financial",
  },
} as const;

export const REPORT_COLUMN_MAP_BY_LIST = [
  {
    id: "rc_ticket_history_ticket_code",
    enabled_for: ["report_ticket_history"],
    name: t("Barcode String"),
    column_type: "ticket_history",
    formats_available: ["csv"],
  },
  {
    id: "rc_ticket_history_item_type",
    enabled_for: ["report_ticket_history", "report_holds_stats"],
    name: t("Item Type"),
    column_type: "ticket_history",
    formats_available: ["csv"],
  },
  {
    id: "rc_ticket_history_ticket_name_on_ticket",
    enabled_for: ["report_ticket_history"],
    name: t("Name On Ticket"),
    column_type: "ticket_history",
    formats_available: ["csv"],
  },
  {
    id: "rc_ticket_history_ticket_event_name",
    enabled_for: [
      "report_ticket_history",
      "report_shipping_fulfillment",
      "report_will_call_financial",
      "report_holds_stats",
      "settlement_report",
      "advance_report",
      "report_marketing_campaign_details",
    ],
    name: t("Event Name"),
    column_type: "ticket_history",
    formats_available: ["csv"],
  },
  {
    id: "rc_ticket_history_event_id",
    enabled_for: [
      "report_ticket_history",
      "report_shipping_fulfillment",
      "report_will_call_financial",
      "report_holds_stats",
      "settlement_report",
      "advance_report",
      "report_marketing_campaign_details",
    ],
    name: t("Event ID"),
    column_type: "ticket_history",
    formats_available: ["csv"],
  },
  {
    id: "rc_ticket_history_tt_description",
    enabled_for: ["report_ticket_history", "report_shipping_fulfillment"],
    name: t("Ticket Type Name"),
    column_type: "ticket_history",
    formats_available: ["csv"],
  },
  {
    id: "rc_ticket_history_ticket_id",
    enabled_for: ["report_ticket_history", "report_shipping_fulfillment"],
    name: t("Ticket Type ID"),
    column_type: "ticket_history",
    formats_available: ["csv"],
  },
  {
    id: "rc_ticket_history_product_description",
    enabled_for: [
      "report_ticket_history",
      "report_shipping_fulfillment",
      "report_holds_stats",
    ],
    name: t("Product Name"),
    column_type: "ticket_history",
    formats_available: ["csv"],
  },
  {
    id: "rc_ticket_history_product_id",
    enabled_for: [
      "report_ticket_history",
      "report_shipping_fulfillment",
      "report_will_call_financial",
      "report_holds_stats",
      "settlement_report",
      "advance_report",
      "report_marketing_campaign_details",
    ],
    name: t("Product ID"),
    column_type: "ticket_history",
    formats_available: ["csv"],
  },
  {
    id: "rc_ticket_history_product_attribute_name",
    enabled_for: [
      "report_ticket_history",
      "report_shipping_fulfillment",
      "report_holds_stats",
    ],
    name: t("Product Attribute Name"),
    column_type: "ticket_history",
    formats_available: ["csv"],
  },
  {
    id: "rc_ticket_history_product_attribute_id",
    enabled_for: [
      "report_ticket_history",
      "report_shipping_fulfillment",
      "report_will_call_financial",
      "report_holds_stats",
      "settlement_report",
      "advance_report",
      "report_marketing_campaign_details",
    ],
    name: t("Product Attribute ID"),
    column_type: "ticket_history",
    formats_available: ["csv"],
  },
  {
    id: "rc_ticket_history_created",
    enabled_for: ["report_ticket_history"],
    name: t("Created On"),
    column_type: "ticket_history",
    formats_available: ["csv"],
  },
  {
    id: "rc_ticket_history_user_action",
    enabled_for: ["report_ticket_history"],
    name: t("Action"),
    column_type: "ticket_history",
    formats_available: ["csv"],
  },
  {
    id: "rc_ticket_history_before_status",
    enabled_for: ["report_ticket_history"],
    name: t("Status Before"),
    column_type: "ticket_history",
    formats_available: ["csv"],
  },
  {
    id: "rc_ticket_history_after_status",
    enabled_for: ["report_ticket_history"],
    name: t("Status After"),
    column_type: "ticket_history",
    formats_available: ["csv"],
  },
  {
    id: "rc_ticket_history_created_by",
    enabled_for: ["report_ticket_history"],
    name: t("Created By"),
    column_type: "ticket_history",
    formats_available: ["csv"],
  },
  {
    id: "picked_up",
    enabled_for: ["report_event_product_inventory"],
    name: t("Picked Up"),
    column_type: "ticket_history",
    formats_available: ["csv"],
  },
  {
    enabled_for: ["report_discount_creation"],
    id: "rc_discount_allowed_checkouts",
    name: t("Allowed Checkouts"),
    column_type: "discount",
    formats_available: ["csv"],
  },
  {
    enabled_for: [
      "report_discount_creation",
      "report_will_call_financial",
      "settlement_report",
      "advance_report",
      "report_marketing_campaign_details",
    ],
    id: "rc_discount_amount",
    name: t("Discount Code Amount"),
    column_type: "discount",
    formats_available: ["csv"],
  },
  {
    enabled_for: [
      "report_will_call_financial",
      "settlement_report",
      "advance_report",
      "report_marketing_campaign_details",
    ],
    id: "rc_rule_discount_percentage",
    name: t("Discount Rule Percentage"),
    column_type: "discount",
    formats_available: ["csv"],
  },
  {
    enabled_for: [
      "report_will_call_financial",
      "settlement_report",
      "advance_report",
      "report_marketing_campaign_details",
    ],
    id: "rc_discount_rule_amount",
    name: t("Discount Rule Amount"),
    column_type: "discount",
    formats_available: ["csv"],
  },
  {
    enabled_for: ["report_discount_creation"],
    id: "rc_discount_limit",
    name: t("Total Limit"),
    column_type: "discount",
    formats_available: ["csv"],
  },
  {
    enabled_for: ["report_discount_creation"],
    id: "rc_discount_maximum_quantity",
    name: t("Maximum Quantity For Tiered Discounts"),
    column_type: "discount",
    formats_available: ["csv"],
  },
  {
    enabled_for: ["report_discount_creation"],
    id: "rc_discount_minimum_quantity",
    name: t("Minimum Quantity for tiered discounts"),
    column_type: "discount",
    formats_available: ["csv"],
  },
  {
    enabled_for: ["report_discount_creation"],
    id: "rc_discount_rule_percentages",
    name: t("Discount Rule Percentages"),
    column_type: "discount",
    formats_available: ["csv"],
  },
  {
    enabled_for: ["report_discount_creation"],
    id: "rc_discount_rule_amounts",
    name: t("Discount Rule Amounts"),
    column_type: "discount",
    formats_available: ["csv"],
  },
  {
    enabled_for: [
      "report_discount_creation",
      "report_will_call_financial",
      "settlement_report",
      "advance_report",
      "report_marketing_campaign_details",
    ],
    id: "rc_discount_percentage",
    name: t("Discount Code Percentage"),
    column_type: "discount",
    formats_available: ["csv"],
  },
  {
    enabled_for: ["report_discount_creation"],
    id: "rc_discount_permission_type",
    name: t("Discount Ticket Type/Event Permissions"),
    column_type: "discount",
    formats_available: ["csv"],
  },
  {
    enabled_for: ["report_discount_creation"],
    id: "rc_discount_per_user_limit",
    name: t("Usage Limit Per User"),
    column_type: "discount",
    formats_available: ["csv"],
  },
  {
    enabled_for: [
      "report_discount_creation",
      "report_will_call_financial",
      "settlement_report",
      "advance_report",
      "report_marketing_campaign_details",
    ],
    id: "rc_discount_type",
    name: t("Discount Type"),
    column_type: "discount",
    formats_available: ["csv"],
  },
  {
    enabled_for: ["report_discount_creation"],
    id: "rc_discount_created_by",
    name: t("Discount Created By"),
    column_type: "discount",
    formats_available: ["csv"],
  },
  {
    enabled_for: ["report_discount_creation"],
    id: "rc_discount_created_on",
    name: t("Discount Created On"),
    column_type: "discount",
    formats_available: ["csv"],
  },
  {
    id: "rc_discount_description",
    enabled_for: ["report_discount_usage_stats", "report_discount_creation"],
    name: t("Discount Description"),
    column_type: "discount",
    formats_available: ["csv"],
  },
  {
    id: "rc_discount_purchase_platform",
    enabled_for: ["report_discount_usage_stats"],
    name: t("Purchase Platform"),
    column_type: "discount",
    formats_available: ["csv"],
  },
  {
    id: "rc_discounts_used",
    enabled_for: ["report_discount_usage_stats"],
    name: t("Quantity Discount Used"),
    column_type: "discount",
    formats_available: ["csv"],
  },
  {
    id: "rc_discount_ticket_quantity",
    enabled_for: ["report_discount_usage_stats"],
    name: t("Ticket Quantity"),
    column_type: "discount",
    formats_available: ["csv"],
  },
  {
    id: "rc_username",
    enabled_for: [
      "report_invoice_transaction",
      "report_venue_user",
      "report_seller_stats",
      "report_surveys",
      "report_will_call_financial",
      "settlement_report",
      "advance_report",
      "report_holds_stats",
      "report_donor_transaction",
      "report_marketing_campaign_details",
    ],
    name: t("Customer Name"),
    column_type: "customer",
    formats_available: ["csv"],
  },
  {
    id: "rc_email",
    name: t("Customer Email"),
    enabled_for: [
      "report_invoice_transaction",
      "report_venue_user",
      "report_will_call",
      "report_seller_stats",
      "report_surveys",
      "report_shipping_fulfillment",
      "report_event_product_inventory",
      "report_will_call_financial",
      "settlement_report",
      "advance_report",
      "report_holds_stats",
      "waitlist_subscriber_report",
      "reseller_submissions_report",
      "report_donor_transaction",
      "report_marketing_campaign_details",
    ],
    column_type: "customer",
    formats_available: ["csv"],
  },
  {
    id: "rc_phone",
    name: t("Customer Phone Number"),
    enabled_for: [
      "report_invoice_transaction",
      "report_venue_user",
      "report_will_call",
      "report_holds_stats",
      "report_seller_stats",
      "report_shipping_fulfillment",
      "report_will_call_financial",
      "report_donor_transaction",
      "settlement_report",
      "advance_report",
      "report_marketing_campaign_details",
    ],
    column_type: "customer",
    formats_available: ["csv"],
  },
  {
    id: "rc_birthday",
    name: t("Birthday"),
    enabled_for: ["report_venue_user"],
    column_type: "customer",
    formats_available: ["csv"],
  },
  {
    id: "rc_gender",
    name: t("Gender"),
    enabled_for: ["report_venue_user"],
    column_type: "customer",
    formats_available: ["csv"],
  },
  {
    id: "rc_is_seller",
    name: t("Seller Status"),
    enabled_for: ["report_venue_user"],
    column_type: "customer",
    formats_available: ["csv"],
  },
  {
    id: "rc_is_employee",
    name: t("Employee Status"),
    enabled_for: ["report_venue_user"],
    column_type: "customer",
    formats_available: ["csv"],
  },
  {
    id: "rc_is_subscribed",
    name: t("Subscribed to Email"),
    enabled_for: [
      "report_venue_user",
      "report_will_call_financial",
      "settlement_report",
      "advance_report",
      "report_marketing_campaign_details",
    ],
    column_type: "customer",
    formats_available: ["csv"],
  },
  {
    id: "rc_allow_mail_contact",
    name: t("Allowed to Mail"),
    enabled_for: ["report_venue_user"],
    column_type: "customer",
    formats_available: ["csv"],
  },
  {
    id: "rc_allow_phone_contact",
    name: t("Allowed to Phone"),
    enabled_for: ["report_venue_user"],
    column_type: "customer",
    formats_available: ["csv"],
  },
  {
    id: "rc_num_customer_reservations",
    name: t("Number Of Customer Reservations Booked"),
    enabled_for: ["report_venue_user"],
    column_type: "customer",
    formats_available: ["csv"],
  },
  {
    id: "rc_num_checked_in_as_customer",
    name: t("Number Of Times Customer Checked In"),
    enabled_for: ["report_venue_user"],
    column_type: "customer",
    formats_available: ["csv"],
  },
  {
    id: "rc_num_reservations_booked",
    name: t("Number Of Staff Reservations Booked"),
    enabled_for: ["report_venue_user"],
    column_type: "customer",
    formats_available: ["csv"],
  },
  {
    id: "rc_num_checked_in_as_employee",
    name: t("Number Of Staff Check Ins"),
    enabled_for: ["report_venue_user"],
    column_type: "customer",
    formats_available: ["csv"],
  },
  {
    id: "rc_num_tickets_purchased",
    name: t("Tickets Purchased"),
    enabled_for: ["report_venue_user"],
    column_type: "customer",
    formats_available: ["csv"],
  },
  {
    id: "rc_num_tickets_sold",
    name: t("Tickets Sold"),
    enabled_for: [
      "report_venue_user",
      "report_surveys",
      "report_password_used_breakdown",
      "report_seller_stats",
    ],
    column_type: "customer",
    formats_available: ["csv"],
  },
  {
    id: "rc_num_items_sold",
    name: t("Items Sold"),
    enabled_for: ["report_marketing_campaigns"],
    column_type: "customer",
    formats_available: ["csv"],
  },
  {
    id: "rc_external_tickets_quantity",
    name: t("Tickets Purchased"),
    enabled_for: ["report_venue_user"],
    column_type: "customer",
    formats_available: ["csv"],
  },
  {
    id: "rc_external_tickets_spend",
    name: t("External Ticket Spend"),
    enabled_for: ["report_venue_user"],
    column_type: "customer",
    formats_available: ["csv"],
  },
  {
    id: "rc_external_donations",
    name: t("External Donations"),
    enabled_for: ["report_venue_user"],
    column_type: "customer",
    formats_available: ["csv"],
  },
  {
    id: "rc_sub_tickets_generated_from_package",
    name: t("Sub Tickets Generated From Package"),
    enabled_for: ["report_event_breakdown", "report_ticket_type_breakdown"],
    column_type: "customer",
    formats_available: ["csv"],
  },
  {
    id: "rc_name_on_ticket",
    name: t("Name On Ticket"),
    enabled_for: [
      "report_invoice_transaction",
      "report_will_call",
      "report_surveys",
      "report_shipping_fulfillment",
      "report_event_product_inventory",
    ],
    column_type: "customer",
    formats_available: ["csv"],
  },
  {
    id: "rc_venueuser_shipping_name",
    name: t("Shipping Name"),
    enabled_for: ["report_venue_user"],
    column_type: "customer",
    formats_available: ["csv"],
  },
  {
    id: "rc_invoice_item_description",
    name: t("Description"),
    enabled_for: [
      "report_will_call_financial",
      "settlement_report",
      "advance_report",
      "report_marketing_campaign_details",
    ],
    column_type: "financial",
    formats_available: ["csv"],
  },
  {
    id: "rc_charge_id",
    name: t("Charge ID"),
    enabled_for: [
      "report_will_call_financial",
      "settlement_report",
      "advance_report",
      "report_marketing_campaign_details",
    ],
    column_type: "financial",
    formats_available: ["csv"],
  },
  {
    id: "rc_invoice_type_name",
    name: t("Item Type"),
    enabled_for: [
      "report_will_call_financial",
      "settlement_report",
      "advance_report",
      "report_marketing_campaign_details",
    ],
    column_type: "financial",
    formats_available: ["csv"],
  },
  {
    id: "rc_invoice_category_name",
    name: t("Item Category"),
    enabled_for: [
      "report_will_call_financial",
      "settlement_report",
      "advance_report",
      "report_marketing_campaign_details",
    ],
    column_type: "financial",
    formats_available: ["csv"],
  },
  {
    id: "rc_revenue_tickets_purchased",
    name: t("Revenue From Customer Purchases"),
    enabled_for: ["report_venue_user"],
    column_type: "financial",
    formats_available: ["csv"],
  },
  {
    id: "rc_revenue_tickets_sold",
    name: t("Revenue From Tickets Sold"),
    enabled_for: ["report_venue_user"],
    column_type: "financial",
    formats_available: ["csv"],
  },
  {
    id: "rc_invoice_type",
    name: t("Invoice Type"),
    enabled_for: ["report_invoice_transaction"],
    column_type: "financial",
    formats_available: ["csv"],
  },
  {
    id: "rc_transaction_id",
    name: t("Transaction ID"),
    enabled_for: [
      "report_invoice_transaction",
      "report_surveys",
      "report_shipping_fulfillment",
      "report_will_call_financial",
      "settlement_report",
      "advance_report",
      "report_marketing_campaign_details",
    ],
    column_type: "financial",
    formats_available: ["csv"],
  },
  {
    id: "rc_transaction_date",
    name: t("Transaction Date"),
    enabled_for: [
      "report_will_call_financial",
      "settlement_report",
      "advance_report",
      "gift_card_recipients_report",
      "report_marketing_campaign_details",
    ],
    column_type: "financial",
    formats_available: ["csv"],
  },
  {
    id: "rc_sale_transaction_id",
    name: t("Sale Transaction ID"),
    enabled_for: [
      "report_will_call_financial",
      "settlement_report",
      "advance_report",
      "report_marketing_campaign_details",
    ],
    column_type: "financial",
    formats_available: ["csv"],
  },
  {
    id: "rc_settlement_date",
    name: t("Settlement Date"),
    enabled_for: [
      "report_will_call_financial",
      "settlement_report",
      "advance_report",
      "report_marketing_campaign_details",
    ],
    column_type: "financial",
    formats_available: ["csv"],
  },
  {
    id: "rc_advance_date",
    name: t("Advance Date"),
    enabled_for: [
      "report_will_call_financial",
      "settlement_report",
      "advance_report",
      "report_marketing_campaign_details",
    ],
    column_type: "financial",
    formats_available: ["csv"],
  },
  {
    id: "rc_ticket_type_price",
    name: t("Ticket Type Price"),
    enabled_for: [
      "report_will_call_financial",
      "settlement_report",
      "advance_report",
      "report_marketing_campaign_details",
      "report_ticket_type_breakdown",
    ],
    column_type: "financial",
    formats_available: ["csv"],
  },
  {
    id: "rc_final_amount",
    name: t("Total Sales"),
    enabled_for: [
      "report_invoice_transaction",
      "report_seller_stats",
      "report_surveys",
      "report_event_product_inventory",
      "report_marketing_campaigns",
    ],
    column_type: "financial",
    formats_available: ["csv"],
  },
  {
    id: "rc_amount_earned",
    name: t("Revenue"),
    enabled_for: ["report_invoice_transaction", "report_seller_stats"],
    column_type: "financial",
    formats_available: ["csv"],
  },
  {
    id: "rc_tax",
    name: t("Total Organizer Taxes"),
    formats_available: ["csv"],
    enabled_for: [
      "report_invoice_transaction",
      "report_will_call_financial",
      "settlement_report",
      "advance_report",
      "report_password_used_breakdown",
      "report_discount_usage_stats",
      "report_event_breakdown",
      "report_ticket_type_breakdown",
      "product_breakdown_report",
      "report_marketing_campaign_details",
    ],
    column_type: "financial",
  },
  {
    id: "rc_refunds",
    name: t("Refunds"),
    formats_available: ["csv"],
    enabled_for: [
      "report_invoice_transaction",
      "report_will_call_financial",
      "settlement_report",
      "advance_report",
      "report_password_used_breakdown",
      "report_discount_usage_stats",
      "report_event_breakdown",
      "report_ticket_type_breakdown",
      "product_breakdown_report",
      "report_marketing_campaign_details",
    ],
    column_type: "financial",
  },
  {
    id: "rc_discounts",
    name: t("Discounts"),
    formats_available: ["csv"],
    enabled_for: [
      "report_invoice_transaction",
      "report_will_call_financial",
      "settlement_report",
      "advance_report",
      "report_password_used_breakdown",
      "report_discount_usage_stats",
      "report_event_breakdown",
      "report_ticket_type_breakdown",
      "product_breakdown_report",
      "report_marketing_campaign_details",
    ],
    column_type: "financial",
  },
  {
    id: "rc_gross_sales",
    name: t("Net Sales"),
    formats_available: ["csv"],
    enabled_for: [
      "report_will_call_financial",
      "settlement_report",
      "advance_report",
      "report_password_used_breakdown",
      "report_discount_usage_stats",
      "report_event_breakdown",
      "report_ticket_type_breakdown",
      "product_breakdown_report",
      "report_marketing_campaign_details",
    ],
    column_type: "financial",
  },
  {
    id: "rc_amount_company_earned",
    name: t("Service Fees"),
    formats_available: ["csv"],
    enabled_for: [
      "report_invoice_transaction",
      "report_will_call_financial",
      "settlement_report",
      "advance_report",
      "report_password_used_breakdown",
      "report_discount_usage_stats",
      "report_event_breakdown",
      "report_ticket_type_breakdown",
      "product_breakdown_report",
      "report_marketing_campaign_details",
    ],
    column_type: "financial",
  },
  {
    id: "rc_display_gross_revenue",
    name: t("Gross Revenue"),
    formats_available: ["csv"],
    enabled_for: [
      "report_will_call_financial",
      "settlement_report",
      "advance_report",
      "report_password_used_breakdown",
      "report_discount_usage_stats",
      "report_event_breakdown",
      "report_ticket_type_breakdown",
      "product_breakdown_report",
      "report_marketing_campaign_details",
    ],
    column_type: "financial",
  },
  {
    id: "rc_display_net_revenue",
    name: t("Net Revenue"),
    formats_available: ["csv"],
    enabled_for: [
      "report_will_call_financial",
      "settlement_report",
      "advance_report",
      "report_password_used_breakdown",
      "report_discount_usage_stats",
      "report_event_breakdown",
      "report_ticket_type_breakdown",
      "product_breakdown_report",
      "report_marketing_campaign_details",
    ],
    column_type: "financial",
  },
  {
    id: "rc_credit_type",
    name: t("Account Credit Type"),
    enabled_for: [
      "report_will_call_financial",
      "settlement_report",
      "advance_report",
      "report_marketing_campaign_details",
    ],
    column_type: "financial",
    formats_available: ["csv"],
  },
  {
    id: "rc_purchase_source_platform",
    name: t("Purchase Source Platform"),
    enabled_for: [
      "report_will_call_financial",
      "settlement_report",
      "advance_report",
      "report_marketing_campaign_details",
    ],
    column_type: "financial",
    formats_available: ["csv"],
  },
  {
    id: "rc_purchase_note",
    name: t("Purchase Note"),
    enabled_for: [
      "report_will_call_financial",
      "settlement_report",
      "advance_report",
      "report_marketing_campaign_details",
    ],
    column_type: "financial",
    formats_available: ["csv"],
  },
  {
    id: "rc_other_custom_type",
    name: t("Other Custom Purchase Type"),
    enabled_for: ["report_invoice_transaction"],
    column_type: "financial",
    formats_available: ["csv"],
  },
  {
    id: "rc_other_payment_type",
    name: t("Other Payment Type"),
    enabled_for: [
      "report_will_call_financial",
      "settlement_report",
      "advance_report",
      "report_marketing_campaign_details",
    ],
    column_type: "financial",
    formats_available: ["csv"],
  },
  {
    id: "rc_quantity",
    name: t("Quantity"),
    enabled_for: [
      "report_will_call",
      "report_event_product_inventory",
      "report_holds_stats",
      "waitlist_subscriber_report",
      "reseller_submissions_report",
      "gift_card_recipients_report",
      "member_seating_report",
    ],
    column_type: "financial",
    formats_available: ["csv"],
  },
  {
    id: "rc_transaction_quantity",
    name: t("Transaction Quantity"),
    enabled_for: [
      "report_will_call_financial",
      "settlement_report",
      "advance_report",
      "report_marketing_campaign_details",
    ],
    column_type: "financial",
    formats_available: ["csv"],
  },
  {
    id: "rc_item_quantity",
    name: t("Item Quantity"),
    enabled_for: [
      "report_will_call_financial",
      "settlement_report",
      "advance_report",
      "report_marketing_campaign_details",
    ],
    column_type: "financial",
    formats_available: ["csv"],
  },
  {
    id: "rc_transfer_quantity",
    name: t("Transfer Quantity"),
    enabled_for: [
      "report_will_call_financial",
      "settlement_report",
      "advance_report",
      "report_marketing_campaign_details",
    ],
    column_type: "financial",
    formats_available: ["csv"],
  },
  {
    id: "rc_scanned_quantity",
    name: t("Scanned Quantity"),
    enabled_for: [
      "report_will_call_financial",
      "settlement_report",
      "advance_report",
      "report_marketing_campaign_details",
    ],
    column_type: "financial",
    formats_available: ["csv"],
  },
  {
    id: "rc_scan_limit",
    name: t("Scan Limit"),
    enabled_for: [
      "report_will_call_financial",
      "settlement_report",
      "advance_report",
      "report_marketing_campaign_details",
    ],
    column_type: "financial",
    formats_available: ["csv"],
  },
  {
    id: "rc_organizer_charges",
    name: t("Organizer Charges"),
    enabled_for: [
      "report_invoice_transaction",
      "report_seller_stats",
      "report_event_product_inventory",
      "report_marketing_campaigns",
    ],
    column_type: "financial",
    formats_available: ["csv"],
  },
  {
    id: "rc_card_organizer_charges",
    name: t("Organizer Fees"),
    formats_available: ["pdf"],
    enabled_for: ["report_event_breakdown", "product_breakdown_report"],
    column_type: "financial",
  },
  {
    id: "rc_cash_organizer_charges",
    name: t("Cash Organizer Charges"),
    enabled_for: [
      "report_invoice_transaction",
      "report_event_breakdown",
      "product_breakdown_report",
      "report_ticket_type_breakdown",
      "report_seller_stats",
    ],
    column_type: "financial",
    formats_available: ["csv"],
  },
  {
    id: "rc_other_organizer_charges",
    name: t("Other Organizer Charges"),
    enabled_for: [
      "report_invoice_transaction",
      "report_event_breakdown",
      "product_breakdown_report",
      "report_ticket_type_breakdown",
      "report_seller_stats",
    ],
    column_type: "financial",
    formats_available: ["csv"],
  },
  {
    id: "rc_refund_type",
    name: t("Refund Type"),
    enabled_for: [
      "report_will_call_financial",
      "settlement_report",
      "advance_report",
      "report_marketing_campaign_details",
    ],
    column_type: "financial",
    formats_available: ["csv"],
  },
  {
    id: "rc_refund_reason",
    name: t("Refund Reason"),
    enabled_for: [
      "report_will_call_financial",
      "settlement_report",
      "advance_report",
      "report_marketing_campaign_details",
    ],
    column_type: "financial",
    formats_available: ["csv"],
  },
  {
    id: "rc_commissions",
    name: t("Commissions"),
    enabled_for: [
      "report_invoice_transaction",
      "report_event_breakdown",
      "product_breakdown_report",
      "report_ticket_type_breakdown",
      "report_will_call_financial",
      "settlement_report",
      "advance_report",
      "report_marketing_campaign_details",
    ],
    column_type: "financial",
    formats_available: ["csv"],
  },
  {
    id: "rc_cash_commissions",
    name: t("Cash Commission"),
    enabled_for: ["report_seller_stats"],
    column_type: "financial",
    formats_available: ["csv"],
  },
  {
    id: "rc_credit_commissions",
    name: t("Credit Commission"),
    enabled_for: ["report_seller_stats"],
    column_type: "financial",
    formats_available: ["csv"],
  },
  {
    id: "rc_shipping_costs",
    name: t("Shipping Costs"),
    formats_available: ["pdf"],
    enabled_for: ["report_event_breakdown", "product_breakdown_report"],
    column_type: "financial",
  },
  {
    id: "rc_items_total_amount",
    name: t("Face Value"),
    enabled_for: ["report_invoice_transaction"],
    column_type: "financial",
    formats_available: ["csv"],
  },
  {
    id: "rc_payment_type",
    name: t("Payment Method"),
    enabled_for: [
      "report_invoice_transaction",
      "report_will_call_financial",
      "settlement_report",
      "advance_report",
      "report_marketing_campaign_details",
    ],
    column_type: "financial",
    formats_available: ["csv"],
  },
  {
    id: "rc_card_type",
    name: t("Card Type"),
    enabled_for: [
      "report_invoice_transaction",
      "report_will_call_financial",
      "settlement_report",
      "advance_report",
      "report_marketing_campaign_details",
    ],
    column_type: "financial",
    formats_available: ["csv"],
  },
  {
    id: "rc_cash_revenue",
    name: t("Cash Revenue"),
    enabled_for: [
      "report_event_breakdown",
      "product_breakdown_report",
      "report_ticket_type_breakdown",
      "report_seller_stats",
    ],
    column_type: "financial",
    formats_available: ["csv"],
  },
  {
    id: "rc_credit_revenue",
    name: t("Credit Revenue"),
    enabled_for: [
      "report_event_breakdown",
      "product_breakdown_report",
      "report_ticket_type_breakdown",
      "report_seller_stats",
    ],
    column_type: "financial",
    formats_available: ["csv"],
  },
  {
    id: "rc_event",
    name: t("Event"),
    enabled_for: [
      "report_will_call",
      "report_event_breakdown",
      "report_ticket_type_breakdown",
      "report_event_product_inventory",
      "report_password_used_breakdown",
      "waitlist_subscriber_report",
      "reseller_submissions_report",
      "report_donor_transaction",
    ],
    column_type: "tickets",
    formats_available: ["csv"],
  },
  {
    id: "rc_event_starts_on",
    name: t("Event Start Time"),
    enabled_for: [
      "report_will_call",
      "report_event_breakdown",
      "report_ticket_type_breakdown",
      "report_event_product_inventory",
      "report_will_call_financial",
      "settlement_report",
      "advance_report",
      "report_shipping_fulfillment",
      "report_holds_stats",
      "waitlist_subscriber_report",
      "reseller_submissions_report",
      "report_donor_transaction",
      "report_marketing_campaign_details",
    ],
    column_type: "tickets",
    formats_available: ["csv"],
  },
  {
    id: "rc_event_ends_on",
    name: t("Event End Time"),
    enabled_for: [
      "report_will_call",
      "report_event_breakdown",
      "report_ticket_type_breakdown",
      "report_will_call_financial",
      "settlement_report",
      "advance_report",
      "report_holds_stats",
      "report_marketing_campaign_details",
    ],
    column_type: "tickets",
    formats_available: ["csv"],
  },
  {
    id: "rc_ticket_type",
    name: t("Ticket Type Name"),
    enabled_for: [
      "report_will_call",
      "report_will_call_financial",
      "report_ticket_type_breakdown",
      "settlement_report",
      "advance_report",
      "report_holds_stats",
      "report_event_product_inventory",
      "waitlist_subscriber_report",
      "reseller_submissions_report",
      "report_marketing_campaign_details",
    ],
    column_type: "tickets",
    formats_available: ["csv"],
  },
  {
    id: "rc_ticket_type_id",
    name: t("Ticket Type ID"),
    enabled_for: [
      "report_will_call_financial",
      "settlement_report",
      "advance_report",
      "report_holds_stats",
      "report_marketing_campaign_details",
    ],
    column_type: "tickets",
    formats_available: ["csv"],
  },
  {
    id: "rc_event_location",
    name: t("Event Location"),
    enabled_for: ["report_event_breakdown", "report_ticket_type_breakdown"],
    column_type: "tickets",
    formats_available: ["csv"],
  },
  {
    id: "rc_event_location_name",
    name: t("Event Location Name"),
    enabled_for: [
      "report_will_call_financial",
      "settlement_report",
      "advance_report",
      "report_marketing_campaign_details",
    ],
    column_type: "tickets",
    formats_available: ["csv"],
  },
  {
    id: "rc_event_location_postal_address",
    name: t("Event Location Postal/Zip Code"),
    enabled_for: [
      "report_will_call_financial",
      "settlement_report",
      "advance_report",
      "report_marketing_campaign_details",
    ],
    column_type: "tickets",
    formats_available: ["csv"],
  },
  {
    id: "rc_event_location_city_address",
    name: t("Event Location City"),
    enabled_for: [
      "report_will_call_financial",
      "settlement_report",
      "advance_report",
      "report_marketing_campaign_details",
    ],
    column_type: "other",
    formats_available: ["csv"],
  },
  {
    id: "rc_event_location_street_name",
    name: t("Event Location Street"),
    enabled_for: [
      "report_will_call_financial",
      "settlement_report",
      "advance_report",
      "report_marketing_campaign_details",
    ],
    column_type: "other",
    formats_available: ["csv"],
  },
  {
    id: "rc_event_location_province_address",
    name: t("Event Location Province/State"),
    enabled_for: [
      "report_will_call_financial",
      "settlement_report",
      "advance_report",
      "report_marketing_campaign_details",
    ],
    column_type: "other",
    formats_available: ["csv"],
  },
  {
    id: "rc_event_location_country_address",
    name: t("Event Location Country"),
    enabled_for: [
      "report_will_call_financial",
      "settlement_report",
      "advance_report",
      "report_marketing_campaign_details",
    ],
    column_type: "other",
    formats_available: ["csv"],
  },
  {
    id: "rc_ticket_status",
    name: t("Ticket Status"),
    enabled_for: ["report_will_call"],
    column_type: "tickets",
    formats_available: ["csv"],
  },
  {
    id: "rc_ticket_barcode",
    name: t("Barcode String"),
    enabled_for: ["report_will_call"],
    column_type: "tickets",
    formats_available: ["csv"],
  },
  {
    id: "rc_ticket_scan_code",
    name: t("Ticket Scan Code"),
    enabled_for: ["report_will_call", "report_shipping_fulfillment"],
    column_type: "tickets",
    formats_available: ["csv"],
  },
  {
    id: "rc_seating_section",
    name: t("Seat Section"),
    enabled_for: [
      "report_will_call",
      "report_holds_stats",
      "member_seating_report",
    ],
    column_type: "tickets",
    formats_available: ["csv"],
  },
  {
    id: "rc_password_used",
    name: t("Password Used"),
    enabled_for: [
      "report_will_call",
      "report_will_call_financial",
      "settlement_report",
      "advance_report",
      "report_marketing_campaign_details",
    ],
    column_type: "tickets",
    formats_available: ["csv"],
  },
  {
    id: "rc_seating_row",
    name: t("Row/Area"),
    enabled_for: [
      "report_will_call",
      "report_holds_stats",
      "member_seating_report",
    ],
    column_type: "tickets",
    formats_available: ["csv"],
  },
  {
    id: "rc_seating_seat",
    name: t("Seat"),
    enabled_for: [
      "report_will_call",
      "report_holds_stats",
      "member_seating_report",
    ],
    column_type: "tickets",
    formats_available: ["csv"],
  },
  {
    id: "rc_basket_uuid",
    name: t("Basket UUID"),
    enabled_for: ["report_holds_stats"],
    column_type: "tickets",
    formats_available: ["csv"],
  },
  {
    id: "rc_ticket_description",
    name: t("Ticket Description"),
    enabled_for: ["report_will_call"],
    column_type: "tickets",
    formats_available: ["csv"],
  },
  {
    id: "rc_last_status_change",
    name: t("Last Ticket Status Change Time"),
    enabled_for: ["report_will_call"],
    column_type: "tickets",
    formats_available: ["csv"],
  },
  {
    id: "rc_last_status_changed_by",
    name: t("Last Ticket Status Changed By"),
    enabled_for: ["report_will_call"],
    column_type: "tickets",
    formats_available: ["csv"],
  },
  {
    id: "rc_num_tickets_sold_cash",
    name: t("Num Cash Tickets Sold"),
    enabled_for: [
      "report_event_breakdown",
      "product_breakdown_report",
      "report_ticket_type_breakdown",
      "report_seller_stats",
    ],
    column_type: "tickets",
    formats_available: ["csv"],
  },
  {
    id: "rc_num_tickets_sold_credit",
    name: t("Num Credit Tickets Sold"),
    enabled_for: [
      "report_event_breakdown",
      "product_breakdown_report",
      "report_ticket_type_breakdown",
      "report_seller_stats",
    ],
    column_type: "tickets",
    formats_available: ["csv"],
  },
  {
    id: "rc_num_tickets_sold_affirm",
    name: t("Num Affirm Tickets Sold"),
    enabled_for: [
      "report_event_breakdown",
      "product_breakdown_report",
      "report_ticket_type_breakdown",
      "report_seller_stats",
    ],
    column_type: "tickets",
    formats_available: ["csv"],
  },
  {
    id: "rc_num_tickets_sold_comp",
    name: t("Num Comp Tickets Sold"),
    enabled_for: [
      "report_event_breakdown",
      "product_breakdown_report",
      "report_ticket_type_breakdown",
      "report_seller_stats",
    ],
    column_type: "tickets",
    formats_available: ["csv"],
  },
  {
    id: "rc_num_tickets_sold_free",
    name: t("Num Free Tickets Sold"),
    enabled_for: [
      "report_event_breakdown",
      "product_breakdown_report",
      "report_ticket_type_breakdown",
      "report_seller_stats",
    ],
    column_type: "tickets",
    formats_available: ["csv"],
  },
  {
    id: "rc_num_tickets_refunded",
    name: t("Num Tickets Refunded"),
    enabled_for: ["report_ticket_type_breakdown"],
    column_type: "tickets",
    formats_available: ["csv"],
  },
  {
    id: "rc_is_child",
    name: t("Child Ticket"),
    enabled_for: ["report_shipping_fulfillment"],
    column_type: "tickets",
    formats_available: ["csv"],
  },
  {
    id: "rc_is_sub_ticket",
    name: t("Is Sub Ticket"),
    enabled_for: [
      "report_will_call_financial",
      "settlement_report",
      "advance_report",
      "report_marketing_campaign_details",
    ],
    column_type: "tickets",
    formats_available: ["csv"],
  },
  {
    id: "rc_member_first_name",
    name: t("Member First Name"),
    enabled_for: ["member_report"],
    column_type: "membership",
    formats_available: ["csv"],
  },
  {
    id: "rc_member_last_name",
    name: t("Member Last Name"),
    enabled_for: ["member_report"],
    column_type: "membership",
    formats_available: ["csv"],
  },
  {
    id: "rc_member_name",
    name: t("Member Name"),
    enabled_for: [
      "report_will_call_financial",
      "settlement_report",
      "advance_report",
      "member_report",
      "member_history_report",
      "member_seating_report",
      "report_marketing_campaign_details",
    ],
    column_type: "membership",
    formats_available: ["csv"],
  },
  {
    id: "rc_member_email",
    name: t("Member Email"),
    enabled_for: [
      "report_will_call_financial",
      "settlement_report",
      "advance_report",
      "member_report",
      "member_history_report",
      "member_seating_report",
      "report_marketing_campaign_details",
    ],
    column_type: "membership",
    formats_available: ["csv"],
  },
  {
    id: "rc_member_phone",
    name: t("Member Phone"),
    enabled_for: [
      "member_report",
      "member_history_report",
      "member_seating_report",
    ],
    column_type: "membership",
    formats_available: ["csv"],
  },
  {
    id: "rc_member_status",
    name: t("Member Status"),
    enabled_for: ["member_report", "member_seating_report"],
    column_type: "membership",
    formats_available: ["csv"],
  },
  {
    id: "rc_member_seating_reserved",
    name: t("Seating Reserved"),
    enabled_for: ["member_seating_report"],
    column_type: "membership",
    formats_available: ["csv"],
  },
  {
    id: "rc_member_quantity",
    name: t("Member Quantity"),
    enabled_for: ["member_report"],
    column_type: "membership",
    formats_available: ["csv"],
  },
  {
    id: "rc_member_expiry_date",
    name: t("Member Expiry Date"),
    enabled_for: ["member_report"],
    column_type: "membership",
    formats_available: ["csv"],
  },
  {
    id: "rc_member_barcode",
    name: t("Member Barcode"),
    enabled_for: ["member_report", "member_history_report"],
    column_type: "membership",
    formats_available: ["csv"],
  },
  {
    id: "rc_member_universal_code",
    name: t("Member Universal Code"),
    enabled_for: ["member_report"],
    column_type: "membership",
    formats_available: ["csv"],
  },
  {
    id: "rc_member_scans_allowed",
    name: t("Member Scans Allowed"),
    enabled_for: ["member_benefit_usage_report"],
    column_type: "membership",
    formats_available: ["csv"],
  },
  {
    id: "rc_member_scans_used",
    name: t("Member Scans Used"),
    enabled_for: ["member_report", "member_benefit_usage_report"],
    column_type: "membership",
    formats_available: ["csv"],
  },
  {
    id: "rc_member_history_amount",
    name: t("Amount"),
    enabled_for: ["member_history_report"],
    column_type: "membership",
    formats_available: ["csv"],
  },
  {
    id: "rc_member_discounts_allowed",
    name: t("Member Discounts Allowed"),
    enabled_for: ["member_benefit_usage_report"],
    column_type: "membership",
    formats_available: ["csv"],
  },
  {
    id: "rc_member_discounts_used",
    name: t("Member Discounts Used"),
    enabled_for: ["member_report", "member_benefit_usage_report"],
    column_type: "membership",
    formats_available: ["csv"],
  },
  {
    id: "rc_member_last_status_change",
    name: t("Member Last Status Change"),
    enabled_for: ["member_report"],
    column_type: "membership",
    formats_available: ["csv"],
  },
  {
    id: "rc_member_last_status_changed_by",
    name: t("Member Last Status Changed By"),
    enabled_for: ["member_report"],
    column_type: "membership",
    formats_available: ["csv"],
  },
  {
    id: "rc_membership_group_name",
    name: t("Membership Group Name"),
    enabled_for: [
      "report_will_call_financial",
      "settlement_report",
      "advance_report",
      "member_report",
      "member_history_report",
      "member_benefit_usage_report",
      "report_shipping_fulfillment",
      "member_seating_report",
      "report_marketing_campaign_details",
      "report_holds_stats",
    ],
    column_type: "membership",
    formats_available: ["csv"],
  },
  {
    id: "rc_membership_group_id",
    name: t("Membership Group ID"),
    enabled_for: [
      "report_will_call_financial",
      "settlement_report",
      "advance_report",
      "report_shipping_fulfillment",
      "report_marketing_campaign_details",
      "report_holds_stats",
    ],
    column_type: "membership",
    formats_available: ["csv"],
  },
  {
    id: "rc_membership_level_name",
    name: t("Membership Level Name"),
    enabled_for: [
      "report_will_call_financial",
      "settlement_report",
      "advance_report",
      "member_report",
      "member_history_report",
      "member_benefit_usage_report",
      "report_shipping_fulfillment",
      "member_seating_report",
      "report_marketing_campaign_details",
      "report_holds_stats",
    ],
    column_type: "membership",
    formats_available: ["csv"],
  },
  {
    id: "rc_membership_level_id",
    name: t("Membership Level ID"),
    enabled_for: [
      "report_will_call_financial",
      "settlement_report",
      "advance_report",
      "report_shipping_fulfillment",
      "report_marketing_campaign_details",
      "report_holds_stats",
    ],
    column_type: "membership",
    formats_available: ["csv"],
  },
  {
    id: "rc_membership_level_price",
    name: t("Membership Level Price"),
    enabled_for: [
      "report_will_call_financial",
      "settlement_report",
      "advance_report",
      "report_marketing_campaign_details",
    ],
    column_type: "membership",
    formats_available: ["csv"],
  },
  {
    id: "rc_member_status_before",
    name: t("Member Status Before"),
    enabled_for: ["member_history_report"],
    column_type: "membership",
    formats_available: ["csv"],
  },
  {
    id: "rc_member_status_after",
    name: t("Member Status After"),
    enabled_for: ["member_history_report"],
    column_type: "membership",
    formats_available: ["csv"],
  },
  {
    id: "rc_member_history_action",
    name: t("Member History Action"),
    enabled_for: ["member_history_report"],
    column_type: "membership",
    formats_available: ["csv"],
  },
  {
    id: "rc_member_history_type",
    name: t("Member History Type"),
    enabled_for: ["member_history_report"],
    column_type: "membership",
    formats_available: ["csv"],
  },
  {
    id: "rc_membership_benefit",
    name: t("Membership Benefit"),
    enabled_for: ["member_history_report", "member_benefit_usage_report"],
    column_type: "membership",
    formats_available: ["csv"],
  },
  {
    id: "rc_membership_benefit_type",
    name: t("Membership Benefit Type"),
    enabled_for: ["member_benefit_usage_report"],
    column_type: "membership",
    formats_available: ["csv"],
  },
  {
    id: "rc_member_latest_season",
    name: t("Member Latest Season"),
    enabled_for: ["member_report"],
    column_type: "membership",
    formats_available: ["csv"],
  },
  {
    id: "rc_product_attribute",
    name: t("Product Attribute Name"),
    enabled_for: [
      "report_will_call",
      "report_event_product_inventory",
      "report_will_call_financial",
      "settlement_report",
      "advance_report",
      "report_marketing_campaign_details",
    ],
    column_type: "products",
    formats_available: ["csv"],
  },
  {
    id: "rc_product_attribute_price",
    name: t("Product Attribute Price"),
    enabled_for: [
      "report_will_call_financial",
      "settlement_report",
      "advance_report",
      "report_marketing_campaign_details",
    ],
    column_type: "products",
    formats_available: ["csv"],
  },
  {
    id: "rc_product",
    name: t("Product Name"),
    enabled_for: [
      "report_will_call",
      "report_event_product_inventory",
      "report_will_call_financial",
      "settlement_report",
      "advance_report",
      "product_breakdown_report",
      "report_marketing_campaign_details",
    ],
    column_type: "products",
    formats_available: ["csv"],
  },
  {
    id: "rc_product_attribute_sku",
    name: t("SKU"),
    enabled_for: ["report_shipping_fulfillment"],
    column_type: "products",
    formats_available: ["csv"],
  },
  {
    id: "rc_purchaser_username",
    name: t("Purchaser Name"),
    enabled_for: ["gift_card_recipients_report"],
    column_type: "gift_cards",
    formats_available: ["csv"],
  },
  {
    id: "rc_purchaser_email",
    name: t("Purchaser Email"),
    enabled_for: ["gift_card_recipients_report"],
    column_type: "gift_cards",
    formats_available: ["csv"],
  },
  {
    id: "rc_purchaser_phone",
    name: t("Purchaser Phone Number"),
    enabled_for: ["gift_card_recipients_report"],
    column_type: "gift_cards",
    formats_available: ["csv"],
  },
  {
    id: "rc_sender_username",
    name: t("Sender Name"),
    enabled_for: ["gift_card_recipients_report"],
    column_type: "gift_cards",
    formats_available: ["csv"],
  },
  {
    id: "rc_gift_card_redeemed",
    name: t("Is Redeemed"),
    enabled_for: ["gift_card_recipients_report"],
    column_type: "gift_cards",
    formats_available: ["csv"],
  },
  {
    id: "rc_recipient_name",
    name: t("Recipient Name"),
    enabled_for: ["gift_card_recipients_report"],
    column_type: "gift_cards",
    formats_available: ["csv"],
  },
  {
    id: "rc_recipient_email",
    name: t("Recipient Email"),
    enabled_for: ["gift_card_recipients_report"],
    column_type: "gift_cards",
    formats_available: ["csv"],
  },
  {
    id: "rc_recipient_phone",
    name: t("Recipient Phone Number"),
    enabled_for: ["gift_card_recipients_report"],
    column_type: "gift_cards",
    formats_available: ["csv"],
  },
  {
    id: "rc_gift_card_id",
    name: t("Gift Card ID"),
    enabled_for: ["gift_card_recipients_report"],
    column_type: "gift_cards",
    formats_available: ["csv"],
  },
  {
    id: "rc_gift_card_name",
    name: t("Gift Card Name"),
    enabled_for: ["gift_card_recipients_report"],
    column_type: "gift_cards",
    formats_available: ["csv"],
  },
  {
    id: "rc_gift_card_denomination_id",
    name: t("Gift Card Denomination ID"),
    enabled_for: ["gift_card_recipients_report"],
    column_type: "gift_cards",
    formats_available: ["csv"],
  },
  {
    id: "rc_gift_card_denomination_price",
    name: t("Gift Card Denomination Price"),
    enabled_for: ["gift_card_recipients_report"],
    column_type: "gift_cards",
    formats_available: ["csv"],
  },
  {
    id: "rc_gift_card_amount_paid",
    name: t("Amount Paid"),
    enabled_for: ["gift_card_recipients_report"],
    column_type: "gift_cards",
    formats_available: ["csv"],
  },
  {
    id: "rc_total_gift_card_amount",
    name: t("Total Amount"),
    enabled_for: ["gift_card_recipients_report"],
    column_type: "gift_cards",
    formats_available: ["csv"],
  },
  {
    id: "rc_amount_advanced",
    name: t("Amount Advanced"),
    enabled_for: ["gift_card_recipients_report"],
    column_type: "gift_cards",
    formats_available: ["csv"],
  },
  {
    id: "rc_amount_used",
    name: t("Amount Used"),
    enabled_for: ["gift_card_recipients_report"],
    column_type: "gift_cards",
    formats_available: ["csv"],
  },
  {
    id: "rc_amount_remaining",
    name: t("Amount Remaining"),
    enabled_for: ["gift_card_recipients_report"],
    column_type: "gift_cards",
    formats_available: ["csv"],
  },
  {
    id: "rc_price_tier_name",
    name: t("Price Tier Name"),
    enabled_for: [
      "report_will_call_financial",
      "settlement_report",
      "advance_report",
    ],
    column_type: "price_tiers",
    formats_available: ["csv"],
  },
  {
    id: "rc_price_tier_id",
    name: t("Price Tier ID"),
    enabled_for: [
      "report_will_call_financial",
      "settlement_report",
      "advance_report",
    ],
    column_type: "price_tiers",
    formats_available: ["csv"],
  },
  {
    id: "rc_price_tier_price",
    name: t("Price Tier Price"),
    enabled_for: [
      "report_will_call_financial",
      "settlement_report",
      "advance_report",
    ],
    column_type: "price_tiers",
    formats_available: ["csv"],
  },
  {
    id: "rc_venue_name",
    name: t("Venue Name"),
    enabled_for: [
      "report_will_call_financial",
      "settlement_report",
      "advance_report",
      "report_marketing_campaign_details",
    ],
    column_type: "other",
    formats_available: ["csv"],
  },
  {
    id: "rc_venue_id",
    name: t("Venue ID"),
    enabled_for: [
      "report_will_call_financial",
      "settlement_report",
      "advance_report",
      "report_marketing_campaign_details",
    ],
    column_type: "other",
    formats_available: ["csv"],
  },
  {
    id: "rc_created",
    name: t("Purchase Date"),
    enabled_for: [
      "report_invoice_transaction",
      "report_will_call",
      "report_surveys",
      "report_shipping_fulfillment",
      "report_donor_transaction",
    ],
    column_type: "other",
    formats_available: ["csv"],
  },
  {
    id: "rc_updated",
    name: t("Last Updated"),
    enabled_for: ["report_holds_stats"],
    column_type: "other",
    formats_available: ["csv"],
  },
  {
    id: "rc_general_created",
    name: t("Created"),
    enabled_for: ["member_history_report"],
    column_type: "other",
    formats_available: ["csv"],
  },
  {
    id: "rc_survey_name",
    name: t("Survey Name"),
    enabled_for: ["report_surveys"],
    column_type: "other",
    formats_available: ["csv"],
  },
  {
    id: "rc_sold_by",
    name: t("Sold By"),
    enabled_for: [
      "report_invoice_transaction",
      "report_will_call",
      "report_will_call_financial",
      "settlement_report",
      "advance_report",
      "report_holds_stats",
      "report_marketing_campaign_details",
    ],
    column_type: "other",
    formats_available: ["csv"],
  },
  {
    id: "rc_sold_by_venue",
    name: t("Sold By Venue"),
    enabled_for: ["report_will_call"],
    column_type: "other",
    formats_available: ["csv"],
  },
  {
    id: "rc_referred_by",
    name: t("Referred By"),
    enabled_for: [
      "report_invoice_transaction",
      "report_will_call_financial",
      "settlement_report",
      "advance_report",
      "report_marketing_campaign_details",
    ],
    column_type: "other",
    formats_available: ["csv"],
  },
  {
    id: "rc_referred_link_description",
    name: t("Referral Link Description"),
    enabled_for: [
      "report_invoice_transaction",
      "report_will_call_financial",
      "settlement_report",
      "advance_report",
      "report_marketing_campaign_details",
    ],
    column_type: "other",
    formats_available: ["csv"],
  },
  {
    id: "rc_referred_link_URL",
    name: t("Referral Link URL"),
    enabled_for: [
      "report_will_call_financial",
      "settlement_report",
      "advance_report",
      "report_marketing_campaign_details",
    ],
    column_type: "other",
    formats_available: ["csv"],
  },
  {
    id: "rc_custom_question_info",
    name: t("Custom Question Info"),
    enabled_for: ["report_will_call", "member_report"],
    column_type: "other",
    formats_available: ["csv"],
  },
  {
    id: "rc_postal_address",
    name: t("Billing Postal Code/Zip"),
    enabled_for: [
      "report_invoice_transaction",
      "report_will_call_financial",
      "settlement_report",
      "advance_report",
      "report_donor_transaction",
      "report_marketing_campaign_details",
    ],
    column_type: "other",
    formats_available: ["csv"],
  },
  {
    id: "rc_billing_address",
    name: t("Billing Address"),
    enabled_for: ["report_event_product_inventory"],
    column_type: "other",
    formats_available: ["csv"],
  },
  {
    id: "rc_city_address",
    name: t("Billing City"),
    enabled_for: [
      "report_invoice_transaction",
      "report_will_call_financial",
      "settlement_report",
      "advance_report",
      "report_donor_transaction",
      "report_marketing_campaign_details",
    ],
    column_type: "other",
    formats_available: ["csv"],
  },
  {
    id: "rc_street_address",
    name: t("Billing Street"),
    enabled_for: [
      "report_invoice_transaction",
      "report_will_call_financial",
      "settlement_report",
      "advance_report",
      "report_donor_transaction",
      "report_marketing_campaign_details",
    ],
    column_type: "other",
    formats_available: ["csv"],
  },
  {
    id: "rc_province_address",
    name: t("Billing Province/State"),
    enabled_for: [
      "report_invoice_transaction",
      "report_will_call_financial",
      "settlement_report",
      "advance_report",
      "report_donor_transaction",
      "report_marketing_campaign_details",
    ],
    column_type: "other",
    formats_available: ["csv"],
  },
  {
    id: "rc_country_address",
    name: t("Billing Country"),
    enabled_for: [
      "report_invoice_transaction",
      "report_will_call_financial",
      "settlement_report",
      "advance_report",
      "report_donor_transaction",
      "report_marketing_campaign_details",
    ],
    column_type: "other",
    formats_available: ["csv"],
  },
  {
    id: "rc_discount_code",
    name: t("Discount Code Used"),
    enabled_for: [
      "report_invoice_transaction",
      "report_discount_usage_stats",
      "report_discount_creation",
      "report_will_call_financial",
      "settlement_report",
      "advance_report",
      "report_marketing_campaign_details",
    ],
    column_type: "other",
    formats_available: ["csv"],
  },
  {
    id: "rc_internal_info",
    name: t("Info"),
    enabled_for: ["report_invoice_transaction"],
    column_type: "other",
    formats_available: ["csv"],
  },
  {
    id: "rc_shipping_fulfillment_status",
    name: t("Fulfillment Status"),
    enabled_for: ["report_shipping_fulfillment"],
    column_type: "shipping",
    formats_available: ["csv"],
  },
  {
    id: "rc_fulfilled_by_employee",
    name: t("Fulfilled By Employee"),
    enabled_for: ["report_shipping_fulfillment"],
    column_type: "shipping",
    formats_available: ["csv"],
  },
  {
    id: "rc_shipping_fulfillment_date",
    name: t("Fulfillment Date"),
    enabled_for: ["report_shipping_fulfillment"],
    column_type: "shipping",
    formats_available: ["csv"],
  },
  {
    id: "rc_ticket_amount_to_ship",
    name: t("Quantity Per Order"),
    enabled_for: ["report_shipping_fulfillment"],
    column_type: "shipping",
    formats_available: ["csv"],
  },
  {
    id: "rc_shipping_method",
    name: t("Delivery Method"),
    enabled_for: [
      "report_will_call_financial",
      "settlement_report",
      "advance_report",
      "report_marketing_campaign_details",
    ],
    column_type: "shipping",
    formats_available: ["csv"],
  },
  {
    id: "rc_shipping_street_address",
    name: t("Shipping Street"),
    enabled_for: [
      "report_will_call_financial",
      "report_shipping_fulfillment",
      "report_venue_user",
      "settlement_report",
      "advance_report",
      "report_marketing_campaign_details",
    ],
    column_type: "other",
    formats_available: ["csv"],
  },
  {
    id: "rc_shipping_unit_number",
    name: t("Shipping Unit Number"),
    enabled_for: [
      "report_will_call_financial",
      "report_shipping_fulfillment",
      "report_venue_user",
      "settlement_report",
      "advance_report",
      "report_marketing_campaign_details",
    ],
    column_type: "other",
    formats_available: ["csv"],
  },
  {
    id: "rc_shipping_city_address",
    name: t("Shipping City"),
    enabled_for: [
      "report_will_call_financial",
      "report_shipping_fulfillment",
      "report_venue_user",
      "settlement_report",
      "advance_report",
      "report_marketing_campaign_details",
    ],
    column_type: "other",
    formats_available: ["csv"],
  },
  {
    id: "rc_shipping_province_address",
    name: t("Shipping Province/State"),
    enabled_for: [
      "report_will_call_financial",
      "report_shipping_fulfillment",
      "report_venue_user",
      "settlement_report",
      "advance_report",
      "report_marketing_campaign_details",
    ],
    column_type: "other",
    formats_available: ["csv"],
  },
  {
    id: "rc_shipping_country_address",
    name: t("Shipping Country"),
    enabled_for: [
      "report_will_call_financial",
      "report_shipping_fulfillment",
      "report_venue_user",
      "settlement_report",
      "advance_report",
      "report_marketing_campaign_details",
    ],
    column_type: "other",
    formats_available: ["csv"],
  },
  {
    id: "rc_shipping_postal_address",
    name: t("Shipping Postal Code/Zip"),
    enabled_for: [
      "report_will_call_financial",
      "report_shipping_fulfillment",
      "report_venue_user",
      "settlement_report",
      "advance_report",
      "report_marketing_campaign_details",
    ],
    column_type: "other",
    formats_available: ["csv"],
  },
  {
    id: "rc_shipping_cost",
    name: t("Shipping & Handling Fees"),
    enabled_for: [
      "report_will_call_financial",
      "settlement_report",
      "advance_report",
      "report_marketing_campaign_details",
    ],
    column_type: "other",
    formats_available: ["csv"],
  },
  {
    id: "rc_company_charges",
    name: t("Showpass Fees"),
    formats_available: ["csv"],
    enabled_for: [
      "report_invoice_transaction",
      "report_will_call_financial",
      "settlement_report",
      "advance_report",
      "report_password_used_breakdown",
      "report_discount_usage_stats",
      "report_event_breakdown",
      "report_ticket_type_breakdown",
      "product_breakdown_report",
      "report_marketing_campaign_details",
    ],
    column_type: "financial",
  },
  {
    id: "rc_total_price",
    name: t("Total Price"),
    enabled_for: ["waitlist_subscriber_report"],
    column_type: "tickets",
    formats_available: ["csv"],
  },
  {
    id: "rc_total_price_no_fees",
    name: t("Total Price No Fees"),
    enabled_for: ["waitlist_subscriber_report"],
    column_type: "tickets",
    formats_available: ["csv"],
  },
  {
    id: "rc_refund_amount",
    name: t("Refund Amount"),
    enabled_for: ["reseller_submissions_report"],
    column_type: "tickets",
    formats_available: ["csv"],
  },
  {
    id: "rc_num_of_passwords_used",
    name: t("Number Of Passwords Used"),
    enabled_for: ["report_password_used_breakdown"],
    column_type: "inventory",
    formats_available: ["csv"],
  },
  {
    id: "rc_num_of_standard_tickets_sold",
    name: t("Standard Tickets Sold"),
    enabled_for: ["product_breakdown_report", "report_event_breakdown"],
    column_type: "inventory",
    formats_available: ["pdf"],
  },
  {
    id: "rc_num_of_tickets_sold_redeemable",
    name: t("Quantity"),
    enabled_for: ["report_event_breakdown"],
    column_type: "inventory",
    formats_available: ["pdf"],
  },
  {
    id: "rc_num_of_redeemable_tickets",
    name: t("Total Redeemable Tickets"),
    enabled_for: [
      "report_event_breakdown",
      "product_breakdown_report",
      "report_ticket_type_breakdown",
    ],
    column_type: "inventory",
    formats_available: ["csv"],
  },
  {
    id: "rc_total_inventory",
    name: t("Total Inventory"),
    enabled_for: [
      "report_event_breakdown",
      "product_breakdown_report",
      "report_ticket_type_breakdown",
    ],
    column_type: "inventory",
    formats_available: ["pdf", "csv"],
  },
  {
    id: "rc_num_of_total_packages",
    name: t("Total Packages"),
    enabled_for: ["report_event_breakdown", "report_ticket_type_breakdown"],
    column_type: "inventory",
    formats_available: ["pdf", "csv"],
  },
  {
    id: "rc_total_ticket_package_inventory",
    name: t("Total Ticket Package Inventory"),
    enabled_for: ["report_event_breakdown"],
    column_type: "inventory",
    formats_available: ["pdf"],
  },
  {
    id: "rc_num_of_sub_tickets_from_event",
    name: t("Sub Tickets From Event"),
    enabled_for: ["report_event_breakdown"],
    column_type: "inventory",
    formats_available: ["pdf", "csv"],
  },
  {
    id: "rc_num_of_sub_tickets_from_outside_event",
    name: t("Sub Tickets From Outside Event"),
    enabled_for: ["report_event_breakdown"],
    column_type: "inventory",
    formats_available: ["pdf", "csv"],
  },
  {
    id: "rc_num_of_tickets_not_included_in_stats",
    name: t("Tickets Not Included In Stats"),
    enabled_for: ["report_event_breakdown", "report_ticket_type_breakdown"],
    column_type: "inventory",
    formats_available: ["pdf", "csv"],
  },
  {
    id: "rc_num_of_hold_tickets",
    name: t("Tickets On Hold"),
    enabled_for: ["product_breakdown_report", "report_event_breakdown"],
    column_type: "inventory",
    formats_available: ["pdf"],
  },
  {
    id: "rc_hold_link",
    name: t("Hold Link"),
    enabled_for: ["report_holds_stats"],
    column_type: "tickets",
    formats_available: ["csv"],
  },
  {
    id: "rc_num_of_payment_plans_copy",
    name: t("Payment Plans Sold"),
    enabled_for: ["report_event_breakdown"],
    column_type: "inventory",
    formats_available: ["pdf"],
  },
  {
    id: "rc_utm_campaign",
    name: t("UTM Campaign"),
    enabled_for: [
      "report_marketing_campaigns",
      "report_marketing_campaign_details",
    ],
    column_type: "marketing_campaigns",
    formats_available: ["csv"],
  },
  {
    id: "rc_utm_source",
    name: t("UTM Source"),
    enabled_for: [
      "report_marketing_campaigns",
      "report_marketing_campaign_details",
    ],
    column_type: "marketing_campaigns",
    formats_available: ["csv"],
  },
  {
    id: "rc_utm_medium",
    name: t("UTM Medium"),
    enabled_for: [
      "report_marketing_campaigns",
      "report_marketing_campaign_details",
    ],
    column_type: "marketing_campaigns",
    formats_available: ["csv"],
  },
  {
    id: "rc_views",
    name: t("Page Views"),
    enabled_for: ["report_marketing_campaigns"],
    column_type: "marketing_campaigns",
    formats_available: ["csv"],
  },
  {
    id: "rc_add_to_cart",
    name: t("Add To Cart Events"),
    enabled_for: ["report_marketing_campaigns"],
    column_type: "marketing_campaigns",
    formats_available: ["csv"],
  },
  {
    id: "rc_add_to_cart_rate",
    name: t("Add To Cart Rate"),
    enabled_for: ["report_marketing_campaigns"],
    column_type: "marketing_campaigns",
    formats_available: ["csv"],
  },
  {
    id: "rc_initiate_checkout",
    name: t("Initiate Checkout Events"),
    enabled_for: ["report_marketing_campaigns"],
    column_type: "marketing_campaigns",
    formats_available: ["csv"],
  },
  {
    id: "rc_initiate_checkout_rate",
    name: t("Initiate Checkout Rate"),
    enabled_for: ["report_marketing_campaigns"],
    column_type: "marketing_campaigns",
    formats_available: ["csv"],
  },
  {
    id: "rc_purchases",
    name: t("Purchase Events"),
    enabled_for: ["report_marketing_campaigns"],
    column_type: "marketing_campaigns",
    formats_available: ["csv"],
  },
  {
    id: "rc_purchase_rate",
    name: t("Purchase Rate"),
    enabled_for: ["report_marketing_campaigns"],
    column_type: "marketing_campaigns",
    formats_available: ["csv"],
  },
  {
    id: "rc_info_student_number",
    name: t("Student Number"),
    enabled_for: ["report_will_call", "member_report"],
    column_type: "tickets",
    formats_available: ["csv"],
  },
  {
    id: "rc_info_company",
    name: t("Company"),
    enabled_for: ["report_will_call", "member_report"],
    column_type: "tickets",
    formats_available: ["csv"],
  },
  {
    id: "rc_info_job_title",
    name: t("Job Title"),
    enabled_for: ["report_will_call", "member_report"],
    column_type: "tickets",
    formats_available: ["csv"],
  },
  {
    id: "rc_info_first_name",
    name: t("First Name"),
    enabled_for: [
      "report_will_call",
      "waitlist_subscriber_report",
      "reseller_submissions_report",
    ],
    column_type: "tickets",
    formats_available: ["csv"],
  },
  {
    id: "rc_info_last_name",
    name: t("Last Name"),
    enabled_for: [
      "report_will_call",
      "waitlist_subscriber_report",
      "reseller_submissions_report",
    ],
    column_type: "tickets",
    formats_available: ["csv"],
  },
  {
    id: "rc_info_phone_number",
    name: t("Phone Number"),
    enabled_for: ["report_will_call"],
    column_type: "tickets",
    formats_available: ["csv"],
  },
  {
    id: "rc_info_email",
    name: t("Info Email"),
    enabled_for: ["report_will_call"],
    column_type: "tickets",
    formats_available: ["csv"],
  },
  {
    id: "rc_info_home_address_unit_number",
    name: t("Guest Unit Number"),
    enabled_for: ["report_will_call", "member_report"],
    column_type: "tickets",
    formats_available: ["csv"],
  },
  {
    id: "rc_info_home_address_street_name",
    name: t("Guest Street Name"),
    enabled_for: ["report_will_call", "member_report"],
    column_type: "tickets",
    formats_available: ["csv"],
  },
  {
    id: "rc_info_home_address_city",
    name: t("Guest City"),
    enabled_for: ["report_will_call", "member_report"],
    column_type: "tickets",
    formats_available: ["csv"],
  },
  {
    id: "rc_info_home_address_province",
    name: t("Guest Province"),
    enabled_for: ["report_will_call", "member_report"],
    column_type: "tickets",
    formats_available: ["csv"],
  },
  {
    id: "rc_info_home_address_postal",
    name: t("Guest Postal Code"),
    enabled_for: ["report_will_call", "member_report"],
    column_type: "tickets",
    formats_available: ["csv"],
  },
  {
    id: "rc_info_home_address_country",
    name: t("Guest Country"),
    enabled_for: ["report_will_call", "member_report"],
    column_type: "tickets",
    formats_available: ["csv"],
  },
  {
    id: "rc_info_birthday",
    name: t("Birthday"),
    enabled_for: ["report_will_call", "member_report"],
    column_type: "tickets",
    formats_available: ["csv"],
  },
  {
    id: "rc_info_license_plate",
    name: t("License Plate"),
    enabled_for: ["report_will_call", "member_report"],
    column_type: "tickets",
    formats_available: ["csv"],
  },
  {
    id: "rc_password",
    name: t("Password"),
    enabled_for: ["report_password_used_breakdown"],
    column_type: "other",
    formats_available: ["csv"],
  },
  {
    id: "rc_status",
    name: t("Status"),
    enabled_for: ["waitlist_subscriber_report", "reseller_submissions_report"],
    column_type: "other",
    formats_available: ["csv"],
  },
  {
    id: "rc_donation_total",
    name: t("Donation Total"),
    enabled_for: ["report_donor_transaction"],
    column_type: "donation",
    formats_available: ["csv"],
  },
  {
    id: "rc_registration_number",
    name: t("Charity Registration Number"),
    enabled_for: ["report_donor_transaction"],
    column_type: "donation",
    formats_available: ["csv"],
  },
  {
    id: "rc_charity_name",
    name: t("Charity Name"),
    enabled_for: ["report_donor_transaction"],
    column_type: "donation",
    formats_available: ["csv"],
  },
  {
    id: "rc_charity_currency",
    name: t("Charity Currency"),
    enabled_for: ["report_donor_transaction"],
    column_type: "donation",
    formats_available: ["csv"],
  },
  {
    id: "rc_ticket_pay_what_you_can_enabled",
    enabled_for: ["report_will_call_financial"],
    name: t("Pay What You Can Enabled"),
    column_type: "ticket_history",
    formats_available: ["csv"],
  },
  {
    id: "rc_ticket_pay_what_you_can_difference",
    enabled_for: ["report_will_call_financial"],
    name: t("Pay What You Can Surplus/Deficit"),
    column_type: "ticket_history",
    formats_available: ["csv"],
  },
  {
    id: "rc_affirm_revenue",
    name: t("Affirm Revenue"),
    enabled_for: [
      "report_event_breakdown",
      "product_breakdown_report",
      "report_ticket_type_breakdown",
      "report_seller_stats",
    ],
    column_type: "financial",
    formats_available: ["csv"],
  },
  {
    id: "rc_display_gross_sales",
    name: t("Gross Sales"),
    formats_available: ["csv"],
    enabled_for: [
      "report_will_call_financial",
      "settlement_report",
      "advance_report",
      "report_password_used_breakdown",
      "report_discount_usage_stats",
      "report_event_breakdown",
      "report_ticket_type_breakdown",
      "product_breakdown_report",
      "report_marketing_campaign_details",
    ],
    column_type: "financial",
  },
  {
    id: "rc_disputes",
    name: t("Chargebacks"),
    formats_available: ["pdf"],
    enabled_for: ["report_event_breakdown", "product_breakdown_report"],
    column_type: "financial",
  },
  {
    id: "rc_amount_company_earned_sub_custom_fees",
    name: t("Service Fees"),
    formats_available: ["pdf"],
    enabled_for: ["report_event_breakdown", "product_breakdown_report"],
    column_type: "financial",
  },
  {
    id: "rc_company_charges_sub_custom_fees",
    name: t("Showpass Fees"),
    formats_available: ["pdf"],
    enabled_for: ["report_event_breakdown", "product_breakdown_report"],
    column_type: "financial",
  },
  {
    id: "rc_cc_charges",
    name: t("Processing Fees"),
    formats_available: ["csv"],
    enabled_for: [
      "report_invoice_transaction",
      "report_will_call_financial",
      "settlement_report",
      "advance_report",
      "report_password_used_breakdown",
      "report_discount_usage_stats",
      "report_event_breakdown",
      "report_ticket_type_breakdown",
      "product_breakdown_report",
      "report_marketing_campaign_details",
    ],
    column_type: "financial",
  },
  {
    id: "rc_discovery_charges",
    name: t("Discovery Fees"),
    formats_available: ["csv"],
    enabled_for: [
      "report_invoice_transaction",
      "report_will_call_financial",
      "settlement_report",
      "advance_report",
      "report_password_used_breakdown",
      "report_discount_usage_stats",
      "report_event_breakdown",
      "report_ticket_type_breakdown",
      "product_breakdown_report",
      "report_marketing_campaign_details",
    ],
    column_type: "financial",
  },
  {
    id: "rc_resale_charges",
    name: t("Resale Fees"),
    formats_available: ["csv"],
    enabled_for: [
      "report_invoice_transaction",
      "report_will_call_financial",
      "settlement_report",
      "advance_report",
      "report_password_used_breakdown",
      "report_discount_usage_stats",
      "report_event_breakdown",
      "report_ticket_type_breakdown",
      "product_breakdown_report",
      "report_marketing_campaign_details",
    ],
    column_type: "financial",
  },
  {
    id: "rc_invoice_fee_total",
    name: t("Invoices"),
    formats_available: ["pdf"],
    enabled_for: ["report_event_breakdown", "product_breakdown_report"],
    column_type: "financial",
  },
  {
    id: "rc_account_credit_applied",
    name: t("Account Credits Applied"),
    formats_available: ["csv"],
    enabled_for: [
      "report_will_call_financial",
      "settlement_report",
      "advance_report",
      "report_password_used_breakdown",
      "report_discount_usage_stats",
      "report_event_breakdown",
      "report_ticket_type_breakdown",
      "product_breakdown_report",
      "report_marketing_campaign_details",
    ],
    column_type: "financial",
  },
  {
    id: "rc_exchange_credit_applied",
    name: t("Exchange Credits"),
    formats_available: ["pdf"],
    enabled_for: ["report_event_breakdown", "product_breakdown_report"],
    column_type: "financial",
  },
  {
    id: "rc_venue_credit_applied",
    name: t("Organizer Credits"),
    formats_available: ["pdf"],
    enabled_for: ["report_event_breakdown", "product_breakdown_report"],
    column_type: "financial",
  },
  {
    id: "rc_user_credit_applied",
    name: t("Universal Credits"),
    formats_available: ["pdf"],
    enabled_for: ["report_event_breakdown", "product_breakdown_report"],
    column_type: "financial",
  },
  {
    id: "rc_referral_credit_applied",
    name: t("Referral Credits"),
    formats_available: ["pdf"],
    enabled_for: ["report_event_breakdown", "product_breakdown_report"],
    column_type: "financial",
  },
  {
    id: "rc_exchanged_out",
    name: t("Exchanged Out"),
    formats_available: ["csv"],
    enabled_for: [
      "report_will_call_financial",
      "settlement_report",
      "advance_report",
      "report_password_used_breakdown",
      "report_discount_usage_stats",
      "report_event_breakdown",
      "report_ticket_type_breakdown",
      "product_breakdown_report",
      "report_marketing_campaign_details",
    ],
    column_type: "financial",
  },
  {
    id: "rc_account_credit_refunds",
    name: t("Account Credit Refunds"),
    formats_available: ["csv"],
    enabled_for: [
      "report_will_call_financial",
      "settlement_report",
      "advance_report",
      "report_password_used_breakdown",
      "report_discount_usage_stats",
      "report_event_breakdown",
      "report_ticket_type_breakdown",
      "product_breakdown_report",
      "report_marketing_campaign_details",
    ],
    column_type: "financial",
  },
  {
    id: "rc_display_organizer_charges",
    name: t("Total Organizer Fees"),
    formats_available: ["csv"],
    enabled_for: [
      "report_invoice_transaction",
      "report_will_call_financial",
      "settlement_report",
      "advance_report",
      "report_password_used_breakdown",
      "report_discount_usage_stats",
      "report_event_breakdown",
      "report_ticket_type_breakdown",
      "product_breakdown_report",
      "report_marketing_campaign_details",
    ],
    column_type: "financial",
  },
  {
    id: "rc_credit_memo_total",
    name: t("Credit Memos"),
    formats_available: ["pdf"],
    enabled_for: ["report_event_breakdown", "product_breakdown_report"],
    column_type: "financial",
  },
  {
    id: "rc_card_tax",
    name: t("Total Taxes"),
    formats_available: ["pdf"],
    enabled_for: ["report_event_breakdown", "product_breakdown_report"],
    column_type: "financial",
  },
  {
    id: "rc_card_shipping_costs",
    name: t("Shipping Costs"),
    formats_available: ["pdf"],
    enabled_for: ["report_event_breakdown", "product_breakdown_report"],
    column_type: "financial",
  },
  {
    id: "rc_other_settlement_difference",
    name: t("Other Payment Adjustment"),
    formats_available: ["pdf"],
    enabled_for: ["report_event_breakdown", "product_breakdown_report"],
    column_type: "financial",
  },
  {
    id: "rc_cash_settlement_difference",
    name: t("Cash Payment Adjustment"),
    formats_available: ["pdf"],
    enabled_for: ["report_event_breakdown", "product_breakdown_report"],
    column_type: "financial",
  },
  {
    id: "rc_custom_processor_adjustment",
    name: t("Custom Processor Adjustment"),
    formats_available: ["pdf"],
    enabled_for: ["report_event_breakdown", "product_breakdown_report"],
    column_type: "financial",
  },
  {
    id: "rc_square_oauth_adjustment",
    name: t("Square OAuth Adjustment"),
    formats_available: ["pdf"],
    enabled_for: ["report_event_breakdown", "product_breakdown_report"],
    column_type: "financial",
  },
  {
    id: "rc_advances",
    name: t("Advances"),
    formats_available: ["pdf"],
    enabled_for: ["report_event_breakdown", "product_breakdown_report"],
    column_type: "financial",
  },
  {
    id: "rc_settlements",
    name: t("Settlements"),
    formats_available: ["pdf"],
    enabled_for: ["report_event_breakdown", "product_breakdown_report"],
    column_type: "financial",
  },
  {
    id: "rc_non_venue_credit_applied",
    name: t("Account Credit Adjustment"),
    formats_available: ["pdf"],
    enabled_for: ["report_event_breakdown", "product_breakdown_report"],
    column_type: "financial",
  },
  {
    id: "rc_amount_paid",
    name: t("Settlement Amount"),
    formats_available: ["csv"],
    enabled_for: [
      "report_will_call_financial",
      "settlement_report",
      "advance_report",
      "report_password_used_breakdown",
      "report_discount_usage_stats",
      "report_event_breakdown",
      "report_ticket_type_breakdown",
      "product_breakdown_report",
      "report_marketing_campaign_details",
    ],
    column_type: "financial",
  },
  {
    id: "rc_pre_tax_company_charges",
    name: t("Pre-Tax Showpass Fees"),
    formats_available: ["csv"],
    enabled_for: [
      "report_invoice_transaction",
      "report_will_call_financial",
      "settlement_report",
      "advance_report",
      "report_password_used_breakdown",
      "report_discount_usage_stats",
      "report_event_breakdown",
      "report_ticket_type_breakdown",
      "product_breakdown_report",
      "report_marketing_campaign_details",
    ],
    column_type: "financial",
  },
  {
    id: "rc_company_charges_tax",
    name: t("Showpass Fees Tax"),
    formats_available: ["csv"],
    enabled_for: [
      "report_invoice_transaction",
      "report_will_call_financial",
      "settlement_report",
      "advance_report",
      "report_password_used_breakdown",
      "report_discount_usage_stats",
      "report_event_breakdown",
      "report_ticket_type_breakdown",
      "product_breakdown_report",
      "report_marketing_campaign_details",
    ],
    column_type: "financial",
  },
  {
    id: "rc_pre_tax_processing_fees",
    name: t("Pre-Tax Processing Fees"),
    formats_available: ["csv"],
    enabled_for: [
      "report_invoice_transaction",
      "report_will_call_financial",
      "settlement_report",
      "advance_report",
      "report_password_used_breakdown",
      "report_discount_usage_stats",
      "report_event_breakdown",
      "report_ticket_type_breakdown",
      "product_breakdown_report",
      "report_marketing_campaign_details",
    ],
    column_type: "financial",
  },
  {
    id: "rc_processing_fees_tax",
    name: t("Processing Fees Tax"),
    formats_available: ["csv"],
    enabled_for: [
      "report_invoice_transaction",
      "report_will_call_financial",
      "settlement_report",
      "advance_report",
      "report_password_used_breakdown",
      "report_discount_usage_stats",
      "report_event_breakdown",
      "report_ticket_type_breakdown",
      "product_breakdown_report",
      "report_marketing_campaign_details",
    ],
    column_type: "financial",
  },
  {
    id: "rc_pre_tax_discovery_charges",
    name: t("Pre-Tax Discovery Fees"),
    formats_available: ["csv"],
    enabled_for: [
      "report_invoice_transaction",
      "report_will_call_financial",
      "settlement_report",
      "advance_report",
      "report_password_used_breakdown",
      "report_discount_usage_stats",
      "report_event_breakdown",
      "report_ticket_type_breakdown",
      "product_breakdown_report",
      "report_marketing_campaign_details",
    ],
    column_type: "financial",
  },
  {
    id: "rc_discovery_charges_tax",
    name: t("Discovery Fees Tax"),
    formats_available: ["csv"],
    enabled_for: [
      "report_invoice_transaction",
      "report_will_call_financial",
      "settlement_report",
      "advance_report",
      "report_password_used_breakdown",
      "report_discount_usage_stats",
      "report_event_breakdown",
      "report_ticket_type_breakdown",
      "product_breakdown_report",
      "report_marketing_campaign_details",
    ],
    column_type: "financial",
  },
  {
    id: "rc_pre_tax_resale_charges",
    name: t("Pre-Tax Resale Fees"),
    formats_available: ["csv"],
    enabled_for: [
      "report_invoice_transaction",
      "report_will_call_financial",
      "settlement_report",
      "advance_report",
      "report_password_used_breakdown",
      "report_discount_usage_stats",
      "report_event_breakdown",
      "report_ticket_type_breakdown",
      "product_breakdown_report",
      "report_marketing_campaign_details",
    ],
    column_type: "financial",
  },
  {
    id: "rc_resale_charges_tax",
    name: t("Resale Fees Tax"),
    formats_available: ["csv"],
    enabled_for: [
      "report_invoice_transaction",
      "report_will_call_financial",
      "settlement_report",
      "advance_report",
      "report_password_used_breakdown",
      "report_discount_usage_stats",
      "report_event_breakdown",
      "report_ticket_type_breakdown",
      "product_breakdown_report",
      "report_marketing_campaign_details",
    ],
    column_type: "financial",
  },
  {
    id: "rc_organizer_item_tax",
    name: t("Item Taxes"),
    formats_available: ["csv"],
    enabled_for: [
      "report_invoice_transaction",
      "report_will_call_financial",
      "settlement_report",
      "advance_report",
      "report_password_used_breakdown",
      "report_discount_usage_stats",
      "report_event_breakdown",
      "report_ticket_type_breakdown",
      "product_breakdown_report",
      "report_marketing_campaign_details",
    ],
    column_type: "financial",
  },
  {
    id: "rc_organizer_fee_tax",
    name: t("Organizer Fee Taxes"),
    formats_available: ["csv"],
    enabled_for: [
      "report_invoice_transaction",
      "report_will_call_financial",
      "settlement_report",
      "advance_report",
      "report_password_used_breakdown",
      "report_discount_usage_stats",
      "report_event_breakdown",
      "report_ticket_type_breakdown",
      "product_breakdown_report",
      "report_marketing_campaign_details",
    ],
    column_type: "financial",
  },
  {
    id: "rc_adjustment",
    name: t("Adjustments"),
    formats_available: ["csv"],
    enabled_for: [
      "report_will_call_financial",
      "settlement_report",
      "advance_report",
      "report_password_used_breakdown",
      "report_discount_usage_stats",
      "report_event_breakdown",
      "report_ticket_type_breakdown",
      "product_breakdown_report",
      "report_marketing_campaign_details",
    ],
    column_type: "financial",
  },
] as const;

export const COLUMN_CORE_VALUES_MAP = {
  COLUMN_DISPLAY_GROSS_SALES: {
    id: "rc_display_gross_sales",
    name: t("Gross Sales"),
    value_descriptor: "display_gross_sales",
    tooltip: "Before Discounts and Refunds",
  },
  COLUMN_TICKETS_TOTAL: {
    id: "rc_tickets_total",
    name: t("Tickets"),
    value_descriptor: "tickets_total",
    count_descriptor: "tickets_total_count",
  },
  COLUMN_PRODUCTS_TOTAL: {
    id: "rc_products_total",
    name: t("Products"),
    value_descriptor: "products_total",
    count_descriptor: "products_total_count",
  },
  COLUMN_MEMBERSHIPS_TOTAL: {
    id: "rc_memberships_total",
    name: t("Memberships"),
    value_descriptor: "memberships_total",
    count_descriptor: "memberships_total_count",
  },
  COLUMN_DISCOUNTS: {
    id: "rc_discounts",
    name: t("Discounts"),
    value_descriptor: "discounts",
    count_descriptor: "discounts_count",
    tooltip: "Includes amounts that may have been refunded",
  },
  COLUMN_REFUNDS: {
    id: "rc_refunds",
    name: t("Refunds"),
    value_descriptor: "refunds",
    count_descriptor: "refunds_count",
  },
  COLUMN_DISPUTES: {
    id: "rc_disputes",
    name: t("Chargebacks"),
    value_descriptor: "disputes",
    count_descriptor: "disputes_count",
  },
  COLUMN_ACCOUNT_CREDIT_APPLIED: {
    id: "rc_account_credit_applied",
    name: t("Account Credits Applied"),
    value_descriptor: "total_credit_applied",
    count_descriptor: "total_credit_applied_count",
  },
  COLUMN_EXCHANGE_CREDIT_APPLIED: {
    id: "rc_exchange_credit_applied",
    name: t("Exchange Credits"),
    value_descriptor: "exchange_credit_applied",
    count_descriptor: "exchange_credit_applied_count",
  },
  COLUMN_VENUE_CREDIT_APPLIED: {
    id: "rc_venue_credit_applied",
    name: t("Organizer Credits"),
    value_descriptor: "venue_credit_applied",
    count_descriptor: "venue_credit_applied_count",
  },
  COLUMN_USER_CREDIT_APPLIED: {
    id: "rc_user_credit_applied",
    name: t("Universal Credits"),
    value_descriptor: "user_credit_applied",
    count_descriptor: "user_credit_applied_count",
  },
  COLUMN_REFERRAL_CREDIT_APPLIED: {
    id: "rc_referral_credit_applied",
    name: t("Referral Credits"),
    value_descriptor: "referral_credit_applied",
    count_descriptor: "referral_credit_applied_count",
  },
  COLUMN_NET_SALES: {
    id: "rc_gross_sales",
    name: t("Net Sales"),
    value_descriptor: "gross_sales",
    tooltip: "Less discounts & refunds",
  },
  COLUMN_EXCHANGED_OUT: {
    id: "rc_exchanged_out",
    name: t("Exchanged Out"),
    value_descriptor: "exchanged_out",
  },
  COLUMN_ACCOUNT_CREDIT_REFUNDS: {
    id: "rc_account_credit_refunds",
    name: t("Account Credit Refunds"),
    value_descriptor: "account_credit_refunds",
  },
  COLUMN_SERVICE_FEES: {
    id: "rc_amount_company_earned",
    name: t("Service Fees"),
    value_descriptor: "amount_company_earned",
    tooltip: "Combined Showpass & Processing Fees",
  },
  COLUMN_SERVICE_FEES_SUB_CUSTOM_FEES: {
    id: "rc_amount_company_earned_sub_custom_fees",
    name: t("Service Fees"),
    value_descriptor: "amount_company_earned_sub_custom_fees",
    tooltip: "Combined Showpass & Processing Fees",
  },
  COLUMN_SHOWPASS_FEES: {
    id: "rc_company_charges",
    name: t("Showpass Fees"),
    value_descriptor: "company_charges",
  },
  COLUMN_PRE_TAX_SHOWPASS_FEES: {
    id: "rc_pre_tax_company_charges",
    name: t("Pre-Tax Showpass Fees"),
    value_descriptor: "pre_tax_company_charges",
  },
  COLUMN_SHOWPASS_FEES_TAX: {
    id: "rc_company_charges_tax",
    name: t("Showpass Fees Tax"),
    value_descriptor: "company_charges_tax",
  },
  COLUMN_SHOWPASS_FEES_SUB_CUSTOM_FEES: {
    id: "rc_company_charges_sub_custom_fees",
    name: t("Showpass Fees"),
    value_descriptor: "company_charges_sub_custom_fees",
  },
  COLUMN_PROCESSING_FEES: {
    id: "rc_cc_charges",
    name: t("Processing Fees"),
    value_descriptor: "cc_charges",
    tooltip: "Charges from credit card processing",
  },
  COLUMN_PRE_TAX_PROCESSING_FEES: {
    id: "rc_pre_tax_processing_fees",
    name: t("Pre-Tax Processing Fees"),
    value_descriptor: "pre_tax_cc_charges",
  },
  COLUMN_PROCESSING_FEES_TAX: {
    id: "rc_processing_fees_tax",
    name: t("Processing Fees Tax"),
    value_descriptor: "cc_charges_tax",
  },
  COLUMN_DISCOVERY_FEES: {
    id: "rc_discovery_charges",
    name: t("Discovery Fees"),
    value_descriptor: "discovery_charges",
    tooltip: "Charges from Showpass discovery fees.",
  },
  COLUMN_PRE_TAX_DISCOVERY_FEES: {
    id: "rc_pre_tax_discovery_charges",
    name: t("Pre-Tax Discovery Fees"),
    value_descriptor: "pre_tax_discovery_charges",
  },
  COLUMN_DISCOVERY_FEES_TAX: {
    id: "rc_discovery_charges_tax",
    name: t("Discovery Fees Tax"),
    value_descriptor: "discovery_charges_tax",
  },
  COLUMN_RESALE_FEES: {
    id: "rc_resale_charges",
    name: t("Resale Fees"),
    value_descriptor: "resale_charges",
    tooltip: "Charges from Showpass resale fees.",
  },
  COLUMN_PRE_TAX_RESALE_FEES: {
    id: "rc_pre_tax_resale_charges",
    name: t("Pre-Tax Resale Fees"),
    value_descriptor: "pre_tax_resale_charges",
  },
  COLUMN_RESALE_FEES_TAX: {
    id: "rc_resale_charges_tax",
    name: t("Resale Fees Tax"),
    value_descriptor: "resale_charges_tax",
  },
  COLUMN_ACCOUNT_CREDITS: {
    id: "rc_account_credits",
    name: t("Account Credits"),
    value_descriptor: "total_credit_applied",
    key: "COLUMN_ACCOUNT_CREDITS",
  },
  COLUMN_DISPLAY_GROSS_REVENUE: {
    id: "rc_display_gross_revenue",
    name: t("Gross Revenue"),
    value_descriptor: "display_gross_revenue",
    tooltip: "Less Showpass fees & seller commissions",
  },
  COLUMN_ORGANIZER_FEES: {
    id: "rc_display_organizer_charges",
    name: t("Total Organizer Fees"),
    value_descriptor: "negated_display_organizer_charges",
  },
  COLUMN_TOTAL_TAXES: {
    id: "rc_tax",
    name: t("Total Organizer Taxes"),
    value_descriptor: "negated_tax",
  },
  COLUMN_ORGANIZER_ITEM_TAX: {
    id: "rc_organizer_item_tax",
    name: t("Item Taxes"),
    value_descriptor: "organizer_item_tax",
  },
  COLUMN_ORGANIZER_FEE_TAX: {
    id: "rc_organizer_fee_tax",
    name: t("Organizer Fee Taxes"),
    value_descriptor: "organizer_fee_tax",
  },
  COLUMN_SHIPPING_COSTS: {
    id: "rc_shipping_costs",
    name: t("Shipping Costs"),
    value_descriptor: "shipping_cost",
    count_descriptor: "shipping_cost_count",
  },
  COLUMN_INVOICE_FEE_TOTAL: {
    id: "rc_invoice_fee_total",
    name: t("Invoices"),
    value_descriptor: "invoice_fee_total",
    count_descriptor: "invoice_fee_total_count",
    tooltip: "Email, SMS, Hardware Rentals, etc.",
  },
  COLUMN_CREDIT_MEMO_TOTAL: {
    id: "rc_credit_memo_total",
    name: t("Credit Memos"),
    value_descriptor: "credit_memo_total",
    count_descriptor: "credit_memo_total_count",
  },
  COLUMN_DISPLAY_NET_REVENUE: {
    id: "rc_display_net_revenue",
    name: t("Net Revenue"),
    value_descriptor: "display_net_revenue",
    tooltip: "Less all fees & taxes",
  },
  COLUMN_CARD_ORGANIZER_FEES: {
    id: "rc_card_organizer_charges",
    name: t("Organizer Fees"),
    tooltip: "Collected by Showpass",
    value_descriptor: "settlement_organizer_charges",
  },
  COLUMN_CARD_TAXES: {
    id: "rc_card_tax",
    name: t("Total Taxes"),
    tooltip: "Collected by Showpass",
    value_descriptor: "settlement_card_tax",
  },
  COLUMN_CARD_SHIPPING_COSTS: {
    id: "rc_card_shipping_costs",
    name: t("Shipping Costs"),
    tooltip: "Collected by Showpass",
    value_descriptor: "settlement_card_shipping_cost",
  },
  COLUMN_OTHER_SALES_ADJUSTMENT: {
    id: "rc_other_settlement_difference",
    name: t("Other Payment Adjustment"),
    value_descriptor: "other_settlement_difference",
  },
  COLUMN_CASH_SALES_ADJUSTMENT: {
    id: "rc_cash_settlement_difference",
    name: t("Cash Payment Adjustment"),
    value_descriptor: "cash_settlement_difference",
  },
  COLUMN_SQUARE_OAUTH_ADJUSTMENT: {
    id: "rc_square_oauth_adjustment",
    name: t("Square OAuth Adjustment"),
    value_descriptor: "square_oauth_adjustment",
  },
  COLUMN_CUSTOM_PROCESSOR_SALES_ADJUSTMENT: {
    id: "rc_custom_processor_adjustment",
    name: t("Custom Processor Adjustment"),
    value_descriptor: "custom_gateway_adjustment",
  },
  COLUMN_ADVANCES: {
    id: "rc_advances",
    name: t("Advances"),
    value_descriptor: "advances_total",
  },
  COLUMN_SETTLEMENTS: {
    id: "rc_settlements",
    name: t("Settlements"),
    value_descriptor: "settlements_total",
    tooltip: "Past settlement totals",
  },
  COLUMN_NON_VENUE_CREDIT: {
    id: "rc_non_venue_credit_applied",
    name: t("Account Credit Adjustment"),
    value_descriptor: "non_venue_credit_applied",
    tooltip: "Universal & Referral Credit Total",
  },
  COLUMN_SETTLEMENT_AMOUNT: {
    id: "rc_amount_paid",
    name: t("Settlement Amount"),
    value_descriptor: "amount_paid",
  },
  COLUMN_ADVANCE_AMOUNT: {
    id: "rc_amount_advanced",
    name: t("Advance Amount"),
    value_descriptor: "amount_paid",
    key: "COLUMN_ADVANCE_AMOUNT",
  },
  COLUMN_NUM_OF_TICKETS_SOLD_REDEEMABLE: {
    id: "rc_num_of_tickets_sold_redeemable",
    name: t("Quantity"),
    value_descriptor: "tickets_sold",
  },
  COLUMN_TOTAL_INVENTORY: {
    id: "rc_total_inventory",
    name: t("Total Inventory"),
    value_descriptor: "inventory",
  },
  COLUMN_TOTAL_ADJUSTMENT_AMOUNT: {
    id: "rc_adjustment",
    name: t("Adjustments"),
    value_descriptor: "adjustments",
  },
} as const;

export const COLUMN_CORE_VALUES_MAP_BY_ID = {
  rc_display_gross_sales: {
    id: "rc_display_gross_sales",
    name: t("Gross Sales"),
    value_descriptor: "display_gross_sales",
    tooltip: "Before Discounts and Refunds",
  },
  rc_tickets_total: {
    id: "rc_tickets_total",
    name: t("Tickets"),
    value_descriptor: "tickets_total",
    count_descriptor: "tickets_total_count",
  },
  rc_products_total: {
    id: "rc_products_total",
    name: t("Products"),
    value_descriptor: "products_total",
    count_descriptor: "products_total_count",
  },
  rc_memberships_total: {
    id: "rc_memberships_total",
    name: t("Memberships"),
    value_descriptor: "memberships_total",
    count_descriptor: "memberships_total_count",
  },
  rc_discounts: {
    id: "rc_discounts",
    name: t("Discounts"),
    value_descriptor: "discounts",
    count_descriptor: "discounts_count",
    tooltip: "Includes amounts that may have been refunded",
  },
  rc_refunds: {
    id: "rc_refunds",
    name: t("Refunds"),
    value_descriptor: "refunds",
    count_descriptor: "refunds_count",
  },
  rc_disputes: {
    id: "rc_disputes",
    name: t("Chargebacks"),
    value_descriptor: "disputes",
    count_descriptor: "disputes_count",
  },
  rc_account_credit_applied: {
    id: "rc_account_credit_applied",
    name: t("Account Credits Applied"),
    value_descriptor: "total_credit_applied",
    count_descriptor: "total_credit_applied_count",
  },
  rc_exchange_credit_applied: {
    id: "rc_exchange_credit_applied",
    name: t("Exchange Credits"),
    value_descriptor: "exchange_credit_applied",
    count_descriptor: "exchange_credit_applied_count",
  },
  rc_venue_credit_applied: {
    id: "rc_venue_credit_applied",
    name: t("Organizer Credits"),
    value_descriptor: "venue_credit_applied",
    count_descriptor: "venue_credit_applied_count",
  },
  rc_user_credit_applied: {
    id: "rc_user_credit_applied",
    name: t("Universal Credits"),
    value_descriptor: "user_credit_applied",
    count_descriptor: "user_credit_applied_count",
  },
  rc_referral_credit_applied: {
    id: "rc_referral_credit_applied",
    name: t("Referral Credits"),
    value_descriptor: "referral_credit_applied",
    count_descriptor: "referral_credit_applied_count",
  },
  rc_gross_sales: {
    id: "rc_gross_sales",
    name: t("Net Sales"),
    value_descriptor: "gross_sales",
    tooltip: "Less discounts & refunds",
  },
  rc_exchanged_out: {
    id: "rc_exchanged_out",
    name: t("Exchanged Out"),
    value_descriptor: "exchanged_out",
  },
  rc_account_credit_refunds: {
    id: "rc_account_credit_refunds",
    name: t("Account Credit Refunds"),
    value_descriptor: "account_credit_refunds",
  },
  rc_amount_company_earned: {
    id: "rc_amount_company_earned",
    name: t("Service Fees"),
    value_descriptor: "amount_company_earned",
    tooltip: "Combined Showpass & Processing Fees",
  },
  rc_amount_company_earned_sub_custom_fees: {
    id: "rc_amount_company_earned_sub_custom_fees",
    name: t("Service Fees"),
    value_descriptor: "amount_company_earned_sub_custom_fees",
    tooltip: "Combined Showpass & Processing Fees",
  },
  rc_company_charges: {
    id: "rc_company_charges",
    name: t("Showpass Fees"),
    value_descriptor: "company_charges",
  },
  rc_pre_tax_company_charges: {
    id: "rc_pre_tax_company_charges",
    name: t("Pre-Tax Showpass Fees"),
    value_descriptor: "pre_tax_company_charges",
  },
  rc_company_charges_tax: {
    id: "rc_company_charges_tax",
    name: t("Showpass Fees Tax"),
    value_descriptor: "company_charges_tax",
  },
  rc_company_charges_sub_custom_fees: {
    id: "rc_company_charges_sub_custom_fees",
    name: t("Showpass Fees"),
    value_descriptor: "company_charges_sub_custom_fees",
  },
  rc_cc_charges: {
    id: "rc_cc_charges",
    name: t("Processing Fees"),
    value_descriptor: "cc_charges",
    tooltip: "Charges from credit card processing",
  },
  rc_pre_tax_processing_fees: {
    id: "rc_pre_tax_processing_fees",
    name: t("Pre-Tax Processing Fees"),
    value_descriptor: "pre_tax_cc_charges",
  },
  rc_processing_fees_tax: {
    id: "rc_processing_fees_tax",
    name: t("Processing Fees Tax"),
    value_descriptor: "cc_charges_tax",
  },
  rc_discovery_charges: {
    id: "rc_discovery_charges",
    name: t("Discovery Fees"),
    value_descriptor: "discovery_charges",
    tooltip: "Charges from Showpass discovery fees.",
  },
  rc_pre_tax_discovery_charges: {
    id: "rc_pre_tax_discovery_charges",
    name: t("Pre-Tax Discovery Fees"),
    value_descriptor: "pre_tax_discovery_charges",
  },
  rc_discovery_charges_tax: {
    id: "rc_discovery_charges_tax",
    name: t("Discovery Fees Tax"),
    value_descriptor: "discovery_charges_tax",
  },
  rc_resale_charges: {
    id: "rc_resale_charges",
    name: t("Resale Fees"),
    value_descriptor: "resale_charges",
    tooltip: "Charges from Showpass resale fees.",
  },
  rc_pre_tax_resale_charges: {
    id: "rc_pre_tax_resale_charges",
    name: t("Pre-Tax Resale Fees"),
    value_descriptor: "pre_tax_resale_charges",
  },
  rc_resale_charges_tax: {
    id: "rc_resale_charges_tax",
    name: t("Resale Fees Tax"),
    value_descriptor: "resale_charges_tax",
  },
  rc_account_credits: {
    id: "rc_account_credits",
    name: t("Account Credits"),
    value_descriptor: "total_credit_applied",
    key: "COLUMN_ACCOUNT_CREDITS",
  },
  rc_display_gross_revenue: {
    id: "rc_display_gross_revenue",
    name: t("Gross Revenue"),
    value_descriptor: "display_gross_revenue",
    tooltip: "Less Showpass fees & seller commissions",
  },
  rc_display_organizer_charges: {
    id: "rc_display_organizer_charges",
    name: t("Total Organizer Fees"),
    value_descriptor: "negated_display_organizer_charges",
  },
  rc_tax: {
    id: "rc_tax",
    name: t("Total Organizer Taxes"),
    value_descriptor: "negated_tax",
  },
  rc_organizer_item_tax: {
    id: "rc_organizer_item_tax",
    name: t("Item Taxes"),
    value_descriptor: "organizer_item_tax",
  },
  rc_organizer_fee_tax: {
    id: "rc_organizer_fee_tax",
    name: t("Organizer Fee Taxes"),
    value_descriptor: "organizer_fee_tax",
  },
  rc_shipping_costs: {
    id: "rc_shipping_costs",
    name: t("Shipping Costs"),
    value_descriptor: "shipping_cost",
    count_descriptor: "shipping_cost_count",
  },
  rc_invoice_fee_total: {
    id: "rc_invoice_fee_total",
    name: t("Invoices"),
    value_descriptor: "invoice_fee_total",
    count_descriptor: "invoice_fee_total_count",
    tooltip: "Email, SMS, Hardware Rentals, etc.",
  },
  rc_credit_memo_total: {
    id: "rc_credit_memo_total",
    name: t("Credit Memos"),
    value_descriptor: "credit_memo_total",
    count_descriptor: "credit_memo_total_count",
  },
  rc_display_net_revenue: {
    id: "rc_display_net_revenue",
    name: t("Net Revenue"),
    value_descriptor: "display_net_revenue",
    tooltip: "Less all fees & taxes",
  },
  rc_card_organizer_charges: {
    id: "rc_card_organizer_charges",
    name: t("Organizer Fees"),
    tooltip: "Collected by Showpass",
    value_descriptor: "settlement_organizer_charges",
  },
  rc_card_tax: {
    id: "rc_card_tax",
    name: t("Total Taxes"),
    tooltip: "Collected by Showpass",
    value_descriptor: "settlement_card_tax",
  },
  rc_card_shipping_costs: {
    id: "rc_card_shipping_costs",
    name: t("Shipping Costs"),
    tooltip: "Collected by Showpass",
    value_descriptor: "settlement_card_shipping_cost",
  },
  rc_other_settlement_difference: {
    id: "rc_other_settlement_difference",
    name: t("Other Payment Adjustment"),
    value_descriptor: "other_settlement_difference",
  },
  rc_cash_settlement_difference: {
    id: "rc_cash_settlement_difference",
    name: t("Cash Payment Adjustment"),
    value_descriptor: "cash_settlement_difference",
  },
  rc_square_oauth_adjustment: {
    id: "rc_square_oauth_adjustment",
    name: t("Square OAuth Adjustment"),
    value_descriptor: "square_oauth_adjustment",
  },
  rc_custom_processor_adjustment: {
    id: "rc_custom_processor_adjustment",
    name: t("Custom Processor Adjustment"),
    value_descriptor: "custom_gateway_adjustment",
  },
  rc_advances: {
    id: "rc_advances",
    name: t("Advances"),
    value_descriptor: "advances_total",
  },
  rc_settlements: {
    id: "rc_settlements",
    name: t("Settlements"),
    value_descriptor: "settlements_total",
    tooltip: "Past settlement totals",
  },
  rc_non_venue_credit_applied: {
    id: "rc_non_venue_credit_applied",
    name: t("Account Credit Adjustment"),
    value_descriptor: "non_venue_credit_applied",
    tooltip: "Universal & Referral Credit Total",
  },
  rc_amount_paid: {
    id: "rc_amount_paid",
    name: t("Settlement Amount"),
    value_descriptor: "amount_paid",
  },
  rc_amount_advanced: {
    id: "rc_amount_advanced",
    name: t("Advance Amount"),
    value_descriptor: "amount_paid",
    key: "COLUMN_ADVANCE_AMOUNT",
  },
  rc_num_of_tickets_sold_redeemable: {
    id: "rc_num_of_tickets_sold_redeemable",
    name: t("Quantity"),
    value_descriptor: "tickets_sold",
  },
  rc_total_inventory: {
    id: "rc_total_inventory",
    name: t("Total Inventory"),
    value_descriptor: "inventory",
  },
  rc_adjustment: {
    id: "rc_adjustment",
    name: t("Adjustments"),
    value_descriptor: "adjustments",
  },
} as const;

export const COLUMN_CORE_VALUES_MAP_BY_LIST = [
  {
    id: "rc_display_gross_sales",
    name: t("Gross Sales"),
    value_descriptor: "display_gross_sales",
    tooltip: "Before Discounts and Refunds",
  },
  {
    id: "rc_tickets_total",
    name: t("Tickets"),
    value_descriptor: "tickets_total",
    count_descriptor: "tickets_total_count",
  },
  {
    id: "rc_products_total",
    name: t("Products"),
    value_descriptor: "products_total",
    count_descriptor: "products_total_count",
  },
  {
    id: "rc_memberships_total",
    name: t("Memberships"),
    value_descriptor: "memberships_total",
    count_descriptor: "memberships_total_count",
  },
  {
    id: "rc_discounts",
    name: t("Discounts"),
    value_descriptor: "discounts",
    count_descriptor: "discounts_count",
    tooltip: "Includes amounts that may have been refunded",
  },
  {
    id: "rc_refunds",
    name: t("Refunds"),
    value_descriptor: "refunds",
    count_descriptor: "refunds_count",
  },
  {
    id: "rc_disputes",
    name: t("Chargebacks"),
    value_descriptor: "disputes",
    count_descriptor: "disputes_count",
  },
  {
    id: "rc_account_credit_applied",
    name: t("Account Credits Applied"),
    value_descriptor: "total_credit_applied",
    count_descriptor: "total_credit_applied_count",
  },
  {
    id: "rc_exchange_credit_applied",
    name: t("Exchange Credits"),
    value_descriptor: "exchange_credit_applied",
    count_descriptor: "exchange_credit_applied_count",
  },
  {
    id: "rc_venue_credit_applied",
    name: t("Organizer Credits"),
    value_descriptor: "venue_credit_applied",
    count_descriptor: "venue_credit_applied_count",
  },
  {
    id: "rc_user_credit_applied",
    name: t("Universal Credits"),
    value_descriptor: "user_credit_applied",
    count_descriptor: "user_credit_applied_count",
  },
  {
    id: "rc_referral_credit_applied",
    name: t("Referral Credits"),
    value_descriptor: "referral_credit_applied",
    count_descriptor: "referral_credit_applied_count",
  },
  {
    id: "rc_gross_sales",
    name: t("Net Sales"),
    value_descriptor: "gross_sales",
    tooltip: "Less discounts & refunds",
  },
  {
    id: "rc_exchanged_out",
    name: t("Exchanged Out"),
    value_descriptor: "exchanged_out",
  },
  {
    id: "rc_account_credit_refunds",
    name: t("Account Credit Refunds"),
    value_descriptor: "account_credit_refunds",
  },
  {
    id: "rc_amount_company_earned",
    name: t("Service Fees"),
    value_descriptor: "amount_company_earned",
    tooltip: "Combined Showpass & Processing Fees",
  },
  {
    id: "rc_amount_company_earned_sub_custom_fees",
    name: t("Service Fees"),
    value_descriptor: "amount_company_earned_sub_custom_fees",
    tooltip: "Combined Showpass & Processing Fees",
  },
  {
    id: "rc_company_charges",
    name: t("Showpass Fees"),
    value_descriptor: "company_charges",
  },
  {
    id: "rc_pre_tax_company_charges",
    name: t("Pre-Tax Showpass Fees"),
    value_descriptor: "pre_tax_company_charges",
  },
  {
    id: "rc_company_charges_tax",
    name: t("Showpass Fees Tax"),
    value_descriptor: "company_charges_tax",
  },
  {
    id: "rc_company_charges_sub_custom_fees",
    name: t("Showpass Fees"),
    value_descriptor: "company_charges_sub_custom_fees",
  },
  {
    id: "rc_cc_charges",
    name: t("Processing Fees"),
    value_descriptor: "cc_charges",
    tooltip: "Charges from credit card processing",
  },
  {
    id: "rc_pre_tax_processing_fees",
    name: t("Pre-Tax Processing Fees"),
    value_descriptor: "pre_tax_cc_charges",
  },
  {
    id: "rc_processing_fees_tax",
    name: t("Processing Fees Tax"),
    value_descriptor: "cc_charges_tax",
  },
  {
    id: "rc_discovery_charges",
    name: t("Discovery Fees"),
    value_descriptor: "discovery_charges",
    tooltip: "Charges from Showpass discovery fees.",
  },
  {
    id: "rc_pre_tax_discovery_charges",
    name: t("Pre-Tax Discovery Fees"),
    value_descriptor: "pre_tax_discovery_charges",
  },
  {
    id: "rc_discovery_charges_tax",
    name: t("Discovery Fees Tax"),
    value_descriptor: "discovery_charges_tax",
  },
  {
    id: "rc_resale_charges",
    name: t("Resale Fees"),
    value_descriptor: "resale_charges",
    tooltip: "Charges from Showpass resale fees.",
  },
  {
    id: "rc_pre_tax_resale_charges",
    name: t("Pre-Tax Resale Fees"),
    value_descriptor: "pre_tax_resale_charges",
  },
  {
    id: "rc_resale_charges_tax",
    name: t("Resale Fees Tax"),
    value_descriptor: "resale_charges_tax",
  },
  {
    id: "rc_account_credits",
    name: t("Account Credits"),
    value_descriptor: "total_credit_applied",
    key: "COLUMN_ACCOUNT_CREDITS",
  },
  {
    id: "rc_display_gross_revenue",
    name: t("Gross Revenue"),
    value_descriptor: "display_gross_revenue",
    tooltip: "Less Showpass fees & seller commissions",
  },
  {
    id: "rc_display_organizer_charges",
    name: t("Total Organizer Fees"),
    value_descriptor: "negated_display_organizer_charges",
  },
  {
    id: "rc_tax",
    name: t("Total Organizer Taxes"),
    value_descriptor: "negated_tax",
  },
  {
    id: "rc_organizer_item_tax",
    name: t("Item Taxes"),
    value_descriptor: "organizer_item_tax",
  },
  {
    id: "rc_organizer_fee_tax",
    name: t("Organizer Fee Taxes"),
    value_descriptor: "organizer_fee_tax",
  },
  {
    id: "rc_shipping_costs",
    name: t("Shipping Costs"),
    value_descriptor: "shipping_cost",
    count_descriptor: "shipping_cost_count",
  },
  {
    id: "rc_invoice_fee_total",
    name: t("Invoices"),
    value_descriptor: "invoice_fee_total",
    count_descriptor: "invoice_fee_total_count",
    tooltip: "Email, SMS, Hardware Rentals, etc.",
  },
  {
    id: "rc_credit_memo_total",
    name: t("Credit Memos"),
    value_descriptor: "credit_memo_total",
    count_descriptor: "credit_memo_total_count",
  },
  {
    id: "rc_display_net_revenue",
    name: t("Net Revenue"),
    value_descriptor: "display_net_revenue",
    tooltip: "Less all fees & taxes",
  },
  {
    id: "rc_card_organizer_charges",
    name: t("Organizer Fees"),
    tooltip: "Collected by Showpass",
    value_descriptor: "settlement_organizer_charges",
  },
  {
    id: "rc_card_tax",
    name: t("Total Taxes"),
    tooltip: "Collected by Showpass",
    value_descriptor: "settlement_card_tax",
  },
  {
    id: "rc_card_shipping_costs",
    name: t("Shipping Costs"),
    tooltip: "Collected by Showpass",
    value_descriptor: "settlement_card_shipping_cost",
  },
  {
    id: "rc_other_settlement_difference",
    name: t("Other Payment Adjustment"),
    value_descriptor: "other_settlement_difference",
  },
  {
    id: "rc_cash_settlement_difference",
    name: t("Cash Payment Adjustment"),
    value_descriptor: "cash_settlement_difference",
  },
  {
    id: "rc_square_oauth_adjustment",
    name: t("Square OAuth Adjustment"),
    value_descriptor: "square_oauth_adjustment",
  },
  {
    id: "rc_custom_processor_adjustment",
    name: t("Custom Processor Adjustment"),
    value_descriptor: "custom_gateway_adjustment",
  },
  {
    id: "rc_advances",
    name: t("Advances"),
    value_descriptor: "advances_total",
  },
  {
    id: "rc_settlements",
    name: t("Settlements"),
    value_descriptor: "settlements_total",
    tooltip: "Past settlement totals",
  },
  {
    id: "rc_non_venue_credit_applied",
    name: t("Account Credit Adjustment"),
    value_descriptor: "non_venue_credit_applied",
    tooltip: "Universal & Referral Credit Total",
  },
  {
    id: "rc_amount_paid",
    name: t("Settlement Amount"),
    value_descriptor: "amount_paid",
  },
  {
    id: "rc_amount_advanced",
    name: t("Advance Amount"),
    value_descriptor: "amount_paid",
    key: "COLUMN_ADVANCE_AMOUNT",
  },
  {
    id: "rc_num_of_tickets_sold_redeemable",
    name: t("Quantity"),
    value_descriptor: "tickets_sold",
  },
  {
    id: "rc_total_inventory",
    name: t("Total Inventory"),
    value_descriptor: "inventory",
  },
  {
    id: "rc_adjustment",
    name: t("Adjustments"),
    value_descriptor: "adjustments",
  },
] as const;

export const REPORT_TYPE_MAP = {
  INVOICE_TRANSACTION: {
    id: "report_invoice_transaction",
    name: t("Transactions"),
    fields: [
      { field: "venue", required: true, qs_filter: "venue" },
      {
        field: "events",
        required: false,
        qs_filter: "invoice_items__event_for_filtering__in",
        limit: 1,
      },
      {
        field: "products",
        required: false,
        qs_filter: "invoice_items__product_for_filtering__in",
        limit: 1,
      },
      { field: "from_dt", required: false, qs_filter: "created__gte" },
      { field: "to_dt", required: false, qs_filter: "created__lte" },
    ],
    format: "csv",
    available_formats: ["csv"],
    enabled_columns: [
      "rc_username",
      "rc_email",
      "rc_phone",
      "rc_name_on_ticket",
      "rc_invoice_type",
      "rc_transaction_id",
      "rc_final_amount",
      "rc_amount_earned",
      "rc_other_custom_type",
      "rc_organizer_charges",
      "rc_card_organizer_charges",
      "rc_cash_organizer_charges",
      "rc_other_organizer_charges",
      "rc_commissions",
      "rc_shipping_costs",
      "rc_items_total_amount",
      "rc_payment_type",
      "rc_card_type",
      "rc_created",
      "rc_sold_by",
      "rc_referred_by",
      "rc_referred_link_description",
      "rc_postal_address",
      "rc_city_address",
      "rc_street_address",
      "rc_province_address",
      "rc_country_address",
      "rc_discount_code",
      "rc_internal_info",
      "rc_refunds",
      "rc_discounts",
      "rc_amount_company_earned",
      "rc_pre_tax_company_charges",
      "rc_company_charges_tax",
      "rc_company_charges",
      "rc_pre_tax_processing_fees",
      "rc_processing_fees_tax",
      "rc_cc_charges",
      "rc_pre_tax_discovery_charges",
      "rc_discovery_charges_tax",
      "rc_discovery_charges",
      "rc_pre_tax_resale_charges",
      "rc_resale_charges_tax",
      "rc_resale_charges",
      "rc_display_organizer_charges",
      "rc_organizer_item_tax",
      "rc_organizer_fee_tax",
      "rc_tax",
    ],
    enabled_fields: ["venue", "events", "products", "from_dt", "to_dt"],
    required_fields: ["venue"],
  },
  VENUE_USER: {
    id: "report_venue_user",
    name: t("Customers and Employees"),
    fields: [
      { field: "venue", required: true, qs_filter: "venue" },
      {
        field: "events",
        required: true,
        qs_filter: "item_groups__event__in",
        limit: 50,
        use_distinct: true,
      },
      {
        field: "ticket_types",
        required: false,
        qs_filter: "item_groups__type__in",
        limit: 50,
        use_distinct: true,
      },
      { field: "is_select_all_events", required: false },
      { field: "from_dt", required: false },
      { field: "to_dt", required: false },
    ],
    format: "csv",
    available_formats: ["csv"],
    enabled_columns: [
      "rc_username",
      "rc_email",
      "rc_phone",
      "rc_birthday",
      "rc_gender",
      "rc_is_seller",
      "rc_is_employee",
      "rc_is_subscribed",
      "rc_allow_mail_contact",
      "rc_allow_phone_contact",
      "rc_num_customer_reservations",
      "rc_num_checked_in_as_customer",
      "rc_num_reservations_booked",
      "rc_num_checked_in_as_employee",
      "rc_num_tickets_purchased",
      "rc_num_tickets_sold",
      "rc_external_tickets_quantity",
      "rc_external_tickets_spend",
      "rc_external_donations",
      "rc_venueuser_shipping_name",
      "rc_revenue_tickets_purchased",
      "rc_revenue_tickets_sold",
      "rc_shipping_street_address",
      "rc_shipping_unit_number",
      "rc_shipping_city_address",
      "rc_shipping_province_address",
      "rc_shipping_country_address",
      "rc_shipping_postal_address",
    ],
    enabled_fields: [
      "venue",
      "events",
      "ticket_types",
      "is_select_all_events",
      "from_dt",
      "to_dt",
    ],
    required_fields: ["venue", "events"],
  },
  WILL_CALL: {
    id: "report_will_call",
    name: t("Will Call"),
    fields: [
      { field: "venue", required: true, qs_filter: "venue" },
      { field: "events", required: false, qs_filter: "event__in", limit: 60 },
      {
        field: "products",
        required: false,
        qs_filter: "product__in",
        limit: 50,
      },
      {
        field: "ticket_types",
        required: false,
        qs_filter: "type__in",
        limit: 60,
      },
      { field: "ticket_statuses", required: false, qs_filter: "status__in" },
      { field: "is_select_all_events", required: false },
      { field: "from_dt", required: false, qs_filter: "created__gte" },
      { field: "to_dt", required: false, qs_filter: "created__lte" },
    ],
    format: "csv",
    available_formats: ["csv"],
    enabled_columns: [
      "rc_email",
      "rc_phone",
      "rc_name_on_ticket",
      "rc_quantity",
      "rc_event",
      "rc_event_starts_on",
      "rc_event_ends_on",
      "rc_ticket_type",
      "rc_ticket_status",
      "rc_ticket_barcode",
      "rc_ticket_scan_code",
      "rc_seating_section",
      "rc_password_used",
      "rc_seating_row",
      "rc_seating_seat",
      "rc_ticket_description",
      "rc_last_status_change",
      "rc_last_status_changed_by",
      "rc_product_attribute",
      "rc_product",
      "rc_created",
      "rc_sold_by",
      "rc_sold_by_venue",
      "rc_custom_question_info",
      "rc_info_student_number",
      "rc_info_company",
      "rc_info_job_title",
      "rc_info_first_name",
      "rc_info_last_name",
      "rc_info_phone_number",
      "rc_info_email",
      "rc_info_home_address_unit_number",
      "rc_info_home_address_street_name",
      "rc_info_home_address_city",
      "rc_info_home_address_province",
      "rc_info_home_address_postal",
      "rc_info_home_address_country",
      "rc_info_birthday",
      "rc_info_license_plate",
    ],
    enabled_fields: [
      "venue",
      "events",
      "products",
      "ticket_types",
      "ticket_statuses",
      "is_select_all_events",
      "from_dt",
      "to_dt",
    ],
    required_fields: ["venue"],
  },
  WILL_CALL_FINANCIAL: {
    id: "report_will_call_financial",
    name: t("Itemized Sales Report"),
    fields: [
      { field: "venue", required: true, qs_filter: "venue" },
      { field: "is_select_from_sub_orgs", required: false },
      {
        field: "events",
        required: false,
        qs_filter: "event_id__in",
        limit: 60,
      },
      {
        field: "products",
        required: false,
        qs_filter: "product_id__in",
        limit: 50,
      },
      {
        field: "ticket_types",
        required: false,
        qs_filter: "ticket_type_id__in",
        limit: 60,
      },
      {
        field: "membership_groups",
        required: false,
        qs_filter: "membership_group_id__in",
        limit: 60,
      },
      {
        field: "membership_levels",
        required: false,
        qs_filter: "membership_level_id__in",
        limit: 60,
      },
      { field: "is_select_all_events", required: false },
      { field: "from_dt", required: false, qs_filter: "created__gte" },
      { field: "to_dt", required: false, qs_filter: "created__lte" },
      {
        field: "employees",
        required: false,
        qs_filter: "invoice__sold_by__in",
        limit: 60,
      },
      {
        field: "purchase_source_platforms",
        required: false,
        qs_filter: "purchase_source_platform__in",
      },
    ],
    format: "csv",
    available_formats: ["csv", "pdf"],
    enabled_columns: [
      "rc_ticket_history_ticket_event_name",
      "rc_ticket_history_event_id",
      "rc_ticket_history_product_id",
      "rc_ticket_history_product_attribute_id",
      "rc_discount_amount",
      "rc_rule_discount_percentage",
      "rc_discount_rule_amount",
      "rc_discount_percentage",
      "rc_discount_type",
      "rc_username",
      "rc_email",
      "rc_phone",
      "rc_is_subscribed",
      "rc_invoice_item_description",
      "rc_charge_id",
      "rc_invoice_type_name",
      "rc_invoice_category_name",
      "rc_transaction_id",
      "rc_transaction_date",
      "rc_sale_transaction_id",
      "rc_settlement_date",
      "rc_advance_date",
      "rc_ticket_type_price",
      "rc_credit_type",
      "rc_purchase_source_platform",
      "rc_purchase_note",
      "rc_other_payment_type",
      "rc_transaction_quantity",
      "rc_item_quantity",
      "rc_transfer_quantity",
      "rc_scanned_quantity",
      "rc_scan_limit",
      "rc_refund_type",
      "rc_refund_reason",
      "rc_commissions",
      "rc_payment_type",
      "rc_card_type",
      "rc_event_starts_on",
      "rc_event_ends_on",
      "rc_ticket_type",
      "rc_ticket_type_id",
      "rc_event_location_name",
      "rc_event_location_postal_address",
      "rc_event_location_city_address",
      "rc_event_location_street_name",
      "rc_event_location_province_address",
      "rc_event_location_country_address",
      "rc_password_used",
      "rc_is_sub_ticket",
      "rc_member_name",
      "rc_member_email",
      "rc_membership_group_name",
      "rc_membership_group_id",
      "rc_membership_level_name",
      "rc_membership_level_id",
      "rc_membership_level_price",
      "rc_product_attribute",
      "rc_product_attribute_price",
      "rc_product",
      "rc_price_tier_name",
      "rc_price_tier_id",
      "rc_price_tier_price",
      "rc_venue_name",
      "rc_venue_id",
      "rc_sold_by",
      "rc_referred_by",
      "rc_referred_link_description",
      "rc_referred_link_URL",
      "rc_postal_address",
      "rc_city_address",
      "rc_street_address",
      "rc_province_address",
      "rc_country_address",
      "rc_discount_code",
      "rc_shipping_method",
      "rc_shipping_street_address",
      "rc_shipping_unit_number",
      "rc_shipping_city_address",
      "rc_shipping_province_address",
      "rc_shipping_country_address",
      "rc_shipping_postal_address",
      "rc_shipping_cost",
      "rc_ticket_pay_what_you_can_enabled",
      "rc_ticket_pay_what_you_can_difference",
      "rc_display_gross_sales",
      "rc_refunds",
      "rc_discounts",
      "rc_gross_sales",
      "rc_amount_company_earned",
      "rc_pre_tax_company_charges",
      "rc_company_charges_tax",
      "rc_company_charges",
      "rc_pre_tax_processing_fees",
      "rc_processing_fees_tax",
      "rc_cc_charges",
      "rc_pre_tax_discovery_charges",
      "rc_discovery_charges_tax",
      "rc_discovery_charges",
      "rc_pre_tax_resale_charges",
      "rc_resale_charges_tax",
      "rc_resale_charges",
      "rc_account_credit_applied",
      "rc_account_credit_refunds",
      "rc_exchanged_out",
      "rc_display_gross_revenue",
      "rc_display_organizer_charges",
      "rc_organizer_item_tax",
      "rc_organizer_fee_tax",
      "rc_tax",
      "rc_display_net_revenue",
      "rc_adjustment",
      "rc_amount_paid",
    ],
    enabled_fields: [
      "venue",
      "is_select_from_sub_orgs",
      "events",
      "products",
      "ticket_types",
      "membership_groups",
      "membership_levels",
      "is_select_all_events",
      "from_dt",
      "to_dt",
      "employees",
      "purchase_source_platforms",
    ],
    required_fields: ["venue"],
  },
  SETTLEMENT_REPORT: {
    id: "settlement_report",
    name: t("Settlement Report"),
    fields: [
      { field: "venue", required: true, qs_filter: "venue" },
      {
        field: "payout_invoices",
        required: false,
        qs_filter: "payout_invoice_item__invoice__in",
        limit: 60,
      },
      { field: "from_dt", required: false, qs_filter: "created__gte" },
      { field: "to_dt", required: false, qs_filter: "created__lte" },
    ],
    available_formats: ["csv", "pdf"],
    enabled_columns: [
      "rc_ticket_history_ticket_event_name",
      "rc_ticket_history_event_id",
      "rc_ticket_history_product_id",
      "rc_ticket_history_product_attribute_id",
      "rc_discount_amount",
      "rc_rule_discount_percentage",
      "rc_discount_rule_amount",
      "rc_discount_percentage",
      "rc_discount_type",
      "rc_username",
      "rc_email",
      "rc_phone",
      "rc_is_subscribed",
      "rc_invoice_item_description",
      "rc_charge_id",
      "rc_invoice_type_name",
      "rc_invoice_category_name",
      "rc_transaction_id",
      "rc_transaction_date",
      "rc_sale_transaction_id",
      "rc_settlement_date",
      "rc_advance_date",
      "rc_ticket_type_price",
      "rc_credit_type",
      "rc_purchase_source_platform",
      "rc_purchase_note",
      "rc_other_payment_type",
      "rc_transaction_quantity",
      "rc_item_quantity",
      "rc_transfer_quantity",
      "rc_scanned_quantity",
      "rc_scan_limit",
      "rc_refund_type",
      "rc_refund_reason",
      "rc_commissions",
      "rc_payment_type",
      "rc_card_type",
      "rc_event_starts_on",
      "rc_event_ends_on",
      "rc_ticket_type",
      "rc_ticket_type_id",
      "rc_event_location_name",
      "rc_event_location_postal_address",
      "rc_event_location_city_address",
      "rc_event_location_street_name",
      "rc_event_location_province_address",
      "rc_event_location_country_address",
      "rc_password_used",
      "rc_is_sub_ticket",
      "rc_member_name",
      "rc_member_email",
      "rc_membership_group_name",
      "rc_membership_group_id",
      "rc_membership_level_name",
      "rc_membership_level_id",
      "rc_membership_level_price",
      "rc_product_attribute",
      "rc_product_attribute_price",
      "rc_product",
      "rc_price_tier_name",
      "rc_price_tier_id",
      "rc_price_tier_price",
      "rc_venue_name",
      "rc_venue_id",
      "rc_sold_by",
      "rc_referred_by",
      "rc_referred_link_description",
      "rc_referred_link_URL",
      "rc_postal_address",
      "rc_city_address",
      "rc_street_address",
      "rc_province_address",
      "rc_country_address",
      "rc_discount_code",
      "rc_shipping_method",
      "rc_shipping_street_address",
      "rc_shipping_unit_number",
      "rc_shipping_city_address",
      "rc_shipping_province_address",
      "rc_shipping_country_address",
      "rc_shipping_postal_address",
      "rc_shipping_cost",
      "rc_display_gross_sales",
      "rc_refunds",
      "rc_discounts",
      "rc_gross_sales",
      "rc_amount_company_earned",
      "rc_pre_tax_company_charges",
      "rc_company_charges_tax",
      "rc_company_charges",
      "rc_pre_tax_processing_fees",
      "rc_processing_fees_tax",
      "rc_cc_charges",
      "rc_pre_tax_discovery_charges",
      "rc_discovery_charges_tax",
      "rc_discovery_charges",
      "rc_pre_tax_resale_charges",
      "rc_resale_charges_tax",
      "rc_resale_charges",
      "rc_account_credit_applied",
      "rc_account_credit_refunds",
      "rc_exchanged_out",
      "rc_display_gross_revenue",
      "rc_display_organizer_charges",
      "rc_organizer_item_tax",
      "rc_organizer_fee_tax",
      "rc_tax",
      "rc_display_net_revenue",
      "rc_adjustment",
      "rc_amount_paid",
    ],
    enabled_fields: ["venue", "payout_invoices", "from_dt", "to_dt"],
    required_fields: ["venue"],
  },
  ADVANCE_REPORT: {
    id: "advance_report",
    name: t("Advance Report"),
    fields: [
      { field: "venue", required: true, qs_filter: "venue" },
      {
        field: "advance_invoices",
        required: false,
        qs_filter: "advance_invoice_item__invoice__in",
        limit: 60,
      },
      { field: "from_dt", required: false, qs_filter: "created__gte" },
      { field: "to_dt", required: false, qs_filter: "created__lte" },
    ],
    available_formats: ["csv", "pdf"],
    enabled_columns: [
      "rc_ticket_history_ticket_event_name",
      "rc_ticket_history_event_id",
      "rc_ticket_history_product_id",
      "rc_ticket_history_product_attribute_id",
      "rc_discount_amount",
      "rc_rule_discount_percentage",
      "rc_discount_rule_amount",
      "rc_discount_percentage",
      "rc_discount_type",
      "rc_username",
      "rc_email",
      "rc_phone",
      "rc_is_subscribed",
      "rc_invoice_item_description",
      "rc_charge_id",
      "rc_invoice_type_name",
      "rc_invoice_category_name",
      "rc_transaction_id",
      "rc_transaction_date",
      "rc_sale_transaction_id",
      "rc_settlement_date",
      "rc_advance_date",
      "rc_ticket_type_price",
      "rc_credit_type",
      "rc_purchase_source_platform",
      "rc_purchase_note",
      "rc_other_payment_type",
      "rc_transaction_quantity",
      "rc_item_quantity",
      "rc_transfer_quantity",
      "rc_scanned_quantity",
      "rc_scan_limit",
      "rc_refund_type",
      "rc_refund_reason",
      "rc_commissions",
      "rc_payment_type",
      "rc_card_type",
      "rc_event_starts_on",
      "rc_event_ends_on",
      "rc_ticket_type",
      "rc_ticket_type_id",
      "rc_event_location_name",
      "rc_event_location_postal_address",
      "rc_event_location_city_address",
      "rc_event_location_street_name",
      "rc_event_location_province_address",
      "rc_event_location_country_address",
      "rc_password_used",
      "rc_is_sub_ticket",
      "rc_member_name",
      "rc_member_email",
      "rc_membership_group_name",
      "rc_membership_group_id",
      "rc_membership_level_name",
      "rc_membership_level_id",
      "rc_membership_level_price",
      "rc_product_attribute",
      "rc_product_attribute_price",
      "rc_product",
      "rc_price_tier_name",
      "rc_price_tier_id",
      "rc_price_tier_price",
      "rc_venue_name",
      "rc_venue_id",
      "rc_sold_by",
      "rc_referred_by",
      "rc_referred_link_description",
      "rc_referred_link_URL",
      "rc_postal_address",
      "rc_city_address",
      "rc_street_address",
      "rc_province_address",
      "rc_country_address",
      "rc_discount_code",
      "rc_shipping_method",
      "rc_shipping_street_address",
      "rc_shipping_unit_number",
      "rc_shipping_city_address",
      "rc_shipping_province_address",
      "rc_shipping_country_address",
      "rc_shipping_postal_address",
      "rc_shipping_cost",
      "rc_display_gross_sales",
      "rc_refunds",
      "rc_discounts",
      "rc_gross_sales",
      "rc_amount_company_earned",
      "rc_pre_tax_company_charges",
      "rc_company_charges_tax",
      "rc_company_charges",
      "rc_pre_tax_processing_fees",
      "rc_processing_fees_tax",
      "rc_cc_charges",
      "rc_pre_tax_discovery_charges",
      "rc_discovery_charges_tax",
      "rc_discovery_charges",
      "rc_pre_tax_resale_charges",
      "rc_resale_charges_tax",
      "rc_resale_charges",
      "rc_account_credit_applied",
      "rc_account_credit_refunds",
      "rc_exchanged_out",
      "rc_display_gross_revenue",
      "rc_display_organizer_charges",
      "rc_organizer_item_tax",
      "rc_organizer_fee_tax",
      "rc_tax",
      "rc_display_net_revenue",
      "rc_adjustment",
      "rc_amount_paid",
    ],
    enabled_fields: ["venue", "advance_invoices", "from_dt", "to_dt"],
    required_fields: ["venue"],
  },
  TICKET_SALE_HISTORY: {
    id: "report_ticket_sales_history",
    name: t("Ticket Sales History"),
    fields: [
      { field: "venue", required: true, qs_filter: "venue" },
      { field: "events", required: false, qs_filter: "event__in", limit: 60 },
      {
        field: "ticket_types",
        required: false,
        qs_filter: "ticket_type__in",
        limit: 60,
      },
      { field: "is_select_all_events", required: false },
      { field: "from_dt", required: false, qs_filter: "created__gte" },
      { field: "to_dt", required: false, qs_filter: "created__lte" },
      { field: "purchase_source_platforms", required: false },
    ],
    format: "pdf",
    available_formats: ["pdf"],
    enabled_columns: [],
    enabled_fields: [
      "venue",
      "events",
      "ticket_types",
      "is_select_all_events",
      "from_dt",
      "to_dt",
      "purchase_source_platforms",
    ],
    required_fields: ["venue"],
  },
  EMPLOYEE_SALE_HISTORY: {
    id: "report_employee_sales_history",
    name: t("Employee Sales History"),
    fields: [
      { field: "venue", required: true, qs_filter: "venue" },
      { field: "events", required: false, qs_filter: "event__in", limit: 60 },
      {
        field: "ticket_types",
        required: false,
        qs_filter: "ticket_type__in",
        limit: 60,
      },
      { field: "is_select_all_events", required: false },
      { field: "from_dt", required: false, qs_filter: "created__gte" },
      { field: "to_dt", required: false, qs_filter: "created__lte" },
      { field: "employees", required: false, limit: 60 },
      { field: "purchase_source_platforms", required: false },
    ],
    format: "pdf",
    available_formats: ["pdf"],
    enabled_columns: [],
    enabled_fields: [
      "venue",
      "events",
      "ticket_types",
      "is_select_all_events",
      "from_dt",
      "to_dt",
      "employees",
      "purchase_source_platforms",
    ],
    required_fields: ["venue"],
  },
  EVENT_BREAKDOWN: {
    id: "report_event_breakdown",
    name: t("Event Summary"),
    fields: [
      { field: "venue", required: true, qs_filter: "venue" },
      { field: "events", required: true, qs_filter: "id__in", limit: 60 },
      { field: "is_select_all_events", required: false },
      { field: "from_dt", required: false },
      { field: "to_dt", required: false },
    ],
    format: "csv",
    available_formats: ["csv", "pdf"],
    enabled_columns: [
      "rc_sub_tickets_generated_from_package",
      "rc_cash_organizer_charges",
      "rc_other_organizer_charges",
      "rc_commissions",
      "rc_shipping_costs",
      "rc_cash_revenue",
      "rc_credit_revenue",
      "rc_event",
      "rc_event_starts_on",
      "rc_event_ends_on",
      "rc_event_location",
      "rc_num_tickets_sold_cash",
      "rc_num_tickets_sold_credit",
      "rc_num_tickets_sold_affirm",
      "rc_num_tickets_sold_comp",
      "rc_num_tickets_sold_free",
      "rc_num_of_standard_tickets_sold",
      "rc_num_of_tickets_sold_redeemable",
      "rc_num_of_redeemable_tickets",
      "rc_total_inventory",
      "rc_num_of_total_packages",
      "rc_total_ticket_package_inventory",
      "rc_num_of_sub_tickets_from_event",
      "rc_num_of_sub_tickets_from_outside_event",
      "rc_num_of_tickets_not_included_in_stats",
      "rc_num_of_hold_tickets",
      "rc_num_of_payment_plans_copy",
      "rc_affirm_revenue",
      "rc_display_gross_sales",
      "rc_discounts",
      "rc_refunds",
      "rc_disputes",
      "rc_gross_sales",
      "rc_amount_company_earned_sub_custom_fees",
      "rc_company_charges_sub_custom_fees",
      "rc_cc_charges",
      "rc_discovery_charges",
      "rc_resale_charges",
      "rc_invoice_fee_total",
      "rc_account_credit_applied",
      "rc_exchange_credit_applied",
      "rc_venue_credit_applied",
      "rc_user_credit_applied",
      "rc_referral_credit_applied",
      "rc_exchanged_out",
      "rc_account_credit_refunds",
      "rc_display_gross_revenue",
      "rc_display_organizer_charges",
      "rc_tax",
      "rc_shipping_costs",
      "rc_credit_memo_total",
      "rc_display_net_revenue",
      "rc_card_organizer_charges",
      "rc_card_tax",
      "rc_card_shipping_costs",
      "rc_other_settlement_difference",
      "rc_cash_settlement_difference",
      "rc_custom_processor_adjustment",
      "rc_square_oauth_adjustment",
      "rc_advances",
      "rc_settlements",
      "rc_non_venue_credit_applied",
      "rc_amount_paid",
      "rc_display_gross_sales",
      "rc_refunds",
      "rc_discounts",
      "rc_gross_sales",
      "rc_amount_company_earned",
      "rc_pre_tax_company_charges",
      "rc_company_charges_tax",
      "rc_company_charges",
      "rc_pre_tax_processing_fees",
      "rc_processing_fees_tax",
      "rc_cc_charges",
      "rc_pre_tax_discovery_charges",
      "rc_discovery_charges_tax",
      "rc_discovery_charges",
      "rc_pre_tax_resale_charges",
      "rc_resale_charges_tax",
      "rc_resale_charges",
      "rc_account_credit_applied",
      "rc_account_credit_refunds",
      "rc_exchanged_out",
      "rc_display_gross_revenue",
      "rc_display_organizer_charges",
      "rc_organizer_item_tax",
      "rc_organizer_fee_tax",
      "rc_tax",
      "rc_display_net_revenue",
      "rc_adjustment",
      "rc_amount_paid",
    ],
    enabled_fields: [
      "venue",
      "events",
      "is_select_all_events",
      "from_dt",
      "to_dt",
    ],
    required_fields: ["venue", "events"],
  },
  EVENT_AUDIT: {
    id: "report_event_audit",
    name: t("Event Audit"),
    fields: [
      { field: "venue", required: true, qs_filter: "venue" },
      { field: "events", required: true, qs_filter: "id__in", limit: 1 },
    ],
    format: "xlsx",
    available_formats: ["xlsx"],
    enabled_columns: [],
    enabled_fields: ["venue", "events"],
    required_fields: ["venue", "events"],
  },
  PAYMENT_TYPE_BREAKDOWN: {
    id: "payment_type_breakdown",
    name: t("Payment Type Breakdown"),
    fields: [
      { field: "venue", required: true, qs_filter: "venue" },
      { field: "events", required: false, limit: 1500 },
      { field: "products", required: false, limit: 1500 },
      { field: "membership_groups", required: false, limit: 1500 },
      { field: "membership_levels", required: false, limit: 1500 },
      { field: "is_select_all_events", required: false },
      { field: "from_dt", required: false },
      { field: "to_dt", required: false },
    ],
    format: "pdf",
    available_formats: ["pdf"],
    enabled_columns: [],
    enabled_fields: [
      "venue",
      "events",
      "products",
      "membership_groups",
      "membership_levels",
      "is_select_all_events",
      "from_dt",
      "to_dt",
    ],
    required_fields: ["venue"],
  },
  FINANCIAL_SCAN_SUMMARY: {
    id: "financial_scan_summary",
    name: t("Financial Scan Summary"),
    fields: [
      { field: "venue", required: true, qs_filter: "venue" },
      { field: "events", required: true, limit: 1500 },
      { field: "from_dt", required: false },
      { field: "to_dt", required: false },
    ],
    format: "pdf",
    available_formats: ["pdf"],
    enabled_columns: [],
    enabled_fields: ["venue", "events", "from_dt", "to_dt"],
    required_fields: ["venue", "events"],
  },
  EVENT_FINANCIAL_SUMMARY: {
    id: "event_financial_summary",
    name: t("Event Financial Summary"),
    fields: [
      { field: "venue", required: true, qs_filter: "venue" },
      { field: "events", required: false, limit: 1500 },
      { field: "is_select_all_events", required: false },
      { field: "from_dt", required: false },
      { field: "to_dt", required: false },
    ],
    format: "pdf",
    available_formats: ["pdf"],
    enabled_columns: [],
    enabled_fields: [
      "venue",
      "events",
      "is_select_all_events",
      "from_dt",
      "to_dt",
    ],
    required_fields: ["venue"],
  },
  TICKET_TYPE_FINANCIAL_SUMMARY: {
    id: "ticket_type_financial_summary",
    name: t("Ticket Type Financial Summary"),
    fields: [
      { field: "venue", required: true, qs_filter: "venue" },
      { field: "events", required: false, limit: 1500 },
      { field: "is_select_all_events", required: false },
      { field: "from_dt", required: false },
      { field: "to_dt", required: false },
    ],
    format: "pdf",
    available_formats: ["pdf"],
    enabled_columns: [],
    enabled_fields: [
      "venue",
      "events",
      "is_select_all_events",
      "from_dt",
      "to_dt",
    ],
    required_fields: ["venue"],
  },
  TICKET_TYPE_BREAKDOWN: {
    id: "report_ticket_type_breakdown",
    name: t("Ticket Type Summary"),
    fields: [
      { field: "venue", required: true, qs_filter: "venue" },
      {
        field: "ticket_types",
        required: false,
        qs_filter: "id__in",
        limit: 50,
      },
      { field: "events", required: true, qs_filter: "event_id__in", limit: 50 },
    ],
    format: "csv",
    available_formats: ["csv"],
    enabled_columns: [
      "rc_sub_tickets_generated_from_package",
      "rc_ticket_type_price",
      "rc_cash_organizer_charges",
      "rc_other_organizer_charges",
      "rc_commissions",
      "rc_shipping_costs",
      "rc_cash_revenue",
      "rc_credit_revenue",
      "rc_event",
      "rc_event_starts_on",
      "rc_event_ends_on",
      "rc_ticket_type",
      "rc_event_location",
      "rc_num_tickets_sold_cash",
      "rc_num_tickets_sold_credit",
      "rc_num_tickets_sold_affirm",
      "rc_num_tickets_sold_comp",
      "rc_num_tickets_sold_free",
      "rc_num_tickets_refunded",
      "rc_num_of_redeemable_tickets",
      "rc_total_inventory",
      "rc_num_of_total_packages",
      "rc_num_of_tickets_not_included_in_stats",
      "rc_affirm_revenue",
      "rc_display_gross_sales",
      "rc_refunds",
      "rc_discounts",
      "rc_gross_sales",
      "rc_amount_company_earned",
      "rc_pre_tax_company_charges",
      "rc_company_charges_tax",
      "rc_company_charges",
      "rc_pre_tax_processing_fees",
      "rc_processing_fees_tax",
      "rc_cc_charges",
      "rc_pre_tax_discovery_charges",
      "rc_discovery_charges_tax",
      "rc_discovery_charges",
      "rc_pre_tax_resale_charges",
      "rc_resale_charges_tax",
      "rc_resale_charges",
      "rc_account_credit_applied",
      "rc_account_credit_refunds",
      "rc_exchanged_out",
      "rc_display_gross_revenue",
      "rc_display_organizer_charges",
      "rc_organizer_item_tax",
      "rc_organizer_fee_tax",
      "rc_tax",
      "rc_display_net_revenue",
      "rc_adjustment",
      "rc_amount_paid",
    ],
    enabled_fields: ["venue", "ticket_types", "events"],
    required_fields: ["venue", "events"],
  },
  PRODUCT_BREAKDOWN: {
    id: "product_breakdown_report",
    name: t("Product Summary"),
    fields: [
      { field: "venue", required: true, qs_filter: "venue" },
      { field: "products", required: true, qs_filter: "id__in", limit: 60 },
      { field: "from_dt", required: false },
      { field: "to_dt", required: false },
    ],
    format: "csv",
    available_formats: ["csv", "pdf"],
    enabled_columns: [
      "rc_cash_organizer_charges",
      "rc_other_organizer_charges",
      "rc_commissions",
      "rc_shipping_costs",
      "rc_cash_revenue",
      "rc_credit_revenue",
      "rc_num_tickets_sold_cash",
      "rc_num_tickets_sold_credit",
      "rc_num_tickets_sold_affirm",
      "rc_num_tickets_sold_comp",
      "rc_num_tickets_sold_free",
      "rc_product",
      "rc_num_of_standard_tickets_sold",
      "rc_num_of_redeemable_tickets",
      "rc_total_inventory",
      "rc_num_of_hold_tickets",
      "rc_affirm_revenue",
      "rc_display_gross_sales",
      "rc_discounts",
      "rc_refunds",
      "rc_disputes",
      "rc_gross_sales",
      "rc_amount_company_earned_sub_custom_fees",
      "rc_company_charges_sub_custom_fees",
      "rc_cc_charges",
      "rc_discovery_charges",
      "rc_resale_charges",
      "rc_invoice_fee_total",
      "rc_account_credit_applied",
      "rc_exchange_credit_applied",
      "rc_venue_credit_applied",
      "rc_user_credit_applied",
      "rc_referral_credit_applied",
      "rc_exchanged_out",
      "rc_account_credit_refunds",
      "rc_display_gross_revenue",
      "rc_display_organizer_charges",
      "rc_tax",
      "rc_shipping_costs",
      "rc_credit_memo_total",
      "rc_display_net_revenue",
      "rc_card_organizer_charges",
      "rc_card_tax",
      "rc_card_shipping_costs",
      "rc_other_settlement_difference",
      "rc_cash_settlement_difference",
      "rc_custom_processor_adjustment",
      "rc_square_oauth_adjustment",
      "rc_advances",
      "rc_settlements",
      "rc_non_venue_credit_applied",
      "rc_amount_paid",
      "rc_display_gross_sales",
      "rc_refunds",
      "rc_discounts",
      "rc_gross_sales",
      "rc_amount_company_earned",
      "rc_pre_tax_company_charges",
      "rc_company_charges_tax",
      "rc_company_charges",
      "rc_pre_tax_processing_fees",
      "rc_processing_fees_tax",
      "rc_cc_charges",
      "rc_pre_tax_discovery_charges",
      "rc_discovery_charges_tax",
      "rc_discovery_charges",
      "rc_pre_tax_resale_charges",
      "rc_resale_charges_tax",
      "rc_resale_charges",
      "rc_account_credit_applied",
      "rc_account_credit_refunds",
      "rc_exchanged_out",
      "rc_display_gross_revenue",
      "rc_display_organizer_charges",
      "rc_organizer_item_tax",
      "rc_organizer_fee_tax",
      "rc_tax",
      "rc_display_net_revenue",
      "rc_adjustment",
      "rc_amount_paid",
    ],
    enabled_fields: ["venue", "products", "from_dt", "to_dt"],
    required_fields: ["venue", "products"],
  },
  PASSWORD_USED_BREAKDOWN: {
    id: "report_password_used_breakdown",
    name: t("Password Used Summary"),
    fields: [
      { field: "venue", required: true, qs_filter: "venue" },
      {
        field: "events",
        required: false,
        qs_filter: "events__id__in",
        limit: 50,
      },
    ],
    format: "csv",
    available_formats: ["csv"],
    enabled_columns: [
      "rc_num_tickets_sold",
      "rc_event",
      "rc_num_of_passwords_used",
      "rc_password",
      "rc_display_gross_sales",
      "rc_refunds",
      "rc_discounts",
      "rc_gross_sales",
      "rc_amount_company_earned",
      "rc_pre_tax_company_charges",
      "rc_company_charges_tax",
      "rc_company_charges",
      "rc_pre_tax_processing_fees",
      "rc_processing_fees_tax",
      "rc_cc_charges",
      "rc_pre_tax_discovery_charges",
      "rc_discovery_charges_tax",
      "rc_discovery_charges",
      "rc_pre_tax_resale_charges",
      "rc_resale_charges_tax",
      "rc_resale_charges",
      "rc_account_credit_applied",
      "rc_account_credit_refunds",
      "rc_exchanged_out",
      "rc_display_gross_revenue",
      "rc_display_organizer_charges",
      "rc_organizer_item_tax",
      "rc_organizer_fee_tax",
      "rc_tax",
      "rc_display_net_revenue",
      "rc_adjustment",
      "rc_amount_paid",
    ],
    enabled_fields: ["venue", "events"],
    required_fields: ["venue"],
  },
  SELLER_STATS: {
    id: "report_seller_stats",
    name: t("Seller Stats"),
    fields: [
      { field: "venue", required: true, qs_filter: "venue" },
      {
        field: "events",
        required: false,
        qs_filter: "event_id__in",
        limit: 50,
        use_distinct: true,
      },
      {
        field: "products",
        required: false,
        qs_filter: "product_id__in",
        limit: 50,
        use_distinct: true,
      },
      {
        field: "membership_groups",
        required: false,
        qs_filter: "membership_group_id__in",
        limit: 50,
        use_distinct: true,
      },
      {
        field: "membership_levels",
        required: false,
        qs_filter: "membership_level_id__in",
        limit: 50,
        use_distinct: true,
      },
      { field: "is_select_all_events", required: false },
      { field: "from_dt", required: false, qs_filter: "created__gte" },
      { field: "to_dt", required: false, qs_filter: "created__lte" },
    ],
    format: "csv",
    available_formats: ["csv"],
    enabled_columns: [
      "rc_username",
      "rc_email",
      "rc_phone",
      "rc_num_tickets_sold",
      "rc_final_amount",
      "rc_amount_earned",
      "rc_organizer_charges",
      "rc_card_organizer_charges",
      "rc_cash_organizer_charges",
      "rc_other_organizer_charges",
      "rc_cash_commissions",
      "rc_credit_commissions",
      "rc_cash_revenue",
      "rc_credit_revenue",
      "rc_num_tickets_sold_cash",
      "rc_num_tickets_sold_credit",
      "rc_num_tickets_sold_affirm",
      "rc_num_tickets_sold_comp",
      "rc_num_tickets_sold_free",
      "rc_affirm_revenue",
    ],
    enabled_fields: [
      "venue",
      "events",
      "products",
      "membership_groups",
      "membership_levels",
      "is_select_all_events",
      "from_dt",
      "to_dt",
    ],
    required_fields: ["venue"],
  },
  SHIPPING_FULFILLMENT: {
    id: "report_shipping_fulfillment",
    name: t("Shipping Fulfillment Stats"),
    fields: [
      { field: "venue", required: true, qs_filter: "venue" },
      {
        field: "events",
        required: false,
        qs_filter: "event_id__in",
        limit: 5,
        use_distinct: false,
      },
      {
        field: "products",
        required: false,
        qs_filter: "product_id__in",
        limit: 20,
        use_distinct: false,
      },
      {
        field: "membership_groups",
        required: false,
        qs_filter: "membership_group_id__in",
        limit: 5,
        use_distinct: false,
      },
      { field: "from_dt", required: false, qs_filter: "created__gte" },
      { field: "to_dt", required: false, qs_filter: "created__lte" },
    ],
    format: "csv",
    available_formats: ["csv"],
    enabled_columns: [
      "rc_ticket_history_ticket_event_name",
      "rc_ticket_history_event_id",
      "rc_ticket_history_tt_description",
      "rc_ticket_history_ticket_id",
      "rc_ticket_history_product_description",
      "rc_ticket_history_product_id",
      "rc_ticket_history_product_attribute_name",
      "rc_ticket_history_product_attribute_id",
      "rc_email",
      "rc_phone",
      "rc_name_on_ticket",
      "rc_transaction_id",
      "rc_event_starts_on",
      "rc_ticket_scan_code",
      "rc_is_child",
      "rc_membership_group_name",
      "rc_membership_group_id",
      "rc_membership_level_name",
      "rc_membership_level_id",
      "rc_product_attribute_sku",
      "rc_created",
      "rc_shipping_fulfillment_status",
      "rc_fulfilled_by_employee",
      "rc_shipping_fulfillment_date",
      "rc_ticket_amount_to_ship",
      "rc_shipping_street_address",
      "rc_shipping_unit_number",
      "rc_shipping_city_address",
      "rc_shipping_province_address",
      "rc_shipping_country_address",
      "rc_shipping_postal_address",
    ],
    enabled_fields: [
      "venue",
      "events",
      "products",
      "membership_groups",
      "from_dt",
      "to_dt",
    ],
    required_fields: ["venue"],
  },
  TICKET_HISTORY: {
    id: "report_ticket_history",
    name: t("Ticket Scan History Report"),
    fields: [
      { field: "venue", required: true, qs_filter: "venue" },
      {
        field: "events",
        required: false,
        qs_filter: "item__event_id__in",
        limit: 50,
        use_distinct: false,
      },
      {
        field: "products",
        required: false,
        qs_filter: "item__product_id__in",
        limit: 50,
        use_distinct: false,
      },
      {
        field: "ticket_types",
        required: false,
        qs_filter: "item__type_id__in",
        limit: 50,
      },
      { field: "from_dt", required: false, qs_filter: "created__gte" },
      { field: "to_dt", required: false, qs_filter: "created__lte" },
      { field: "is_select_all_events", required: false },
    ],
    format: "csv",
    available_formats: ["csv", "pdf"],
    enabled_columns: [
      "rc_ticket_history_ticket_code",
      "rc_ticket_history_item_type",
      "rc_ticket_history_ticket_name_on_ticket",
      "rc_ticket_history_ticket_event_name",
      "rc_ticket_history_event_id",
      "rc_ticket_history_tt_description",
      "rc_ticket_history_ticket_id",
      "rc_ticket_history_product_description",
      "rc_ticket_history_product_id",
      "rc_ticket_history_product_attribute_name",
      "rc_ticket_history_product_attribute_id",
      "rc_ticket_history_created",
      "rc_ticket_history_user_action",
      "rc_ticket_history_before_status",
      "rc_ticket_history_after_status",
      "rc_ticket_history_created_by",
    ],
    enabled_fields: [
      "venue",
      "events",
      "products",
      "ticket_types",
      "from_dt",
      "to_dt",
      "is_select_all_events",
    ],
    required_fields: ["venue"],
  },
  EMPLOYEE_SCAN_HISTORY: {
    id: "report_employee_scan_history",
    name: t("Employee Scan History Report"),
    fields: [
      { field: "venue", required: true, qs_filter: "venue" },
      {
        field: "events",
        required: false,
        qs_filter: "item__event_id__in",
        limit: 50,
        use_distinct: false,
      },
      {
        field: "ticket_types",
        required: false,
        qs_filter: "item__type_id__in",
        limit: 50,
      },
      { field: "from_dt", required: false, qs_filter: "created__gte" },
      { field: "to_dt", required: false, qs_filter: "created__lte" },
      { field: "is_select_all_events", required: false },
      { field: "employees", required: false, limit: 60 },
    ],
    format: "pdf",
    available_formats: ["pdf"],
    enabled_columns: [],
    enabled_fields: [
      "venue",
      "events",
      "ticket_types",
      "from_dt",
      "to_dt",
      "is_select_all_events",
      "employees",
    ],
    required_fields: ["venue"],
  },
  VENUE_USER_CASH_OUT: {
    id: "report_venue_user_cash_out",
    name: t("Seller Cash Out Report"),
    fields: [
      { field: "venue", required: true, qs_filter: "venue" },
      {
        field: "employees",
        required: true,
        qs_filter: "venue_user__employment__employee_id__in",
        limit: 1,
      },
      { field: "from_dt", required: false, qs_filter: "from_dt" },
      { field: "to_dt", required: false, qs_filter: "to_dt" },
    ],
    format: "pdf",
    available_formats: ["pdf"],
    enabled_columns: [],
    enabled_fields: ["venue", "employees", "from_dt", "to_dt"],
    required_fields: ["venue", "employees"],
  },
  DISCOUNT_CREATION_REPORT: {
    id: "report_discount_creation",
    name: t("Discount Creation Report"),
    fields: [
      { field: "from_dt", required: false, qs_filter: "created__gte" },
      { field: "to_dt", required: false, qs_filter: "created__lte" },
      { field: "venue", required: true, qs_filter: "venue" },
    ],
    format: "csv",
    available_formats: ["csv"],
    enabled_columns: [
      "rc_discount_allowed_checkouts",
      "rc_discount_amount",
      "rc_discount_limit",
      "rc_discount_maximum_quantity",
      "rc_discount_minimum_quantity",
      "rc_discount_rule_percentages",
      "rc_discount_rule_amounts",
      "rc_discount_percentage",
      "rc_discount_permission_type",
      "rc_discount_per_user_limit",
      "rc_discount_type",
      "rc_discount_created_by",
      "rc_discount_created_on",
      "rc_discount_description",
      "rc_discount_code",
    ],
    enabled_fields: ["from_dt", "to_dt", "venue"],
    required_fields: ["venue"],
  },
  DISCOUNT_USAGE_STATS: {
    id: "report_discount_usage_stats",
    name: t("Discount Usage Stats"),
    fields: [
      { field: "venue", required: true, qs_filter: "venue" },
      { field: "from_dt", required: false, qs_filter: "start_date" },
      { field: "to_dt", required: false, qs_filter: "end_date" },
    ],
    format: "csv",
    available_formats: ["csv"],
    enabled_columns: [
      "rc_discount_description",
      "rc_discount_purchase_platform",
      "rc_discounts_used",
      "rc_discount_ticket_quantity",
      "rc_discount_code",
      "rc_display_gross_sales",
      "rc_refunds",
      "rc_discounts",
      "rc_gross_sales",
      "rc_amount_company_earned",
      "rc_pre_tax_company_charges",
      "rc_company_charges_tax",
      "rc_company_charges",
      "rc_pre_tax_processing_fees",
      "rc_processing_fees_tax",
      "rc_cc_charges",
      "rc_pre_tax_discovery_charges",
      "rc_discovery_charges_tax",
      "rc_discovery_charges",
      "rc_pre_tax_resale_charges",
      "rc_resale_charges_tax",
      "rc_resale_charges",
      "rc_account_credit_applied",
      "rc_account_credit_refunds",
      "rc_exchanged_out",
      "rc_display_gross_revenue",
      "rc_display_organizer_charges",
      "rc_organizer_item_tax",
      "rc_organizer_fee_tax",
      "rc_tax",
      "rc_display_net_revenue",
      "rc_adjustment",
      "rc_amount_paid",
    ],
    enabled_fields: ["venue", "from_dt", "to_dt"],
    required_fields: ["venue"],
  },
  HOLDS_STATS: {
    id: "report_holds_stats",
    name: t("Holds Stats"),
    fields: [
      { field: "venue", required: true, qs_filter: "venue" },
      {
        field: "events",
        required: false,
        qs_filter: "event_id__in",
        limit: 50,
        use_distinct: false,
      },
      {
        field: "ticket_types",
        required: false,
        qs_filter: "type_id__in",
        limit: 50,
      },
      {
        field: "products",
        required: false,
        qs_filter: "product_id__in",
        limit: 50,
        use_distinct: false,
      },
      {
        field: "membership_groups",
        required: false,
        qs_filter: "membership_group_id__in",
        limit: 50,
      },
      {
        field: "membership_levels",
        required: false,
        qs_filter: "membership_level_id__in",
        limit: 50,
      },
      { field: "is_select_all_events", required: false },
      { field: "from_dt", required: false, qs_filter: "created__gte" },
      { field: "to_dt", required: false, qs_filter: "created__lte" },
    ],
    format: "csv",
    available_formats: ["csv"],
    enabled_columns: [
      "rc_ticket_history_item_type",
      "rc_ticket_history_ticket_event_name",
      "rc_ticket_history_event_id",
      "rc_ticket_history_product_description",
      "rc_ticket_history_product_id",
      "rc_ticket_history_product_attribute_name",
      "rc_ticket_history_product_attribute_id",
      "rc_username",
      "rc_email",
      "rc_phone",
      "rc_quantity",
      "rc_event_starts_on",
      "rc_event_ends_on",
      "rc_ticket_type",
      "rc_ticket_type_id",
      "rc_seating_section",
      "rc_seating_row",
      "rc_seating_seat",
      "rc_basket_uuid",
      "rc_membership_group_name",
      "rc_membership_group_id",
      "rc_membership_level_name",
      "rc_membership_level_id",
      "rc_updated",
      "rc_sold_by",
      "rc_hold_link",
    ],
    enabled_fields: [
      "venue",
      "events",
      "ticket_types",
      "products",
      "membership_groups",
      "membership_levels",
      "is_select_all_events",
      "from_dt",
      "to_dt",
    ],
    required_fields: ["venue"],
  },
  EVENT_PRODUCT_INVENTORY: {
    id: "report_event_product_inventory",
    name: t("Event/Product Inventory Report"),
    fields: [
      { field: "venue", required: true, qs_filter: "venue" },
      {
        field: "events",
        required: true,
        qs_filter: "event_id__in",
        limit: 500,
        use_distinct: true,
      },
      {
        field: "products",
        required: false,
        qs_filter: "product_id__in",
        limit: 500,
        use_distinct: true,
      },
    ],
    format: "csv",
    available_formats: ["csv"],
    enabled_columns: [
      "picked_up",
      "rc_email",
      "rc_name_on_ticket",
      "rc_final_amount",
      "rc_tax",
      "rc_quantity",
      "rc_organizer_charges",
      "rc_card_organizer_charges",
      "rc_event",
      "rc_event_starts_on",
      "rc_ticket_type",
      "rc_product_attribute",
      "rc_product",
      "rc_billing_address",
      "rc_company_charges",
    ],
    enabled_fields: ["venue", "events", "products"],
    required_fields: ["venue", "events"],
  },
  MEMBER_REPORT: {
    id: "member_report",
    name: t("Member Report"),
    fields: [
      { field: "venue", required: true, qs_filter: "venue" },
      {
        field: "membership_groups",
        required: false,
        qs_filter: "membership_group__in",
        limit: 60,
      },
      {
        field: "membership_levels",
        required: false,
        qs_filter: "membership_level__in",
        limit: 60,
      },
      { field: "from_dt", required: false, qs_filter: "created__gte" },
      { field: "to_dt", required: false, qs_filter: "created__lte" },
    ],
    format: "csv",
    available_formats: ["csv"],
    enabled_columns: [
      "rc_member_first_name",
      "rc_member_last_name",
      "rc_member_name",
      "rc_member_email",
      "rc_member_phone",
      "rc_member_status",
      "rc_member_quantity",
      "rc_member_expiry_date",
      "rc_member_barcode",
      "rc_member_universal_code",
      "rc_member_scans_used",
      "rc_member_discounts_used",
      "rc_member_last_status_change",
      "rc_member_last_status_changed_by",
      "rc_membership_group_name",
      "rc_membership_level_name",
      "rc_member_latest_season",
      "rc_custom_question_info",
      "rc_info_student_number",
      "rc_info_company",
      "rc_info_job_title",
      "rc_info_home_address_unit_number",
      "rc_info_home_address_street_name",
      "rc_info_home_address_city",
      "rc_info_home_address_province",
      "rc_info_home_address_postal",
      "rc_info_home_address_country",
      "rc_info_birthday",
      "rc_info_license_plate",
    ],
    enabled_fields: [
      "venue",
      "membership_groups",
      "membership_levels",
      "from_dt",
      "to_dt",
    ],
    required_fields: ["venue"],
  },
  MEMBER_HISTORY_REPORT: {
    id: "member_history_report",
    name: t("Member History Report"),
    fields: [
      { field: "venue", required: true, qs_filter: "venue" },
      {
        field: "membership_groups",
        required: false,
        qs_filter: "member__membership_group__in",
        limit: 60,
      },
      {
        field: "membership_levels",
        required: false,
        qs_filter: "member__membership_level__in",
        limit: 60,
      },
      { field: "from_dt", required: false, qs_filter: "created__gte" },
      { field: "to_dt", required: false, qs_filter: "created__lte" },
    ],
    format: "csv",
    available_formats: ["csv"],
    enabled_columns: [
      "rc_member_name",
      "rc_member_email",
      "rc_member_phone",
      "rc_member_barcode",
      "rc_member_history_amount",
      "rc_membership_group_name",
      "rc_membership_level_name",
      "rc_member_status_before",
      "rc_member_status_after",
      "rc_member_history_action",
      "rc_member_history_type",
      "rc_membership_benefit",
      "rc_general_created",
    ],
    enabled_fields: [
      "venue",
      "membership_groups",
      "membership_levels",
      "from_dt",
      "to_dt",
    ],
    required_fields: ["venue"],
  },
  MEMBER_BENEFIT_USAGE_REPORT: {
    id: "member_benefit_usage_report",
    name: t("Member Benefit Usage Report"),
    fields: [
      { field: "venue", required: true, qs_filter: "venue" },
      {
        field: "membership_groups",
        required: false,
        qs_filter: "membership_group__in",
        limit: 60,
      },
      {
        field: "membership_levels",
        required: false,
        qs_filter: "membership_level__in",
        limit: 60,
      },
      { field: "from_dt", required: false, qs_filter: "created__gte" },
      { field: "to_dt", required: false, qs_filter: "created__lte" },
    ],
    format: "csv",
    available_formats: ["csv"],
    enabled_columns: [
      "rc_member_scans_allowed",
      "rc_member_scans_used",
      "rc_member_discounts_allowed",
      "rc_member_discounts_used",
      "rc_membership_group_name",
      "rc_membership_level_name",
      "rc_membership_benefit",
      "rc_membership_benefit_type",
    ],
    enabled_fields: [
      "venue",
      "membership_groups",
      "membership_levels",
      "from_dt",
      "to_dt",
    ],
    required_fields: ["venue"],
  },
  MEMBER_SEATING_REPORT: {
    id: "member_seating_report",
    name: t("Member Seating Report"),
    fields: [
      { field: "venue", required: true, qs_filter: "venue" },
      {
        field: "membership_groups",
        required: false,
        qs_filter: "membership_group__in",
        limit: 60,
      },
      { field: "from_dt", required: false, qs_filter: "created__gte" },
      { field: "to_dt", required: false, qs_filter: "created__lte" },
    ],
    format: "csv",
    available_formats: ["csv"],
    enabled_columns: [
      "rc_quantity",
      "rc_seating_section",
      "rc_seating_row",
      "rc_seating_seat",
      "rc_member_name",
      "rc_member_email",
      "rc_member_phone",
      "rc_member_status",
      "rc_member_seating_reserved",
      "rc_membership_group_name",
      "rc_membership_level_name",
    ],
    enabled_fields: ["venue", "membership_groups", "from_dt", "to_dt"],
    required_fields: ["venue"],
  },
  WAITLIST_SUBSCRIBER_REPORT: {
    id: "waitlist_subscriber_report",
    name: t("Waitlist Subscribers Report"),
    fields: [
      { field: "venue", required: true, qs_filter: "waitlist__venue_id" },
      {
        field: "events",
        required: false,
        qs_filter: "ticket_type__event_id__in",
        limit: 50,
        use_distinct: false,
      },
      {
        field: "ticket_types",
        required: false,
        qs_filter: "ticket_type_id__in",
        limit: 50,
      },
    ],
    format: "csv",
    available_formats: ["csv"],
    enabled_columns: [
      "rc_email",
      "rc_quantity",
      "rc_event",
      "rc_event_starts_on",
      "rc_ticket_type",
      "rc_total_price",
      "rc_total_price_no_fees",
      "rc_info_first_name",
      "rc_info_last_name",
      "rc_status",
    ],
    enabled_fields: ["venue", "events", "ticket_types"],
    required_fields: ["venue"],
  },
  RESELLER_SUBMISSIONS_REPORT: {
    id: "reseller_submissions_report",
    name: t("Reselling Submissions Report"),
    fields: [
      { field: "venue", required: true, qs_filter: "venue_id" },
      {
        field: "events",
        required: false,
        qs_filter: "event_id__in",
        limit: 50,
        use_distinct: false,
      },
    ],
    format: "csv",
    available_formats: ["csv"],
    enabled_columns: [
      "rc_email",
      "rc_quantity",
      "rc_event",
      "rc_event_starts_on",
      "rc_ticket_type",
      "rc_refund_amount",
      "rc_info_first_name",
      "rc_info_last_name",
      "rc_status",
    ],
    enabled_fields: ["venue", "events"],
    required_fields: ["venue"],
  },
  DONOR_TRANSACTIONS: {
    id: "report_donor_transaction",
    name: t("Donations History"),
    fields: [
      { field: "venue", required: true, qs_filter: "venue" },
      { field: "venue", required: false, qs_filter: "invoice_items__venue" },
      { field: "from_dt", required: false, qs_filter: "created__gte" },
      { field: "to_dt", required: false, qs_filter: "created__lte" },
    ],
    format: "csv",
    available_formats: ["csv"],
    enabled_columns: [
      "rc_username",
      "rc_email",
      "rc_phone",
      "rc_event",
      "rc_event_starts_on",
      "rc_created",
      "rc_postal_address",
      "rc_city_address",
      "rc_street_address",
      "rc_province_address",
      "rc_country_address",
      "rc_donation_total",
      "rc_registration_number",
      "rc_charity_name",
      "rc_charity_currency",
    ],
    enabled_fields: ["venue", "venue", "from_dt", "to_dt"],
    required_fields: ["venue"],
  },
  GIFT_CARD_RECIPIENTS: {
    id: "gift_card_recipients_report",
    name: t("Gift Card Recipient Report"),
    fields: [
      { field: "venue", required: true, qs_filter: "gift_card__venue_id" },
      { field: "gift_cards", required: true, qs_filter: "gift_card_id__in" },
      {
        field: "gift_card_denominations",
        required: true,
        qs_filter: "gift_card_denomination_id__in",
      },
      { field: "from_dt", required: false, qs_filter: "created__gte" },
      { field: "to_dt", required: false, qs_filter: "created__lte" },
    ],
    format: "csv",
    available_formats: ["csv"],
    enabled_columns: [
      "rc_transaction_date",
      "rc_quantity",
      "rc_purchaser_username",
      "rc_purchaser_email",
      "rc_purchaser_phone",
      "rc_sender_username",
      "rc_gift_card_redeemed",
      "rc_recipient_name",
      "rc_recipient_email",
      "rc_recipient_phone",
      "rc_gift_card_id",
      "rc_gift_card_name",
      "rc_gift_card_denomination_id",
      "rc_gift_card_denomination_price",
      "rc_gift_card_amount_paid",
      "rc_total_gift_card_amount",
      "rc_amount_advanced",
      "rc_amount_used",
      "rc_amount_remaining",
    ],
    enabled_fields: [
      "venue",
      "gift_cards",
      "gift_card_denominations",
      "from_dt",
      "to_dt",
    ],
    required_fields: ["venue", "gift_cards", "gift_card_denominations"],
  },
  MARKETING_CAMPAIGN_SUMMARY: {
    id: "report_marketing_campaigns",
    name: t("Marketing Campaign Summary"),
    fields: [
      { field: "venue", required: true, qs_filter: "venue" },
      {
        field: "events",
        required: false,
        qs_filter: "event_id__in",
        limit: 50,
        use_distinct: false,
      },
      {
        field: "utm_campaigns",
        required: false,
        qs_filter: "id__in",
        limit: 50,
        use_distinct: false,
      },
      { field: "from_dt", required: false },
      { field: "to_dt", required: false },
    ],
    format: "csv",
    available_formats: ["csv"],
    enabled_columns: [
      "rc_num_items_sold",
      "rc_final_amount",
      "rc_tax",
      "rc_refunds",
      "rc_discounts",
      "rc_gross_sales",
      "rc_amount_company_earned",
      "rc_display_gross_revenue",
      "rc_display_net_revenue",
      "rc_organizer_charges",
      "rc_utm_campaign",
      "rc_utm_source",
      "rc_utm_medium",
      "rc_views",
      "rc_add_to_cart",
      "rc_add_to_cart_rate",
      "rc_initiate_checkout",
      "rc_initiate_checkout_rate",
      "rc_purchases",
      "rc_purchase_rate",
    ],
    enabled_fields: ["venue", "events", "utm_campaigns", "from_dt", "to_dt"],
    required_fields: ["venue"],
  },
  MARKETING_CAMPAIGN_DETAIL: {
    id: "report_marketing_campaign_details",
    name: t("Marketing Campaign Detail"),
    fields: [
      { field: "venue", required: true, qs_filter: "venue" },
      {
        field: "events",
        required: false,
        qs_filter: "event_id__in",
        limit: 60,
      },
      {
        field: "products",
        required: false,
        qs_filter: "product_id__in",
        limit: 50,
      },
      {
        field: "membership_groups",
        required: false,
        qs_filter: "membership_group_id__in",
        limit: 60,
      },
      {
        field: "utm_campaigns",
        required: true,
        qs_filter: "utm_campaign_id__in",
        limit: 50,
        use_distinct: false,
      },
      { field: "from_dt", required: false, qs_filter: "created__gte" },
      { field: "to_dt", required: false, qs_filter: "created__lte" },
    ],
    format: "csv",
    available_formats: ["csv", "pdf"],
    enabled_columns: [
      "rc_ticket_history_ticket_event_name",
      "rc_ticket_history_event_id",
      "rc_ticket_history_product_id",
      "rc_ticket_history_product_attribute_id",
      "rc_discount_amount",
      "rc_rule_discount_percentage",
      "rc_discount_rule_amount",
      "rc_discount_percentage",
      "rc_discount_type",
      "rc_username",
      "rc_email",
      "rc_phone",
      "rc_is_subscribed",
      "rc_invoice_item_description",
      "rc_charge_id",
      "rc_invoice_type_name",
      "rc_invoice_category_name",
      "rc_transaction_id",
      "rc_transaction_date",
      "rc_sale_transaction_id",
      "rc_settlement_date",
      "rc_advance_date",
      "rc_ticket_type_price",
      "rc_credit_type",
      "rc_purchase_source_platform",
      "rc_purchase_note",
      "rc_other_payment_type",
      "rc_transaction_quantity",
      "rc_item_quantity",
      "rc_transfer_quantity",
      "rc_scanned_quantity",
      "rc_scan_limit",
      "rc_refund_type",
      "rc_refund_reason",
      "rc_commissions",
      "rc_payment_type",
      "rc_card_type",
      "rc_event_starts_on",
      "rc_event_ends_on",
      "rc_ticket_type",
      "rc_ticket_type_id",
      "rc_event_location_name",
      "rc_event_location_postal_address",
      "rc_event_location_city_address",
      "rc_event_location_street_name",
      "rc_event_location_province_address",
      "rc_event_location_country_address",
      "rc_password_used",
      "rc_is_sub_ticket",
      "rc_member_name",
      "rc_member_email",
      "rc_membership_group_name",
      "rc_membership_group_id",
      "rc_membership_level_name",
      "rc_membership_level_id",
      "rc_membership_level_price",
      "rc_product_attribute",
      "rc_product_attribute_price",
      "rc_product",
      "rc_venue_name",
      "rc_venue_id",
      "rc_sold_by",
      "rc_referred_by",
      "rc_referred_link_description",
      "rc_referred_link_URL",
      "rc_postal_address",
      "rc_city_address",
      "rc_street_address",
      "rc_province_address",
      "rc_country_address",
      "rc_discount_code",
      "rc_shipping_method",
      "rc_shipping_street_address",
      "rc_shipping_unit_number",
      "rc_shipping_city_address",
      "rc_shipping_province_address",
      "rc_shipping_country_address",
      "rc_shipping_postal_address",
      "rc_shipping_cost",
      "rc_utm_campaign",
      "rc_utm_source",
      "rc_utm_medium",
      "rc_display_gross_sales",
      "rc_refunds",
      "rc_discounts",
      "rc_gross_sales",
      "rc_amount_company_earned",
      "rc_pre_tax_company_charges",
      "rc_company_charges_tax",
      "rc_company_charges",
      "rc_pre_tax_processing_fees",
      "rc_processing_fees_tax",
      "rc_cc_charges",
      "rc_pre_tax_discovery_charges",
      "rc_discovery_charges_tax",
      "rc_discovery_charges",
      "rc_pre_tax_resale_charges",
      "rc_resale_charges_tax",
      "rc_resale_charges",
      "rc_account_credit_applied",
      "rc_account_credit_refunds",
      "rc_exchanged_out",
      "rc_display_gross_revenue",
      "rc_display_organizer_charges",
      "rc_organizer_item_tax",
      "rc_organizer_fee_tax",
      "rc_tax",
      "rc_display_net_revenue",
      "rc_adjustment",
      "rc_amount_paid",
    ],
    enabled_fields: [
      "venue",
      "events",
      "products",
      "membership_groups",
      "utm_campaigns",
      "from_dt",
      "to_dt",
    ],
    required_fields: ["venue", "utm_campaigns"],
  },
} as const;

export const REPORT_TYPE_MAP_BY_ID = {
  report_invoice_transaction: {
    id: "report_invoice_transaction",
    name: t("Transactions"),
    fields: [
      { field: "venue", required: true, qs_filter: "venue" },
      {
        field: "events",
        required: false,
        qs_filter: "invoice_items__event_for_filtering__in",
        limit: 1,
      },
      {
        field: "products",
        required: false,
        qs_filter: "invoice_items__product_for_filtering__in",
        limit: 1,
      },
      { field: "from_dt", required: false, qs_filter: "created__gte" },
      { field: "to_dt", required: false, qs_filter: "created__lte" },
    ],
    format: "csv",
    available_formats: ["csv"],
    enabled_columns: [
      "rc_username",
      "rc_email",
      "rc_phone",
      "rc_name_on_ticket",
      "rc_invoice_type",
      "rc_transaction_id",
      "rc_final_amount",
      "rc_amount_earned",
      "rc_other_custom_type",
      "rc_organizer_charges",
      "rc_card_organizer_charges",
      "rc_cash_organizer_charges",
      "rc_other_organizer_charges",
      "rc_commissions",
      "rc_shipping_costs",
      "rc_items_total_amount",
      "rc_payment_type",
      "rc_card_type",
      "rc_created",
      "rc_sold_by",
      "rc_referred_by",
      "rc_referred_link_description",
      "rc_postal_address",
      "rc_city_address",
      "rc_street_address",
      "rc_province_address",
      "rc_country_address",
      "rc_discount_code",
      "rc_internal_info",
      "rc_refunds",
      "rc_discounts",
      "rc_amount_company_earned",
      "rc_pre_tax_company_charges",
      "rc_company_charges_tax",
      "rc_company_charges",
      "rc_pre_tax_processing_fees",
      "rc_processing_fees_tax",
      "rc_cc_charges",
      "rc_pre_tax_discovery_charges",
      "rc_discovery_charges_tax",
      "rc_discovery_charges",
      "rc_pre_tax_resale_charges",
      "rc_resale_charges_tax",
      "rc_resale_charges",
      "rc_display_organizer_charges",
      "rc_organizer_item_tax",
      "rc_organizer_fee_tax",
      "rc_tax",
    ],
    enabled_fields: ["venue", "events", "products", "from_dt", "to_dt"],
    required_fields: ["venue"],
  },
  report_venue_user: {
    id: "report_venue_user",
    name: t("Customers and Employees"),
    fields: [
      { field: "venue", required: true, qs_filter: "venue" },
      {
        field: "events",
        required: true,
        qs_filter: "item_groups__event__in",
        limit: 50,
        use_distinct: true,
      },
      {
        field: "ticket_types",
        required: false,
        qs_filter: "item_groups__type__in",
        limit: 50,
        use_distinct: true,
      },
      { field: "is_select_all_events", required: false },
      { field: "from_dt", required: false },
      { field: "to_dt", required: false },
    ],
    format: "csv",
    available_formats: ["csv"],
    enabled_columns: [
      "rc_username",
      "rc_email",
      "rc_phone",
      "rc_birthday",
      "rc_gender",
      "rc_is_seller",
      "rc_is_employee",
      "rc_is_subscribed",
      "rc_allow_mail_contact",
      "rc_allow_phone_contact",
      "rc_num_customer_reservations",
      "rc_num_checked_in_as_customer",
      "rc_num_reservations_booked",
      "rc_num_checked_in_as_employee",
      "rc_num_tickets_purchased",
      "rc_num_tickets_sold",
      "rc_external_tickets_quantity",
      "rc_external_tickets_spend",
      "rc_external_donations",
      "rc_venueuser_shipping_name",
      "rc_revenue_tickets_purchased",
      "rc_revenue_tickets_sold",
      "rc_shipping_street_address",
      "rc_shipping_unit_number",
      "rc_shipping_city_address",
      "rc_shipping_province_address",
      "rc_shipping_country_address",
      "rc_shipping_postal_address",
    ],
    enabled_fields: [
      "venue",
      "events",
      "ticket_types",
      "is_select_all_events",
      "from_dt",
      "to_dt",
    ],
    required_fields: ["venue", "events"],
  },
  report_will_call: {
    id: "report_will_call",
    name: t("Will Call"),
    fields: [
      { field: "venue", required: true, qs_filter: "venue" },
      { field: "events", required: false, qs_filter: "event__in", limit: 60 },
      {
        field: "products",
        required: false,
        qs_filter: "product__in",
        limit: 50,
      },
      {
        field: "ticket_types",
        required: false,
        qs_filter: "type__in",
        limit: 60,
      },
      { field: "ticket_statuses", required: false, qs_filter: "status__in" },
      { field: "is_select_all_events", required: false },
      { field: "from_dt", required: false, qs_filter: "created__gte" },
      { field: "to_dt", required: false, qs_filter: "created__lte" },
    ],
    format: "csv",
    available_formats: ["csv"],
    enabled_columns: [
      "rc_email",
      "rc_phone",
      "rc_name_on_ticket",
      "rc_quantity",
      "rc_event",
      "rc_event_starts_on",
      "rc_event_ends_on",
      "rc_ticket_type",
      "rc_ticket_status",
      "rc_ticket_barcode",
      "rc_ticket_scan_code",
      "rc_seating_section",
      "rc_password_used",
      "rc_seating_row",
      "rc_seating_seat",
      "rc_ticket_description",
      "rc_last_status_change",
      "rc_last_status_changed_by",
      "rc_product_attribute",
      "rc_product",
      "rc_created",
      "rc_sold_by",
      "rc_sold_by_venue",
      "rc_custom_question_info",
      "rc_info_student_number",
      "rc_info_company",
      "rc_info_job_title",
      "rc_info_first_name",
      "rc_info_last_name",
      "rc_info_phone_number",
      "rc_info_email",
      "rc_info_home_address_unit_number",
      "rc_info_home_address_street_name",
      "rc_info_home_address_city",
      "rc_info_home_address_province",
      "rc_info_home_address_postal",
      "rc_info_home_address_country",
      "rc_info_birthday",
      "rc_info_license_plate",
    ],
    enabled_fields: [
      "venue",
      "events",
      "products",
      "ticket_types",
      "ticket_statuses",
      "is_select_all_events",
      "from_dt",
      "to_dt",
    ],
    required_fields: ["venue"],
  },
  report_will_call_financial: {
    id: "report_will_call_financial",
    name: t("Itemized Sales Report"),
    fields: [
      { field: "venue", required: true, qs_filter: "venue" },
      { field: "is_select_from_sub_orgs", required: false },
      {
        field: "events",
        required: false,
        qs_filter: "event_id__in",
        limit: 60,
      },
      {
        field: "products",
        required: false,
        qs_filter: "product_id__in",
        limit: 50,
      },
      {
        field: "ticket_types",
        required: false,
        qs_filter: "ticket_type_id__in",
        limit: 60,
      },
      {
        field: "membership_groups",
        required: false,
        qs_filter: "membership_group_id__in",
        limit: 60,
      },
      {
        field: "membership_levels",
        required: false,
        qs_filter: "membership_level_id__in",
        limit: 60,
      },
      { field: "is_select_all_events", required: false },
      { field: "from_dt", required: false, qs_filter: "created__gte" },
      { field: "to_dt", required: false, qs_filter: "created__lte" },
      {
        field: "employees",
        required: false,
        qs_filter: "invoice__sold_by__in",
        limit: 60,
      },
      {
        field: "purchase_source_platforms",
        required: false,
        qs_filter: "purchase_source_platform__in",
      },
    ],
    format: "csv",
    available_formats: ["csv", "pdf"],
    enabled_columns: [
      "rc_ticket_history_ticket_event_name",
      "rc_ticket_history_event_id",
      "rc_ticket_history_product_id",
      "rc_ticket_history_product_attribute_id",
      "rc_discount_amount",
      "rc_rule_discount_percentage",
      "rc_discount_rule_amount",
      "rc_discount_percentage",
      "rc_discount_type",
      "rc_username",
      "rc_email",
      "rc_phone",
      "rc_is_subscribed",
      "rc_invoice_item_description",
      "rc_charge_id",
      "rc_invoice_type_name",
      "rc_invoice_category_name",
      "rc_transaction_id",
      "rc_transaction_date",
      "rc_sale_transaction_id",
      "rc_settlement_date",
      "rc_advance_date",
      "rc_ticket_type_price",
      "rc_credit_type",
      "rc_purchase_source_platform",
      "rc_purchase_note",
      "rc_other_payment_type",
      "rc_transaction_quantity",
      "rc_item_quantity",
      "rc_transfer_quantity",
      "rc_scanned_quantity",
      "rc_scan_limit",
      "rc_refund_type",
      "rc_refund_reason",
      "rc_commissions",
      "rc_payment_type",
      "rc_card_type",
      "rc_event_starts_on",
      "rc_event_ends_on",
      "rc_ticket_type",
      "rc_ticket_type_id",
      "rc_event_location_name",
      "rc_event_location_postal_address",
      "rc_event_location_city_address",
      "rc_event_location_street_name",
      "rc_event_location_province_address",
      "rc_event_location_country_address",
      "rc_password_used",
      "rc_is_sub_ticket",
      "rc_member_name",
      "rc_member_email",
      "rc_membership_group_name",
      "rc_membership_group_id",
      "rc_membership_level_name",
      "rc_membership_level_id",
      "rc_membership_level_price",
      "rc_product_attribute",
      "rc_product_attribute_price",
      "rc_product",
      "rc_price_tier_name",
      "rc_price_tier_id",
      "rc_price_tier_price",
      "rc_venue_name",
      "rc_venue_id",
      "rc_sold_by",
      "rc_referred_by",
      "rc_referred_link_description",
      "rc_referred_link_URL",
      "rc_postal_address",
      "rc_city_address",
      "rc_street_address",
      "rc_province_address",
      "rc_country_address",
      "rc_discount_code",
      "rc_shipping_method",
      "rc_shipping_street_address",
      "rc_shipping_unit_number",
      "rc_shipping_city_address",
      "rc_shipping_province_address",
      "rc_shipping_country_address",
      "rc_shipping_postal_address",
      "rc_shipping_cost",
      "rc_ticket_pay_what_you_can_enabled",
      "rc_ticket_pay_what_you_can_difference",
      "rc_display_gross_sales",
      "rc_refunds",
      "rc_discounts",
      "rc_gross_sales",
      "rc_amount_company_earned",
      "rc_pre_tax_company_charges",
      "rc_company_charges_tax",
      "rc_company_charges",
      "rc_pre_tax_processing_fees",
      "rc_processing_fees_tax",
      "rc_cc_charges",
      "rc_pre_tax_discovery_charges",
      "rc_discovery_charges_tax",
      "rc_discovery_charges",
      "rc_pre_tax_resale_charges",
      "rc_resale_charges_tax",
      "rc_resale_charges",
      "rc_account_credit_applied",
      "rc_account_credit_refunds",
      "rc_exchanged_out",
      "rc_display_gross_revenue",
      "rc_display_organizer_charges",
      "rc_organizer_item_tax",
      "rc_organizer_fee_tax",
      "rc_tax",
      "rc_display_net_revenue",
      "rc_adjustment",
      "rc_amount_paid",
    ],
    enabled_fields: [
      "venue",
      "is_select_from_sub_orgs",
      "events",
      "products",
      "ticket_types",
      "membership_groups",
      "membership_levels",
      "is_select_all_events",
      "from_dt",
      "to_dt",
      "employees",
      "purchase_source_platforms",
    ],
    required_fields: ["venue"],
  },
  settlement_report: {
    id: "settlement_report",
    name: t("Settlement Report"),
    fields: [
      { field: "venue", required: true, qs_filter: "venue" },
      {
        field: "payout_invoices",
        required: false,
        qs_filter: "payout_invoice_item__invoice__in",
        limit: 60,
      },
      { field: "from_dt", required: false, qs_filter: "created__gte" },
      { field: "to_dt", required: false, qs_filter: "created__lte" },
    ],
    available_formats: ["csv", "pdf"],
    enabled_columns: [
      "rc_ticket_history_ticket_event_name",
      "rc_ticket_history_event_id",
      "rc_ticket_history_product_id",
      "rc_ticket_history_product_attribute_id",
      "rc_discount_amount",
      "rc_rule_discount_percentage",
      "rc_discount_rule_amount",
      "rc_discount_percentage",
      "rc_discount_type",
      "rc_username",
      "rc_email",
      "rc_phone",
      "rc_is_subscribed",
      "rc_invoice_item_description",
      "rc_charge_id",
      "rc_invoice_type_name",
      "rc_invoice_category_name",
      "rc_transaction_id",
      "rc_transaction_date",
      "rc_sale_transaction_id",
      "rc_settlement_date",
      "rc_advance_date",
      "rc_ticket_type_price",
      "rc_credit_type",
      "rc_purchase_source_platform",
      "rc_purchase_note",
      "rc_other_payment_type",
      "rc_transaction_quantity",
      "rc_item_quantity",
      "rc_transfer_quantity",
      "rc_scanned_quantity",
      "rc_scan_limit",
      "rc_refund_type",
      "rc_refund_reason",
      "rc_commissions",
      "rc_payment_type",
      "rc_card_type",
      "rc_event_starts_on",
      "rc_event_ends_on",
      "rc_ticket_type",
      "rc_ticket_type_id",
      "rc_event_location_name",
      "rc_event_location_postal_address",
      "rc_event_location_city_address",
      "rc_event_location_street_name",
      "rc_event_location_province_address",
      "rc_event_location_country_address",
      "rc_password_used",
      "rc_is_sub_ticket",
      "rc_member_name",
      "rc_member_email",
      "rc_membership_group_name",
      "rc_membership_group_id",
      "rc_membership_level_name",
      "rc_membership_level_id",
      "rc_membership_level_price",
      "rc_product_attribute",
      "rc_product_attribute_price",
      "rc_product",
      "rc_price_tier_name",
      "rc_price_tier_id",
      "rc_price_tier_price",
      "rc_venue_name",
      "rc_venue_id",
      "rc_sold_by",
      "rc_referred_by",
      "rc_referred_link_description",
      "rc_referred_link_URL",
      "rc_postal_address",
      "rc_city_address",
      "rc_street_address",
      "rc_province_address",
      "rc_country_address",
      "rc_discount_code",
      "rc_shipping_method",
      "rc_shipping_street_address",
      "rc_shipping_unit_number",
      "rc_shipping_city_address",
      "rc_shipping_province_address",
      "rc_shipping_country_address",
      "rc_shipping_postal_address",
      "rc_shipping_cost",
      "rc_display_gross_sales",
      "rc_refunds",
      "rc_discounts",
      "rc_gross_sales",
      "rc_amount_company_earned",
      "rc_pre_tax_company_charges",
      "rc_company_charges_tax",
      "rc_company_charges",
      "rc_pre_tax_processing_fees",
      "rc_processing_fees_tax",
      "rc_cc_charges",
      "rc_pre_tax_discovery_charges",
      "rc_discovery_charges_tax",
      "rc_discovery_charges",
      "rc_pre_tax_resale_charges",
      "rc_resale_charges_tax",
      "rc_resale_charges",
      "rc_account_credit_applied",
      "rc_account_credit_refunds",
      "rc_exchanged_out",
      "rc_display_gross_revenue",
      "rc_display_organizer_charges",
      "rc_organizer_item_tax",
      "rc_organizer_fee_tax",
      "rc_tax",
      "rc_display_net_revenue",
      "rc_adjustment",
      "rc_amount_paid",
    ],
    enabled_fields: ["venue", "payout_invoices", "from_dt", "to_dt"],
    required_fields: ["venue"],
  },
  advance_report: {
    id: "advance_report",
    name: t("Advance Report"),
    fields: [
      { field: "venue", required: true, qs_filter: "venue" },
      {
        field: "advance_invoices",
        required: false,
        qs_filter: "advance_invoice_item__invoice__in",
        limit: 60,
      },
      { field: "from_dt", required: false, qs_filter: "created__gte" },
      { field: "to_dt", required: false, qs_filter: "created__lte" },
    ],
    available_formats: ["csv", "pdf"],
    enabled_columns: [
      "rc_ticket_history_ticket_event_name",
      "rc_ticket_history_event_id",
      "rc_ticket_history_product_id",
      "rc_ticket_history_product_attribute_id",
      "rc_discount_amount",
      "rc_rule_discount_percentage",
      "rc_discount_rule_amount",
      "rc_discount_percentage",
      "rc_discount_type",
      "rc_username",
      "rc_email",
      "rc_phone",
      "rc_is_subscribed",
      "rc_invoice_item_description",
      "rc_charge_id",
      "rc_invoice_type_name",
      "rc_invoice_category_name",
      "rc_transaction_id",
      "rc_transaction_date",
      "rc_sale_transaction_id",
      "rc_settlement_date",
      "rc_advance_date",
      "rc_ticket_type_price",
      "rc_credit_type",
      "rc_purchase_source_platform",
      "rc_purchase_note",
      "rc_other_payment_type",
      "rc_transaction_quantity",
      "rc_item_quantity",
      "rc_transfer_quantity",
      "rc_scanned_quantity",
      "rc_scan_limit",
      "rc_refund_type",
      "rc_refund_reason",
      "rc_commissions",
      "rc_payment_type",
      "rc_card_type",
      "rc_event_starts_on",
      "rc_event_ends_on",
      "rc_ticket_type",
      "rc_ticket_type_id",
      "rc_event_location_name",
      "rc_event_location_postal_address",
      "rc_event_location_city_address",
      "rc_event_location_street_name",
      "rc_event_location_province_address",
      "rc_event_location_country_address",
      "rc_password_used",
      "rc_is_sub_ticket",
      "rc_member_name",
      "rc_member_email",
      "rc_membership_group_name",
      "rc_membership_group_id",
      "rc_membership_level_name",
      "rc_membership_level_id",
      "rc_membership_level_price",
      "rc_product_attribute",
      "rc_product_attribute_price",
      "rc_product",
      "rc_price_tier_name",
      "rc_price_tier_id",
      "rc_price_tier_price",
      "rc_venue_name",
      "rc_venue_id",
      "rc_sold_by",
      "rc_referred_by",
      "rc_referred_link_description",
      "rc_referred_link_URL",
      "rc_postal_address",
      "rc_city_address",
      "rc_street_address",
      "rc_province_address",
      "rc_country_address",
      "rc_discount_code",
      "rc_shipping_method",
      "rc_shipping_street_address",
      "rc_shipping_unit_number",
      "rc_shipping_city_address",
      "rc_shipping_province_address",
      "rc_shipping_country_address",
      "rc_shipping_postal_address",
      "rc_shipping_cost",
      "rc_display_gross_sales",
      "rc_refunds",
      "rc_discounts",
      "rc_gross_sales",
      "rc_amount_company_earned",
      "rc_pre_tax_company_charges",
      "rc_company_charges_tax",
      "rc_company_charges",
      "rc_pre_tax_processing_fees",
      "rc_processing_fees_tax",
      "rc_cc_charges",
      "rc_pre_tax_discovery_charges",
      "rc_discovery_charges_tax",
      "rc_discovery_charges",
      "rc_pre_tax_resale_charges",
      "rc_resale_charges_tax",
      "rc_resale_charges",
      "rc_account_credit_applied",
      "rc_account_credit_refunds",
      "rc_exchanged_out",
      "rc_display_gross_revenue",
      "rc_display_organizer_charges",
      "rc_organizer_item_tax",
      "rc_organizer_fee_tax",
      "rc_tax",
      "rc_display_net_revenue",
      "rc_adjustment",
      "rc_amount_paid",
    ],
    enabled_fields: ["venue", "advance_invoices", "from_dt", "to_dt"],
    required_fields: ["venue"],
  },
  report_ticket_sales_history: {
    id: "report_ticket_sales_history",
    name: t("Ticket Sales History"),
    fields: [
      { field: "venue", required: true, qs_filter: "venue" },
      { field: "events", required: false, qs_filter: "event__in", limit: 60 },
      {
        field: "ticket_types",
        required: false,
        qs_filter: "ticket_type__in",
        limit: 60,
      },
      { field: "is_select_all_events", required: false },
      { field: "from_dt", required: false, qs_filter: "created__gte" },
      { field: "to_dt", required: false, qs_filter: "created__lte" },
      { field: "purchase_source_platforms", required: false },
    ],
    format: "pdf",
    available_formats: ["pdf"],
    enabled_columns: [],
    enabled_fields: [
      "venue",
      "events",
      "ticket_types",
      "is_select_all_events",
      "from_dt",
      "to_dt",
      "purchase_source_platforms",
    ],
    required_fields: ["venue"],
  },
  report_employee_sales_history: {
    id: "report_employee_sales_history",
    name: t("Employee Sales History"),
    fields: [
      { field: "venue", required: true, qs_filter: "venue" },
      { field: "events", required: false, qs_filter: "event__in", limit: 60 },
      {
        field: "ticket_types",
        required: false,
        qs_filter: "ticket_type__in",
        limit: 60,
      },
      { field: "is_select_all_events", required: false },
      { field: "from_dt", required: false, qs_filter: "created__gte" },
      { field: "to_dt", required: false, qs_filter: "created__lte" },
      { field: "employees", required: false, limit: 60 },
      { field: "purchase_source_platforms", required: false },
    ],
    format: "pdf",
    available_formats: ["pdf"],
    enabled_columns: [],
    enabled_fields: [
      "venue",
      "events",
      "ticket_types",
      "is_select_all_events",
      "from_dt",
      "to_dt",
      "employees",
      "purchase_source_platforms",
    ],
    required_fields: ["venue"],
  },
  report_event_breakdown: {
    id: "report_event_breakdown",
    name: t("Event Summary"),
    fields: [
      { field: "venue", required: true, qs_filter: "venue" },
      { field: "events", required: true, qs_filter: "id__in", limit: 60 },
      { field: "is_select_all_events", required: false },
      { field: "from_dt", required: false },
      { field: "to_dt", required: false },
    ],
    format: "csv",
    available_formats: ["csv", "pdf"],
    enabled_columns: [
      "rc_sub_tickets_generated_from_package",
      "rc_cash_organizer_charges",
      "rc_other_organizer_charges",
      "rc_commissions",
      "rc_shipping_costs",
      "rc_cash_revenue",
      "rc_credit_revenue",
      "rc_event",
      "rc_event_starts_on",
      "rc_event_ends_on",
      "rc_event_location",
      "rc_num_tickets_sold_cash",
      "rc_num_tickets_sold_credit",
      "rc_num_tickets_sold_affirm",
      "rc_num_tickets_sold_comp",
      "rc_num_tickets_sold_free",
      "rc_num_of_standard_tickets_sold",
      "rc_num_of_tickets_sold_redeemable",
      "rc_num_of_redeemable_tickets",
      "rc_total_inventory",
      "rc_num_of_total_packages",
      "rc_total_ticket_package_inventory",
      "rc_num_of_sub_tickets_from_event",
      "rc_num_of_sub_tickets_from_outside_event",
      "rc_num_of_tickets_not_included_in_stats",
      "rc_num_of_hold_tickets",
      "rc_num_of_payment_plans_copy",
      "rc_affirm_revenue",
      "rc_display_gross_sales",
      "rc_discounts",
      "rc_refunds",
      "rc_disputes",
      "rc_gross_sales",
      "rc_amount_company_earned_sub_custom_fees",
      "rc_company_charges_sub_custom_fees",
      "rc_cc_charges",
      "rc_discovery_charges",
      "rc_resale_charges",
      "rc_invoice_fee_total",
      "rc_account_credit_applied",
      "rc_exchange_credit_applied",
      "rc_venue_credit_applied",
      "rc_user_credit_applied",
      "rc_referral_credit_applied",
      "rc_exchanged_out",
      "rc_account_credit_refunds",
      "rc_display_gross_revenue",
      "rc_display_organizer_charges",
      "rc_tax",
      "rc_shipping_costs",
      "rc_credit_memo_total",
      "rc_display_net_revenue",
      "rc_card_organizer_charges",
      "rc_card_tax",
      "rc_card_shipping_costs",
      "rc_other_settlement_difference",
      "rc_cash_settlement_difference",
      "rc_custom_processor_adjustment",
      "rc_square_oauth_adjustment",
      "rc_advances",
      "rc_settlements",
      "rc_non_venue_credit_applied",
      "rc_amount_paid",
      "rc_display_gross_sales",
      "rc_refunds",
      "rc_discounts",
      "rc_gross_sales",
      "rc_amount_company_earned",
      "rc_pre_tax_company_charges",
      "rc_company_charges_tax",
      "rc_company_charges",
      "rc_pre_tax_processing_fees",
      "rc_processing_fees_tax",
      "rc_cc_charges",
      "rc_pre_tax_discovery_charges",
      "rc_discovery_charges_tax",
      "rc_discovery_charges",
      "rc_pre_tax_resale_charges",
      "rc_resale_charges_tax",
      "rc_resale_charges",
      "rc_account_credit_applied",
      "rc_account_credit_refunds",
      "rc_exchanged_out",
      "rc_display_gross_revenue",
      "rc_display_organizer_charges",
      "rc_organizer_item_tax",
      "rc_organizer_fee_tax",
      "rc_tax",
      "rc_display_net_revenue",
      "rc_adjustment",
      "rc_amount_paid",
    ],
    enabled_fields: [
      "venue",
      "events",
      "is_select_all_events",
      "from_dt",
      "to_dt",
    ],
    required_fields: ["venue", "events"],
  },
  report_event_audit: {
    id: "report_event_audit",
    name: t("Event Audit"),
    fields: [
      { field: "venue", required: true, qs_filter: "venue" },
      { field: "events", required: true, qs_filter: "id__in", limit: 1 },
    ],
    format: "xlsx",
    available_formats: ["xlsx"],
    enabled_columns: [],
    enabled_fields: ["venue", "events"],
    required_fields: ["venue", "events"],
  },
  payment_type_breakdown: {
    id: "payment_type_breakdown",
    name: t("Payment Type Breakdown"),
    fields: [
      { field: "venue", required: true, qs_filter: "venue" },
      { field: "events", required: false, limit: 1500 },
      { field: "products", required: false, limit: 1500 },
      { field: "membership_groups", required: false, limit: 1500 },
      { field: "membership_levels", required: false, limit: 1500 },
      { field: "is_select_all_events", required: false },
      { field: "from_dt", required: false },
      { field: "to_dt", required: false },
    ],
    format: "pdf",
    available_formats: ["pdf"],
    enabled_columns: [],
    enabled_fields: [
      "venue",
      "events",
      "products",
      "membership_groups",
      "membership_levels",
      "is_select_all_events",
      "from_dt",
      "to_dt",
    ],
    required_fields: ["venue"],
  },
  financial_scan_summary: {
    id: "financial_scan_summary",
    name: t("Financial Scan Summary"),
    fields: [
      { field: "venue", required: true, qs_filter: "venue" },
      { field: "events", required: true, limit: 1500 },
      { field: "from_dt", required: false },
      { field: "to_dt", required: false },
    ],
    format: "pdf",
    available_formats: ["pdf"],
    enabled_columns: [],
    enabled_fields: ["venue", "events", "from_dt", "to_dt"],
    required_fields: ["venue", "events"],
  },
  event_financial_summary: {
    id: "event_financial_summary",
    name: t("Event Financial Summary"),
    fields: [
      { field: "venue", required: true, qs_filter: "venue" },
      { field: "events", required: false, limit: 1500 },
      { field: "is_select_all_events", required: false },
      { field: "from_dt", required: false },
      { field: "to_dt", required: false },
    ],
    format: "pdf",
    available_formats: ["pdf"],
    enabled_columns: [],
    enabled_fields: [
      "venue",
      "events",
      "is_select_all_events",
      "from_dt",
      "to_dt",
    ],
    required_fields: ["venue"],
  },
  ticket_type_financial_summary: {
    id: "ticket_type_financial_summary",
    name: t("Ticket Type Financial Summary"),
    fields: [
      { field: "venue", required: true, qs_filter: "venue" },
      { field: "events", required: false, limit: 1500 },
      { field: "is_select_all_events", required: false },
      { field: "from_dt", required: false },
      { field: "to_dt", required: false },
    ],
    format: "pdf",
    available_formats: ["pdf"],
    enabled_columns: [],
    enabled_fields: [
      "venue",
      "events",
      "is_select_all_events",
      "from_dt",
      "to_dt",
    ],
    required_fields: ["venue"],
  },
  report_ticket_type_breakdown: {
    id: "report_ticket_type_breakdown",
    name: t("Ticket Type Summary"),
    fields: [
      { field: "venue", required: true, qs_filter: "venue" },
      {
        field: "ticket_types",
        required: false,
        qs_filter: "id__in",
        limit: 50,
      },
      { field: "events", required: true, qs_filter: "event_id__in", limit: 50 },
    ],
    format: "csv",
    available_formats: ["csv"],
    enabled_columns: [
      "rc_sub_tickets_generated_from_package",
      "rc_ticket_type_price",
      "rc_cash_organizer_charges",
      "rc_other_organizer_charges",
      "rc_commissions",
      "rc_shipping_costs",
      "rc_cash_revenue",
      "rc_credit_revenue",
      "rc_event",
      "rc_event_starts_on",
      "rc_event_ends_on",
      "rc_ticket_type",
      "rc_event_location",
      "rc_num_tickets_sold_cash",
      "rc_num_tickets_sold_credit",
      "rc_num_tickets_sold_affirm",
      "rc_num_tickets_sold_comp",
      "rc_num_tickets_sold_free",
      "rc_num_tickets_refunded",
      "rc_num_of_redeemable_tickets",
      "rc_total_inventory",
      "rc_num_of_total_packages",
      "rc_num_of_tickets_not_included_in_stats",
      "rc_affirm_revenue",
      "rc_display_gross_sales",
      "rc_refunds",
      "rc_discounts",
      "rc_gross_sales",
      "rc_amount_company_earned",
      "rc_pre_tax_company_charges",
      "rc_company_charges_tax",
      "rc_company_charges",
      "rc_pre_tax_processing_fees",
      "rc_processing_fees_tax",
      "rc_cc_charges",
      "rc_pre_tax_discovery_charges",
      "rc_discovery_charges_tax",
      "rc_discovery_charges",
      "rc_pre_tax_resale_charges",
      "rc_resale_charges_tax",
      "rc_resale_charges",
      "rc_account_credit_applied",
      "rc_account_credit_refunds",
      "rc_exchanged_out",
      "rc_display_gross_revenue",
      "rc_display_organizer_charges",
      "rc_organizer_item_tax",
      "rc_organizer_fee_tax",
      "rc_tax",
      "rc_display_net_revenue",
      "rc_adjustment",
      "rc_amount_paid",
    ],
    enabled_fields: ["venue", "ticket_types", "events"],
    required_fields: ["venue", "events"],
  },
  product_breakdown_report: {
    id: "product_breakdown_report",
    name: t("Product Summary"),
    fields: [
      { field: "venue", required: true, qs_filter: "venue" },
      { field: "products", required: true, qs_filter: "id__in", limit: 60 },
      { field: "from_dt", required: false },
      { field: "to_dt", required: false },
    ],
    format: "csv",
    available_formats: ["csv", "pdf"],
    enabled_columns: [
      "rc_cash_organizer_charges",
      "rc_other_organizer_charges",
      "rc_commissions",
      "rc_shipping_costs",
      "rc_cash_revenue",
      "rc_credit_revenue",
      "rc_num_tickets_sold_cash",
      "rc_num_tickets_sold_credit",
      "rc_num_tickets_sold_affirm",
      "rc_num_tickets_sold_comp",
      "rc_num_tickets_sold_free",
      "rc_product",
      "rc_num_of_standard_tickets_sold",
      "rc_num_of_redeemable_tickets",
      "rc_total_inventory",
      "rc_num_of_hold_tickets",
      "rc_affirm_revenue",
      "rc_display_gross_sales",
      "rc_discounts",
      "rc_refunds",
      "rc_disputes",
      "rc_gross_sales",
      "rc_amount_company_earned_sub_custom_fees",
      "rc_company_charges_sub_custom_fees",
      "rc_cc_charges",
      "rc_discovery_charges",
      "rc_resale_charges",
      "rc_invoice_fee_total",
      "rc_account_credit_applied",
      "rc_exchange_credit_applied",
      "rc_venue_credit_applied",
      "rc_user_credit_applied",
      "rc_referral_credit_applied",
      "rc_exchanged_out",
      "rc_account_credit_refunds",
      "rc_display_gross_revenue",
      "rc_display_organizer_charges",
      "rc_tax",
      "rc_shipping_costs",
      "rc_credit_memo_total",
      "rc_display_net_revenue",
      "rc_card_organizer_charges",
      "rc_card_tax",
      "rc_card_shipping_costs",
      "rc_other_settlement_difference",
      "rc_cash_settlement_difference",
      "rc_custom_processor_adjustment",
      "rc_square_oauth_adjustment",
      "rc_advances",
      "rc_settlements",
      "rc_non_venue_credit_applied",
      "rc_amount_paid",
      "rc_display_gross_sales",
      "rc_refunds",
      "rc_discounts",
      "rc_gross_sales",
      "rc_amount_company_earned",
      "rc_pre_tax_company_charges",
      "rc_company_charges_tax",
      "rc_company_charges",
      "rc_pre_tax_processing_fees",
      "rc_processing_fees_tax",
      "rc_cc_charges",
      "rc_pre_tax_discovery_charges",
      "rc_discovery_charges_tax",
      "rc_discovery_charges",
      "rc_pre_tax_resale_charges",
      "rc_resale_charges_tax",
      "rc_resale_charges",
      "rc_account_credit_applied",
      "rc_account_credit_refunds",
      "rc_exchanged_out",
      "rc_display_gross_revenue",
      "rc_display_organizer_charges",
      "rc_organizer_item_tax",
      "rc_organizer_fee_tax",
      "rc_tax",
      "rc_display_net_revenue",
      "rc_adjustment",
      "rc_amount_paid",
    ],
    enabled_fields: ["venue", "products", "from_dt", "to_dt"],
    required_fields: ["venue", "products"],
  },
  report_password_used_breakdown: {
    id: "report_password_used_breakdown",
    name: t("Password Used Summary"),
    fields: [
      { field: "venue", required: true, qs_filter: "venue" },
      {
        field: "events",
        required: false,
        qs_filter: "events__id__in",
        limit: 50,
      },
    ],
    format: "csv",
    available_formats: ["csv"],
    enabled_columns: [
      "rc_num_tickets_sold",
      "rc_event",
      "rc_num_of_passwords_used",
      "rc_password",
      "rc_display_gross_sales",
      "rc_refunds",
      "rc_discounts",
      "rc_gross_sales",
      "rc_amount_company_earned",
      "rc_pre_tax_company_charges",
      "rc_company_charges_tax",
      "rc_company_charges",
      "rc_pre_tax_processing_fees",
      "rc_processing_fees_tax",
      "rc_cc_charges",
      "rc_pre_tax_discovery_charges",
      "rc_discovery_charges_tax",
      "rc_discovery_charges",
      "rc_pre_tax_resale_charges",
      "rc_resale_charges_tax",
      "rc_resale_charges",
      "rc_account_credit_applied",
      "rc_account_credit_refunds",
      "rc_exchanged_out",
      "rc_display_gross_revenue",
      "rc_display_organizer_charges",
      "rc_organizer_item_tax",
      "rc_organizer_fee_tax",
      "rc_tax",
      "rc_display_net_revenue",
      "rc_adjustment",
      "rc_amount_paid",
    ],
    enabled_fields: ["venue", "events"],
    required_fields: ["venue"],
  },
  report_seller_stats: {
    id: "report_seller_stats",
    name: t("Seller Stats"),
    fields: [
      { field: "venue", required: true, qs_filter: "venue" },
      {
        field: "events",
        required: false,
        qs_filter: "event_id__in",
        limit: 50,
        use_distinct: true,
      },
      {
        field: "products",
        required: false,
        qs_filter: "product_id__in",
        limit: 50,
        use_distinct: true,
      },
      {
        field: "membership_groups",
        required: false,
        qs_filter: "membership_group_id__in",
        limit: 50,
        use_distinct: true,
      },
      {
        field: "membership_levels",
        required: false,
        qs_filter: "membership_level_id__in",
        limit: 50,
        use_distinct: true,
      },
      { field: "is_select_all_events", required: false },
      { field: "from_dt", required: false, qs_filter: "created__gte" },
      { field: "to_dt", required: false, qs_filter: "created__lte" },
    ],
    format: "csv",
    available_formats: ["csv"],
    enabled_columns: [
      "rc_username",
      "rc_email",
      "rc_phone",
      "rc_num_tickets_sold",
      "rc_final_amount",
      "rc_amount_earned",
      "rc_organizer_charges",
      "rc_card_organizer_charges",
      "rc_cash_organizer_charges",
      "rc_other_organizer_charges",
      "rc_cash_commissions",
      "rc_credit_commissions",
      "rc_cash_revenue",
      "rc_credit_revenue",
      "rc_num_tickets_sold_cash",
      "rc_num_tickets_sold_credit",
      "rc_num_tickets_sold_affirm",
      "rc_num_tickets_sold_comp",
      "rc_num_tickets_sold_free",
      "rc_affirm_revenue",
    ],
    enabled_fields: [
      "venue",
      "events",
      "products",
      "membership_groups",
      "membership_levels",
      "is_select_all_events",
      "from_dt",
      "to_dt",
    ],
    required_fields: ["venue"],
  },
  report_shipping_fulfillment: {
    id: "report_shipping_fulfillment",
    name: t("Shipping Fulfillment Stats"),
    fields: [
      { field: "venue", required: true, qs_filter: "venue" },
      {
        field: "events",
        required: false,
        qs_filter: "event_id__in",
        limit: 5,
        use_distinct: false,
      },
      {
        field: "products",
        required: false,
        qs_filter: "product_id__in",
        limit: 20,
        use_distinct: false,
      },
      {
        field: "membership_groups",
        required: false,
        qs_filter: "membership_group_id__in",
        limit: 5,
        use_distinct: false,
      },
      { field: "from_dt", required: false, qs_filter: "created__gte" },
      { field: "to_dt", required: false, qs_filter: "created__lte" },
    ],
    format: "csv",
    available_formats: ["csv"],
    enabled_columns: [
      "rc_ticket_history_ticket_event_name",
      "rc_ticket_history_event_id",
      "rc_ticket_history_tt_description",
      "rc_ticket_history_ticket_id",
      "rc_ticket_history_product_description",
      "rc_ticket_history_product_id",
      "rc_ticket_history_product_attribute_name",
      "rc_ticket_history_product_attribute_id",
      "rc_email",
      "rc_phone",
      "rc_name_on_ticket",
      "rc_transaction_id",
      "rc_event_starts_on",
      "rc_ticket_scan_code",
      "rc_is_child",
      "rc_membership_group_name",
      "rc_membership_group_id",
      "rc_membership_level_name",
      "rc_membership_level_id",
      "rc_product_attribute_sku",
      "rc_created",
      "rc_shipping_fulfillment_status",
      "rc_fulfilled_by_employee",
      "rc_shipping_fulfillment_date",
      "rc_ticket_amount_to_ship",
      "rc_shipping_street_address",
      "rc_shipping_unit_number",
      "rc_shipping_city_address",
      "rc_shipping_province_address",
      "rc_shipping_country_address",
      "rc_shipping_postal_address",
    ],
    enabled_fields: [
      "venue",
      "events",
      "products",
      "membership_groups",
      "from_dt",
      "to_dt",
    ],
    required_fields: ["venue"],
  },
  report_ticket_history: {
    id: "report_ticket_history",
    name: t("Ticket Scan History Report"),
    fields: [
      { field: "venue", required: true, qs_filter: "venue" },
      {
        field: "events",
        required: false,
        qs_filter: "item__event_id__in",
        limit: 50,
        use_distinct: false,
      },
      {
        field: "products",
        required: false,
        qs_filter: "item__product_id__in",
        limit: 50,
        use_distinct: false,
      },
      {
        field: "ticket_types",
        required: false,
        qs_filter: "item__type_id__in",
        limit: 50,
      },
      { field: "from_dt", required: false, qs_filter: "created__gte" },
      { field: "to_dt", required: false, qs_filter: "created__lte" },
      { field: "is_select_all_events", required: false },
    ],
    format: "csv",
    available_formats: ["csv", "pdf"],
    enabled_columns: [
      "rc_ticket_history_ticket_code",
      "rc_ticket_history_item_type",
      "rc_ticket_history_ticket_name_on_ticket",
      "rc_ticket_history_ticket_event_name",
      "rc_ticket_history_event_id",
      "rc_ticket_history_tt_description",
      "rc_ticket_history_ticket_id",
      "rc_ticket_history_product_description",
      "rc_ticket_history_product_id",
      "rc_ticket_history_product_attribute_name",
      "rc_ticket_history_product_attribute_id",
      "rc_ticket_history_created",
      "rc_ticket_history_user_action",
      "rc_ticket_history_before_status",
      "rc_ticket_history_after_status",
      "rc_ticket_history_created_by",
    ],
    enabled_fields: [
      "venue",
      "events",
      "products",
      "ticket_types",
      "from_dt",
      "to_dt",
      "is_select_all_events",
    ],
    required_fields: ["venue"],
  },
  report_employee_scan_history: {
    id: "report_employee_scan_history",
    name: t("Employee Scan History Report"),
    fields: [
      { field: "venue", required: true, qs_filter: "venue" },
      {
        field: "events",
        required: false,
        qs_filter: "item__event_id__in",
        limit: 50,
        use_distinct: false,
      },
      {
        field: "ticket_types",
        required: false,
        qs_filter: "item__type_id__in",
        limit: 50,
      },
      { field: "from_dt", required: false, qs_filter: "created__gte" },
      { field: "to_dt", required: false, qs_filter: "created__lte" },
      { field: "is_select_all_events", required: false },
      { field: "employees", required: false, limit: 60 },
    ],
    format: "pdf",
    available_formats: ["pdf"],
    enabled_columns: [],
    enabled_fields: [
      "venue",
      "events",
      "ticket_types",
      "from_dt",
      "to_dt",
      "is_select_all_events",
      "employees",
    ],
    required_fields: ["venue"],
  },
  report_venue_user_cash_out: {
    id: "report_venue_user_cash_out",
    name: t("Seller Cash Out Report"),
    fields: [
      { field: "venue", required: true, qs_filter: "venue" },
      {
        field: "employees",
        required: true,
        qs_filter: "venue_user__employment__employee_id__in",
        limit: 1,
      },
      { field: "from_dt", required: false, qs_filter: "from_dt" },
      { field: "to_dt", required: false, qs_filter: "to_dt" },
    ],
    format: "pdf",
    available_formats: ["pdf"],
    enabled_columns: [],
    enabled_fields: ["venue", "employees", "from_dt", "to_dt"],
    required_fields: ["venue", "employees"],
  },
  report_discount_creation: {
    id: "report_discount_creation",
    name: t("Discount Creation Report"),
    fields: [
      { field: "from_dt", required: false, qs_filter: "created__gte" },
      { field: "to_dt", required: false, qs_filter: "created__lte" },
      { field: "venue", required: true, qs_filter: "venue" },
    ],
    format: "csv",
    available_formats: ["csv"],
    enabled_columns: [
      "rc_discount_allowed_checkouts",
      "rc_discount_amount",
      "rc_discount_limit",
      "rc_discount_maximum_quantity",
      "rc_discount_minimum_quantity",
      "rc_discount_rule_percentages",
      "rc_discount_rule_amounts",
      "rc_discount_percentage",
      "rc_discount_permission_type",
      "rc_discount_per_user_limit",
      "rc_discount_type",
      "rc_discount_created_by",
      "rc_discount_created_on",
      "rc_discount_description",
      "rc_discount_code",
    ],
    enabled_fields: ["from_dt", "to_dt", "venue"],
    required_fields: ["venue"],
  },
  report_discount_usage_stats: {
    id: "report_discount_usage_stats",
    name: t("Discount Usage Stats"),
    fields: [
      { field: "venue", required: true, qs_filter: "venue" },
      { field: "from_dt", required: false, qs_filter: "start_date" },
      { field: "to_dt", required: false, qs_filter: "end_date" },
    ],
    format: "csv",
    available_formats: ["csv"],
    enabled_columns: [
      "rc_discount_description",
      "rc_discount_purchase_platform",
      "rc_discounts_used",
      "rc_discount_ticket_quantity",
      "rc_discount_code",
      "rc_display_gross_sales",
      "rc_refunds",
      "rc_discounts",
      "rc_gross_sales",
      "rc_amount_company_earned",
      "rc_pre_tax_company_charges",
      "rc_company_charges_tax",
      "rc_company_charges",
      "rc_pre_tax_processing_fees",
      "rc_processing_fees_tax",
      "rc_cc_charges",
      "rc_pre_tax_discovery_charges",
      "rc_discovery_charges_tax",
      "rc_discovery_charges",
      "rc_pre_tax_resale_charges",
      "rc_resale_charges_tax",
      "rc_resale_charges",
      "rc_account_credit_applied",
      "rc_account_credit_refunds",
      "rc_exchanged_out",
      "rc_display_gross_revenue",
      "rc_display_organizer_charges",
      "rc_organizer_item_tax",
      "rc_organizer_fee_tax",
      "rc_tax",
      "rc_display_net_revenue",
      "rc_adjustment",
      "rc_amount_paid",
    ],
    enabled_fields: ["venue", "from_dt", "to_dt"],
    required_fields: ["venue"],
  },
  report_holds_stats: {
    id: "report_holds_stats",
    name: t("Holds Stats"),
    fields: [
      { field: "venue", required: true, qs_filter: "venue" },
      {
        field: "events",
        required: false,
        qs_filter: "event_id__in",
        limit: 50,
        use_distinct: false,
      },
      {
        field: "ticket_types",
        required: false,
        qs_filter: "type_id__in",
        limit: 50,
      },
      {
        field: "products",
        required: false,
        qs_filter: "product_id__in",
        limit: 50,
        use_distinct: false,
      },
      {
        field: "membership_groups",
        required: false,
        qs_filter: "membership_group_id__in",
        limit: 50,
      },
      {
        field: "membership_levels",
        required: false,
        qs_filter: "membership_level_id__in",
        limit: 50,
      },
      { field: "is_select_all_events", required: false },
      { field: "from_dt", required: false, qs_filter: "created__gte" },
      { field: "to_dt", required: false, qs_filter: "created__lte" },
    ],
    format: "csv",
    available_formats: ["csv"],
    enabled_columns: [
      "rc_ticket_history_item_type",
      "rc_ticket_history_ticket_event_name",
      "rc_ticket_history_event_id",
      "rc_ticket_history_product_description",
      "rc_ticket_history_product_id",
      "rc_ticket_history_product_attribute_name",
      "rc_ticket_history_product_attribute_id",
      "rc_username",
      "rc_email",
      "rc_phone",
      "rc_quantity",
      "rc_event_starts_on",
      "rc_event_ends_on",
      "rc_ticket_type",
      "rc_ticket_type_id",
      "rc_seating_section",
      "rc_seating_row",
      "rc_seating_seat",
      "rc_basket_uuid",
      "rc_membership_group_name",
      "rc_membership_group_id",
      "rc_membership_level_name",
      "rc_membership_level_id",
      "rc_updated",
      "rc_sold_by",
      "rc_hold_link",
    ],
    enabled_fields: [
      "venue",
      "events",
      "ticket_types",
      "products",
      "membership_groups",
      "membership_levels",
      "is_select_all_events",
      "from_dt",
      "to_dt",
    ],
    required_fields: ["venue"],
  },
  report_event_product_inventory: {
    id: "report_event_product_inventory",
    name: t("Event/Product Inventory Report"),
    fields: [
      { field: "venue", required: true, qs_filter: "venue" },
      {
        field: "events",
        required: true,
        qs_filter: "event_id__in",
        limit: 500,
        use_distinct: true,
      },
      {
        field: "products",
        required: false,
        qs_filter: "product_id__in",
        limit: 500,
        use_distinct: true,
      },
    ],
    format: "csv",
    available_formats: ["csv"],
    enabled_columns: [
      "picked_up",
      "rc_email",
      "rc_name_on_ticket",
      "rc_final_amount",
      "rc_tax",
      "rc_quantity",
      "rc_organizer_charges",
      "rc_card_organizer_charges",
      "rc_event",
      "rc_event_starts_on",
      "rc_ticket_type",
      "rc_product_attribute",
      "rc_product",
      "rc_billing_address",
      "rc_company_charges",
    ],
    enabled_fields: ["venue", "events", "products"],
    required_fields: ["venue", "events"],
  },
  member_report: {
    id: "member_report",
    name: t("Member Report"),
    fields: [
      { field: "venue", required: true, qs_filter: "venue" },
      {
        field: "membership_groups",
        required: false,
        qs_filter: "membership_group__in",
        limit: 60,
      },
      {
        field: "membership_levels",
        required: false,
        qs_filter: "membership_level__in",
        limit: 60,
      },
      { field: "from_dt", required: false, qs_filter: "created__gte" },
      { field: "to_dt", required: false, qs_filter: "created__lte" },
    ],
    format: "csv",
    available_formats: ["csv"],
    enabled_columns: [
      "rc_member_first_name",
      "rc_member_last_name",
      "rc_member_name",
      "rc_member_email",
      "rc_member_phone",
      "rc_member_status",
      "rc_member_quantity",
      "rc_member_expiry_date",
      "rc_member_barcode",
      "rc_member_universal_code",
      "rc_member_scans_used",
      "rc_member_discounts_used",
      "rc_member_last_status_change",
      "rc_member_last_status_changed_by",
      "rc_membership_group_name",
      "rc_membership_level_name",
      "rc_member_latest_season",
      "rc_custom_question_info",
      "rc_info_student_number",
      "rc_info_company",
      "rc_info_job_title",
      "rc_info_home_address_unit_number",
      "rc_info_home_address_street_name",
      "rc_info_home_address_city",
      "rc_info_home_address_province",
      "rc_info_home_address_postal",
      "rc_info_home_address_country",
      "rc_info_birthday",
      "rc_info_license_plate",
    ],
    enabled_fields: [
      "venue",
      "membership_groups",
      "membership_levels",
      "from_dt",
      "to_dt",
    ],
    required_fields: ["venue"],
  },
  member_history_report: {
    id: "member_history_report",
    name: t("Member History Report"),
    fields: [
      { field: "venue", required: true, qs_filter: "venue" },
      {
        field: "membership_groups",
        required: false,
        qs_filter: "member__membership_group__in",
        limit: 60,
      },
      {
        field: "membership_levels",
        required: false,
        qs_filter: "member__membership_level__in",
        limit: 60,
      },
      { field: "from_dt", required: false, qs_filter: "created__gte" },
      { field: "to_dt", required: false, qs_filter: "created__lte" },
    ],
    format: "csv",
    available_formats: ["csv"],
    enabled_columns: [
      "rc_member_name",
      "rc_member_email",
      "rc_member_phone",
      "rc_member_barcode",
      "rc_member_history_amount",
      "rc_membership_group_name",
      "rc_membership_level_name",
      "rc_member_status_before",
      "rc_member_status_after",
      "rc_member_history_action",
      "rc_member_history_type",
      "rc_membership_benefit",
      "rc_general_created",
    ],
    enabled_fields: [
      "venue",
      "membership_groups",
      "membership_levels",
      "from_dt",
      "to_dt",
    ],
    required_fields: ["venue"],
  },
  member_benefit_usage_report: {
    id: "member_benefit_usage_report",
    name: t("Member Benefit Usage Report"),
    fields: [
      { field: "venue", required: true, qs_filter: "venue" },
      {
        field: "membership_groups",
        required: false,
        qs_filter: "membership_group__in",
        limit: 60,
      },
      {
        field: "membership_levels",
        required: false,
        qs_filter: "membership_level__in",
        limit: 60,
      },
      { field: "from_dt", required: false, qs_filter: "created__gte" },
      { field: "to_dt", required: false, qs_filter: "created__lte" },
    ],
    format: "csv",
    available_formats: ["csv"],
    enabled_columns: [
      "rc_member_scans_allowed",
      "rc_member_scans_used",
      "rc_member_discounts_allowed",
      "rc_member_discounts_used",
      "rc_membership_group_name",
      "rc_membership_level_name",
      "rc_membership_benefit",
      "rc_membership_benefit_type",
    ],
    enabled_fields: [
      "venue",
      "membership_groups",
      "membership_levels",
      "from_dt",
      "to_dt",
    ],
    required_fields: ["venue"],
  },
  member_seating_report: {
    id: "member_seating_report",
    name: t("Member Seating Report"),
    fields: [
      { field: "venue", required: true, qs_filter: "venue" },
      {
        field: "membership_groups",
        required: false,
        qs_filter: "membership_group__in",
        limit: 60,
      },
      { field: "from_dt", required: false, qs_filter: "created__gte" },
      { field: "to_dt", required: false, qs_filter: "created__lte" },
    ],
    format: "csv",
    available_formats: ["csv"],
    enabled_columns: [
      "rc_quantity",
      "rc_seating_section",
      "rc_seating_row",
      "rc_seating_seat",
      "rc_member_name",
      "rc_member_email",
      "rc_member_phone",
      "rc_member_status",
      "rc_member_seating_reserved",
      "rc_membership_group_name",
      "rc_membership_level_name",
    ],
    enabled_fields: ["venue", "membership_groups", "from_dt", "to_dt"],
    required_fields: ["venue"],
  },
  waitlist_subscriber_report: {
    id: "waitlist_subscriber_report",
    name: t("Waitlist Subscribers Report"),
    fields: [
      { field: "venue", required: true, qs_filter: "waitlist__venue_id" },
      {
        field: "events",
        required: false,
        qs_filter: "ticket_type__event_id__in",
        limit: 50,
        use_distinct: false,
      },
      {
        field: "ticket_types",
        required: false,
        qs_filter: "ticket_type_id__in",
        limit: 50,
      },
    ],
    format: "csv",
    available_formats: ["csv"],
    enabled_columns: [
      "rc_email",
      "rc_quantity",
      "rc_event",
      "rc_event_starts_on",
      "rc_ticket_type",
      "rc_total_price",
      "rc_total_price_no_fees",
      "rc_info_first_name",
      "rc_info_last_name",
      "rc_status",
    ],
    enabled_fields: ["venue", "events", "ticket_types"],
    required_fields: ["venue"],
  },
  reseller_submissions_report: {
    id: "reseller_submissions_report",
    name: t("Reselling Submissions Report"),
    fields: [
      { field: "venue", required: true, qs_filter: "venue_id" },
      {
        field: "events",
        required: false,
        qs_filter: "event_id__in",
        limit: 50,
        use_distinct: false,
      },
    ],
    format: "csv",
    available_formats: ["csv"],
    enabled_columns: [
      "rc_email",
      "rc_quantity",
      "rc_event",
      "rc_event_starts_on",
      "rc_ticket_type",
      "rc_refund_amount",
      "rc_info_first_name",
      "rc_info_last_name",
      "rc_status",
    ],
    enabled_fields: ["venue", "events"],
    required_fields: ["venue"],
  },
  report_donor_transaction: {
    id: "report_donor_transaction",
    name: t("Donations History"),
    fields: [
      { field: "venue", required: true, qs_filter: "venue" },
      { field: "venue", required: false, qs_filter: "invoice_items__venue" },
      { field: "from_dt", required: false, qs_filter: "created__gte" },
      { field: "to_dt", required: false, qs_filter: "created__lte" },
    ],
    format: "csv",
    available_formats: ["csv"],
    enabled_columns: [
      "rc_username",
      "rc_email",
      "rc_phone",
      "rc_event",
      "rc_event_starts_on",
      "rc_created",
      "rc_postal_address",
      "rc_city_address",
      "rc_street_address",
      "rc_province_address",
      "rc_country_address",
      "rc_donation_total",
      "rc_registration_number",
      "rc_charity_name",
      "rc_charity_currency",
    ],
    enabled_fields: ["venue", "venue", "from_dt", "to_dt"],
    required_fields: ["venue"],
  },
  gift_card_recipients_report: {
    id: "gift_card_recipients_report",
    name: t("Gift Card Recipient Report"),
    fields: [
      { field: "venue", required: true, qs_filter: "gift_card__venue_id" },
      { field: "gift_cards", required: true, qs_filter: "gift_card_id__in" },
      {
        field: "gift_card_denominations",
        required: true,
        qs_filter: "gift_card_denomination_id__in",
      },
      { field: "from_dt", required: false, qs_filter: "created__gte" },
      { field: "to_dt", required: false, qs_filter: "created__lte" },
    ],
    format: "csv",
    available_formats: ["csv"],
    enabled_columns: [
      "rc_transaction_date",
      "rc_quantity",
      "rc_purchaser_username",
      "rc_purchaser_email",
      "rc_purchaser_phone",
      "rc_sender_username",
      "rc_gift_card_redeemed",
      "rc_recipient_name",
      "rc_recipient_email",
      "rc_recipient_phone",
      "rc_gift_card_id",
      "rc_gift_card_name",
      "rc_gift_card_denomination_id",
      "rc_gift_card_denomination_price",
      "rc_gift_card_amount_paid",
      "rc_total_gift_card_amount",
      "rc_amount_advanced",
      "rc_amount_used",
      "rc_amount_remaining",
    ],
    enabled_fields: [
      "venue",
      "gift_cards",
      "gift_card_denominations",
      "from_dt",
      "to_dt",
    ],
    required_fields: ["venue", "gift_cards", "gift_card_denominations"],
  },
  report_marketing_campaigns: {
    id: "report_marketing_campaigns",
    name: t("Marketing Campaign Summary"),
    fields: [
      { field: "venue", required: true, qs_filter: "venue" },
      {
        field: "events",
        required: false,
        qs_filter: "event_id__in",
        limit: 50,
        use_distinct: false,
      },
      {
        field: "utm_campaigns",
        required: false,
        qs_filter: "id__in",
        limit: 50,
        use_distinct: false,
      },
      { field: "from_dt", required: false },
      { field: "to_dt", required: false },
    ],
    format: "csv",
    available_formats: ["csv"],
    enabled_columns: [
      "rc_num_items_sold",
      "rc_final_amount",
      "rc_tax",
      "rc_refunds",
      "rc_discounts",
      "rc_gross_sales",
      "rc_amount_company_earned",
      "rc_display_gross_revenue",
      "rc_display_net_revenue",
      "rc_organizer_charges",
      "rc_utm_campaign",
      "rc_utm_source",
      "rc_utm_medium",
      "rc_views",
      "rc_add_to_cart",
      "rc_add_to_cart_rate",
      "rc_initiate_checkout",
      "rc_initiate_checkout_rate",
      "rc_purchases",
      "rc_purchase_rate",
    ],
    enabled_fields: ["venue", "events", "utm_campaigns", "from_dt", "to_dt"],
    required_fields: ["venue"],
  },
  report_marketing_campaign_details: {
    id: "report_marketing_campaign_details",
    name: t("Marketing Campaign Detail"),
    fields: [
      { field: "venue", required: true, qs_filter: "venue" },
      {
        field: "events",
        required: false,
        qs_filter: "event_id__in",
        limit: 60,
      },
      {
        field: "products",
        required: false,
        qs_filter: "product_id__in",
        limit: 50,
      },
      {
        field: "membership_groups",
        required: false,
        qs_filter: "membership_group_id__in",
        limit: 60,
      },
      {
        field: "utm_campaigns",
        required: true,
        qs_filter: "utm_campaign_id__in",
        limit: 50,
        use_distinct: false,
      },
      { field: "from_dt", required: false, qs_filter: "created__gte" },
      { field: "to_dt", required: false, qs_filter: "created__lte" },
    ],
    format: "csv",
    available_formats: ["csv", "pdf"],
    enabled_columns: [
      "rc_ticket_history_ticket_event_name",
      "rc_ticket_history_event_id",
      "rc_ticket_history_product_id",
      "rc_ticket_history_product_attribute_id",
      "rc_discount_amount",
      "rc_rule_discount_percentage",
      "rc_discount_rule_amount",
      "rc_discount_percentage",
      "rc_discount_type",
      "rc_username",
      "rc_email",
      "rc_phone",
      "rc_is_subscribed",
      "rc_invoice_item_description",
      "rc_charge_id",
      "rc_invoice_type_name",
      "rc_invoice_category_name",
      "rc_transaction_id",
      "rc_transaction_date",
      "rc_sale_transaction_id",
      "rc_settlement_date",
      "rc_advance_date",
      "rc_ticket_type_price",
      "rc_credit_type",
      "rc_purchase_source_platform",
      "rc_purchase_note",
      "rc_other_payment_type",
      "rc_transaction_quantity",
      "rc_item_quantity",
      "rc_transfer_quantity",
      "rc_scanned_quantity",
      "rc_scan_limit",
      "rc_refund_type",
      "rc_refund_reason",
      "rc_commissions",
      "rc_payment_type",
      "rc_card_type",
      "rc_event_starts_on",
      "rc_event_ends_on",
      "rc_ticket_type",
      "rc_ticket_type_id",
      "rc_event_location_name",
      "rc_event_location_postal_address",
      "rc_event_location_city_address",
      "rc_event_location_street_name",
      "rc_event_location_province_address",
      "rc_event_location_country_address",
      "rc_password_used",
      "rc_is_sub_ticket",
      "rc_member_name",
      "rc_member_email",
      "rc_membership_group_name",
      "rc_membership_group_id",
      "rc_membership_level_name",
      "rc_membership_level_id",
      "rc_membership_level_price",
      "rc_product_attribute",
      "rc_product_attribute_price",
      "rc_product",
      "rc_venue_name",
      "rc_venue_id",
      "rc_sold_by",
      "rc_referred_by",
      "rc_referred_link_description",
      "rc_referred_link_URL",
      "rc_postal_address",
      "rc_city_address",
      "rc_street_address",
      "rc_province_address",
      "rc_country_address",
      "rc_discount_code",
      "rc_shipping_method",
      "rc_shipping_street_address",
      "rc_shipping_unit_number",
      "rc_shipping_city_address",
      "rc_shipping_province_address",
      "rc_shipping_country_address",
      "rc_shipping_postal_address",
      "rc_shipping_cost",
      "rc_utm_campaign",
      "rc_utm_source",
      "rc_utm_medium",
      "rc_display_gross_sales",
      "rc_refunds",
      "rc_discounts",
      "rc_gross_sales",
      "rc_amount_company_earned",
      "rc_pre_tax_company_charges",
      "rc_company_charges_tax",
      "rc_company_charges",
      "rc_pre_tax_processing_fees",
      "rc_processing_fees_tax",
      "rc_cc_charges",
      "rc_pre_tax_discovery_charges",
      "rc_discovery_charges_tax",
      "rc_discovery_charges",
      "rc_pre_tax_resale_charges",
      "rc_resale_charges_tax",
      "rc_resale_charges",
      "rc_account_credit_applied",
      "rc_account_credit_refunds",
      "rc_exchanged_out",
      "rc_display_gross_revenue",
      "rc_display_organizer_charges",
      "rc_organizer_item_tax",
      "rc_organizer_fee_tax",
      "rc_tax",
      "rc_display_net_revenue",
      "rc_adjustment",
      "rc_amount_paid",
    ],
    enabled_fields: [
      "venue",
      "events",
      "products",
      "membership_groups",
      "utm_campaigns",
      "from_dt",
      "to_dt",
    ],
    required_fields: ["venue", "utm_campaigns"],
  },
} as const;

export const REPORT_TYPE_MAP_BY_LIST = [
  {
    id: "report_invoice_transaction",
    name: t("Transactions"),
    fields: [
      { field: "venue", required: true, qs_filter: "venue" },
      {
        field: "events",
        required: false,
        qs_filter: "invoice_items__event_for_filtering__in",
        limit: 1,
      },
      {
        field: "products",
        required: false,
        qs_filter: "invoice_items__product_for_filtering__in",
        limit: 1,
      },
      { field: "from_dt", required: false, qs_filter: "created__gte" },
      { field: "to_dt", required: false, qs_filter: "created__lte" },
    ],
    format: "csv",
    available_formats: ["csv"],
    enabled_columns: [
      "rc_username",
      "rc_email",
      "rc_phone",
      "rc_name_on_ticket",
      "rc_invoice_type",
      "rc_transaction_id",
      "rc_final_amount",
      "rc_amount_earned",
      "rc_other_custom_type",
      "rc_organizer_charges",
      "rc_card_organizer_charges",
      "rc_cash_organizer_charges",
      "rc_other_organizer_charges",
      "rc_commissions",
      "rc_shipping_costs",
      "rc_items_total_amount",
      "rc_payment_type",
      "rc_card_type",
      "rc_created",
      "rc_sold_by",
      "rc_referred_by",
      "rc_referred_link_description",
      "rc_postal_address",
      "rc_city_address",
      "rc_street_address",
      "rc_province_address",
      "rc_country_address",
      "rc_discount_code",
      "rc_internal_info",
      "rc_refunds",
      "rc_discounts",
      "rc_amount_company_earned",
      "rc_pre_tax_company_charges",
      "rc_company_charges_tax",
      "rc_company_charges",
      "rc_pre_tax_processing_fees",
      "rc_processing_fees_tax",
      "rc_cc_charges",
      "rc_pre_tax_discovery_charges",
      "rc_discovery_charges_tax",
      "rc_discovery_charges",
      "rc_pre_tax_resale_charges",
      "rc_resale_charges_tax",
      "rc_resale_charges",
      "rc_display_organizer_charges",
      "rc_organizer_item_tax",
      "rc_organizer_fee_tax",
      "rc_tax",
    ],
    enabled_fields: ["venue", "events", "products", "from_dt", "to_dt"],
    required_fields: ["venue"],
  },
  {
    id: "report_venue_user",
    name: t("Customers and Employees"),
    fields: [
      { field: "venue", required: true, qs_filter: "venue" },
      {
        field: "events",
        required: true,
        qs_filter: "item_groups__event__in",
        limit: 50,
        use_distinct: true,
      },
      {
        field: "ticket_types",
        required: false,
        qs_filter: "item_groups__type__in",
        limit: 50,
        use_distinct: true,
      },
      { field: "is_select_all_events", required: false },
      { field: "from_dt", required: false },
      { field: "to_dt", required: false },
    ],
    format: "csv",
    available_formats: ["csv"],
    enabled_columns: [
      "rc_username",
      "rc_email",
      "rc_phone",
      "rc_birthday",
      "rc_gender",
      "rc_is_seller",
      "rc_is_employee",
      "rc_is_subscribed",
      "rc_allow_mail_contact",
      "rc_allow_phone_contact",
      "rc_num_customer_reservations",
      "rc_num_checked_in_as_customer",
      "rc_num_reservations_booked",
      "rc_num_checked_in_as_employee",
      "rc_num_tickets_purchased",
      "rc_num_tickets_sold",
      "rc_external_tickets_quantity",
      "rc_external_tickets_spend",
      "rc_external_donations",
      "rc_venueuser_shipping_name",
      "rc_revenue_tickets_purchased",
      "rc_revenue_tickets_sold",
      "rc_shipping_street_address",
      "rc_shipping_unit_number",
      "rc_shipping_city_address",
      "rc_shipping_province_address",
      "rc_shipping_country_address",
      "rc_shipping_postal_address",
    ],
    enabled_fields: [
      "venue",
      "events",
      "ticket_types",
      "is_select_all_events",
      "from_dt",
      "to_dt",
    ],
    required_fields: ["venue", "events"],
  },
  {
    id: "report_will_call",
    name: t("Will Call"),
    fields: [
      { field: "venue", required: true, qs_filter: "venue" },
      { field: "events", required: false, qs_filter: "event__in", limit: 60 },
      {
        field: "products",
        required: false,
        qs_filter: "product__in",
        limit: 50,
      },
      {
        field: "ticket_types",
        required: false,
        qs_filter: "type__in",
        limit: 60,
      },
      { field: "ticket_statuses", required: false, qs_filter: "status__in" },
      { field: "is_select_all_events", required: false },
      { field: "from_dt", required: false, qs_filter: "created__gte" },
      { field: "to_dt", required: false, qs_filter: "created__lte" },
    ],
    format: "csv",
    available_formats: ["csv"],
    enabled_columns: [
      "rc_email",
      "rc_phone",
      "rc_name_on_ticket",
      "rc_quantity",
      "rc_event",
      "rc_event_starts_on",
      "rc_event_ends_on",
      "rc_ticket_type",
      "rc_ticket_status",
      "rc_ticket_barcode",
      "rc_ticket_scan_code",
      "rc_seating_section",
      "rc_password_used",
      "rc_seating_row",
      "rc_seating_seat",
      "rc_ticket_description",
      "rc_last_status_change",
      "rc_last_status_changed_by",
      "rc_product_attribute",
      "rc_product",
      "rc_created",
      "rc_sold_by",
      "rc_sold_by_venue",
      "rc_custom_question_info",
      "rc_info_student_number",
      "rc_info_company",
      "rc_info_job_title",
      "rc_info_first_name",
      "rc_info_last_name",
      "rc_info_phone_number",
      "rc_info_email",
      "rc_info_home_address_unit_number",
      "rc_info_home_address_street_name",
      "rc_info_home_address_city",
      "rc_info_home_address_province",
      "rc_info_home_address_postal",
      "rc_info_home_address_country",
      "rc_info_birthday",
      "rc_info_license_plate",
    ],
    enabled_fields: [
      "venue",
      "events",
      "products",
      "ticket_types",
      "ticket_statuses",
      "is_select_all_events",
      "from_dt",
      "to_dt",
    ],
    required_fields: ["venue"],
  },
  {
    id: "report_will_call_financial",
    name: t("Itemized Sales Report"),
    fields: [
      { field: "venue", required: true, qs_filter: "venue" },
      { field: "is_select_from_sub_orgs", required: false },
      {
        field: "events",
        required: false,
        qs_filter: "event_id__in",
        limit: 60,
      },
      {
        field: "products",
        required: false,
        qs_filter: "product_id__in",
        limit: 50,
      },
      {
        field: "ticket_types",
        required: false,
        qs_filter: "ticket_type_id__in",
        limit: 60,
      },
      {
        field: "membership_groups",
        required: false,
        qs_filter: "membership_group_id__in",
        limit: 60,
      },
      {
        field: "membership_levels",
        required: false,
        qs_filter: "membership_level_id__in",
        limit: 60,
      },
      { field: "is_select_all_events", required: false },
      { field: "from_dt", required: false, qs_filter: "created__gte" },
      { field: "to_dt", required: false, qs_filter: "created__lte" },
      {
        field: "employees",
        required: false,
        qs_filter: "invoice__sold_by__in",
        limit: 60,
      },
      {
        field: "purchase_source_platforms",
        required: false,
        qs_filter: "purchase_source_platform__in",
      },
    ],
    format: "csv",
    available_formats: ["csv", "pdf"],
    enabled_columns: [
      "rc_ticket_history_ticket_event_name",
      "rc_ticket_history_event_id",
      "rc_ticket_history_product_id",
      "rc_ticket_history_product_attribute_id",
      "rc_discount_amount",
      "rc_rule_discount_percentage",
      "rc_discount_rule_amount",
      "rc_discount_percentage",
      "rc_discount_type",
      "rc_username",
      "rc_email",
      "rc_phone",
      "rc_is_subscribed",
      "rc_invoice_item_description",
      "rc_charge_id",
      "rc_invoice_type_name",
      "rc_invoice_category_name",
      "rc_transaction_id",
      "rc_transaction_date",
      "rc_sale_transaction_id",
      "rc_settlement_date",
      "rc_advance_date",
      "rc_ticket_type_price",
      "rc_credit_type",
      "rc_purchase_source_platform",
      "rc_purchase_note",
      "rc_other_payment_type",
      "rc_transaction_quantity",
      "rc_item_quantity",
      "rc_transfer_quantity",
      "rc_scanned_quantity",
      "rc_scan_limit",
      "rc_refund_type",
      "rc_refund_reason",
      "rc_commissions",
      "rc_payment_type",
      "rc_card_type",
      "rc_event_starts_on",
      "rc_event_ends_on",
      "rc_ticket_type",
      "rc_ticket_type_id",
      "rc_event_location_name",
      "rc_event_location_postal_address",
      "rc_event_location_city_address",
      "rc_event_location_street_name",
      "rc_event_location_province_address",
      "rc_event_location_country_address",
      "rc_password_used",
      "rc_is_sub_ticket",
      "rc_member_name",
      "rc_member_email",
      "rc_membership_group_name",
      "rc_membership_group_id",
      "rc_membership_level_name",
      "rc_membership_level_id",
      "rc_membership_level_price",
      "rc_product_attribute",
      "rc_product_attribute_price",
      "rc_product",
      "rc_price_tier_name",
      "rc_price_tier_id",
      "rc_price_tier_price",
      "rc_venue_name",
      "rc_venue_id",
      "rc_sold_by",
      "rc_referred_by",
      "rc_referred_link_description",
      "rc_referred_link_URL",
      "rc_postal_address",
      "rc_city_address",
      "rc_street_address",
      "rc_province_address",
      "rc_country_address",
      "rc_discount_code",
      "rc_shipping_method",
      "rc_shipping_street_address",
      "rc_shipping_unit_number",
      "rc_shipping_city_address",
      "rc_shipping_province_address",
      "rc_shipping_country_address",
      "rc_shipping_postal_address",
      "rc_shipping_cost",
      "rc_ticket_pay_what_you_can_enabled",
      "rc_ticket_pay_what_you_can_difference",
      "rc_display_gross_sales",
      "rc_refunds",
      "rc_discounts",
      "rc_gross_sales",
      "rc_amount_company_earned",
      "rc_pre_tax_company_charges",
      "rc_company_charges_tax",
      "rc_company_charges",
      "rc_pre_tax_processing_fees",
      "rc_processing_fees_tax",
      "rc_cc_charges",
      "rc_pre_tax_discovery_charges",
      "rc_discovery_charges_tax",
      "rc_discovery_charges",
      "rc_pre_tax_resale_charges",
      "rc_resale_charges_tax",
      "rc_resale_charges",
      "rc_account_credit_applied",
      "rc_account_credit_refunds",
      "rc_exchanged_out",
      "rc_display_gross_revenue",
      "rc_display_organizer_charges",
      "rc_organizer_item_tax",
      "rc_organizer_fee_tax",
      "rc_tax",
      "rc_display_net_revenue",
      "rc_adjustment",
      "rc_amount_paid",
    ],
    enabled_fields: [
      "venue",
      "is_select_from_sub_orgs",
      "events",
      "products",
      "ticket_types",
      "membership_groups",
      "membership_levels",
      "is_select_all_events",
      "from_dt",
      "to_dt",
      "employees",
      "purchase_source_platforms",
    ],
    required_fields: ["venue"],
  },
  {
    id: "settlement_report",
    name: t("Settlement Report"),
    fields: [
      { field: "venue", required: true, qs_filter: "venue" },
      {
        field: "payout_invoices",
        required: false,
        qs_filter: "payout_invoice_item__invoice__in",
        limit: 60,
      },
      { field: "from_dt", required: false, qs_filter: "created__gte" },
      { field: "to_dt", required: false, qs_filter: "created__lte" },
    ],
    available_formats: ["csv", "pdf"],
    enabled_columns: [
      "rc_ticket_history_ticket_event_name",
      "rc_ticket_history_event_id",
      "rc_ticket_history_product_id",
      "rc_ticket_history_product_attribute_id",
      "rc_discount_amount",
      "rc_rule_discount_percentage",
      "rc_discount_rule_amount",
      "rc_discount_percentage",
      "rc_discount_type",
      "rc_username",
      "rc_email",
      "rc_phone",
      "rc_is_subscribed",
      "rc_invoice_item_description",
      "rc_charge_id",
      "rc_invoice_type_name",
      "rc_invoice_category_name",
      "rc_transaction_id",
      "rc_transaction_date",
      "rc_sale_transaction_id",
      "rc_settlement_date",
      "rc_advance_date",
      "rc_ticket_type_price",
      "rc_credit_type",
      "rc_purchase_source_platform",
      "rc_purchase_note",
      "rc_other_payment_type",
      "rc_transaction_quantity",
      "rc_item_quantity",
      "rc_transfer_quantity",
      "rc_scanned_quantity",
      "rc_scan_limit",
      "rc_refund_type",
      "rc_refund_reason",
      "rc_commissions",
      "rc_payment_type",
      "rc_card_type",
      "rc_event_starts_on",
      "rc_event_ends_on",
      "rc_ticket_type",
      "rc_ticket_type_id",
      "rc_event_location_name",
      "rc_event_location_postal_address",
      "rc_event_location_city_address",
      "rc_event_location_street_name",
      "rc_event_location_province_address",
      "rc_event_location_country_address",
      "rc_password_used",
      "rc_is_sub_ticket",
      "rc_member_name",
      "rc_member_email",
      "rc_membership_group_name",
      "rc_membership_group_id",
      "rc_membership_level_name",
      "rc_membership_level_id",
      "rc_membership_level_price",
      "rc_product_attribute",
      "rc_product_attribute_price",
      "rc_product",
      "rc_price_tier_name",
      "rc_price_tier_id",
      "rc_price_tier_price",
      "rc_venue_name",
      "rc_venue_id",
      "rc_sold_by",
      "rc_referred_by",
      "rc_referred_link_description",
      "rc_referred_link_URL",
      "rc_postal_address",
      "rc_city_address",
      "rc_street_address",
      "rc_province_address",
      "rc_country_address",
      "rc_discount_code",
      "rc_shipping_method",
      "rc_shipping_street_address",
      "rc_shipping_unit_number",
      "rc_shipping_city_address",
      "rc_shipping_province_address",
      "rc_shipping_country_address",
      "rc_shipping_postal_address",
      "rc_shipping_cost",
      "rc_display_gross_sales",
      "rc_refunds",
      "rc_discounts",
      "rc_gross_sales",
      "rc_amount_company_earned",
      "rc_pre_tax_company_charges",
      "rc_company_charges_tax",
      "rc_company_charges",
      "rc_pre_tax_processing_fees",
      "rc_processing_fees_tax",
      "rc_cc_charges",
      "rc_pre_tax_discovery_charges",
      "rc_discovery_charges_tax",
      "rc_discovery_charges",
      "rc_pre_tax_resale_charges",
      "rc_resale_charges_tax",
      "rc_resale_charges",
      "rc_account_credit_applied",
      "rc_account_credit_refunds",
      "rc_exchanged_out",
      "rc_display_gross_revenue",
      "rc_display_organizer_charges",
      "rc_organizer_item_tax",
      "rc_organizer_fee_tax",
      "rc_tax",
      "rc_display_net_revenue",
      "rc_adjustment",
      "rc_amount_paid",
    ],
    enabled_fields: ["venue", "payout_invoices", "from_dt", "to_dt"],
    required_fields: ["venue"],
  },
  {
    id: "advance_report",
    name: t("Advance Report"),
    fields: [
      { field: "venue", required: true, qs_filter: "venue" },
      {
        field: "advance_invoices",
        required: false,
        qs_filter: "advance_invoice_item__invoice__in",
        limit: 60,
      },
      { field: "from_dt", required: false, qs_filter: "created__gte" },
      { field: "to_dt", required: false, qs_filter: "created__lte" },
    ],
    available_formats: ["csv", "pdf"],
    enabled_columns: [
      "rc_ticket_history_ticket_event_name",
      "rc_ticket_history_event_id",
      "rc_ticket_history_product_id",
      "rc_ticket_history_product_attribute_id",
      "rc_discount_amount",
      "rc_rule_discount_percentage",
      "rc_discount_rule_amount",
      "rc_discount_percentage",
      "rc_discount_type",
      "rc_username",
      "rc_email",
      "rc_phone",
      "rc_is_subscribed",
      "rc_invoice_item_description",
      "rc_charge_id",
      "rc_invoice_type_name",
      "rc_invoice_category_name",
      "rc_transaction_id",
      "rc_transaction_date",
      "rc_sale_transaction_id",
      "rc_settlement_date",
      "rc_advance_date",
      "rc_ticket_type_price",
      "rc_credit_type",
      "rc_purchase_source_platform",
      "rc_purchase_note",
      "rc_other_payment_type",
      "rc_transaction_quantity",
      "rc_item_quantity",
      "rc_transfer_quantity",
      "rc_scanned_quantity",
      "rc_scan_limit",
      "rc_refund_type",
      "rc_refund_reason",
      "rc_commissions",
      "rc_payment_type",
      "rc_card_type",
      "rc_event_starts_on",
      "rc_event_ends_on",
      "rc_ticket_type",
      "rc_ticket_type_id",
      "rc_event_location_name",
      "rc_event_location_postal_address",
      "rc_event_location_city_address",
      "rc_event_location_street_name",
      "rc_event_location_province_address",
      "rc_event_location_country_address",
      "rc_password_used",
      "rc_is_sub_ticket",
      "rc_member_name",
      "rc_member_email",
      "rc_membership_group_name",
      "rc_membership_group_id",
      "rc_membership_level_name",
      "rc_membership_level_id",
      "rc_membership_level_price",
      "rc_product_attribute",
      "rc_product_attribute_price",
      "rc_product",
      "rc_price_tier_name",
      "rc_price_tier_id",
      "rc_price_tier_price",
      "rc_venue_name",
      "rc_venue_id",
      "rc_sold_by",
      "rc_referred_by",
      "rc_referred_link_description",
      "rc_referred_link_URL",
      "rc_postal_address",
      "rc_city_address",
      "rc_street_address",
      "rc_province_address",
      "rc_country_address",
      "rc_discount_code",
      "rc_shipping_method",
      "rc_shipping_street_address",
      "rc_shipping_unit_number",
      "rc_shipping_city_address",
      "rc_shipping_province_address",
      "rc_shipping_country_address",
      "rc_shipping_postal_address",
      "rc_shipping_cost",
      "rc_display_gross_sales",
      "rc_refunds",
      "rc_discounts",
      "rc_gross_sales",
      "rc_amount_company_earned",
      "rc_pre_tax_company_charges",
      "rc_company_charges_tax",
      "rc_company_charges",
      "rc_pre_tax_processing_fees",
      "rc_processing_fees_tax",
      "rc_cc_charges",
      "rc_pre_tax_discovery_charges",
      "rc_discovery_charges_tax",
      "rc_discovery_charges",
      "rc_pre_tax_resale_charges",
      "rc_resale_charges_tax",
      "rc_resale_charges",
      "rc_account_credit_applied",
      "rc_account_credit_refunds",
      "rc_exchanged_out",
      "rc_display_gross_revenue",
      "rc_display_organizer_charges",
      "rc_organizer_item_tax",
      "rc_organizer_fee_tax",
      "rc_tax",
      "rc_display_net_revenue",
      "rc_adjustment",
      "rc_amount_paid",
    ],
    enabled_fields: ["venue", "advance_invoices", "from_dt", "to_dt"],
    required_fields: ["venue"],
  },
  {
    id: "report_ticket_sales_history",
    name: t("Ticket Sales History"),
    fields: [
      { field: "venue", required: true, qs_filter: "venue" },
      { field: "events", required: false, qs_filter: "event__in", limit: 60 },
      {
        field: "ticket_types",
        required: false,
        qs_filter: "ticket_type__in",
        limit: 60,
      },
      { field: "is_select_all_events", required: false },
      { field: "from_dt", required: false, qs_filter: "created__gte" },
      { field: "to_dt", required: false, qs_filter: "created__lte" },
      { field: "purchase_source_platforms", required: false },
    ],
    format: "pdf",
    available_formats: ["pdf"],
    enabled_columns: [],
    enabled_fields: [
      "venue",
      "events",
      "ticket_types",
      "is_select_all_events",
      "from_dt",
      "to_dt",
      "purchase_source_platforms",
    ],
    required_fields: ["venue"],
  },
  {
    id: "report_employee_sales_history",
    name: t("Employee Sales History"),
    fields: [
      { field: "venue", required: true, qs_filter: "venue" },
      { field: "events", required: false, qs_filter: "event__in", limit: 60 },
      {
        field: "ticket_types",
        required: false,
        qs_filter: "ticket_type__in",
        limit: 60,
      },
      { field: "is_select_all_events", required: false },
      { field: "from_dt", required: false, qs_filter: "created__gte" },
      { field: "to_dt", required: false, qs_filter: "created__lte" },
      { field: "employees", required: false, limit: 60 },
      { field: "purchase_source_platforms", required: false },
    ],
    format: "pdf",
    available_formats: ["pdf"],
    enabled_columns: [],
    enabled_fields: [
      "venue",
      "events",
      "ticket_types",
      "is_select_all_events",
      "from_dt",
      "to_dt",
      "employees",
      "purchase_source_platforms",
    ],
    required_fields: ["venue"],
  },
  {
    id: "report_event_breakdown",
    name: t("Event Summary"),
    fields: [
      { field: "venue", required: true, qs_filter: "venue" },
      { field: "events", required: true, qs_filter: "id__in", limit: 60 },
      { field: "is_select_all_events", required: false },
      { field: "from_dt", required: false },
      { field: "to_dt", required: false },
    ],
    format: "csv",
    available_formats: ["csv", "pdf"],
    enabled_columns: [
      "rc_sub_tickets_generated_from_package",
      "rc_cash_organizer_charges",
      "rc_other_organizer_charges",
      "rc_commissions",
      "rc_shipping_costs",
      "rc_cash_revenue",
      "rc_credit_revenue",
      "rc_event",
      "rc_event_starts_on",
      "rc_event_ends_on",
      "rc_event_location",
      "rc_num_tickets_sold_cash",
      "rc_num_tickets_sold_credit",
      "rc_num_tickets_sold_affirm",
      "rc_num_tickets_sold_comp",
      "rc_num_tickets_sold_free",
      "rc_num_of_standard_tickets_sold",
      "rc_num_of_tickets_sold_redeemable",
      "rc_num_of_redeemable_tickets",
      "rc_total_inventory",
      "rc_num_of_total_packages",
      "rc_total_ticket_package_inventory",
      "rc_num_of_sub_tickets_from_event",
      "rc_num_of_sub_tickets_from_outside_event",
      "rc_num_of_tickets_not_included_in_stats",
      "rc_num_of_hold_tickets",
      "rc_num_of_payment_plans_copy",
      "rc_affirm_revenue",
      "rc_display_gross_sales",
      "rc_discounts",
      "rc_refunds",
      "rc_disputes",
      "rc_gross_sales",
      "rc_amount_company_earned_sub_custom_fees",
      "rc_company_charges_sub_custom_fees",
      "rc_cc_charges",
      "rc_discovery_charges",
      "rc_resale_charges",
      "rc_invoice_fee_total",
      "rc_account_credit_applied",
      "rc_exchange_credit_applied",
      "rc_venue_credit_applied",
      "rc_user_credit_applied",
      "rc_referral_credit_applied",
      "rc_exchanged_out",
      "rc_account_credit_refunds",
      "rc_display_gross_revenue",
      "rc_display_organizer_charges",
      "rc_tax",
      "rc_shipping_costs",
      "rc_credit_memo_total",
      "rc_display_net_revenue",
      "rc_card_organizer_charges",
      "rc_card_tax",
      "rc_card_shipping_costs",
      "rc_other_settlement_difference",
      "rc_cash_settlement_difference",
      "rc_custom_processor_adjustment",
      "rc_square_oauth_adjustment",
      "rc_advances",
      "rc_settlements",
      "rc_non_venue_credit_applied",
      "rc_amount_paid",
      "rc_display_gross_sales",
      "rc_refunds",
      "rc_discounts",
      "rc_gross_sales",
      "rc_amount_company_earned",
      "rc_pre_tax_company_charges",
      "rc_company_charges_tax",
      "rc_company_charges",
      "rc_pre_tax_processing_fees",
      "rc_processing_fees_tax",
      "rc_cc_charges",
      "rc_pre_tax_discovery_charges",
      "rc_discovery_charges_tax",
      "rc_discovery_charges",
      "rc_pre_tax_resale_charges",
      "rc_resale_charges_tax",
      "rc_resale_charges",
      "rc_account_credit_applied",
      "rc_account_credit_refunds",
      "rc_exchanged_out",
      "rc_display_gross_revenue",
      "rc_display_organizer_charges",
      "rc_organizer_item_tax",
      "rc_organizer_fee_tax",
      "rc_tax",
      "rc_display_net_revenue",
      "rc_adjustment",
      "rc_amount_paid",
    ],
    enabled_fields: [
      "venue",
      "events",
      "is_select_all_events",
      "from_dt",
      "to_dt",
    ],
    required_fields: ["venue", "events"],
  },
  {
    id: "report_event_audit",
    name: t("Event Audit"),
    fields: [
      { field: "venue", required: true, qs_filter: "venue" },
      { field: "events", required: true, qs_filter: "id__in", limit: 1 },
    ],
    format: "xlsx",
    available_formats: ["xlsx"],
    enabled_columns: [],
    enabled_fields: ["venue", "events"],
    required_fields: ["venue", "events"],
  },
  {
    id: "payment_type_breakdown",
    name: t("Payment Type Breakdown"),
    fields: [
      { field: "venue", required: true, qs_filter: "venue" },
      { field: "events", required: false, limit: 1500 },
      { field: "products", required: false, limit: 1500 },
      { field: "membership_groups", required: false, limit: 1500 },
      { field: "membership_levels", required: false, limit: 1500 },
      { field: "is_select_all_events", required: false },
      { field: "from_dt", required: false },
      { field: "to_dt", required: false },
    ],
    format: "pdf",
    available_formats: ["pdf"],
    enabled_columns: [],
    enabled_fields: [
      "venue",
      "events",
      "products",
      "membership_groups",
      "membership_levels",
      "is_select_all_events",
      "from_dt",
      "to_dt",
    ],
    required_fields: ["venue"],
  },
  {
    id: "financial_scan_summary",
    name: t("Financial Scan Summary"),
    fields: [
      { field: "venue", required: true, qs_filter: "venue" },
      { field: "events", required: true, limit: 1500 },
      { field: "from_dt", required: false },
      { field: "to_dt", required: false },
    ],
    format: "pdf",
    available_formats: ["pdf"],
    enabled_columns: [],
    enabled_fields: ["venue", "events", "from_dt", "to_dt"],
    required_fields: ["venue", "events"],
  },
  {
    id: "event_financial_summary",
    name: t("Event Financial Summary"),
    fields: [
      { field: "venue", required: true, qs_filter: "venue" },
      { field: "events", required: false, limit: 1500 },
      { field: "is_select_all_events", required: false },
      { field: "from_dt", required: false },
      { field: "to_dt", required: false },
    ],
    format: "pdf",
    available_formats: ["pdf"],
    enabled_columns: [],
    enabled_fields: [
      "venue",
      "events",
      "is_select_all_events",
      "from_dt",
      "to_dt",
    ],
    required_fields: ["venue"],
  },
  {
    id: "ticket_type_financial_summary",
    name: t("Ticket Type Financial Summary"),
    fields: [
      { field: "venue", required: true, qs_filter: "venue" },
      { field: "events", required: false, limit: 1500 },
      { field: "is_select_all_events", required: false },
      { field: "from_dt", required: false },
      { field: "to_dt", required: false },
    ],
    format: "pdf",
    available_formats: ["pdf"],
    enabled_columns: [],
    enabled_fields: [
      "venue",
      "events",
      "is_select_all_events",
      "from_dt",
      "to_dt",
    ],
    required_fields: ["venue"],
  },
  {
    id: "report_ticket_type_breakdown",
    name: t("Ticket Type Summary"),
    fields: [
      { field: "venue", required: true, qs_filter: "venue" },
      {
        field: "ticket_types",
        required: false,
        qs_filter: "id__in",
        limit: 50,
      },
      { field: "events", required: true, qs_filter: "event_id__in", limit: 50 },
    ],
    format: "csv",
    available_formats: ["csv"],
    enabled_columns: [
      "rc_sub_tickets_generated_from_package",
      "rc_ticket_type_price",
      "rc_cash_organizer_charges",
      "rc_other_organizer_charges",
      "rc_commissions",
      "rc_shipping_costs",
      "rc_cash_revenue",
      "rc_credit_revenue",
      "rc_event",
      "rc_event_starts_on",
      "rc_event_ends_on",
      "rc_ticket_type",
      "rc_event_location",
      "rc_num_tickets_sold_cash",
      "rc_num_tickets_sold_credit",
      "rc_num_tickets_sold_affirm",
      "rc_num_tickets_sold_comp",
      "rc_num_tickets_sold_free",
      "rc_num_tickets_refunded",
      "rc_num_of_redeemable_tickets",
      "rc_total_inventory",
      "rc_num_of_total_packages",
      "rc_num_of_tickets_not_included_in_stats",
      "rc_affirm_revenue",
      "rc_display_gross_sales",
      "rc_refunds",
      "rc_discounts",
      "rc_gross_sales",
      "rc_amount_company_earned",
      "rc_pre_tax_company_charges",
      "rc_company_charges_tax",
      "rc_company_charges",
      "rc_pre_tax_processing_fees",
      "rc_processing_fees_tax",
      "rc_cc_charges",
      "rc_pre_tax_discovery_charges",
      "rc_discovery_charges_tax",
      "rc_discovery_charges",
      "rc_pre_tax_resale_charges",
      "rc_resale_charges_tax",
      "rc_resale_charges",
      "rc_account_credit_applied",
      "rc_account_credit_refunds",
      "rc_exchanged_out",
      "rc_display_gross_revenue",
      "rc_display_organizer_charges",
      "rc_organizer_item_tax",
      "rc_organizer_fee_tax",
      "rc_tax",
      "rc_display_net_revenue",
      "rc_adjustment",
      "rc_amount_paid",
    ],
    enabled_fields: ["venue", "ticket_types", "events"],
    required_fields: ["venue", "events"],
  },
  {
    id: "product_breakdown_report",
    name: t("Product Summary"),
    fields: [
      { field: "venue", required: true, qs_filter: "venue" },
      { field: "products", required: true, qs_filter: "id__in", limit: 60 },
      { field: "from_dt", required: false },
      { field: "to_dt", required: false },
    ],
    format: "csv",
    available_formats: ["csv", "pdf"],
    enabled_columns: [
      "rc_cash_organizer_charges",
      "rc_other_organizer_charges",
      "rc_commissions",
      "rc_shipping_costs",
      "rc_cash_revenue",
      "rc_credit_revenue",
      "rc_num_tickets_sold_cash",
      "rc_num_tickets_sold_credit",
      "rc_num_tickets_sold_affirm",
      "rc_num_tickets_sold_comp",
      "rc_num_tickets_sold_free",
      "rc_product",
      "rc_num_of_standard_tickets_sold",
      "rc_num_of_redeemable_tickets",
      "rc_total_inventory",
      "rc_num_of_hold_tickets",
      "rc_affirm_revenue",
      "rc_display_gross_sales",
      "rc_discounts",
      "rc_refunds",
      "rc_disputes",
      "rc_gross_sales",
      "rc_amount_company_earned_sub_custom_fees",
      "rc_company_charges_sub_custom_fees",
      "rc_cc_charges",
      "rc_discovery_charges",
      "rc_resale_charges",
      "rc_invoice_fee_total",
      "rc_account_credit_applied",
      "rc_exchange_credit_applied",
      "rc_venue_credit_applied",
      "rc_user_credit_applied",
      "rc_referral_credit_applied",
      "rc_exchanged_out",
      "rc_account_credit_refunds",
      "rc_display_gross_revenue",
      "rc_display_organizer_charges",
      "rc_tax",
      "rc_shipping_costs",
      "rc_credit_memo_total",
      "rc_display_net_revenue",
      "rc_card_organizer_charges",
      "rc_card_tax",
      "rc_card_shipping_costs",
      "rc_other_settlement_difference",
      "rc_cash_settlement_difference",
      "rc_custom_processor_adjustment",
      "rc_square_oauth_adjustment",
      "rc_advances",
      "rc_settlements",
      "rc_non_venue_credit_applied",
      "rc_amount_paid",
      "rc_display_gross_sales",
      "rc_refunds",
      "rc_discounts",
      "rc_gross_sales",
      "rc_amount_company_earned",
      "rc_pre_tax_company_charges",
      "rc_company_charges_tax",
      "rc_company_charges",
      "rc_pre_tax_processing_fees",
      "rc_processing_fees_tax",
      "rc_cc_charges",
      "rc_pre_tax_discovery_charges",
      "rc_discovery_charges_tax",
      "rc_discovery_charges",
      "rc_pre_tax_resale_charges",
      "rc_resale_charges_tax",
      "rc_resale_charges",
      "rc_account_credit_applied",
      "rc_account_credit_refunds",
      "rc_exchanged_out",
      "rc_display_gross_revenue",
      "rc_display_organizer_charges",
      "rc_organizer_item_tax",
      "rc_organizer_fee_tax",
      "rc_tax",
      "rc_display_net_revenue",
      "rc_adjustment",
      "rc_amount_paid",
    ],
    enabled_fields: ["venue", "products", "from_dt", "to_dt"],
    required_fields: ["venue", "products"],
  },
  {
    id: "report_password_used_breakdown",
    name: t("Password Used Summary"),
    fields: [
      { field: "venue", required: true, qs_filter: "venue" },
      {
        field: "events",
        required: false,
        qs_filter: "events__id__in",
        limit: 50,
      },
    ],
    format: "csv",
    available_formats: ["csv"],
    enabled_columns: [
      "rc_num_tickets_sold",
      "rc_event",
      "rc_num_of_passwords_used",
      "rc_password",
      "rc_display_gross_sales",
      "rc_refunds",
      "rc_discounts",
      "rc_gross_sales",
      "rc_amount_company_earned",
      "rc_pre_tax_company_charges",
      "rc_company_charges_tax",
      "rc_company_charges",
      "rc_pre_tax_processing_fees",
      "rc_processing_fees_tax",
      "rc_cc_charges",
      "rc_pre_tax_discovery_charges",
      "rc_discovery_charges_tax",
      "rc_discovery_charges",
      "rc_pre_tax_resale_charges",
      "rc_resale_charges_tax",
      "rc_resale_charges",
      "rc_account_credit_applied",
      "rc_account_credit_refunds",
      "rc_exchanged_out",
      "rc_display_gross_revenue",
      "rc_display_organizer_charges",
      "rc_organizer_item_tax",
      "rc_organizer_fee_tax",
      "rc_tax",
      "rc_display_net_revenue",
      "rc_adjustment",
      "rc_amount_paid",
    ],
    enabled_fields: ["venue", "events"],
    required_fields: ["venue"],
  },
  {
    id: "report_seller_stats",
    name: t("Seller Stats"),
    fields: [
      { field: "venue", required: true, qs_filter: "venue" },
      {
        field: "events",
        required: false,
        qs_filter: "event_id__in",
        limit: 50,
        use_distinct: true,
      },
      {
        field: "products",
        required: false,
        qs_filter: "product_id__in",
        limit: 50,
        use_distinct: true,
      },
      {
        field: "membership_groups",
        required: false,
        qs_filter: "membership_group_id__in",
        limit: 50,
        use_distinct: true,
      },
      {
        field: "membership_levels",
        required: false,
        qs_filter: "membership_level_id__in",
        limit: 50,
        use_distinct: true,
      },
      { field: "is_select_all_events", required: false },
      { field: "from_dt", required: false, qs_filter: "created__gte" },
      { field: "to_dt", required: false, qs_filter: "created__lte" },
    ],
    format: "csv",
    available_formats: ["csv"],
    enabled_columns: [
      "rc_username",
      "rc_email",
      "rc_phone",
      "rc_num_tickets_sold",
      "rc_final_amount",
      "rc_amount_earned",
      "rc_organizer_charges",
      "rc_card_organizer_charges",
      "rc_cash_organizer_charges",
      "rc_other_organizer_charges",
      "rc_cash_commissions",
      "rc_credit_commissions",
      "rc_cash_revenue",
      "rc_credit_revenue",
      "rc_num_tickets_sold_cash",
      "rc_num_tickets_sold_credit",
      "rc_num_tickets_sold_affirm",
      "rc_num_tickets_sold_comp",
      "rc_num_tickets_sold_free",
      "rc_affirm_revenue",
    ],
    enabled_fields: [
      "venue",
      "events",
      "products",
      "membership_groups",
      "membership_levels",
      "is_select_all_events",
      "from_dt",
      "to_dt",
    ],
    required_fields: ["venue"],
  },
  {
    id: "report_shipping_fulfillment",
    name: t("Shipping Fulfillment Stats"),
    fields: [
      { field: "venue", required: true, qs_filter: "venue" },
      {
        field: "events",
        required: false,
        qs_filter: "event_id__in",
        limit: 5,
        use_distinct: false,
      },
      {
        field: "products",
        required: false,
        qs_filter: "product_id__in",
        limit: 20,
        use_distinct: false,
      },
      {
        field: "membership_groups",
        required: false,
        qs_filter: "membership_group_id__in",
        limit: 5,
        use_distinct: false,
      },
      { field: "from_dt", required: false, qs_filter: "created__gte" },
      { field: "to_dt", required: false, qs_filter: "created__lte" },
    ],
    format: "csv",
    available_formats: ["csv"],
    enabled_columns: [
      "rc_ticket_history_ticket_event_name",
      "rc_ticket_history_event_id",
      "rc_ticket_history_tt_description",
      "rc_ticket_history_ticket_id",
      "rc_ticket_history_product_description",
      "rc_ticket_history_product_id",
      "rc_ticket_history_product_attribute_name",
      "rc_ticket_history_product_attribute_id",
      "rc_email",
      "rc_phone",
      "rc_name_on_ticket",
      "rc_transaction_id",
      "rc_event_starts_on",
      "rc_ticket_scan_code",
      "rc_is_child",
      "rc_membership_group_name",
      "rc_membership_group_id",
      "rc_membership_level_name",
      "rc_membership_level_id",
      "rc_product_attribute_sku",
      "rc_created",
      "rc_shipping_fulfillment_status",
      "rc_fulfilled_by_employee",
      "rc_shipping_fulfillment_date",
      "rc_ticket_amount_to_ship",
      "rc_shipping_street_address",
      "rc_shipping_unit_number",
      "rc_shipping_city_address",
      "rc_shipping_province_address",
      "rc_shipping_country_address",
      "rc_shipping_postal_address",
    ],
    enabled_fields: [
      "venue",
      "events",
      "products",
      "membership_groups",
      "from_dt",
      "to_dt",
    ],
    required_fields: ["venue"],
  },
  {
    id: "report_ticket_history",
    name: t("Ticket Scan History Report"),
    fields: [
      { field: "venue", required: true, qs_filter: "venue" },
      {
        field: "events",
        required: false,
        qs_filter: "item__event_id__in",
        limit: 50,
        use_distinct: false,
      },
      {
        field: "products",
        required: false,
        qs_filter: "item__product_id__in",
        limit: 50,
        use_distinct: false,
      },
      {
        field: "ticket_types",
        required: false,
        qs_filter: "item__type_id__in",
        limit: 50,
      },
      { field: "from_dt", required: false, qs_filter: "created__gte" },
      { field: "to_dt", required: false, qs_filter: "created__lte" },
      { field: "is_select_all_events", required: false },
    ],
    format: "csv",
    available_formats: ["csv", "pdf"],
    enabled_columns: [
      "rc_ticket_history_ticket_code",
      "rc_ticket_history_item_type",
      "rc_ticket_history_ticket_name_on_ticket",
      "rc_ticket_history_ticket_event_name",
      "rc_ticket_history_event_id",
      "rc_ticket_history_tt_description",
      "rc_ticket_history_ticket_id",
      "rc_ticket_history_product_description",
      "rc_ticket_history_product_id",
      "rc_ticket_history_product_attribute_name",
      "rc_ticket_history_product_attribute_id",
      "rc_ticket_history_created",
      "rc_ticket_history_user_action",
      "rc_ticket_history_before_status",
      "rc_ticket_history_after_status",
      "rc_ticket_history_created_by",
    ],
    enabled_fields: [
      "venue",
      "events",
      "products",
      "ticket_types",
      "from_dt",
      "to_dt",
      "is_select_all_events",
    ],
    required_fields: ["venue"],
  },
  {
    id: "report_employee_scan_history",
    name: t("Employee Scan History Report"),
    fields: [
      { field: "venue", required: true, qs_filter: "venue" },
      {
        field: "events",
        required: false,
        qs_filter: "item__event_id__in",
        limit: 50,
        use_distinct: false,
      },
      {
        field: "ticket_types",
        required: false,
        qs_filter: "item__type_id__in",
        limit: 50,
      },
      { field: "from_dt", required: false, qs_filter: "created__gte" },
      { field: "to_dt", required: false, qs_filter: "created__lte" },
      { field: "is_select_all_events", required: false },
      { field: "employees", required: false, limit: 60 },
    ],
    format: "pdf",
    available_formats: ["pdf"],
    enabled_columns: [],
    enabled_fields: [
      "venue",
      "events",
      "ticket_types",
      "from_dt",
      "to_dt",
      "is_select_all_events",
      "employees",
    ],
    required_fields: ["venue"],
  },
  {
    id: "report_venue_user_cash_out",
    name: t("Seller Cash Out Report"),
    fields: [
      { field: "venue", required: true, qs_filter: "venue" },
      {
        field: "employees",
        required: true,
        qs_filter: "venue_user__employment__employee_id__in",
        limit: 1,
      },
      { field: "from_dt", required: false, qs_filter: "from_dt" },
      { field: "to_dt", required: false, qs_filter: "to_dt" },
    ],
    format: "pdf",
    available_formats: ["pdf"],
    enabled_columns: [],
    enabled_fields: ["venue", "employees", "from_dt", "to_dt"],
    required_fields: ["venue", "employees"],
  },
  {
    id: "report_discount_creation",
    name: t("Discount Creation Report"),
    fields: [
      { field: "from_dt", required: false, qs_filter: "created__gte" },
      { field: "to_dt", required: false, qs_filter: "created__lte" },
      { field: "venue", required: true, qs_filter: "venue" },
    ],
    format: "csv",
    available_formats: ["csv"],
    enabled_columns: [
      "rc_discount_allowed_checkouts",
      "rc_discount_amount",
      "rc_discount_limit",
      "rc_discount_maximum_quantity",
      "rc_discount_minimum_quantity",
      "rc_discount_rule_percentages",
      "rc_discount_rule_amounts",
      "rc_discount_percentage",
      "rc_discount_permission_type",
      "rc_discount_per_user_limit",
      "rc_discount_type",
      "rc_discount_created_by",
      "rc_discount_created_on",
      "rc_discount_description",
      "rc_discount_code",
    ],
    enabled_fields: ["from_dt", "to_dt", "venue"],
    required_fields: ["venue"],
  },
  {
    id: "report_discount_usage_stats",
    name: t("Discount Usage Stats"),
    fields: [
      { field: "venue", required: true, qs_filter: "venue" },
      { field: "from_dt", required: false, qs_filter: "start_date" },
      { field: "to_dt", required: false, qs_filter: "end_date" },
    ],
    format: "csv",
    available_formats: ["csv"],
    enabled_columns: [
      "rc_discount_description",
      "rc_discount_purchase_platform",
      "rc_discounts_used",
      "rc_discount_ticket_quantity",
      "rc_discount_code",
      "rc_display_gross_sales",
      "rc_refunds",
      "rc_discounts",
      "rc_gross_sales",
      "rc_amount_company_earned",
      "rc_pre_tax_company_charges",
      "rc_company_charges_tax",
      "rc_company_charges",
      "rc_pre_tax_processing_fees",
      "rc_processing_fees_tax",
      "rc_cc_charges",
      "rc_pre_tax_discovery_charges",
      "rc_discovery_charges_tax",
      "rc_discovery_charges",
      "rc_pre_tax_resale_charges",
      "rc_resale_charges_tax",
      "rc_resale_charges",
      "rc_account_credit_applied",
      "rc_account_credit_refunds",
      "rc_exchanged_out",
      "rc_display_gross_revenue",
      "rc_display_organizer_charges",
      "rc_organizer_item_tax",
      "rc_organizer_fee_tax",
      "rc_tax",
      "rc_display_net_revenue",
      "rc_adjustment",
      "rc_amount_paid",
    ],
    enabled_fields: ["venue", "from_dt", "to_dt"],
    required_fields: ["venue"],
  },
  {
    id: "report_holds_stats",
    name: t("Holds Stats"),
    fields: [
      { field: "venue", required: true, qs_filter: "venue" },
      {
        field: "events",
        required: false,
        qs_filter: "event_id__in",
        limit: 50,
        use_distinct: false,
      },
      {
        field: "ticket_types",
        required: false,
        qs_filter: "type_id__in",
        limit: 50,
      },
      {
        field: "products",
        required: false,
        qs_filter: "product_id__in",
        limit: 50,
        use_distinct: false,
      },
      {
        field: "membership_groups",
        required: false,
        qs_filter: "membership_group_id__in",
        limit: 50,
      },
      {
        field: "membership_levels",
        required: false,
        qs_filter: "membership_level_id__in",
        limit: 50,
      },
      { field: "is_select_all_events", required: false },
      { field: "from_dt", required: false, qs_filter: "created__gte" },
      { field: "to_dt", required: false, qs_filter: "created__lte" },
    ],
    format: "csv",
    available_formats: ["csv"],
    enabled_columns: [
      "rc_ticket_history_item_type",
      "rc_ticket_history_ticket_event_name",
      "rc_ticket_history_event_id",
      "rc_ticket_history_product_description",
      "rc_ticket_history_product_id",
      "rc_ticket_history_product_attribute_name",
      "rc_ticket_history_product_attribute_id",
      "rc_username",
      "rc_email",
      "rc_phone",
      "rc_quantity",
      "rc_event_starts_on",
      "rc_event_ends_on",
      "rc_ticket_type",
      "rc_ticket_type_id",
      "rc_seating_section",
      "rc_seating_row",
      "rc_seating_seat",
      "rc_basket_uuid",
      "rc_membership_group_name",
      "rc_membership_group_id",
      "rc_membership_level_name",
      "rc_membership_level_id",
      "rc_updated",
      "rc_sold_by",
      "rc_hold_link",
    ],
    enabled_fields: [
      "venue",
      "events",
      "ticket_types",
      "products",
      "membership_groups",
      "membership_levels",
      "is_select_all_events",
      "from_dt",
      "to_dt",
    ],
    required_fields: ["venue"],
  },
  {
    id: "report_event_product_inventory",
    name: t("Event/Product Inventory Report"),
    fields: [
      { field: "venue", required: true, qs_filter: "venue" },
      {
        field: "events",
        required: true,
        qs_filter: "event_id__in",
        limit: 500,
        use_distinct: true,
      },
      {
        field: "products",
        required: false,
        qs_filter: "product_id__in",
        limit: 500,
        use_distinct: true,
      },
    ],
    format: "csv",
    available_formats: ["csv"],
    enabled_columns: [
      "picked_up",
      "rc_email",
      "rc_name_on_ticket",
      "rc_final_amount",
      "rc_tax",
      "rc_quantity",
      "rc_organizer_charges",
      "rc_card_organizer_charges",
      "rc_event",
      "rc_event_starts_on",
      "rc_ticket_type",
      "rc_product_attribute",
      "rc_product",
      "rc_billing_address",
      "rc_company_charges",
    ],
    enabled_fields: ["venue", "events", "products"],
    required_fields: ["venue", "events"],
  },
  {
    id: "member_report",
    name: t("Member Report"),
    fields: [
      { field: "venue", required: true, qs_filter: "venue" },
      {
        field: "membership_groups",
        required: false,
        qs_filter: "membership_group__in",
        limit: 60,
      },
      {
        field: "membership_levels",
        required: false,
        qs_filter: "membership_level__in",
        limit: 60,
      },
      { field: "from_dt", required: false, qs_filter: "created__gte" },
      { field: "to_dt", required: false, qs_filter: "created__lte" },
    ],
    format: "csv",
    available_formats: ["csv"],
    enabled_columns: [
      "rc_member_first_name",
      "rc_member_last_name",
      "rc_member_name",
      "rc_member_email",
      "rc_member_phone",
      "rc_member_status",
      "rc_member_quantity",
      "rc_member_expiry_date",
      "rc_member_barcode",
      "rc_member_universal_code",
      "rc_member_scans_used",
      "rc_member_discounts_used",
      "rc_member_last_status_change",
      "rc_member_last_status_changed_by",
      "rc_membership_group_name",
      "rc_membership_level_name",
      "rc_member_latest_season",
      "rc_custom_question_info",
      "rc_info_student_number",
      "rc_info_company",
      "rc_info_job_title",
      "rc_info_home_address_unit_number",
      "rc_info_home_address_street_name",
      "rc_info_home_address_city",
      "rc_info_home_address_province",
      "rc_info_home_address_postal",
      "rc_info_home_address_country",
      "rc_info_birthday",
      "rc_info_license_plate",
    ],
    enabled_fields: [
      "venue",
      "membership_groups",
      "membership_levels",
      "from_dt",
      "to_dt",
    ],
    required_fields: ["venue"],
  },
  {
    id: "member_history_report",
    name: t("Member History Report"),
    fields: [
      { field: "venue", required: true, qs_filter: "venue" },
      {
        field: "membership_groups",
        required: false,
        qs_filter: "member__membership_group__in",
        limit: 60,
      },
      {
        field: "membership_levels",
        required: false,
        qs_filter: "member__membership_level__in",
        limit: 60,
      },
      { field: "from_dt", required: false, qs_filter: "created__gte" },
      { field: "to_dt", required: false, qs_filter: "created__lte" },
    ],
    format: "csv",
    available_formats: ["csv"],
    enabled_columns: [
      "rc_member_name",
      "rc_member_email",
      "rc_member_phone",
      "rc_member_barcode",
      "rc_member_history_amount",
      "rc_membership_group_name",
      "rc_membership_level_name",
      "rc_member_status_before",
      "rc_member_status_after",
      "rc_member_history_action",
      "rc_member_history_type",
      "rc_membership_benefit",
      "rc_general_created",
    ],
    enabled_fields: [
      "venue",
      "membership_groups",
      "membership_levels",
      "from_dt",
      "to_dt",
    ],
    required_fields: ["venue"],
  },
  {
    id: "member_benefit_usage_report",
    name: t("Member Benefit Usage Report"),
    fields: [
      { field: "venue", required: true, qs_filter: "venue" },
      {
        field: "membership_groups",
        required: false,
        qs_filter: "membership_group__in",
        limit: 60,
      },
      {
        field: "membership_levels",
        required: false,
        qs_filter: "membership_level__in",
        limit: 60,
      },
      { field: "from_dt", required: false, qs_filter: "created__gte" },
      { field: "to_dt", required: false, qs_filter: "created__lte" },
    ],
    format: "csv",
    available_formats: ["csv"],
    enabled_columns: [
      "rc_member_scans_allowed",
      "rc_member_scans_used",
      "rc_member_discounts_allowed",
      "rc_member_discounts_used",
      "rc_membership_group_name",
      "rc_membership_level_name",
      "rc_membership_benefit",
      "rc_membership_benefit_type",
    ],
    enabled_fields: [
      "venue",
      "membership_groups",
      "membership_levels",
      "from_dt",
      "to_dt",
    ],
    required_fields: ["venue"],
  },
  {
    id: "member_seating_report",
    name: t("Member Seating Report"),
    fields: [
      { field: "venue", required: true, qs_filter: "venue" },
      {
        field: "membership_groups",
        required: false,
        qs_filter: "membership_group__in",
        limit: 60,
      },
      { field: "from_dt", required: false, qs_filter: "created__gte" },
      { field: "to_dt", required: false, qs_filter: "created__lte" },
    ],
    format: "csv",
    available_formats: ["csv"],
    enabled_columns: [
      "rc_quantity",
      "rc_seating_section",
      "rc_seating_row",
      "rc_seating_seat",
      "rc_member_name",
      "rc_member_email",
      "rc_member_phone",
      "rc_member_status",
      "rc_member_seating_reserved",
      "rc_membership_group_name",
      "rc_membership_level_name",
    ],
    enabled_fields: ["venue", "membership_groups", "from_dt", "to_dt"],
    required_fields: ["venue"],
  },
  {
    id: "waitlist_subscriber_report",
    name: t("Waitlist Subscribers Report"),
    fields: [
      { field: "venue", required: true, qs_filter: "waitlist__venue_id" },
      {
        field: "events",
        required: false,
        qs_filter: "ticket_type__event_id__in",
        limit: 50,
        use_distinct: false,
      },
      {
        field: "ticket_types",
        required: false,
        qs_filter: "ticket_type_id__in",
        limit: 50,
      },
    ],
    format: "csv",
    available_formats: ["csv"],
    enabled_columns: [
      "rc_email",
      "rc_quantity",
      "rc_event",
      "rc_event_starts_on",
      "rc_ticket_type",
      "rc_total_price",
      "rc_total_price_no_fees",
      "rc_info_first_name",
      "rc_info_last_name",
      "rc_status",
    ],
    enabled_fields: ["venue", "events", "ticket_types"],
    required_fields: ["venue"],
  },
  {
    id: "reseller_submissions_report",
    name: t("Reselling Submissions Report"),
    fields: [
      { field: "venue", required: true, qs_filter: "venue_id" },
      {
        field: "events",
        required: false,
        qs_filter: "event_id__in",
        limit: 50,
        use_distinct: false,
      },
    ],
    format: "csv",
    available_formats: ["csv"],
    enabled_columns: [
      "rc_email",
      "rc_quantity",
      "rc_event",
      "rc_event_starts_on",
      "rc_ticket_type",
      "rc_refund_amount",
      "rc_info_first_name",
      "rc_info_last_name",
      "rc_status",
    ],
    enabled_fields: ["venue", "events"],
    required_fields: ["venue"],
  },
  {
    id: "report_donor_transaction",
    name: t("Donations History"),
    fields: [
      { field: "venue", required: true, qs_filter: "venue" },
      { field: "venue", required: false, qs_filter: "invoice_items__venue" },
      { field: "from_dt", required: false, qs_filter: "created__gte" },
      { field: "to_dt", required: false, qs_filter: "created__lte" },
    ],
    format: "csv",
    available_formats: ["csv"],
    enabled_columns: [
      "rc_username",
      "rc_email",
      "rc_phone",
      "rc_event",
      "rc_event_starts_on",
      "rc_created",
      "rc_postal_address",
      "rc_city_address",
      "rc_street_address",
      "rc_province_address",
      "rc_country_address",
      "rc_donation_total",
      "rc_registration_number",
      "rc_charity_name",
      "rc_charity_currency",
    ],
    enabled_fields: ["venue", "venue", "from_dt", "to_dt"],
    required_fields: ["venue"],
  },
  {
    id: "gift_card_recipients_report",
    name: t("Gift Card Recipient Report"),
    fields: [
      { field: "venue", required: true, qs_filter: "gift_card__venue_id" },
      { field: "gift_cards", required: true, qs_filter: "gift_card_id__in" },
      {
        field: "gift_card_denominations",
        required: true,
        qs_filter: "gift_card_denomination_id__in",
      },
      { field: "from_dt", required: false, qs_filter: "created__gte" },
      { field: "to_dt", required: false, qs_filter: "created__lte" },
    ],
    format: "csv",
    available_formats: ["csv"],
    enabled_columns: [
      "rc_transaction_date",
      "rc_quantity",
      "rc_purchaser_username",
      "rc_purchaser_email",
      "rc_purchaser_phone",
      "rc_sender_username",
      "rc_gift_card_redeemed",
      "rc_recipient_name",
      "rc_recipient_email",
      "rc_recipient_phone",
      "rc_gift_card_id",
      "rc_gift_card_name",
      "rc_gift_card_denomination_id",
      "rc_gift_card_denomination_price",
      "rc_gift_card_amount_paid",
      "rc_total_gift_card_amount",
      "rc_amount_advanced",
      "rc_amount_used",
      "rc_amount_remaining",
    ],
    enabled_fields: [
      "venue",
      "gift_cards",
      "gift_card_denominations",
      "from_dt",
      "to_dt",
    ],
    required_fields: ["venue", "gift_cards", "gift_card_denominations"],
  },
  {
    id: "report_marketing_campaigns",
    name: t("Marketing Campaign Summary"),
    fields: [
      { field: "venue", required: true, qs_filter: "venue" },
      {
        field: "events",
        required: false,
        qs_filter: "event_id__in",
        limit: 50,
        use_distinct: false,
      },
      {
        field: "utm_campaigns",
        required: false,
        qs_filter: "id__in",
        limit: 50,
        use_distinct: false,
      },
      { field: "from_dt", required: false },
      { field: "to_dt", required: false },
    ],
    format: "csv",
    available_formats: ["csv"],
    enabled_columns: [
      "rc_num_items_sold",
      "rc_final_amount",
      "rc_tax",
      "rc_refunds",
      "rc_discounts",
      "rc_gross_sales",
      "rc_amount_company_earned",
      "rc_display_gross_revenue",
      "rc_display_net_revenue",
      "rc_organizer_charges",
      "rc_utm_campaign",
      "rc_utm_source",
      "rc_utm_medium",
      "rc_views",
      "rc_add_to_cart",
      "rc_add_to_cart_rate",
      "rc_initiate_checkout",
      "rc_initiate_checkout_rate",
      "rc_purchases",
      "rc_purchase_rate",
    ],
    enabled_fields: ["venue", "events", "utm_campaigns", "from_dt", "to_dt"],
    required_fields: ["venue"],
  },
  {
    id: "report_marketing_campaign_details",
    name: t("Marketing Campaign Detail"),
    fields: [
      { field: "venue", required: true, qs_filter: "venue" },
      {
        field: "events",
        required: false,
        qs_filter: "event_id__in",
        limit: 60,
      },
      {
        field: "products",
        required: false,
        qs_filter: "product_id__in",
        limit: 50,
      },
      {
        field: "membership_groups",
        required: false,
        qs_filter: "membership_group_id__in",
        limit: 60,
      },
      {
        field: "utm_campaigns",
        required: true,
        qs_filter: "utm_campaign_id__in",
        limit: 50,
        use_distinct: false,
      },
      { field: "from_dt", required: false, qs_filter: "created__gte" },
      { field: "to_dt", required: false, qs_filter: "created__lte" },
    ],
    format: "csv",
    available_formats: ["csv", "pdf"],
    enabled_columns: [
      "rc_ticket_history_ticket_event_name",
      "rc_ticket_history_event_id",
      "rc_ticket_history_product_id",
      "rc_ticket_history_product_attribute_id",
      "rc_discount_amount",
      "rc_rule_discount_percentage",
      "rc_discount_rule_amount",
      "rc_discount_percentage",
      "rc_discount_type",
      "rc_username",
      "rc_email",
      "rc_phone",
      "rc_is_subscribed",
      "rc_invoice_item_description",
      "rc_charge_id",
      "rc_invoice_type_name",
      "rc_invoice_category_name",
      "rc_transaction_id",
      "rc_transaction_date",
      "rc_sale_transaction_id",
      "rc_settlement_date",
      "rc_advance_date",
      "rc_ticket_type_price",
      "rc_credit_type",
      "rc_purchase_source_platform",
      "rc_purchase_note",
      "rc_other_payment_type",
      "rc_transaction_quantity",
      "rc_item_quantity",
      "rc_transfer_quantity",
      "rc_scanned_quantity",
      "rc_scan_limit",
      "rc_refund_type",
      "rc_refund_reason",
      "rc_commissions",
      "rc_payment_type",
      "rc_card_type",
      "rc_event_starts_on",
      "rc_event_ends_on",
      "rc_ticket_type",
      "rc_ticket_type_id",
      "rc_event_location_name",
      "rc_event_location_postal_address",
      "rc_event_location_city_address",
      "rc_event_location_street_name",
      "rc_event_location_province_address",
      "rc_event_location_country_address",
      "rc_password_used",
      "rc_is_sub_ticket",
      "rc_member_name",
      "rc_member_email",
      "rc_membership_group_name",
      "rc_membership_group_id",
      "rc_membership_level_name",
      "rc_membership_level_id",
      "rc_membership_level_price",
      "rc_product_attribute",
      "rc_product_attribute_price",
      "rc_product",
      "rc_venue_name",
      "rc_venue_id",
      "rc_sold_by",
      "rc_referred_by",
      "rc_referred_link_description",
      "rc_referred_link_URL",
      "rc_postal_address",
      "rc_city_address",
      "rc_street_address",
      "rc_province_address",
      "rc_country_address",
      "rc_discount_code",
      "rc_shipping_method",
      "rc_shipping_street_address",
      "rc_shipping_unit_number",
      "rc_shipping_city_address",
      "rc_shipping_province_address",
      "rc_shipping_country_address",
      "rc_shipping_postal_address",
      "rc_shipping_cost",
      "rc_utm_campaign",
      "rc_utm_source",
      "rc_utm_medium",
      "rc_display_gross_sales",
      "rc_refunds",
      "rc_discounts",
      "rc_gross_sales",
      "rc_amount_company_earned",
      "rc_pre_tax_company_charges",
      "rc_company_charges_tax",
      "rc_company_charges",
      "rc_pre_tax_processing_fees",
      "rc_processing_fees_tax",
      "rc_cc_charges",
      "rc_pre_tax_discovery_charges",
      "rc_discovery_charges_tax",
      "rc_discovery_charges",
      "rc_pre_tax_resale_charges",
      "rc_resale_charges_tax",
      "rc_resale_charges",
      "rc_account_credit_applied",
      "rc_account_credit_refunds",
      "rc_exchanged_out",
      "rc_display_gross_revenue",
      "rc_display_organizer_charges",
      "rc_organizer_item_tax",
      "rc_organizer_fee_tax",
      "rc_tax",
      "rc_display_net_revenue",
      "rc_adjustment",
      "rc_amount_paid",
    ],
    enabled_fields: [
      "venue",
      "events",
      "products",
      "membership_groups",
      "utm_campaigns",
      "from_dt",
      "to_dt",
    ],
    required_fields: ["venue", "utm_campaigns"],
  },
] as const;

export const REPORT_FREQUENCY_MAP = {
  ONE_TIME: { id: "rf_one_time", name: t("One Time") },
  RECUR_MONTHLY: { id: "rf_recur_monthly", name: t("Recur Monthly") },
  RECUR_WEEKLY: { id: "rf_recur_weekly", name: t("Recur Weekly") },
  RECUR_DAILY: { id: "rf_recur_daily", name: t("Recur Daily") },
  RECUR_HOURLY: { id: "rf_recur_hourly", name: t("Recur Hourly") },
  RECUR_EVERY_TEN_MINUTES: {
    id: "rf_recur_every_ten_minutes",
    name: t("Recur Every Ten Minutes"),
  },
} as const;

export const REPORT_FREQUENCY_MAP_BY_ID = {
  rf_one_time: { id: "rf_one_time", name: t("One Time") },
  rf_recur_monthly: { id: "rf_recur_monthly", name: t("Recur Monthly") },
  rf_recur_weekly: { id: "rf_recur_weekly", name: t("Recur Weekly") },
  rf_recur_daily: { id: "rf_recur_daily", name: t("Recur Daily") },
  rf_recur_hourly: { id: "rf_recur_hourly", name: t("Recur Hourly") },
  rf_recur_every_ten_minutes: {
    id: "rf_recur_every_ten_minutes",
    name: t("Recur Every Ten Minutes"),
  },
} as const;

export const REPORT_FREQUENCY_MAP_BY_LIST = [
  { id: "rf_one_time", name: t("One Time") },
  { id: "rf_recur_monthly", name: t("Recur Monthly") },
  { id: "rf_recur_weekly", name: t("Recur Weekly") },
  { id: "rf_recur_daily", name: t("Recur Daily") },
  { id: "rf_recur_hourly", name: t("Recur Hourly") },
  { id: "rf_recur_every_ten_minutes", name: t("Recur Every Ten Minutes") },
] as const;

export const REPORT_COLUMN_TYPE_MAP = {
  TICKET_HISTORY: { id: "ticket_history", name: t("Ticket History") },
  DISCOUNT: { id: "discount", name: t("Discount") },
  CUSTOMER: { id: "customer", name: t("Customer") },
  FINANCIAL: { id: "financial", name: t("Financial") },
  INVENTORY: { id: "inventory", name: t("Inventory Data") },
  TICKETS: { id: "tickets", name: t("Tickets") },
  MEMBERSHIP: { id: "membership", name: t("Membership") },
  PRODUCTS: { id: "products", name: t("Products") },
  GIFT_CARDS: { id: "gift_cards", name: t("Gift Cards") },
  PRICE_TIERS: { id: "price_tiers", name: t("Price Tiers") },
  SHIPPING: { id: "shipping", name: t("Shipping") },
  DONATION: { id: "donation", name: t("Donation") },
  MARKETING_CAMPAIGNS: {
    id: "marketing_campaigns",
    name: t("Marketing Campaigns"),
  },
  OTHER: { id: "other", name: t("Other") },
} as const;

export const REPORT_COLUMN_TYPE_MAP_BY_ID = {
  ticket_history: { id: "ticket_history", name: t("Ticket History") },
  discount: { id: "discount", name: t("Discount") },
  customer: { id: "customer", name: t("Customer") },
  financial: { id: "financial", name: t("Financial") },
  inventory: { id: "inventory", name: t("Inventory Data") },
  tickets: { id: "tickets", name: t("Tickets") },
  membership: { id: "membership", name: t("Membership") },
  products: { id: "products", name: t("Products") },
  gift_cards: { id: "gift_cards", name: t("Gift Cards") },
  price_tiers: { id: "price_tiers", name: t("Price Tiers") },
  shipping: { id: "shipping", name: t("Shipping") },
  donation: { id: "donation", name: t("Donation") },
  marketing_campaigns: {
    id: "marketing_campaigns",
    name: t("Marketing Campaigns"),
  },
  other: { id: "other", name: t("Other") },
} as const;

export const REPORT_COLUMN_TYPE_MAP_BY_LIST = [
  { id: "ticket_history", name: t("Ticket History") },
  { id: "discount", name: t("Discount") },
  { id: "customer", name: t("Customer") },
  { id: "financial", name: t("Financial") },
  { id: "inventory", name: t("Inventory Data") },
  { id: "tickets", name: t("Tickets") },
  { id: "membership", name: t("Membership") },
  { id: "products", name: t("Products") },
  { id: "gift_cards", name: t("Gift Cards") },
  { id: "price_tiers", name: t("Price Tiers") },
  { id: "shipping", name: t("Shipping") },
  { id: "donation", name: t("Donation") },
  { id: "marketing_campaigns", name: t("Marketing Campaigns") },
  { id: "other", name: t("Other") },
] as const;

export const REPORT_FORMAT_MAP = {
  CSV: { id: "csv", name: t("CSV") },
  PDF: { id: "pdf", name: t("PDF") },
  XLSX: { id: "xlsx", name: t("XLSX") },
} as const;

export const REPORT_FORMAT_MAP_BY_ID = {
  csv: { id: "csv", name: t("CSV") },
  pdf: { id: "pdf", name: t("PDF") },
  xlsx: { id: "xlsx", name: t("XLSX") },
} as const;

export const REPORT_FORMAT_MAP_BY_LIST = [
  { id: "csv", name: t("CSV") },
  { id: "pdf", name: t("PDF") },
  { id: "xlsx", name: t("XLSX") },
] as const;

export const REPORT_DISPLAY_CLASS_TYPE_MAP = {
  DEFAULT: { id: "default", name: t("default") },
  MAIN_ROW: { id: "main-row", name: t("main-row") },
  MAIN_SUBROW: { id: "main-subrow", name: t("main-subrow") },
  SECONDARY_SUBROW: { id: "secondary-subrow", name: t("secondary-subrow") },
  TERTIARY_SUBROW: { id: "tertiary-subrow", name: t("tertiary-subrow") },
} as const;

export const REPORT_DISPLAY_CLASS_TYPE_MAP_BY_ID = {
  default: { id: "default", name: t("default") },
  "main-row": { id: "main-row", name: t("main-row") },
  "main-subrow": { id: "main-subrow", name: t("main-subrow") },
  "secondary-subrow": { id: "secondary-subrow", name: t("secondary-subrow") },
  "tertiary-subrow": { id: "tertiary-subrow", name: t("tertiary-subrow") },
} as const;

export const REPORT_DISPLAY_CLASS_TYPE_MAP_BY_LIST = [
  { id: "default", name: t("default") },
  { id: "main-row", name: t("main-row") },
  { id: "main-subrow", name: t("main-subrow") },
  { id: "secondary-subrow", name: t("secondary-subrow") },
  { id: "tertiary-subrow", name: t("tertiary-subrow") },
] as const;

export const PURCHASE_SOURCE_PLATFORM_MAP = {
  PLATFORM_WEB: {
    id: "psp_web",
    name: t("Web"),
    payment_types: [2, 5, 14],
    item_types: [
      "ticket",
      "product",
      "donation",
      "membership",
      "gift_card",
      "protection",
    ],
    internal_fees: ["company_fee", "payment_processing_fee"],
    is_deprecated: false,
    is_stripe_platform: true,
    key: "PLATFORM_WEB",
  },
  PLATFORM_WEB_BOX_OFFICE: {
    id: "psp_web_box_office",
    name: t("Web Box Office"),
    payment_types: [1, 2, 4, 5, 9],
    item_types: ["ticket", "product", "membership", "gift_card", "donation"],
    internal_fees: ["company_fee", "payment_processing_fee"],
    is_deprecated: false,
    is_stripe_platform: true,
    key: "PLATFORM_WEB_BOX_OFFICE",
  },
  PLATFORM_DESKTOP_BOX_OFFICE: {
    id: "psp_desktop_box_office",
    name: t("Desktop Box Office"),
    payment_types: [1, 2, 4, 5, 9],
    item_types: ["ticket", "product", "membership", "gift_card", "donation"],
    internal_fees: ["company_fee", "payment_processing_fee"],
    is_deprecated: false,
    is_stripe_platform: true,
    key: "PLATFORM_DESKTOP_BOX_OFFICE",
  },
  PLATFORM_MOBILE_BOX_OFFICE: {
    id: "psp_mobile_box_office",
    name: t("Mobile Box Office"),
    payment_types: [1, 2, 4, 5, 9],
    item_types: ["ticket", "product", "membership"],
    internal_fees: ["company_fee", "payment_processing_fee"],
    is_deprecated: false,
    is_stripe_platform: true,
    key: "PLATFORM_MOBILE_BOX_OFFICE",
  },
  PLATFORM_MOBILE: {
    id: "psp_mobile",
    name: t("Mobile"),
    payment_types: [2, 5],
    item_types: [
      "ticket",
      "product",
      "membership",
      "gift_card",
      "donation",
      "protection",
    ],
    internal_fees: ["company_fee", "payment_processing_fee"],
    is_deprecated: false,
    is_stripe_platform: true,
    key: "PLATFORM_MOBILE",
  },
  PLATFORM_WIDGET: {
    id: "psp_widget",
    name: t("Widget"),
    payment_types: [2, 14, 5],
    item_types: [
      "ticket",
      "product",
      "donation",
      "membership",
      "protection",
      "gift_card",
    ],
    internal_fees: ["company_fee", "payment_processing_fee"],
    is_deprecated: false,
    is_stripe_platform: true,
    key: "PLATFORM_WIDGET",
  },
  PLATFORM_FACEBOOK: {
    id: "psp_facebook",
    name: t("Facebook"),
    payment_types: [2, 5],
    item_types: ["ticket"],
    internal_fees: ["company_fee", "payment_processing_fee"],
    is_deprecated: true,
    is_stripe_platform: false,
    key: "PLATFORM_FACEBOOK",
  },
  PLATFORM_GOOGLE_RESERVE: {
    id: "psp_google_reserve",
    name: t("Google Reserve"),
    payment_types: [2],
    item_types: ["ticket"],
    internal_fees: ["company_fee", "payment_processing_fee"],
    is_deprecated: true,
    is_stripe_platform: false,
    key: "PLATFORM_GOOGLE_RESERVE",
  },
  PLATFORM_QPOS: {
    id: "psp_qpos",
    name: t("Quick Point Of Sale"),
    payment_types: [],
    item_types: [],
    internal_fees: [],
    is_deprecated: true,
    is_stripe_platform: false,
    key: "PLATFORM_QPOS",
  },
  PLATFORM_SQUARE_QPOS: {
    id: "psp_square_qpos",
    name: t("Square Point of Sale"),
    payment_types: [1, 2, 4, 5, 9],
    item_types: ["ticket", "product", "tip"],
    internal_fees: ["company_fee", "payment_processing_fee"],
    is_deprecated: true,
    is_stripe_platform: false,
    key: "PLATFORM_SQUARE_QPOS",
  },
  PLATFORM_SQUARE_TERMINAL: {
    id: "psp_square_terminal",
    name: t("Square Terminal"),
    payment_types: [2],
    item_types: ["ticket", "product"],
    internal_fees: ["company_fee", "payment_processing_fee"],
    is_deprecated: true,
    is_stripe_platform: false,
    key: "PLATFORM_SQUARE_TERMINAL",
  },
  PLATFORM_SQUARE_TERMINAL_OAUTH: {
    id: "psp_square_terminal_oauth",
    name: t("Web Square Terminal (OAuth)"),
    payment_types: [2],
    item_types: [
      "ticket",
      "product",
      "tip",
      "membership",
      "gift_card",
      "donation",
    ],
    internal_fees: ["company_fee", "payment_processing_fee"],
    is_deprecated: false,
    is_stripe_platform: false,
    key: "PLATFORM_SQUARE_TERMINAL_OAUTH",
  },
  PLATFORM_SQUARE_QPOS_OAUTH: {
    id: "psp_square_qpos_oauth",
    name: t("Square Point of Sale (OAuth)"),
    payment_types: [1, 2, 4, 5],
    item_types: ["ticket", "product", "tip", "membership", "gift_card"],
    internal_fees: ["company_fee", "payment_processing_fee"],
    is_deprecated: false,
    is_stripe_platform: false,
    key: "PLATFORM_SQUARE_QPOS_OAUTH",
  },
  PLATFORM_SQUARE_KIOSK: {
    id: "psp_square_kiosk",
    name: t("Square Kiosk"),
    payment_types: [2, 5],
    item_types: ["ticket", "product", "tip", "membership"],
    internal_fees: ["company_fee", "payment_processing_fee"],
    is_deprecated: false,
    is_stripe_platform: false,
    key: "PLATFORM_SQUARE_KIOSK",
  },
  PLATFORM_SQUARE_TERMINAL_OAUTH_DESKTOP: {
    id: "psp_square_terminal_desktop",
    name: t("Square Terminal OAuth Desktop"),
    payment_types: [2],
    item_types: ["ticket", "product", "tip", "membership", "donation"],
    internal_fees: ["company_fee", "payment_processing_fee"],
    is_deprecated: false,
    is_stripe_platform: false,
    key: "PLATFORM_SQUARE_TERMINAL_OAUTH_DESKTOP",
  },
  PLATFORM_UNKNOWN: {
    id: "psp_unknown",
    name: t("Unknown"),
    payment_types: [],
    item_types: [],
    internal_fees: [],
    is_deprecated: false,
    is_stripe_platform: false,
    key: "PLATFORM_UNKNOWN",
  },
  PLATFORM_AUTO_GENERATED: {
    id: "psp_auto_generated",
    name: t("Auto Generated"),
    payment_types: [],
    item_types: [],
    internal_fees: [],
    is_deprecated: false,
    is_stripe_platform: false,
    key: "PLATFORM_AUTO_GENERATED",
  },
  PLATFORM_SHIFT4_TERMINAL: {
    id: "psp_shift4_terminal",
    name: t("Shift4 Terminal"),
    payment_types: [2],
    item_types: ["ticket", "product", "tip", "membership"],
    internal_fees: ["company_fee", "payment_processing_fee"],
    is_deprecated: false,
    is_stripe_platform: false,
    key: "PLATFORM_SHIFT4_TERMINAL",
  },
  PLATFORM_SHIFT4_TERMINAL_DESKTOP: {
    id: "psp_shift4_terminal_desktop",
    name: t("Shift4 Terminal Desktop"),
    payment_types: [2],
    item_types: ["ticket", "product", "tip", "membership"],
    internal_fees: ["company_fee", "payment_processing_fee"],
    is_deprecated: false,
    is_stripe_platform: false,
    key: "PLATFORM_SHIFT4_TERMINAL_DESKTOP",
  },
  PLATFORM_SQUARE_TERMINAL_OAUTH_MOBILE: {
    id: "psp_square_terminal_oauth_mobile",
    name: t("Square Terminal OAuth Mobile"),
    payment_types: [2],
    item_types: ["ticket", "product", "tip", "membership"],
    internal_fees: ["company_fee", "payment_processing_fee"],
    is_deprecated: false,
    is_stripe_platform: false,
    key: "PLATFORM_SQUARE_TERMINAL_OAUTH_MOBILE",
  },
} as const;

export const PURCHASE_SOURCE_PLATFORM_MAP_BY_ID = {
  psp_web: {
    id: "psp_web",
    name: t("Web"),
    payment_types: [2, 5, 14],
    item_types: [
      "ticket",
      "product",
      "donation",
      "membership",
      "gift_card",
      "protection",
    ],
    internal_fees: ["company_fee", "payment_processing_fee"],
    is_deprecated: false,
    is_stripe_platform: true,
    key: "PLATFORM_WEB",
  },
  psp_web_box_office: {
    id: "psp_web_box_office",
    name: t("Web Box Office"),
    payment_types: [1, 2, 4, 5, 9],
    item_types: ["ticket", "product", "membership", "gift_card", "donation"],
    internal_fees: ["company_fee", "payment_processing_fee"],
    is_deprecated: false,
    is_stripe_platform: true,
    key: "PLATFORM_WEB_BOX_OFFICE",
  },
  psp_desktop_box_office: {
    id: "psp_desktop_box_office",
    name: t("Desktop Box Office"),
    payment_types: [1, 2, 4, 5, 9],
    item_types: ["ticket", "product", "membership", "gift_card", "donation"],
    internal_fees: ["company_fee", "payment_processing_fee"],
    is_deprecated: false,
    is_stripe_platform: true,
    key: "PLATFORM_DESKTOP_BOX_OFFICE",
  },
  psp_mobile_box_office: {
    id: "psp_mobile_box_office",
    name: t("Mobile Box Office"),
    payment_types: [1, 2, 4, 5, 9],
    item_types: ["ticket", "product", "membership"],
    internal_fees: ["company_fee", "payment_processing_fee"],
    is_deprecated: false,
    is_stripe_platform: true,
    key: "PLATFORM_MOBILE_BOX_OFFICE",
  },
  psp_mobile: {
    id: "psp_mobile",
    name: t("Mobile"),
    payment_types: [2, 5],
    item_types: [
      "ticket",
      "product",
      "membership",
      "gift_card",
      "donation",
      "protection",
    ],
    internal_fees: ["company_fee", "payment_processing_fee"],
    is_deprecated: false,
    is_stripe_platform: true,
    key: "PLATFORM_MOBILE",
  },
  psp_widget: {
    id: "psp_widget",
    name: t("Widget"),
    payment_types: [2, 14, 5],
    item_types: [
      "ticket",
      "product",
      "donation",
      "membership",
      "protection",
      "gift_card",
    ],
    internal_fees: ["company_fee", "payment_processing_fee"],
    is_deprecated: false,
    is_stripe_platform: true,
    key: "PLATFORM_WIDGET",
  },
  psp_facebook: {
    id: "psp_facebook",
    name: t("Facebook"),
    payment_types: [2, 5],
    item_types: ["ticket"],
    internal_fees: ["company_fee", "payment_processing_fee"],
    is_deprecated: true,
    is_stripe_platform: false,
    key: "PLATFORM_FACEBOOK",
  },
  psp_google_reserve: {
    id: "psp_google_reserve",
    name: t("Google Reserve"),
    payment_types: [2],
    item_types: ["ticket"],
    internal_fees: ["company_fee", "payment_processing_fee"],
    is_deprecated: true,
    is_stripe_platform: false,
    key: "PLATFORM_GOOGLE_RESERVE",
  },
  psp_qpos: {
    id: "psp_qpos",
    name: t("Quick Point Of Sale"),
    payment_types: [],
    item_types: [],
    internal_fees: [],
    is_deprecated: true,
    is_stripe_platform: false,
    key: "PLATFORM_QPOS",
  },
  psp_square_qpos: {
    id: "psp_square_qpos",
    name: t("Square Point of Sale"),
    payment_types: [1, 2, 4, 5, 9],
    item_types: ["ticket", "product", "tip"],
    internal_fees: ["company_fee", "payment_processing_fee"],
    is_deprecated: true,
    is_stripe_platform: false,
    key: "PLATFORM_SQUARE_QPOS",
  },
  psp_square_terminal: {
    id: "psp_square_terminal",
    name: t("Square Terminal"),
    payment_types: [2],
    item_types: ["ticket", "product"],
    internal_fees: ["company_fee", "payment_processing_fee"],
    is_deprecated: true,
    is_stripe_platform: false,
    key: "PLATFORM_SQUARE_TERMINAL",
  },
  psp_square_terminal_oauth: {
    id: "psp_square_terminal_oauth",
    name: t("Web Square Terminal (OAuth)"),
    payment_types: [2],
    item_types: [
      "ticket",
      "product",
      "tip",
      "membership",
      "gift_card",
      "donation",
    ],
    internal_fees: ["company_fee", "payment_processing_fee"],
    is_deprecated: false,
    is_stripe_platform: false,
    key: "PLATFORM_SQUARE_TERMINAL_OAUTH",
  },
  psp_square_qpos_oauth: {
    id: "psp_square_qpos_oauth",
    name: t("Square Point of Sale (OAuth)"),
    payment_types: [1, 2, 4, 5],
    item_types: ["ticket", "product", "tip", "membership", "gift_card"],
    internal_fees: ["company_fee", "payment_processing_fee"],
    is_deprecated: false,
    is_stripe_platform: false,
    key: "PLATFORM_SQUARE_QPOS_OAUTH",
  },
  psp_square_kiosk: {
    id: "psp_square_kiosk",
    name: t("Square Kiosk"),
    payment_types: [2, 5],
    item_types: ["ticket", "product", "tip", "membership"],
    internal_fees: ["company_fee", "payment_processing_fee"],
    is_deprecated: false,
    is_stripe_platform: false,
    key: "PLATFORM_SQUARE_KIOSK",
  },
  psp_square_terminal_desktop: {
    id: "psp_square_terminal_desktop",
    name: t("Square Terminal OAuth Desktop"),
    payment_types: [2],
    item_types: ["ticket", "product", "tip", "membership", "donation"],
    internal_fees: ["company_fee", "payment_processing_fee"],
    is_deprecated: false,
    is_stripe_platform: false,
    key: "PLATFORM_SQUARE_TERMINAL_OAUTH_DESKTOP",
  },
  psp_unknown: {
    id: "psp_unknown",
    name: t("Unknown"),
    payment_types: [],
    item_types: [],
    internal_fees: [],
    is_deprecated: false,
    is_stripe_platform: false,
    key: "PLATFORM_UNKNOWN",
  },
  psp_auto_generated: {
    id: "psp_auto_generated",
    name: t("Auto Generated"),
    payment_types: [],
    item_types: [],
    internal_fees: [],
    is_deprecated: false,
    is_stripe_platform: false,
    key: "PLATFORM_AUTO_GENERATED",
  },
  psp_shift4_terminal: {
    id: "psp_shift4_terminal",
    name: t("Shift4 Terminal"),
    payment_types: [2],
    item_types: ["ticket", "product", "tip", "membership"],
    internal_fees: ["company_fee", "payment_processing_fee"],
    is_deprecated: false,
    is_stripe_platform: false,
    key: "PLATFORM_SHIFT4_TERMINAL",
  },
  psp_shift4_terminal_desktop: {
    id: "psp_shift4_terminal_desktop",
    name: t("Shift4 Terminal Desktop"),
    payment_types: [2],
    item_types: ["ticket", "product", "tip", "membership"],
    internal_fees: ["company_fee", "payment_processing_fee"],
    is_deprecated: false,
    is_stripe_platform: false,
    key: "PLATFORM_SHIFT4_TERMINAL_DESKTOP",
  },
  psp_square_terminal_oauth_mobile: {
    id: "psp_square_terminal_oauth_mobile",
    name: t("Square Terminal OAuth Mobile"),
    payment_types: [2],
    item_types: ["ticket", "product", "tip", "membership"],
    internal_fees: ["company_fee", "payment_processing_fee"],
    is_deprecated: false,
    is_stripe_platform: false,
    key: "PLATFORM_SQUARE_TERMINAL_OAUTH_MOBILE",
  },
} as const;

export const PURCHASE_SOURCE_PLATFORM_MAP_BY_LIST = [
  {
    id: "psp_web",
    name: t("Web"),
    payment_types: [2, 5, 14],
    item_types: [
      "ticket",
      "product",
      "donation",
      "membership",
      "gift_card",
      "protection",
    ],
    internal_fees: ["company_fee", "payment_processing_fee"],
    is_deprecated: false,
    is_stripe_platform: true,
    key: "PLATFORM_WEB",
  },
  {
    id: "psp_web_box_office",
    name: t("Web Box Office"),
    payment_types: [1, 2, 4, 5, 9],
    item_types: ["ticket", "product", "membership", "gift_card", "donation"],
    internal_fees: ["company_fee", "payment_processing_fee"],
    is_deprecated: false,
    is_stripe_platform: true,
    key: "PLATFORM_WEB_BOX_OFFICE",
  },
  {
    id: "psp_desktop_box_office",
    name: t("Desktop Box Office"),
    payment_types: [1, 2, 4, 5, 9],
    item_types: ["ticket", "product", "membership", "gift_card", "donation"],
    internal_fees: ["company_fee", "payment_processing_fee"],
    is_deprecated: false,
    is_stripe_platform: true,
    key: "PLATFORM_DESKTOP_BOX_OFFICE",
  },
  {
    id: "psp_mobile_box_office",
    name: t("Mobile Box Office"),
    payment_types: [1, 2, 4, 5, 9],
    item_types: ["ticket", "product", "membership"],
    internal_fees: ["company_fee", "payment_processing_fee"],
    is_deprecated: false,
    is_stripe_platform: true,
    key: "PLATFORM_MOBILE_BOX_OFFICE",
  },
  {
    id: "psp_mobile",
    name: t("Mobile"),
    payment_types: [2, 5],
    item_types: [
      "ticket",
      "product",
      "membership",
      "gift_card",
      "donation",
      "protection",
    ],
    internal_fees: ["company_fee", "payment_processing_fee"],
    is_deprecated: false,
    is_stripe_platform: true,
    key: "PLATFORM_MOBILE",
  },
  {
    id: "psp_widget",
    name: t("Widget"),
    payment_types: [2, 14, 5],
    item_types: [
      "ticket",
      "product",
      "donation",
      "membership",
      "protection",
      "gift_card",
    ],
    internal_fees: ["company_fee", "payment_processing_fee"],
    is_deprecated: false,
    is_stripe_platform: true,
    key: "PLATFORM_WIDGET",
  },
  {
    id: "psp_facebook",
    name: t("Facebook"),
    payment_types: [2, 5],
    item_types: ["ticket"],
    internal_fees: ["company_fee", "payment_processing_fee"],
    is_deprecated: true,
    is_stripe_platform: false,
    key: "PLATFORM_FACEBOOK",
  },
  {
    id: "psp_google_reserve",
    name: t("Google Reserve"),
    payment_types: [2],
    item_types: ["ticket"],
    internal_fees: ["company_fee", "payment_processing_fee"],
    is_deprecated: true,
    is_stripe_platform: false,
    key: "PLATFORM_GOOGLE_RESERVE",
  },
  {
    id: "psp_qpos",
    name: t("Quick Point Of Sale"),
    payment_types: [],
    item_types: [],
    internal_fees: [],
    is_deprecated: true,
    is_stripe_platform: false,
    key: "PLATFORM_QPOS",
  },
  {
    id: "psp_square_qpos",
    name: t("Square Point of Sale"),
    payment_types: [1, 2, 4, 5, 9],
    item_types: ["ticket", "product", "tip"],
    internal_fees: ["company_fee", "payment_processing_fee"],
    is_deprecated: true,
    is_stripe_platform: false,
    key: "PLATFORM_SQUARE_QPOS",
  },
  {
    id: "psp_square_terminal",
    name: t("Square Terminal"),
    payment_types: [2],
    item_types: ["ticket", "product"],
    internal_fees: ["company_fee", "payment_processing_fee"],
    is_deprecated: true,
    is_stripe_platform: false,
    key: "PLATFORM_SQUARE_TERMINAL",
  },
  {
    id: "psp_square_terminal_oauth",
    name: t("Web Square Terminal (OAuth)"),
    payment_types: [2],
    item_types: [
      "ticket",
      "product",
      "tip",
      "membership",
      "gift_card",
      "donation",
    ],
    internal_fees: ["company_fee", "payment_processing_fee"],
    is_deprecated: false,
    is_stripe_platform: false,
    key: "PLATFORM_SQUARE_TERMINAL_OAUTH",
  },
  {
    id: "psp_square_qpos_oauth",
    name: t("Square Point of Sale (OAuth)"),
    payment_types: [1, 2, 4, 5],
    item_types: ["ticket", "product", "tip", "membership", "gift_card"],
    internal_fees: ["company_fee", "payment_processing_fee"],
    is_deprecated: false,
    is_stripe_platform: false,
    key: "PLATFORM_SQUARE_QPOS_OAUTH",
  },
  {
    id: "psp_square_kiosk",
    name: t("Square Kiosk"),
    payment_types: [2, 5],
    item_types: ["ticket", "product", "tip", "membership"],
    internal_fees: ["company_fee", "payment_processing_fee"],
    is_deprecated: false,
    is_stripe_platform: false,
    key: "PLATFORM_SQUARE_KIOSK",
  },
  {
    id: "psp_square_terminal_desktop",
    name: t("Square Terminal OAuth Desktop"),
    payment_types: [2],
    item_types: ["ticket", "product", "tip", "membership", "donation"],
    internal_fees: ["company_fee", "payment_processing_fee"],
    is_deprecated: false,
    is_stripe_platform: false,
    key: "PLATFORM_SQUARE_TERMINAL_OAUTH_DESKTOP",
  },
  {
    id: "psp_unknown",
    name: t("Unknown"),
    payment_types: [],
    item_types: [],
    internal_fees: [],
    is_deprecated: false,
    is_stripe_platform: false,
    key: "PLATFORM_UNKNOWN",
  },
  {
    id: "psp_auto_generated",
    name: t("Auto Generated"),
    payment_types: [],
    item_types: [],
    internal_fees: [],
    is_deprecated: false,
    is_stripe_platform: false,
    key: "PLATFORM_AUTO_GENERATED",
  },
  {
    id: "psp_shift4_terminal",
    name: t("Shift4 Terminal"),
    payment_types: [2],
    item_types: ["ticket", "product", "tip", "membership"],
    internal_fees: ["company_fee", "payment_processing_fee"],
    is_deprecated: false,
    is_stripe_platform: false,
    key: "PLATFORM_SHIFT4_TERMINAL",
  },
  {
    id: "psp_shift4_terminal_desktop",
    name: t("Shift4 Terminal Desktop"),
    payment_types: [2],
    item_types: ["ticket", "product", "tip", "membership"],
    internal_fees: ["company_fee", "payment_processing_fee"],
    is_deprecated: false,
    is_stripe_platform: false,
    key: "PLATFORM_SHIFT4_TERMINAL_DESKTOP",
  },
  {
    id: "psp_square_terminal_oauth_mobile",
    name: t("Square Terminal OAuth Mobile"),
    payment_types: [2],
    item_types: ["ticket", "product", "tip", "membership"],
    internal_fees: ["company_fee", "payment_processing_fee"],
    is_deprecated: false,
    is_stripe_platform: false,
    key: "PLATFORM_SQUARE_TERMINAL_OAUTH_MOBILE",
  },
] as const;

export const INITIATE_PURCHASE_BUTTON_DESCRIPTION_MAP = {
  IPBD_BUY_TICKETS: {
    id: "ipbd_buy_tickets",
    name: t("Buy Tickets"),
    key: "IPBD_BUY_TICKETS",
  },
  IPBD_REGISTER: {
    id: "ipbd_register",
    name: t("Register"),
    key: "IPBD_REGISTER",
  },
  IPBD_BUY_PASSES: {
    id: "ipbd_buy_passes",
    name: t("Buy Passes"),
    key: "IPBD_BUY_PASSES",
  },
  IPBD_SELECT_DATE: {
    id: "ipbd_select_date",
    name: t("Select Date"),
    key: "IPBD_SELECT_DATE",
  },
  IPBD_SELECT_TIME: {
    id: "ipbd_select_time",
    name: t("Select Time"),
    key: "IPBD_SELECT_TIME",
  },
  IPBD_RSVP: { id: "ipbd_rsvp", name: t("RSVP"), key: "IPBD_RSVP" },
  IPBD_GET_TICKETS: {
    id: "ipbd_get_tickets",
    name: t("Get Tickets"),
    key: "IPBD_GET_TICKETS",
  },
  IPBD_SELECT_SEATS: {
    id: "ipbd_select_seats",
    name: t("Select Seats"),
    key: "IPBD_SELECT_SEATS",
  },
  IPBD_LEARN_MORE: {
    id: "ipbd_learn_more",
    name: t("Learn More"),
    key: "IPBD_LEARN_MORE",
  },
} as const;

export const INITIATE_PURCHASE_BUTTON_DESCRIPTION_MAP_BY_ID = {
  ipbd_buy_tickets: {
    id: "ipbd_buy_tickets",
    name: t("Buy Tickets"),
    key: "IPBD_BUY_TICKETS",
  },
  ipbd_register: {
    id: "ipbd_register",
    name: t("Register"),
    key: "IPBD_REGISTER",
  },
  ipbd_buy_passes: {
    id: "ipbd_buy_passes",
    name: t("Buy Passes"),
    key: "IPBD_BUY_PASSES",
  },
  ipbd_select_date: {
    id: "ipbd_select_date",
    name: t("Select Date"),
    key: "IPBD_SELECT_DATE",
  },
  ipbd_select_time: {
    id: "ipbd_select_time",
    name: t("Select Time"),
    key: "IPBD_SELECT_TIME",
  },
  ipbd_rsvp: { id: "ipbd_rsvp", name: t("RSVP"), key: "IPBD_RSVP" },
  ipbd_get_tickets: {
    id: "ipbd_get_tickets",
    name: t("Get Tickets"),
    key: "IPBD_GET_TICKETS",
  },
  ipbd_select_seats: {
    id: "ipbd_select_seats",
    name: t("Select Seats"),
    key: "IPBD_SELECT_SEATS",
  },
  ipbd_learn_more: {
    id: "ipbd_learn_more",
    name: t("Learn More"),
    key: "IPBD_LEARN_MORE",
  },
} as const;

export const INITIATE_PURCHASE_BUTTON_DESCRIPTION_MAP_BY_LIST = [
  { id: "ipbd_buy_tickets", name: t("Buy Tickets"), key: "IPBD_BUY_TICKETS" },
  { id: "ipbd_register", name: t("Register"), key: "IPBD_REGISTER" },
  { id: "ipbd_buy_passes", name: t("Buy Passes"), key: "IPBD_BUY_PASSES" },
  { id: "ipbd_select_date", name: t("Select Date"), key: "IPBD_SELECT_DATE" },
  { id: "ipbd_select_time", name: t("Select Time"), key: "IPBD_SELECT_TIME" },
  { id: "ipbd_rsvp", name: t("RSVP"), key: "IPBD_RSVP" },
  { id: "ipbd_get_tickets", name: t("Get Tickets"), key: "IPBD_GET_TICKETS" },
  {
    id: "ipbd_select_seats",
    name: t("Select Seats"),
    key: "IPBD_SELECT_SEATS",
  },
  { id: "ipbd_learn_more", name: t("Learn More"), key: "IPBD_LEARN_MORE" },
] as const;

export const VENUE_PAYOUT_PAYMENT_PREFERENCE_TYPE_MAP = {
  VPPT_DIRECT_DEPOSIT: {
    id: "vppt_direct_deposit",
    name: t("Direct Deposit"),
    fields: [
      "institution_number",
      "transit_number",
      "account_number",
      "routing_aba_number",
      "account_type",
    ],
    key: "VPPT_DIRECT_DEPOSIT",
  },
  VPPT_CHEQUE: {
    id: "vppt_cheque",
    name: t("Cheque"),
    fields: [
      "name_on_cheque",
      "address",
      "unit",
      "city",
      "province",
      "country",
      "postal",
    ],
    key: "VPPT_CHEQUE",
  },
} as const;

export const VENUE_PAYOUT_PAYMENT_PREFERENCE_TYPE_MAP_BY_ID = {
  vppt_direct_deposit: {
    id: "vppt_direct_deposit",
    name: t("Direct Deposit"),
    fields: [
      "institution_number",
      "transit_number",
      "account_number",
      "routing_aba_number",
      "account_type",
    ],
    key: "VPPT_DIRECT_DEPOSIT",
  },
  vppt_cheque: {
    id: "vppt_cheque",
    name: t("Cheque"),
    fields: [
      "name_on_cheque",
      "address",
      "unit",
      "city",
      "province",
      "country",
      "postal",
    ],
    key: "VPPT_CHEQUE",
  },
} as const;

export const VENUE_PAYOUT_PAYMENT_PREFERENCE_TYPE_MAP_BY_LIST = [
  {
    id: "vppt_direct_deposit",
    name: t("Direct Deposit"),
    fields: [
      "institution_number",
      "transit_number",
      "account_number",
      "routing_aba_number",
      "account_type",
    ],
    key: "VPPT_DIRECT_DEPOSIT",
  },
  {
    id: "vppt_cheque",
    name: t("Cheque"),
    fields: [
      "name_on_cheque",
      "address",
      "unit",
      "city",
      "province",
      "country",
      "postal",
    ],
    key: "VPPT_CHEQUE",
  },
] as const;

export const VENUE_PAYOUT_PAYMENT_PREFERENCE_ACCOUNT_TYPE_MAP = {
  VPPAT_CHECKING: {
    id: "vppat_checking",
    name: t("Checking"),
    key: "VPPAT_CHECKING",
  },
  VPPAT_SAVINGS: {
    id: "vppat_savings",
    name: t("Savings"),
    key: "VPPAT_SAVINGS",
  },
} as const;

export const VENUE_PAYOUT_PAYMENT_PREFERENCE_ACCOUNT_TYPE_MAP_BY_ID = {
  vppat_checking: {
    id: "vppat_checking",
    name: t("Checking"),
    key: "VPPAT_CHECKING",
  },
  vppat_savings: {
    id: "vppat_savings",
    name: t("Savings"),
    key: "VPPAT_SAVINGS",
  },
} as const;

export const VENUE_PAYOUT_PAYMENT_PREFERENCE_ACCOUNT_TYPE_MAP_BY_LIST = [
  { id: "vppat_checking", name: t("Checking"), key: "VPPAT_CHECKING" },
  { id: "vppat_savings", name: t("Savings"), key: "VPPAT_SAVINGS" },
] as const;

export const VENUE_PAYOUT_PAYMENT_PREFERENCE_AGREEMENT_MAP = {
  PAYOUT_AGREEMENT: {
    id: "payout_agreement",
    name: t("Payout Agreement"),
    content: t(
      "The frequency of debiting/crediting the above account will be on a weekly basis based on the obligations agreed to in the Terms of Service and/or any superseding Agreements. Showpass in its sole discretion reserves the right to immediately debit the above account for the occurrence of Organizer requested refunds, disputed charges, customer complaints or allegations of fraud."
    ),
    key: "PAYOUT_AGREEMENT",
  },
  PAYOUT_ACKNOWLEDGEMENT: {
    id: "payout_acknowledgment",
    name: t("Payout Acknowledgement"),
    content: t(
      "You acknowledge that this information and authorization is for business purposes relating to the services provided by Showpass and is also to allow Showpass to both deposit and collect through crediting and debiting your bank account for amounts based on each parties’ obligations under the Services."
    ),
    key: "PAYOUT_ACKNOWLEDGEMENT",
  },
  PAYOUT_INFORMATION_CLAUSE: {
    id: "payout_information",
    name: t("Payout Information"),
    content: t(
      "You agree that Showpass may rely solely on the information provided as the proper identification of your bank account. In the case of a rejected credit or debit transaction, for whatever reason, Showpass may attempt to process it again. If any information provided is inaccurate, you agree to reimburse Showpass for any losses or expenses incurred in result of any inaccurate banking information you provide."
    ),
    key: "PAYOUT_INFORMATION_CLAUSE",
  },
  AUTHORIZATION_AGREEMENT: {
    id: "authorization_agreement",
    name: t("Authorization Agreement"),
    content: t(
      "Through this authorization, you understand that you are waiving any legislative or regulatory requirement for pre-notification."
    ),
    key: "AUTHORIZATION_AGREEMENT",
  },
  DISPUTE_AGREEMENT: {
    id: "dispute_agreement",
    name: t("Dispute Agreement"),
    content: t(
      "You may revoke your authorization at any time, subject to providing 10 business days notice before the next scheduled transaction by emailing finance@showpass.com. You have certain recourse rights if any debit does not comply with this agreement. For example, you have the right to receive reimbursement for any debit that is not authorized or is not consistent with this PAD Agreement. To obtain more information on your recourse rights, contact your financial institution or visit www.payments.ca"
    ),
    key: "DISPUTE_AGREEMENT",
  },
  DISPUTE_AGREEMENT_USD: {
    id: "dispute_agreement_usd",
    name: t("Dispute Agreement"),
    content: t(
      "You have certain recourse rights if any debit does not comply with this agreement. For example, you have the right to receive reimbursement for any ACH that is not authorized or is not consistent with this ACH Agreement. You understand that this authorization will remain in effect until it is canceled in writing and you agree to provide at least 10 business days notice before the next scheduled transaction by emailing finance@showpass.com. To obtain more information about your recourse rights, you can visit www.nacha.org."
    ),
    key: "DISPUTE_AGREEMENT_USD",
  },
  SIGNATURE_AGREEMENT: {
    id: "signature_agreement",
    name: t("Signature Agreement"),
    content: t(
      "You agree that typing your name will be the electronic representation of your signature."
    ),
    key: "SIGNATURE_AGREEMENT",
  },
  BIND_AGREEMENT: {
    id: "bind_agreement",
    name: t("Bind Agreement"),
    content: t("I certify that I have authority to bind the organization"),
    key: "BIND_AGREEMENT",
  },
  SHOWPASS_AGREEMENT: {
    id: "showpass_agreement",
    name: t("Showpass Agreement"),
    content: t(
      "I authorize Showpass to credit and debit my bank account based on each parties’ obligations under the Services."
    ),
    key: "SHOWPASS_AGREEMENT",
  },
} as const;

export const VENUE_PAYOUT_PAYMENT_PREFERENCE_AGREEMENT_MAP_BY_ID = {
  payout_agreement: {
    id: "payout_agreement",
    name: t("Payout Agreement"),
    content: t(
      "The frequency of debiting/crediting the above account will be on a weekly basis based on the obligations agreed to in the Terms of Service and/or any superseding Agreements. Showpass in its sole discretion reserves the right to immediately debit the above account for the occurrence of Organizer requested refunds, disputed charges, customer complaints or allegations of fraud."
    ),
    key: "PAYOUT_AGREEMENT",
  },
  payout_acknowledgment: {
    id: "payout_acknowledgment",
    name: t("Payout Acknowledgement"),
    content: t(
      "You acknowledge that this information and authorization is for business purposes relating to the services provided by Showpass and is also to allow Showpass to both deposit and collect through crediting and debiting your bank account for amounts based on each parties’ obligations under the Services."
    ),
    key: "PAYOUT_ACKNOWLEDGEMENT",
  },
  payout_information: {
    id: "payout_information",
    name: t("Payout Information"),
    content: t(
      "You agree that Showpass may rely solely on the information provided as the proper identification of your bank account. In the case of a rejected credit or debit transaction, for whatever reason, Showpass may attempt to process it again. If any information provided is inaccurate, you agree to reimburse Showpass for any losses or expenses incurred in result of any inaccurate banking information you provide."
    ),
    key: "PAYOUT_INFORMATION_CLAUSE",
  },
  authorization_agreement: {
    id: "authorization_agreement",
    name: t("Authorization Agreement"),
    content: t(
      "Through this authorization, you understand that you are waiving any legislative or regulatory requirement for pre-notification."
    ),
    key: "AUTHORIZATION_AGREEMENT",
  },
  dispute_agreement: {
    id: "dispute_agreement",
    name: t("Dispute Agreement"),
    content: t(
      "You may revoke your authorization at any time, subject to providing 10 business days notice before the next scheduled transaction by emailing finance@showpass.com. You have certain recourse rights if any debit does not comply with this agreement. For example, you have the right to receive reimbursement for any debit that is not authorized or is not consistent with this PAD Agreement. To obtain more information on your recourse rights, contact your financial institution or visit www.payments.ca"
    ),
    key: "DISPUTE_AGREEMENT",
  },
  dispute_agreement_usd: {
    id: "dispute_agreement_usd",
    name: t("Dispute Agreement"),
    content: t(
      "You have certain recourse rights if any debit does not comply with this agreement. For example, you have the right to receive reimbursement for any ACH that is not authorized or is not consistent with this ACH Agreement. You understand that this authorization will remain in effect until it is canceled in writing and you agree to provide at least 10 business days notice before the next scheduled transaction by emailing finance@showpass.com. To obtain more information about your recourse rights, you can visit www.nacha.org."
    ),
    key: "DISPUTE_AGREEMENT_USD",
  },
  signature_agreement: {
    id: "signature_agreement",
    name: t("Signature Agreement"),
    content: t(
      "You agree that typing your name will be the electronic representation of your signature."
    ),
    key: "SIGNATURE_AGREEMENT",
  },
  bind_agreement: {
    id: "bind_agreement",
    name: t("Bind Agreement"),
    content: t("I certify that I have authority to bind the organization"),
    key: "BIND_AGREEMENT",
  },
  showpass_agreement: {
    id: "showpass_agreement",
    name: t("Showpass Agreement"),
    content: t(
      "I authorize Showpass to credit and debit my bank account based on each parties’ obligations under the Services."
    ),
    key: "SHOWPASS_AGREEMENT",
  },
} as const;

export const VENUE_PAYOUT_PAYMENT_PREFERENCE_AGREEMENT_MAP_BY_LIST = [
  {
    id: "payout_agreement",
    name: t("Payout Agreement"),
    content: t(
      "The frequency of debiting/crediting the above account will be on a weekly basis based on the obligations agreed to in the Terms of Service and/or any superseding Agreements. Showpass in its sole discretion reserves the right to immediately debit the above account for the occurrence of Organizer requested refunds, disputed charges, customer complaints or allegations of fraud."
    ),
    key: "PAYOUT_AGREEMENT",
  },
  {
    id: "payout_acknowledgment",
    name: t("Payout Acknowledgement"),
    content: t(
      "You acknowledge that this information and authorization is for business purposes relating to the services provided by Showpass and is also to allow Showpass to both deposit and collect through crediting and debiting your bank account for amounts based on each parties’ obligations under the Services."
    ),
    key: "PAYOUT_ACKNOWLEDGEMENT",
  },
  {
    id: "payout_information",
    name: t("Payout Information"),
    content: t(
      "You agree that Showpass may rely solely on the information provided as the proper identification of your bank account. In the case of a rejected credit or debit transaction, for whatever reason, Showpass may attempt to process it again. If any information provided is inaccurate, you agree to reimburse Showpass for any losses or expenses incurred in result of any inaccurate banking information you provide."
    ),
    key: "PAYOUT_INFORMATION_CLAUSE",
  },
  {
    id: "authorization_agreement",
    name: t("Authorization Agreement"),
    content: t(
      "Through this authorization, you understand that you are waiving any legislative or regulatory requirement for pre-notification."
    ),
    key: "AUTHORIZATION_AGREEMENT",
  },
  {
    id: "dispute_agreement",
    name: t("Dispute Agreement"),
    content: t(
      "You may revoke your authorization at any time, subject to providing 10 business days notice before the next scheduled transaction by emailing finance@showpass.com. You have certain recourse rights if any debit does not comply with this agreement. For example, you have the right to receive reimbursement for any debit that is not authorized or is not consistent with this PAD Agreement. To obtain more information on your recourse rights, contact your financial institution or visit www.payments.ca"
    ),
    key: "DISPUTE_AGREEMENT",
  },
  {
    id: "dispute_agreement_usd",
    name: t("Dispute Agreement"),
    content: t(
      "You have certain recourse rights if any debit does not comply with this agreement. For example, you have the right to receive reimbursement for any ACH that is not authorized or is not consistent with this ACH Agreement. You understand that this authorization will remain in effect until it is canceled in writing and you agree to provide at least 10 business days notice before the next scheduled transaction by emailing finance@showpass.com. To obtain more information about your recourse rights, you can visit www.nacha.org."
    ),
    key: "DISPUTE_AGREEMENT_USD",
  },
  {
    id: "signature_agreement",
    name: t("Signature Agreement"),
    content: t(
      "You agree that typing your name will be the electronic representation of your signature."
    ),
    key: "SIGNATURE_AGREEMENT",
  },
  {
    id: "bind_agreement",
    name: t("Bind Agreement"),
    content: t("I certify that I have authority to bind the organization"),
    key: "BIND_AGREEMENT",
  },
  {
    id: "showpass_agreement",
    name: t("Showpass Agreement"),
    content: t(
      "I authorize Showpass to credit and debit my bank account based on each parties’ obligations under the Services."
    ),
    key: "SHOWPASS_AGREEMENT",
  },
] as const;

export const VENUE_FRAUD_PROTECTION_LEVEL_MAP = {
  "0": { id: 0, name: t("None"), key: 0 },
  "1": { id: 1, name: t("Fraud Protection"), key: 1 },
  "2": { id: 2, name: t("Fraud Protection Plus"), key: 2 },
} as const;

export const VENUE_FRAUD_PROTECTION_LEVEL_MAP_BY_ID = {} as const;

export const VENUE_FRAUD_PROTECTION_LEVEL_MAP_BY_LIST = [] as const;

export const GUEST_INFO_COLLECTION_TYPE_MAP = {
  GICT_STANDARD_INFO: {
    id: "gict_standard_info",
    name: t("Standard Info"),
    fields: ["info_first_name", "info_last_name", "info_email"],
  },
  GICT_ENHANCED_INFO: {
    id: "gict_enhanced_info",
    name: t("Enhanced Info"),
    fields: [
      "info_first_name",
      "info_last_name",
      "info_email",
      "info_phone_number",
      "info_company",
      "info_job_title",
      "info_student_number",
      "info_home_address_unit_number",
      "info_home_address_street_name",
      "info_home_address_city",
      "info_home_address_province",
      "info_home_address_postal",
      "info_home_address_country",
    ],
  },
} as const;

export const GUEST_INFO_COLLECTION_TYPE_MAP_BY_ID = {
  gict_standard_info: {
    id: "gict_standard_info",
    name: t("Standard Info"),
    fields: ["info_first_name", "info_last_name", "info_email"],
  },
  gict_enhanced_info: {
    id: "gict_enhanced_info",
    name: t("Enhanced Info"),
    fields: [
      "info_first_name",
      "info_last_name",
      "info_email",
      "info_phone_number",
      "info_company",
      "info_job_title",
      "info_student_number",
      "info_home_address_unit_number",
      "info_home_address_street_name",
      "info_home_address_city",
      "info_home_address_province",
      "info_home_address_postal",
      "info_home_address_country",
    ],
  },
} as const;

export const GUEST_INFO_COLLECTION_TYPE_MAP_BY_LIST = [
  {
    id: "gict_standard_info",
    name: t("Standard Info"),
    fields: ["info_first_name", "info_last_name", "info_email"],
  },
  {
    id: "gict_enhanced_info",
    name: t("Enhanced Info"),
    fields: [
      "info_first_name",
      "info_last_name",
      "info_email",
      "info_phone_number",
      "info_company",
      "info_job_title",
      "info_student_number",
      "info_home_address_unit_number",
      "info_home_address_street_name",
      "info_home_address_city",
      "info_home_address_province",
      "info_home_address_postal",
      "info_home_address_country",
    ],
  },
] as const;

export const FACEBOOK_TICKET_TIER_STATUS_MAP = {
  FBTTS_PENDING: {
    id: "fbtts_pending",
    name: t("Pending"),
    facebook_status: "PENDING",
  },
  FBTTS_ON_SALE: {
    id: "fbtts_on_sale",
    name: t("On sale"),
    facebook_status: "ON_SALE",
  },
  FBTTS_PAUSED: {
    id: "fbtts_paused",
    name: t("Paused"),
    facebook_status: "PAUSED",
  },
  FBTTS_SOLD_OUT: {
    id: "fbtts_sold_out",
    name: t("Sold out"),
    facebook_status: "SOLD_OUT",
  },
} as const;

export const FACEBOOK_TICKET_TIER_STATUS_MAP_BY_ID = {
  fbtts_pending: {
    id: "fbtts_pending",
    name: t("Pending"),
    facebook_status: "PENDING",
  },
  fbtts_on_sale: {
    id: "fbtts_on_sale",
    name: t("On sale"),
    facebook_status: "ON_SALE",
  },
  fbtts_paused: {
    id: "fbtts_paused",
    name: t("Paused"),
    facebook_status: "PAUSED",
  },
  fbtts_sold_out: {
    id: "fbtts_sold_out",
    name: t("Sold out"),
    facebook_status: "SOLD_OUT",
  },
} as const;

export const FACEBOOK_TICKET_TIER_STATUS_MAP_BY_LIST = [
  { id: "fbtts_pending", name: t("Pending"), facebook_status: "PENDING" },
  { id: "fbtts_on_sale", name: t("On sale"), facebook_status: "ON_SALE" },
  { id: "fbtts_paused", name: t("Paused"), facebook_status: "PAUSED" },
  { id: "fbtts_sold_out", name: t("Sold out"), facebook_status: "SOLD_OUT" },
] as const;

export const INV_SHIPPING_STATUS_MAP = {
  SHIPPING_NOT_FULFILLED: {
    id: "shipping_not_fulfilled",
    name: t("Unfulfilled"),
    key: "SHIPPING_NOT_FULFILLED",
  },
  SHIPPING_PARTIALLY_FULFILLED: {
    id: "shipping_partially_fulfilled",
    name: t("Partially Fulfilled"),
    key: "SHIPPING_PARTIALLY_FULFILLED",
  },
  SHIPPING_FULFILLED: {
    id: "shipping_fulfilled",
    name: t("Fulfilled"),
    key: "SHIPPING_FULFILLED",
  },
  SHIPPING_NOT_APPLICABLE: {
    id: "shipping_not_applicable",
    name: t("Shipping Not Selected"),
    key: "SHIPPING_NOT_APPLICABLE",
  },
} as const;

export const INV_SHIPPING_STATUS_MAP_BY_ID = {
  shipping_not_fulfilled: {
    id: "shipping_not_fulfilled",
    name: t("Unfulfilled"),
    key: "SHIPPING_NOT_FULFILLED",
  },
  shipping_partially_fulfilled: {
    id: "shipping_partially_fulfilled",
    name: t("Partially Fulfilled"),
    key: "SHIPPING_PARTIALLY_FULFILLED",
  },
  shipping_fulfilled: {
    id: "shipping_fulfilled",
    name: t("Fulfilled"),
    key: "SHIPPING_FULFILLED",
  },
  shipping_not_applicable: {
    id: "shipping_not_applicable",
    name: t("Shipping Not Selected"),
    key: "SHIPPING_NOT_APPLICABLE",
  },
} as const;

export const INV_SHIPPING_STATUS_MAP_BY_LIST = [
  {
    id: "shipping_not_fulfilled",
    name: t("Unfulfilled"),
    key: "SHIPPING_NOT_FULFILLED",
  },
  {
    id: "shipping_partially_fulfilled",
    name: t("Partially Fulfilled"),
    key: "SHIPPING_PARTIALLY_FULFILLED",
  },
  { id: "shipping_fulfilled", name: t("Fulfilled"), key: "SHIPPING_FULFILLED" },
  {
    id: "shipping_not_applicable",
    name: t("Shipping Not Selected"),
    key: "SHIPPING_NOT_APPLICABLE",
  },
] as const;

export const MEMBER_ACTIVITY_HISTORY_ACTION_MAP = {
  MAHA_SCAN_IN: {
    id: "maha_scan_in",
    name: t("Scan In"),
    before: null,
    after: null,
    redemption: true,
    icon: "icon-signin fa fa-sign-in",
    button: "btn-success",
    text: "text-green",
    key: "MAHA_SCAN_IN",
  },
  MAHA_SCAN_OUT: {
    id: "maha_scan_out",
    name: t("Scan Out"),
    before: null,
    after: null,
    redemption: true,
    icon: "icon-signout fa fa-sign-out",
    button: "btn-danger",
    text: "text-yellow",
    key: "MAHA_SCAN_OUT",
  },
  MAHA_DISABLE_ACCESS: {
    id: "maha_disable_access",
    name: t("Access Disabled"),
    before: "ms_active",
    after: "ms_disabled",
    redemption: false,
    icon: "icon-remove-sign fa fa-remove",
    button: "btn-danger",
    text: "text-red",
    key: "MAHA_DISABLE_ACCESS",
  },
  MAHA_ACTIVATE_ACCESS: {
    id: "maha_activate_access",
    name: t("Access Enabled"),
    before: "ms_disabled",
    after: "ms_active",
    redemption: false,
    icon: "icon-check fa fa-check",
    button: "btn-success",
    text: "text-green",
    key: "MAHA_ACTIVATE_ACCESS",
  },
  MAHA_EXPIRE_MEMBER: {
    id: "maha_expire_member",
    name: t("Member Expired"),
    before: "ms_active",
    after: "ms_expired",
    redemption: false,
    icon: "icon-remove-sign fa fa-remove",
    button: "btn-danger",
    text: "text-red",
    key: "MAHA_EXPIRE_MEMBER",
  },
  MAHA_DISCOUNT_USED: {
    id: "maha_discount_used",
    name: t("Discount Used"),
    before: null,
    after: null,
    redemption: false,
    icon: "icon-signin fa fa-sign-in",
    button: "btn-success",
    text: "text-green",
    key: "MAHA_DISCOUNT_USED",
  },
  MAHA_RENEW_MEMBER: {
    id: "maha_renew_member",
    name: t("Member Renewed"),
    before: "ms_expired",
    after: "ms_active",
    redemption: false,
    icon: "icon-check fa fa-check",
    button: "btn-success",
    text: "text-green",
    key: "MAHA_RENEW_MEMBER",
  },
  MAHA_REFUND_INITIATED: {
    id: "maha_refund_initiated",
    name: t("Member Refund Initiated"),
    before: "ms_active",
    after: "ms_refund_in_progress",
    redemption: false,
    icon: "icon-remove-sign fa fa-remove",
    button: "btn-danger",
    text: "text-red",
    key: "MAHA_REFUND_INITIATED",
  },
  MAHA_REFUND_CANCELLED: {
    id: "maha_refund_cancelled",
    name: t("Member Refund Cancelled"),
    before: "ms_refund_in_progress",
    after: "ms_active",
    redemption: false,
    icon: "icon-remove-sign fa fa-remove",
    button: "btn-danger",
    text: "text-red",
    key: "MAHA_REFUND_CANCELLED",
  },
  MAHA_REFUND_COMPLETED: {
    id: "maha_refund_completed",
    name: t("Member Refund Completed"),
    before: "ms_refund_in_progress",
    after: "ms_refunded",
    redemption: false,
    icon: "icon-remove-sign fa fa-remove",
    button: "btn-danger",
    text: "text-red",
    key: "MAHA_REFUND_COMPLETED",
  },
  MAHA_VOID_MEMBER: {
    id: "maha_void_member",
    name: t("Member Voided"),
    before: "ms_active",
    after: "ms_voided",
    redemption: false,
    icon: "icon-remove-sign fa fa-remove",
    button: "btn-danger",
    text: "text-red",
    key: "MAHA_VOID_MEMBER",
  },
  MAHA_TRANSFER_MEMBER: {
    id: "maha_transfer_member",
    name: t("Member Transferred"),
    before: "ms_active",
    after: "ms_transferred",
    redemption: false,
    icon: "icon-check fa fa-check",
    button: "btn-success",
    text: "text-green",
    key: "MAHA_TRANSFER_MEMBER",
  },
  MAHA_RETURN_MEMBER: {
    id: "maha_return_member",
    name: t("Member Returned"),
    before: "ms_active",
    after: "ms_transfer_returned",
    redemption: false,
    icon: "icon-check fa fa-check",
    button: "btn-success",
    text: "text-green",
    key: "MAHA_RETURN_MEMBER",
  },
} as const;

export const MEMBER_ACTIVITY_HISTORY_ACTION_MAP_BY_ID = {
  maha_scan_in: {
    id: "maha_scan_in",
    name: t("Scan In"),
    before: null,
    after: null,
    redemption: true,
    icon: "icon-signin fa fa-sign-in",
    button: "btn-success",
    text: "text-green",
    key: "MAHA_SCAN_IN",
  },
  maha_scan_out: {
    id: "maha_scan_out",
    name: t("Scan Out"),
    before: null,
    after: null,
    redemption: true,
    icon: "icon-signout fa fa-sign-out",
    button: "btn-danger",
    text: "text-yellow",
    key: "MAHA_SCAN_OUT",
  },
  maha_disable_access: {
    id: "maha_disable_access",
    name: t("Access Disabled"),
    before: "ms_active",
    after: "ms_disabled",
    redemption: false,
    icon: "icon-remove-sign fa fa-remove",
    button: "btn-danger",
    text: "text-red",
    key: "MAHA_DISABLE_ACCESS",
  },
  maha_activate_access: {
    id: "maha_activate_access",
    name: t("Access Enabled"),
    before: "ms_disabled",
    after: "ms_active",
    redemption: false,
    icon: "icon-check fa fa-check",
    button: "btn-success",
    text: "text-green",
    key: "MAHA_ACTIVATE_ACCESS",
  },
  maha_expire_member: {
    id: "maha_expire_member",
    name: t("Member Expired"),
    before: "ms_active",
    after: "ms_expired",
    redemption: false,
    icon: "icon-remove-sign fa fa-remove",
    button: "btn-danger",
    text: "text-red",
    key: "MAHA_EXPIRE_MEMBER",
  },
  maha_discount_used: {
    id: "maha_discount_used",
    name: t("Discount Used"),
    before: null,
    after: null,
    redemption: false,
    icon: "icon-signin fa fa-sign-in",
    button: "btn-success",
    text: "text-green",
    key: "MAHA_DISCOUNT_USED",
  },
  maha_renew_member: {
    id: "maha_renew_member",
    name: t("Member Renewed"),
    before: "ms_expired",
    after: "ms_active",
    redemption: false,
    icon: "icon-check fa fa-check",
    button: "btn-success",
    text: "text-green",
    key: "MAHA_RENEW_MEMBER",
  },
  maha_refund_initiated: {
    id: "maha_refund_initiated",
    name: t("Member Refund Initiated"),
    before: "ms_active",
    after: "ms_refund_in_progress",
    redemption: false,
    icon: "icon-remove-sign fa fa-remove",
    button: "btn-danger",
    text: "text-red",
    key: "MAHA_REFUND_INITIATED",
  },
  maha_refund_cancelled: {
    id: "maha_refund_cancelled",
    name: t("Member Refund Cancelled"),
    before: "ms_refund_in_progress",
    after: "ms_active",
    redemption: false,
    icon: "icon-remove-sign fa fa-remove",
    button: "btn-danger",
    text: "text-red",
    key: "MAHA_REFUND_CANCELLED",
  },
  maha_refund_completed: {
    id: "maha_refund_completed",
    name: t("Member Refund Completed"),
    before: "ms_refund_in_progress",
    after: "ms_refunded",
    redemption: false,
    icon: "icon-remove-sign fa fa-remove",
    button: "btn-danger",
    text: "text-red",
    key: "MAHA_REFUND_COMPLETED",
  },
  maha_void_member: {
    id: "maha_void_member",
    name: t("Member Voided"),
    before: "ms_active",
    after: "ms_voided",
    redemption: false,
    icon: "icon-remove-sign fa fa-remove",
    button: "btn-danger",
    text: "text-red",
    key: "MAHA_VOID_MEMBER",
  },
  maha_transfer_member: {
    id: "maha_transfer_member",
    name: t("Member Transferred"),
    before: "ms_active",
    after: "ms_transferred",
    redemption: false,
    icon: "icon-check fa fa-check",
    button: "btn-success",
    text: "text-green",
    key: "MAHA_TRANSFER_MEMBER",
  },
  maha_return_member: {
    id: "maha_return_member",
    name: t("Member Returned"),
    before: "ms_active",
    after: "ms_transfer_returned",
    redemption: false,
    icon: "icon-check fa fa-check",
    button: "btn-success",
    text: "text-green",
    key: "MAHA_RETURN_MEMBER",
  },
} as const;

export const MEMBER_ACTIVITY_HISTORY_ACTION_MAP_BY_LIST = [
  {
    id: "maha_scan_in",
    name: t("Scan In"),
    before: null,
    after: null,
    redemption: true,
    icon: "icon-signin fa fa-sign-in",
    button: "btn-success",
    text: "text-green",
    key: "MAHA_SCAN_IN",
  },
  {
    id: "maha_scan_out",
    name: t("Scan Out"),
    before: null,
    after: null,
    redemption: true,
    icon: "icon-signout fa fa-sign-out",
    button: "btn-danger",
    text: "text-yellow",
    key: "MAHA_SCAN_OUT",
  },
  {
    id: "maha_disable_access",
    name: t("Access Disabled"),
    before: "ms_active",
    after: "ms_disabled",
    redemption: false,
    icon: "icon-remove-sign fa fa-remove",
    button: "btn-danger",
    text: "text-red",
    key: "MAHA_DISABLE_ACCESS",
  },
  {
    id: "maha_activate_access",
    name: t("Access Enabled"),
    before: "ms_disabled",
    after: "ms_active",
    redemption: false,
    icon: "icon-check fa fa-check",
    button: "btn-success",
    text: "text-green",
    key: "MAHA_ACTIVATE_ACCESS",
  },
  {
    id: "maha_expire_member",
    name: t("Member Expired"),
    before: "ms_active",
    after: "ms_expired",
    redemption: false,
    icon: "icon-remove-sign fa fa-remove",
    button: "btn-danger",
    text: "text-red",
    key: "MAHA_EXPIRE_MEMBER",
  },
  {
    id: "maha_discount_used",
    name: t("Discount Used"),
    before: null,
    after: null,
    redemption: false,
    icon: "icon-signin fa fa-sign-in",
    button: "btn-success",
    text: "text-green",
    key: "MAHA_DISCOUNT_USED",
  },
  {
    id: "maha_renew_member",
    name: t("Member Renewed"),
    before: "ms_expired",
    after: "ms_active",
    redemption: false,
    icon: "icon-check fa fa-check",
    button: "btn-success",
    text: "text-green",
    key: "MAHA_RENEW_MEMBER",
  },
  {
    id: "maha_refund_initiated",
    name: t("Member Refund Initiated"),
    before: "ms_active",
    after: "ms_refund_in_progress",
    redemption: false,
    icon: "icon-remove-sign fa fa-remove",
    button: "btn-danger",
    text: "text-red",
    key: "MAHA_REFUND_INITIATED",
  },
  {
    id: "maha_refund_cancelled",
    name: t("Member Refund Cancelled"),
    before: "ms_refund_in_progress",
    after: "ms_active",
    redemption: false,
    icon: "icon-remove-sign fa fa-remove",
    button: "btn-danger",
    text: "text-red",
    key: "MAHA_REFUND_CANCELLED",
  },
  {
    id: "maha_refund_completed",
    name: t("Member Refund Completed"),
    before: "ms_refund_in_progress",
    after: "ms_refunded",
    redemption: false,
    icon: "icon-remove-sign fa fa-remove",
    button: "btn-danger",
    text: "text-red",
    key: "MAHA_REFUND_COMPLETED",
  },
  {
    id: "maha_void_member",
    name: t("Member Voided"),
    before: "ms_active",
    after: "ms_voided",
    redemption: false,
    icon: "icon-remove-sign fa fa-remove",
    button: "btn-danger",
    text: "text-red",
    key: "MAHA_VOID_MEMBER",
  },
  {
    id: "maha_transfer_member",
    name: t("Member Transferred"),
    before: "ms_active",
    after: "ms_transferred",
    redemption: false,
    icon: "icon-check fa fa-check",
    button: "btn-success",
    text: "text-green",
    key: "MAHA_TRANSFER_MEMBER",
  },
  {
    id: "maha_return_member",
    name: t("Member Returned"),
    before: "ms_active",
    after: "ms_transfer_returned",
    redemption: false,
    icon: "icon-check fa fa-check",
    button: "btn-success",
    text: "text-green",
    key: "MAHA_RETURN_MEMBER",
  },
] as const;

export const MEMBER_ACTIVITY_HISTORY_TYPE_MAP = {
  MAHT_SCAN: {
    id: "maht_scan",
    name: t("Scan"),
    required_fields: ["scans_used", "membership_benefit"],
    key: "MAHT_SCAN",
  },
  MAHT_STATUS: {
    id: "maht_status",
    name: t("Status"),
    required_fields: ["membership_status_before", "membership_status_after"],
    key: "MAHT_STATUS",
  },
  MAHT_DISCOUNT: {
    id: "maht_discount",
    name: t("Discount"),
    required_fields: ["discounts_used", "membership_benefit"],
    key: "MAHT_DISCOUNT",
  },
} as const;

export const MEMBER_ACTIVITY_HISTORY_TYPE_MAP_BY_ID = {
  maht_scan: {
    id: "maht_scan",
    name: t("Scan"),
    required_fields: ["scans_used", "membership_benefit"],
    key: "MAHT_SCAN",
  },
  maht_status: {
    id: "maht_status",
    name: t("Status"),
    required_fields: ["membership_status_before", "membership_status_after"],
    key: "MAHT_STATUS",
  },
  maht_discount: {
    id: "maht_discount",
    name: t("Discount"),
    required_fields: ["discounts_used", "membership_benefit"],
    key: "MAHT_DISCOUNT",
  },
} as const;

export const MEMBER_ACTIVITY_HISTORY_TYPE_MAP_BY_LIST = [
  {
    id: "maht_scan",
    name: t("Scan"),
    required_fields: ["scans_used", "membership_benefit"],
    key: "MAHT_SCAN",
  },
  {
    id: "maht_status",
    name: t("Status"),
    required_fields: ["membership_status_before", "membership_status_after"],
    key: "MAHT_STATUS",
  },
  {
    id: "maht_discount",
    name: t("Discount"),
    required_fields: ["discounts_used", "membership_benefit"],
    key: "MAHT_DISCOUNT",
  },
] as const;

export const MEMBER_STATUS_MAP = {
  MS_ACTIVE: {
    id: "ms_active",
    name: t("Active"),
    ticket_status: null,
    key: "MS_ACTIVE",
  },
  MS_DISABLED: {
    id: "ms_disabled",
    name: t("Disabled"),
    ticket_status: null,
    key: "MS_DISABLED",
  },
  MS_EXPIRED: {
    id: "ms_expired",
    name: t("Expired"),
    ticket_status: null,
    key: "MS_EXPIRED",
  },
  MS_TRANSFERRED: {
    id: "ms_transferred",
    name: t("Transferred"),
    ticket_status: null,
    key: "MS_TRANSFERRED",
  },
  MS_TRANSFER_RETURNED: {
    id: "ms_transfer_returned",
    name: t("Returned"),
    ticket_status: null,
    key: "MS_TRANSFER_RETURNED",
  },
  MS_REFUNDED: {
    id: "ms_refunded",
    name: t("Refunded"),
    ticket_status: 5,
    key: "MS_REFUNDED",
  },
  MS_REFUND_IN_PROGRESS: {
    id: "ms_refund_in_progress",
    name: t("Refund In Progress"),
    ticket_status: 12,
    key: "MS_REFUND_IN_PROGRESS",
  },
  MS_VOIDED: {
    id: "ms_voided",
    name: t("Voided"),
    ticket_status: 6,
    key: "MS_VOIDED",
  },
  MS_SCANCODE_PENDING: {
    id: "ms_scancode_pending",
    name: t("Scancode Pending"),
    ticket_status: 6,
    key: "MS_SCANCODE_PENDING",
  },
} as const;

export const MEMBER_STATUS_MAP_BY_ID = {
  ms_active: {
    id: "ms_active",
    name: t("Active"),
    ticket_status: null,
    key: "MS_ACTIVE",
  },
  ms_disabled: {
    id: "ms_disabled",
    name: t("Disabled"),
    ticket_status: null,
    key: "MS_DISABLED",
  },
  ms_expired: {
    id: "ms_expired",
    name: t("Expired"),
    ticket_status: null,
    key: "MS_EXPIRED",
  },
  ms_transferred: {
    id: "ms_transferred",
    name: t("Transferred"),
    ticket_status: null,
    key: "MS_TRANSFERRED",
  },
  ms_transfer_returned: {
    id: "ms_transfer_returned",
    name: t("Returned"),
    ticket_status: null,
    key: "MS_TRANSFER_RETURNED",
  },
  ms_refunded: {
    id: "ms_refunded",
    name: t("Refunded"),
    ticket_status: 5,
    key: "MS_REFUNDED",
  },
  ms_refund_in_progress: {
    id: "ms_refund_in_progress",
    name: t("Refund In Progress"),
    ticket_status: 12,
    key: "MS_REFUND_IN_PROGRESS",
  },
  ms_voided: {
    id: "ms_voided",
    name: t("Voided"),
    ticket_status: 6,
    key: "MS_VOIDED",
  },
  ms_scancode_pending: {
    id: "ms_scancode_pending",
    name: t("Scancode Pending"),
    ticket_status: 6,
    key: "MS_SCANCODE_PENDING",
  },
} as const;

export const MEMBER_STATUS_MAP_BY_LIST = [
  { id: "ms_active", name: t("Active"), ticket_status: null, key: "MS_ACTIVE" },
  {
    id: "ms_disabled",
    name: t("Disabled"),
    ticket_status: null,
    key: "MS_DISABLED",
  },
  {
    id: "ms_expired",
    name: t("Expired"),
    ticket_status: null,
    key: "MS_EXPIRED",
  },
  {
    id: "ms_transferred",
    name: t("Transferred"),
    ticket_status: null,
    key: "MS_TRANSFERRED",
  },
  {
    id: "ms_transfer_returned",
    name: t("Returned"),
    ticket_status: null,
    key: "MS_TRANSFER_RETURNED",
  },
  {
    id: "ms_refunded",
    name: t("Refunded"),
    ticket_status: 5,
    key: "MS_REFUNDED",
  },
  {
    id: "ms_refund_in_progress",
    name: t("Refund In Progress"),
    ticket_status: 12,
    key: "MS_REFUND_IN_PROGRESS",
  },
  { id: "ms_voided", name: t("Voided"), ticket_status: 6, key: "MS_VOIDED" },
  {
    id: "ms_scancode_pending",
    name: t("Scancode Pending"),
    ticket_status: 6,
    key: "MS_SCANCODE_PENDING",
  },
] as const;

export const BARCODE_PREFIX_MAP = {
  MEMBERSHIP_PREFIX: {
    id: "membership_prefix",
    name: t("Membership Prefix"),
    prefix: "SM-",
    key: "MEMBERSHIP_PREFIX",
  },
  UNIVERSAL_CODE_PREFIX: {
    id: "universal_code_prefix",
    name: t("Universal Code Prefix"),
    prefix: "SPU_",
    key: "UNIVERSAL_CODE_PREFIX",
  },
  ORDER_CODE_PREFIX: {
    id: "order_code_prefix",
    name: t("Order Code Prefix"),
    prefix: "SPO-",
    key: "ORDER_CODE_PREFIX",
  },
} as const;

export const BARCODE_PREFIX_MAP_BY_ID = {
  membership_prefix: {
    id: "membership_prefix",
    name: t("Membership Prefix"),
    prefix: "SM-",
    key: "MEMBERSHIP_PREFIX",
  },
  universal_code_prefix: {
    id: "universal_code_prefix",
    name: t("Universal Code Prefix"),
    prefix: "SPU_",
    key: "UNIVERSAL_CODE_PREFIX",
  },
  order_code_prefix: {
    id: "order_code_prefix",
    name: t("Order Code Prefix"),
    prefix: "SPO-",
    key: "ORDER_CODE_PREFIX",
  },
} as const;

export const BARCODE_PREFIX_MAP_BY_LIST = [
  {
    id: "membership_prefix",
    name: t("Membership Prefix"),
    prefix: "SM-",
    key: "MEMBERSHIP_PREFIX",
  },
  {
    id: "universal_code_prefix",
    name: t("Universal Code Prefix"),
    prefix: "SPU_",
    key: "UNIVERSAL_CODE_PREFIX",
  },
  {
    id: "order_code_prefix",
    name: t("Order Code Prefix"),
    prefix: "SPO-",
    key: "ORDER_CODE_PREFIX",
  },
] as const;

export const PAYMENT_GATEWAY_MAP = {
  GATEWAY_STRIPE: {
    id: 101,
    name: t("Stripe"),
    login_id_required: false,
    publishable_api_key_required: true,
    settings_prefix: "STRIPE",
    key: "GATEWAY_STRIPE",
  },
  GATEWAY_AUTHNET: {
    id: 102,
    name: t("Authorize.net"),
    login_id_required: true,
    publishable_api_key_required: false,
    settings_prefix: "AUTHNET",
    key: "GATEWAY_AUTHNET",
  },
  GATEWAY_BEANSTREAM: {
    id: 103,
    name: t("Beanstream"),
    login_id_required: true,
    publishable_api_key_required: false,
    settings_prefix: "BEANSTREAM",
    key: "GATEWAY_BEANSTREAM",
  },
  GATEWAY_BRAINTREE: {
    id: 104,
    name: t("Braintree"),
    login_id_required: true,
    publishable_api_key_required: true,
    settings_prefix: "BRAINTREE",
    key: "GATEWAY_BRAINTREE",
  },
  GATEWAY_SQUARE_QPOS: {
    id: 105,
    name: t("Square QPOS"),
    login_id_required: true,
    publishable_api_key_required: true,
    settings_prefix: "SQUARE_QPOS",
    key: "GATEWAY_SQUARE_QPOS",
  },
  GATEWAY_FACEBOOK_MPP: {
    id: 106,
    name: t("Facebook MPP"),
    login_id_required: true,
    publishable_api_key_required: true,
    settings_prefix: "FACEBOOK_MPP",
    key: "GATEWAY_FACEBOOK_MPP",
  },
} as const;

export const PAYMENT_GATEWAY_MAP_BY_ID = {
  "101": {
    id: 101,
    name: t("Stripe"),
    login_id_required: false,
    publishable_api_key_required: true,
    settings_prefix: "STRIPE",
    key: "GATEWAY_STRIPE",
  },
  "102": {
    id: 102,
    name: t("Authorize.net"),
    login_id_required: true,
    publishable_api_key_required: false,
    settings_prefix: "AUTHNET",
    key: "GATEWAY_AUTHNET",
  },
  "103": {
    id: 103,
    name: t("Beanstream"),
    login_id_required: true,
    publishable_api_key_required: false,
    settings_prefix: "BEANSTREAM",
    key: "GATEWAY_BEANSTREAM",
  },
  "104": {
    id: 104,
    name: t("Braintree"),
    login_id_required: true,
    publishable_api_key_required: true,
    settings_prefix: "BRAINTREE",
    key: "GATEWAY_BRAINTREE",
  },
  "105": {
    id: 105,
    name: t("Square QPOS"),
    login_id_required: true,
    publishable_api_key_required: true,
    settings_prefix: "SQUARE_QPOS",
    key: "GATEWAY_SQUARE_QPOS",
  },
  "106": {
    id: 106,
    name: t("Facebook MPP"),
    login_id_required: true,
    publishable_api_key_required: true,
    settings_prefix: "FACEBOOK_MPP",
    key: "GATEWAY_FACEBOOK_MPP",
  },
} as const;

export const PAYMENT_GATEWAY_MAP_BY_LIST = [
  {
    id: 101,
    name: t("Stripe"),
    login_id_required: false,
    publishable_api_key_required: true,
    settings_prefix: "STRIPE",
    key: "GATEWAY_STRIPE",
  },
  {
    id: 102,
    name: t("Authorize.net"),
    login_id_required: true,
    publishable_api_key_required: false,
    settings_prefix: "AUTHNET",
    key: "GATEWAY_AUTHNET",
  },
  {
    id: 103,
    name: t("Beanstream"),
    login_id_required: true,
    publishable_api_key_required: false,
    settings_prefix: "BEANSTREAM",
    key: "GATEWAY_BEANSTREAM",
  },
  {
    id: 104,
    name: t("Braintree"),
    login_id_required: true,
    publishable_api_key_required: true,
    settings_prefix: "BRAINTREE",
    key: "GATEWAY_BRAINTREE",
  },
  {
    id: 105,
    name: t("Square QPOS"),
    login_id_required: true,
    publishable_api_key_required: true,
    settings_prefix: "SQUARE_QPOS",
    key: "GATEWAY_SQUARE_QPOS",
  },
  {
    id: 106,
    name: t("Facebook MPP"),
    login_id_required: true,
    publishable_api_key_required: true,
    settings_prefix: "FACEBOOK_MPP",
    key: "GATEWAY_FACEBOOK_MPP",
  },
] as const;

export const CURRENCY_MAP = {
  CAD: {
    id: "CAD",
    name: t("Canadian Dollars"),
    symbol: "$",
    use_exchange_rate: false,
    key: "CAD",
  },
  USD: {
    id: "USD",
    name: t("US Dollars"),
    symbol: "$",
    use_exchange_rate: true,
    key: "USD",
  },
  EUR: {
    id: "EUR",
    name: t("Euro"),
    symbol: "€",
    use_exchange_rate: true,
    key: "EUR",
  },
  GBP: {
    id: "GBP",
    name: t("British Pound"),
    symbol: "£",
    use_exchange_rate: true,
    key: "GBP",
  },
  AUD: {
    id: "AUD",
    name: t("Australian Dollar"),
    symbol: "$",
    use_exchange_rate: true,
    key: "AUD",
  },
} as const;

export const CURRENCY_MAP_BY_ID = {} as const;

export const CURRENCY_MAP_BY_LIST = [] as const;

export const DISCOUNT_ALLOWED_MAP = {
  ALLOW_BOX_OFFICE: {
    id: "disc_allowed_box_office",
    name: t("Box Office Allowed"),
    key: "ALLOW_BOX_OFFICE",
  },
  ALLOW_PUBLIC: {
    id: "disc_allowed_public",
    name: t("Public Checkout Allowed"),
    key: "ALLOW_PUBLIC",
  },
} as const;

export const DISCOUNT_ALLOWED_MAP_BY_ID = {
  disc_allowed_box_office: {
    id: "disc_allowed_box_office",
    name: t("Box Office Allowed"),
    key: "ALLOW_BOX_OFFICE",
  },
  disc_allowed_public: {
    id: "disc_allowed_public",
    name: t("Public Checkout Allowed"),
    key: "ALLOW_PUBLIC",
  },
} as const;

export const DISCOUNT_ALLOWED_MAP_BY_LIST = [
  {
    id: "disc_allowed_box_office",
    name: t("Box Office Allowed"),
    key: "ALLOW_BOX_OFFICE",
  },
  {
    id: "disc_allowed_public",
    name: t("Public Checkout Allowed"),
    key: "ALLOW_PUBLIC",
  },
] as const;

export const SEATING_LOCATION_TYPE_MAP = {
  TYPE_ROW: { id: "row", name: t("Row"), key: "TYPE_ROW" },
  TYPE_TABLE: { id: "table", name: t("Table"), key: "TYPE_TABLE" },
  TYPE_SEMI_ROUND_TABLE: {
    id: "semi_round_table",
    name: t("Semi-round Table"),
    key: "TYPE_SEMI_ROUND_TABLE",
  },
  TYPE_SQUARE_TABLE: {
    id: "square_table",
    name: t("Square Table"),
    key: "TYPE_SQUARE_TABLE",
  },
  TYPE_GENERAL_ADMISSION: {
    id: "general_admission",
    name: t("General Admission"),
    key: "TYPE_GENERAL_ADMISSION",
  },
} as const;

export const SEATING_LOCATION_TYPE_MAP_BY_ID = {
  row: { id: "row", name: t("Row"), key: "TYPE_ROW" },
  table: { id: "table", name: t("Table"), key: "TYPE_TABLE" },
  semi_round_table: {
    id: "semi_round_table",
    name: t("Semi-round Table"),
    key: "TYPE_SEMI_ROUND_TABLE",
  },
  square_table: {
    id: "square_table",
    name: t("Square Table"),
    key: "TYPE_SQUARE_TABLE",
  },
  general_admission: {
    id: "general_admission",
    name: t("General Admission"),
    key: "TYPE_GENERAL_ADMISSION",
  },
} as const;

export const SEATING_LOCATION_TYPE_MAP_BY_LIST = [
  { id: "row", name: t("Row"), key: "TYPE_ROW" },
  { id: "table", name: t("Table"), key: "TYPE_TABLE" },
  {
    id: "semi_round_table",
    name: t("Semi-round Table"),
    key: "TYPE_SEMI_ROUND_TABLE",
  },
  { id: "square_table", name: t("Square Table"), key: "TYPE_SQUARE_TABLE" },
  {
    id: "general_admission",
    name: t("General Admission"),
    key: "TYPE_GENERAL_ADMISSION",
  },
] as const;

export const DISCOUNT_PERMISSION_MAP = {
  VENUE_DISCOUNT: {
    id: "disc_level_venue",
    name: t("Apply to all items of this type"),
    description:
      "Discounts that can be applied to any items of this type for a venue",
    key: "VENUE_DISCOUNT",
  },
  TICKET_TYPE_DISCOUNT: {
    id: "disc_level_ticket_type",
    name: t("Apply to certain items of this type"),
    description: "Discounts only apply to specific items of this type",
    key: "TICKET_TYPE_DISCOUNT",
  },
  EXCLUDE_TICKET_TYPE_DISCOUNT: {
    id: "disc_level_excluded_ticket_type",
    name: t("Exclude certain items of this type"),
    description: "Discounts don't apply to specific items of this type",
    key: "EXCLUDE_TICKET_TYPE_DISCOUNT",
  },
  ALL_DISCOUNT: {
    id: "disc_level_all",
    name: t("Allowed to be used to all items of this type"),
    description: "Discounts can be used to all types regardless of venue",
    key: "ALL_DISCOUNT",
  },
} as const;

export const DISCOUNT_PERMISSION_MAP_BY_ID = {
  disc_level_venue: {
    id: "disc_level_venue",
    name: t("Apply to all items of this type"),
    description:
      "Discounts that can be applied to any items of this type for a venue",
    key: "VENUE_DISCOUNT",
  },
  disc_level_ticket_type: {
    id: "disc_level_ticket_type",
    name: t("Apply to certain items of this type"),
    description: "Discounts only apply to specific items of this type",
    key: "TICKET_TYPE_DISCOUNT",
  },
  disc_level_excluded_ticket_type: {
    id: "disc_level_excluded_ticket_type",
    name: t("Exclude certain items of this type"),
    description: "Discounts don't apply to specific items of this type",
    key: "EXCLUDE_TICKET_TYPE_DISCOUNT",
  },
  disc_level_all: {
    id: "disc_level_all",
    name: t("Allowed to be used to all items of this type"),
    description: "Discounts can be used to all types regardless of venue",
    key: "ALL_DISCOUNT",
  },
} as const;

export const DISCOUNT_PERMISSION_MAP_BY_LIST = [
  {
    id: "disc_level_venue",
    name: t("Apply to all items of this type"),
    description:
      "Discounts that can be applied to any items of this type for a venue",
    key: "VENUE_DISCOUNT",
  },
  {
    id: "disc_level_ticket_type",
    name: t("Apply to certain items of this type"),
    description: "Discounts only apply to specific items of this type",
    key: "TICKET_TYPE_DISCOUNT",
  },
  {
    id: "disc_level_excluded_ticket_type",
    name: t("Exclude certain items of this type"),
    description: "Discounts don't apply to specific items of this type",
    key: "EXCLUDE_TICKET_TYPE_DISCOUNT",
  },
  {
    id: "disc_level_all",
    name: t("Allowed to be used to all items of this type"),
    description: "Discounts can be used to all types regardless of venue",
    key: "ALL_DISCOUNT",
  },
] as const;

export const APPLY_TYPE_MAP = {
  APPLY_TO_EACH: {
    id: 1,
    name: t("Apply to each item individually"),
    key: "APPLY_TO_EACH",
  },
  APPLY_ONCE: {
    id: 2,
    name: t("Single application to entire basket"),
    key: "APPLY_ONCE",
  },
} as const;

export const APPLY_TYPE_MAP_BY_ID = {
  "1": {
    id: 1,
    name: t("Apply to each item individually"),
    key: "APPLY_TO_EACH",
  },
  "2": {
    id: 2,
    name: t("Single application to entire basket"),
    key: "APPLY_ONCE",
  },
} as const;

export const APPLY_TYPE_MAP_BY_LIST = [
  { id: 1, name: t("Apply to each item individually"), key: "APPLY_TO_EACH" },
  { id: 2, name: t("Single application to entire basket"), key: "APPLY_ONCE" },
] as const;

export const SALE_ENDS_ON_DEFAULT_OPTIONS = {
  TWO_WEEKS_BEFORE_EVENT: {
    id: "two_weeks_before_event",
    name: t("Two weeks before event starts"),
    event_field: "starts_on",
    hours: 336,
    should_add: false,
    key: "TWO_WEEKS_BEFORE_EVENT",
  },
  TEN_DAYS_BEFORE_EVENT: {
    id: "ten_days_before_event",
    name: t("Ten days before event starts"),
    event_field: "starts_on",
    hours: 240,
    should_add: false,
    key: "TEN_DAYS_BEFORE_EVENT",
  },
  ONE_WEEK_BEFORE_EVENT: {
    id: "one_week_before_event",
    name: t("One week before event starts"),
    event_field: "starts_on",
    hours: 168,
    should_add: false,
    key: "ONE_WEEK_BEFORE_EVENT",
  },
  FIVE_DAYS_BEFORE_EVENT: {
    id: "five_days_before_event",
    name: t("Five days before event starts"),
    event_field: "starts_on",
    hours: 120,
    should_add: false,
    key: "FIVE_DAYS_BEFORE_EVENT",
  },
  TWO_DAYS_BEFORE_EVENT: {
    id: "two_days_before_event",
    name: t("Two days before event starts"),
    event_field: "starts_on",
    hours: 48,
    should_add: false,
    key: "TWO_DAYS_BEFORE_EVENT",
  },
  ONE_DAY_BEFORE_EVENT: {
    id: "day_before_event",
    name: t("One day before event starts"),
    event_field: "starts_on",
    hours: 24,
    should_add: false,
    key: "ONE_DAY_BEFORE_EVENT",
  },
  FOUR_HOUR_BEFORE_EVENT: {
    id: "four_hour_before_event",
    name: t("Four hours before event starts"),
    event_field: "starts_on",
    hours: 4,
    should_add: false,
    key: "FOUR_HOUR_BEFORE_EVENT",
  },
  TWO_HOUR_BEFORE_EVENT: {
    id: "two_hour_before_event",
    name: t("Two hours before event starts"),
    event_field: "starts_on",
    hours: 2,
    should_add: false,
    key: "TWO_HOUR_BEFORE_EVENT",
  },
  ONE_HOUR_BEFORE_EVENT: {
    id: "hour_before_event",
    name: t("One hour before event starts"),
    event_field: "starts_on",
    hours: 1,
    should_add: false,
    key: "ONE_HOUR_BEFORE_EVENT",
  },
  THIRTY_MINUTES_BEFORE_EVENT: {
    id: "thirty_minutes_before_event",
    name: t("Thirty minutes before event starts"),
    event_field: "starts_on",
    hours: 0.5,
    should_add: false,
    key: "THIRTY_MINUTES_BEFORE_EVENT",
  },
  THIRTY_MINUTES_AFTER_EVENT: {
    id: "thirty_minutes_after_event",
    name: t("Thirty minutes after event starts"),
    event_field: "starts_on",
    hours: 0.5,
    should_add: true,
    key: "THIRTY_MINUTES_AFTER_EVENT",
  },
  START_OF_THE_EVENT: {
    id: "start_of_event",
    name: t("Start of the event"),
    event_field: "starts_on",
    hours: 0,
    should_add: false,
    key: "START_OF_THE_EVENT",
  },
  END_OF_THE_EVENT: {
    id: "end_of_event",
    name: t("End of the event"),
    event_field: "ends_on",
    hours: 0,
    should_add: false,
    key: "END_OF_THE_EVENT",
  },
  ONE_BEFORE_EVENT_END: {
    id: "one_before_event_end",
    name: t("One hour before the event ends"),
    event_field: "ends_on",
    hours: 1,
    should_add: false,
    key: "ONE_BEFORE_EVENT_END",
  },
  TWO_BEFORE_EVENT_END: {
    id: "two_before_event_end",
    name: t("Two hours before the event ends"),
    event_field: "ends_on",
    hours: 2,
    should_add: false,
    key: "TWO_BEFORE_EVENT_END",
  },
} as const;

export const SALE_ENDS_ON_DEFAULT_OPTIONS_BY_ID = {
  two_weeks_before_event: {
    id: "two_weeks_before_event",
    name: t("Two weeks before event starts"),
    event_field: "starts_on",
    hours: 336,
    should_add: false,
    key: "TWO_WEEKS_BEFORE_EVENT",
  },
  ten_days_before_event: {
    id: "ten_days_before_event",
    name: t("Ten days before event starts"),
    event_field: "starts_on",
    hours: 240,
    should_add: false,
    key: "TEN_DAYS_BEFORE_EVENT",
  },
  one_week_before_event: {
    id: "one_week_before_event",
    name: t("One week before event starts"),
    event_field: "starts_on",
    hours: 168,
    should_add: false,
    key: "ONE_WEEK_BEFORE_EVENT",
  },
  five_days_before_event: {
    id: "five_days_before_event",
    name: t("Five days before event starts"),
    event_field: "starts_on",
    hours: 120,
    should_add: false,
    key: "FIVE_DAYS_BEFORE_EVENT",
  },
  two_days_before_event: {
    id: "two_days_before_event",
    name: t("Two days before event starts"),
    event_field: "starts_on",
    hours: 48,
    should_add: false,
    key: "TWO_DAYS_BEFORE_EVENT",
  },
  day_before_event: {
    id: "day_before_event",
    name: t("One day before event starts"),
    event_field: "starts_on",
    hours: 24,
    should_add: false,
    key: "ONE_DAY_BEFORE_EVENT",
  },
  four_hour_before_event: {
    id: "four_hour_before_event",
    name: t("Four hours before event starts"),
    event_field: "starts_on",
    hours: 4,
    should_add: false,
    key: "FOUR_HOUR_BEFORE_EVENT",
  },
  two_hour_before_event: {
    id: "two_hour_before_event",
    name: t("Two hours before event starts"),
    event_field: "starts_on",
    hours: 2,
    should_add: false,
    key: "TWO_HOUR_BEFORE_EVENT",
  },
  hour_before_event: {
    id: "hour_before_event",
    name: t("One hour before event starts"),
    event_field: "starts_on",
    hours: 1,
    should_add: false,
    key: "ONE_HOUR_BEFORE_EVENT",
  },
  thirty_minutes_before_event: {
    id: "thirty_minutes_before_event",
    name: t("Thirty minutes before event starts"),
    event_field: "starts_on",
    hours: 0.5,
    should_add: false,
    key: "THIRTY_MINUTES_BEFORE_EVENT",
  },
  thirty_minutes_after_event: {
    id: "thirty_minutes_after_event",
    name: t("Thirty minutes after event starts"),
    event_field: "starts_on",
    hours: 0.5,
    should_add: true,
    key: "THIRTY_MINUTES_AFTER_EVENT",
  },
  start_of_event: {
    id: "start_of_event",
    name: t("Start of the event"),
    event_field: "starts_on",
    hours: 0,
    should_add: false,
    key: "START_OF_THE_EVENT",
  },
  end_of_event: {
    id: "end_of_event",
    name: t("End of the event"),
    event_field: "ends_on",
    hours: 0,
    should_add: false,
    key: "END_OF_THE_EVENT",
  },
  one_before_event_end: {
    id: "one_before_event_end",
    name: t("One hour before the event ends"),
    event_field: "ends_on",
    hours: 1,
    should_add: false,
    key: "ONE_BEFORE_EVENT_END",
  },
  two_before_event_end: {
    id: "two_before_event_end",
    name: t("Two hours before the event ends"),
    event_field: "ends_on",
    hours: 2,
    should_add: false,
    key: "TWO_BEFORE_EVENT_END",
  },
} as const;

export const SALE_ENDS_ON_DEFAULT_OPTIONS_BY_LIST = [
  {
    id: "two_weeks_before_event",
    name: t("Two weeks before event starts"),
    event_field: "starts_on",
    hours: 336,
    should_add: false,
    key: "TWO_WEEKS_BEFORE_EVENT",
  },
  {
    id: "ten_days_before_event",
    name: t("Ten days before event starts"),
    event_field: "starts_on",
    hours: 240,
    should_add: false,
    key: "TEN_DAYS_BEFORE_EVENT",
  },
  {
    id: "one_week_before_event",
    name: t("One week before event starts"),
    event_field: "starts_on",
    hours: 168,
    should_add: false,
    key: "ONE_WEEK_BEFORE_EVENT",
  },
  {
    id: "five_days_before_event",
    name: t("Five days before event starts"),
    event_field: "starts_on",
    hours: 120,
    should_add: false,
    key: "FIVE_DAYS_BEFORE_EVENT",
  },
  {
    id: "two_days_before_event",
    name: t("Two days before event starts"),
    event_field: "starts_on",
    hours: 48,
    should_add: false,
    key: "TWO_DAYS_BEFORE_EVENT",
  },
  {
    id: "day_before_event",
    name: t("One day before event starts"),
    event_field: "starts_on",
    hours: 24,
    should_add: false,
    key: "ONE_DAY_BEFORE_EVENT",
  },
  {
    id: "four_hour_before_event",
    name: t("Four hours before event starts"),
    event_field: "starts_on",
    hours: 4,
    should_add: false,
    key: "FOUR_HOUR_BEFORE_EVENT",
  },
  {
    id: "two_hour_before_event",
    name: t("Two hours before event starts"),
    event_field: "starts_on",
    hours: 2,
    should_add: false,
    key: "TWO_HOUR_BEFORE_EVENT",
  },
  {
    id: "hour_before_event",
    name: t("One hour before event starts"),
    event_field: "starts_on",
    hours: 1,
    should_add: false,
    key: "ONE_HOUR_BEFORE_EVENT",
  },
  {
    id: "thirty_minutes_before_event",
    name: t("Thirty minutes before event starts"),
    event_field: "starts_on",
    hours: 0.5,
    should_add: false,
    key: "THIRTY_MINUTES_BEFORE_EVENT",
  },
  {
    id: "thirty_minutes_after_event",
    name: t("Thirty minutes after event starts"),
    event_field: "starts_on",
    hours: 0.5,
    should_add: true,
    key: "THIRTY_MINUTES_AFTER_EVENT",
  },
  {
    id: "start_of_event",
    name: t("Start of the event"),
    event_field: "starts_on",
    hours: 0,
    should_add: false,
    key: "START_OF_THE_EVENT",
  },
  {
    id: "end_of_event",
    name: t("End of the event"),
    event_field: "ends_on",
    hours: 0,
    should_add: false,
    key: "END_OF_THE_EVENT",
  },
  {
    id: "one_before_event_end",
    name: t("One hour before the event ends"),
    event_field: "ends_on",
    hours: 1,
    should_add: false,
    key: "ONE_BEFORE_EVENT_END",
  },
  {
    id: "two_before_event_end",
    name: t("Two hours before the event ends"),
    event_field: "ends_on",
    hours: 2,
    should_add: false,
    key: "TWO_BEFORE_EVENT_END",
  },
] as const;

export const STATS_RESOLUTION_MAP = {
  SR_HOUR: { id: "sr_hour", name: t("Hour") },
  SR_DAY: { id: "sr_day", name: t("Day") },
} as const;

export const STATS_RESOLUTION_MAP_BY_ID = {
  sr_hour: { id: "sr_hour", name: t("Hour") },
  sr_day: { id: "sr_day", name: t("Day") },
} as const;

export const STATS_RESOLUTION_MAP_BY_LIST = [
  { id: "sr_hour", name: t("Hour") },
  { id: "sr_day", name: t("Day") },
] as const;

export const EMAIL_STATUS_MAP = {
  NOT_SENT: {
    id: "email_not_sent",
    name: t("Not Sent"),
    detail: t("E-Mail has not yet been sent to the recipient"),
    class: "label-danger",
    key: "NOT_SENT",
  },
  SENT: {
    id: "email_sent",
    name: t("Sent"),
    detail: t("E-Mail is on its way to the recipient"),
    class: "label-primary",
    key: "SENT",
  },
  SCHEDULED: {
    id: "email_scheduled",
    name: t("Scheduled"),
    detail: t("E-Mail is scheduled to be sent at a future date"),
    class: "label-primary",
    key: "SCHEDULED",
  },
  DELAYED: {
    id: "email_delayed",
    name: t("Delayed"),
    detail: t("E-Mail sending is currently delayed"),
    class: "label-warning",
    key: "DELAYED",
  },
  PENDING: {
    id: "email_pending",
    name: t("Pending"),
    detail: t("E-Mail is currently being sent"),
    class: "label-default",
    key: "PENDING",
  },
  DELIVERED: {
    id: "email_delivered",
    name: t("Delivered"),
    detail: t("E-Mail successfully delivered to the recipient"),
    class: "label-success",
    key: "DELIVERED",
  },
  BOUNCED: {
    id: "email_bounced",
    name: t("Bounced"),
    detail: t("E-Mail was not delivered"),
    class: "label-danger",
    key: "BOUNCED",
  },
  OPENED: {
    id: "email_opened",
    name: t("Opened"),
    detail: t("E-Mail was successfully delivered and opened by the recipient"),
    class: "label-success",
    key: "OPENED",
  },
  REJECTED: {
    id: "email_rejected",
    name: t("Rejected"),
    detail: t("E-Mail was rejected for an unknown reason"),
    class: "label-danger",
    key: "REJECTED",
  },
} as const;

export const EMAIL_STATUS_MAP_BY_ID = {
  email_not_sent: {
    id: "email_not_sent",
    name: t("Not Sent"),
    detail: t("E-Mail has not yet been sent to the recipient"),
    class: "label-danger",
    key: "NOT_SENT",
  },
  email_sent: {
    id: "email_sent",
    name: t("Sent"),
    detail: t("E-Mail is on its way to the recipient"),
    class: "label-primary",
    key: "SENT",
  },
  email_scheduled: {
    id: "email_scheduled",
    name: t("Scheduled"),
    detail: t("E-Mail is scheduled to be sent at a future date"),
    class: "label-primary",
    key: "SCHEDULED",
  },
  email_delayed: {
    id: "email_delayed",
    name: t("Delayed"),
    detail: t("E-Mail sending is currently delayed"),
    class: "label-warning",
    key: "DELAYED",
  },
  email_pending: {
    id: "email_pending",
    name: t("Pending"),
    detail: t("E-Mail is currently being sent"),
    class: "label-default",
    key: "PENDING",
  },
  email_delivered: {
    id: "email_delivered",
    name: t("Delivered"),
    detail: t("E-Mail successfully delivered to the recipient"),
    class: "label-success",
    key: "DELIVERED",
  },
  email_bounced: {
    id: "email_bounced",
    name: t("Bounced"),
    detail: t("E-Mail was not delivered"),
    class: "label-danger",
    key: "BOUNCED",
  },
  email_opened: {
    id: "email_opened",
    name: t("Opened"),
    detail: t("E-Mail was successfully delivered and opened by the recipient"),
    class: "label-success",
    key: "OPENED",
  },
  email_rejected: {
    id: "email_rejected",
    name: t("Rejected"),
    detail: t("E-Mail was rejected for an unknown reason"),
    class: "label-danger",
    key: "REJECTED",
  },
} as const;

export const EMAIL_STATUS_MAP_BY_LIST = [
  {
    id: "email_not_sent",
    name: t("Not Sent"),
    detail: t("E-Mail has not yet been sent to the recipient"),
    class: "label-danger",
    key: "NOT_SENT",
  },
  {
    id: "email_sent",
    name: t("Sent"),
    detail: t("E-Mail is on its way to the recipient"),
    class: "label-primary",
    key: "SENT",
  },
  {
    id: "email_scheduled",
    name: t("Scheduled"),
    detail: t("E-Mail is scheduled to be sent at a future date"),
    class: "label-primary",
    key: "SCHEDULED",
  },
  {
    id: "email_delayed",
    name: t("Delayed"),
    detail: t("E-Mail sending is currently delayed"),
    class: "label-warning",
    key: "DELAYED",
  },
  {
    id: "email_pending",
    name: t("Pending"),
    detail: t("E-Mail is currently being sent"),
    class: "label-default",
    key: "PENDING",
  },
  {
    id: "email_delivered",
    name: t("Delivered"),
    detail: t("E-Mail successfully delivered to the recipient"),
    class: "label-success",
    key: "DELIVERED",
  },
  {
    id: "email_bounced",
    name: t("Bounced"),
    detail: t("E-Mail was not delivered"),
    class: "label-danger",
    key: "BOUNCED",
  },
  {
    id: "email_opened",
    name: t("Opened"),
    detail: t("E-Mail was successfully delivered and opened by the recipient"),
    class: "label-success",
    key: "OPENED",
  },
  {
    id: "email_rejected",
    name: t("Rejected"),
    detail: t("E-Mail was rejected for an unknown reason"),
    class: "label-danger",
    key: "REJECTED",
  },
] as const;

export const REFUND_TYPE_MAP = {
  REFUND_PARTIAL: {
    id: "refund_partial",
    name: t("Partial Refund"),
    key: "REFUND_PARTIAL",
  },
  REFUND_FULL_WITHOUT_CHARGES: {
    id: "refund_full_without_charges",
    name: t("Full Refund"),
    key: "REFUND_FULL_WITHOUT_CHARGES",
  },
  REFUND_FULL_WITHOUT_COMPANY_CHARGES: {
    id: "refund_full_no_company_charges",
    name: t("Full Refund + Org. Fees + Commissions"),
    key: "REFUND_FULL_WITHOUT_COMPANY_CHARGES",
  },
  REFUND_FULL: {
    id: "refund_full",
    name: t(
      "Full Refund + Org. Fees + Commissions + Showpass Fees (Fees Invoiced)"
    ),
    key: "REFUND_FULL",
  },
  REFUND_FULL_COMPANY_CHARGES: {
    id: "refund_full_company_charges",
    name: t("Full Admin Refund"),
    key: "REFUND_FULL_COMPANY_CHARGES",
  },
} as const;

export const REFUND_TYPE_MAP_BY_ID = {
  refund_partial: {
    id: "refund_partial",
    name: t("Partial Refund"),
    key: "REFUND_PARTIAL",
  },
  refund_full_without_charges: {
    id: "refund_full_without_charges",
    name: t("Full Refund"),
    key: "REFUND_FULL_WITHOUT_CHARGES",
  },
  refund_full_no_company_charges: {
    id: "refund_full_no_company_charges",
    name: t("Full Refund + Org. Fees + Commissions"),
    key: "REFUND_FULL_WITHOUT_COMPANY_CHARGES",
  },
  refund_full: {
    id: "refund_full",
    name: t(
      "Full Refund + Org. Fees + Commissions + Showpass Fees (Fees Invoiced)"
    ),
    key: "REFUND_FULL",
  },
  refund_full_company_charges: {
    id: "refund_full_company_charges",
    name: t("Full Admin Refund"),
    key: "REFUND_FULL_COMPANY_CHARGES",
  },
} as const;

export const REFUND_TYPE_MAP_BY_LIST = [
  { id: "refund_partial", name: t("Partial Refund"), key: "REFUND_PARTIAL" },
  {
    id: "refund_full_without_charges",
    name: t("Full Refund"),
    key: "REFUND_FULL_WITHOUT_CHARGES",
  },
  {
    id: "refund_full_no_company_charges",
    name: t("Full Refund + Org. Fees + Commissions"),
    key: "REFUND_FULL_WITHOUT_COMPANY_CHARGES",
  },
  {
    id: "refund_full",
    name: t(
      "Full Refund + Org. Fees + Commissions + Showpass Fees (Fees Invoiced)"
    ),
    key: "REFUND_FULL",
  },
  {
    id: "refund_full_company_charges",
    name: t("Full Admin Refund"),
    key: "REFUND_FULL_COMPANY_CHARGES",
  },
] as const;

export const REFUND_REASON_MAP = {
  reason_duplicate: {
    id: "duplicate",
    name: t("Duplicate"),
    key: "reason_duplicate",
  },
  reason_fraudulent: {
    id: "fraudulent",
    name: t("Fraudulent"),
    key: "reason_fraudulent",
  },
  reason_requested_by_customer: {
    id: "requested_by_customer",
    name: t("Requested by customer"),
    key: "reason_requested_by_customer",
  },
  reason_resale: {
    id: "reason_resale",
    name: t("Resale"),
    key: "reason_resale",
  },
} as const;

export const REFUND_REASON_MAP_BY_ID = {
  duplicate: { id: "duplicate", name: t("Duplicate"), key: "reason_duplicate" },
  fraudulent: {
    id: "fraudulent",
    name: t("Fraudulent"),
    key: "reason_fraudulent",
  },
  requested_by_customer: {
    id: "requested_by_customer",
    name: t("Requested by customer"),
    key: "reason_requested_by_customer",
  },
} as const;

export const REFUND_REASON_MAP_BY_LIST = [
  { id: "duplicate", name: t("Duplicate"), key: "reason_duplicate" },
  { id: "fraudulent", name: t("Fraudulent"), key: "reason_fraudulent" },
  {
    id: "requested_by_customer",
    name: t("Requested by customer"),
    key: "reason_requested_by_customer",
  },
] as const;

export const EXCHANGE_TICKETS_VISIBILITY_MAP = {
  BOX_OFFICE_AND_PUBLIC: {
    id: "box_office_and_public",
    name: t("Box Office + Public"),
    key: "BOX_OFFICE_AND_PUBLIC",
  },
  BOX_OFFICE_ONLY: {
    id: "box_office_only",
    name: t("Box Office Only"),
    key: "BOX_OFFICE_ONLY",
  },
  PUBLIC_ONLY: {
    id: "public_only",
    name: t("Public Only"),
    key: "PUBLIC_ONLY",
  },
} as const;

export const EXCHANGE_TICKETS_VISIBILITY_MAP_BY_ID = {
  box_office_and_public: {
    id: "box_office_and_public",
    name: t("Box Office + Public"),
    key: "BOX_OFFICE_AND_PUBLIC",
  },
  box_office_only: {
    id: "box_office_only",
    name: t("Box Office Only"),
    key: "BOX_OFFICE_ONLY",
  },
  public_only: {
    id: "public_only",
    name: t("Public Only"),
    key: "PUBLIC_ONLY",
  },
} as const;

export const EXCHANGE_TICKETS_VISIBILITY_MAP_BY_LIST = [
  {
    id: "box_office_and_public",
    name: t("Box Office + Public"),
    key: "BOX_OFFICE_AND_PUBLIC",
  },
  { id: "box_office_only", name: t("Box Office Only"), key: "BOX_OFFICE_ONLY" },
  { id: "public_only", name: t("Public Only"), key: "PUBLIC_ONLY" },
] as const;

export const VENUE_THERMAL_TEMPLATES_MAP = {
  VTT_SHOWPASS: {
    id: "vtt_showpass",
    name: t("Showpass Default"),
    key: "VTT_SHOWPASS",
  },
  VTT_SHOWPASS_CENTERED: {
    id: "vtt_showpass_centered",
    name: t("Showpass Centered"),
    key: "VTT_SHOWPASS_CENTERED",
  },
  VTT_GIANTS_SEASON_TICKET: {
    id: "vtt_giants_season_ticket",
    name: t("Giants Season Tickets"),
    key: "VTT_GIANTS_SEASON_TICKET",
  },
  VTT_LEC_THERMAL_TICKETS: {
    id: "vtt_lec_thermal_tickets",
    name: t("LEC Thermal Tickets"),
    key: "VTT_LEC_THERMAL_TICKETS",
  },
  VTT_BANDIT_THERMAL_TICKETS: {
    id: "vtt_bandit_thermal_tickets",
    name: t("Bandit Thermal Tickets"),
    key: "VTT_BANDIT_THERMAL_TICKETS",
  },
  VTT_KETTLE_VALLEY_RAILWAY: {
    id: "vtt_kettle_valley_railway",
    name: t("Kettle Valley Railway"),
    key: "VTT_KETTLE_VALLEY_RAILWAY",
  },
  VTT_DAWSON_CREEK_THERMAL_TICKETS: {
    id: "vtt_dawson_creek_thermal_tickets",
    name: t("Dawson Creek"),
    key: "VTT_DAWSON_CREEK_THERMAL_TICKETS",
  },
  VTT_BUENA_VISTA_THERMAL_TICKETS: {
    id: "vtt_buena_vista_thermal_tickets",
    name: t("Buena Vista Live"),
    key: "VTT_BUENA_VISTA_THERMAL_TICKETS",
  },
  VTT_PACE_THERMAL_TICKETS: {
    id: "vtt_pace_thermal_tickets",
    name: t("PACE Thermal Tickets"),
    key: "VTT_PACE_THERMAL_TICKETS",
  },
  VTT_NORDIQUES_THERMAL_TICKETS: {
    id: "vtt_nordiques_thermal_tickets",
    name: t("Maine Nordiques Thermal Tickets"),
    key: "VTT_NORDIQUES_THERMAL_TICKETS",
  },
  VTT_HARBOUR_CATS_TICKETS: {
    id: "vtt_harbour_cats_tickets",
    name: t("Harbour Cats Baseball Tickets"),
    key: "VTT_HARBOUR_CATS_TICKETS",
  },
  VTT_HARBOUR_CATS_GAME_PACK_TICKETS: {
    id: "vtt_harbour_cats_game_pack_tickets",
    name: t("Harbour Cats Baseball Game Pack Tickets"),
    key: "VTT_HARBOUR_CATS_GAME_PACK_TICKETS",
  },
  VTT_SPRUCE_KING_THERMAL_TICKETS: {
    id: "vtt_spruce_king_thermal_tickets",
    name: t("Spruce King Thermal Tickets"),
    key: "VTT_SPRUCE_KING_THERMAL_TICKETS",
  },
  VTT_MC_MORRAN_PLACE_THERMAL_TICKETS: {
    id: "vtt_mc_morran_place_thermal_tickets",
    name: t("McMorran Place Thermal Tickets"),
    key: "VTT_MC_MORRAN_PLACE_THERMAL_TICKETS",
  },
} as const;

export const VENUE_THERMAL_TEMPLATES_MAP_BY_ID = {
  vtt_showpass: {
    id: "vtt_showpass",
    name: t("Showpass Default"),
    key: "VTT_SHOWPASS",
  },
  vtt_showpass_centered: {
    id: "vtt_showpass_centered",
    name: t("Showpass Centered"),
    key: "VTT_SHOWPASS_CENTERED",
  },
  vtt_giants_season_ticket: {
    id: "vtt_giants_season_ticket",
    name: t("Giants Season Tickets"),
    key: "VTT_GIANTS_SEASON_TICKET",
  },
  vtt_lec_thermal_tickets: {
    id: "vtt_lec_thermal_tickets",
    name: t("LEC Thermal Tickets"),
    key: "VTT_LEC_THERMAL_TICKETS",
  },
  vtt_bandit_thermal_tickets: {
    id: "vtt_bandit_thermal_tickets",
    name: t("Bandit Thermal Tickets"),
    key: "VTT_BANDIT_THERMAL_TICKETS",
  },
  vtt_kettle_valley_railway: {
    id: "vtt_kettle_valley_railway",
    name: t("Kettle Valley Railway"),
    key: "VTT_KETTLE_VALLEY_RAILWAY",
  },
  vtt_dawson_creek_thermal_tickets: {
    id: "vtt_dawson_creek_thermal_tickets",
    name: t("Dawson Creek"),
    key: "VTT_DAWSON_CREEK_THERMAL_TICKETS",
  },
  vtt_buena_vista_thermal_tickets: {
    id: "vtt_buena_vista_thermal_tickets",
    name: t("Buena Vista Live"),
    key: "VTT_BUENA_VISTA_THERMAL_TICKETS",
  },
  vtt_pace_thermal_tickets: {
    id: "vtt_pace_thermal_tickets",
    name: t("PACE Thermal Tickets"),
    key: "VTT_PACE_THERMAL_TICKETS",
  },
  vtt_nordiques_thermal_tickets: {
    id: "vtt_nordiques_thermal_tickets",
    name: t("Maine Nordiques Thermal Tickets"),
    key: "VTT_NORDIQUES_THERMAL_TICKETS",
  },
  vtt_harbour_cats_tickets: {
    id: "vtt_harbour_cats_tickets",
    name: t("Harbour Cats Baseball Tickets"),
    key: "VTT_HARBOUR_CATS_TICKETS",
  },
  vtt_harbour_cats_game_pack_tickets: {
    id: "vtt_harbour_cats_game_pack_tickets",
    name: t("Harbour Cats Baseball Game Pack Tickets"),
    key: "VTT_HARBOUR_CATS_GAME_PACK_TICKETS",
  },
  vtt_spruce_king_thermal_tickets: {
    id: "vtt_spruce_king_thermal_tickets",
    name: t("Spruce King Thermal Tickets"),
    key: "VTT_SPRUCE_KING_THERMAL_TICKETS",
  },
  vtt_mc_morran_place_thermal_tickets: {
    id: "vtt_mc_morran_place_thermal_tickets",
    name: t("McMorran Place Thermal Tickets"),
    key: "VTT_MC_MORRAN_PLACE_THERMAL_TICKETS",
  },
} as const;

export const VENUE_THERMAL_TEMPLATES_MAP_BY_LIST = [
  { id: "vtt_showpass", name: t("Showpass Default"), key: "VTT_SHOWPASS" },
  {
    id: "vtt_showpass_centered",
    name: t("Showpass Centered"),
    key: "VTT_SHOWPASS_CENTERED",
  },
  {
    id: "vtt_giants_season_ticket",
    name: t("Giants Season Tickets"),
    key: "VTT_GIANTS_SEASON_TICKET",
  },
  {
    id: "vtt_lec_thermal_tickets",
    name: t("LEC Thermal Tickets"),
    key: "VTT_LEC_THERMAL_TICKETS",
  },
  {
    id: "vtt_bandit_thermal_tickets",
    name: t("Bandit Thermal Tickets"),
    key: "VTT_BANDIT_THERMAL_TICKETS",
  },
  {
    id: "vtt_kettle_valley_railway",
    name: t("Kettle Valley Railway"),
    key: "VTT_KETTLE_VALLEY_RAILWAY",
  },
  {
    id: "vtt_dawson_creek_thermal_tickets",
    name: t("Dawson Creek"),
    key: "VTT_DAWSON_CREEK_THERMAL_TICKETS",
  },
  {
    id: "vtt_buena_vista_thermal_tickets",
    name: t("Buena Vista Live"),
    key: "VTT_BUENA_VISTA_THERMAL_TICKETS",
  },
  {
    id: "vtt_pace_thermal_tickets",
    name: t("PACE Thermal Tickets"),
    key: "VTT_PACE_THERMAL_TICKETS",
  },
  {
    id: "vtt_nordiques_thermal_tickets",
    name: t("Maine Nordiques Thermal Tickets"),
    key: "VTT_NORDIQUES_THERMAL_TICKETS",
  },
  {
    id: "vtt_harbour_cats_tickets",
    name: t("Harbour Cats Baseball Tickets"),
    key: "VTT_HARBOUR_CATS_TICKETS",
  },
  {
    id: "vtt_harbour_cats_game_pack_tickets",
    name: t("Harbour Cats Baseball Game Pack Tickets"),
    key: "VTT_HARBOUR_CATS_GAME_PACK_TICKETS",
  },
  {
    id: "vtt_spruce_king_thermal_tickets",
    name: t("Spruce King Thermal Tickets"),
    key: "VTT_SPRUCE_KING_THERMAL_TICKETS",
  },
  {
    id: "vtt_mc_morran_place_thermal_tickets",
    name: t("McMorran Place Thermal Tickets"),
    key: "VTT_MC_MORRAN_PLACE_THERMAL_TICKETS",
  },
] as const;

export const SQUARE_TERMINAL_STATUS_MAP = {
  STS_PENDING: {
    id: "sts_pending",
    name: t("Pending"),
    square_id: "PENDING",
    final_state: false,
    key: "STS_PENDING",
  },
  STS_IN_PROGRESS: {
    id: "sts_in_progress",
    name: t("In Progress"),
    square_id: "IN_PROGRESS",
    final_state: false,
    key: "STS_IN_PROGRESS",
  },
  STS_REQUIRES_INPUT: {
    id: "sts_requires_input",
    name: t("Requires Input"),
    square_id: "REQUIRES_INPUT",
    final_state: false,
    key: "STS_REQUIRES_INPUT",
  },
  STS_CANCELED: {
    id: "sts_canceled",
    name: t("Canceled"),
    square_id: "CANCELED",
    final_state: true,
    key: "STS_CANCELED",
  },
  STS_COMPLETED: {
    id: "sts_completed",
    name: t("Completed"),
    square_id: "COMPLETED",
    final_state: true,
    key: "STS_COMPLETED",
  },
  STS_FAILED: {
    id: "sts_failed",
    name: t("Failed"),
    square_id: "FAILED",
    final_state: true,
    key: "STS_FAILED",
  },
  STS_CANCEL_REQUESTED: {
    id: "sts_cancel_requested",
    name: t("Cancel Requested"),
    square_id: "CANCEL_REQUESTED",
    final_state: false,
    key: "STS_CANCEL_REQUESTED",
  },
} as const;

export const SQUARE_TERMINAL_STATUS_MAP_BY_ID = {
  sts_pending: {
    id: "sts_pending",
    name: t("Pending"),
    square_id: "PENDING",
    final_state: false,
    key: "STS_PENDING",
  },
  sts_in_progress: {
    id: "sts_in_progress",
    name: t("In Progress"),
    square_id: "IN_PROGRESS",
    final_state: false,
    key: "STS_IN_PROGRESS",
  },
  sts_requires_input: {
    id: "sts_requires_input",
    name: t("Requires Input"),
    square_id: "REQUIRES_INPUT",
    final_state: false,
    key: "STS_REQUIRES_INPUT",
  },
  sts_canceled: {
    id: "sts_canceled",
    name: t("Canceled"),
    square_id: "CANCELED",
    final_state: true,
    key: "STS_CANCELED",
  },
  sts_completed: {
    id: "sts_completed",
    name: t("Completed"),
    square_id: "COMPLETED",
    final_state: true,
    key: "STS_COMPLETED",
  },
  sts_failed: {
    id: "sts_failed",
    name: t("Failed"),
    square_id: "FAILED",
    final_state: true,
    key: "STS_FAILED",
  },
  sts_cancel_requested: {
    id: "sts_cancel_requested",
    name: t("Cancel Requested"),
    square_id: "CANCEL_REQUESTED",
    final_state: false,
    key: "STS_CANCEL_REQUESTED",
  },
} as const;

export const SQUARE_TERMINAL_STATUS_MAP_BY_LIST = [
  {
    id: "sts_pending",
    name: t("Pending"),
    square_id: "PENDING",
    final_state: false,
    key: "STS_PENDING",
  },
  {
    id: "sts_in_progress",
    name: t("In Progress"),
    square_id: "IN_PROGRESS",
    final_state: false,
    key: "STS_IN_PROGRESS",
  },
  {
    id: "sts_requires_input",
    name: t("Requires Input"),
    square_id: "REQUIRES_INPUT",
    final_state: false,
    key: "STS_REQUIRES_INPUT",
  },
  {
    id: "sts_canceled",
    name: t("Canceled"),
    square_id: "CANCELED",
    final_state: true,
    key: "STS_CANCELED",
  },
  {
    id: "sts_completed",
    name: t("Completed"),
    square_id: "COMPLETED",
    final_state: true,
    key: "STS_COMPLETED",
  },
  {
    id: "sts_failed",
    name: t("Failed"),
    square_id: "FAILED",
    final_state: true,
    key: "STS_FAILED",
  },
  {
    id: "sts_cancel_requested",
    name: t("Cancel Requested"),
    square_id: "CANCEL_REQUESTED",
    final_state: false,
    key: "STS_CANCEL_REQUESTED",
  },
] as const;

export const TICKET_PACKAGE_TYPE_MAP = {
  TPT_PRESET: { id: "tpt_preset", name: t("Preset"), key: "TPT_PRESET" },
  TPT_CUSTOM: { id: "tpt_custom", name: t("Custom"), key: "TPT_CUSTOM" },
} as const;

export const TICKET_PACKAGE_TYPE_MAP_BY_ID = {
  tpt_preset: { id: "tpt_preset", name: t("Preset"), key: "TPT_PRESET" },
  tpt_custom: { id: "tpt_custom", name: t("Custom"), key: "TPT_CUSTOM" },
} as const;

export const TICKET_PACKAGE_TYPE_MAP_BY_LIST = [
  { id: "tpt_preset", name: t("Preset"), key: "TPT_PRESET" },
  { id: "tpt_custom", name: t("Custom"), key: "TPT_CUSTOM" },
] as const;

export const DONATION_AMOUNT_MAP = {
  "0": {
    id: "zero",
    name: t("No donation"),
    amount: 0,
    amount_cents: 0,
    key: "0",
  },
  "1": { id: "one", name: t("1"), amount: 1, amount_cents: 1000, key: "1" },
  "2": { id: "two", name: t("2"), amount: 2, amount_cents: 2000, key: "2" },
  "5": { id: "five", name: t("5"), amount: 5, amount_cents: 5000, key: "5" },
  "10": { id: "ten", name: t("10"), amount: 10, amount_cents: 1000, key: "10" },
  "25": {
    id: "twentyfive",
    name: t("25"),
    amount: 25,
    amount_cents: 2500,
    key: "25",
  },
  "50": {
    id: "fifty",
    name: t("50"),
    amount: 50,
    amount_cents: 5000,
    key: "50",
  },
  "75": {
    id: "seventyfive",
    name: t("75"),
    amount: 75,
    amount_cents: 7500,
    key: "75",
  },
  "100": {
    id: "hundred",
    name: t("100"),
    amount: 100,
    amount_cents: 10000,
    key: "100",
  },
  OTHER: {
    id: "other",
    name: t("Custom amount"),
    amount: 0,
    amount_cents: 0,
    key: "OTHER",
  },
} as const;

export const DONATION_AMOUNT_MAP_BY_ID = {
  zero: {
    id: "zero",
    name: t("No donation"),
    amount: 0,
    amount_cents: 0,
    key: "0",
  },
  one: { id: "one", name: t("1"), amount: 1, amount_cents: 1000, key: "1" },
  two: { id: "two", name: t("2"), amount: 2, amount_cents: 2000, key: "2" },
  five: { id: "five", name: t("5"), amount: 5, amount_cents: 5000, key: "5" },
  ten: { id: "ten", name: t("10"), amount: 10, amount_cents: 1000, key: "10" },
  twentyfive: {
    id: "twentyfive",
    name: t("25"),
    amount: 25,
    amount_cents: 2500,
    key: "25",
  },
  fifty: {
    id: "fifty",
    name: t("50"),
    amount: 50,
    amount_cents: 5000,
    key: "50",
  },
  seventyfive: {
    id: "seventyfive",
    name: t("75"),
    amount: 75,
    amount_cents: 7500,
    key: "75",
  },
  hundred: {
    id: "hundred",
    name: t("100"),
    amount: 100,
    amount_cents: 10000,
    key: "100",
  },
  other: {
    id: "other",
    name: t("Custom amount"),
    amount: 0,
    amount_cents: 0,
    key: "OTHER",
  },
} as const;

export const DONATION_AMOUNT_MAP_BY_LIST = [
  { id: "zero", name: t("No donation"), amount: 0, amount_cents: 0, key: "0" },
  { id: "one", name: t("1"), amount: 1, amount_cents: 1000, key: "1" },
  { id: "two", name: t("2"), amount: 2, amount_cents: 2000, key: "2" },
  { id: "five", name: t("5"), amount: 5, amount_cents: 5000, key: "5" },
  { id: "ten", name: t("10"), amount: 10, amount_cents: 1000, key: "10" },
  {
    id: "twentyfive",
    name: t("25"),
    amount: 25,
    amount_cents: 2500,
    key: "25",
  },
  { id: "fifty", name: t("50"), amount: 50, amount_cents: 5000, key: "50" },
  {
    id: "seventyfive",
    name: t("75"),
    amount: 75,
    amount_cents: 7500,
    key: "75",
  },
  {
    id: "hundred",
    name: t("100"),
    amount: 100,
    amount_cents: 10000,
    key: "100",
  },
  {
    id: "other",
    name: t("Custom amount"),
    amount: 0,
    amount_cents: 0,
    key: "OTHER",
  },
] as const;

export const VOID_TYPE_MAP = {
  VOID_ALL_INVOICE_ITEM: {
    id: "void_all_invoice_item",
    name: t("Void All Invoice Items"),
    key: "VOID_ALL_INVOICE_ITEM",
  },
  VOID_SELECTED_TICKETS: {
    id: "void_selected_tickets",
    name: t("Void Selected Tickets/Members"),
    key: "VOID_SELECTED_TICKETS",
  },
} as const;

export const VOID_TYPE_MAP_BY_ID = {
  void_all_invoice_item: {
    id: "void_all_invoice_item",
    name: t("Void All Invoice Items"),
    key: "VOID_ALL_INVOICE_ITEM",
  },
  void_selected_tickets: {
    id: "void_selected_tickets",
    name: t("Void Selected Tickets/Members"),
    key: "VOID_SELECTED_TICKETS",
  },
} as const;

export const VOID_TYPE_MAP_BY_LIST = [
  {
    id: "void_all_invoice_item",
    name: t("Void All Invoice Items"),
    key: "VOID_ALL_INVOICE_ITEM",
  },
  {
    id: "void_selected_tickets",
    name: t("Void Selected Tickets/Members"),
    key: "VOID_SELECTED_TICKETS",
  },
] as const;

export const PAYMENT_PLAN_INTERVAL_MAP = {
  PP_INTERVAL_DAY: {
    id: "pp_interval_day",
    name: t("Day"),
    stripe_value: "day",
    num_of_days: 1,
    key: "PP_INTERVAL_DAY",
  },
  PP_INTERVAL_WEEK: {
    id: "pp_interval_week",
    name: t("Week"),
    stripe_value: "week",
    num_of_days: 7,
    key: "PP_INTERVAL_WEEK",
  },
  PP_INTERVAL_MONTH: {
    id: "pp_interval_month",
    name: t("Month"),
    stripe_value: "month",
    num_of_days: 30.34,
    key: "PP_INTERVAL_MONTH",
  },
  PP_INTERVAL_YEAR: {
    id: "pp_interval_year",
    name: t("Year"),
    stripe_value: "year",
    num_of_days: 365,
    key: "PP_INTERVAL_YEAR",
  },
} as const;

export const PAYMENT_PLAN_INTERVAL_MAP_BY_ID = {
  pp_interval_day: {
    id: "pp_interval_day",
    name: t("Day"),
    stripe_value: "day",
    num_of_days: 1,
    key: "PP_INTERVAL_DAY",
  },
  pp_interval_week: {
    id: "pp_interval_week",
    name: t("Week"),
    stripe_value: "week",
    num_of_days: 7,
    key: "PP_INTERVAL_WEEK",
  },
  pp_interval_month: {
    id: "pp_interval_month",
    name: t("Month"),
    stripe_value: "month",
    num_of_days: 30.34,
    key: "PP_INTERVAL_MONTH",
  },
  pp_interval_year: {
    id: "pp_interval_year",
    name: t("Year"),
    stripe_value: "year",
    num_of_days: 365,
    key: "PP_INTERVAL_YEAR",
  },
} as const;

export const PAYMENT_PLAN_INTERVAL_MAP_BY_LIST = [
  {
    id: "pp_interval_day",
    name: t("Day"),
    stripe_value: "day",
    num_of_days: 1,
    key: "PP_INTERVAL_DAY",
  },
  {
    id: "pp_interval_week",
    name: t("Week"),
    stripe_value: "week",
    num_of_days: 7,
    key: "PP_INTERVAL_WEEK",
  },
  {
    id: "pp_interval_month",
    name: t("Month"),
    stripe_value: "month",
    num_of_days: 30.34,
    key: "PP_INTERVAL_MONTH",
  },
  {
    id: "pp_interval_year",
    name: t("Year"),
    stripe_value: "year",
    num_of_days: 365,
    key: "PP_INTERVAL_YEAR",
  },
] as const;

export const PAYMENT_SCHEME_MAP = {
  PS_ONE_TIME_CHARGE: {
    id: "ps_one_time_charge",
    name: t("One Time Charge"),
    key: "PS_ONE_TIME_CHARGE",
  },
  PS_PAYMENT_PLAN: {
    id: "ps_payment_plan",
    name: t("Payment Plan"),
    key: "PS_PAYMENT_PLAN",
  },
} as const;

export const PAYMENT_SCHEME_MAP_BY_ID = {
  ps_one_time_charge: {
    id: "ps_one_time_charge",
    name: t("One Time Charge"),
    key: "PS_ONE_TIME_CHARGE",
  },
  ps_payment_plan: {
    id: "ps_payment_plan",
    name: t("Payment Plan"),
    key: "PS_PAYMENT_PLAN",
  },
} as const;

export const PAYMENT_SCHEME_MAP_BY_LIST = [
  {
    id: "ps_one_time_charge",
    name: t("One Time Charge"),
    key: "PS_ONE_TIME_CHARGE",
  },
  { id: "ps_payment_plan", name: t("Payment Plan"), key: "PS_PAYMENT_PLAN" },
] as const;

export const EVENT_STATUS_MAP = {
  ACTIVE: {
    id: "sp_event_active",
    name: t("Active"),
    purchasable: true,
    viewable: true,
    key: "ACTIVE",
  },
  POSTPONED: {
    id: "sp_event_postponed",
    name: t("Postponed"),
    purchasable: true,
    viewable: true,
    key: "POSTPONED",
  },
  CANCELLED: {
    id: "sp_event_cancelled",
    name: t("Cancelled"),
    purchasable: false,
    viewable: true,
    key: "CANCELLED",
  },
  REFUNDED: {
    id: "sp_event_refunded",
    name: t("Refunded"),
    purchasable: false,
    viewable: true,
    key: "REFUNDED",
  },
  REFUND_IN_PROGRESS: {
    id: "sp_event_refund_in_progress",
    name: t("Refund In Progress"),
    purchasable: false,
    viewable: true,
    key: "REFUND_IN_PROGRESS",
  },
  RESCHEDULED: {
    id: "sp_event_rescheduled",
    name: t("Rescheduled"),
    purchasable: true,
    viewable: true,
    key: "RESCHEDULED",
  },
  DRAFT: {
    id: "sp_event_draft",
    name: t("Draft"),
    purchasable: false,
    viewable: false,
    key: "DRAFT",
  },
  TEMPLATE: {
    id: "sp_event_template",
    name: t("Template"),
    purchasable: false,
    viewable: false,
    key: "TEMPLATE",
  },
} as const;

export const EVENT_STATUS_MAP_BY_ID = {
  sp_event_active: {
    id: "sp_event_active",
    name: t("Active"),
    purchasable: true,
    viewable: true,
    key: "ACTIVE",
  },
  sp_event_postponed: {
    id: "sp_event_postponed",
    name: t("Postponed"),
    purchasable: true,
    viewable: true,
    key: "POSTPONED",
  },
  sp_event_cancelled: {
    id: "sp_event_cancelled",
    name: t("Cancelled"),
    purchasable: false,
    viewable: true,
    key: "CANCELLED",
  },
  sp_event_refunded: {
    id: "sp_event_refunded",
    name: t("Refunded"),
    purchasable: false,
    viewable: true,
    key: "REFUNDED",
  },
  sp_event_refund_in_progress: {
    id: "sp_event_refund_in_progress",
    name: t("Refund In Progress"),
    purchasable: false,
    viewable: true,
    key: "REFUND_IN_PROGRESS",
  },
  sp_event_rescheduled: {
    id: "sp_event_rescheduled",
    name: t("Rescheduled"),
    purchasable: true,
    viewable: true,
    key: "RESCHEDULED",
  },
  sp_event_draft: {
    id: "sp_event_draft",
    name: t("Draft"),
    purchasable: false,
    viewable: false,
    key: "DRAFT",
  },
  sp_event_template: {
    id: "sp_event_template",
    name: t("Template"),
    purchasable: false,
    viewable: false,
    key: "TEMPLATE",
  },
} as const;

export const EVENT_STATUS_MAP_BY_LIST = [
  {
    id: "sp_event_active",
    name: t("Active"),
    purchasable: true,
    viewable: true,
    key: "ACTIVE",
  },
  {
    id: "sp_event_postponed",
    name: t("Postponed"),
    purchasable: true,
    viewable: true,
    key: "POSTPONED",
  },
  {
    id: "sp_event_cancelled",
    name: t("Cancelled"),
    purchasable: false,
    viewable: true,
    key: "CANCELLED",
  },
  {
    id: "sp_event_refunded",
    name: t("Refunded"),
    purchasable: false,
    viewable: true,
    key: "REFUNDED",
  },
  {
    id: "sp_event_refund_in_progress",
    name: t("Refund In Progress"),
    purchasable: false,
    viewable: true,
    key: "REFUND_IN_PROGRESS",
  },
  {
    id: "sp_event_rescheduled",
    name: t("Rescheduled"),
    purchasable: true,
    viewable: true,
    key: "RESCHEDULED",
  },
  {
    id: "sp_event_draft",
    name: t("Draft"),
    purchasable: false,
    viewable: false,
    key: "DRAFT",
  },
  {
    id: "sp_event_template",
    name: t("Template"),
    purchasable: false,
    viewable: false,
    key: "TEMPLATE",
  },
] as const;

export const DEFAULT_DRAFT_LOCATION_NAME = "Draft Location" as const;

export const DEFAULT_DRAFT_EVENT_NAME = "Draft Event" as const;

export const DEFAULT_DRAFT_TT_NAME = "General Admission" as const;

export const DEFAULT_DRAFT_TT_QUANTITY = 500 as const;

export const SLUGIFIED_DRAFT_NAME = "draft-event" as const;

export const VIRTUAL_EVENT_TYPE_MAP = {
  VIRTUAL_PRIVATE: {
    id: "oet_virtual_private",
    name: t("Virtual Private"),
    room_type: "rtm_group",
    key: "VIRTUAL_PRIVATE",
  },
  VIRTUAL_PUBLIC: {
    id: "oet_virtual_public",
    name: t("Virtual Public"),
    room_type: "rtm_group",
    key: "VIRTUAL_PUBLIC",
  },
  VIRTUAL_EXTERNAL: {
    id: "oet_virtual_external",
    name: t("Virtual External"),
    room_type: null,
    key: "VIRTUAL_EXTERNAL",
  },
  VIRTUAL_STREAM: {
    id: "oet_virtual_stream",
    name: t("Virtual Stream"),
    room_type: "rtm_live_stream",
    key: "VIRTUAL_STREAM",
  },
} as const;

export const VIRTUAL_EVENT_TYPE_MAP_BY_ID = {
  oet_virtual_private: {
    id: "oet_virtual_private",
    name: t("Virtual Private"),
    room_type: "rtm_group",
    key: "VIRTUAL_PRIVATE",
  },
  oet_virtual_public: {
    id: "oet_virtual_public",
    name: t("Virtual Public"),
    room_type: "rtm_group",
    key: "VIRTUAL_PUBLIC",
  },
  oet_virtual_external: {
    id: "oet_virtual_external",
    name: t("Virtual External"),
    room_type: null,
    key: "VIRTUAL_EXTERNAL",
  },
  oet_virtual_stream: {
    id: "oet_virtual_stream",
    name: t("Virtual Stream"),
    room_type: "rtm_live_stream",
    key: "VIRTUAL_STREAM",
  },
} as const;

export const VIRTUAL_EVENT_TYPE_MAP_BY_LIST = [
  {
    id: "oet_virtual_private",
    name: t("Virtual Private"),
    room_type: "rtm_group",
    key: "VIRTUAL_PRIVATE",
  },
  {
    id: "oet_virtual_public",
    name: t("Virtual Public"),
    room_type: "rtm_group",
    key: "VIRTUAL_PUBLIC",
  },
  {
    id: "oet_virtual_external",
    name: t("Virtual External"),
    room_type: null,
    key: "VIRTUAL_EXTERNAL",
  },
  {
    id: "oet_virtual_stream",
    name: t("Virtual Stream"),
    room_type: "rtm_live_stream",
    key: "VIRTUAL_STREAM",
  },
] as const;

export const ROOM_STATUS_MAP = {
  PENDING: {
    id: "rsm_pending",
    name: t("Pending"),
    twilio_type: null,
    key: "PENDING",
  },
  IN_PROGRESS: {
    id: "rsm_in_progress",
    name: t("In Progress"),
    twilio_type: "in-progress",
    key: "IN_PROGRESS",
  },
  FAILED: {
    id: "rsm_failed",
    name: t("Failed"),
    twilio_type: "failed",
    key: "FAILED",
  },
  COMPLETED: {
    id: "rsm_completed",
    name: t("Completed"),
    twilio_type: "completed",
    key: "COMPLETED",
  },
} as const;

export const ROOM_STATUS_MAP_BY_ID = {
  rsm_pending: {
    id: "rsm_pending",
    name: t("Pending"),
    twilio_type: null,
    key: "PENDING",
  },
  rsm_in_progress: {
    id: "rsm_in_progress",
    name: t("In Progress"),
    twilio_type: "in-progress",
    key: "IN_PROGRESS",
  },
  rsm_failed: {
    id: "rsm_failed",
    name: t("Failed"),
    twilio_type: "failed",
    key: "FAILED",
  },
  rsm_completed: {
    id: "rsm_completed",
    name: t("Completed"),
    twilio_type: "completed",
    key: "COMPLETED",
  },
} as const;

export const ROOM_STATUS_MAP_BY_LIST = [
  { id: "rsm_pending", name: t("Pending"), twilio_type: null, key: "PENDING" },
  {
    id: "rsm_in_progress",
    name: t("In Progress"),
    twilio_type: "in-progress",
    key: "IN_PROGRESS",
  },
  { id: "rsm_failed", name: t("Failed"), twilio_type: "failed", key: "FAILED" },
  {
    id: "rsm_completed",
    name: t("Completed"),
    twilio_type: "completed",
    key: "COMPLETED",
  },
] as const;

export const ROOM_TYPE_MAP = {
  SESSION: {
    id: "rtm_group",
    name: t("Interactive Session"),
    twilio_type: "group",
    key: "SESSION",
  },
  LIVE_STREAM: {
    id: "rtm_live_stream",
    name: t("Live Stream"),
    key: "LIVE_STREAM",
  },
} as const;

export const ROOM_TYPE_MAP_BY_ID = {
  rtm_group: {
    id: "rtm_group",
    name: t("Interactive Session"),
    twilio_type: "group",
    key: "SESSION",
  },
  rtm_live_stream: {
    id: "rtm_live_stream",
    name: t("Live Stream"),
    key: "LIVE_STREAM",
  },
} as const;

export const ROOM_TYPE_MAP_BY_LIST = [
  {
    id: "rtm_group",
    name: t("Interactive Session"),
    twilio_type: "group",
    key: "SESSION",
  },
  { id: "rtm_live_stream", name: t("Live Stream"), key: "LIVE_STREAM" },
] as const;

export const STREAMING_PROVIDER_MAP = {
  VIMEO: { id: "sptm_vimeo", name: t("Vimeo - player.vimeo.com/video/ID") },
  VIMEO_EMBED: {
    id: "sptm_vimeo_embed",
    name: t("Vimeo - vimeo.com/event/ID/embed"),
  },
  WOWZA: { id: "sptm_wowza", name: t("Wowza") },
  CASTR: { id: "sptm_castr", name: t("Castr.io") },
  LIVESTREAM: { id: "sptm_livestream", name: t("Livestream.com") },
} as const;

export const STREAMING_PROVIDER_MAP_BY_ID = {
  sptm_vimeo: {
    id: "sptm_vimeo",
    name: t("Vimeo - player.vimeo.com/video/ID"),
  },
  sptm_vimeo_embed: {
    id: "sptm_vimeo_embed",
    name: t("Vimeo - vimeo.com/event/ID/embed"),
  },
  sptm_wowza: { id: "sptm_wowza", name: t("Wowza") },
  sptm_castr: { id: "sptm_castr", name: t("Castr.io") },
  sptm_livestream: { id: "sptm_livestream", name: t("Livestream.com") },
} as const;

export const STREAMING_PROVIDER_MAP_BY_LIST = [
  { id: "sptm_vimeo", name: t("Vimeo - player.vimeo.com/video/ID") },
  { id: "sptm_vimeo_embed", name: t("Vimeo - vimeo.com/event/ID/embed") },
  { id: "sptm_wowza", name: t("Wowza") },
  { id: "sptm_castr", name: t("Castr.io") },
  { id: "sptm_livestream", name: t("Livestream.com") },
] as const;

export const PARTICIPANT_ROLE_MAP = {
  HOST: { id: "prtm_host", name: t("Host"), key: "HOST" },
  PURCHASER: { id: "prtm_purchaser", name: t("Purchaser"), key: "PURCHASER" },
  GUEST: { id: "prtm_guest", name: t("Invited Guest"), key: "GUEST" },
  SUPERVISOR: {
    id: "prtm_supervisor",
    name: t("Supervisor"),
    key: "SUPERVISOR",
  },
} as const;

export const PARTICIPANT_ROLE_MAP_BY_ID = {
  prtm_host: { id: "prtm_host", name: t("Host"), key: "HOST" },
  prtm_purchaser: {
    id: "prtm_purchaser",
    name: t("Purchaser"),
    key: "PURCHASER",
  },
  prtm_guest: { id: "prtm_guest", name: t("Invited Guest"), key: "GUEST" },
  prtm_supervisor: {
    id: "prtm_supervisor",
    name: t("Supervisor"),
    key: "SUPERVISOR",
  },
} as const;

export const PARTICIPANT_ROLE_MAP_BY_LIST = [
  { id: "prtm_host", name: t("Host"), key: "HOST" },
  { id: "prtm_purchaser", name: t("Purchaser"), key: "PURCHASER" },
  { id: "prtm_guest", name: t("Invited Guest"), key: "GUEST" },
  { id: "prtm_supervisor", name: t("Supervisor"), key: "SUPERVISOR" },
] as const;

export const PARTICIPANT_INVITATION_STATE_MAP = {
  PENDING: { id: "pism_pending", name: t("Pending"), key: "PENDING" },
  CANCELLED: { id: "pism_cancelled", name: t("Cancelled"), key: "CANCELLED" },
  ACCEPTED: { id: "pism_accepted", name: t("Accepted"), key: "ACCEPTED" },
} as const;

export const PARTICIPANT_INVITATION_STATE_MAP_BY_ID = {
  pism_pending: { id: "pism_pending", name: t("Pending"), key: "PENDING" },
  pism_cancelled: {
    id: "pism_cancelled",
    name: t("Cancelled"),
    key: "CANCELLED",
  },
  pism_accepted: { id: "pism_accepted", name: t("Accepted"), key: "ACCEPTED" },
} as const;

export const PARTICIPANT_INVITATION_STATE_MAP_BY_LIST = [
  { id: "pism_pending", name: t("Pending"), key: "PENDING" },
  { id: "pism_cancelled", name: t("Cancelled"), key: "CANCELLED" },
  { id: "pism_accepted", name: t("Accepted"), key: "ACCEPTED" },
] as const;

export const USER_REFERRAL_CREDIT_AMOUNT = 5 as const;

export const VENUE_INTERNAL_FEE_TYPE_MAP = {
  COMPANY_FEE: {
    id: "company_fee",
    name: t("Showpass Fee"),
    key: "COMPANY_FEE",
  },
  PAYMENT_PROCESSING_FEE: {
    id: "payment_processing_fee",
    name: t("Payment Processing Fee"),
    key: "PAYMENT_PROCESSING_FEE",
  },
  FEE_TAX: { id: "fee_tax", name: t("Fee Tax"), key: "FEE_TAX" },
  DISCOVERY_FEE: {
    id: "discovery_fee",
    name: t("Discovery Fee"),
    key: "DISCOVERY_FEE",
  },
  RESALE_FEE: { id: "resale_fee", name: t("Resale Fee"), key: "RESALE_FEE" },
} as const;

export const VENUE_INTERNAL_FEE_TYPE_MAP_BY_ID = {
  company_fee: {
    id: "company_fee",
    name: t("Showpass Fee"),
    key: "COMPANY_FEE",
  },
  payment_processing_fee: {
    id: "payment_processing_fee",
    name: t("Payment Processing Fee"),
    key: "PAYMENT_PROCESSING_FEE",
  },
  fee_tax: { id: "fee_tax", name: t("Fee Tax"), key: "FEE_TAX" },
  discovery_fee: {
    id: "discovery_fee",
    name: t("Discovery Fee"),
    key: "DISCOVERY_FEE",
  },
  resale_fee: { id: "resale_fee", name: t("Resale Fee"), key: "RESALE_FEE" },
} as const;

export const VENUE_INTERNAL_FEE_TYPE_MAP_BY_LIST = [
  { id: "company_fee", name: t("Showpass Fee"), key: "COMPANY_FEE" },
  {
    id: "payment_processing_fee",
    name: t("Payment Processing Fee"),
    key: "PAYMENT_PROCESSING_FEE",
  },
  { id: "fee_tax", name: t("Fee Tax"), key: "FEE_TAX" },
  { id: "discovery_fee", name: t("Discovery Fee"), key: "DISCOVERY_FEE" },
  { id: "resale_fee", name: t("Resale Fee"), key: "RESALE_FEE" },
] as const;

export const FEE_TAX_TYPE = {
  COMPANY_FEE_TAX: {
    id: "company_fee_tax",
    name: t("Company Fee Tax"),
    reporting_name: "Showpass Fees",
    key: "COMPANY_FEE_TAX",
  },
  PROCESSING_FEE_TAX: {
    id: "processing_fee_tax",
    name: t("Processing Fee Tax"),
    reporting_name: "Processing Fees",
    key: "PROCESSING_FEE_TAX",
  },
  DISCOVERY_FEE_TAX: {
    id: "discovery_fee_tax",
    name: t("Discovery Fee Tax"),
    reporting_name: "Discovery Fees",
    key: "DISCOVERY_FEE_TAX",
  },
  RESALE_FEE_TAX: {
    id: "resale_fee_tax",
    name: t("Resale Fee Tax"),
    reporting_name: "Resale Fees",
    key: "RESALE_FEE_TAX",
  },
} as const;

export const FEE_TAX_TYPE_BY_ID = {
  company_fee_tax: {
    id: "company_fee_tax",
    name: t("Company Fee Tax"),
    reporting_name: "Showpass Fees",
    key: "COMPANY_FEE_TAX",
  },
  processing_fee_tax: {
    id: "processing_fee_tax",
    name: t("Processing Fee Tax"),
    reporting_name: "Processing Fees",
    key: "PROCESSING_FEE_TAX",
  },
  discovery_fee_tax: {
    id: "discovery_fee_tax",
    name: t("Discovery Fee Tax"),
    reporting_name: "Discovery Fees",
    key: "DISCOVERY_FEE_TAX",
  },
  resale_fee_tax: {
    id: "resale_fee_tax",
    name: t("Resale Fee Tax"),
    reporting_name: "Resale Fees",
    key: "RESALE_FEE_TAX",
  },
} as const;

export const FEE_TAX_TYPE_BY_LIST = [
  {
    id: "company_fee_tax",
    name: t("Company Fee Tax"),
    reporting_name: "Showpass Fees",
    key: "COMPANY_FEE_TAX",
  },
  {
    id: "processing_fee_tax",
    name: t("Processing Fee Tax"),
    reporting_name: "Processing Fees",
    key: "PROCESSING_FEE_TAX",
  },
  {
    id: "discovery_fee_tax",
    name: t("Discovery Fee Tax"),
    reporting_name: "Discovery Fees",
    key: "DISCOVERY_FEE_TAX",
  },
  {
    id: "resale_fee_tax",
    name: t("Resale Fee Tax"),
    reporting_name: "Resale Fees",
    key: "RESALE_FEE_TAX",
  },
] as const;

export const VENUE_CUSTOM_FEE_TYPE_MAP = {
  FEE: { id: "fee", name: t("Fee"), key: "FEE" },
  TAX: { id: "tax", name: t("Tax"), key: "TAX" },
  PROCESSING: { id: "processing", name: t("Processing"), key: "PROCESSING" },
} as const;

export const VENUE_CUSTOM_FEE_TYPE_MAP_BY_ID = {
  fee: { id: "fee", name: t("Fee"), key: "FEE" },
  tax: { id: "tax", name: t("Tax"), key: "TAX" },
  processing: { id: "processing", name: t("Processing"), key: "PROCESSING" },
} as const;

export const VENUE_CUSTOM_FEE_TYPE_MAP_BY_LIST = [
  { id: "fee", name: t("Fee"), key: "FEE" },
  { id: "tax", name: t("Tax"), key: "TAX" },
  { id: "processing", name: t("Processing"), key: "PROCESSING" },
] as const;

export const VENUE_CUSTOM_FEE_PAYMENT_TYPE_MAP = {
  CASH: { id: "cash", name: t("Cash"), key: "CASH" },
  CARD: { id: "card", name: t("Card"), key: "CARD" },
  OTHER: { id: "other", name: t("Other"), key: "OTHER" },
} as const;

export const VENUE_CUSTOM_FEE_PAYMENT_TYPE_MAP_BY_ID = {
  cash: { id: "cash", name: t("Cash"), key: "CASH" },
  card: { id: "card", name: t("Card"), key: "CARD" },
  other: { id: "other", name: t("Other"), key: "OTHER" },
} as const;

export const VENUE_CUSTOM_FEE_PAYMENT_TYPE_MAP_BY_LIST = [
  { id: "cash", name: t("Cash"), key: "CASH" },
  { id: "card", name: t("Card"), key: "CARD" },
  { id: "other", name: t("Other"), key: "OTHER" },
] as const;

export const VENUE_CUSTOM_FEE_PURCHASE_PLATFORM_MAP = {
  ONLINE: { id: "online", name: t("Online"), key: "ONLINE" },
  IN_PERSON: { id: "in_person", name: t("In-Person"), key: "IN_PERSON" },
} as const;

export const VENUE_CUSTOM_FEE_PURCHASE_PLATFORM_MAP_BY_ID = {
  online: { id: "online", name: t("Online"), key: "ONLINE" },
  in_person: { id: "in_person", name: t("In-Person"), key: "IN_PERSON" },
} as const;

export const VENUE_CUSTOM_FEE_PURCHASE_PLATFORM_MAP_BY_LIST = [
  { id: "online", name: t("Online"), key: "ONLINE" },
  { id: "in_person", name: t("In-Person"), key: "IN_PERSON" },
] as const;

export const VENUE_FEE_STRUCTURE = {
  CONFIGURED_FEE_STRUCTURE: {
    id: "configured_fee_structure",
    name: t("Configured Fee Structure"),
    key: "CONFIGURED_FEE_STRUCTURE",
  },
} as const;

export const VENUE_FEE_STRUCTURE_BY_ID = {
  configured_fee_structure: {
    id: "configured_fee_structure",
    name: t("Configured Fee Structure"),
    key: "CONFIGURED_FEE_STRUCTURE",
  },
} as const;

export const VENUE_FEE_STRUCTURE_BY_LIST = [
  {
    id: "configured_fee_structure",
    name: t("Configured Fee Structure"),
    key: "CONFIGURED_FEE_STRUCTURE",
  },
] as const;

export const BARCODE_DELIVERY_TYPE_MAP = {
  DEFAULT: {
    id: "default",
    name: t("Default"),
    flags_disabled: [],
    key: "DEFAULT",
  },
  CUSTOMER_ACTIVATION: {
    id: "customer_activation",
    name: t("Customer Activation"),
    flags_disabled: ["reminder_emails"],
    key: "CUSTOMER_ACTIVATION",
  },
  DELAYED_ACTIVATION: {
    id: "delayed_activation",
    name: t("Delayed Activation"),
    flags_disabled: ["reminder_emails"],
    key: "DELAYED_ACTIVATION",
  },
} as const;

export const BARCODE_DELIVERY_TYPE_MAP_BY_ID = {
  default: {
    id: "default",
    name: t("Default"),
    flags_disabled: [],
    key: "DEFAULT",
  },
  customer_activation: {
    id: "customer_activation",
    name: t("Customer Activation"),
    flags_disabled: ["reminder_emails"],
    key: "CUSTOMER_ACTIVATION",
  },
  delayed_activation: {
    id: "delayed_activation",
    name: t("Delayed Activation"),
    flags_disabled: ["reminder_emails"],
    key: "DELAYED_ACTIVATION",
  },
} as const;

export const BARCODE_DELIVERY_TYPE_MAP_BY_LIST = [
  { id: "default", name: t("Default"), flags_disabled: [], key: "DEFAULT" },
  {
    id: "customer_activation",
    name: t("Customer Activation"),
    flags_disabled: ["reminder_emails"],
    key: "CUSTOMER_ACTIVATION",
  },
  {
    id: "delayed_activation",
    name: t("Delayed Activation"),
    flags_disabled: ["reminder_emails"],
    key: "DELAYED_ACTIVATION",
  },
] as const;

export const VENUE_INTERNAL_PAYMENT_TYPE_TO_CUSTOM_MAP = {
  "1": "cash",
  "2": "card",
  "3": "card",
  "4": "not_applicable",
  "5": "not_applicable",
  "6": "not_applicable",
  "9": "other",
  "10": "card",
  "11": "card",
  "12": "card",
  "13": "card",
  "14": "card",
  "15": "not_applicable",
} as const;

export const VENUE_INTERNAL_PSP_TO_CUSTOM_MAP = {
  psp_web: "online",
  psp_web_box_office: "in_person",
  psp_desktop_box_office: "in_person",
  psp_mobile_box_office: "in_person",
  psp_mobile: "online",
  psp_widget: "online",
  psp_facebook: "online",
  psp_google_reserve: "online",
  psp_qpos: "in_person",
  psp_square_qpos: "in_person",
  psp_square_terminal: "in_person",
  psp_square_terminal_oauth: "in_person",
  psp_square_qpos_oauth: "in_person",
  psp_square_kiosk: "in_person",
  psp_square_terminal_desktop: "in_person",
  psp_square_terminal_oauth_mobile: "in_person",
  psp_unknown: "not_applicable",
  psp_auto_generated: "not_applicable",
} as const;

export const MINIMUM_REFERRAL_PURCHASE = 10 as const;

export const EXTERNAL_CONTENT_PROVIDERS = {
  MOCK_PROVIDER: {
    id: "ex_mock_provider",
    name: t("Mock Provider"),
    allowed_content: ["ex_content_subscription", "ex_content_voucher"],
    key: "MOCK_PROVIDER",
  },
  CINESEND: {
    id: "ex_provider_cinesend",
    name: t("Cinesend"),
    allowed_content: ["ex_content_subscription", "ex_content_voucher"],
    key: "CINESEND",
  },
} as const;

export const EXTERNAL_CONTENT_PROVIDERS_BY_ID = {
  ex_mock_provider: {
    id: "ex_mock_provider",
    name: t("Mock Provider"),
    allowed_content: ["ex_content_subscription", "ex_content_voucher"],
    key: "MOCK_PROVIDER",
  },
  ex_provider_cinesend: {
    id: "ex_provider_cinesend",
    name: t("Cinesend"),
    allowed_content: ["ex_content_subscription", "ex_content_voucher"],
    key: "CINESEND",
  },
} as const;

export const EXTERNAL_CONTENT_PROVIDERS_BY_LIST = [
  {
    id: "ex_mock_provider",
    name: t("Mock Provider"),
    allowed_content: ["ex_content_subscription", "ex_content_voucher"],
    key: "MOCK_PROVIDER",
  },
  {
    id: "ex_provider_cinesend",
    name: t("Cinesend"),
    allowed_content: ["ex_content_subscription", "ex_content_voucher"],
    key: "CINESEND",
  },
] as const;

export const EXTERNAL_CONTENT_TYPES = {
  EX_SUBSCRIPTION: {
    id: "ex_content_subscription",
    name: t("Subscription"),
    key: "EX_SUBSCRIPTION",
  },
  EX_VOUCHER: {
    id: "ex_content_voucher",
    name: t("Voucher"),
    key: "EX_VOUCHER",
  },
} as const;

export const EXTERNAL_CONTENT_TYPES_BY_ID = {
  ex_content_subscription: {
    id: "ex_content_subscription",
    name: t("Subscription"),
    key: "EX_SUBSCRIPTION",
  },
  ex_content_voucher: {
    id: "ex_content_voucher",
    name: t("Voucher"),
    key: "EX_VOUCHER",
  },
} as const;

export const EXTERNAL_CONTENT_TYPES_BY_LIST = [
  {
    id: "ex_content_subscription",
    name: t("Subscription"),
    key: "EX_SUBSCRIPTION",
  },
  { id: "ex_content_voucher", name: t("Voucher"), key: "EX_VOUCHER" },
] as const;

export const SHOWPASS_CREDIT_TYPES = {
  VENUE_CREDIT: {
    id: "venue_credit",
    webhook_id: "venue_credit",
    name: t("Venue Credit"),
    key: "VENUE_CREDIT",
  },
  USER_CREDIT: {
    id: "user_credit",
    webhook_id: "user_credit",
    name: t("User Credit"),
    key: "USER_CREDIT",
  },
  REFERRAL_CREDIT: {
    id: "referral_credit",
    webhook_id: "referral_credit",
    name: t("Referral Credit"),
    key: "REFERRAL_CREDIT",
  },
  EXCHANGE_CREDIT: {
    id: "exchange_credit",
    webhook_id: "exchange_credit",
    name: t("Exchange Credit"),
    key: "EXCHANGE_CREDIT",
  },
  GIFT_CARD_CREDIT: {
    id: "gift_card_credit",
    webhook_id: "gift_card_credit",
    name: t("Gift Card Credit"),
    key: "GIFT_CARD_CREDIT",
  },
} as const;

export const SHOWPASS_CREDIT_TYPES_BY_ID = {
  venue_credit: {
    id: "venue_credit",
    webhook_id: "venue_credit",
    name: t("Venue Credit"),
    key: "VENUE_CREDIT",
  },
  user_credit: {
    id: "user_credit",
    webhook_id: "user_credit",
    name: t("User Credit"),
    key: "USER_CREDIT",
  },
  referral_credit: {
    id: "referral_credit",
    webhook_id: "referral_credit",
    name: t("Referral Credit"),
    key: "REFERRAL_CREDIT",
  },
  exchange_credit: {
    id: "exchange_credit",
    webhook_id: "exchange_credit",
    name: t("Exchange Credit"),
    key: "EXCHANGE_CREDIT",
  },
  gift_card_credit: {
    id: "gift_card_credit",
    webhook_id: "gift_card_credit",
    name: t("Gift Card Credit"),
    key: "GIFT_CARD_CREDIT",
  },
} as const;

export const SHOWPASS_CREDIT_TYPES_BY_LIST = [
  {
    id: "venue_credit",
    webhook_id: "venue_credit",
    name: t("Venue Credit"),
    key: "VENUE_CREDIT",
  },
  {
    id: "user_credit",
    webhook_id: "user_credit",
    name: t("User Credit"),
    key: "USER_CREDIT",
  },
  {
    id: "referral_credit",
    webhook_id: "referral_credit",
    name: t("Referral Credit"),
    key: "REFERRAL_CREDIT",
  },
  {
    id: "exchange_credit",
    webhook_id: "exchange_credit",
    name: t("Exchange Credit"),
    key: "EXCHANGE_CREDIT",
  },
  {
    id: "gift_card_credit",
    webhook_id: "gift_card_credit",
    name: t("Gift Card Credit"),
    key: "GIFT_CARD_CREDIT",
  },
] as const;

export const PRODUCT_PERMISSION_MAP = {
  ALLOW_ALL_PRODUCT: {
    id: "allow_all",
    name: t("Include for all items"),
    description: "Products that can be applied to all items at checkout",
    key: "ALLOW_ALL_PRODUCT",
  },
  INCLUDE_PRODUCT: {
    id: "include",
    name: t("Include for certain items"),
    description: "Products that can be included for selected items",
    key: "INCLUDE_PRODUCT",
  },
  EXCLUDE_PRODUCT: {
    id: "exclude",
    name: t("Exclude for certain items"),
    description: "Products excluded for selected items",
    key: "EXCLUDE_PRODUCT",
  },
} as const;

export const PRODUCT_PERMISSION_MAP_BY_ID = {
  allow_all: {
    id: "allow_all",
    name: t("Include for all items"),
    description: "Products that can be applied to all items at checkout",
    key: "ALLOW_ALL_PRODUCT",
  },
  include: {
    id: "include",
    name: t("Include for certain items"),
    description: "Products that can be included for selected items",
    key: "INCLUDE_PRODUCT",
  },
  exclude: {
    id: "exclude",
    name: t("Exclude for certain items"),
    description: "Products excluded for selected items",
    key: "EXCLUDE_PRODUCT",
  },
} as const;

export const PRODUCT_PERMISSION_MAP_BY_LIST = [
  {
    id: "allow_all",
    name: t("Include for all items"),
    description: "Products that can be applied to all items at checkout",
    key: "ALLOW_ALL_PRODUCT",
  },
  {
    id: "include",
    name: t("Include for certain items"),
    description: "Products that can be included for selected items",
    key: "INCLUDE_PRODUCT",
  },
  {
    id: "exclude",
    name: t("Exclude for certain items"),
    description: "Products excluded for selected items",
    key: "EXCLUDE_PRODUCT",
  },
] as const;

export const SQUARE_DEVICE_PAIRING_STATUS_MAP = {
  UNKNOWN: { id: "unknown", name: t("Unknown"), key: "UNKNOWN" },
  UNPAIRED: { id: "unpaired", name: t("Unpaired"), key: "UNPAIRED" },
  PAIRED: { id: "paired", name: t("Paired"), key: "PAIRED" },
  EXPIRED: { id: "expired", name: t("Expired"), key: "EXPIRED" },
} as const;

export const SQUARE_DEVICE_PAIRING_STATUS_MAP_BY_ID = {
  unknown: { id: "unknown", name: t("Unknown"), key: "UNKNOWN" },
  unpaired: { id: "unpaired", name: t("Unpaired"), key: "UNPAIRED" },
  paired: { id: "paired", name: t("Paired"), key: "PAIRED" },
  expired: { id: "expired", name: t("Expired"), key: "EXPIRED" },
} as const;

export const SQUARE_DEVICE_PAIRING_STATUS_MAP_BY_LIST = [
  { id: "unknown", name: t("Unknown"), key: "UNKNOWN" },
  { id: "unpaired", name: t("Unpaired"), key: "UNPAIRED" },
  { id: "paired", name: t("Paired"), key: "PAIRED" },
  { id: "expired", name: t("Expired"), key: "EXPIRED" },
] as const;

export const FULL_SITE_URL = "https://www.showpass.com" as const;

export const FEE_TYPE_MAP = {
  PROCESSING_FEE: {
    id: "processing_fee",
    name: t("Processing Fee Calculation"),
    input_name: "processing_fee_inputs",
    acceptable_inputs: [
      "post_discount_amount",
      "shipping_cost",
      "organizer_fees",
      "taxes",
      "company_fees",
    ],
    key: "PROCESSING_FEE",
  },
  COMPANY_FEE: {
    id: "company_fee",
    name: t("Showpass Fee Calculation"),
    input_name: "company_fee_inputs",
    acceptable_inputs: [
      "post_discount_amount",
      "pre_discount_amount",
      "shipping_cost",
      "organizer_fees",
      "taxes",
    ],
    key: "COMPANY_FEE",
  },
  ORGANIZER_FEE: {
    id: "organizer_fee",
    name: t("Organizer Fee Calculation"),
    input_name: "organizer_fee_inputs",
    acceptable_inputs: ["post_discount_amount", "pre_discount_amount"],
    key: "ORGANIZER_FEE",
  },
} as const;

export const FEE_TYPE_MAP_BY_ID = {
  processing_fee: {
    id: "processing_fee",
    name: t("Processing Fee Calculation"),
    input_name: "processing_fee_inputs",
    acceptable_inputs: [
      "post_discount_amount",
      "shipping_cost",
      "organizer_fees",
      "taxes",
      "company_fees",
    ],
    key: "PROCESSING_FEE",
  },
  company_fee: {
    id: "company_fee",
    name: t("Showpass Fee Calculation"),
    input_name: "company_fee_inputs",
    acceptable_inputs: [
      "post_discount_amount",
      "pre_discount_amount",
      "shipping_cost",
      "organizer_fees",
      "taxes",
    ],
    key: "COMPANY_FEE",
  },
  organizer_fee: {
    id: "organizer_fee",
    name: t("Organizer Fee Calculation"),
    input_name: "organizer_fee_inputs",
    acceptable_inputs: ["post_discount_amount", "pre_discount_amount"],
    key: "ORGANIZER_FEE",
  },
} as const;

export const FEE_TYPE_MAP_BY_LIST = [
  {
    id: "processing_fee",
    name: t("Processing Fee Calculation"),
    input_name: "processing_fee_inputs",
    acceptable_inputs: [
      "post_discount_amount",
      "shipping_cost",
      "organizer_fees",
      "taxes",
      "company_fees",
    ],
    key: "PROCESSING_FEE",
  },
  {
    id: "company_fee",
    name: t("Showpass Fee Calculation"),
    input_name: "company_fee_inputs",
    acceptable_inputs: [
      "post_discount_amount",
      "pre_discount_amount",
      "shipping_cost",
      "organizer_fees",
      "taxes",
    ],
    key: "COMPANY_FEE",
  },
  {
    id: "organizer_fee",
    name: t("Organizer Fee Calculation"),
    input_name: "organizer_fee_inputs",
    acceptable_inputs: ["post_discount_amount", "pre_discount_amount"],
    key: "ORGANIZER_FEE",
  },
] as const;

export const FEE_CALCULATION_INPUT_MAP = {
  POST_DISCOUNT_AMOUNT: {
    id: "post_discount_amount",
    name: t("Post-discount Amount Less Absorbed Taxes"),
    multiple: false,
    key: "POST_DISCOUNT_AMOUNT",
  },
  PRE_DISCOUNT_AMOUNT: {
    id: "pre_discount_amount",
    name: t("Pre-Discount Amount"),
    multiple: false,
    key: "PRE_DISCOUNT_AMOUNT",
  },
  SHIPPING_COST: {
    id: "shipping_cost",
    name: t("Shipping Cost"),
    multiple: true,
    key: "SHIPPING_COST",
  },
  ORGANIZER_FEES: {
    id: "organizer_fees",
    name: t("Organizer Fees"),
    multiple: true,
    key: "ORGANIZER_FEES",
  },
  TAXES: { id: "taxes", name: t("Taxes"), multiple: true, key: "TAXES" },
  COMPANY_FEES: {
    id: "company_fees",
    name: t("Showpass Fees"),
    multiple: true,
    key: "COMPANY_FEES",
  },
} as const;

export const FEE_CALCULATION_INPUT_MAP_BY_ID = {
  post_discount_amount: {
    id: "post_discount_amount",
    name: t("Post-discount Amount Less Absorbed Taxes"),
    multiple: false,
    key: "POST_DISCOUNT_AMOUNT",
  },
  pre_discount_amount: {
    id: "pre_discount_amount",
    name: t("Pre-Discount Amount"),
    multiple: false,
    key: "PRE_DISCOUNT_AMOUNT",
  },
  shipping_cost: {
    id: "shipping_cost",
    name: t("Shipping Cost"),
    multiple: true,
    key: "SHIPPING_COST",
  },
  organizer_fees: {
    id: "organizer_fees",
    name: t("Organizer Fees"),
    multiple: true,
    key: "ORGANIZER_FEES",
  },
  taxes: { id: "taxes", name: t("Taxes"), multiple: true, key: "TAXES" },
  company_fees: {
    id: "company_fees",
    name: t("Showpass Fees"),
    multiple: true,
    key: "COMPANY_FEES",
  },
} as const;

export const FEE_CALCULATION_INPUT_MAP_BY_LIST = [
  {
    id: "post_discount_amount",
    name: t("Post-discount Amount Less Absorbed Taxes"),
    multiple: false,
    key: "POST_DISCOUNT_AMOUNT",
  },
  {
    id: "pre_discount_amount",
    name: t("Pre-Discount Amount"),
    multiple: false,
    key: "PRE_DISCOUNT_AMOUNT",
  },
  {
    id: "shipping_cost",
    name: t("Shipping Cost"),
    multiple: true,
    key: "SHIPPING_COST",
  },
  {
    id: "organizer_fees",
    name: t("Organizer Fees"),
    multiple: true,
    key: "ORGANIZER_FEES",
  },
  { id: "taxes", name: t("Taxes"), multiple: true, key: "TAXES" },
  {
    id: "company_fees",
    name: t("Showpass Fees"),
    multiple: true,
    key: "COMPANY_FEES",
  },
] as const;

export const EVENT_CATEGORIES_MAP = {
  ARTS_AND_THEATRES: {
    id: "arts_and_theatres",
    name: t("Arts & Theatres"),
    key: "ARTS_AND_THEATRES",
  },
  AUTOMOTIVE_BOATS_AIR: {
    id: "automotive_boats_air",
    name: t("Automotive, Boats, Air"),
    key: "AUTOMOTIVE_BOATS_AIR",
  },
  BUSINESS_AND_PROFESSIONAL: {
    id: "business_and_professional",
    name: t("Business & Professional"),
    key: "BUSINESS_AND_PROFESSIONAL",
  },
  CHARITY_AND_CAUSES: {
    id: "charity_and_causes",
    name: t("Charity & Causes"),
    key: "CHARITY_AND_CAUSES",
  },
  COMMUNITY_AND_CULTURE: {
    id: "community_and_culture",
    name: t("Community & Culture"),
    key: "COMMUNITY_AND_CULTURE",
  },
  COMEDY: { id: "comedy", name: t("Comedy"), key: "COMEDY" },
  EDUCATION: { id: "education", name: t("Education"), key: "EDUCATION" },
  FAIRS_AND_FESTIVALS: {
    id: "fairs_and_festivals",
    name: t("Fairs & Festivals"),
    key: "FAIRS_AND_FESTIVALS",
  },
  FAMILY_FRIENDLY: {
    id: "family_friendly",
    name: t("Family Friendly"),
    key: "FAMILY_FRIENDLY",
  },
  FASHION_AND_BEAUTY: {
    id: "fashion_and_beauty",
    name: t("Fashion & Beauty"),
    key: "FASHION_AND_BEAUTY",
  },
  FILM_MEDIA_AND_ENTERTAINMENT: {
    id: "film_media_and_entertainment",
    name: t("Film, Media, & Entertainment"),
    key: "FILM_MEDIA_AND_ENTERTAINMENT",
  },
  FOOD_AND_BEVERAGE: {
    id: "food_and_beverage",
    name: t("Food & Beverage"),
    key: "FOOD_AND_BEVERAGE",
  },
  GOVERNMENT_AND_POLITICS: {
    id: "government_and_politics",
    name: t("Government & Politics"),
    key: "GOVERNMENT_AND_POLITICS",
  },
  HEALTH_AND_WELLNESS: {
    id: "health_and_wellness",
    name: t("Health & Wellness"),
    key: "HEALTH_AND_WELLNESS",
  },
  HOBBIES_AND_SPECIAL_INTERESTS: {
    id: "hobbies_and_special_interests",
    name: t("Hobbies & Special Interests"),
    key: "HOBBIES_AND_SPECIAL_INTERESTS",
  },
  HOME_AND_LIFESTYLE: {
    id: "home_and_lifestyle",
    name: t("Home & Lifestyle"),
    key: "HOME_AND_LIFESTYLE",
  },
  MUSIC: { id: "music", name: t("Music"), key: "MUSIC" },
  OTHER: { id: "other", name: t("Other"), key: "OTHER" },
  RACING: { id: "racing", name: t("Racing"), key: "RACING" },
  RELIGION_AND_SPIRITUALITY: {
    id: "religion_and_spirituality",
    name: t("Religion & Spirituality"),
    key: "RELIGION_AND_SPIRITUALITY",
  },
  SCHOOL_ACTIVITIES: {
    id: "school_activities",
    name: t("School Activities"),
    key: "SCHOOL_ACTIVITIES",
  },
  SCIENCE_AND_TECHNOLOGY: {
    id: "science_and_technology",
    name: t("Science & Technology"),
    key: "SCIENCE_AND_TECHNOLOGY",
  },
  SEASONAL_AND_HOLIDAY: {
    id: "seasonal_and_holiday",
    name: t("Seasonal & Holiday"),
    key: "SEASONAL_AND_HOLIDAY",
  },
  SPORTS: { id: "sports", name: t("Sports"), key: "SPORTS" },
  FITNESS: { id: "fitness", name: t("Fitness"), key: "FITNESS" },
  TRAVEL_AND_OUTDOOR: {
    id: "travel_and_outdoor",
    name: t("Travel & Outdoor"),
    key: "TRAVEL_AND_OUTDOOR",
  },
} as const;

export const EVENT_CATEGORIES_MAP_BY_ID = {
  arts_and_theatres: {
    id: "arts_and_theatres",
    name: t("Arts & Theatres"),
    key: "ARTS_AND_THEATRES",
  },
  automotive_boats_air: {
    id: "automotive_boats_air",
    name: t("Automotive, Boats, Air"),
    key: "AUTOMOTIVE_BOATS_AIR",
  },
  business_and_professional: {
    id: "business_and_professional",
    name: t("Business & Professional"),
    key: "BUSINESS_AND_PROFESSIONAL",
  },
  charity_and_causes: {
    id: "charity_and_causes",
    name: t("Charity & Causes"),
    key: "CHARITY_AND_CAUSES",
  },
  community_and_culture: {
    id: "community_and_culture",
    name: t("Community & Culture"),
    key: "COMMUNITY_AND_CULTURE",
  },
  comedy: { id: "comedy", name: t("Comedy"), key: "COMEDY" },
  education: { id: "education", name: t("Education"), key: "EDUCATION" },
  fairs_and_festivals: {
    id: "fairs_and_festivals",
    name: t("Fairs & Festivals"),
    key: "FAIRS_AND_FESTIVALS",
  },
  family_friendly: {
    id: "family_friendly",
    name: t("Family Friendly"),
    key: "FAMILY_FRIENDLY",
  },
  fashion_and_beauty: {
    id: "fashion_and_beauty",
    name: t("Fashion & Beauty"),
    key: "FASHION_AND_BEAUTY",
  },
  film_media_and_entertainment: {
    id: "film_media_and_entertainment",
    name: t("Film, Media, & Entertainment"),
    key: "FILM_MEDIA_AND_ENTERTAINMENT",
  },
  food_and_beverage: {
    id: "food_and_beverage",
    name: t("Food & Beverage"),
    key: "FOOD_AND_BEVERAGE",
  },
  government_and_politics: {
    id: "government_and_politics",
    name: t("Government & Politics"),
    key: "GOVERNMENT_AND_POLITICS",
  },
  health_and_wellness: {
    id: "health_and_wellness",
    name: t("Health & Wellness"),
    key: "HEALTH_AND_WELLNESS",
  },
  hobbies_and_special_interests: {
    id: "hobbies_and_special_interests",
    name: t("Hobbies & Special Interests"),
    key: "HOBBIES_AND_SPECIAL_INTERESTS",
  },
  home_and_lifestyle: {
    id: "home_and_lifestyle",
    name: t("Home & Lifestyle"),
    key: "HOME_AND_LIFESTYLE",
  },
  music: { id: "music", name: t("Music"), key: "MUSIC" },
  other: { id: "other", name: t("Other"), key: "OTHER" },
  racing: { id: "racing", name: t("Racing"), key: "RACING" },
  religion_and_spirituality: {
    id: "religion_and_spirituality",
    name: t("Religion & Spirituality"),
    key: "RELIGION_AND_SPIRITUALITY",
  },
  school_activities: {
    id: "school_activities",
    name: t("School Activities"),
    key: "SCHOOL_ACTIVITIES",
  },
  science_and_technology: {
    id: "science_and_technology",
    name: t("Science & Technology"),
    key: "SCIENCE_AND_TECHNOLOGY",
  },
  seasonal_and_holiday: {
    id: "seasonal_and_holiday",
    name: t("Seasonal & Holiday"),
    key: "SEASONAL_AND_HOLIDAY",
  },
  sports: { id: "sports", name: t("Sports"), key: "SPORTS" },
  fitness: { id: "fitness", name: t("Fitness"), key: "FITNESS" },
  travel_and_outdoor: {
    id: "travel_and_outdoor",
    name: t("Travel & Outdoor"),
    key: "TRAVEL_AND_OUTDOOR",
  },
} as const;

export const EVENT_CATEGORIES_MAP_BY_LIST = [
  {
    id: "arts_and_theatres",
    name: t("Arts & Theatres"),
    key: "ARTS_AND_THEATRES",
  },
  {
    id: "automotive_boats_air",
    name: t("Automotive, Boats, Air"),
    key: "AUTOMOTIVE_BOATS_AIR",
  },
  {
    id: "business_and_professional",
    name: t("Business & Professional"),
    key: "BUSINESS_AND_PROFESSIONAL",
  },
  {
    id: "charity_and_causes",
    name: t("Charity & Causes"),
    key: "CHARITY_AND_CAUSES",
  },
  {
    id: "community_and_culture",
    name: t("Community & Culture"),
    key: "COMMUNITY_AND_CULTURE",
  },
  { id: "comedy", name: t("Comedy"), key: "COMEDY" },
  { id: "education", name: t("Education"), key: "EDUCATION" },
  {
    id: "fairs_and_festivals",
    name: t("Fairs & Festivals"),
    key: "FAIRS_AND_FESTIVALS",
  },
  { id: "family_friendly", name: t("Family Friendly"), key: "FAMILY_FRIENDLY" },
  {
    id: "fashion_and_beauty",
    name: t("Fashion & Beauty"),
    key: "FASHION_AND_BEAUTY",
  },
  {
    id: "film_media_and_entertainment",
    name: t("Film, Media, & Entertainment"),
    key: "FILM_MEDIA_AND_ENTERTAINMENT",
  },
  {
    id: "food_and_beverage",
    name: t("Food & Beverage"),
    key: "FOOD_AND_BEVERAGE",
  },
  {
    id: "government_and_politics",
    name: t("Government & Politics"),
    key: "GOVERNMENT_AND_POLITICS",
  },
  {
    id: "health_and_wellness",
    name: t("Health & Wellness"),
    key: "HEALTH_AND_WELLNESS",
  },
  {
    id: "hobbies_and_special_interests",
    name: t("Hobbies & Special Interests"),
    key: "HOBBIES_AND_SPECIAL_INTERESTS",
  },
  {
    id: "home_and_lifestyle",
    name: t("Home & Lifestyle"),
    key: "HOME_AND_LIFESTYLE",
  },
  { id: "music", name: t("Music"), key: "MUSIC" },
  { id: "other", name: t("Other"), key: "OTHER" },
  { id: "racing", name: t("Racing"), key: "RACING" },
  {
    id: "religion_and_spirituality",
    name: t("Religion & Spirituality"),
    key: "RELIGION_AND_SPIRITUALITY",
  },
  {
    id: "school_activities",
    name: t("School Activities"),
    key: "SCHOOL_ACTIVITIES",
  },
  {
    id: "science_and_technology",
    name: t("Science & Technology"),
    key: "SCIENCE_AND_TECHNOLOGY",
  },
  {
    id: "seasonal_and_holiday",
    name: t("Seasonal & Holiday"),
    key: "SEASONAL_AND_HOLIDAY",
  },
  { id: "sports", name: t("Sports"), key: "SPORTS" },
  { id: "fitness", name: t("Fitness"), key: "FITNESS" },
  {
    id: "travel_and_outdoor",
    name: t("Travel & Outdoor"),
    key: "TRAVEL_AND_OUTDOOR",
  },
] as const;

export const TTD_EVENT_CATEGORIES_MAP = {
  ADULTS_ONLY: {
    id: "adults-only",
    name: t("Adults Only"),
    exclusive_with: ["family-friendly"],
    key: "ADULTS_ONLY",
  },
  ANIMALS: {
    id: "animals",
    name: t("Animals"),
    exclusive_with: [],
    key: "ANIMALS",
  },
  AUDIO_GUIDE: {
    id: "audio-guide",
    name: t("Audio Guide"),
    exclusive_with: [],
    key: "AUDIO_GUIDE",
  },
  BEACHES: {
    id: "beaches",
    name: t("Beaches"),
    exclusive_with: [],
    key: "BEACHES",
  },
  BIKE_TOURS: {
    id: "bike-tours",
    name: t("Bike Tours"),
    exclusive_with: [],
    key: "BIKE_TOURS",
  },
  BOAT_TOURS: {
    id: "boat-tours",
    name: t("Boat Tours"),
    exclusive_with: [],
    key: "BOAT_TOURS",
  },
  CITY_CARDS: {
    id: "city-cards",
    name: t("City Cards"),
    exclusive_with: [],
    key: "CITY_CARDS",
  },
  CLASSES: {
    id: "classes",
    name: t("Classes"),
    exclusive_with: [],
    key: "CLASSES",
  },
  DAY_TRIPS: {
    id: "day-trips",
    name: t("Day Trips"),
    exclusive_with: [],
    key: "DAY_TRIPS",
  },
  FAMILY_FRIENDLY: {
    id: "family-friendly",
    name: t("Family Friendly"),
    exclusive_with: ["adults-only"],
    key: "FAMILY_FRIENDLY",
  },
  FAST_TRACK: {
    id: "fast-track",
    name: t("Fast Track"),
    exclusive_with: [],
    key: "FAST_TRACK",
  },
  FOOD: { id: "food", name: t("Food"), exclusive_with: [], key: "FOOD" },
  GUIDED_TOURS: {
    id: "guided-tours",
    name: t("Guided Tours"),
    exclusive_with: ["self-guided"],
    key: "GUIDED_TOURS",
  },
  HISTORY: {
    id: "history",
    name: t("History"),
    exclusive_with: [],
    key: "HISTORY",
  },
  HOP_ON_HOP_OFF: {
    id: "hop-on-hop-off",
    name: t("Hop-on hop-off"),
    exclusive_with: [],
    key: "HOP_ON_HOP_OFF",
  },
  LITERATURE: {
    id: "literature",
    name: t("Literature"),
    exclusive_with: [],
    key: "LITERATURE",
  },
  LIVE_MUSIC: {
    id: "live-music",
    name: t("Live Music"),
    exclusive_with: [],
    key: "LIVE_MUSIC",
  },
  MUSEUMS: {
    id: "museums",
    name: t("Museums"),
    exclusive_with: [],
    key: "MUSEUMS",
  },
  NIGHTLIFE: {
    id: "nightlife",
    name: t("Nightlife"),
    exclusive_with: [],
    key: "NIGHTLIFE",
  },
  OUTDOORS: {
    id: "outdoors",
    name: t("Outdoors"),
    exclusive_with: [],
    key: "OUTDOORS",
  },
  PRIVATE_TOURS: {
    id: "private-tours",
    name: t("Private Tours"),
    exclusive_with: ["small-group-tours"],
    key: "PRIVATE_TOURS",
  },
  ROMANTIC: {
    id: "romantic",
    name: t("Romantic"),
    exclusive_with: [],
    key: "ROMANTIC",
  },
  SELF_GUIDED: {
    id: "self-guided",
    name: t("Self-Guided"),
    exclusive_with: ["guided-tours"],
    key: "SELF_GUIDED",
  },
  SMALL_GROUP_TOURS: {
    id: "small-group-tours",
    name: t("Small Group Tours"),
    exclusive_with: ["private-tours"],
    key: "SMALL_GROUP_TOURS",
  },
  SPORTS: {
    id: "sports",
    name: t("Sports"),
    exclusive_with: [],
    key: "SPORTS",
  },
  THEME_PARKS: {
    id: "theme-parks",
    name: t("Theme Parks"),
    exclusive_with: [],
    key: "THEME_PARKS",
  },
  WALKING_TOURS: {
    id: "walking-tours",
    name: t("Walking Tours"),
    exclusive_with: [],
    key: "WALKING_TOURS",
  },
  WHEELCHAIR_ACCESSIBLE: {
    id: "wheelchair-accessible",
    name: t("Wheelchair Accessible"),
    exclusive_with: [],
    key: "WHEELCHAIR_ACCESSIBLE",
  },
} as const;

export const TTD_EVENT_CATEGORIES_MAP_BY_ID = {
  "adults-only": {
    id: "adults-only",
    name: t("Adults Only"),
    exclusive_with: ["family-friendly"],
    key: "ADULTS_ONLY",
  },
  animals: {
    id: "animals",
    name: t("Animals"),
    exclusive_with: [],
    key: "ANIMALS",
  },
  "audio-guide": {
    id: "audio-guide",
    name: t("Audio Guide"),
    exclusive_with: [],
    key: "AUDIO_GUIDE",
  },
  beaches: {
    id: "beaches",
    name: t("Beaches"),
    exclusive_with: [],
    key: "BEACHES",
  },
  "bike-tours": {
    id: "bike-tours",
    name: t("Bike Tours"),
    exclusive_with: [],
    key: "BIKE_TOURS",
  },
  "boat-tours": {
    id: "boat-tours",
    name: t("Boat Tours"),
    exclusive_with: [],
    key: "BOAT_TOURS",
  },
  "city-cards": {
    id: "city-cards",
    name: t("City Cards"),
    exclusive_with: [],
    key: "CITY_CARDS",
  },
  classes: {
    id: "classes",
    name: t("Classes"),
    exclusive_with: [],
    key: "CLASSES",
  },
  "day-trips": {
    id: "day-trips",
    name: t("Day Trips"),
    exclusive_with: [],
    key: "DAY_TRIPS",
  },
  "family-friendly": {
    id: "family-friendly",
    name: t("Family Friendly"),
    exclusive_with: ["adults-only"],
    key: "FAMILY_FRIENDLY",
  },
  "fast-track": {
    id: "fast-track",
    name: t("Fast Track"),
    exclusive_with: [],
    key: "FAST_TRACK",
  },
  food: { id: "food", name: t("Food"), exclusive_with: [], key: "FOOD" },
  "guided-tours": {
    id: "guided-tours",
    name: t("Guided Tours"),
    exclusive_with: ["self-guided"],
    key: "GUIDED_TOURS",
  },
  history: {
    id: "history",
    name: t("History"),
    exclusive_with: [],
    key: "HISTORY",
  },
  "hop-on-hop-off": {
    id: "hop-on-hop-off",
    name: t("Hop-on hop-off"),
    exclusive_with: [],
    key: "HOP_ON_HOP_OFF",
  },
  literature: {
    id: "literature",
    name: t("Literature"),
    exclusive_with: [],
    key: "LITERATURE",
  },
  "live-music": {
    id: "live-music",
    name: t("Live Music"),
    exclusive_with: [],
    key: "LIVE_MUSIC",
  },
  museums: {
    id: "museums",
    name: t("Museums"),
    exclusive_with: [],
    key: "MUSEUMS",
  },
  nightlife: {
    id: "nightlife",
    name: t("Nightlife"),
    exclusive_with: [],
    key: "NIGHTLIFE",
  },
  outdoors: {
    id: "outdoors",
    name: t("Outdoors"),
    exclusive_with: [],
    key: "OUTDOORS",
  },
  "private-tours": {
    id: "private-tours",
    name: t("Private Tours"),
    exclusive_with: ["small-group-tours"],
    key: "PRIVATE_TOURS",
  },
  romantic: {
    id: "romantic",
    name: t("Romantic"),
    exclusive_with: [],
    key: "ROMANTIC",
  },
  "self-guided": {
    id: "self-guided",
    name: t("Self-Guided"),
    exclusive_with: ["guided-tours"],
    key: "SELF_GUIDED",
  },
  "small-group-tours": {
    id: "small-group-tours",
    name: t("Small Group Tours"),
    exclusive_with: ["private-tours"],
    key: "SMALL_GROUP_TOURS",
  },
  sports: {
    id: "sports",
    name: t("Sports"),
    exclusive_with: [],
    key: "SPORTS",
  },
  "theme-parks": {
    id: "theme-parks",
    name: t("Theme Parks"),
    exclusive_with: [],
    key: "THEME_PARKS",
  },
  "walking-tours": {
    id: "walking-tours",
    name: t("Walking Tours"),
    exclusive_with: [],
    key: "WALKING_TOURS",
  },
  "wheelchair-accessible": {
    id: "wheelchair-accessible",
    name: t("Wheelchair Accessible"),
    exclusive_with: [],
    key: "WHEELCHAIR_ACCESSIBLE",
  },
} as const;

export const TTD_EVENT_CATEGORIES_MAP_BY_LIST = [
  {
    id: "adults-only",
    name: t("Adults Only"),
    exclusive_with: ["family-friendly"],
    key: "ADULTS_ONLY",
  },
  { id: "animals", name: t("Animals"), exclusive_with: [], key: "ANIMALS" },
  {
    id: "audio-guide",
    name: t("Audio Guide"),
    exclusive_with: [],
    key: "AUDIO_GUIDE",
  },
  { id: "beaches", name: t("Beaches"), exclusive_with: [], key: "BEACHES" },
  {
    id: "bike-tours",
    name: t("Bike Tours"),
    exclusive_with: [],
    key: "BIKE_TOURS",
  },
  {
    id: "boat-tours",
    name: t("Boat Tours"),
    exclusive_with: [],
    key: "BOAT_TOURS",
  },
  {
    id: "city-cards",
    name: t("City Cards"),
    exclusive_with: [],
    key: "CITY_CARDS",
  },
  { id: "classes", name: t("Classes"), exclusive_with: [], key: "CLASSES" },
  {
    id: "day-trips",
    name: t("Day Trips"),
    exclusive_with: [],
    key: "DAY_TRIPS",
  },
  {
    id: "family-friendly",
    name: t("Family Friendly"),
    exclusive_with: ["adults-only"],
    key: "FAMILY_FRIENDLY",
  },
  {
    id: "fast-track",
    name: t("Fast Track"),
    exclusive_with: [],
    key: "FAST_TRACK",
  },
  { id: "food", name: t("Food"), exclusive_with: [], key: "FOOD" },
  {
    id: "guided-tours",
    name: t("Guided Tours"),
    exclusive_with: ["self-guided"],
    key: "GUIDED_TOURS",
  },
  { id: "history", name: t("History"), exclusive_with: [], key: "HISTORY" },
  {
    id: "hop-on-hop-off",
    name: t("Hop-on hop-off"),
    exclusive_with: [],
    key: "HOP_ON_HOP_OFF",
  },
  {
    id: "literature",
    name: t("Literature"),
    exclusive_with: [],
    key: "LITERATURE",
  },
  {
    id: "live-music",
    name: t("Live Music"),
    exclusive_with: [],
    key: "LIVE_MUSIC",
  },
  { id: "museums", name: t("Museums"), exclusive_with: [], key: "MUSEUMS" },
  {
    id: "nightlife",
    name: t("Nightlife"),
    exclusive_with: [],
    key: "NIGHTLIFE",
  },
  { id: "outdoors", name: t("Outdoors"), exclusive_with: [], key: "OUTDOORS" },
  {
    id: "private-tours",
    name: t("Private Tours"),
    exclusive_with: ["small-group-tours"],
    key: "PRIVATE_TOURS",
  },
  { id: "romantic", name: t("Romantic"), exclusive_with: [], key: "ROMANTIC" },
  {
    id: "self-guided",
    name: t("Self-Guided"),
    exclusive_with: ["guided-tours"],
    key: "SELF_GUIDED",
  },
  {
    id: "small-group-tours",
    name: t("Small Group Tours"),
    exclusive_with: ["private-tours"],
    key: "SMALL_GROUP_TOURS",
  },
  { id: "sports", name: t("Sports"), exclusive_with: [], key: "SPORTS" },
  {
    id: "theme-parks",
    name: t("Theme Parks"),
    exclusive_with: [],
    key: "THEME_PARKS",
  },
  {
    id: "walking-tours",
    name: t("Walking Tours"),
    exclusive_with: [],
    key: "WALKING_TOURS",
  },
  {
    id: "wheelchair-accessible",
    name: t("Wheelchair Accessible"),
    exclusive_with: [],
    key: "WHEELCHAIR_ACCESSIBLE",
  },
] as const;

export const REMAINING_TICKETS_PERCENTAGE_MAP = {
  NO_WARNING: {
    id: 0,
    name: t("No Warning"),
    threshold: 0,
    venue_field: "",
    key: "NO_WARNING",
  },
  THRESHOLD_LOW: {
    id: 1,
    name: t("Threshold Low"),
    venue_field: "low_inventory_threshold_low",
    key: "THRESHOLD_LOW",
  },
  THRESHOLD_MIDDLE: {
    id: 2,
    name: t("Threshold Middle"),
    venue_field: "low_inventory_threshold_middle",
    key: "THRESHOLD_MIDDLE",
  },
  THRESHOLD_HIGH: {
    id: 3,
    name: t("Threshold High"),
    venue_field: "low_inventory_threshold_high",
    key: "THRESHOLD_HIGH",
  },
} as const;

export const REMAINING_TICKETS_PERCENTAGE_MAP_BY_ID = {
  "0": {
    id: 0,
    name: t("No Warning"),
    threshold: 0,
    venue_field: "",
    key: "NO_WARNING",
  },
  "1": {
    id: 1,
    name: t("Threshold Low"),
    venue_field: "low_inventory_threshold_low",
    key: "THRESHOLD_LOW",
  },
  "2": {
    id: 2,
    name: t("Threshold Middle"),
    venue_field: "low_inventory_threshold_middle",
    key: "THRESHOLD_MIDDLE",
  },
  "3": {
    id: 3,
    name: t("Threshold High"),
    venue_field: "low_inventory_threshold_high",
    key: "THRESHOLD_HIGH",
  },
} as const;

export const REMAINING_TICKETS_PERCENTAGE_MAP_BY_LIST = [
  {
    id: 0,
    name: t("No Warning"),
    threshold: 0,
    venue_field: "",
    key: "NO_WARNING",
  },
  {
    id: 1,
    name: t("Threshold Low"),
    venue_field: "low_inventory_threshold_low",
    key: "THRESHOLD_LOW",
  },
  {
    id: 2,
    name: t("Threshold Middle"),
    venue_field: "low_inventory_threshold_middle",
    key: "THRESHOLD_MIDDLE",
  },
  {
    id: 3,
    name: t("Threshold High"),
    venue_field: "low_inventory_threshold_high",
    key: "THRESHOLD_HIGH",
  },
] as const;

export const VISIBILITY_MAP = {
  VISIBILITY_PUBLIC: { id: 1, name: t("Public"), key: "VISIBILITY_PUBLIC" },
  VISIBILITY_HIDDEN: { id: 2, name: t("Hidden"), key: "VISIBILITY_HIDDEN" },
  VISIBILITY_SELLERS_ONLY: {
    id: 3,
    name: t("Sellers only"),
    key: "VISIBILITY_SELLERS_ONLY",
  },
  VISIBILITY_PUBLIC_ONLY: {
    id: 4,
    name: t("Public only"),
    key: "VISIBILITY_PUBLIC_ONLY",
  },
} as const;

export const VISIBILITY_MAP_BY_ID = {
  "1": { id: 1, name: t("Public"), key: "VISIBILITY_PUBLIC" },
  "2": { id: 2, name: t("Hidden"), key: "VISIBILITY_HIDDEN" },
  "3": { id: 3, name: t("Sellers only"), key: "VISIBILITY_SELLERS_ONLY" },
  "4": { id: 4, name: t("Public only"), key: "VISIBILITY_PUBLIC_ONLY" },
} as const;

export const VISIBILITY_MAP_BY_LIST = [
  { id: 1, name: t("Public"), key: "VISIBILITY_PUBLIC" },
  { id: 2, name: t("Hidden"), key: "VISIBILITY_HIDDEN" },
  { id: 3, name: t("Sellers only"), key: "VISIBILITY_SELLERS_ONLY" },
  { id: 4, name: t("Public only"), key: "VISIBILITY_PUBLIC_ONLY" },
] as const;

export const RENEWAL_FREQUENCIES_MAP = {
  ONE_TIME: { id: "one_time", name: t("One Time"), key: "ONE_TIME" },
  MONTHLY: {
    id: "monthly",
    name: t("Monthly"),
    email_name: "month",
    key: "MONTHLY",
  },
  EVERY_3_MONTHS: {
    id: "every_3_months",
    name: t("Every 3 Months"),
    email_name: "3 months",
    key: "EVERY_3_MONTHS",
  },
  EVERY_6_MONTHS: {
    id: "every_6_months",
    name: t("Every 6 Months"),
    email_name: "6 months",
    key: "EVERY_6_MONTHS",
  },
  YEARLY: {
    id: "yearly",
    name: t("Yearly"),
    email_name: "year",
    key: "YEARLY",
  },
  LIFETIME: { id: "lifetime", name: t("Lifetime"), key: "LIFETIME" },
  SEASONAL: {
    id: "seasonal",
    name: t("Seasonal"),
    email_name: "season",
    key: "SEASONAL",
  },
} as const;

export const RENEWAL_FREQUENCIES_MAP_BY_ID = {
  one_time: { id: "one_time", name: t("One Time"), key: "ONE_TIME" },
  monthly: {
    id: "monthly",
    name: t("Monthly"),
    email_name: "month",
    key: "MONTHLY",
  },
  every_3_months: {
    id: "every_3_months",
    name: t("Every 3 Months"),
    email_name: "3 months",
    key: "EVERY_3_MONTHS",
  },
  every_6_months: {
    id: "every_6_months",
    name: t("Every 6 Months"),
    email_name: "6 months",
    key: "EVERY_6_MONTHS",
  },
  yearly: {
    id: "yearly",
    name: t("Yearly"),
    email_name: "year",
    key: "YEARLY",
  },
  lifetime: { id: "lifetime", name: t("Lifetime"), key: "LIFETIME" },
  seasonal: {
    id: "seasonal",
    name: t("Seasonal"),
    email_name: "season",
    key: "SEASONAL",
  },
} as const;

export const RENEWAL_FREQUENCIES_MAP_BY_LIST = [
  { id: "one_time", name: t("One Time"), key: "ONE_TIME" },
  { id: "monthly", name: t("Monthly"), email_name: "month", key: "MONTHLY" },
  {
    id: "every_3_months",
    name: t("Every 3 Months"),
    email_name: "3 months",
    key: "EVERY_3_MONTHS",
  },
  {
    id: "every_6_months",
    name: t("Every 6 Months"),
    email_name: "6 months",
    key: "EVERY_6_MONTHS",
  },
  { id: "yearly", name: t("Yearly"), email_name: "year", key: "YEARLY" },
  { id: "lifetime", name: t("Lifetime"), key: "LIFETIME" },
  {
    id: "seasonal",
    name: t("Seasonal"),
    email_name: "season",
    key: "SEASONAL",
  },
] as const;

export const REFUND_MEDIUM_MAP = {
  REVERT_FUNDS: {
    id: "revert_funds",
    name: t("Revert Funds"),
    credit_type: "",
    key: "REVERT_FUNDS",
  },
  VENUE_CREDIT: {
    id: "venue_credit",
    name: t("Organizer Credit"),
    credit_type: "venue_credit",
    key: "VENUE_CREDIT",
  },
  USER_CREDIT: {
    id: "user_credit",
    name: t("Universal Credit"),
    credit_type: "user_credit",
    key: "USER_CREDIT",
  },
} as const;

export const REFUND_MEDIUM_MAP_BY_ID = {
  revert_funds: {
    id: "revert_funds",
    name: t("Revert Funds"),
    credit_type: "",
    key: "REVERT_FUNDS",
  },
  venue_credit: {
    id: "venue_credit",
    name: t("Organizer Credit"),
    credit_type: "venue_credit",
    key: "VENUE_CREDIT",
  },
  user_credit: {
    id: "user_credit",
    name: t("Universal Credit"),
    credit_type: "user_credit",
    key: "USER_CREDIT",
  },
} as const;

export const REFUND_MEDIUM_MAP_BY_LIST = [
  {
    id: "revert_funds",
    name: t("Revert Funds"),
    credit_type: "",
    key: "REVERT_FUNDS",
  },
  {
    id: "venue_credit",
    name: t("Organizer Credit"),
    credit_type: "venue_credit",
    key: "VENUE_CREDIT",
  },
  {
    id: "user_credit",
    name: t("Universal Credit"),
    credit_type: "user_credit",
    key: "USER_CREDIT",
  },
] as const;

export const REPORT_TIME_DELTA_MAP = {
  TODAY: { id: "today", name: t("Today"), key: "TODAY" },
  YESTERDAY: { id: "yesterday", name: t("Yesterday"), key: "YESTERDAY" },
  CURRENT_WEEK: {
    id: "current_week",
    name: t("This Week"),
    key: "CURRENT_WEEK",
  },
  LAST_WEEK: { id: "last_week", name: t("Last Week"), key: "LAST_WEEK" },
  CURRENT_MONTH: {
    id: "current_month",
    name: t("This Month"),
    key: "CURRENT_MONTH",
  },
  LAST_MONTH: { id: "last_month", name: t("Last Month"), key: "LAST_MONTH" },
  CURRENT_QUARTER: {
    id: "current_quarter",
    name: t("This Quarter"),
    key: "CURRENT_QUARTER",
  },
  LAST_QUARTER: {
    id: "last_quarter",
    name: t("Last Quarter"),
    key: "LAST_QUARTER",
  },
  YEAR_TO_DATE: {
    id: "year_to_date",
    name: t("Year to Date"),
    key: "YEAR_TO_DATE",
  },
  LAST_YEAR: { id: "last_year", name: t("Last Year"), key: "LAST_YEAR" },
  CUSTOM: { id: "custom", name: t("Custom"), key: "CUSTOM" },
} as const;

export const REPORT_TIME_DELTA_MAP_BY_ID = {
  today: { id: "today", name: t("Today"), key: "TODAY" },
  yesterday: { id: "yesterday", name: t("Yesterday"), key: "YESTERDAY" },
  current_week: {
    id: "current_week",
    name: t("This Week"),
    key: "CURRENT_WEEK",
  },
  last_week: { id: "last_week", name: t("Last Week"), key: "LAST_WEEK" },
  current_month: {
    id: "current_month",
    name: t("This Month"),
    key: "CURRENT_MONTH",
  },
  last_month: { id: "last_month", name: t("Last Month"), key: "LAST_MONTH" },
  current_quarter: {
    id: "current_quarter",
    name: t("This Quarter"),
    key: "CURRENT_QUARTER",
  },
  last_quarter: {
    id: "last_quarter",
    name: t("Last Quarter"),
    key: "LAST_QUARTER",
  },
  year_to_date: {
    id: "year_to_date",
    name: t("Year to Date"),
    key: "YEAR_TO_DATE",
  },
  last_year: { id: "last_year", name: t("Last Year"), key: "LAST_YEAR" },
  custom: { id: "custom", name: t("Custom"), key: "CUSTOM" },
} as const;

export const REPORT_TIME_DELTA_MAP_BY_LIST = [
  { id: "today", name: t("Today"), key: "TODAY" },
  { id: "yesterday", name: t("Yesterday"), key: "YESTERDAY" },
  { id: "current_week", name: t("This Week"), key: "CURRENT_WEEK" },
  { id: "last_week", name: t("Last Week"), key: "LAST_WEEK" },
  { id: "current_month", name: t("This Month"), key: "CURRENT_MONTH" },
  { id: "last_month", name: t("Last Month"), key: "LAST_MONTH" },
  { id: "current_quarter", name: t("This Quarter"), key: "CURRENT_QUARTER" },
  { id: "last_quarter", name: t("Last Quarter"), key: "LAST_QUARTER" },
  { id: "year_to_date", name: t("Year to Date"), key: "YEAR_TO_DATE" },
  { id: "last_year", name: t("Last Year"), key: "LAST_YEAR" },
  { id: "custom", name: t("Custom"), key: "CUSTOM" },
] as const;

export const REPORT_GROUPING_OPTION_MAP = {
  INDIVIDUAL_EVENT: {
    id: "individual_event",
    name: t("Individual Occurrences"),
    description: "Group recurring and non-recurring events individually.",
    key: "INDIVIDUAL_EVENT",
  },
  MAIN_EVENT: {
    id: "main_event",
    name: t("Main Events"),
    description:
      "Group recurring events by the main events. Non-recurring events are displayed individually.",
    key: "MAIN_EVENT",
  },
} as const;

export const REPORT_GROUPING_OPTION_MAP_BY_ID = {
  individual_event: {
    id: "individual_event",
    name: t("Individual Occurrences"),
    description: "Group recurring and non-recurring events individually.",
    key: "INDIVIDUAL_EVENT",
  },
  main_event: {
    id: "main_event",
    name: t("Main Events"),
    description:
      "Group recurring events by the main events. Non-recurring events are displayed individually.",
    key: "MAIN_EVENT",
  },
} as const;

export const REPORT_GROUPING_OPTION_MAP_BY_LIST = [
  {
    id: "individual_event",
    name: t("Individual Occurrences"),
    description: "Group recurring and non-recurring events individually.",
    key: "INDIVIDUAL_EVENT",
  },
  {
    id: "main_event",
    name: t("Main Events"),
    description:
      "Group recurring events by the main events. Non-recurring events are displayed individually.",
    key: "MAIN_EVENT",
  },
] as const;

export const MEMBERSHIP_GROUP_STATUS_MAP = {
  PUBLISHED: {
    id: "sp_membership_group_published",
    name: t("Published"),
    purchasable: true,
    viewable: true,
    key: "PUBLISHED",
  },
  DRAFT: {
    id: "sp_membership_group_draft",
    name: t("Draft"),
    purchasable: false,
    viewable: false,
    key: "DRAFT",
  },
} as const;

export const MEMBERSHIP_GROUP_STATUS_MAP_BY_ID = {
  sp_membership_group_published: {
    id: "sp_membership_group_published",
    name: t("Published"),
    purchasable: true,
    viewable: true,
    key: "PUBLISHED",
  },
  sp_membership_group_draft: {
    id: "sp_membership_group_draft",
    name: t("Draft"),
    purchasable: false,
    viewable: false,
    key: "DRAFT",
  },
} as const;

export const MEMBERSHIP_GROUP_STATUS_MAP_BY_LIST = [
  {
    id: "sp_membership_group_published",
    name: t("Published"),
    purchasable: true,
    viewable: true,
    key: "PUBLISHED",
  },
  {
    id: "sp_membership_group_draft",
    name: t("Draft"),
    purchasable: false,
    viewable: false,
    key: "DRAFT",
  },
] as const;

export const MEMBERSHIP_BENEFIT_TYPE_MAP = {
  EVENT_SCAN_ACCESS: {
    id: "event_scan_access",
    name: t("Event Scan Access"),
    description:
      "Give members entry access into your events by allowing in and out scans for specific ticket types.",
    key: "EVENT_SCAN_ACCESS",
  },
  DAILY_SCAN_ACCESS: {
    id: "daily_scan_access",
    name: t("Daily Scan Access"),
    description:
      "Give members daily entry access by allowing in and out scans for memberships.",
    key: "DAILY_SCAN_ACCESS",
  },
  DISCOUNT: {
    id: "discount",
    name: t("Discount"),
    description: "Give members discounts on specific ticket types.",
    key: "DISCOUNT",
  },
  ISSUE_TICKET: {
    id: "issue_ticket",
    name: t("Issue Tickets"),
    description: "Distribute ticket batches to members for selected events.",
    key: "ISSUE_TICKET",
  },
} as const;

export const MEMBERSHIP_BENEFIT_TYPE_MAP_BY_ID = {
  event_scan_access: {
    id: "event_scan_access",
    name: t("Event Scan Access"),
    description:
      "Give members entry access into your events by allowing in and out scans for specific ticket types.",
    key: "EVENT_SCAN_ACCESS",
  },
  daily_scan_access: {
    id: "daily_scan_access",
    name: t("Daily Scan Access"),
    description:
      "Give members daily entry access by allowing in and out scans for memberships.",
    key: "DAILY_SCAN_ACCESS",
  },
  discount: {
    id: "discount",
    name: t("Discount"),
    description: "Give members discounts on specific ticket types.",
    key: "DISCOUNT",
  },
  issue_ticket: {
    id: "issue_ticket",
    name: t("Issue Tickets"),
    description: "Distribute ticket batches to members for selected events.",
    key: "ISSUE_TICKET",
  },
} as const;

export const MEMBERSHIP_BENEFIT_TYPE_MAP_BY_LIST = [
  {
    id: "event_scan_access",
    name: t("Event Scan Access"),
    description:
      "Give members entry access into your events by allowing in and out scans for specific ticket types.",
    key: "EVENT_SCAN_ACCESS",
  },
  {
    id: "daily_scan_access",
    name: t("Daily Scan Access"),
    description:
      "Give members daily entry access by allowing in and out scans for memberships.",
    key: "DAILY_SCAN_ACCESS",
  },
  {
    id: "discount",
    name: t("Discount"),
    description: "Give members discounts on specific ticket types.",
    key: "DISCOUNT",
  },
  {
    id: "issue_ticket",
    name: t("Issue Tickets"),
    description: "Distribute ticket batches to members for selected events.",
    key: "ISSUE_TICKET",
  },
] as const;

export const MEMBERSHIP_GROUP_VERBIAGE_MAP = {
  MEMBERSHIP: {
    id: "sp_membership_group_membership",
    name: t("Memberships"),
    name_singular: "Membership",
    key: "MEMBERSHIP",
  },
  PASS: {
    id: "sp_membership_group_pass",
    name: t("Passes"),
    name_singular: "Pass",
    key: "PASS",
  },
} as const;

export const MEMBERSHIP_GROUP_VERBIAGE_MAP_BY_ID = {
  sp_membership_group_membership: {
    id: "sp_membership_group_membership",
    name: t("Memberships"),
    name_singular: "Membership",
    key: "MEMBERSHIP",
  },
  sp_membership_group_pass: {
    id: "sp_membership_group_pass",
    name: t("Passes"),
    name_singular: "Pass",
    key: "PASS",
  },
} as const;

export const MEMBERSHIP_GROUP_VERBIAGE_MAP_BY_LIST = [
  {
    id: "sp_membership_group_membership",
    name: t("Memberships"),
    name_singular: "Membership",
    key: "MEMBERSHIP",
  },
  {
    id: "sp_membership_group_pass",
    name: t("Passes"),
    name_singular: "Pass",
    key: "PASS",
  },
] as const;

export const CARD_TYPE_MAP = {
  VISA: {
    id: "visa",
    name: t("Visa"),
    cc_regex: "4\\d{12}(\\d{3})?$",
    stripe_name: "Visa",
    square_name: "VISA",
    authorizenet_name: "Visa",
    braintree_name: "Visa",
    bambora_name: "visa",
    names: ["visa"],
    labelClass: "label-blue",
    icon32: "assets/img/card-icons/visa-curved-32px.png",
    key: "VISA",
  },
  AMEX: {
    id: "amex",
    name: t("American Express"),
    cc_regex: "37\\d{13}$",
    stripe_name: "American Express",
    square_name: "AMERICAN_EXPRESS",
    authorizenet_name: "AmericanExpress",
    braintree_name: "American Express",
    bambora_name: "amex",
    names: ["amex", "American Express", "AmericanExpress", "AMERICAN_EXPRESS"],
    labelClass: "label-black",
    icon32: "assets/img/card-icons/american-express-curved-32px.png",
    key: "AMEX",
  },
  MASTERCARD: {
    id: "mc",
    name: t("Mastercard"),
    cc_regex: "5[1-5]\\d{14}$",
    stripe_name: "MasterCard",
    square_name: "MASTERCARD",
    authorizenet_name: "Mastercard",
    braintree_name: "MasterCard",
    bambora_name: "mastercard",
    names: ["mc", "MasterCard"],
    labelClass: "label-red",
    icon32: "assets/img/card-icons/mastercard-curved-32px.png",
    key: "MASTERCARD",
  },
  DISCOVER: {
    id: "discover",
    name: t("Discover"),
    cc_regex: "6011\\d{12}",
    stripe_name: "Discover",
    square_name: "DISCOVER",
    authorizenet_name: "Discover",
    braintree_name: "Discover",
    bambora_name: "discover",
    names: ["Discover"],
    labelClass: "label-black",
    icon32: "assets/img/card-icons/discover-curved-32px.png",
    key: "DISCOVER",
  },
  DINERS: {
    id: "diners",
    name: t("Diners"),
    cc_regex: "(30[0-5]\\d{11}|(36|38)\\d{12})$",
    stripe_name: "Diners Club",
    square_name: "DISCOVER_DINERS",
    authorizenet_name: "DinersClub",
    braintree_name: "",
    bambora_name: "diners",
    names: ["Diners Club", "DISCOVER_DINERS", "DinersClub"],
    labelClass: "label-black",
    icon32: "assets/img/card-icons/diners-club-32px.png",
    key: "DINERS",
  },
  UNIONPAY: {
    id: "union",
    name: t("Union Pay"),
    stripe_name: "UnionPay",
    square_name: "CHINA_UNIONPAY",
    braintree_name: "China UnionPay",
    authorizenet_name: "",
    bambora_name: "",
    names: ["union", "UnionPay", "CHINA_UNIONPAY", "China UnionPay"],
    labelClass: "label-black",
    icon32: "assets/img/card-icons/union-pay-32px.png",
    key: "UNIONPAY",
  },
  JCB: {
    id: "jcb",
    name: t("JCB"),
    stripe_name: "JCB",
    square_name: "JCB",
    authorizenet_name: "JCB",
    braintree_name: "JCB",
    bambora_name: "jcb",
    names: ["JCB"],
    labelClass: "label-black",
    icon32: "assets/img/card-icons/jcb-32px.png",
    key: "JCB",
  },
  INTERAC: {
    id: "interac",
    name: t("Interac"),
    stripe_name: "",
    square_name: "INTERAC",
    authorizenet_name: "",
    braintree_name: "",
    bambora_name: "",
    names: ["INTERAC"],
    key: "INTERAC",
  },
  EFTPOS: {
    id: "eftpos",
    name: t("EFTPOS"),
    stripe_name: "",
    square_name: "EFTPOS",
    authorizenet_name: "",
    braintree_name: "",
    bambora_name: "",
    names: ["EFTPOS"],
    key: "EFTPOS",
  },
  FELICA: {
    id: "felica",
    name: t("FeliCa"),
    stripe_name: "",
    square_name: "FELICA",
    authorizenet_name: "",
    braintree_name: "",
    bambora_name: "",
    names: ["FELICA"],
    key: "FELICA",
  },
  SQUARE_GIFT_CARD: {
    id: "square_gift_card",
    name: t("Square Gift Card"),
    stripe_name: "",
    square_name: "SQUARE_GIFT_CARD",
    authorizenet_name: "",
    braintree_name: "",
    bambora_name: "",
    names: ["SQUARE_GIFT_CARD"],
    key: "SQUARE_GIFT_CARD",
  },
  UNKNOWN: {
    id: "unknown",
    name: t("Unknown"),
    stripe_name: "Unknown",
    square_name: "OTHER_BRAND",
    authorizenet_name: "",
    braintree_name: "",
    bambora_name: "None",
    names: ["Unknown", "OTHER_BRAND", "None"],
    key: "UNKNOWN",
  },
} as const;

export const CARD_TYPE_MAP_BY_ID = {
  visa: {
    id: "visa",
    name: t("Visa"),
    cc_regex: "4\\d{12}(\\d{3})?$",
    stripe_name: "Visa",
    square_name: "VISA",
    authorizenet_name: "Visa",
    braintree_name: "Visa",
    bambora_name: "visa",
    names: ["visa"],
    labelClass: "label-blue",
    icon32: "assets/img/card-icons/visa-curved-32px.png",
    key: "VISA",
  },
  amex: {
    id: "amex",
    name: t("American Express"),
    cc_regex: "37\\d{13}$",
    stripe_name: "American Express",
    square_name: "AMERICAN_EXPRESS",
    authorizenet_name: "AmericanExpress",
    braintree_name: "American Express",
    bambora_name: "amex",
    names: ["amex", "American Express", "AmericanExpress", "AMERICAN_EXPRESS"],
    labelClass: "label-black",
    icon32: "assets/img/card-icons/american-express-curved-32px.png",
    key: "AMEX",
  },
  mc: {
    id: "mc",
    name: t("Mastercard"),
    cc_regex: "5[1-5]\\d{14}$",
    stripe_name: "MasterCard",
    square_name: "MASTERCARD",
    authorizenet_name: "Mastercard",
    braintree_name: "MasterCard",
    bambora_name: "mastercard",
    names: ["mc", "MasterCard"],
    labelClass: "label-red",
    icon32: "assets/img/card-icons/mastercard-curved-32px.png",
    key: "MASTERCARD",
  },
  discover: {
    id: "discover",
    name: t("Discover"),
    cc_regex: "6011\\d{12}",
    stripe_name: "Discover",
    square_name: "DISCOVER",
    authorizenet_name: "Discover",
    braintree_name: "Discover",
    bambora_name: "discover",
    names: ["Discover"],
    labelClass: "label-black",
    icon32: "assets/img/card-icons/discover-curved-32px.png",
    key: "DISCOVER",
  },
  diners: {
    id: "diners",
    name: t("Diners"),
    cc_regex: "(30[0-5]\\d{11}|(36|38)\\d{12})$",
    stripe_name: "Diners Club",
    square_name: "DISCOVER_DINERS",
    authorizenet_name: "DinersClub",
    braintree_name: "",
    bambora_name: "diners",
    names: ["Diners Club", "DISCOVER_DINERS", "DinersClub"],
    labelClass: "label-black",
    icon32: "assets/img/card-icons/diners-club-32px.png",
    key: "DINERS",
  },
  union: {
    id: "union",
    name: t("Union Pay"),
    stripe_name: "UnionPay",
    square_name: "CHINA_UNIONPAY",
    braintree_name: "China UnionPay",
    authorizenet_name: "",
    bambora_name: "",
    names: ["union", "UnionPay", "CHINA_UNIONPAY", "China UnionPay"],
    labelClass: "label-black",
    icon32: "assets/img/card-icons/union-pay-32px.png",
    key: "UNIONPAY",
  },
  jcb: {
    id: "jcb",
    name: t("JCB"),
    stripe_name: "JCB",
    square_name: "JCB",
    authorizenet_name: "JCB",
    braintree_name: "JCB",
    bambora_name: "jcb",
    names: ["JCB"],
    labelClass: "label-black",
    icon32: "assets/img/card-icons/jcb-32px.png",
    key: "JCB",
  },
  interac: {
    id: "interac",
    name: t("Interac"),
    stripe_name: "",
    square_name: "INTERAC",
    authorizenet_name: "",
    braintree_name: "",
    bambora_name: "",
    names: ["INTERAC"],
    key: "INTERAC",
  },
  eftpos: {
    id: "eftpos",
    name: t("EFTPOS"),
    stripe_name: "",
    square_name: "EFTPOS",
    authorizenet_name: "",
    braintree_name: "",
    bambora_name: "",
    names: ["EFTPOS"],
    key: "EFTPOS",
  },
  felica: {
    id: "felica",
    name: t("FeliCa"),
    stripe_name: "",
    square_name: "FELICA",
    authorizenet_name: "",
    braintree_name: "",
    bambora_name: "",
    names: ["FELICA"],
    key: "FELICA",
  },
  square_gift_card: {
    id: "square_gift_card",
    name: t("Square Gift Card"),
    stripe_name: "",
    square_name: "SQUARE_GIFT_CARD",
    authorizenet_name: "",
    braintree_name: "",
    bambora_name: "",
    names: ["SQUARE_GIFT_CARD"],
    key: "SQUARE_GIFT_CARD",
  },
  unknown: {
    id: "unknown",
    name: t("Unknown"),
    stripe_name: "Unknown",
    square_name: "OTHER_BRAND",
    authorizenet_name: "",
    braintree_name: "",
    bambora_name: "None",
    names: ["Unknown", "OTHER_BRAND", "None"],
    key: "UNKNOWN",
  },
} as const;

export const CARD_TYPE_MAP_BY_LIST = [
  {
    id: "visa",
    name: t("Visa"),
    cc_regex: "4\\d{12}(\\d{3})?$",
    stripe_name: "Visa",
    square_name: "VISA",
    authorizenet_name: "Visa",
    braintree_name: "Visa",
    bambora_name: "visa",
    names: ["visa"],
    labelClass: "label-blue",
    icon32: "assets/img/card-icons/visa-curved-32px.png",
    key: "VISA",
  },
  {
    id: "amex",
    name: t("American Express"),
    cc_regex: "37\\d{13}$",
    stripe_name: "American Express",
    square_name: "AMERICAN_EXPRESS",
    authorizenet_name: "AmericanExpress",
    braintree_name: "American Express",
    bambora_name: "amex",
    names: ["amex", "American Express", "AmericanExpress", "AMERICAN_EXPRESS"],
    labelClass: "label-black",
    icon32: "assets/img/card-icons/american-express-curved-32px.png",
    key: "AMEX",
  },
  {
    id: "mc",
    name: t("Mastercard"),
    cc_regex: "5[1-5]\\d{14}$",
    stripe_name: "MasterCard",
    square_name: "MASTERCARD",
    authorizenet_name: "Mastercard",
    braintree_name: "MasterCard",
    bambora_name: "mastercard",
    names: ["mc", "MasterCard"],
    labelClass: "label-red",
    icon32: "assets/img/card-icons/mastercard-curved-32px.png",
    key: "MASTERCARD",
  },
  {
    id: "discover",
    name: t("Discover"),
    cc_regex: "6011\\d{12}",
    stripe_name: "Discover",
    square_name: "DISCOVER",
    authorizenet_name: "Discover",
    braintree_name: "Discover",
    bambora_name: "discover",
    names: ["Discover"],
    labelClass: "label-black",
    icon32: "assets/img/card-icons/discover-curved-32px.png",
    key: "DISCOVER",
  },
  {
    id: "diners",
    name: t("Diners"),
    cc_regex: "(30[0-5]\\d{11}|(36|38)\\d{12})$",
    stripe_name: "Diners Club",
    square_name: "DISCOVER_DINERS",
    authorizenet_name: "DinersClub",
    braintree_name: "",
    bambora_name: "diners",
    names: ["Diners Club", "DISCOVER_DINERS", "DinersClub"],
    labelClass: "label-black",
    icon32: "assets/img/card-icons/diners-club-32px.png",
    key: "DINERS",
  },
  {
    id: "union",
    name: t("Union Pay"),
    stripe_name: "UnionPay",
    square_name: "CHINA_UNIONPAY",
    braintree_name: "China UnionPay",
    authorizenet_name: "",
    bambora_name: "",
    names: ["union", "UnionPay", "CHINA_UNIONPAY", "China UnionPay"],
    labelClass: "label-black",
    icon32: "assets/img/card-icons/union-pay-32px.png",
    key: "UNIONPAY",
  },
  {
    id: "jcb",
    name: t("JCB"),
    stripe_name: "JCB",
    square_name: "JCB",
    authorizenet_name: "JCB",
    braintree_name: "JCB",
    bambora_name: "jcb",
    names: ["JCB"],
    labelClass: "label-black",
    icon32: "assets/img/card-icons/jcb-32px.png",
    key: "JCB",
  },
  {
    id: "interac",
    name: t("Interac"),
    stripe_name: "",
    square_name: "INTERAC",
    authorizenet_name: "",
    braintree_name: "",
    bambora_name: "",
    names: ["INTERAC"],
    key: "INTERAC",
  },
  {
    id: "eftpos",
    name: t("EFTPOS"),
    stripe_name: "",
    square_name: "EFTPOS",
    authorizenet_name: "",
    braintree_name: "",
    bambora_name: "",
    names: ["EFTPOS"],
    key: "EFTPOS",
  },
  {
    id: "felica",
    name: t("FeliCa"),
    stripe_name: "",
    square_name: "FELICA",
    authorizenet_name: "",
    braintree_name: "",
    bambora_name: "",
    names: ["FELICA"],
    key: "FELICA",
  },
  {
    id: "square_gift_card",
    name: t("Square Gift Card"),
    stripe_name: "",
    square_name: "SQUARE_GIFT_CARD",
    authorizenet_name: "",
    braintree_name: "",
    bambora_name: "",
    names: ["SQUARE_GIFT_CARD"],
    key: "SQUARE_GIFT_CARD",
  },
  {
    id: "unknown",
    name: t("Unknown"),
    stripe_name: "Unknown",
    square_name: "OTHER_BRAND",
    authorizenet_name: "",
    braintree_name: "",
    bambora_name: "None",
    names: ["Unknown", "OTHER_BRAND", "None"],
    key: "UNKNOWN",
  },
] as const;

export const STRIPE_PAYMENT_INTENT_STATUS_MAP = {
  REQUIRES_PAYMENT_METHOD: {
    id: "requires_payment_method",
    name: t("Requires Payment Method"),
    key: "REQUIRES_PAYMENT_METHOD",
  },
  REQUIRES_CONFIRMATION: {
    id: "requires_confirmation",
    name: t("Requires Confirmation"),
    key: "REQUIRES_CONFIRMATION",
  },
  REQUIRES_ACTION: {
    id: "requires_action",
    name: t("Requires Action"),
    key: "REQUIRES_ACTION",
  },
  PROCESSING: { id: "processing", name: t("Processing"), key: "PROCESSING" },
  SUCCEEDED: { id: "succeeded", name: t("Succeeded"), key: "SUCCEEDED" },
  CANCELED: { id: "canceled", name: t("Canceled"), key: "CANCELED" },
  REQUIRES_CAPTURE: {
    id: "requires_capture",
    name: t("Requires Capture"),
    key: "REQUIRES_CAPTURE",
  },
  REQUIRES_SOURCE: {
    id: "requires_source",
    name: t("Requires Source"),
    key: "REQUIRES_SOURCE",
  },
  REQUIRES_SOURCE_ACTION: {
    id: "requires_source_action",
    name: t("Requires Source Action"),
    key: "REQUIRES_SOURCE_ACTION",
  },
} as const;

export const STRIPE_PAYMENT_INTENT_STATUS_MAP_BY_ID = {
  requires_payment_method: {
    id: "requires_payment_method",
    name: t("Requires Payment Method"),
    key: "REQUIRES_PAYMENT_METHOD",
  },
  requires_confirmation: {
    id: "requires_confirmation",
    name: t("Requires Confirmation"),
    key: "REQUIRES_CONFIRMATION",
  },
  requires_action: {
    id: "requires_action",
    name: t("Requires Action"),
    key: "REQUIRES_ACTION",
  },
  processing: { id: "processing", name: t("Processing"), key: "PROCESSING" },
  succeeded: { id: "succeeded", name: t("Succeeded"), key: "SUCCEEDED" },
  canceled: { id: "canceled", name: t("Canceled"), key: "CANCELED" },
  requires_capture: {
    id: "requires_capture",
    name: t("Requires Capture"),
    key: "REQUIRES_CAPTURE",
  },
  requires_source: {
    id: "requires_source",
    name: t("Requires Source"),
    key: "REQUIRES_SOURCE",
  },
  requires_source_action: {
    id: "requires_source_action",
    name: t("Requires Source Action"),
    key: "REQUIRES_SOURCE_ACTION",
  },
} as const;

export const STRIPE_PAYMENT_INTENT_STATUS_MAP_BY_LIST = [
  {
    id: "requires_payment_method",
    name: t("Requires Payment Method"),
    key: "REQUIRES_PAYMENT_METHOD",
  },
  {
    id: "requires_confirmation",
    name: t("Requires Confirmation"),
    key: "REQUIRES_CONFIRMATION",
  },
  { id: "requires_action", name: t("Requires Action"), key: "REQUIRES_ACTION" },
  { id: "processing", name: t("Processing"), key: "PROCESSING" },
  { id: "succeeded", name: t("Succeeded"), key: "SUCCEEDED" },
  { id: "canceled", name: t("Canceled"), key: "CANCELED" },
  {
    id: "requires_capture",
    name: t("Requires Capture"),
    key: "REQUIRES_CAPTURE",
  },
  { id: "requires_source", name: t("Requires Source"), key: "REQUIRES_SOURCE" },
  {
    id: "requires_source_action",
    name: t("Requires Source Action"),
    key: "REQUIRES_SOURCE_ACTION",
  },
] as const;

export const RECAPTCHA_KEY_MAP = {
  PUBLIC_KEY: {
    id: "public_key",
    name: t("Public Key"),
    key_value: "6LfnMx4qAAAAAOZVB7vgUVLxjU5FDJev9sgjN9ui",
    key: "PUBLIC_KEY",
  },
} as const;

export const RECAPTCHA_KEY_MAP_BY_ID = {
  public_key: {
    id: "public_key",
    name: t("Public Key"),
    key_value: "6LfnMx4qAAAAAOZVB7vgUVLxjU5FDJev9sgjN9ui",
    key: "PUBLIC_KEY",
  },
} as const;

export const RECAPTCHA_KEY_MAP_BY_LIST = [
  {
    id: "public_key",
    name: t("Public Key"),
    key_value: "6LfnMx4qAAAAAOZVB7vgUVLxjU5FDJev9sgjN9ui",
    key: "PUBLIC_KEY",
  },
] as const;

export const ITEM_TYPES_MAP = {
  ITEM_TYPE_TICKET: {
    id: "ticket",
    name: t("Ticket"),
    sub_item_name: "Ticket Type",
    key: "ITEM_TYPE_TICKET",
  },
  ITEM_TYPE_PRODUCT: {
    id: "product",
    name: t("Product"),
    sub_item_name: "Product Attribute",
    key: "ITEM_TYPE_PRODUCT",
  },
  ITEM_TYPE_MEMBERSHIP: {
    id: "membership",
    name: t("Membership"),
    sub_item_name: "Membership Level",
    key: "ITEM_TYPE_MEMBERSHIP",
  },
  ITEM_TYPE_TIP: { id: "tip", name: t("Tip"), key: "ITEM_TYPE_TIP" },
  ITEM_TYPE_DONATION: {
    id: "donation",
    name: t("Donation"),
    key: "ITEM_TYPE_DONATION",
  },
  ITEM_TYPE_USER_CREDIT: {
    id: "user_credit",
    name: t("User Credit"),
    key: "ITEM_TYPE_USER_CREDIT",
  },
  ITEM_TYPE_GIFT_CARD: {
    id: "gift_card",
    name: t("Gift Card"),
    sub_item_name: "Gift Card Denomination",
    key: "ITEM_TYPE_GIFT_CARD",
  },
  ITEM_TYPE_PROTECTION: {
    id: "protection",
    name: t("Protection"),
    sub_item_name: "Protected Item Group",
    key: "ITEM_TYPE_PROTECTION",
  },
} as const;

export const ITEM_TYPES_MAP_BY_ID = {
  ticket: {
    id: "ticket",
    name: t("Ticket"),
    sub_item_name: "Ticket Type",
    key: "ITEM_TYPE_TICKET",
  },
  product: {
    id: "product",
    name: t("Product"),
    sub_item_name: "Product Attribute",
    key: "ITEM_TYPE_PRODUCT",
  },
  membership: {
    id: "membership",
    name: t("Membership"),
    sub_item_name: "Membership Level",
    key: "ITEM_TYPE_MEMBERSHIP",
  },
  tip: { id: "tip", name: t("Tip"), key: "ITEM_TYPE_TIP" },
  donation: { id: "donation", name: t("Donation"), key: "ITEM_TYPE_DONATION" },
  user_credit: {
    id: "user_credit",
    name: t("User Credit"),
    key: "ITEM_TYPE_USER_CREDIT",
  },
  gift_card: {
    id: "gift_card",
    name: t("Gift Card"),
    sub_item_name: "Gift Card Denomination",
    key: "ITEM_TYPE_GIFT_CARD",
  },
  protection: {
    id: "protection",
    name: t("Protection"),
    sub_item_name: "Protected Item Group",
    key: "ITEM_TYPE_PROTECTION",
  },
} as const;

export const ITEM_TYPES_MAP_BY_LIST = [
  {
    id: "ticket",
    name: t("Ticket"),
    sub_item_name: "Ticket Type",
    key: "ITEM_TYPE_TICKET",
  },
  {
    id: "product",
    name: t("Product"),
    sub_item_name: "Product Attribute",
    key: "ITEM_TYPE_PRODUCT",
  },
  {
    id: "membership",
    name: t("Membership"),
    sub_item_name: "Membership Level",
    key: "ITEM_TYPE_MEMBERSHIP",
  },
  { id: "tip", name: t("Tip"), key: "ITEM_TYPE_TIP" },
  { id: "donation", name: t("Donation"), key: "ITEM_TYPE_DONATION" },
  { id: "user_credit", name: t("User Credit"), key: "ITEM_TYPE_USER_CREDIT" },
  {
    id: "gift_card",
    name: t("Gift Card"),
    sub_item_name: "Gift Card Denomination",
    key: "ITEM_TYPE_GIFT_CARD",
  },
  {
    id: "protection",
    name: t("Protection"),
    sub_item_name: "Protected Item Group",
    key: "ITEM_TYPE_PROTECTION",
  },
] as const;

export const RENEWAL_REMINDER_FREQUENCIES_MAP = {
  ONE_DAY_BEFORE: {
    id: "one_day_before",
    name: t("One Day Before"),
    email_name: "one day",
    key: "ONE_DAY_BEFORE",
  },
  ONE_WEEK_BEFORE: {
    id: "one_week_before",
    name: t("One Week Before"),
    email_name: "one week",
    key: "ONE_WEEK_BEFORE",
  },
  TWO_WEEKS_BEFORE: {
    id: "two_weeks_before",
    name: t("Two Weeks Before"),
    email_name: "two weeks",
    key: "TWO_WEEKS_BEFORE",
  },
  ONE_MONTH_BEFORE: {
    id: "one_month_before",
    name: t("One Month Before"),
    email_name: "one month",
    key: "ONE_MONTH_BEFORE",
  },
  NOT_AVAILABLE: {
    id: "not_available",
    name: t("Not Available"),
    email_name: "not available",
    key: "NOT_AVAILABLE",
  },
} as const;

export const RENEWAL_REMINDER_FREQUENCIES_MAP_BY_ID = {
  one_day_before: {
    id: "one_day_before",
    name: t("One Day Before"),
    email_name: "one day",
    key: "ONE_DAY_BEFORE",
  },
  one_week_before: {
    id: "one_week_before",
    name: t("One Week Before"),
    email_name: "one week",
    key: "ONE_WEEK_BEFORE",
  },
  two_weeks_before: {
    id: "two_weeks_before",
    name: t("Two Weeks Before"),
    email_name: "two weeks",
    key: "TWO_WEEKS_BEFORE",
  },
  one_month_before: {
    id: "one_month_before",
    name: t("One Month Before"),
    email_name: "one month",
    key: "ONE_MONTH_BEFORE",
  },
  not_available: {
    id: "not_available",
    name: t("Not Available"),
    email_name: "not available",
    key: "NOT_AVAILABLE",
  },
} as const;

export const RENEWAL_REMINDER_FREQUENCIES_MAP_BY_LIST = [
  {
    id: "one_day_before",
    name: t("One Day Before"),
    email_name: "one day",
    key: "ONE_DAY_BEFORE",
  },
  {
    id: "one_week_before",
    name: t("One Week Before"),
    email_name: "one week",
    key: "ONE_WEEK_BEFORE",
  },
  {
    id: "two_weeks_before",
    name: t("Two Weeks Before"),
    email_name: "two weeks",
    key: "TWO_WEEKS_BEFORE",
  },
  {
    id: "one_month_before",
    name: t("One Month Before"),
    email_name: "one month",
    key: "ONE_MONTH_BEFORE",
  },
  {
    id: "not_available",
    name: t("Not Available"),
    email_name: "not available",
    key: "NOT_AVAILABLE",
  },
] as const;

export const ATTRACTION_CHILD_TYPE_MAP = {
  EVENT: {
    id: 1,
    name: t("Event"),
    required_fields: ["type", "title", "description", "ids", "sort_order"],
    class: "tickets.Event",
    key: "EVENT",
  },
  PRODUCT: {
    id: 2,
    name: t("Product"),
    required_fields: ["type", "title", "description", "ids", "sort_order"],
    class: "inventory.Product",
    key: "PRODUCT",
  },
  MEMBERSHIP: {
    id: 3,
    name: t("Membership"),
    required_fields: ["type", "title", "description", "ids", "sort_order"],
    class: "memberships.MembershipGroup",
    key: "MEMBERSHIP",
  },
  SINGLE_EVENT: {
    id: 4,
    name: t("Single event"),
    required_fields: ["type", "title", "description", "ids", "sort_order"],
    class: "tickets.Event",
    key: "SINGLE_EVENT",
  },
  REDIRECT: {
    id: 5,
    name: t("Redirect"),
    required_fields: ["type", "title", "description", "url", "sort_order"],
    class: null,
    key: "REDIRECT",
  },
  TICKET_TYPES: {
    id: 6,
    name: t("Ticket Types"),
    required_fields: ["type", "title", "description", "ids", "sort_order"],
    class: "tickets.TicketType",
    key: "TICKET_TYPES",
  },
} as const;

export const ATTRACTION_CHILD_TYPE_MAP_BY_ID = {
  "1": {
    id: 1,
    name: t("Event"),
    required_fields: ["type", "title", "description", "ids", "sort_order"],
    class: "tickets.Event",
    key: "EVENT",
  },
  "2": {
    id: 2,
    name: t("Product"),
    required_fields: ["type", "title", "description", "ids", "sort_order"],
    class: "inventory.Product",
    key: "PRODUCT",
  },
  "3": {
    id: 3,
    name: t("Membership"),
    required_fields: ["type", "title", "description", "ids", "sort_order"],
    class: "memberships.MembershipGroup",
    key: "MEMBERSHIP",
  },
  "4": {
    id: 4,
    name: t("Single event"),
    required_fields: ["type", "title", "description", "ids", "sort_order"],
    class: "tickets.Event",
    key: "SINGLE_EVENT",
  },
  "5": {
    id: 5,
    name: t("Redirect"),
    required_fields: ["type", "title", "description", "url", "sort_order"],
    class: null,
    key: "REDIRECT",
  },
  "6": {
    id: 6,
    name: t("Ticket Types"),
    required_fields: ["type", "title", "description", "ids", "sort_order"],
    class: "tickets.TicketType",
    key: "TICKET_TYPES",
  },
} as const;

export const ATTRACTION_CHILD_TYPE_MAP_BY_LIST = [
  {
    id: 1,
    name: t("Event"),
    required_fields: ["type", "title", "description", "ids", "sort_order"],
    class: "tickets.Event",
    key: "EVENT",
  },
  {
    id: 2,
    name: t("Product"),
    required_fields: ["type", "title", "description", "ids", "sort_order"],
    class: "inventory.Product",
    key: "PRODUCT",
  },
  {
    id: 3,
    name: t("Membership"),
    required_fields: ["type", "title", "description", "ids", "sort_order"],
    class: "memberships.MembershipGroup",
    key: "MEMBERSHIP",
  },
  {
    id: 4,
    name: t("Single event"),
    required_fields: ["type", "title", "description", "ids", "sort_order"],
    class: "tickets.Event",
    key: "SINGLE_EVENT",
  },
  {
    id: 5,
    name: t("Redirect"),
    required_fields: ["type", "title", "description", "url", "sort_order"],
    class: null,
    key: "REDIRECT",
  },
  {
    id: 6,
    name: t("Ticket Types"),
    required_fields: ["type", "title", "description", "ids", "sort_order"],
    class: "tickets.TicketType",
    key: "TICKET_TYPES",
  },
] as const;

export const CS_NOTE_TYPE_MAP = {
  NOTE_TYPE_VENUE: {
    id: "cs_note_type_venue",
    name: t("Venue Note"),
    key: "NOTE_TYPE_VENUE",
  },
  NOTE_TYPE_EVENT: {
    id: "cs_note_type_event",
    name: t("Event Note"),
    key: "NOTE_TYPE_EVENT",
  },
  NOTE_TYPE_VENUE_USER: {
    id: "cs_note_type_venue_user",
    name: t("Venue User Note"),
    key: "NOTE_TYPE_VENUE_USER",
  },
} as const;

export const CS_NOTE_TYPE_MAP_BY_ID = {
  cs_note_type_venue: {
    id: "cs_note_type_venue",
    name: t("Venue Note"),
    key: "NOTE_TYPE_VENUE",
  },
  cs_note_type_event: {
    id: "cs_note_type_event",
    name: t("Event Note"),
    key: "NOTE_TYPE_EVENT",
  },
  cs_note_type_venue_user: {
    id: "cs_note_type_venue_user",
    name: t("Venue User Note"),
    key: "NOTE_TYPE_VENUE_USER",
  },
} as const;

export const CS_NOTE_TYPE_MAP_BY_LIST = [
  { id: "cs_note_type_venue", name: t("Venue Note"), key: "NOTE_TYPE_VENUE" },
  { id: "cs_note_type_event", name: t("Event Note"), key: "NOTE_TYPE_EVENT" },
  {
    id: "cs_note_type_venue_user",
    name: t("Venue User Note"),
    key: "NOTE_TYPE_VENUE_USER",
  },
] as const;

export const SPACE_ELEMENT_TYPE_MAP = {
  SPACE: { id: "space", name: t("Space"), key: "SPACE" },
  SEGMENT: { id: "segment", name: t("Segment"), key: "SEGMENT" },
  LOCATION: { id: "location", name: t("Location"), key: "LOCATION" },
  SEAT: { id: "seat", name: t("Seat"), key: "SEAT" },
} as const;

export const SPACE_ELEMENT_TYPE_MAP_BY_ID = {
  space: { id: "space", name: t("Space"), key: "SPACE" },
  segment: { id: "segment", name: t("Segment"), key: "SEGMENT" },
  location: { id: "location", name: t("Location"), key: "LOCATION" },
  seat: { id: "seat", name: t("Seat"), key: "SEAT" },
} as const;

export const SPACE_ELEMENT_TYPE_MAP_BY_LIST = [
  { id: "space", name: t("Space"), key: "SPACE" },
  { id: "segment", name: t("Segment"), key: "SEGMENT" },
  { id: "location", name: t("Location"), key: "LOCATION" },
  { id: "seat", name: t("Seat"), key: "SEAT" },
] as const;

export const SPACE_REQUEST_TYPE_MAP = {
  CREATE: { id: "create", name: t("Create"), key: "CREATE" },
  UPDATE: { id: "update", name: t("Update"), key: "UPDATE" },
  DELETE: { id: "delete", name: t("Delete"), key: "DELETE" },
} as const;

export const SPACE_REQUEST_TYPE_MAP_BY_ID = {
  create: { id: "create", name: t("Create"), key: "CREATE" },
  update: { id: "update", name: t("Update"), key: "UPDATE" },
  delete: { id: "delete", name: t("Delete"), key: "DELETE" },
} as const;

export const SPACE_REQUEST_TYPE_MAP_BY_LIST = [
  { id: "create", name: t("Create"), key: "CREATE" },
  { id: "update", name: t("Update"), key: "UPDATE" },
  { id: "delete", name: t("Delete"), key: "DELETE" },
] as const;

export const WEBHOOK_TYPE_MAP = {
  PURCHASE: { id: "invoice.purchase", name: t("Purchase"), key: "PURCHASE" },
  REFUND: { id: "invoice.refund", name: t("Refund"), key: "REFUND" },
  VOID: { id: "invoice.void", name: t("Void"), key: "VOID" },
  TRANSFER: { id: "invoice.transfer", name: t("Transfer"), key: "TRANSFER" },
  TRANSFERRED: {
    id: "invoice.transferred",
    name: t("Transferred"),
    key: "TRANSFERRED",
  },
  TEST: { id: "webhook.test", name: t("Test"), key: "TEST" },
} as const;

export const WEBHOOK_TYPE_MAP_BY_ID = {
  "invoice.purchase": {
    id: "invoice.purchase",
    name: t("Purchase"),
    key: "PURCHASE",
  },
  "invoice.refund": { id: "invoice.refund", name: t("Refund"), key: "REFUND" },
  "invoice.void": { id: "invoice.void", name: t("Void"), key: "VOID" },
  "invoice.transfer": {
    id: "invoice.transfer",
    name: t("Transfer"),
    key: "TRANSFER",
  },
  "invoice.transferred": {
    id: "invoice.transferred",
    name: t("Transferred"),
    key: "TRANSFERRED",
  },
  "webhook.test": { id: "webhook.test", name: t("Test"), key: "TEST" },
} as const;

export const WEBHOOK_TYPE_MAP_BY_LIST = [
  { id: "invoice.purchase", name: t("Purchase"), key: "PURCHASE" },
  { id: "invoice.refund", name: t("Refund"), key: "REFUND" },
  { id: "invoice.void", name: t("Void"), key: "VOID" },
  { id: "invoice.transfer", name: t("Transfer"), key: "TRANSFER" },
  { id: "invoice.transferred", name: t("Transferred"), key: "TRANSFERRED" },
  { id: "webhook.test", name: t("Test"), key: "TEST" },
] as const;

export const WEBHOOK_STATUS_MAP = {
  SUCCESS: { id: "success", name: t("Success"), key: "SUCCESS" },
  FAILURE: { id: "failure", name: t("Failure"), key: "FAILURE" },
} as const;

export const WEBHOOK_STATUS_MAP_BY_ID = {
  success: { id: "success", name: t("Success"), key: "SUCCESS" },
  failure: { id: "failure", name: t("Failure"), key: "FAILURE" },
} as const;

export const WEBHOOK_STATUS_MAP_BY_LIST = [
  { id: "success", name: t("Success"), key: "SUCCESS" },
  { id: "failure", name: t("Failure"), key: "FAILURE" },
] as const;

export const TRANSFER_STATE_MAP = {
  TRANSFER_STATE_PENDING: {
    id: "pending",
    name: t("Pending"),
    next_state: ["cancelled", "complete"],
    key: "TRANSFER_STATE_PENDING",
  },
  TRANSFER_STATE_CANCELLED: {
    id: "cancelled",
    name: t("Cancelled"),
    next_state: [],
    key: "TRANSFER_STATE_CANCELLED",
  },
  TRANSFER_STATE_COMPLETE: {
    id: "complete",
    name: t("Completed"),
    next_state: ["returned"],
    key: "TRANSFER_STATE_COMPLETE",
  },
  TRANSFER_STATE_RETURNED: {
    id: "returned",
    name: t("Returned"),
    next_state: [],
    key: "TRANSFER_STATE_RETURNED",
  },
} as const;

export const TRANSFER_STATE_MAP_BY_ID = {
  pending: {
    id: "pending",
    name: t("Pending"),
    next_state: ["cancelled", "complete"],
    key: "TRANSFER_STATE_PENDING",
  },
  cancelled: {
    id: "cancelled",
    name: t("Cancelled"),
    next_state: [],
    key: "TRANSFER_STATE_CANCELLED",
  },
  complete: {
    id: "complete",
    name: t("Completed"),
    next_state: ["returned"],
    key: "TRANSFER_STATE_COMPLETE",
  },
  returned: {
    id: "returned",
    name: t("Returned"),
    next_state: [],
    key: "TRANSFER_STATE_RETURNED",
  },
} as const;

export const TRANSFER_STATE_MAP_BY_LIST = [
  {
    id: "pending",
    name: t("Pending"),
    next_state: ["cancelled", "complete"],
    key: "TRANSFER_STATE_PENDING",
  },
  {
    id: "cancelled",
    name: t("Cancelled"),
    next_state: [],
    key: "TRANSFER_STATE_CANCELLED",
  },
  {
    id: "complete",
    name: t("Completed"),
    next_state: ["returned"],
    key: "TRANSFER_STATE_COMPLETE",
  },
  {
    id: "returned",
    name: t("Returned"),
    next_state: [],
    key: "TRANSFER_STATE_RETURNED",
  },
] as const;

export const ITEM_TYPES_PURCHASED = [
  "product",
  "ticket",
  "membership",
  "gift_card",
  "protection",
] as const;

export const FB_CONVERSION_API_EVENT_NAME_MAP = {
  PageView: { name: t("PageView"), id: "PageView", key: "PageView" },
  ViewContent: {
    name: t("ViewContent"),
    id: "ViewContent",
    key: "ViewContent",
  },
  AddToCart: { name: t("AddToCart"), id: "AddToCart", key: "AddToCart" },
  CompleteRegistration: {
    name: t("CompleteRegistration"),
    id: "CompleteRegistration",
    key: "CompleteRegistration",
  },
  InitiateCheckout: {
    name: t("InitiateCheckout"),
    id: "InitiateCheckout",
    key: "InitiateCheckout",
  },
  Purchase: { name: t("Purchase"), id: "Purchase", key: "Purchase" },
} as const;

export const FB_CONVERSION_API_EVENT_NAME_MAP_BY_ID = {} as const;

export const FB_CONVERSION_API_EVENT_NAME_MAP_BY_LIST = [] as const;

export const INTERACTION_TYPE_MAP = {
  PAGE_VIEW: { id: 1, name: t("Page View"), key: "PAGE_VIEW" },
  ADD_TO_CART: { id: 2, name: t("Add to Cart"), key: "ADD_TO_CART" },
  INITIATE_CHECKOUT: {
    id: 3,
    name: t("Checkout Initiated"),
    key: "INITIATE_CHECKOUT",
  },
  PURCHASE: { id: 4, name: t("Purchase"), key: "PURCHASE" },
  BUTTON_CLICK: { id: 5, name: t("Button Click"), key: "BUTTON_CLICK" },
  BOX_VIEW: { id: 6, name: t("Box Element View"), key: "BOX_VIEW" },
  SEARCH: { id: 7, name: t("Search"), key: "SEARCH" },
} as const;

export const INTERACTION_TYPE_MAP_BY_ID = {
  "1": { id: 1, name: t("Page View"), key: "PAGE_VIEW" },
  "2": { id: 2, name: t("Add to Cart"), key: "ADD_TO_CART" },
  "3": { id: 3, name: t("Checkout Initiated"), key: "INITIATE_CHECKOUT" },
  "4": { id: 4, name: t("Purchase"), key: "PURCHASE" },
  "5": { id: 5, name: t("Button Click"), key: "BUTTON_CLICK" },
  "6": { id: 6, name: t("Box Element View"), key: "BOX_VIEW" },
  "7": { id: 7, name: t("Search"), key: "SEARCH" },
} as const;

export const INTERACTION_TYPE_MAP_BY_LIST = [
  { id: 1, name: t("Page View"), key: "PAGE_VIEW" },
  { id: 2, name: t("Add to Cart"), key: "ADD_TO_CART" },
  { id: 3, name: t("Checkout Initiated"), key: "INITIATE_CHECKOUT" },
  { id: 4, name: t("Purchase"), key: "PURCHASE" },
  { id: 5, name: t("Button Click"), key: "BUTTON_CLICK" },
  { id: 6, name: t("Box Element View"), key: "BOX_VIEW" },
  { id: 7, name: t("Search"), key: "SEARCH" },
] as const;

export const INTERACTION_LABEL_MAP = {
  HOME_PAGE: { id: "home_page", name: t("Home Page"), key: "HOME_PAGE" },
  EVENT_PAGE: { id: "EVENT", name: t("Event Page"), key: "EVENT_PAGE" },
  MEMBERSHIP_PAGE: {
    id: "MEMBERSHIP",
    name: t("Membership Page"),
    key: "MEMBERSHIP_PAGE",
  },
  SEATING_PAGE: {
    id: "seating_page",
    name: t("Seating Page"),
    key: "SEATING_PAGE",
  },
  SEARCH_PAGE: {
    id: "search_page",
    name: t("Search Page"),
    key: "SEARCH_PAGE",
  },
  CITY_PAGE: { id: "city_page", name: t("City Page"), key: "CITY_PAGE" },
  CATEGORY_PAGE: {
    id: "category_page",
    name: t("Category Page"),
    key: "CATEGORY_PAGE",
  },
  ADD_TO_CART: {
    id: "add_to_cart",
    name: t("Add to Cart"),
    key: "ADD_TO_CART",
  },
  ADD_TO_CART_WIDGET: {
    id: "add_to_cart_widget",
    name: t("Add to Cart Widget"),
    key: "ADD_TO_CART_WIDGET",
  },
  INITIATE_CHECKOUT: {
    id: "initiate_checkout",
    name: t("Initiate Checkout"),
    key: "INITIATE_CHECKOUT",
  },
  INITIATE_CHECKOUT_WIDGET: {
    id: "initiate_checkout_widget",
    name: t("Initiate Checkout Widget"),
    key: "INITIATE_CHECKOUT_WIDGET",
  },
  PURCHASE: { id: "purchase", name: t("Purchase"), key: "PURCHASE" },
  EVENT_CALENDAR: {
    id: "event_calendar",
    name: t("Event Calendar"),
    key: "EVENT_CALENDAR",
  },
  EVENT_CALENDAR_TICKET_TYPE_SELECTION: {
    id: "event_calendar_ticket_type_selection",
    name: t("Event Calendar Ticket Type Selection"),
    key: "EVENT_CALENDAR_TICKET_TYPE_SELECTION",
  },
  EVENT_CALENDAR_QUANTITY_PROMPT: {
    id: "event_calendar_quantity_prompt",
    name: t("Event Calendar Quantity Prompt"),
    key: "EVENT_CALENDAR_QUANTITY_PROMPT",
  },
  EVENT_CALENDAR_V2: {
    id: "event_calendar_v2",
    name: t("Event Calendar V2"),
    key: "EVENT_CALENDAR_V2",
  },
  WIDGET: { id: "widget", name: t("Widget"), key: "WIDGET" },
  CHECKOUT_ADDONS: {
    id: "checkout_addons",
    name: t("Checkout Addons"),
    key: "CHECKOUT_ADDONS",
  },
  PRODUCT_PAGE: {
    id: "product_page",
    name: t("Product Page"),
    key: "PRODUCT_PAGE",
  },
  VIEW_ITEMS: { id: "view_items", name: t("View Items"), key: "VIEW_ITEMS" },
  REFUND_PROTECTION_EXPOSURE: {
    id: "refund_protection_exposure",
    name: t("Refund Protection Exposure"),
    key: "REFUND_PROTECTION_EXPOSURE",
  },
  REFUND_PROTECTION_SELECTION: {
    id: "refund_protection_selection",
    name: t("Refund Protection Selection"),
    key: "REFUND_PROTECTION_SELECTION",
  },
} as const;

export const INTERACTION_LABEL_MAP_BY_ID = {
  home_page: { id: "home_page", name: t("Home Page"), key: "HOME_PAGE" },
  EVENT: { id: "EVENT", name: t("Event Page"), key: "EVENT_PAGE" },
  MEMBERSHIP: {
    id: "MEMBERSHIP",
    name: t("Membership Page"),
    key: "MEMBERSHIP_PAGE",
  },
  seating_page: {
    id: "seating_page",
    name: t("Seating Page"),
    key: "SEATING_PAGE",
  },
  search_page: {
    id: "search_page",
    name: t("Search Page"),
    key: "SEARCH_PAGE",
  },
  city_page: { id: "city_page", name: t("City Page"), key: "CITY_PAGE" },
  category_page: {
    id: "category_page",
    name: t("Category Page"),
    key: "CATEGORY_PAGE",
  },
  add_to_cart: {
    id: "add_to_cart",
    name: t("Add to Cart"),
    key: "ADD_TO_CART",
  },
  add_to_cart_widget: {
    id: "add_to_cart_widget",
    name: t("Add to Cart Widget"),
    key: "ADD_TO_CART_WIDGET",
  },
  initiate_checkout: {
    id: "initiate_checkout",
    name: t("Initiate Checkout"),
    key: "INITIATE_CHECKOUT",
  },
  initiate_checkout_widget: {
    id: "initiate_checkout_widget",
    name: t("Initiate Checkout Widget"),
    key: "INITIATE_CHECKOUT_WIDGET",
  },
  purchase: { id: "purchase", name: t("Purchase"), key: "PURCHASE" },
  event_calendar: {
    id: "event_calendar",
    name: t("Event Calendar"),
    key: "EVENT_CALENDAR",
  },
  event_calendar_ticket_type_selection: {
    id: "event_calendar_ticket_type_selection",
    name: t("Event Calendar Ticket Type Selection"),
    key: "EVENT_CALENDAR_TICKET_TYPE_SELECTION",
  },
  event_calendar_quantity_prompt: {
    id: "event_calendar_quantity_prompt",
    name: t("Event Calendar Quantity Prompt"),
    key: "EVENT_CALENDAR_QUANTITY_PROMPT",
  },
  event_calendar_v2: {
    id: "event_calendar_v2",
    name: t("Event Calendar V2"),
    key: "EVENT_CALENDAR_V2",
  },
  widget: { id: "widget", name: t("Widget"), key: "WIDGET" },
  checkout_addons: {
    id: "checkout_addons",
    name: t("Checkout Addons"),
    key: "CHECKOUT_ADDONS",
  },
  product_page: {
    id: "product_page",
    name: t("Product Page"),
    key: "PRODUCT_PAGE",
  },
  view_items: { id: "view_items", name: t("View Items"), key: "VIEW_ITEMS" },
  refund_protection_exposure: {
    id: "refund_protection_exposure",
    name: t("Refund Protection Exposure"),
    key: "REFUND_PROTECTION_EXPOSURE",
  },
  refund_protection_selection: {
    id: "refund_protection_selection",
    name: t("Refund Protection Selection"),
    key: "REFUND_PROTECTION_SELECTION",
  },
} as const;

export const INTERACTION_LABEL_MAP_BY_LIST = [
  { id: "home_page", name: t("Home Page"), key: "HOME_PAGE" },
  { id: "EVENT", name: t("Event Page"), key: "EVENT_PAGE" },
  { id: "MEMBERSHIP", name: t("Membership Page"), key: "MEMBERSHIP_PAGE" },
  { id: "seating_page", name: t("Seating Page"), key: "SEATING_PAGE" },
  { id: "search_page", name: t("Search Page"), key: "SEARCH_PAGE" },
  { id: "city_page", name: t("City Page"), key: "CITY_PAGE" },
  { id: "category_page", name: t("Category Page"), key: "CATEGORY_PAGE" },
  { id: "add_to_cart", name: t("Add to Cart"), key: "ADD_TO_CART" },
  {
    id: "add_to_cart_widget",
    name: t("Add to Cart Widget"),
    key: "ADD_TO_CART_WIDGET",
  },
  {
    id: "initiate_checkout",
    name: t("Initiate Checkout"),
    key: "INITIATE_CHECKOUT",
  },
  {
    id: "initiate_checkout_widget",
    name: t("Initiate Checkout Widget"),
    key: "INITIATE_CHECKOUT_WIDGET",
  },
  { id: "purchase", name: t("Purchase"), key: "PURCHASE" },
  { id: "event_calendar", name: t("Event Calendar"), key: "EVENT_CALENDAR" },
  {
    id: "event_calendar_ticket_type_selection",
    name: t("Event Calendar Ticket Type Selection"),
    key: "EVENT_CALENDAR_TICKET_TYPE_SELECTION",
  },
  {
    id: "event_calendar_quantity_prompt",
    name: t("Event Calendar Quantity Prompt"),
    key: "EVENT_CALENDAR_QUANTITY_PROMPT",
  },
  {
    id: "event_calendar_v2",
    name: t("Event Calendar V2"),
    key: "EVENT_CALENDAR_V2",
  },
  { id: "widget", name: t("Widget"), key: "WIDGET" },
  { id: "checkout_addons", name: t("Checkout Addons"), key: "CHECKOUT_ADDONS" },
  { id: "product_page", name: t("Product Page"), key: "PRODUCT_PAGE" },
  { id: "view_items", name: t("View Items"), key: "VIEW_ITEMS" },
  {
    id: "refund_protection_exposure",
    name: t("Refund Protection Exposure"),
    key: "REFUND_PROTECTION_EXPOSURE",
  },
  {
    id: "refund_protection_selection",
    name: t("Refund Protection Selection"),
    key: "REFUND_PROTECTION_SELECTION",
  },
] as const;

export const FAKE_FAILURE_TASK_PREFIX = "!!ERROR" as const;

export const BASKET_ON_HOLD_TYPE_MAP = {
  BASIC: { id: "basic_hold", name: t("Basic Hold"), key: "BASIC" },
  DYNAMIC: { id: "dynamic_hold", name: t("Dynamic Hold"), key: "DYNAMIC" },
} as const;

export const BASKET_ON_HOLD_TYPE_MAP_BY_ID = {
  basic_hold: { id: "basic_hold", name: t("Basic Hold"), key: "BASIC" },
  dynamic_hold: { id: "dynamic_hold", name: t("Dynamic Hold"), key: "DYNAMIC" },
} as const;

export const BASKET_ON_HOLD_TYPE_MAP_BY_LIST = [
  { id: "basic_hold", name: t("Basic Hold"), key: "BASIC" },
  { id: "dynamic_hold", name: t("Dynamic Hold"), key: "DYNAMIC" },
] as const;

export const VENUE_PACKAGE_REVENUE_REALIZATION_TYPE_MAP = {
  PARENT: {
    id: "parent",
    name: t("Parent"),
    description:
      "Revenue will be realized on the parent items for a package purchase.",
    key: "PARENT",
  },
  CHILD: {
    id: "child",
    name: t("Child"),
    description:
      "Revenue will be realized on the child items for a package purchase.",
    key: "CHILD",
  },
} as const;

export const VENUE_PACKAGE_REVENUE_REALIZATION_TYPE_MAP_BY_ID = {
  parent: {
    id: "parent",
    name: t("Parent"),
    description:
      "Revenue will be realized on the parent items for a package purchase.",
    key: "PARENT",
  },
  child: {
    id: "child",
    name: t("Child"),
    description:
      "Revenue will be realized on the child items for a package purchase.",
    key: "CHILD",
  },
} as const;

export const VENUE_PACKAGE_REVENUE_REALIZATION_TYPE_MAP_BY_LIST = [
  {
    id: "parent",
    name: t("Parent"),
    description:
      "Revenue will be realized on the parent items for a package purchase.",
    key: "PARENT",
  },
  {
    id: "child",
    name: t("Child"),
    description:
      "Revenue will be realized on the child items for a package purchase.",
    key: "CHILD",
  },
] as const;

export const TICKET_PACKAGE_REVENUE_DISTRIBUTION_TYPE_MAP = {
  PARENT: {
    id: "parent",
    name: t("Parent"),
    description:
      "This distribution method acts as a placeholder for the old methodology for package revenue realization, where the financials are only set for the parent of the package.",
    usefulness:
      "This is deprecated and should be phased out, since it is not the recommended strategy for realizing revenue.",
  },
  UNIFORM: {
    id: "uniform",
    name: t("Uniform"),
    description:
      "The Uniform method allocates revenue amongst child event tickets by dividing the number of sub-tickets by the total amount of tickets in the package. That percent determines the profit assigned to that sub-ticket.",
    usefulness: "Simplified, with less accounting granularity",
  },
  PROPORTIONAL: {
    id: "proportional",
    name: t("Proportional"),
    description:
      "The Proportional method allocates revenue based on the weight of a sub-ticket, determined by its dollar value multiplied by its quantity. ",
    usefulness:
      "Very precise and is recommended for the highest accounting standards",
  },
} as const;

export const TICKET_PACKAGE_REVENUE_DISTRIBUTION_TYPE_MAP_BY_ID = {
  parent: {
    id: "parent",
    name: t("Parent"),
    description:
      "This distribution method acts as a placeholder for the old methodology for package revenue realization, where the financials are only set for the parent of the package.",
    usefulness:
      "This is deprecated and should be phased out, since it is not the recommended strategy for realizing revenue.",
  },
  uniform: {
    id: "uniform",
    name: t("Uniform"),
    description:
      "The Uniform method allocates revenue amongst child event tickets by dividing the number of sub-tickets by the total amount of tickets in the package. That percent determines the profit assigned to that sub-ticket.",
    usefulness: "Simplified, with less accounting granularity",
  },
  proportional: {
    id: "proportional",
    name: t("Proportional"),
    description:
      "The Proportional method allocates revenue based on the weight of a sub-ticket, determined by its dollar value multiplied by its quantity. ",
    usefulness:
      "Very precise and is recommended for the highest accounting standards",
  },
} as const;

export const TICKET_PACKAGE_REVENUE_DISTRIBUTION_TYPE_MAP_BY_LIST = [
  {
    id: "parent",
    name: t("Parent"),
    description:
      "This distribution method acts as a placeholder for the old methodology for package revenue realization, where the financials are only set for the parent of the package.",
    usefulness:
      "This is deprecated and should be phased out, since it is not the recommended strategy for realizing revenue.",
  },
  {
    id: "uniform",
    name: t("Uniform"),
    description:
      "The Uniform method allocates revenue amongst child event tickets by dividing the number of sub-tickets by the total amount of tickets in the package. That percent determines the profit assigned to that sub-ticket.",
    usefulness: "Simplified, with less accounting granularity",
  },
  {
    id: "proportional",
    name: t("Proportional"),
    description:
      "The Proportional method allocates revenue based on the weight of a sub-ticket, determined by its dollar value multiplied by its quantity. ",
    usefulness:
      "Very precise and is recommended for the highest accounting standards",
  },
] as const;

export const WAITLIST_STATUS_MAP = {
  ACTIVE: { id: "active", name: t("Active"), key: "ACTIVE" },
  EXPIRED: { id: "expired", name: t("Expired"), key: "EXPIRED" },
} as const;

export const WAITLIST_STATUS_MAP_BY_ID = {
  active: { id: "active", name: t("Active"), key: "ACTIVE" },
  expired: { id: "expired", name: t("Expired"), key: "EXPIRED" },
} as const;

export const WAITLIST_STATUS_MAP_BY_LIST = [
  { id: "active", name: t("Active"), key: "ACTIVE" },
  { id: "expired", name: t("Expired"), key: "EXPIRED" },
] as const;

export const WAITLIST_SUBSCRIBER_STATUS_MAP = {
  PENDING: { id: "pending", name: t("Pending"), key: "PENDING" },
  SCHEDULED: {
    id: "scheduled",
    name: t("Scheduled for processing"),
    key: "SCHEDULED",
  },
  IN_PROGRESS: {
    id: "in_progress",
    name: t("In Progress"),
    key: "IN_PROGRESS",
  },
  HOLD: { id: "hold", name: t("On Hold"), key: "HOLD" },
  COMPLETED: { id: "completed", name: t("Completed"), key: "COMPLETED" },
  CANCELLED: { id: "cancelled", name: t("Cancelled"), key: "CANCELLED" },
  EXPIRED: { id: "expired", name: t("Expired"), key: "EXPIRED" },
} as const;

export const WAITLIST_SUBSCRIBER_STATUS_MAP_BY_ID = {
  pending: { id: "pending", name: t("Pending"), key: "PENDING" },
  scheduled: {
    id: "scheduled",
    name: t("Scheduled for processing"),
    key: "SCHEDULED",
  },
  in_progress: {
    id: "in_progress",
    name: t("In Progress"),
    key: "IN_PROGRESS",
  },
  hold: { id: "hold", name: t("On Hold"), key: "HOLD" },
  completed: { id: "completed", name: t("Completed"), key: "COMPLETED" },
  cancelled: { id: "cancelled", name: t("Cancelled"), key: "CANCELLED" },
  expired: { id: "expired", name: t("Expired"), key: "EXPIRED" },
} as const;

export const WAITLIST_SUBSCRIBER_STATUS_MAP_BY_LIST = [
  { id: "pending", name: t("Pending"), key: "PENDING" },
  { id: "scheduled", name: t("Scheduled for processing"), key: "SCHEDULED" },
  { id: "in_progress", name: t("In Progress"), key: "IN_PROGRESS" },
  { id: "hold", name: t("On Hold"), key: "HOLD" },
  { id: "completed", name: t("Completed"), key: "COMPLETED" },
  { id: "cancelled", name: t("Cancelled"), key: "CANCELLED" },
  { id: "expired", name: t("Expired"), key: "EXPIRED" },
] as const;

export const RESALE_SUBMISSION_STATUS_MAP = {
  PENDING: {
    id: "pending",
    name: t("Listed"),
    payout_preference_editable: false,
    status_color: "warning",
    key: "PENDING",
  },
  IN_PROGRESS: {
    id: "in_progress",
    name: t("Processing"),
    payout_preference_editable: false,
    status_color: "warning",
    key: "IN_PROGRESS",
  },
  COMPLETED: {
    id: "completed",
    name: t("Completed"),
    payout_preference_editable: false,
    status_color: "success",
    key: "COMPLETED",
  },
  CANCELLED: {
    id: "cancelled",
    name: t("Cancelled"),
    payout_preference_editable: false,
    status_color: "error",
    key: "CANCELLED",
  },
  REFUND_FAILED: {
    id: "refund_failed",
    name: t("Payment method required"),
    payout_preference_editable: true,
    status_color: "error",
    key: "REFUND_FAILED",
  },
  BANKING_INFO_SUBMITTED: {
    id: "banking_info_submitted",
    name: t("Payment method submitted"),
    payout_preference_editable: true,
    status_color: "warning",
    key: "BANKING_INFO_SUBMITTED",
  },
  PAYOUT_PENDING: {
    id: "payout_pending",
    name: t("Payout pending"),
    payout_preference_editable: false,
    status_color: "warning",
    key: "PAYOUT_PENDING",
  },
  PAYOUT_FAILED: {
    id: "payout_failed",
    name: t("Payout failed"),
    payout_preference_editable: true,
    status_color: "error",
    key: "PAYOUT_FAILED",
  },
  PAYOUT_COMPLETED: {
    id: "payout_completed",
    name: t("Payout completed"),
    payout_preference_editable: false,
    status_color: "success",
    key: "PAYOUT_COMPLETED",
  },
} as const;

export const RESALE_SUBMISSION_STATUS_MAP_BY_ID = {
  pending: {
    id: "pending",
    name: t("Listed"),
    payout_preference_editable: false,
    status_color: "warning",
    key: "PENDING",
  },
  in_progress: {
    id: "in_progress",
    name: t("Processing"),
    payout_preference_editable: false,
    status_color: "warning",
    key: "IN_PROGRESS",
  },
  completed: {
    id: "completed",
    name: t("Completed"),
    payout_preference_editable: false,
    status_color: "success",
    key: "COMPLETED",
  },
  cancelled: {
    id: "cancelled",
    name: t("Cancelled"),
    payout_preference_editable: false,
    status_color: "error",
    key: "CANCELLED",
  },
  refund_failed: {
    id: "refund_failed",
    name: t("Payment method required"),
    payout_preference_editable: true,
    status_color: "error",
    key: "REFUND_FAILED",
  },
  banking_info_submitted: {
    id: "banking_info_submitted",
    name: t("Payment method submitted"),
    payout_preference_editable: true,
    status_color: "warning",
    key: "BANKING_INFO_SUBMITTED",
  },
  payout_pending: {
    id: "payout_pending",
    name: t("Payout pending"),
    payout_preference_editable: false,
    status_color: "warning",
    key: "PAYOUT_PENDING",
  },
  payout_failed: {
    id: "payout_failed",
    name: t("Payout failed"),
    payout_preference_editable: true,
    status_color: "error",
    key: "PAYOUT_FAILED",
  },
  payout_completed: {
    id: "payout_completed",
    name: t("Payout completed"),
    payout_preference_editable: false,
    status_color: "success",
    key: "PAYOUT_COMPLETED",
  },
} as const;

export const RESALE_SUBMISSION_STATUS_MAP_BY_LIST = [
  {
    id: "pending",
    name: t("Listed"),
    payout_preference_editable: false,
    status_color: "warning",
    key: "PENDING",
  },
  {
    id: "in_progress",
    name: t("Processing"),
    payout_preference_editable: false,
    status_color: "warning",
    key: "IN_PROGRESS",
  },
  {
    id: "completed",
    name: t("Completed"),
    payout_preference_editable: false,
    status_color: "success",
    key: "COMPLETED",
  },
  {
    id: "cancelled",
    name: t("Cancelled"),
    payout_preference_editable: false,
    status_color: "error",
    key: "CANCELLED",
  },
  {
    id: "refund_failed",
    name: t("Payment method required"),
    payout_preference_editable: true,
    status_color: "error",
    key: "REFUND_FAILED",
  },
  {
    id: "banking_info_submitted",
    name: t("Payment method submitted"),
    payout_preference_editable: true,
    status_color: "warning",
    key: "BANKING_INFO_SUBMITTED",
  },
  {
    id: "payout_pending",
    name: t("Payout pending"),
    payout_preference_editable: false,
    status_color: "warning",
    key: "PAYOUT_PENDING",
  },
  {
    id: "payout_failed",
    name: t("Payout failed"),
    payout_preference_editable: true,
    status_color: "error",
    key: "PAYOUT_FAILED",
  },
  {
    id: "payout_completed",
    name: t("Payout completed"),
    payout_preference_editable: false,
    status_color: "success",
    key: "PAYOUT_COMPLETED",
  },
] as const;

export const TAGGED_ITEM_TYPE_MAP = {
  venueuser: {
    id: "venueuser",
    name: t("VenueUser"),
    app_label: "venues",
    model: "venueuser",
    key: "venueuser",
  },
} as const;

export const TAGGED_ITEM_TYPE_MAP_BY_ID = {} as const;

export const TAGGED_ITEM_TYPE_MAP_BY_LIST = [] as const;

export const CHARITY_AGREEMENT_MAP = {
  CHECKOUT_REFUND_POLICY: {
    id: "checkout_refund_policy",
    name: t("Checkout Refund Policy"),
    content: t(
      'Please see our <strong><a href="https://help.showpass.com/hc/en-us/articles/360043062454" target="_blank"class="text-danger">FAQs</a></strong> to learn more about the donation process and our fee structure. <strong>Donations are non-refundable</strong>.'
    ),
    key: "CHECKOUT_REFUND_POLICY",
  },
  SHOWPASS_ACKNOWLEDGEMENT: {
    id: "showpass_acknowledgment",
    name: t("Showpass Acknowledgment"),
    content: t(
      "Once the transaction is complete Showpass will collect the funds to disperse to the selected charity. Automated tax receipts are currently not available."
    ),
    key: "SHOWPASS_ACKNOWLEDGEMENT",
  },
  EVENT_HELP: {
    id: "event_help",
    name: t("Event Help"),
    content: t(
      "Once a charity is selected, the customer will be presented with the option to add a donation during the checkout process. Customers will be able to choose from a preset amount, or they can enter in a custom donation amount."
    ),
    key: "EVENT_HELP",
  },
  EVENT_REFUND_POLICY: {
    id: "event_refund_policy",
    name: t("Event Refund Policy"),
    content: t(
      '<p>The customer will be charged a credit card processing fee on top of the donation amount.</p> <p>All donations are non-refundable.</p><p>Please review our <a href="https://help.showpass.com/hc/en-us/articles/360040023673" target="_blank" class="text-danger">help article</a> for more information.</p>'
    ),
    key: "EVENT_REFUND_POLICY",
  },
} as const;

export const CHARITY_AGREEMENT_MAP_BY_ID = {
  checkout_refund_policy: {
    id: "checkout_refund_policy",
    name: t("Checkout Refund Policy"),
    content: t(
      'Please see our <strong><a href="https://help.showpass.com/hc/en-us/articles/360043062454" target="_blank"class="text-danger">FAQs</a></strong> to learn more about the donation process and our fee structure. <strong>Donations are non-refundable</strong>.'
    ),
    key: "CHECKOUT_REFUND_POLICY",
  },
  showpass_acknowledgment: {
    id: "showpass_acknowledgment",
    name: t("Showpass Acknowledgment"),
    content: t(
      "Once the transaction is complete Showpass will collect the funds to disperse to the selected charity. Automated tax receipts are currently not available."
    ),
    key: "SHOWPASS_ACKNOWLEDGEMENT",
  },
  event_help: {
    id: "event_help",
    name: t("Event Help"),
    content: t(
      "Once a charity is selected, the customer will be presented with the option to add a donation during the checkout process. Customers will be able to choose from a preset amount, or they can enter in a custom donation amount."
    ),
    key: "EVENT_HELP",
  },
  event_refund_policy: {
    id: "event_refund_policy",
    name: t("Event Refund Policy"),
    content: t(
      '<p>The customer will be charged a credit card processing fee on top of the donation amount.</p> <p>All donations are non-refundable.</p><p>Please review our <a href="https://help.showpass.com/hc/en-us/articles/360040023673" target="_blank" class="text-danger">help article</a> for more information.</p>'
    ),
    key: "EVENT_REFUND_POLICY",
  },
} as const;

export const CHARITY_AGREEMENT_MAP_BY_LIST = [
  {
    id: "checkout_refund_policy",
    name: t("Checkout Refund Policy"),
    content: t(
      'Please see our <strong><a href="https://help.showpass.com/hc/en-us/articles/360043062454" target="_blank"class="text-danger">FAQs</a></strong> to learn more about the donation process and our fee structure. <strong>Donations are non-refundable</strong>.'
    ),
    key: "CHECKOUT_REFUND_POLICY",
  },
  {
    id: "showpass_acknowledgment",
    name: t("Showpass Acknowledgment"),
    content: t(
      "Once the transaction is complete Showpass will collect the funds to disperse to the selected charity. Automated tax receipts are currently not available."
    ),
    key: "SHOWPASS_ACKNOWLEDGEMENT",
  },
  {
    id: "event_help",
    name: t("Event Help"),
    content: t(
      "Once a charity is selected, the customer will be presented with the option to add a donation during the checkout process. Customers will be able to choose from a preset amount, or they can enter in a custom donation amount."
    ),
    key: "EVENT_HELP",
  },
  {
    id: "event_refund_policy",
    name: t("Event Refund Policy"),
    content: t(
      '<p>The customer will be charged a credit card processing fee on top of the donation amount.</p> <p>All donations are non-refundable.</p><p>Please review our <a href="https://help.showpass.com/hc/en-us/articles/360040023673" target="_blank" class="text-danger">help article</a> for more information.</p>'
    ),
    key: "EVENT_REFUND_POLICY",
  },
] as const;

export const DISCOUNT_LIMIT_TYPE_MAP = {
  DISC_LIMIT_TYPE_ITEM_QUANTITY: {
    id: 1,
    name: t("Item quantity"),
    key: "DISC_LIMIT_TYPE_ITEM_QUANTITY",
  },
  DISC_LIMIT_TYPE_TOTAL_BASKET_QUANTITY: {
    id: 2,
    name: t("Total basket quantity"),
    key: "DISC_LIMIT_TYPE_TOTAL_BASKET_QUANTITY",
  },
  DISC_LIMIT_TYPE_TOTAL_PURCHASE_AMOUNT: {
    id: 3,
    name: t("Total purchase amount"),
    key: "DISC_LIMIT_TYPE_TOTAL_PURCHASE_AMOUNT",
  },
} as const;

export const DISCOUNT_LIMIT_TYPE_MAP_BY_ID = {
  "1": {
    id: 1,
    name: t("Item quantity"),
    key: "DISC_LIMIT_TYPE_ITEM_QUANTITY",
  },
  "2": {
    id: 2,
    name: t("Total basket quantity"),
    key: "DISC_LIMIT_TYPE_TOTAL_BASKET_QUANTITY",
  },
  "3": {
    id: 3,
    name: t("Total purchase amount"),
    key: "DISC_LIMIT_TYPE_TOTAL_PURCHASE_AMOUNT",
  },
} as const;

export const DISCOUNT_LIMIT_TYPE_MAP_BY_LIST = [
  { id: 1, name: t("Item quantity"), key: "DISC_LIMIT_TYPE_ITEM_QUANTITY" },
  {
    id: 2,
    name: t("Total basket quantity"),
    key: "DISC_LIMIT_TYPE_TOTAL_BASKET_QUANTITY",
  },
  {
    id: 3,
    name: t("Total purchase amount"),
    key: "DISC_LIMIT_TYPE_TOTAL_PURCHASE_AMOUNT",
  },
] as const;

export const MEMBERSHIP_EVENT_BATCH_TYPE_MAP = {
  TICKET: { id: "ticket", name: t("Ticket"), key: "TICKET" },
  HOLD: { id: "hold", name: t("Hold"), key: "HOLD" },
} as const;

export const MEMBERSHIP_EVENT_BATCH_TYPE_MAP_BY_ID = {
  ticket: { id: "ticket", name: t("Ticket"), key: "TICKET" },
  hold: { id: "hold", name: t("Hold"), key: "HOLD" },
} as const;

export const MEMBERSHIP_EVENT_BATCH_TYPE_MAP_BY_LIST = [
  { id: "ticket", name: t("Ticket"), key: "TICKET" },
  { id: "hold", name: t("Hold"), key: "HOLD" },
] as const;

export const ROTATING_BARCODE_MAP = {
  prefix: { id: "prefix", name: t("Prefix"), value: "R", key: "prefix" },
  barcode: { id: "barcode", name: t("Barcode"), key: "barcode" },
  totp: { id: "totp", name: t("TOTP"), key: "totp" },
  regex: {
    id: "regex",
    name: t("Regex"),
    value: "(?P<prefix>\\w+)-(?P<barcode>(\\w+)(-(1|2|3))?)-(?P<totp>\\w{2,})$",
    key: "regex",
  },
  secret: {
    id: "secret",
    name: t("Secret"),
    value: "8DazlbkMiylNRq20K4OQo7aKv4laQXNa",
    key: "secret",
  },
  interval: { id: "interval", name: t("Interval"), value: 60, key: "interval" },
  digest: { id: "digest", name: t("Digest"), value: "sha1", key: "digest" },
  digits: { id: "digits", name: t("Digits"), value: 6, key: "digits" },
  valid_window: {
    id: "valid_window",
    name: t("Valid Window"),
    value: 2,
    key: "valid_window",
  },
} as const;

export const ROTATING_BARCODE_MAP_BY_ID = {} as const;

export const ROTATING_BARCODE_MAP_BY_LIST = [] as const;

export const SCANNER_DEVICE_MAP = {
  "1": {
    id: 1,
    name: t("Zebra Scanner Barcode"),
    is_nfc_scanner: false,
    ui_reference: "ZEBRA_SCANNER_BARCODE",
    key: 1,
  },
  "2": {
    id: 2,
    name: t("Zebra Scanner NFC"),
    is_nfc_scanner: true,
    ui_reference: "ZEBRA_SCANNER_NFC",
    key: 2,
  },
  "3": {
    id: 3,
    name: t("iPhone"),
    is_nfc_scanner: false,
    ui_reference: "IPHONE",
    key: 3,
  },
  "4": {
    id: 4,
    name: t("Android Phone"),
    is_nfc_scanner: false,
    ui_reference: "ANDROID_PHONE",
    key: 4,
  },
  "5": {
    id: 5,
    name: t("Web App"),
    is_nfc_scanner: false,
    ui_reference: "WEB_APP",
    key: 5,
  },
} as const;

export const SCANNER_DEVICE_MAP_BY_ID = {} as const;

export const SCANNER_DEVICE_MAP_BY_LIST = [] as const;

export const ARTIST_TYPE_MAP = {
  PERSON: { id: "person", name: t("Person"), key: "PERSON" },
  GROUP: { id: "group", name: t("Group"), key: "GROUP" },
  ORCHESTRA: { id: "orchestra", name: t("Orchestra"), key: "ORCHESTRA" },
  CHOIR: { id: "choir", name: t("Choir"), key: "CHOIR" },
  CHARACTER: { id: "character", name: t("Character"), key: "CHARACTER" },
  OTHER: { id: "other", name: t("Other"), key: "OTHER" },
} as const;

export const ARTIST_TYPE_MAP_BY_ID = {
  person: { id: "person", name: t("Person"), key: "PERSON" },
  group: { id: "group", name: t("Group"), key: "GROUP" },
  orchestra: { id: "orchestra", name: t("Orchestra"), key: "ORCHESTRA" },
  choir: { id: "choir", name: t("Choir"), key: "CHOIR" },
  character: { id: "character", name: t("Character"), key: "CHARACTER" },
  other: { id: "other", name: t("Other"), key: "OTHER" },
} as const;

export const ARTIST_TYPE_MAP_BY_LIST = [
  { id: "person", name: t("Person"), key: "PERSON" },
  { id: "group", name: t("Group"), key: "GROUP" },
  { id: "orchestra", name: t("Orchestra"), key: "ORCHESTRA" },
  { id: "choir", name: t("Choir"), key: "CHOIR" },
  { id: "character", name: t("Character"), key: "CHARACTER" },
  { id: "other", name: t("Other"), key: "OTHER" },
] as const;

export const ARTIST_URL_TYPE_MAP = {
  FACEBOOK: {
    id: "facebook",
    name: t("Facebook"),
    domain: "facebook.com",
    key: "FACEBOOK",
  },
  INSTAGRAM: {
    id: "instagram",
    name: t("Instagram"),
    domain: "instagram.com",
    key: "INSTAGRAM",
  },
  X: { id: "x", name: t("x"), domain: "x.com", key: "X" },
  YOUTUBE: {
    id: "youtube",
    name: t("YouTube"),
    domain: "youtube.com",
    key: "YOUTUBE",
  },
  WIKIPEDIA: {
    id: "wikipedia",
    name: t("Wikipedia"),
    domain: "wikipedia.org",
    key: "WIKIPEDIA",
  },
  WEBSITE: { id: "website", name: t("Website"), key: "WEBSITE" },
} as const;

export const ARTIST_URL_TYPE_MAP_BY_ID = {
  facebook: {
    id: "facebook",
    name: t("Facebook"),
    domain: "facebook.com",
    key: "FACEBOOK",
  },
  instagram: {
    id: "instagram",
    name: t("Instagram"),
    domain: "instagram.com",
    key: "INSTAGRAM",
  },
  x: { id: "x", name: t("x"), domain: "x.com", key: "X" },
  youtube: {
    id: "youtube",
    name: t("YouTube"),
    domain: "youtube.com",
    key: "YOUTUBE",
  },
  wikipedia: {
    id: "wikipedia",
    name: t("Wikipedia"),
    domain: "wikipedia.org",
    key: "WIKIPEDIA",
  },
  website: { id: "website", name: t("Website"), key: "WEBSITE" },
} as const;

export const ARTIST_URL_TYPE_MAP_BY_LIST = [
  {
    id: "facebook",
    name: t("Facebook"),
    domain: "facebook.com",
    key: "FACEBOOK",
  },
  {
    id: "instagram",
    name: t("Instagram"),
    domain: "instagram.com",
    key: "INSTAGRAM",
  },
  { id: "x", name: t("x"), domain: "x.com", key: "X" },
  { id: "youtube", name: t("YouTube"), domain: "youtube.com", key: "YOUTUBE" },
  {
    id: "wikipedia",
    name: t("Wikipedia"),
    domain: "wikipedia.org",
    key: "WIKIPEDIA",
  },
  { id: "website", name: t("Website"), key: "WEBSITE" },
] as const;

export const USER_BASED_RETURN_MAP = {
  "1": { id: 1, name: t("Not Provided"), key: 1 },
  "2": { id: 2, name: t("Bought by Mistake"), key: 2 },
  "3": { id: 3, name: t("Can No Longer Attend"), key: 3 },
  "4": { id: 4, name: t("Inaccurate Description"), key: 4 },
  "5": { id: 5, name: t("Wrong Event"), key: 5 },
  "6": { id: 6, name: t("Wrong Ticket"), key: 6 },
  "7": { id: 7, name: t("Other"), key: 7 },
} as const;

export const USER_BASED_RETURN_MAP_BY_ID = {} as const;

export const USER_BASED_RETURN_MAP_BY_LIST = [] as const;

export const TICKETS_VALIDATION_ERROR_MAP = {
  TVEM_UNFULFILLABLE_SERVICE_COMBINATION: {
    id: 1994,
    name: t("Unfillable Service Combination"),
    key: "TVEM_UNFULFILLABLE_SERVICE_COMBINATION",
  },
  TVEM_UNFULFILLABLE_LINE_ITEM: {
    id: 1995,
    name: t("Unfillable Line Item"),
    key: "TVEM_UNFULFILLABLE_LINE_ITEM",
  },
  TVEM_BASKET_LOCK_TIMEOUT: {
    id: 1996,
    name: t("Basket Lock Timeout"),
    key: "TVEM_BASKET_LOCK_TIMEOUT",
  },
  TVEM_MAX_TICKET_CONSTRAINT_VIOLATED: {
    id: 1950,
    name: t("Maximum Ticket Constraint Violated"),
    key: "TVEM_MAX_TICKET_CONSTRAINT_VIOLATED",
  },
  TVEM_MIN_TICKET_CONSTRAINT_VIOLATED: {
    id: 1951,
    name: t("Minimum Ticket Constraint Violated"),
    key: "TVEM_MIN_TICKET_CONSTRAINT_VIOLATED",
  },
  TVEM_OTHER_REASON: {
    id: 1985,
    name: t("Other Reason"),
    key: "TVEM_OTHER_REASON",
  },
  non_field_errors: {
    id: 1986,
    name: t("Other Reason"),
    key: "non_field_errors",
  },
} as const;

export const TICKETS_VALIDATION_ERROR_MAP_BY_ID = {
  "1950": {
    id: 1950,
    name: t("Maximum Ticket Constraint Violated"),
    key: "TVEM_MAX_TICKET_CONSTRAINT_VIOLATED",
  },
  "1951": {
    id: 1951,
    name: t("Minimum Ticket Constraint Violated"),
    key: "TVEM_MIN_TICKET_CONSTRAINT_VIOLATED",
  },
  "1985": { id: 1985, name: t("Other Reason"), key: "TVEM_OTHER_REASON" },
  "1986": { id: 1986, name: t("Other Reason"), key: "non_field_errors" },
  "1994": {
    id: 1994,
    name: t("Unfillable Service Combination"),
    key: "TVEM_UNFULFILLABLE_SERVICE_COMBINATION",
  },
  "1995": {
    id: 1995,
    name: t("Unfillable Line Item"),
    key: "TVEM_UNFULFILLABLE_LINE_ITEM",
  },
  "1996": {
    id: 1996,
    name: t("Basket Lock Timeout"),
    key: "TVEM_BASKET_LOCK_TIMEOUT",
  },
} as const;

export const TICKETS_VALIDATION_ERROR_MAP_BY_LIST = [
  {
    id: 1950,
    name: t("Maximum Ticket Constraint Violated"),
    key: "TVEM_MAX_TICKET_CONSTRAINT_VIOLATED",
  },
  {
    id: 1951,
    name: t("Minimum Ticket Constraint Violated"),
    key: "TVEM_MIN_TICKET_CONSTRAINT_VIOLATED",
  },
  { id: 1985, name: t("Other Reason"), key: "TVEM_OTHER_REASON" },
  { id: 1986, name: t("Other Reason"), key: "non_field_errors" },
  {
    id: 1994,
    name: t("Unfillable Service Combination"),
    key: "TVEM_UNFULFILLABLE_SERVICE_COMBINATION",
  },
  {
    id: 1995,
    name: t("Unfillable Line Item"),
    key: "TVEM_UNFULFILLABLE_LINE_ITEM",
  },
  { id: 1996, name: t("Basket Lock Timeout"), key: "TVEM_BASKET_LOCK_TIMEOUT" },
] as const;

export const USER_VALIDATION_ERROR_MAP = {
  UVEM_OTP_CODE_SENT: {
    id: 2994,
    name: t("Authentication code sent to your email. Please provide the code"),
    key: "UVEM_OTP_CODE_SENT",
  },
  UVEM_OTP_CODE_INVALID: {
    id: 2995,
    name: t("Authentication code is not valid. Please try again."),
    key: "UVEM_OTP_CODE_INVALID",
  },
} as const;

export const USER_VALIDATION_ERROR_MAP_BY_ID = {
  "2994": {
    id: 2994,
    name: t("Authentication code sent to your email. Please provide the code"),
    key: "UVEM_OTP_CODE_SENT",
  },
  "2995": {
    id: 2995,
    name: t("Authentication code is not valid. Please try again."),
    key: "UVEM_OTP_CODE_INVALID",
  },
} as const;

export const USER_VALIDATION_ERROR_MAP_BY_LIST = [
  {
    id: 2994,
    name: t("Authentication code sent to your email. Please provide the code"),
    key: "UVEM_OTP_CODE_SENT",
  },
  {
    id: 2995,
    name: t("Authentication code is not valid. Please try again."),
    key: "UVEM_OTP_CODE_INVALID",
  },
] as const;

export const DYN_FORM_INPUT_TYPE_OPTIONS_MAP = {
  text: {
    id: "text",
    name: "Text input",
    options_required: false,
    max_response_length: 300,
  },
  select: {
    id: "select",
    name: "Select box",
    options_required: true,
    max_response_length: null,
  },
  paragraph: {
    id: "paragraph",
    name: "Paragraph",
    options_required: false,
    max_response_length: 1000,
  },
  date: {
    id: "date",
    name: "Date input",
    options_required: false,
    max_response_length: null,
  },
  int: {
    id: "int",
    name: "Integer input (Max 9 digits)",
    options_required: false,
    max_response_length: 9,
  },
  char_int: {
    id: "char_int",
    name: "Long Integer input (Max 16 digits)",
    options_required: false,
    max_response_length: 16,
  },
  decimal: {
    id: "decimal",
    name: "Decimal input",
    options_required: false,
    max_response_length: 10,
  },
  html: {
    id: "html",
    name: "HTML input",
    options_required: false,
    max_response_length: 2048,
  },
  checkbox_group: {
    id: "checkbox_group",
    name: "Checkbox group",
    options_required: false,
    max_response_length: null,
    custom_html_available: true,
  },
} as const;

export const THIRD_PARTY_REDIRECT_OPTIONS = {
  PAGE_LOAD: { id: "page_load", name: t("Event Page Load"), key: "PAGE_LOAD" },
  BUY_NOW: { id: "buy_now", name: t("Event Purchase Button"), key: "BUY_NOW" },
} as const;

export const THIRD_PARTY_REDIRECT_OPTIONS_BY_ID = {
  page_load: { id: "page_load", name: t("Event Page Load"), key: "PAGE_LOAD" },
  buy_now: { id: "buy_now", name: t("Event Purchase Button"), key: "BUY_NOW" },
} as const;

export const THIRD_PARTY_REDIRECT_OPTIONS_BY_LIST = [
  { id: "page_load", name: t("Event Page Load"), key: "PAGE_LOAD" },
  { id: "buy_now", name: t("Event Purchase Button"), key: "BUY_NOW" },
] as const;

export const VENUE_REFERRAL_SOURCE_MAP = {
  GOOGLE_SEARCH: {
    id: "google_search",
    name: t("Google Search"),
    key: "GOOGLE_SEARCH",
  },
  REVIEW_SITE: {
    id: "review_site",
    name: t("Platform Review Website"),
    key: "REVIEW_SITE",
  },
  MARKETING_EMAIL: {
    id: "marketing_email",
    name: t("Showpass Marketing Email"),
    key: "MARKETING_EMAIL",
  },
  FACEBOOK: { id: "facebook", name: t("Facebook"), key: "FACEBOOK" },
  INSTAGRAM: { id: "instagram", name: t("Instagram"), key: "INSTAGRAM" },
  LINKEDIN: { id: "linkedin", name: t("LinkedIn"), key: "LINKEDIN" },
  REFERRAL: { id: "referral", name: t("Referral"), key: "REFERRAL" },
  SALES: { id: "sales", name: t("Showpass Sales Team"), key: "SALES" },
  TRADE_SHOW: { id: "trade_show", name: t("Trade Show"), key: "TRADE_SHOW" },
  OTHER: { id: "other", name: t("Other"), key: "OTHER" },
} as const;

export const VENUE_REFERRAL_SOURCE_MAP_BY_ID = {
  google_search: {
    id: "google_search",
    name: t("Google Search"),
    key: "GOOGLE_SEARCH",
  },
  review_site: {
    id: "review_site",
    name: t("Platform Review Website"),
    key: "REVIEW_SITE",
  },
  marketing_email: {
    id: "marketing_email",
    name: t("Showpass Marketing Email"),
    key: "MARKETING_EMAIL",
  },
  facebook: { id: "facebook", name: t("Facebook"), key: "FACEBOOK" },
  instagram: { id: "instagram", name: t("Instagram"), key: "INSTAGRAM" },
  linkedin: { id: "linkedin", name: t("LinkedIn"), key: "LINKEDIN" },
  referral: { id: "referral", name: t("Referral"), key: "REFERRAL" },
  sales: { id: "sales", name: t("Showpass Sales Team"), key: "SALES" },
  trade_show: { id: "trade_show", name: t("Trade Show"), key: "TRADE_SHOW" },
  other: { id: "other", name: t("Other"), key: "OTHER" },
} as const;

export const VENUE_REFERRAL_SOURCE_MAP_BY_LIST = [
  { id: "google_search", name: t("Google Search"), key: "GOOGLE_SEARCH" },
  { id: "review_site", name: t("Platform Review Website"), key: "REVIEW_SITE" },
  {
    id: "marketing_email",
    name: t("Showpass Marketing Email"),
    key: "MARKETING_EMAIL",
  },
  { id: "facebook", name: t("Facebook"), key: "FACEBOOK" },
  { id: "instagram", name: t("Instagram"), key: "INSTAGRAM" },
  { id: "linkedin", name: t("LinkedIn"), key: "LINKEDIN" },
  { id: "referral", name: t("Referral"), key: "REFERRAL" },
  { id: "sales", name: t("Showpass Sales Team"), key: "SALES" },
  { id: "trade_show", name: t("Trade Show"), key: "TRADE_SHOW" },
  { id: "other", name: t("Other"), key: "OTHER" },
] as const;

export const DISCOVERY_VIEW_TYPE_MAP = {
  event: { id: "event", name: t("Event"), key: "event" },
  membership: { id: "membership", name: t("Membership"), key: "membership" },
} as const;

export const DISCOVERY_VIEW_TYPE_MAP_BY_ID = {} as const;

export const DISCOVERY_VIEW_TYPE_MAP_BY_LIST = [] as const;

export const CUSTOMER_GROUP_STATUS_MAP = {
  ACTIVE: { id: 1, name: t("Active"), key: "ACTIVE" },
  INACTIVE: { id: 2, name: t("Inactive"), key: "INACTIVE" },
} as const;

export const CUSTOMER_GROUP_STATUS_MAP_BY_ID = {
  "1": { id: 1, name: t("Active"), key: "ACTIVE" },
  "2": { id: 2, name: t("Inactive"), key: "INACTIVE" },
} as const;

export const CUSTOMER_GROUP_STATUS_MAP_BY_LIST = [
  { id: 1, name: t("Active"), key: "ACTIVE" },
  { id: 2, name: t("Inactive"), key: "INACTIVE" },
] as const;

export const CUSTOMER_GROUP_STATS_GROUP_ITEM_STATUS_MAP = {
  CGSGIS_ACTIVE: {
    id: "CGSGIS_ACTIVE",
    name: t("Active"),
    key: "CGSGIS_ACTIVE",
  },
  CGSGIS_INACTIVE: {
    id: "CGSGIS_INACTIVE",
    name: t("Inactive"),
    key: "CGSGIS_INACTIVE",
  },
} as const;

export const CUSTOMER_GROUP_STATS_GROUP_ITEM_STATUS_MAP_BY_ID = {} as const;

export const CUSTOMER_GROUP_STATS_GROUP_ITEM_STATUS_MAP_BY_LIST = [] as const;

export const GOOGLE_OAUTH_MAP = {
  CLIENT_ID: {
    id: "client_id",
    name: t("Client ID"),
    key_value:
      "394355680138-3ggqhsci25ggsrk1opa8sjkq5kioagle.apps.googleusercontent.com",
    key: "CLIENT_ID",
  },
} as const;

export const GOOGLE_OAUTH_MAP_BY_ID = {
  client_id: {
    id: "client_id",
    name: t("Client ID"),
    key_value:
      "394355680138-3ggqhsci25ggsrk1opa8sjkq5kioagle.apps.googleusercontent.com",
    key: "CLIENT_ID",
  },
} as const;

export const GOOGLE_OAUTH_MAP_BY_LIST = [
  {
    id: "client_id",
    name: t("Client ID"),
    key_value:
      "394355680138-3ggqhsci25ggsrk1opa8sjkq5kioagle.apps.googleusercontent.com",
    key: "CLIENT_ID",
  },
] as const;

export const SALESFORCE_ENTITY_ID_PREFIX_MAP = {
  ACCOUNT: { id: "001", name: t("Account"), key: "ACCOUNT" },
  CONTACT: { id: "003", name: t("Contact"), key: "CONTACT" },
  LEAD: { id: "00Q", name: t("Lead"), key: "LEAD" },
  ACCOUNT_CONTACT_RELATION: {
    id: "07k",
    name: t("AccountContactRelation"),
    key: "ACCOUNT_CONTACT_RELATION",
  },
} as const;

export const SALESFORCE_ENTITY_ID_PREFIX_MAP_BY_ID = {
  "001": { id: "001", name: t("Account"), key: "ACCOUNT" },
  "003": { id: "003", name: t("Contact"), key: "CONTACT" },
  "00Q": { id: "00Q", name: t("Lead"), key: "LEAD" },
  "07k": {
    id: "07k",
    name: t("AccountContactRelation"),
    key: "ACCOUNT_CONTACT_RELATION",
  },
} as const;

export const SALESFORCE_ENTITY_ID_PREFIX_MAP_BY_LIST = [
  { id: "001", name: t("Account"), key: "ACCOUNT" },
  { id: "003", name: t("Contact"), key: "CONTACT" },
  { id: "00Q", name: t("Lead"), key: "LEAD" },
  {
    id: "07k",
    name: t("AccountContactRelation"),
    key: "ACCOUNT_CONTACT_RELATION",
  },
] as const;

export const BULK_UPDATE_TYPE_MAP = {
  inventory: { id: "inventory", name: t("Inventory"), key: "inventory" },
  price: { id: "price", name: t("Price"), key: "price" },
  name: { id: "name", name: t("Name"), key: "name" },
} as const;

export const BULK_UPDATE_TYPE_MAP_BY_ID = {} as const;

export const BULK_UPDATE_TYPE_MAP_BY_LIST = [] as const;

export const ACCOMMODATION_PARTNER_TYPE_MAP = {
  no_partner: {
    id: "no_partner",
    name: t("No Partner"),
    base_url: null,
    key: "no_partner",
  },
  hotel_planner: {
    id: "hotel_planner",
    name: t("HotelPlanner"),
    base_url: "https://showpass.hotelplanner.com/Search/",
    key: "hotel_planner",
  },
} as const;

export const ACCOMMODATION_PARTNER_TYPE_MAP_BY_ID = {} as const;

export const ACCOMMODATION_PARTNER_TYPE_MAP_BY_LIST = [] as const;

export const MODULE_PRICE_TRIAL_DELTA_MAP = {
  ONE_MONTH: { id: "one_month", name: t("One Month"), key: "ONE_MONTH" },
  ONE_YEAR: { id: "one_year", name: t("One Year"), key: "ONE_YEAR" },
  CUSTOM: { id: "custom", name: t("Custom"), key: "CUSTOM" },
} as const;

export const MODULE_PRICE_TRIAL_DELTA_MAP_BY_ID = {
  one_month: { id: "one_month", name: t("One Month"), key: "ONE_MONTH" },
  one_year: { id: "one_year", name: t("One Year"), key: "ONE_YEAR" },
  custom: { id: "custom", name: t("Custom"), key: "CUSTOM" },
} as const;

export const MODULE_PRICE_TRIAL_DELTA_MAP_BY_LIST = [
  { id: "one_month", name: t("One Month"), key: "ONE_MONTH" },
  { id: "one_year", name: t("One Year"), key: "ONE_YEAR" },
  { id: "custom", name: t("Custom"), key: "CUSTOM" },
] as const;

export const MODULE_TYPE_MAP = {
  INDUSTRY_DASHBOARD: {
    id: "industry_dashboard",
    name: t("Industry Dashboard"),
    module_group_type: "advanced_analytics",
    documentation_links: [],
  },
  CUSTOM_DASHBOARD: {
    id: "custom_dashboard",
    name: t("Custom Dashboard"),
    module_group_type: "advanced_analytics",
    documentation_links: [],
  },
  ANALYTICS_PARTNER_PROGRAM: {
    id: "analytics_partner_program",
    name: t("Partner Program"),
    module_group_type: "advanced_analytics",
    documentation_links: [],
  },
} as const;

export const MODULE_TYPE_MAP_BY_ID = {
  industry_dashboard: {
    id: "industry_dashboard",
    name: t("Industry Dashboard"),
    module_group_type: "advanced_analytics",
    documentation_links: [],
  },
  custom_dashboard: {
    id: "custom_dashboard",
    name: t("Custom Dashboard"),
    module_group_type: "advanced_analytics",
    documentation_links: [],
  },
  analytics_partner_program: {
    id: "analytics_partner_program",
    name: t("Partner Program"),
    module_group_type: "advanced_analytics",
    documentation_links: [],
  },
} as const;

export const MODULE_TYPE_MAP_BY_LIST = [
  {
    id: "industry_dashboard",
    name: t("Industry Dashboard"),
    module_group_type: "advanced_analytics",
    documentation_links: [],
  },
  {
    id: "custom_dashboard",
    name: t("Custom Dashboard"),
    module_group_type: "advanced_analytics",
    documentation_links: [],
  },
  {
    id: "analytics_partner_program",
    name: t("Partner Program"),
    module_group_type: "advanced_analytics",
    documentation_links: [],
  },
] as const;

export const MODULE_USAGE_STATUS_MAP = {
  ENABLED: { id: "enabled", name: t("Enabled"), key: "ENABLED" },
  DISABLED: { id: "disabled", name: t("Disabled"), key: "DISABLED" },
  HIDDEN: { id: "hidden", name: t("Hidden"), key: "HIDDEN" },
  SUGGESTED: { id: "suggested", name: t("Suggested"), key: "SUGGESTED" },
} as const;

export const MODULE_USAGE_STATUS_MAP_BY_ID = {
  enabled: { id: "enabled", name: t("Enabled"), key: "ENABLED" },
  disabled: { id: "disabled", name: t("Disabled"), key: "DISABLED" },
  hidden: { id: "hidden", name: t("Hidden"), key: "HIDDEN" },
  suggested: { id: "suggested", name: t("Suggested"), key: "SUGGESTED" },
} as const;

export const MODULE_USAGE_STATUS_MAP_BY_LIST = [
  { id: "enabled", name: t("Enabled"), key: "ENABLED" },
  { id: "disabled", name: t("Disabled"), key: "DISABLED" },
  { id: "hidden", name: t("Hidden"), key: "HIDDEN" },
  { id: "suggested", name: t("Suggested"), key: "SUGGESTED" },
] as const;

export const MODULE_PRICE_TYPE_MAP = {
  FREE_TRIAL: {
    id: "free_trial",
    name: t("Free Trial"),
    default_status: "inactive",
    key: "FREE_TRIAL",
  },
  FREE: {
    id: "free",
    name: t("Free"),
    default_status: "inactive",
    key: "FREE",
  },
  PER_ITEM: {
    id: "per_item",
    name: t("Per Item Showpass Fee"),
    default_status: "inactive",
    key: "PER_ITEM",
  },
  PER_ITEM_PROCESSING: {
    id: "per_item_processing",
    name: t("Per Item Processing Fee"),
    default_status: "inactive",
    key: "PER_ITEM_PROCESSING",
  },
  ONE_TIME: {
    id: "one_time",
    name: t("One Time Fee"),
    default_status: "inactive",
    key: "ONE_TIME",
  },
} as const;

export const MODULE_PRICE_TYPE_MAP_BY_ID = {
  free_trial: {
    id: "free_trial",
    name: t("Free Trial"),
    default_status: "inactive",
    key: "FREE_TRIAL",
  },
  free: {
    id: "free",
    name: t("Free"),
    default_status: "inactive",
    key: "FREE",
  },
  per_item: {
    id: "per_item",
    name: t("Per Item Showpass Fee"),
    default_status: "inactive",
    key: "PER_ITEM",
  },
  per_item_processing: {
    id: "per_item_processing",
    name: t("Per Item Processing Fee"),
    default_status: "inactive",
    key: "PER_ITEM_PROCESSING",
  },
  one_time: {
    id: "one_time",
    name: t("One Time Fee"),
    default_status: "inactive",
    key: "ONE_TIME",
  },
} as const;

export const MODULE_PRICE_TYPE_MAP_BY_LIST = [
  {
    id: "free_trial",
    name: t("Free Trial"),
    default_status: "inactive",
    key: "FREE_TRIAL",
  },
  { id: "free", name: t("Free"), default_status: "inactive", key: "FREE" },
  {
    id: "per_item",
    name: t("Per Item Showpass Fee"),
    default_status: "inactive",
    key: "PER_ITEM",
  },
  {
    id: "per_item_processing",
    name: t("Per Item Processing Fee"),
    default_status: "inactive",
    key: "PER_ITEM_PROCESSING",
  },
  {
    id: "one_time",
    name: t("One Time Fee"),
    default_status: "inactive",
    key: "ONE_TIME",
  },
] as const;

export const MODULE_PRICE_STATUS_MAP = {
  ACTIVE: { id: "active", name: t("Active"), key: "ACTIVE" },
  INACTIVE: { id: "inactive", name: t("Inactive"), key: "INACTIVE" },
} as const;

export const MODULE_PRICE_STATUS_MAP_BY_ID = {
  active: { id: "active", name: t("Active"), key: "ACTIVE" },
  inactive: { id: "inactive", name: t("Inactive"), key: "INACTIVE" },
} as const;

export const MODULE_PRICE_STATUS_MAP_BY_LIST = [
  { id: "active", name: t("Active"), key: "ACTIVE" },
  { id: "inactive", name: t("Inactive"), key: "INACTIVE" },
] as const;

export const MODULE_GROUP_TYPE_MAP = {
  NONE: { id: "none", name: t("None"), description: null, key: "NONE" },
  ADVANCED_ANALYTICS: {
    id: "advanced_analytics",
    name: t("Advanced Analytics"),
    description: "",
    key: "ADVANCED_ANALYTICS",
  },
  ADVANCED_TICKET_TYPES: {
    id: "advanced_ticket_types",
    name: t("Advanced Ticket Types"),
    description: "",
    key: "ADVANCED_TICKET_TYPES",
  },
} as const;

export const MODULE_GROUP_TYPE_MAP_BY_ID = {
  none: { id: "none", name: t("None"), description: null, key: "NONE" },
  advanced_analytics: {
    id: "advanced_analytics",
    name: t("Advanced Analytics"),
    description: "",
    key: "ADVANCED_ANALYTICS",
  },
  advanced_ticket_types: {
    id: "advanced_ticket_types",
    name: t("Advanced Ticket Types"),
    description: "",
    key: "ADVANCED_TICKET_TYPES",
  },
} as const;

export const MODULE_GROUP_TYPE_MAP_BY_LIST = [
  { id: "none", name: t("None"), description: null, key: "NONE" },
  {
    id: "advanced_analytics",
    name: t("Advanced Analytics"),
    description: "",
    key: "ADVANCED_ANALYTICS",
  },
  {
    id: "advanced_ticket_types",
    name: t("Advanced Ticket Types"),
    description: "",
    key: "ADVANCED_TICKET_TYPES",
  },
] as const;

export const MODULE_SUB_OPTION_TYPE_MAP = {
  INDUSTRY_DASHBOARD_SUB_OPTION: {
    id: "industry_dashboard_sub_option",
    name: t("Industry Dashboard Sub Option"),
    key: "INDUSTRY_DASHBOARD_SUB_OPTION",
  },
  CUSTOM_DASHBOARD_SUB_OPTION: {
    id: "custom_dashboard_sub_option",
    name: t("Custom Dashboard Sub Option"),
    key: "CUSTOM_DASHBOARD_SUB_OPTION",
  },
} as const;

export const MODULE_SUB_OPTION_TYPE_MAP_BY_ID = {
  industry_dashboard_sub_option: {
    id: "industry_dashboard_sub_option",
    name: t("Industry Dashboard Sub Option"),
    key: "INDUSTRY_DASHBOARD_SUB_OPTION",
  },
  custom_dashboard_sub_option: {
    id: "custom_dashboard_sub_option",
    name: t("Custom Dashboard Sub Option"),
    key: "CUSTOM_DASHBOARD_SUB_OPTION",
  },
} as const;

export const MODULE_SUB_OPTION_TYPE_MAP_BY_LIST = [
  {
    id: "industry_dashboard_sub_option",
    name: t("Industry Dashboard Sub Option"),
    key: "INDUSTRY_DASHBOARD_SUB_OPTION",
  },
  {
    id: "custom_dashboard_sub_option",
    name: t("Custom Dashboard Sub Option"),
    key: "CUSTOM_DASHBOARD_SUB_OPTION",
  },
] as const;

export const EVENT_SPORT_TEAM_ROLE_MAP = {
  HOME: {
    id: "home",
    name: t("Home"),
    google_events_entity_role: "ENTITY_ROLE_HOME_TEAM",
    key: "HOME",
  },
  AWAY: {
    id: "away",
    name: t("Away"),
    google_events_entity_role: "ENTITY_ROLE_AWAY_TEAM",
    key: "AWAY",
  },
  UNSPECIFIED: {
    id: "unspecified",
    name: t("Unspecified"),
    google_events_entity_role: "ENTITY_ROLE_UNSPECIFIED",
    key: "UNSPECIFIED",
  },
} as const;

export const EVENT_SPORT_TEAM_ROLE_MAP_BY_ID = {
  home: {
    id: "home",
    name: t("Home"),
    google_events_entity_role: "ENTITY_ROLE_HOME_TEAM",
    key: "HOME",
  },
  away: {
    id: "away",
    name: t("Away"),
    google_events_entity_role: "ENTITY_ROLE_AWAY_TEAM",
    key: "AWAY",
  },
  unspecified: {
    id: "unspecified",
    name: t("Unspecified"),
    google_events_entity_role: "ENTITY_ROLE_UNSPECIFIED",
    key: "UNSPECIFIED",
  },
} as const;

export const EVENT_SPORT_TEAM_ROLE_MAP_BY_LIST = [
  {
    id: "home",
    name: t("Home"),
    google_events_entity_role: "ENTITY_ROLE_HOME_TEAM",
    key: "HOME",
  },
  {
    id: "away",
    name: t("Away"),
    google_events_entity_role: "ENTITY_ROLE_AWAY_TEAM",
    key: "AWAY",
  },
  {
    id: "unspecified",
    name: t("Unspecified"),
    google_events_entity_role: "ENTITY_ROLE_UNSPECIFIED",
    key: "UNSPECIFIED",
  },
] as const;

export const COMEDIAN_ROLE_MAP = {
  HEADLINER: {
    id: "headliner",
    name: t("Headliner"),
    google_events_entity_role: "ENTITY_ROLE_HEADLINER",
    key: "HEADLINER",
  },
  SUPPORTER: {
    id: "supporter",
    name: t("Supporter"),
    google_events_entity_role: "ENTITY_ROLE_SUPPORTER",
    key: "SUPPORTER",
  },
} as const;

export const COMEDIAN_ROLE_MAP_BY_ID = {
  headliner: {
    id: "headliner",
    name: t("Headliner"),
    google_events_entity_role: "ENTITY_ROLE_HEADLINER",
    key: "HEADLINER",
  },
  supporter: {
    id: "supporter",
    name: t("Supporter"),
    google_events_entity_role: "ENTITY_ROLE_SUPPORTER",
    key: "SUPPORTER",
  },
} as const;

export const COMEDIAN_ROLE_MAP_BY_LIST = [
  {
    id: "headliner",
    name: t("Headliner"),
    google_events_entity_role: "ENTITY_ROLE_HEADLINER",
    key: "HEADLINER",
  },
  {
    id: "supporter",
    name: t("Supporter"),
    google_events_entity_role: "ENTITY_ROLE_SUPPORTER",
    key: "SUPPORTER",
  },
] as const;

export const VENUE_FEATURE_REQUEST_TYPE_MAP = {
  CUSTOM_DASHBOARD_REQUEST: {
    id: "custom_dashboard_request",
    name: t("Custom Dashboard Request"),
    description:
      "Request to create or update a custom dashboard for the venue.",
    key: "CUSTOM_DASHBOARD_REQUEST",
  },
  UPDATE_PRICING_TIER: {
    id: "update_pricing_tier",
    name: t("Update Pricing Tier"),
    description: "Request to update the pricing tier for the venue.",
    key: "UPDATE_PRICING_TIER",
  },
  NO_TYPE: {
    id: "no_type",
    name: t("No Specific Type"),
    description: "General request with no specific type.",
    key: "NO_TYPE",
  },
  ANALYTICS_PARTNER_PROGRAM_REQUEST: {
    id: "analytics_partner_program_request",
    name: t("Partner Program Request"),
    description: "Request to join or inquire about the partner program.",
    key: "ANALYTICS_PARTNER_PROGRAM_REQUEST",
  },
} as const;

export const VENUE_FEATURE_REQUEST_TYPE_MAP_BY_ID = {
  custom_dashboard_request: {
    id: "custom_dashboard_request",
    name: t("Custom Dashboard Request"),
    description:
      "Request to create or update a custom dashboard for the venue.",
    key: "CUSTOM_DASHBOARD_REQUEST",
  },
  update_pricing_tier: {
    id: "update_pricing_tier",
    name: t("Update Pricing Tier"),
    description: "Request to update the pricing tier for the venue.",
    key: "UPDATE_PRICING_TIER",
  },
  no_type: {
    id: "no_type",
    name: t("No Specific Type"),
    description: "General request with no specific type.",
    key: "NO_TYPE",
  },
  analytics_partner_program_request: {
    id: "analytics_partner_program_request",
    name: t("Partner Program Request"),
    description: "Request to join or inquire about the partner program.",
    key: "ANALYTICS_PARTNER_PROGRAM_REQUEST",
  },
} as const;

export const VENUE_FEATURE_REQUEST_TYPE_MAP_BY_LIST = [
  {
    id: "custom_dashboard_request",
    name: t("Custom Dashboard Request"),
    description:
      "Request to create or update a custom dashboard for the venue.",
    key: "CUSTOM_DASHBOARD_REQUEST",
  },
  {
    id: "update_pricing_tier",
    name: t("Update Pricing Tier"),
    description: "Request to update the pricing tier for the venue.",
    key: "UPDATE_PRICING_TIER",
  },
  {
    id: "no_type",
    name: t("No Specific Type"),
    description: "General request with no specific type.",
    key: "NO_TYPE",
  },
  {
    id: "analytics_partner_program_request",
    name: t("Partner Program Request"),
    description: "Request to join or inquire about the partner program.",
    key: "ANALYTICS_PARTNER_PROGRAM_REQUEST",
  },
] as const;

export const ENTITY_ROLE_MAP = {
  HEADLINER: {
    id: "headliner",
    name: t("Headliner"),
    google_events_entity_role: "ENTITY_ROLE_HEADLINER",
    key: "HEADLINER",
  },
  SUPPORTER: {
    id: "supporter",
    name: t("Supporter"),
    google_events_entity_role: "ENTITY_ROLE_SUPPORTER",
    key: "SUPPORTER",
  },
} as const;

export const ENTITY_ROLE_MAP_BY_ID = {
  headliner: {
    id: "headliner",
    name: t("Headliner"),
    google_events_entity_role: "ENTITY_ROLE_HEADLINER",
    key: "HEADLINER",
  },
  supporter: {
    id: "supporter",
    name: t("Supporter"),
    google_events_entity_role: "ENTITY_ROLE_SUPPORTER",
    key: "SUPPORTER",
  },
} as const;

export const ENTITY_ROLE_MAP_BY_LIST = [
  {
    id: "headliner",
    name: t("Headliner"),
    google_events_entity_role: "ENTITY_ROLE_HEADLINER",
    key: "HEADLINER",
  },
  {
    id: "supporter",
    name: t("Supporter"),
    google_events_entity_role: "ENTITY_ROLE_SUPPORTER",
    key: "SUPPORTER",
  },
] as const;

export const VENUE_EMAIL_CONFIG_SEND_TYPE_MAP = {
  SPECIFIC_DATE: {
    id: "specific_date",
    name: t("Specific Date"),
    key: "SPECIFIC_DATE",
  },
  SEASON_SALES_STARTS_ON_DATE: {
    id: "season_sales_starts_on_date",
    name: t("Season Sales Starts on Date"),
    key: "SEASON_SALES_STARTS_ON_DATE",
  },
  DO_NOT_SEND: {
    id: "do_not_send",
    name: t("Do Not Send"),
    key: "DO_NOT_SEND",
  },
} as const;

export const VENUE_EMAIL_CONFIG_SEND_TYPE_MAP_BY_ID = {
  specific_date: {
    id: "specific_date",
    name: t("Specific Date"),
    key: "SPECIFIC_DATE",
  },
  season_sales_starts_on_date: {
    id: "season_sales_starts_on_date",
    name: t("Season Sales Starts on Date"),
    key: "SEASON_SALES_STARTS_ON_DATE",
  },
  do_not_send: {
    id: "do_not_send",
    name: t("Do Not Send"),
    key: "DO_NOT_SEND",
  },
} as const;

export const VENUE_EMAIL_CONFIG_SEND_TYPE_MAP_BY_LIST = [
  { id: "specific_date", name: t("Specific Date"), key: "SPECIFIC_DATE" },
  {
    id: "season_sales_starts_on_date",
    name: t("Season Sales Starts on Date"),
    key: "SEASON_SALES_STARTS_ON_DATE",
  },
  { id: "do_not_send", name: t("Do Not Send"), key: "DO_NOT_SEND" },
] as const;

export const FEE_VALUE_TYPE_MAP = {
  default: { id: "default", name: t("Default"), key: "default" },
  standard: { id: "standard", name: t("Standard"), key: "standard" },
  exception: { id: "exception", name: t("Exception"), key: "exception" },
} as const;

export const FEE_VALUE_TYPE_MAP_BY_ID = {} as const;

export const FEE_VALUE_TYPE_MAP_BY_LIST = [] as const;

export const DEFAULT_FEE_VALUE_EDITABLE_FIELDS_MAP = {
  fee_added: { id: "fee_added", name: t("Fee Added"), key: "fee_added" },
  fee_percent: {
    id: "fee_percent",
    name: t("Fee Percent"),
    key: "fee_percent",
  },
  description: {
    id: "description",
    name: t("Description"),
    key: "description",
  },
  long_description: {
    id: "long_description",
    name: t("Long Description"),
    key: "long_description",
  },
} as const;

export const DEFAULT_FEE_VALUE_EDITABLE_FIELDS_MAP_BY_ID = {} as const;

export const DEFAULT_FEE_VALUE_EDITABLE_FIELDS_MAP_BY_LIST = [] as const;

export const USER_SEGMENT_FILTER_TYPE_MAP = {
  BASIC: { id: "BASIC", name: t("Basic"), key: "BASIC" },
  AND: { id: "AND", name: t("And"), key: "AND" },
  OR: { id: "OR", name: t("Or"), key: "OR" },
} as const;

export const USER_SEGMENT_FILTER_TYPE_MAP_BY_ID = {} as const;

export const USER_SEGMENT_FILTER_TYPE_MAP_BY_LIST = [] as const;

export const USER_SEGMENT_STATUS_TYPE_MAP = {
  idle: { id: "idle", name: t("Idle"), key: "idle" },
  refreshing: { id: "refreshing", name: t("Refreshing"), key: "refreshing" },
  failed: { id: "failed", name: t("Failed"), key: "failed" },
} as const;

export const USER_SEGMENT_STATUS_TYPE_MAP_BY_ID = {} as const;

export const USER_SEGMENT_STATUS_TYPE_MAP_BY_LIST = [] as const;

export const PRODUCT_FEEDBACK_STATUS_MAP = {
  NEW: { id: "new", name: t("New"), color_scheme: "blue", key: "NEW" },
  UNDER_REVIEW: {
    id: "under_review",
    name: t("Under Review"),
    color_scheme: "purple",
    key: "UNDER_REVIEW",
  },
  BACKLOG: {
    id: "backlog",
    name: t("Backlog"),
    color_scheme: "gray",
    key: "BACKLOG",
  },
  IN_PROGRESS: {
    id: "in_progress",
    name: t("In Progress"),
    color_scheme: "warning",
    key: "IN_PROGRESS",
  },
  DONE: { id: "done", name: t("Done"), color_scheme: "success", key: "DONE" },
  WONT_DO: {
    id: "wont_do",
    name: t("Will not implement"),
    color_scheme: "error",
    key: "WONT_DO",
  },
} as const;

export const PRODUCT_FEEDBACK_STATUS_MAP_BY_ID = {
  new: { id: "new", name: t("New"), color_scheme: "blue", key: "NEW" },
  under_review: {
    id: "under_review",
    name: t("Under Review"),
    color_scheme: "purple",
    key: "UNDER_REVIEW",
  },
  backlog: {
    id: "backlog",
    name: t("Backlog"),
    color_scheme: "gray",
    key: "BACKLOG",
  },
  in_progress: {
    id: "in_progress",
    name: t("In Progress"),
    color_scheme: "warning",
    key: "IN_PROGRESS",
  },
  done: { id: "done", name: t("Done"), color_scheme: "success", key: "DONE" },
  wont_do: {
    id: "wont_do",
    name: t("Will not implement"),
    color_scheme: "error",
    key: "WONT_DO",
  },
} as const;

export const PRODUCT_FEEDBACK_STATUS_MAP_BY_LIST = [
  { id: "new", name: t("New"), color_scheme: "blue", key: "NEW" },
  {
    id: "under_review",
    name: t("Under Review"),
    color_scheme: "purple",
    key: "UNDER_REVIEW",
  },
  { id: "backlog", name: t("Backlog"), color_scheme: "gray", key: "BACKLOG" },
  {
    id: "in_progress",
    name: t("In Progress"),
    color_scheme: "warning",
    key: "IN_PROGRESS",
  },
  { id: "done", name: t("Done"), color_scheme: "success", key: "DONE" },
  {
    id: "wont_do",
    name: t("Will not implement"),
    color_scheme: "error",
    key: "WONT_DO",
  },
] as const;

export const PRODUCT_FEEDBACK_IMPACT_MAP = {
  HIGH: { id: "high", name: t("High"), color_scheme: "error", key: "HIGH" },
  MEDIUM: {
    id: "medium",
    name: t("Medium"),
    color_scheme: "warning",
    key: "MEDIUM",
  },
  LOW: { id: "low", name: t("Low"), color_scheme: "success", key: "LOW" },
} as const;

export const PRODUCT_FEEDBACK_IMPACT_MAP_BY_ID = {
  high: { id: "high", name: t("High"), color_scheme: "error", key: "HIGH" },
  medium: {
    id: "medium",
    name: t("Medium"),
    color_scheme: "warning",
    key: "MEDIUM",
  },
  low: { id: "low", name: t("Low"), color_scheme: "success", key: "LOW" },
} as const;

export const PRODUCT_FEEDBACK_IMPACT_MAP_BY_LIST = [
  { id: "high", name: t("High"), color_scheme: "error", key: "HIGH" },
  { id: "medium", name: t("Medium"), color_scheme: "warning", key: "MEDIUM" },
  { id: "low", name: t("Low"), color_scheme: "success", key: "LOW" },
] as const;

export const PRODUCT_FEEDBACK_EFFORT_MAP = {
  UI_TWEAK: {
    id: "ui_tweak",
    name: t("UI Tweak"),
    color_scheme: "green",
    key: "UI_TWEAK",
  },
  MINOR_FEATURE: {
    id: "minor_feature",
    name: t("Minor Feature"),
    color_scheme: "yellow",
    key: "MINOR_FEATURE",
  },
  MAJOR_FEATURE: {
    id: "major_feature",
    name: t("Major Feature"),
    color_scheme: "red",
    key: "MAJOR_FEATURE",
  },
  NEW_INTEGRATION: {
    id: "new_integration",
    name: t("New Integration"),
    color_scheme: "red",
    key: "NEW_INTEGRATION",
  },
} as const;

export const PRODUCT_FEEDBACK_EFFORT_MAP_BY_ID = {
  ui_tweak: {
    id: "ui_tweak",
    name: t("UI Tweak"),
    color_scheme: "green",
    key: "UI_TWEAK",
  },
  minor_feature: {
    id: "minor_feature",
    name: t("Minor Feature"),
    color_scheme: "yellow",
    key: "MINOR_FEATURE",
  },
  major_feature: {
    id: "major_feature",
    name: t("Major Feature"),
    color_scheme: "red",
    key: "MAJOR_FEATURE",
  },
  new_integration: {
    id: "new_integration",
    name: t("New Integration"),
    color_scheme: "red",
    key: "NEW_INTEGRATION",
  },
} as const;

export const PRODUCT_FEEDBACK_EFFORT_MAP_BY_LIST = [
  {
    id: "ui_tweak",
    name: t("UI Tweak"),
    color_scheme: "green",
    key: "UI_TWEAK",
  },
  {
    id: "minor_feature",
    name: t("Minor Feature"),
    color_scheme: "yellow",
    key: "MINOR_FEATURE",
  },
  {
    id: "major_feature",
    name: t("Major Feature"),
    color_scheme: "red",
    key: "MAJOR_FEATURE",
  },
  {
    id: "new_integration",
    name: t("New Integration"),
    color_scheme: "red",
    key: "NEW_INTEGRATION",
  },
] as const;

export const BASKET_PROTECTION_ITEM_CLAIM_STATUS_MAP = {
  ps_not_claimed: {
    id: "ps_not_claimed",
    name: t("No Claim"),
    key: "ps_not_claimed",
  },
  ps_approved: {
    id: "ps_approved",
    name: t("Claim is Approved"),
    key: "ps_approved",
  },
  ps_submitted: {
    id: "ps_submitted",
    name: t("Claim is Submitted"),
    key: "ps_submitted",
  },
  ps_denied: { id: "ps_denied", name: t("Claim is Denied"), key: "ps_denied" },
  ps_closed: { id: "ps_closed", name: t("Claim is Closed"), key: "ps_closed" },
} as const;

export const BASKET_PROTECTION_ITEM_CLAIM_STATUS_MAP_BY_ID = {} as const;

export const BASKET_PROTECTION_ITEM_CLAIM_STATUS_MAP_BY_LIST = [] as const;

export const TWILIO_SUPPORTED_COUNTRY_CODES_MAP = {
  US_CA: {
    id: "1",
    name: t("United States & Canada"),
    countries: ["US", "CA"],
    key: "US_CA",
  },
  UK: { id: "44", name: t("United Kingdom"), countries: ["GB"], key: "UK" },
  AU: { id: "61", name: t("Australia"), countries: ["AU"], key: "AU" },
} as const;

export const TWILIO_SUPPORTED_COUNTRY_CODES_MAP_BY_ID = {
  "1": {
    id: "1",
    name: t("United States & Canada"),
    countries: ["US", "CA"],
    key: "US_CA",
  },
  "44": { id: "44", name: t("United Kingdom"), countries: ["GB"], key: "UK" },
  "61": { id: "61", name: t("Australia"), countries: ["AU"], key: "AU" },
} as const;

export const TWILIO_SUPPORTED_COUNTRY_CODES_MAP_BY_LIST = [
  {
    id: "1",
    name: t("United States & Canada"),
    countries: ["US", "CA"],
    key: "US_CA",
  },
  { id: "44", name: t("United Kingdom"), countries: ["GB"], key: "UK" },
  { id: "61", name: t("Australia"), countries: ["AU"], key: "AU" },
] as const;

export const SYSTEM_PAYMENT_GATEWAY_IDS = [
  179, 180, 166, 172, 142, 14, 2342, 199, 156, 15, 192, 2341, 177, 2351, 2350,
  193,
] as const;
